(function () {
    function Vw(i) {
        return i &&
            i.__esModule &&
            Object.prototype.hasOwnProperty.call(i, 'default')
            ? i.default
            : i;
    }
    var ap = { exports: {} },
        su = {},
        ip = { exports: {} },
        ru = { exports: {} },
        J1;
    function zw() {
        return (
            J1 ||
            ((J1 = 1),
                (function (i, l) {
              /**
               * @license React
               * react.development.js
               *
               * Copyright (c) Meta Platforms, Inc. and affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */ (function () {
                        function s(x, M) {
                            Object.defineProperty(d.prototype, x, {
                                get: function () {
                                    console.warn(
                                        '%s(...) is deprecated in plain JavaScript React classes. %s',
                                        M[0],
                                        M[1]
                                    );
                                },
                            });
                        }
                        function r(x) {
                            return x === null || typeof x != 'object'
                                ? null
                                : ((x = (Mi && x[Mi]) || x['@@iterator']),
                                    typeof x == 'function' ? x : null);
                        }
                        function u(x, M) {
                            x =
                                ((x = x.constructor) && (x.displayName || x.name)) ||
                                'ReactClass';
                            var ee = x + '.' + M;
                            Do[ee] ||
                                (console.error(
                                    "Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",
                                    M,
                                    x
                                ),
                                    (Do[ee] = !0));
                        }
                        function d(x, M, ee) {
                            ((this.props = x),
                                (this.context = M),
                                (this.refs = To),
                                (this.updater = ee || Xa));
                        }
                        function p() { }
                        function h(x, M, ee) {
                            ((this.props = x),
                                (this.context = M),
                                (this.refs = To),
                                (this.updater = ee || Xa));
                        }
                        function m(x) {
                            return '' + x;
                        }
                        function y(x) {
                            try {
                                var M = !1;
                            } catch {
                                M = !0;
                            }
                            if (M) {
                                M = console;
                                var ee = M.error,
                                    ie =
                                        (typeof Symbol == 'function' &&
                                            Symbol.toStringTag &&
                                            x[Symbol.toStringTag]) ||
                                        x.constructor.name ||
                                        'Object';
                                return (
                                    ee.call(
                                        M,
                                        'The provided key is an unsupported type %s. This value must be coerced to a string before using it here.',
                                        ie
                                    ),
                                    m(x)
                                );
                            }
                        }
                        function E(x) {
                            if (x == null) return null;
                            if (typeof x == 'function')
                                return x.$$typeof === Mu
                                    ? null
                                    : x.displayName || x.name || null;
                            if (typeof x == 'string') return x;
                            switch (x) {
                                case U:
                                    return 'Fragment';
                                case ue:
                                    return 'Profiler';
                                case re:
                                    return 'StrictMode';
                                case Ie:
                                    return 'Suspense';
                                case Ri:
                                    return 'SuspenseList';
                                case bn:
                                    return 'Activity';
                            }
                            if (typeof x == 'object')
                                switch (
                                (typeof x.tag == 'number' &&
                                    console.error(
                                        'Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.'
                                    ),
                                    x.$$typeof)
                                ) {
                                    case me:
                                        return 'Portal';
                                    case at:
                                        return (x.displayName || 'Context') + '.Provider';
                                    case Ge:
                                        return (
                                            (x._context.displayName || 'Context') + '.Consumer'
                                        );
                                    case zt:
                                        var M = x.render;
                                        return (
                                            (x = x.displayName),
                                            x ||
                                            ((x = M.displayName || M.name || ''),
                                                (x =
                                                    x !== ''
                                                        ? 'ForwardRef(' + x + ')'
                                                        : 'ForwardRef')),
                                            x
                                        );
                                    case ot:
                                        return (
                                            (M = x.displayName || null),
                                            M !== null ? M : E(x.type) || 'Memo'
                                        );
                                    case Tt:
                                        ((M = x._payload), (x = x._init));
                                        try {
                                            return E(x(M));
                                        } catch { }
                                }
                            return null;
                        }
                        function v(x) {
                            if (x === U) return '<>';
                            if (typeof x == 'object' && x !== null && x.$$typeof === Tt)
                                return '<...>';
                            try {
                                var M = E(x);
                                return M ? '<' + M + '>' : '<...>';
                            } catch {
                                return '<...>';
                            }
                        }
                        function N() {
                            var x = Oe.A;
                            return x === null ? null : x.getOwner();
                        }
                        function S() {
                            return Error('react-stack-top-frame');
                        }
                        function D(x) {
                            if (Oi.call(x, 'key')) {
                                var M = Object.getOwnPropertyDescriptor(x, 'key').get;
                                if (M && M.isReactWarning) return !1;
                            }
                            return x.key !== void 0;
                        }
                        function O(x, M) {
                            function ee() {
                                Ja ||
                                    ((Ja = !0),
                                        console.error(
                                            '%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)',
                                            M
                                        ));
                            }
                            ((ee.isReactWarning = !0),
                                Object.defineProperty(x, 'key', {
                                    get: ee,
                                    configurable: !0,
                                }));
                        }
                        function k() {
                            var x = E(this.type);
                            return (
                                Co[x] ||
                                ((Co[x] = !0),
                                    console.error(
                                        'Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.'
                                    )),
                                (x = this.props.ref),
                                x !== void 0 ? x : null
                            );
                        }
                        function _(x, M, ee, ie, pe, Re, De, He) {
                            return (
                                (ee = Re.ref),
                                (x = {
                                    $$typeof: Q,
                                    type: x,
                                    key: M,
                                    props: Re,
                                    _owner: pe,
                                }),
                                (ee !== void 0 ? ee : null) !== null
                                    ? Object.defineProperty(x, 'ref', {
                                        enumerable: !1,
                                        get: k,
                                    })
                                    : Object.defineProperty(x, 'ref', {
                                        enumerable: !1,
                                        value: null,
                                    }),
                                (x._store = {}),
                                Object.defineProperty(x._store, 'validated', {
                                    configurable: !1,
                                    enumerable: !1,
                                    writable: !0,
                                    value: 0,
                                }),
                                Object.defineProperty(x, '_debugInfo', {
                                    configurable: !1,
                                    enumerable: !1,
                                    writable: !0,
                                    value: null,
                                }),
                                Object.defineProperty(x, '_debugStack', {
                                    configurable: !1,
                                    enumerable: !1,
                                    writable: !0,
                                    value: De,
                                }),
                                Object.defineProperty(x, '_debugTask', {
                                    configurable: !1,
                                    enumerable: !1,
                                    writable: !0,
                                    value: He,
                                }),
                                Object.freeze && (Object.freeze(x.props), Object.freeze(x)),
                                x
                            );
                        }
                        function I(x, M) {
                            return (
                                (M = _(
                                    x.type,
                                    M,
                                    void 0,
                                    void 0,
                                    x._owner,
                                    x.props,
                                    x._debugStack,
                                    x._debugTask
                                )),
                                x._store && (M._store.validated = x._store.validated),
                                M
                            );
                        }
                        function Y(x) {
                            return typeof x == 'object' && x !== null && x.$$typeof === Q;
                        }
                        function Z(x) {
                            var M = { '=': '=0', ':': '=2' };
                            return (
                                '$' +
                                x.replace(/[=:]/g, function (ee) {
                                    return M[ee];
                                })
                            );
                        }
                        function P(x, M) {
                            return typeof x == 'object' && x !== null && x.key != null
                                ? (y(x.key), Z('' + x.key))
                                : M.toString(36);
                        }
                        function le() { }
                        function q(x) {
                            switch (x.status) {
                                case 'fulfilled':
                                    return x.value;
                                case 'rejected':
                                    throw x.reason;
                                default:
                                    switch (
                                    (typeof x.status == 'string'
                                        ? x.then(le, le)
                                        : ((x.status = 'pending'),
                                            x.then(
                                                function (M) {
                                                    x.status === 'pending' &&
                                                        ((x.status = 'fulfilled'), (x.value = M));
                                                },
                                                function (M) {
                                                    x.status === 'pending' &&
                                                        ((x.status = 'rejected'), (x.reason = M));
                                                }
                                            )),
                                        x.status)
                                    ) {
                                        case 'fulfilled':
                                            return x.value;
                                        case 'rejected':
                                            throw x.reason;
                                    }
                            }
                            throw x;
                        }
                        function W(x, M, ee, ie, pe) {
                            var Re = typeof x;
                            (Re === 'undefined' || Re === 'boolean') && (x = null);
                            var De = !1;
                            if (x === null) De = !0;
                            else
                                switch (Re) {
                                    case 'bigint':
                                    case 'string':
                                    case 'number':
                                        De = !0;
                                        break;
                                    case 'object':
                                        switch (x.$$typeof) {
                                            case Q:
                                            case me:
                                                De = !0;
                                                break;
                                            case Tt:
                                                return (
                                                    (De = x._init),
                                                    W(De(x._payload), M, ee, ie, pe)
                                                );
                                        }
                                }
                            if (De) {
                                ((De = x), (pe = pe(De)));
                                var He = ie === '' ? '.' + P(De, 0) : ie;
                                return (
                                    Qa(pe)
                                        ? ((ee = ''),
                                            He != null && (ee = He.replace(Oo, '$&/') + '/'),
                                            W(pe, M, ee, '', function (wt) {
                                                return wt;
                                            }))
                                        : pe != null &&
                                        (Y(pe) &&
                                            (pe.key != null &&
                                                ((De && De.key === pe.key) || y(pe.key)),
                                                (ee = I(
                                                    pe,
                                                    ee +
                                                    (pe.key == null || (De && De.key === pe.key)
                                                        ? ''
                                                        : ('' + pe.key).replace(Oo, '$&/') + '/') +
                                                    He
                                                )),
                                                ie !== '' &&
                                                De != null &&
                                                Y(De) &&
                                                De.key == null &&
                                                De._store &&
                                                !De._store.validated &&
                                                (ee._store.validated = 2),
                                                (pe = ee)),
                                            M.push(pe)),
                                    1
                                );
                            }
                            if (((De = 0), (He = ie === '' ? '.' : ie + ':'), Qa(x)))
                                for (var Te = 0; Te < x.length; Te++)
                                    ((ie = x[Te]),
                                        (Re = He + P(ie, Te)),
                                        (De += W(ie, M, ee, Re, pe)));
                            else if (((Te = r(x)), typeof Te == 'function'))
                                for (
                                    Te === x.entries &&
                                    (Mo ||
                                        console.warn(
                                            'Using Maps as children is not supported. Use an array of keyed ReactElements instead.'
                                        ),
                                        (Mo = !0)),
                                    x = Te.call(x),
                                    Te = 0;
                                    !(ie = x.next()).done;
                                )
                                    ((ie = ie.value),
                                        (Re = He + P(ie, Te++)),
                                        (De += W(ie, M, ee, Re, pe)));
                            else if (Re === 'object') {
                                if (typeof x.then == 'function')
                                    return W(q(x), M, ee, ie, pe);
                                throw (
                                    (M = String(x)),
                                    Error(
                                        'Objects are not valid as a React child (found: ' +
                                        (M === '[object Object]'
                                            ? 'object with keys {' +
                                            Object.keys(x).join(', ') +
                                            '}'
                                            : M) +
                                        '). If you meant to render a collection of children, use an array instead.'
                                    )
                                );
                            }
                            return De;
                        }
                        function K(x, M, ee) {
                            if (x == null) return x;
                            var ie = [],
                                pe = 0;
                            return (
                                W(x, ie, '', '', function (Re) {
                                    return M.call(ee, Re, pe++);
                                }),
                                ie
                            );
                        }
                        function te(x) {
                            if (x._status === -1) {
                                var M = x._result;
                                ((M = M()),
                                    M.then(
                                        function (ee) {
                                            (x._status === 0 || x._status === -1) &&
                                                ((x._status = 1), (x._result = ee));
                                        },
                                        function (ee) {
                                            (x._status === 0 || x._status === -1) &&
                                                ((x._status = 2), (x._result = ee));
                                        }
                                    ),
                                    x._status === -1 && ((x._status = 0), (x._result = M)));
                            }
                            if (x._status === 1)
                                return (
                                    (M = x._result),
                                    M === void 0 &&
                                    console.error(
                                        `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`,
                                        M
                                    ),
                                    'default' in M ||
                                    console.error(
                                        `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`,
                                        M
                                    ),
                                    M.default
                                );
                            throw x._result;
                        }
                        function X() {
                            var x = Oe.H;
                            return (
                                x === null &&
                                console.error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`),
                                x
                            );
                        }
                        function oe() { }
                        function ge(x) {
                            if (Sl === null)
                                try {
                                    var M = ('require' + Math.random()).slice(0, 7);
                                    Sl = (i && i[M]).call(i, 'timers').setImmediate;
                                } catch {
                                    Sl = function (ie) {
                                        ko === !1 &&
                                            ((ko = !0),
                                                typeof MessageChannel > 'u' &&
                                                console.error(
                                                    'This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.'
                                                ));
                                        var pe = new MessageChannel();
                                        ((pe.port1.onmessage = ie),
                                            pe.port2.postMessage(void 0));
                                    };
                                }
                            return Sl(x);
                        }
                        function Ee(x) {
                            return 1 < x.length && typeof AggregateError == 'function'
                                ? new AggregateError(x)
                                : x[0];
                        }
                        function _e(x, M) {
                            (M !== qa - 1 &&
                                console.error(
                                    'You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. '
                                ),
                                (qa = M));
                        }
                        function J(x, M, ee) {
                            var ie = Oe.actQueue;
                            if (ie !== null)
                                if (ie.length !== 0)
                                    try {
                                        (ce(ie),
                                            ge(function () {
                                                return J(x, M, ee);
                                            }));
                                        return;
                                    } catch (pe) {
                                        Oe.thrownErrors.push(pe);
                                    }
                                else Oe.actQueue = null;
                            0 < Oe.thrownErrors.length
                                ? ((ie = Ee(Oe.thrownErrors)),
                                    (Oe.thrownErrors.length = 0),
                                    ee(ie))
                                : M(x);
                        }
                        function ce(x) {
                            if (!Hn) {
                                Hn = !0;
                                var M = 0;
                                try {
                                    for (; M < x.length; M++) {
                                        var ee = x[M];
                                        do {
                                            Oe.didUsePromise = !1;
                                            var ie = ee(!1);
                                            if (ie !== null) {
                                                if (Oe.didUsePromise) {
                                                    ((x[M] = ee), x.splice(0, M));
                                                    return;
                                                }
                                                ee = ie;
                                            } else break;
                                        } while (!0);
                                    }
                                    x.length = 0;
                                } catch (pe) {
                                    (x.splice(0, M + 1), Oe.thrownErrors.push(pe));
                                } finally {
                                    Hn = !1;
                                }
                            }
                        }
                        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ==
                            'function' &&
                            __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(
                                Error()
                            );
                        var Q = Symbol.for('react.transitional.element'),
                            me = Symbol.for('react.portal'),
                            U = Symbol.for('react.fragment'),
                            re = Symbol.for('react.strict_mode'),
                            ue = Symbol.for('react.profiler'),
                            Ge = Symbol.for('react.consumer'),
                            at = Symbol.for('react.context'),
                            zt = Symbol.for('react.forward_ref'),
                            Ie = Symbol.for('react.suspense'),
                            Ri = Symbol.for('react.suspense_list'),
                            ot = Symbol.for('react.memo'),
                            Tt = Symbol.for('react.lazy'),
                            bn = Symbol.for('react.activity'),
                            Mi = Symbol.iterator,
                            Do = {},
                            Xa = {
                                isMounted: function () {
                                    return !1;
                                },
                                enqueueForceUpdate: function (x) {
                                    u(x, 'forceUpdate');
                                },
                                enqueueReplaceState: function (x) {
                                    u(x, 'replaceState');
                                },
                                enqueueSetState: function (x) {
                                    u(x, 'setState');
                                },
                            },
                            ur = Object.assign,
                            To = {};
                        (Object.freeze(To),
                            (d.prototype.isReactComponent = {}),
                            (d.prototype.setState = function (x, M) {
                                if (
                                    typeof x != 'object' &&
                                    typeof x != 'function' &&
                                    x != null
                                )
                                    throw Error(
                                        'takes an object of state variables to update or a function which returns an object of state variables.'
                                    );
                                this.updater.enqueueSetState(this, x, M, 'setState');
                            }),
                            (d.prototype.forceUpdate = function (x) {
                                this.updater.enqueueForceUpdate(this, x, 'forceUpdate');
                            }));
                        var ht = {
                            isMounted: [
                                'isMounted',
                                'Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks.',
                            ],
                            replaceState: [
                                'replaceState',
                                'Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236).',
                            ],
                        },
                            va;
                        for (va in ht) ht.hasOwnProperty(va) && s(va, ht[va]);
                        ((p.prototype = d.prototype),
                            (ht = h.prototype = new p()),
                            (ht.constructor = h),
                            ur(ht, d.prototype),
                            (ht.isPureReactComponent = !0));
                        var Qa = Array.isArray,
                            Mu = Symbol.for('react.client.reference'),
                            Oe = {
                                H: null,
                                A: null,
                                T: null,
                                S: null,
                                V: null,
                                actQueue: null,
                                isBatchingLegacy: !1,
                                didScheduleLegacyUpdate: !1,
                                didUsePromise: !1,
                                thrownErrors: [],
                                getCurrentStack: null,
                                recentlyCreatedOwnerStacks: 0,
                            },
                            Oi = Object.prototype.hasOwnProperty,
                            yl = console.createTask
                                ? console.createTask
                                : function () {
                                    return null;
                                };
                        ht = {
                            react_stack_bottom_frame: function (x) {
                                return x();
                            },
                        };
                        var Ja,
                            dr,
                            Co = {},
                            fr = ht.react_stack_bottom_frame.bind(ht, S)(),
                            Ro = yl(v(S)),
                            Mo = !1,
                            Oo = /\/+/g,
                            vl =
                                typeof reportError == 'function'
                                    ? reportError
                                    : function (x) {
                                        if (
                                            typeof window == 'object' &&
                                            typeof window.ErrorEvent == 'function'
                                        ) {
                                            var M = new window.ErrorEvent('error', {
                                                bubbles: !0,
                                                cancelable: !0,
                                                message:
                                                    typeof x == 'object' &&
                                                        x !== null &&
                                                        typeof x.message == 'string'
                                                        ? String(x.message)
                                                        : String(x),
                                                error: x,
                                            });
                                            if (!window.dispatchEvent(M)) return;
                                        } else if (
                                            typeof process == 'object' &&
                                            typeof process.emit == 'function'
                                        ) {
                                            process.emit('uncaughtException', x);
                                            return;
                                        }
                                        console.error(x);
                                    },
                            ko = !1,
                            Sl = null,
                            qa = 0,
                            In = !1,
                            Hn = !1,
                            $a =
                                typeof queueMicrotask == 'function'
                                    ? function (x) {
                                        queueMicrotask(function () {
                                            return queueMicrotask(x);
                                        });
                                    }
                                    : ge;
                        ((ht = Object.freeze({
                            __proto__: null,
                            c: function (x) {
                                return X().useMemoCache(x);
                            },
                        })),
                            (l.Children = {
                                map: K,
                                forEach: function (x, M, ee) {
                                    K(
                                        x,
                                        function () {
                                            M.apply(this, arguments);
                                        },
                                        ee
                                    );
                                },
                                count: function (x) {
                                    var M = 0;
                                    return (
                                        K(x, function () {
                                            M++;
                                        }),
                                        M
                                    );
                                },
                                toArray: function (x) {
                                    return (
                                        K(x, function (M) {
                                            return M;
                                        }) || []
                                    );
                                },
                                only: function (x) {
                                    if (!Y(x))
                                        throw Error(
                                            'React.Children.only expected to receive a single React element child.'
                                        );
                                    return x;
                                },
                            }),
                            (l.Component = d),
                            (l.Fragment = U),
                            (l.Profiler = ue),
                            (l.PureComponent = h),
                            (l.StrictMode = re),
                            (l.Suspense = Ie),
                            (l.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
                                Oe),
                            (l.__COMPILER_RUNTIME = ht),
                            (l.act = function (x) {
                                var M = Oe.actQueue,
                                    ee = qa;
                                qa++;
                                var ie = (Oe.actQueue = M !== null ? M : []),
                                    pe = !1;
                                try {
                                    var Re = x();
                                } catch (Te) {
                                    Oe.thrownErrors.push(Te);
                                }
                                if (0 < Oe.thrownErrors.length)
                                    throw (
                                        _e(M, ee),
                                        (x = Ee(Oe.thrownErrors)),
                                        (Oe.thrownErrors.length = 0),
                                        x
                                    );
                                if (
                                    Re !== null &&
                                    typeof Re == 'object' &&
                                    typeof Re.then == 'function'
                                ) {
                                    var De = Re;
                                    return (
                                        $a(function () {
                                            pe ||
                                                In ||
                                                ((In = !0),
                                                    console.error(
                                                        'You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);'
                                                    ));
                                        }),
                                        {
                                            then: function (Te, wt) {
                                                ((pe = !0),
                                                    De.then(
                                                        function (Sa) {
                                                            if ((_e(M, ee), ee === 0)) {
                                                                try {
                                                                    (ce(ie),
                                                                        ge(function () {
                                                                            return J(Sa, Te, wt);
                                                                        }));
                                                                } catch (ku) {
                                                                    Oe.thrownErrors.push(ku);
                                                                }
                                                                if (0 < Oe.thrownErrors.length) {
                                                                    var Ou = Ee(Oe.thrownErrors);
                                                                    ((Oe.thrownErrors.length = 0), wt(Ou));
                                                                }
                                                            } else Te(Sa);
                                                        },
                                                        function (Sa) {
                                                            (_e(M, ee),
                                                                0 < Oe.thrownErrors.length &&
                                                                ((Sa = Ee(Oe.thrownErrors)),
                                                                    (Oe.thrownErrors.length = 0)),
                                                                wt(Sa));
                                                        }
                                                    ));
                                            },
                                        }
                                    );
                                }
                                var He = Re;
                                if (
                                    (_e(M, ee),
                                        ee === 0 &&
                                        (ce(ie),
                                            ie.length !== 0 &&
                                            $a(function () {
                                                pe ||
                                                    In ||
                                                    ((In = !0),
                                                        console.error(
                                                            'A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)'
                                                        ));
                                            }),
                                            (Oe.actQueue = null)),
                                        0 < Oe.thrownErrors.length)
                                )
                                    throw (
                                        (x = Ee(Oe.thrownErrors)),
                                        (Oe.thrownErrors.length = 0),
                                        x
                                    );
                                return {
                                    then: function (Te, wt) {
                                        ((pe = !0),
                                            ee === 0
                                                ? ((Oe.actQueue = ie),
                                                    ge(function () {
                                                        return J(He, Te, wt);
                                                    }))
                                                : Te(He));
                                    },
                                };
                            }),
                            (l.cache = function (x) {
                                return function () {
                                    return x.apply(null, arguments);
                                };
                            }),
                            (l.captureOwnerStack = function () {
                                var x = Oe.getCurrentStack;
                                return x === null ? null : x();
                            }),
                            (l.cloneElement = function (x, M, ee) {
                                if (x == null)
                                    throw Error(
                                        'The argument must be a React element, but you passed ' +
                                        x +
                                        '.'
                                    );
                                var ie = ur({}, x.props),
                                    pe = x.key,
                                    Re = x._owner;
                                if (M != null) {
                                    var De;
                                    e: {
                                        if (
                                            Oi.call(M, 'ref') &&
                                            (De = Object.getOwnPropertyDescriptor(
                                                M,
                                                'ref'
                                            ).get) &&
                                            De.isReactWarning
                                        ) {
                                            De = !1;
                                            break e;
                                        }
                                        De = M.ref !== void 0;
                                    }
                                    (De && (Re = N()), D(M) && (y(M.key), (pe = '' + M.key)));
                                    for (He in M)
                                        !Oi.call(M, He) ||
                                            He === 'key' ||
                                            He === '__self' ||
                                            He === '__source' ||
                                            (He === 'ref' && M.ref === void 0) ||
                                            (ie[He] = M[He]);
                                }
                                var He = arguments.length - 2;
                                if (He === 1) ie.children = ee;
                                else if (1 < He) {
                                    De = Array(He);
                                    for (var Te = 0; Te < He; Te++)
                                        De[Te] = arguments[Te + 2];
                                    ie.children = De;
                                }
                                for (
                                    ie = _(
                                        x.type,
                                        pe,
                                        void 0,
                                        void 0,
                                        Re,
                                        ie,
                                        x._debugStack,
                                        x._debugTask
                                    ),
                                    pe = 2;
                                    pe < arguments.length;
                                    pe++
                                )
                                    ((Re = arguments[pe]),
                                        Y(Re) && Re._store && (Re._store.validated = 1));
                                return ie;
                            }),
                            (l.createContext = function (x) {
                                return (
                                    (x = {
                                        $$typeof: at,
                                        _currentValue: x,
                                        _currentValue2: x,
                                        _threadCount: 0,
                                        Provider: null,
                                        Consumer: null,
                                    }),
                                    (x.Provider = x),
                                    (x.Consumer = { $$typeof: Ge, _context: x }),
                                    (x._currentRenderer = null),
                                    (x._currentRenderer2 = null),
                                    x
                                );
                            }),
                            (l.createElement = function (x, M, ee) {
                                for (var ie = 2; ie < arguments.length; ie++) {
                                    var pe = arguments[ie];
                                    Y(pe) && pe._store && (pe._store.validated = 1);
                                }
                                if (((ie = {}), (pe = null), M != null))
                                    for (Te in (dr ||
                                        !('__self' in M) ||
                                        'key' in M ||
                                        ((dr = !0),
                                            console.warn(
                                                'Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform'
                                            )),
                                        D(M) && (y(M.key), (pe = '' + M.key)),
                                        M))
                                        Oi.call(M, Te) &&
                                            Te !== 'key' &&
                                            Te !== '__self' &&
                                            Te !== '__source' &&
                                            (ie[Te] = M[Te]);
                                var Re = arguments.length - 2;
                                if (Re === 1) ie.children = ee;
                                else if (1 < Re) {
                                    for (var De = Array(Re), He = 0; He < Re; He++)
                                        De[He] = arguments[He + 2];
                                    (Object.freeze && Object.freeze(De), (ie.children = De));
                                }
                                if (x && x.defaultProps)
                                    for (Te in ((Re = x.defaultProps), Re))
                                        ie[Te] === void 0 && (ie[Te] = Re[Te]);
                                pe &&
                                    O(
                                        ie,
                                        typeof x == 'function'
                                            ? x.displayName || x.name || 'Unknown'
                                            : x
                                    );
                                var Te = 1e4 > Oe.recentlyCreatedOwnerStacks++;
                                return _(
                                    x,
                                    pe,
                                    void 0,
                                    void 0,
                                    N(),
                                    ie,
                                    Te ? Error('react-stack-top-frame') : fr,
                                    Te ? yl(v(x)) : Ro
                                );
                            }),
                            (l.createRef = function () {
                                var x = { current: null };
                                return (Object.seal(x), x);
                            }),
                            (l.forwardRef = function (x) {
                                (x != null && x.$$typeof === ot
                                    ? console.error(
                                        'forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).'
                                    )
                                    : typeof x != 'function'
                                        ? console.error(
                                            'forwardRef requires a render function but was given %s.',
                                            x === null ? 'null' : typeof x
                                        )
                                        : x.length !== 0 &&
                                        x.length !== 2 &&
                                        console.error(
                                            'forwardRef render functions accept exactly two parameters: props and ref. %s',
                                            x.length === 1
                                                ? 'Did you forget to use the ref parameter?'
                                                : 'Any additional parameter will be undefined.'
                                        ),
                                    x != null &&
                                    x.defaultProps != null &&
                                    console.error(
                                        'forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?'
                                    ));
                                var M = { $$typeof: zt, render: x },
                                    ee;
                                return (
                                    Object.defineProperty(M, 'displayName', {
                                        enumerable: !1,
                                        configurable: !0,
                                        get: function () {
                                            return ee;
                                        },
                                        set: function (ie) {
                                            ((ee = ie),
                                                x.name ||
                                                x.displayName ||
                                                (Object.defineProperty(x, 'name', { value: ie }),
                                                    (x.displayName = ie)));
                                        },
                                    }),
                                    M
                                );
                            }),
                            (l.isValidElement = Y),
                            (l.lazy = function (x) {
                                return {
                                    $$typeof: Tt,
                                    _payload: { _status: -1, _result: x },
                                    _init: te,
                                };
                            }),
                            (l.memo = function (x, M) {
                                (x == null &&
                                    console.error(
                                        'memo: The first argument must be a component. Instead received: %s',
                                        x === null ? 'null' : typeof x
                                    ),
                                    (M = {
                                        $$typeof: ot,
                                        type: x,
                                        compare: M === void 0 ? null : M,
                                    }));
                                var ee;
                                return (
                                    Object.defineProperty(M, 'displayName', {
                                        enumerable: !1,
                                        configurable: !0,
                                        get: function () {
                                            return ee;
                                        },
                                        set: function (ie) {
                                            ((ee = ie),
                                                x.name ||
                                                x.displayName ||
                                                (Object.defineProperty(x, 'name', { value: ie }),
                                                    (x.displayName = ie)));
                                        },
                                    }),
                                    M
                                );
                            }),
                            (l.startTransition = function (x) {
                                var M = Oe.T,
                                    ee = {};
                                ((Oe.T = ee), (ee._updatedFibers = new Set()));
                                try {
                                    var ie = x(),
                                        pe = Oe.S;
                                    (pe !== null && pe(ee, ie),
                                        typeof ie == 'object' &&
                                        ie !== null &&
                                        typeof ie.then == 'function' &&
                                        ie.then(oe, vl));
                                } catch (Re) {
                                    vl(Re);
                                } finally {
                                    (M === null &&
                                        ee._updatedFibers &&
                                        ((x = ee._updatedFibers.size),
                                            ee._updatedFibers.clear(),
                                            10 < x &&
                                            console.warn(
                                                'Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.'
                                            )),
                                        (Oe.T = M));
                                }
                            }),
                            (l.unstable_useCacheRefresh = function () {
                                return X().useCacheRefresh();
                            }),
                            (l.use = function (x) {
                                return X().use(x);
                            }),
                            (l.useActionState = function (x, M, ee) {
                                return X().useActionState(x, M, ee);
                            }),
                            (l.useCallback = function (x, M) {
                                return X().useCallback(x, M);
                            }),
                            (l.useContext = function (x) {
                                var M = X();
                                return (
                                    x.$$typeof === Ge &&
                                    console.error(
                                        'Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?'
                                    ),
                                    M.useContext(x)
                                );
                            }),
                            (l.useDebugValue = function (x, M) {
                                return X().useDebugValue(x, M);
                            }),
                            (l.useDeferredValue = function (x, M) {
                                return X().useDeferredValue(x, M);
                            }),
                            (l.useEffect = function (x, M, ee) {
                                x == null &&
                                    console.warn(
                                        'React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?'
                                    );
                                var ie = X();
                                if (typeof ee == 'function')
                                    throw Error(
                                        'useEffect CRUD overload is not enabled in this build of React.'
                                    );
                                return ie.useEffect(x, M);
                            }),
                            (l.useId = function () {
                                return X().useId();
                            }),
                            (l.useImperativeHandle = function (x, M, ee) {
                                return X().useImperativeHandle(x, M, ee);
                            }),
                            (l.useInsertionEffect = function (x, M) {
                                return (
                                    x == null &&
                                    console.warn(
                                        'React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?'
                                    ),
                                    X().useInsertionEffect(x, M)
                                );
                            }),
                            (l.useLayoutEffect = function (x, M) {
                                return (
                                    x == null &&
                                    console.warn(
                                        'React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?'
                                    ),
                                    X().useLayoutEffect(x, M)
                                );
                            }),
                            (l.useMemo = function (x, M) {
                                return X().useMemo(x, M);
                            }),
                            (l.useOptimistic = function (x, M) {
                                return X().useOptimistic(x, M);
                            }),
                            (l.useReducer = function (x, M, ee) {
                                return X().useReducer(x, M, ee);
                            }),
                            (l.useRef = function (x) {
                                return X().useRef(x);
                            }),
                            (l.useState = function (x) {
                                return X().useState(x);
                            }),
                            (l.useSyncExternalStore = function (x, M, ee) {
                                return X().useSyncExternalStore(x, M, ee);
                            }),
                            (l.useTransition = function () {
                                return X().useTransition();
                            }),
                            (l.version = '19.1.1'),
                            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ==
                            'function' &&
                            __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(
                                Error()
                            ));
                    })();
                })(ru, ru.exports)),
            ru.exports
        );
    }
    var q1;
    function Nu() {
        return (q1 || ((q1 = 1), (ip.exports = zw())), ip.exports);
    }
    var $1;
    function Bw() {
        if ($1) return su;
        $1 = 1;
        /**
         * @license React
         * react-jsx-dev-runtime.development.js
         *
         * Copyright (c) Meta Platforms, Inc. and affiliates.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */ return (
            (function () {
                function i(U) {
                    if (U == null) return null;
                    if (typeof U == 'function')
                        return U.$$typeof === te
                            ? null
                            : U.displayName || U.name || null;
                    if (typeof U == 'string') return U;
                    switch (U) {
                        case O:
                            return 'Fragment';
                        case _:
                            return 'Profiler';
                        case k:
                            return 'StrictMode';
                        case P:
                            return 'Suspense';
                        case le:
                            return 'SuspenseList';
                        case K:
                            return 'Activity';
                    }
                    if (typeof U == 'object')
                        switch (
                        (typeof U.tag == 'number' &&
                            console.error(
                                'Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.'
                            ),
                            U.$$typeof)
                        ) {
                            case D:
                                return 'Portal';
                            case Y:
                                return (U.displayName || 'Context') + '.Provider';
                            case I:
                                return (U._context.displayName || 'Context') + '.Consumer';
                            case Z:
                                var re = U.render;
                                return (
                                    (U = U.displayName),
                                    U ||
                                    ((U = re.displayName || re.name || ''),
                                        (U =
                                            U !== '' ? 'ForwardRef(' + U + ')' : 'ForwardRef')),
                                    U
                                );
                            case q:
                                return (
                                    (re = U.displayName || null),
                                    re !== null ? re : i(U.type) || 'Memo'
                                );
                            case W:
                                ((re = U._payload), (U = U._init));
                                try {
                                    return i(U(re));
                                } catch { }
                        }
                    return null;
                }
                function l(U) {
                    return '' + U;
                }
                function s(U) {
                    try {
                        var re = !1;
                    } catch {
                        re = !0;
                    }
                    if (re) {
                        re = console;
                        var ue = re.error,
                            Ge =
                                (typeof Symbol == 'function' &&
                                    Symbol.toStringTag &&
                                    U[Symbol.toStringTag]) ||
                                U.constructor.name ||
                                'Object';
                        return (
                            ue.call(
                                re,
                                'The provided key is an unsupported type %s. This value must be coerced to a string before using it here.',
                                Ge
                            ),
                            l(U)
                        );
                    }
                }
                function r(U) {
                    if (U === O) return '<>';
                    if (typeof U == 'object' && U !== null && U.$$typeof === W)
                        return '<...>';
                    try {
                        var re = i(U);
                        return re ? '<' + re + '>' : '<...>';
                    } catch {
                        return '<...>';
                    }
                }
                function u() {
                    var U = X.A;
                    return U === null ? null : U.getOwner();
                }
                function d() {
                    return Error('react-stack-top-frame');
                }
                function p(U) {
                    if (oe.call(U, 'key')) {
                        var re = Object.getOwnPropertyDescriptor(U, 'key').get;
                        if (re && re.isReactWarning) return !1;
                    }
                    return U.key !== void 0;
                }
                function h(U, re) {
                    function ue() {
                        _e ||
                            ((_e = !0),
                                console.error(
                                    '%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)',
                                    re
                                ));
                    }
                    ((ue.isReactWarning = !0),
                        Object.defineProperty(U, 'key', { get: ue, configurable: !0 }));
                }
                function m() {
                    var U = i(this.type);
                    return (
                        J[U] ||
                        ((J[U] = !0),
                            console.error(
                                'Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.'
                            )),
                        (U = this.props.ref),
                        U !== void 0 ? U : null
                    );
                }
                function y(U, re, ue, Ge, at, zt, Ie, Ri) {
                    return (
                        (ue = zt.ref),
                        (U = { $$typeof: S, type: U, key: re, props: zt, _owner: at }),
                        (ue !== void 0 ? ue : null) !== null
                            ? Object.defineProperty(U, 'ref', { enumerable: !1, get: m })
                            : Object.defineProperty(U, 'ref', {
                                enumerable: !1,
                                value: null,
                            }),
                        (U._store = {}),
                        Object.defineProperty(U._store, 'validated', {
                            configurable: !1,
                            enumerable: !1,
                            writable: !0,
                            value: 0,
                        }),
                        Object.defineProperty(U, '_debugInfo', {
                            configurable: !1,
                            enumerable: !1,
                            writable: !0,
                            value: null,
                        }),
                        Object.defineProperty(U, '_debugStack', {
                            configurable: !1,
                            enumerable: !1,
                            writable: !0,
                            value: Ie,
                        }),
                        Object.defineProperty(U, '_debugTask', {
                            configurable: !1,
                            enumerable: !1,
                            writable: !0,
                            value: Ri,
                        }),
                        Object.freeze && (Object.freeze(U.props), Object.freeze(U)),
                        U
                    );
                }
                function E(U, re, ue, Ge, at, zt, Ie, Ri) {
                    var ot = re.children;
                    if (ot !== void 0)
                        if (Ge)
                            if (ge(ot)) {
                                for (Ge = 0; Ge < ot.length; Ge++) v(ot[Ge]);
                                Object.freeze && Object.freeze(ot);
                            } else
                                console.error(
                                    'React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.'
                                );
                        else v(ot);
                    if (oe.call(re, 'key')) {
                        ot = i(U);
                        var Tt = Object.keys(re).filter(function (Mi) {
                            return Mi !== 'key';
                        });
                        ((Ge =
                            0 < Tt.length
                                ? '{key: someKey, ' + Tt.join(': ..., ') + ': ...}'
                                : '{key: someKey}'),
                            me[ot + Ge] ||
                            ((Tt =
                                0 < Tt.length
                                    ? '{' + Tt.join(': ..., ') + ': ...}'
                                    : '{}'),
                                console.error(
                                    `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
                                    Ge,
                                    ot,
                                    Tt,
                                    ot
                                ),
                                (me[ot + Ge] = !0)));
                    }
                    if (
                        ((ot = null),
                            ue !== void 0 && (s(ue), (ot = '' + ue)),
                            p(re) && (s(re.key), (ot = '' + re.key)),
                            'key' in re)
                    ) {
                        ue = {};
                        for (var bn in re) bn !== 'key' && (ue[bn] = re[bn]);
                    } else ue = re;
                    return (
                        ot &&
                        h(
                            ue,
                            typeof U == 'function'
                                ? U.displayName || U.name || 'Unknown'
                                : U
                        ),
                        y(U, ot, zt, at, u(), ue, Ie, Ri)
                    );
                }
                function v(U) {
                    typeof U == 'object' &&
                        U !== null &&
                        U.$$typeof === S &&
                        U._store &&
                        (U._store.validated = 1);
                }
                var N = Nu(),
                    S = Symbol.for('react.transitional.element'),
                    D = Symbol.for('react.portal'),
                    O = Symbol.for('react.fragment'),
                    k = Symbol.for('react.strict_mode'),
                    _ = Symbol.for('react.profiler'),
                    I = Symbol.for('react.consumer'),
                    Y = Symbol.for('react.context'),
                    Z = Symbol.for('react.forward_ref'),
                    P = Symbol.for('react.suspense'),
                    le = Symbol.for('react.suspense_list'),
                    q = Symbol.for('react.memo'),
                    W = Symbol.for('react.lazy'),
                    K = Symbol.for('react.activity'),
                    te = Symbol.for('react.client.reference'),
                    X =
                        N.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
                    oe = Object.prototype.hasOwnProperty,
                    ge = Array.isArray,
                    Ee = console.createTask
                        ? console.createTask
                        : function () {
                            return null;
                        };
                N = {
                    react_stack_bottom_frame: function (U) {
                        return U();
                    },
                };
                var _e,
                    J = {},
                    ce = N.react_stack_bottom_frame.bind(N, d)(),
                    Q = Ee(r(d)),
                    me = {};
                ((su.Fragment = O),
                    (su.jsxDEV = function (U, re, ue, Ge, at, zt) {
                        var Ie = 1e4 > X.recentlyCreatedOwnerStacks++;
                        return E(
                            U,
                            re,
                            ue,
                            Ge,
                            at,
                            zt,
                            Ie ? Error('react-stack-top-frame') : ce,
                            Ie ? Ee(r(U)) : Q
                        );
                    }));
            })(),
            su
        );
    }
    var F1;
    function Lw() {
        return (F1 || ((F1 = 1), (ap.exports = Bw())), ap.exports);
    }
    var b = Lw(),
        $ = Nu();
    const Nt = Vw($);
    var lp = { exports: {} },
        tr = {},
        op = { exports: {} },
        sp = {},
        K1;
    function Iw() {
        return (
            K1 ||
            ((K1 = 1),
                (function (i) {
              /**
               * @license React
               * scheduler.development.js
               *
               * Copyright (c) Meta Platforms, Inc. and affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */ (function () {
                        function l() {
                            if (((P = !1), K)) {
                                var J = i.unstable_now();
                                oe = J;
                                var ce = !0;
                                try {
                                    e: {
                                        ((Y = !1), Z && ((Z = !1), q(te), (te = -1)), (I = !0));
                                        var Q = _;
                                        try {
                                            t: {
                                                for (
                                                    p(J), k = r(S);
                                                    k !== null && !(k.expirationTime > J && m());
                                                ) {
                                                    var me = k.callback;
                                                    if (typeof me == 'function') {
                                                        ((k.callback = null), (_ = k.priorityLevel));
                                                        var U = me(k.expirationTime <= J);
                                                        if (
                                                            ((J = i.unstable_now()),
                                                                typeof U == 'function')
                                                        ) {
                                                            ((k.callback = U), p(J), (ce = !0));
                                                            break t;
                                                        }
                                                        (k === r(S) && u(S), p(J));
                                                    } else u(S);
                                                    k = r(S);
                                                }
                                                if (k !== null) ce = !0;
                                                else {
                                                    var re = r(D);
                                                    (re !== null && y(h, re.startTime - J),
                                                        (ce = !1));
                                                }
                                            }
                                            break e;
                                        } finally {
                                            ((k = null), (_ = Q), (I = !1));
                                        }
                                        ce = void 0;
                                    }
                                } finally {
                                    ce ? ge() : (K = !1);
                                }
                            }
                        }
                        function s(J, ce) {
                            var Q = J.length;
                            J.push(ce);
                            e: for (; 0 < Q;) {
                                var me = (Q - 1) >>> 1,
                                    U = J[me];
                                if (0 < d(U, ce)) ((J[me] = ce), (J[Q] = U), (Q = me));
                                else break e;
                            }
                        }
                        function r(J) {
                            return J.length === 0 ? null : J[0];
                        }
                        function u(J) {
                            if (J.length === 0) return null;
                            var ce = J[0],
                                Q = J.pop();
                            if (Q !== ce) {
                                J[0] = Q;
                                e: for (var me = 0, U = J.length, re = U >>> 1; me < re;) {
                                    var ue = 2 * (me + 1) - 1,
                                        Ge = J[ue],
                                        at = ue + 1,
                                        zt = J[at];
                                    if (0 > d(Ge, Q))
                                        at < U && 0 > d(zt, Ge)
                                            ? ((J[me] = zt), (J[at] = Q), (me = at))
                                            : ((J[me] = Ge), (J[ue] = Q), (me = ue));
                                    else if (at < U && 0 > d(zt, Q))
                                        ((J[me] = zt), (J[at] = Q), (me = at));
                                    else break e;
                                }
                            }
                            return ce;
                        }
                        function d(J, ce) {
                            var Q = J.sortIndex - ce.sortIndex;
                            return Q !== 0 ? Q : J.id - ce.id;
                        }
                        function p(J) {
                            for (var ce = r(D); ce !== null;) {
                                if (ce.callback === null) u(D);
                                else if (ce.startTime <= J)
                                    (u(D), (ce.sortIndex = ce.expirationTime), s(S, ce));
                                else break;
                                ce = r(D);
                            }
                        }
                        function h(J) {
                            if (((Z = !1), p(J), !Y))
                                if (r(S) !== null) ((Y = !0), K || ((K = !0), ge()));
                                else {
                                    var ce = r(D);
                                    ce !== null && y(h, ce.startTime - J);
                                }
                        }
                        function m() {
                            return P ? !0 : !(i.unstable_now() - oe < X);
                        }
                        function y(J, ce) {
                            te = le(function () {
                                J(i.unstable_now());
                            }, ce);
                        }
                        if (
                            (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                                typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ==
                                'function' &&
                                __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(
                                    Error()
                                ),
                                (i.unstable_now = void 0),
                                typeof performance == 'object' &&
                                typeof performance.now == 'function')
                        ) {
                            var E = performance;
                            i.unstable_now = function () {
                                return E.now();
                            };
                        } else {
                            var v = Date,
                                N = v.now();
                            i.unstable_now = function () {
                                return v.now() - N;
                            };
                        }
                        var S = [],
                            D = [],
                            O = 1,
                            k = null,
                            _ = 3,
                            I = !1,
                            Y = !1,
                            Z = !1,
                            P = !1,
                            le = typeof setTimeout == 'function' ? setTimeout : null,
                            q = typeof clearTimeout == 'function' ? clearTimeout : null,
                            W = typeof setImmediate < 'u' ? setImmediate : null,
                            K = !1,
                            te = -1,
                            X = 5,
                            oe = -1;
                        if (typeof W == 'function')
                            var ge = function () {
                                W(l);
                            };
                        else if (typeof MessageChannel < 'u') {
                            var Ee = new MessageChannel(),
                                _e = Ee.port2;
                            ((Ee.port1.onmessage = l),
                                (ge = function () {
                                    _e.postMessage(null);
                                }));
                        } else
                            ge = function () {
                                le(l, 0);
                            };
                        ((i.unstable_IdlePriority = 5),
                            (i.unstable_ImmediatePriority = 1),
                            (i.unstable_LowPriority = 4),
                            (i.unstable_NormalPriority = 3),
                            (i.unstable_Profiling = null),
                            (i.unstable_UserBlockingPriority = 2),
                            (i.unstable_cancelCallback = function (J) {
                                J.callback = null;
                            }),
                            (i.unstable_forceFrameRate = function (J) {
                                0 > J || 125 < J
                                    ? console.error(
                                        'forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported'
                                    )
                                    : (X = 0 < J ? Math.floor(1e3 / J) : 5);
                            }),
                            (i.unstable_getCurrentPriorityLevel = function () {
                                return _;
                            }),
                            (i.unstable_next = function (J) {
                                switch (_) {
                                    case 1:
                                    case 2:
                                    case 3:
                                        var ce = 3;
                                        break;
                                    default:
                                        ce = _;
                                }
                                var Q = _;
                                _ = ce;
                                try {
                                    return J();
                                } finally {
                                    _ = Q;
                                }
                            }),
                            (i.unstable_requestPaint = function () {
                                P = !0;
                            }),
                            (i.unstable_runWithPriority = function (J, ce) {
                                switch (J) {
                                    case 1:
                                    case 2:
                                    case 3:
                                    case 4:
                                    case 5:
                                        break;
                                    default:
                                        J = 3;
                                }
                                var Q = _;
                                _ = J;
                                try {
                                    return ce();
                                } finally {
                                    _ = Q;
                                }
                            }),
                            (i.unstable_scheduleCallback = function (J, ce, Q) {
                                var me = i.unstable_now();
                                switch (
                                (typeof Q == 'object' && Q !== null
                                    ? ((Q = Q.delay),
                                        (Q = typeof Q == 'number' && 0 < Q ? me + Q : me))
                                    : (Q = me),
                                    J)
                                ) {
                                    case 1:
                                        var U = -1;
                                        break;
                                    case 2:
                                        U = 250;
                                        break;
                                    case 5:
                                        U = 1073741823;
                                        break;
                                    case 4:
                                        U = 1e4;
                                        break;
                                    default:
                                        U = 5e3;
                                }
                                return (
                                    (U = Q + U),
                                    (J = {
                                        id: O++,
                                        callback: ce,
                                        priorityLevel: J,
                                        startTime: Q,
                                        expirationTime: U,
                                        sortIndex: -1,
                                    }),
                                    Q > me
                                        ? ((J.sortIndex = Q),
                                            s(D, J),
                                            r(S) === null &&
                                            J === r(D) &&
                                            (Z ? (q(te), (te = -1)) : (Z = !0), y(h, Q - me)))
                                        : ((J.sortIndex = U),
                                            s(S, J),
                                            Y || I || ((Y = !0), K || ((K = !0), ge()))),
                                    J
                                );
                            }),
                            (i.unstable_shouldYield = m),
                            (i.unstable_wrapCallback = function (J) {
                                var ce = _;
                                return function () {
                                    var Q = _;
                                    _ = ce;
                                    try {
                                        return J.apply(this, arguments);
                                    } finally {
                                        _ = Q;
                                    }
                                };
                            }),
                            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ==
                            'function' &&
                            __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(
                                Error()
                            ));
                    })();
                })(sp)),
            sp
        );
    }
    var e0;
    function Hw() {
        return (e0 || ((e0 = 1), (op.exports = Iw())), op.exports);
    }
    var rp = { exports: {} },
        Ht = {},
        t0;
    function Uw() {
        if (t0) return Ht;
        t0 = 1;
        /**
         * @license React
         * react-dom.development.js
         *
         * Copyright (c) Meta Platforms, Inc. and affiliates.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */ return (
            (function () {
                function i() { }
                function l(v) {
                    return '' + v;
                }
                function s(v, N, S) {
                    var D =
                        3 < arguments.length && arguments[3] !== void 0
                            ? arguments[3]
                            : null;
                    try {
                        var O = !1;
                    } catch {
                        O = !0;
                    }
                    return (
                        O &&
                        (console.error(
                            'The provided key is an unsupported type %s. This value must be coerced to a string before using it here.',
                            (typeof Symbol == 'function' &&
                                Symbol.toStringTag &&
                                D[Symbol.toStringTag]) ||
                            D.constructor.name ||
                            'Object'
                        ),
                            l(D)),
                        {
                            $$typeof: y,
                            key: D == null ? null : '' + D,
                            children: v,
                            containerInfo: N,
                            implementation: S,
                        }
                    );
                }
                function r(v, N) {
                    if (v === 'font') return '';
                    if (typeof N == 'string') return N === 'use-credentials' ? N : '';
                }
                function u(v) {
                    return v === null
                        ? '`null`'
                        : v === void 0
                            ? '`undefined`'
                            : v === ''
                                ? 'an empty string'
                                : 'something with type "' + typeof v + '"';
                }
                function d(v) {
                    return v === null
                        ? '`null`'
                        : v === void 0
                            ? '`undefined`'
                            : v === ''
                                ? 'an empty string'
                                : typeof v == 'string'
                                    ? JSON.stringify(v)
                                    : typeof v == 'number'
                                        ? '`' + v + '`'
                                        : 'something with type "' + typeof v + '"';
                }
                function p() {
                    var v = E.H;
                    return (
                        v === null &&
                        console.error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`),
                        v
                    );
                }
                typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ==
                    'function' &&
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(
                        Error()
                    );
                var h = Nu(),
                    m = {
                        d: {
                            f: i,
                            r: function () {
                                throw Error(
                                    'Invalid form element. requestFormReset must be passed a form that was rendered by React.'
                                );
                            },
                            D: i,
                            C: i,
                            L: i,
                            m: i,
                            X: i,
                            S: i,
                            M: i,
                        },
                        p: 0,
                        findDOMNode: null,
                    },
                    y = Symbol.for('react.portal'),
                    E =
                        h.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
                ((typeof Map == 'function' &&
                    Map.prototype != null &&
                    typeof Map.prototype.forEach == 'function' &&
                    typeof Set == 'function' &&
                    Set.prototype != null &&
                    typeof Set.prototype.clear == 'function' &&
                    typeof Set.prototype.forEach == 'function') ||
                    console.error(
                        'React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills'
                    ),
                    (Ht.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
                        m),
                    (Ht.createPortal = function (v, N) {
                        var S =
                            2 < arguments.length && arguments[2] !== void 0
                                ? arguments[2]
                                : null;
                        if (
                            !N ||
                            (N.nodeType !== 1 && N.nodeType !== 9 && N.nodeType !== 11)
                        )
                            throw Error('Target container is not a DOM element.');
                        return s(v, N, null, S);
                    }),
                    (Ht.flushSync = function (v) {
                        var N = E.T,
                            S = m.p;
                        try {
                            if (((E.T = null), (m.p = 2), v)) return v();
                        } finally {
                            ((E.T = N),
                                (m.p = S),
                                m.d.f() &&
                                console.error(
                                    'flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.'
                                ));
                        }
                    }),
                    (Ht.preconnect = function (v, N) {
                        (typeof v == 'string' && v
                            ? N != null && typeof N != 'object'
                                ? console.error(
                                    'ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.',
                                    d(N)
                                )
                                : N != null &&
                                typeof N.crossOrigin != 'string' &&
                                console.error(
                                    'ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.',
                                    u(N.crossOrigin)
                                )
                            : console.error(
                                'ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.',
                                u(v)
                            ),
                            typeof v == 'string' &&
                            (N
                                ? ((N = N.crossOrigin),
                                    (N =
                                        typeof N == 'string'
                                            ? N === 'use-credentials'
                                                ? N
                                                : ''
                                            : void 0))
                                : (N = null),
                                m.d.C(v, N)));
                    }),
                    (Ht.prefetchDNS = function (v) {
                        if (typeof v != 'string' || !v)
                            console.error(
                                'ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.',
                                u(v)
                            );
                        else if (1 < arguments.length) {
                            var N = arguments[1];
                            typeof N == 'object' && N.hasOwnProperty('crossOrigin')
                                ? console.error(
                                    'ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.',
                                    d(N)
                                )
                                : console.error(
                                    'ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.',
                                    d(N)
                                );
                        }
                        typeof v == 'string' && m.d.D(v);
                    }),
                    (Ht.preinit = function (v, N) {
                        if (
                            (typeof v == 'string' && v
                                ? N == null || typeof N != 'object'
                                    ? console.error(
                                        'ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.',
                                        d(N)
                                    )
                                    : N.as !== 'style' &&
                                    N.as !== 'script' &&
                                    console.error(
                                        'ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".',
                                        d(N.as)
                                    )
                                : console.error(
                                    'ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.',
                                    u(v)
                                ),
                                typeof v == 'string' && N && typeof N.as == 'string')
                        ) {
                            var S = N.as,
                                D = r(S, N.crossOrigin),
                                O = typeof N.integrity == 'string' ? N.integrity : void 0,
                                k =
                                    typeof N.fetchPriority == 'string'
                                        ? N.fetchPriority
                                        : void 0;
                            S === 'style'
                                ? m.d.S(
                                    v,
                                    typeof N.precedence == 'string' ? N.precedence : void 0,
                                    { crossOrigin: D, integrity: O, fetchPriority: k }
                                )
                                : S === 'script' &&
                                m.d.X(v, {
                                    crossOrigin: D,
                                    integrity: O,
                                    fetchPriority: k,
                                    nonce: typeof N.nonce == 'string' ? N.nonce : void 0,
                                });
                        }
                    }),
                    (Ht.preinitModule = function (v, N) {
                        var S = '';
                        if (
                            ((typeof v == 'string' && v) ||
                                (S += ' The `href` argument encountered was ' + u(v) + '.'),
                                N !== void 0 && typeof N != 'object'
                                    ? (S +=
                                        ' The `options` argument encountered was ' + u(N) + '.')
                                    : N &&
                                    'as' in N &&
                                    N.as !== 'script' &&
                                    (S +=
                                        ' The `as` option encountered was ' + d(N.as) + '.'),
                                S)
                        )
                            console.error(
                                'ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s',
                                S
                            );
                        else
                            switch (
                            ((S = N && typeof N.as == 'string' ? N.as : 'script'), S)
                            ) {
                                case 'script':
                                    break;
                                default:
                                    ((S = d(S)),
                                        console.error(
                                            'ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)',
                                            S,
                                            v
                                        ));
                            }
                        typeof v == 'string' &&
                            (typeof N == 'object' && N !== null
                                ? (N.as == null || N.as === 'script') &&
                                ((S = r(N.as, N.crossOrigin)),
                                    m.d.M(v, {
                                        crossOrigin: S,
                                        integrity:
                                            typeof N.integrity == 'string' ? N.integrity : void 0,
                                        nonce: typeof N.nonce == 'string' ? N.nonce : void 0,
                                    }))
                                : N == null && m.d.M(v));
                    }),
                    (Ht.preload = function (v, N) {
                        var S = '';
                        if (
                            ((typeof v == 'string' && v) ||
                                (S += ' The `href` argument encountered was ' + u(v) + '.'),
                                N == null || typeof N != 'object'
                                    ? (S +=
                                        ' The `options` argument encountered was ' + u(N) + '.')
                                    : (typeof N.as == 'string' && N.as) ||
                                    (S +=
                                        ' The `as` option encountered was ' + u(N.as) + '.'),
                                S &&
                                console.error(
                                    'ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s',
                                    S
                                ),
                                typeof v == 'string' &&
                                typeof N == 'object' &&
                                N !== null &&
                                typeof N.as == 'string')
                        ) {
                            S = N.as;
                            var D = r(S, N.crossOrigin);
                            m.d.L(v, S, {
                                crossOrigin: D,
                                integrity:
                                    typeof N.integrity == 'string' ? N.integrity : void 0,
                                nonce: typeof N.nonce == 'string' ? N.nonce : void 0,
                                type: typeof N.type == 'string' ? N.type : void 0,
                                fetchPriority:
                                    typeof N.fetchPriority == 'string'
                                        ? N.fetchPriority
                                        : void 0,
                                referrerPolicy:
                                    typeof N.referrerPolicy == 'string'
                                        ? N.referrerPolicy
                                        : void 0,
                                imageSrcSet:
                                    typeof N.imageSrcSet == 'string' ? N.imageSrcSet : void 0,
                                imageSizes:
                                    typeof N.imageSizes == 'string' ? N.imageSizes : void 0,
                                media: typeof N.media == 'string' ? N.media : void 0,
                            });
                        }
                    }),
                    (Ht.preloadModule = function (v, N) {
                        var S = '';
                        ((typeof v == 'string' && v) ||
                            (S += ' The `href` argument encountered was ' + u(v) + '.'),
                            N !== void 0 && typeof N != 'object'
                                ? (S +=
                                    ' The `options` argument encountered was ' + u(N) + '.')
                                : N &&
                                'as' in N &&
                                typeof N.as != 'string' &&
                                (S +=
                                    ' The `as` option encountered was ' + u(N.as) + '.'),
                            S &&
                            console.error(
                                'ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s',
                                S
                            ),
                            typeof v == 'string' &&
                            (N
                                ? ((S = r(N.as, N.crossOrigin)),
                                    m.d.m(v, {
                                        as:
                                            typeof N.as == 'string' && N.as !== 'script'
                                                ? N.as
                                                : void 0,
                                        crossOrigin: S,
                                        integrity:
                                            typeof N.integrity == 'string'
                                                ? N.integrity
                                                : void 0,
                                    }))
                                : m.d.m(v)));
                    }),
                    (Ht.requestFormReset = function (v) {
                        m.d.r(v);
                    }),
                    (Ht.unstable_batchedUpdates = function (v, N) {
                        return v(N);
                    }),
                    (Ht.useFormState = function (v, N, S) {
                        return p().useFormState(v, N, S);
                    }),
                    (Ht.useFormStatus = function () {
                        return p().useHostTransitionStatus();
                    }),
                    (Ht.version = '19.1.1'),
                    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ==
                    'function' &&
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(
                        Error()
                    ));
            })(),
            Ht
        );
    }
    var n0;
    function z0() {
        return (n0 || ((n0 = 1), (rp.exports = Uw())), rp.exports);
    }
    var a0;
    function Gw() {
        if (a0) return tr;
        a0 = 1;
        /**
         * @license React
         * react-dom-client.development.js
         *
         * Copyright (c) Meta Platforms, Inc. and affiliates.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */ return (
            (function () {
                function i(e, t) {
                    for (e = e.memoizedState; e !== null && 0 < t;)
                        ((e = e.next), t--);
                    return e;
                }
                function l(e, t, n, a) {
                    if (n >= t.length) return a;
                    var o = t[n],
                        c = Ot(e) ? e.slice() : Me({}, e);
                    return ((c[o] = l(e[o], t, n + 1, a)), c);
                }
                function s(e, t, n) {
                    if (t.length !== n.length)
                        console.warn(
                            'copyWithRename() expects paths of the same length'
                        );
                    else {
                        for (var a = 0; a < n.length - 1; a++)
                            if (t[a] !== n[a]) {
                                console.warn(
                                    'copyWithRename() expects paths to be the same except for the deepest key'
                                );
                                return;
                            }
                        return r(e, t, n, 0);
                    }
                }
                function r(e, t, n, a) {
                    var o = t[a],
                        c = Ot(e) ? e.slice() : Me({}, e);
                    return (
                        a + 1 === t.length
                            ? ((c[n[a]] = c[o]), Ot(c) ? c.splice(o, 1) : delete c[o])
                            : (c[o] = r(e[o], t, n, a + 1)),
                        c
                    );
                }
                function u(e, t, n) {
                    var a = t[n],
                        o = Ot(e) ? e.slice() : Me({}, e);
                    return n + 1 === t.length
                        ? (Ot(o) ? o.splice(a, 1) : delete o[a], o)
                        : ((o[a] = u(e[a], t, n + 1)), o);
                }
                function d() {
                    return !1;
                }
                function p() {
                    return null;
                }
                function h() { }
                function m() {
                    console.error(
                        'Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks'
                    );
                }
                function y() {
                    console.error(
                        'Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().'
                    );
                }
                function E() { }
                function v(e) {
                    var t = [];
                    return (
                        e.forEach(function (n) {
                            t.push(n);
                        }),
                        t.sort().join(', ')
                    );
                }
                function N(e, t, n, a) {
                    return new kS(e, t, n, a);
                }
                function S(e, t) {
                    e.context === mi && (Rf(e.current, 2, t, e, null, null), Ol());
                }
                function D(e, t) {
                    if (An !== null) {
                        var n = t.staleFamilies;
                        ((t = t.updatedFamilies), is(), Xu(e.current, t, n), Ol());
                    }
                }
                function O(e) {
                    An = e;
                }
                function k(e) {
                    return !(
                        !e ||
                        (e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11)
                    );
                }
                function _(e) {
                    var t = e,
                        n = e;
                    if (e.alternate) for (; t.return;) t = t.return;
                    else {
                        e = t;
                        do
                            ((t = e),
                                (t.flags & 4098) !== 0 && (n = t.return),
                                (e = t.return));
                        while (e);
                    }
                    return t.tag === 3 ? n : null;
                }
                function I(e) {
                    if (e.tag === 13) {
                        var t = e.memoizedState;
                        if (
                            (t === null &&
                                ((e = e.alternate), e !== null && (t = e.memoizedState)),
                                t !== null)
                        )
                            return t.dehydrated;
                    }
                    return null;
                }
                function Y(e) {
                    if (_(e) !== e)
                        throw Error('Unable to find node on an unmounted component.');
                }
                function Z(e) {
                    var t = e.alternate;
                    if (!t) {
                        if (((t = _(e)), t === null))
                            throw Error('Unable to find node on an unmounted component.');
                        return t !== e ? null : e;
                    }
                    for (var n = e, a = t; ;) {
                        var o = n.return;
                        if (o === null) break;
                        var c = o.alternate;
                        if (c === null) {
                            if (((a = o.return), a !== null)) {
                                n = a;
                                continue;
                            }
                            break;
                        }
                        if (o.child === c.child) {
                            for (c = o.child; c;) {
                                if (c === n) return (Y(o), e);
                                if (c === a) return (Y(o), t);
                                c = c.sibling;
                            }
                            throw Error('Unable to find node on an unmounted component.');
                        }
                        if (n.return !== a.return) ((n = o), (a = c));
                        else {
                            for (var f = !1, g = o.child; g;) {
                                if (g === n) {
                                    ((f = !0), (n = o), (a = c));
                                    break;
                                }
                                if (g === a) {
                                    ((f = !0), (a = o), (n = c));
                                    break;
                                }
                                g = g.sibling;
                            }
                            if (!f) {
                                for (g = c.child; g;) {
                                    if (g === n) {
                                        ((f = !0), (n = c), (a = o));
                                        break;
                                    }
                                    if (g === a) {
                                        ((f = !0), (a = c), (n = o));
                                        break;
                                    }
                                    g = g.sibling;
                                }
                                if (!f)
                                    throw Error(
                                        'Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.'
                                    );
                            }
                        }
                        if (n.alternate !== a)
                            throw Error(
                                "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
                            );
                    }
                    if (n.tag !== 3)
                        throw Error('Unable to find node on an unmounted component.');
                    return n.stateNode.current === n ? e : t;
                }
                function P(e) {
                    var t = e.tag;
                    if (t === 5 || t === 26 || t === 27 || t === 6) return e;
                    for (e = e.child; e !== null;) {
                        if (((t = P(e)), t !== null)) return t;
                        e = e.sibling;
                    }
                    return null;
                }
                function le(e) {
                    return e === null || typeof e != 'object'
                        ? null
                        : ((e = (yy && e[yy]) || e['@@iterator']),
                            typeof e == 'function' ? e : null);
                }
                function q(e) {
                    if (e == null) return null;
                    if (typeof e == 'function')
                        return e.$$typeof === Qx
                            ? null
                            : e.displayName || e.name || null;
                    if (typeof e == 'string') return e;
                    switch (e) {
                        case Il:
                            return 'Fragment';
                        case Bf:
                            return 'Profiler';
                        case mc:
                            return 'StrictMode';
                        case If:
                            return 'Suspense';
                        case Hf:
                            return 'SuspenseList';
                        case Uf:
                            return 'Activity';
                    }
                    if (typeof e == 'object')
                        switch (
                        (typeof e.tag == 'number' &&
                            console.error(
                                'Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.'
                            ),
                            e.$$typeof)
                        ) {
                            case Ll:
                                return 'Portal';
                            case la:
                                return (e.displayName || 'Context') + '.Provider';
                            case Lf:
                                return (e._context.displayName || 'Context') + '.Consumer';
                            case ms:
                                var t = e.render;
                                return (
                                    (e = e.displayName),
                                    e ||
                                    ((e = t.displayName || t.name || ''),
                                        (e =
                                            e !== '' ? 'ForwardRef(' + e + ')' : 'ForwardRef')),
                                    e
                                );
                            case pc:
                                return (
                                    (t = e.displayName || null),
                                    t !== null ? t : q(e.type) || 'Memo'
                                );
                            case dn:
                                ((t = e._payload), (e = e._init));
                                try {
                                    return q(e(t));
                                } catch { }
                        }
                    return null;
                }
                function W(e) {
                    return typeof e.tag == 'number'
                        ? K(e)
                        : typeof e.name == 'string'
                            ? e.name
                            : null;
                }
                function K(e) {
                    var t = e.type;
                    switch (e.tag) {
                        case 31:
                            return 'Activity';
                        case 24:
                            return 'Cache';
                        case 9:
                            return (t._context.displayName || 'Context') + '.Consumer';
                        case 10:
                            return (t.displayName || 'Context') + '.Provider';
                        case 18:
                            return 'DehydratedFragment';
                        case 11:
                            return (
                                (e = t.render),
                                (e = e.displayName || e.name || ''),
                                t.displayName ||
                                (e !== '' ? 'ForwardRef(' + e + ')' : 'ForwardRef')
                            );
                        case 7:
                            return 'Fragment';
                        case 26:
                        case 27:
                        case 5:
                            return t;
                        case 4:
                            return 'Portal';
                        case 3:
                            return 'Root';
                        case 6:
                            return 'Text';
                        case 16:
                            return q(t);
                        case 8:
                            return t === mc ? 'StrictMode' : 'Mode';
                        case 22:
                            return 'Offscreen';
                        case 12:
                            return 'Profiler';
                        case 21:
                            return 'Scope';
                        case 13:
                            return 'Suspense';
                        case 19:
                            return 'SuspenseList';
                        case 25:
                            return 'TracingMarker';
                        case 1:
                        case 0:
                        case 14:
                        case 15:
                            if (typeof t == 'function')
                                return t.displayName || t.name || null;
                            if (typeof t == 'string') return t;
                            break;
                        case 29:
                            if (((t = e._debugInfo), t != null)) {
                                for (var n = t.length - 1; 0 <= n; n--)
                                    if (typeof t[n].name == 'string') return t[n].name;
                            }
                            if (e.return !== null) return K(e.return);
                    }
                    return null;
                }
                function te(e) {
                    return { current: e };
                }
                function X(e, t) {
                    0 > Ma
                        ? console.error('Unexpected pop.')
                        : (t !== _f[Ma] && console.error('Unexpected Fiber popped.'),
                            (e.current = Gf[Ma]),
                            (Gf[Ma] = null),
                            (_f[Ma] = null),
                            Ma--);
                }
                function oe(e, t, n) {
                    (Ma++, (Gf[Ma] = e.current), (_f[Ma] = n), (e.current = t));
                }
                function ge(e) {
                    return (
                        e === null &&
                        console.error(
                            'Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.'
                        ),
                        e
                    );
                }
                function Ee(e, t) {
                    (oe(ci, t, e), oe(ps, e, e), oe(ri, null, e));
                    var n = t.nodeType;
                    switch (n) {
                        case 9:
                        case 11:
                            ((n = n === 9 ? '#document' : '#fragment'),
                                (t =
                                    (t = t.documentElement) && (t = t.namespaceURI)
                                        ? Wb(t)
                                        : _a));
                            break;
                        default:
                            if (((n = t.tagName), (t = t.namespaceURI)))
                                ((t = Wb(t)), (t = Xb(t, n)));
                            else
                                switch (n) {
                                    case 'svg':
                                        t = So;
                                        break;
                                    case 'math':
                                        t = eu;
                                        break;
                                    default:
                                        t = _a;
                                }
                    }
                    ((n = n.toLowerCase()),
                        (n = nh(null, n)),
                        (n = { context: t, ancestorInfo: n }),
                        X(ri, e),
                        oe(ri, n, e));
                }
                function _e(e) {
                    (X(ri, e), X(ps, e), X(ci, e));
                }
                function J() {
                    return ge(ri.current);
                }
                function ce(e) {
                    e.memoizedState !== null && oe(hc, e, e);
                    var t = ge(ri.current),
                        n = e.type,
                        a = Xb(t.context, n);
                    ((n = nh(t.ancestorInfo, n)),
                        (a = { context: a, ancestorInfo: n }),
                        t !== a && (oe(ps, e, e), oe(ri, a, e)));
                }
                function Q(e) {
                    (ps.current === e && (X(ri, e), X(ps, e)),
                        hc.current === e && (X(hc, e), (Fs._currentValue = ml)));
                }
                function me(e) {
                    return (
                        (typeof Symbol == 'function' &&
                            Symbol.toStringTag &&
                            e[Symbol.toStringTag]) ||
                        e.constructor.name ||
                        'Object'
                    );
                }
                function U(e) {
                    try {
                        return !1;
                    } catch {
                        return !0;
                    }
                }
                function re(e) {
                    return '' + e;
                }
                function ue(e, t) {
                    if (U())
                        return (
                            console.error(
                                'The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.',
                                t,
                                me(e)
                            ),
                            re(e)
                        );
                }
                function Ge(e, t) {
                    if (U())
                        return (
                            console.error(
                                'The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.',
                                t,
                                me(e)
                            ),
                            re(e)
                        );
                }
                function at(e) {
                    if (U())
                        return (
                            console.error(
                                'Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.',
                                me(e)
                            ),
                            re(e)
                        );
                }
                function zt(e) {
                    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u') return !1;
                    var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                    if (t.isDisabled) return !0;
                    if (!t.supportsFiber)
                        return (
                            console.error(
                                'The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools'
                            ),
                            !0
                        );
                    try {
                        ((Ul = t.inject(e)), (Bt = t));
                    } catch (n) {
                        console.error(
                            'React instrumentation encountered an error: %s.',
                            n
                        );
                    }
                    return !!t.checkDCE;
                }
                function Ie(e) {
                    if (
                        (typeof tN == 'function' && nN(e),
                            Bt && typeof Bt.setStrictMode == 'function')
                    )
                        try {
                            Bt.setStrictMode(Ul, e);
                        } catch (t) {
                            sa ||
                                ((sa = !0),
                                    console.error(
                                        'React instrumentation encountered an error: %s',
                                        t
                                    ));
                        }
                }
                function Ri(e) {
                    se = e;
                }
                function ot() {
                    se !== null &&
                        typeof se.markCommitStopped == 'function' &&
                        se.markCommitStopped();
                }
                function Tt(e) {
                    se !== null &&
                        typeof se.markComponentRenderStarted == 'function' &&
                        se.markComponentRenderStarted(e);
                }
                function bn() {
                    se !== null &&
                        typeof se.markComponentRenderStopped == 'function' &&
                        se.markComponentRenderStopped();
                }
                function Mi(e) {
                    se !== null &&
                        typeof se.markRenderStarted == 'function' &&
                        se.markRenderStarted(e);
                }
                function Do() {
                    se !== null &&
                        typeof se.markRenderStopped == 'function' &&
                        se.markRenderStopped();
                }
                function Xa(e, t) {
                    se !== null &&
                        typeof se.markStateUpdateScheduled == 'function' &&
                        se.markStateUpdateScheduled(e, t);
                }
                function ur(e) {
                    return ((e >>>= 0), e === 0 ? 32 : (31 - ((aN(e) / iN) | 0)) | 0);
                }
                function To(e) {
                    if (e & 1) return 'SyncHydrationLane';
                    if (e & 2) return 'Sync';
                    if (e & 4) return 'InputContinuousHydration';
                    if (e & 8) return 'InputContinuous';
                    if (e & 16) return 'DefaultHydration';
                    if (e & 32) return 'Default';
                    if (e & 128) return 'TransitionHydration';
                    if (e & 4194048) return 'Transition';
                    if (e & 62914560) return 'Retry';
                    if (e & 67108864) return 'SelectiveHydration';
                    if (e & 134217728) return 'IdleHydration';
                    if (e & 268435456) return 'Idle';
                    if (e & 536870912) return 'Offscreen';
                    if (e & 1073741824) return 'Deferred';
                }
                function ht(e) {
                    var t = e & 42;
                    if (t !== 0) return t;
                    switch (e & -e) {
                        case 1:
                            return 1;
                        case 2:
                            return 2;
                        case 4:
                            return 4;
                        case 8:
                            return 8;
                        case 16:
                            return 16;
                        case 32:
                            return 32;
                        case 64:
                            return 64;
                        case 128:
                            return 128;
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                            return e & 4194048;
                        case 4194304:
                        case 8388608:
                        case 16777216:
                        case 33554432:
                            return e & 62914560;
                        case 67108864:
                            return 67108864;
                        case 134217728:
                            return 134217728;
                        case 268435456:
                            return 268435456;
                        case 536870912:
                            return 536870912;
                        case 1073741824:
                            return 0;
                        default:
                            return (
                                console.error(
                                    'Should have found matching lanes. This is a bug in React.'
                                ),
                                e
                            );
                    }
                }
                function va(e, t, n) {
                    var a = e.pendingLanes;
                    if (a === 0) return 0;
                    var o = 0,
                        c = e.suspendedLanes,
                        f = e.pingedLanes;
                    e = e.warmLanes;
                    var g = a & 134217727;
                    return (
                        g !== 0
                            ? ((a = g & ~c),
                                a !== 0
                                    ? (o = ht(a))
                                    : ((f &= g),
                                        f !== 0
                                            ? (o = ht(f))
                                            : n || ((n = g & ~e), n !== 0 && (o = ht(n)))))
                            : ((g = a & ~c),
                                g !== 0
                                    ? (o = ht(g))
                                    : f !== 0
                                        ? (o = ht(f))
                                        : n || ((n = a & ~e), n !== 0 && (o = ht(n)))),
                        o === 0
                            ? 0
                            : t !== 0 &&
                                t !== o &&
                                (t & c) === 0 &&
                                ((c = o & -o),
                                    (n = t & -t),
                                    c >= n || (c === 32 && (n & 4194048) !== 0))
                                ? t
                                : o
                    );
                }
                function Qa(e, t) {
                    return (
                        (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) ===
                        0
                    );
                }
                function Mu(e, t) {
                    switch (e) {
                        case 1:
                        case 2:
                        case 4:
                        case 8:
                        case 64:
                            return t + 250;
                        case 16:
                        case 32:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                            return t + 5e3;
                        case 4194304:
                        case 8388608:
                        case 16777216:
                        case 33554432:
                            return -1;
                        case 67108864:
                        case 134217728:
                        case 268435456:
                        case 536870912:
                        case 1073741824:
                            return -1;
                        default:
                            return (
                                console.error(
                                    'Should have found matching lanes. This is a bug in React.'
                                ),
                                -1
                            );
                    }
                }
                function Oe() {
                    var e = gc;
                    return ((gc <<= 1), (gc & 4194048) === 0 && (gc = 256), e);
                }
                function Oi() {
                    var e = bc;
                    return ((bc <<= 1), (bc & 62914560) === 0 && (bc = 4194304), e);
                }
                function yl(e) {
                    for (var t = [], n = 0; 31 > n; n++) t.push(e);
                    return t;
                }
                function Ja(e, t) {
                    ((e.pendingLanes |= t),
                        t !== 268435456 &&
                        ((e.suspendedLanes = 0),
                            (e.pingedLanes = 0),
                            (e.warmLanes = 0)));
                }
                function dr(e, t, n, a, o, c) {
                    var f = e.pendingLanes;
                    ((e.pendingLanes = n),
                        (e.suspendedLanes = 0),
                        (e.pingedLanes = 0),
                        (e.warmLanes = 0),
                        (e.expiredLanes &= n),
                        (e.entangledLanes &= n),
                        (e.errorRecoveryDisabledLanes &= n),
                        (e.shellSuspendCounter = 0));
                    var g = e.entanglements,
                        w = e.expirationTimes,
                        A = e.hiddenUpdates;
                    for (n = f & ~n; 0 < n;) {
                        var V = 31 - Gt(n),
                            L = 1 << V;
                        ((g[V] = 0), (w[V] = -1));
                        var j = A[V];
                        if (j !== null)
                            for (A[V] = null, V = 0; V < j.length; V++) {
                                var H = j[V];
                                H !== null && (H.lane &= -536870913);
                            }
                        n &= ~L;
                    }
                    (a !== 0 && Co(e, a, 0),
                        c !== 0 &&
                        o === 0 &&
                        e.tag !== 0 &&
                        (e.suspendedLanes |= c & ~(f & ~t)));
                }
                function Co(e, t, n) {
                    ((e.pendingLanes |= t), (e.suspendedLanes &= ~t));
                    var a = 31 - Gt(t);
                    ((e.entangledLanes |= t),
                        (e.entanglements[a] =
                            e.entanglements[a] | 1073741824 | (n & 4194090)));
                }
                function fr(e, t) {
                    var n = (e.entangledLanes |= t);
                    for (e = e.entanglements; n;) {
                        var a = 31 - Gt(n),
                            o = 1 << a;
                        ((o & t) | (e[a] & t) && (e[a] |= t), (n &= ~o));
                    }
                }
                function Ro(e) {
                    switch (e) {
                        case 2:
                            e = 1;
                            break;
                        case 8:
                            e = 4;
                            break;
                        case 32:
                            e = 16;
                            break;
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                        case 4194304:
                        case 8388608:
                        case 16777216:
                        case 33554432:
                            e = 128;
                            break;
                        case 268435456:
                            e = 134217728;
                            break;
                        default:
                            e = 0;
                    }
                    return e;
                }
                function Mo(e, t, n) {
                    if (_n)
                        for (e = e.pendingUpdatersLaneMap; 0 < n;) {
                            var a = 31 - Gt(n),
                                o = 1 << a;
                            (e[a].add(t), (n &= ~o));
                        }
                }
                function Oo(e, t) {
                    if (_n)
                        for (
                            var n = e.pendingUpdatersLaneMap, a = e.memoizedUpdaters;
                            0 < t;
                        ) {
                            var o = 31 - Gt(t);
                            ((e = 1 << o),
                                (o = n[o]),
                                0 < o.size &&
                                (o.forEach(function (c) {
                                    var f = c.alternate;
                                    (f !== null && a.has(f)) || a.add(c);
                                }),
                                    o.clear()),
                                (t &= ~e));
                        }
                }
                function vl(e) {
                    return (
                        (e &= -e),
                        wn < e ? (ra < e ? ((e & 134217727) !== 0 ? ka : yc) : ra) : wn
                    );
                }
                function ko() {
                    var e = Ye.p;
                    return e !== 0
                        ? e
                        : ((e = window.event), e === void 0 ? ka : fy(e.type));
                }
                function Sl(e, t) {
                    var n = Ye.p;
                    try {
                        return ((Ye.p = e), t());
                    } finally {
                        Ye.p = n;
                    }
                }
                function qa(e) {
                    (delete e[Lt],
                        delete e[en],
                        delete e[Xf],
                        delete e[lN],
                        delete e[oN]);
                }
                function In(e) {
                    var t = e[Lt];
                    if (t) return t;
                    for (var n = e.parentNode; n;) {
                        if ((t = n[di] || n[Lt])) {
                            if (
                                ((n = t.alternate),
                                    t.child !== null || (n !== null && n.child !== null))
                            )
                                for (e = Kb(e); e !== null;) {
                                    if ((n = e[Lt])) return n;
                                    e = Kb(e);
                                }
                            return t;
                        }
                        ((e = n), (n = e.parentNode));
                    }
                    return null;
                }
                function Hn(e) {
                    if ((e = e[Lt] || e[di])) {
                        var t = e.tag;
                        if (
                            t === 5 ||
                            t === 6 ||
                            t === 13 ||
                            t === 26 ||
                            t === 27 ||
                            t === 3
                        )
                            return e;
                    }
                    return null;
                }
                function $a(e) {
                    var t = e.tag;
                    if (t === 5 || t === 26 || t === 27 || t === 6)
                        return e.stateNode;
                    throw Error('getNodeFromInstance: Invalid argument.');
                }
                function x(e) {
                    var t = e[vy];
                    return (
                        t ||
                        (t = e[vy] =
                        {
                            hoistableStyles: new Map(),
                            hoistableScripts: new Map(),
                        }),
                        t
                    );
                }
                function M(e) {
                    e[hs] = !0;
                }
                function ee(e, t) {
                    (ie(e, t), ie(e + 'Capture', t));
                }
                function ie(e, t) {
                    (Qi[e] &&
                        console.error(
                            'EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.',
                            e
                        ),
                        (Qi[e] = t));
                    var n = e.toLowerCase();
                    for (
                        Qf[n] = e, e === 'onDoubleClick' && (Qf.ondblclick = e), e = 0;
                        e < t.length;
                        e++
                    )
                        Sy.add(t[e]);
                }
                function pe(e, t) {
                    (sN[t.type] ||
                        t.onChange ||
                        t.onInput ||
                        t.readOnly ||
                        t.disabled ||
                        t.value == null ||
                        console.error(
                            e === 'select'
                                ? 'You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`.'
                                : 'You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.'
                        ),
                        t.onChange ||
                        t.readOnly ||
                        t.disabled ||
                        t.checked == null ||
                        console.error(
                            'You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.'
                        ));
                }
                function Re(e) {
                    return Oa.call(Ny, e)
                        ? !0
                        : Oa.call(xy, e)
                            ? !1
                            : rN.test(e)
                                ? (Ny[e] = !0)
                                : ((xy[e] = !0),
                                    console.error('Invalid attribute name: `%s`', e),
                                    !1);
                }
                function De(e, t, n) {
                    if (Re(t)) {
                        if (!e.hasAttribute(t)) {
                            switch (typeof n) {
                                case 'symbol':
                                case 'object':
                                    return n;
                                case 'function':
                                    return n;
                                case 'boolean':
                                    if (n === !1) return n;
                            }
                            return n === void 0 ? void 0 : null;
                        }
                        return (
                            (e = e.getAttribute(t)),
                            e === '' && n === !0 ? !0 : (ue(n, t), e === '' + n ? n : e)
                        );
                    }
                }
                function He(e, t, n) {
                    if (Re(t))
                        if (n === null) e.removeAttribute(t);
                        else {
                            switch (typeof n) {
                                case 'undefined':
                                case 'function':
                                case 'symbol':
                                    e.removeAttribute(t);
                                    return;
                                case 'boolean':
                                    var a = t.toLowerCase().slice(0, 5);
                                    if (a !== 'data-' && a !== 'aria-') {
                                        e.removeAttribute(t);
                                        return;
                                    }
                            }
                            (ue(n, t), e.setAttribute(t, '' + n));
                        }
                }
                function Te(e, t, n) {
                    if (n === null) e.removeAttribute(t);
                    else {
                        switch (typeof n) {
                            case 'undefined':
                            case 'function':
                            case 'symbol':
                            case 'boolean':
                                e.removeAttribute(t);
                                return;
                        }
                        (ue(n, t), e.setAttribute(t, '' + n));
                    }
                }
                function wt(e, t, n, a) {
                    if (a === null) e.removeAttribute(n);
                    else {
                        switch (typeof a) {
                            case 'undefined':
                            case 'function':
                            case 'symbol':
                            case 'boolean':
                                e.removeAttribute(n);
                                return;
                        }
                        (ue(a, n), e.setAttributeNS(t, n, '' + a));
                    }
                }
                function Sa() { }
                function Ou() {
                    if (gs === 0) {
                        ((wy = console.log),
                            (Ey = console.info),
                            (Ay = console.warn),
                            (Dy = console.error),
                            (Ty = console.group),
                            (Cy = console.groupCollapsed),
                            (Ry = console.groupEnd));
                        var e = {
                            configurable: !0,
                            enumerable: !0,
                            value: Sa,
                            writable: !0,
                        };
                        Object.defineProperties(console, {
                            info: e,
                            log: e,
                            warn: e,
                            error: e,
                            group: e,
                            groupCollapsed: e,
                            groupEnd: e,
                        });
                    }
                    gs++;
                }
                function ku() {
                    if ((gs--, gs === 0)) {
                        var e = { configurable: !0, enumerable: !0, writable: !0 };
                        Object.defineProperties(console, {
                            log: Me({}, e, { value: wy }),
                            info: Me({}, e, { value: Ey }),
                            warn: Me({}, e, { value: Ay }),
                            error: Me({}, e, { value: Dy }),
                            group: Me({}, e, { value: Ty }),
                            groupCollapsed: Me({}, e, { value: Cy }),
                            groupEnd: Me({}, e, { value: Ry }),
                        });
                    }
                    0 > gs &&
                        console.error(
                            'disabledDepth fell below zero. This is a bug in React. Please file an issue.'
                        );
                }
                function yn(e) {
                    if (Jf === void 0)
                        try {
                            throw Error();
                        } catch (n) {
                            var t = n.stack.trim().match(/\n( *(at )?)/);
                            ((Jf = (t && t[1]) || ''),
                                (My =
                                    -1 <
                                        n.stack.indexOf(`
    at`)
                                        ? ' (<anonymous>)'
                                        : -1 < n.stack.indexOf('@')
                                            ? '@unknown:0:0'
                                            : ''));
                        }
                    return (
                        `
` +
                        Jf +
                        e +
                        My
                    );
                }
                function ju(e, t) {
                    if (!e || qf) return '';
                    var n = $f.get(e);
                    if (n !== void 0) return n;
                    ((qf = !0),
                        (n = Error.prepareStackTrace),
                        (Error.prepareStackTrace = void 0));
                    var a = null;
                    ((a = B.H), (B.H = null), Ou());
                    try {
                        var o = {
                            DetermineComponentFrameRoot: function () {
                                try {
                                    if (t) {
                                        var j = function () {
                                            throw Error();
                                        };
                                        if (
                                            (Object.defineProperty(j.prototype, 'props', {
                                                set: function () {
                                                    throw Error();
                                                },
                                            }),
                                                typeof Reflect == 'object' && Reflect.construct)
                                        ) {
                                            try {
                                                Reflect.construct(j, []);
                                            } catch (fe) {
                                                var H = fe;
                                            }
                                            Reflect.construct(e, [], j);
                                        } else {
                                            try {
                                                j.call();
                                            } catch (fe) {
                                                H = fe;
                                            }
                                            e.call(j.prototype);
                                        }
                                    } else {
                                        try {
                                            throw Error();
                                        } catch (fe) {
                                            H = fe;
                                        }
                                        (j = e()) &&
                                            typeof j.catch == 'function' &&
                                            j.catch(function () { });
                                    }
                                } catch (fe) {
                                    if (fe && H && typeof fe.stack == 'string')
                                        return [fe.stack, H.stack];
                                }
                                return [null, null];
                            },
                        };
                        o.DetermineComponentFrameRoot.displayName =
                            'DetermineComponentFrameRoot';
                        var c = Object.getOwnPropertyDescriptor(
                            o.DetermineComponentFrameRoot,
                            'name'
                        );
                        c &&
                            c.configurable &&
                            Object.defineProperty(o.DetermineComponentFrameRoot, 'name', {
                                value: 'DetermineComponentFrameRoot',
                            });
                        var f = o.DetermineComponentFrameRoot(),
                            g = f[0],
                            w = f[1];
                        if (g && w) {
                            var A = g.split(`
`),
                                V = w.split(`
`);
                            for (
                                f = c = 0;
                                c < A.length &&
                                !A[c].includes('DetermineComponentFrameRoot');
                            )
                                c++;
                            for (
                                ;
                                f < V.length &&
                                !V[f].includes('DetermineComponentFrameRoot');
                            )
                                f++;
                            if (c === A.length || f === V.length)
                                for (
                                    c = A.length - 1, f = V.length - 1;
                                    1 <= c && 0 <= f && A[c] !== V[f];
                                )
                                    f--;
                            for (; 1 <= c && 0 <= f; c--, f--)
                                if (A[c] !== V[f]) {
                                    if (c !== 1 || f !== 1)
                                        do
                                            if ((c--, f--, 0 > f || A[c] !== V[f])) {
                                                var L =
                                                    `
` + A[c].replace(' at new ', ' at ');
                                                return (
                                                    e.displayName &&
                                                    L.includes('<anonymous>') &&
                                                    (L = L.replace('<anonymous>', e.displayName)),
                                                    typeof e == 'function' && $f.set(e, L),
                                                    L
                                                );
                                            }
                                        while (1 <= c && 0 <= f);
                                    break;
                                }
                        }
                    } finally {
                        ((qf = !1), (B.H = a), ku(), (Error.prepareStackTrace = n));
                    }
                    return (
                        (A = (A = e ? e.displayName || e.name : '') ? yn(A) : ''),
                        typeof e == 'function' && $f.set(e, A),
                        A
                    );
                }
                function Hp(e) {
                    var t = Error.prepareStackTrace;
                    if (
                        ((Error.prepareStackTrace = void 0),
                            (e = e.stack),
                            (Error.prepareStackTrace = t),
                            e.startsWith(`Error: react-stack-top-frame
`) && (e = e.slice(29)),
                            (t = e.indexOf(`
`)),
                            t !== -1 && (e = e.slice(t + 1)),
                            (t = e.indexOf('react_stack_bottom_frame')),
                            t !== -1 &&
                            (t = e.lastIndexOf(
                                `
`,
                                t
                            )),
                            t !== -1)
                    )
                        e = e.slice(0, t);
                    else return '';
                    return e;
                }
                function dS(e) {
                    switch (e.tag) {
                        case 26:
                        case 27:
                        case 5:
                            return yn(e.type);
                        case 16:
                            return yn('Lazy');
                        case 13:
                            return yn('Suspense');
                        case 19:
                            return yn('SuspenseList');
                        case 0:
                        case 15:
                            return ju(e.type, !1);
                        case 11:
                            return ju(e.type.render, !1);
                        case 1:
                            return ju(e.type, !0);
                        case 31:
                            return yn('Activity');
                        default:
                            return '';
                    }
                }
                function Up(e) {
                    try {
                        var t = '';
                        do {
                            t += dS(e);
                            var n = e._debugInfo;
                            if (n)
                                for (var a = n.length - 1; 0 <= a; a--) {
                                    var o = n[a];
                                    if (typeof o.name == 'string') {
                                        var c = t,
                                            f = o.env,
                                            g = yn(o.name + (f ? ' [' + f + ']' : ''));
                                        t = c + g;
                                    }
                                }
                            e = e.return;
                        } while (e);
                        return t;
                    } catch (w) {
                        return (
                            `
Error generating stack: ` +
                            w.message +
                            `
` +
                            w.stack
                        );
                    }
                }
                function Gp(e) {
                    return (e = e ? e.displayName || e.name : '') ? yn(e) : '';
                }
                function mr() {
                    if (fn === null) return null;
                    var e = fn._debugOwner;
                    return e != null ? W(e) : null;
                }
                function fS() {
                    if (fn === null) return '';
                    var e = fn;
                    try {
                        var t = '';
                        switch ((e.tag === 6 && (e = e.return), e.tag)) {
                            case 26:
                            case 27:
                            case 5:
                                t += yn(e.type);
                                break;
                            case 13:
                                t += yn('Suspense');
                                break;
                            case 19:
                                t += yn('SuspenseList');
                                break;
                            case 31:
                                t += yn('Activity');
                                break;
                            case 30:
                            case 0:
                            case 15:
                            case 1:
                                e._debugOwner || t !== '' || (t += Gp(e.type));
                                break;
                            case 11:
                                e._debugOwner || t !== '' || (t += Gp(e.type.render));
                        }
                        for (; e;)
                            if (typeof e.tag == 'number') {
                                var n = e;
                                e = n._debugOwner;
                                var a = n._debugStack;
                                e &&
                                    a &&
                                    (typeof a != 'string' && (n._debugStack = a = Hp(a)),
                                        a !== '' &&
                                        (t +=
                                            `
` + a));
                            } else if (e.debugStack != null) {
                                var o = e.debugStack;
                                (e = e.owner) &&
                                    o &&
                                    (t +=
                                        `
` + Hp(o));
                            } else break;
                        var c = t;
                    } catch (f) {
                        c =
                            `
Error generating stack: ` +
                            f.message +
                            `
` +
                            f.stack;
                    }
                    return c;
                }
                function he(e, t, n, a, o, c, f) {
                    var g = fn;
                    Vu(e);
                    try {
                        return e !== null && e._debugTask
                            ? e._debugTask.run(t.bind(null, n, a, o, c, f))
                            : t(n, a, o, c, f);
                    } finally {
                        Vu(g);
                    }
                    throw Error(
                        'runWithFiberInDEV should never be called in production. This is a bug in React.'
                    );
                }
                function Vu(e) {
                    ((B.getCurrentStack = e === null ? null : fS),
                        (ca = !1),
                        (fn = e));
                }
                function vn(e) {
                    switch (typeof e) {
                        case 'bigint':
                        case 'boolean':
                        case 'number':
                        case 'string':
                        case 'undefined':
                            return e;
                        case 'object':
                            return (at(e), e);
                        default:
                            return '';
                    }
                }
                function _p(e) {
                    var t = e.type;
                    return (
                        (e = e.nodeName) &&
                        e.toLowerCase() === 'input' &&
                        (t === 'checkbox' || t === 'radio')
                    );
                }
                function mS(e) {
                    var t = _p(e) ? 'checked' : 'value',
                        n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
                    at(e[t]);
                    var a = '' + e[t];
                    if (
                        !e.hasOwnProperty(t) &&
                        typeof n < 'u' &&
                        typeof n.get == 'function' &&
                        typeof n.set == 'function'
                    ) {
                        var o = n.get,
                            c = n.set;
                        return (
                            Object.defineProperty(e, t, {
                                configurable: !0,
                                get: function () {
                                    return o.call(this);
                                },
                                set: function (f) {
                                    (at(f), (a = '' + f), c.call(this, f));
                                },
                            }),
                            Object.defineProperty(e, t, { enumerable: n.enumerable }),
                            {
                                getValue: function () {
                                    return a;
                                },
                                setValue: function (f) {
                                    (at(f), (a = '' + f));
                                },
                                stopTracking: function () {
                                    ((e._valueTracker = null), delete e[t]);
                                },
                            }
                        );
                    }
                }
                function pr(e) {
                    e._valueTracker || (e._valueTracker = mS(e));
                }
                function Yp(e) {
                    if (!e) return !1;
                    var t = e._valueTracker;
                    if (!t) return !0;
                    var n = t.getValue(),
                        a = '';
                    return (
                        e && (a = _p(e) ? (e.checked ? 'true' : 'false') : e.value),
                        (e = a),
                        e !== n ? (t.setValue(e), !0) : !1
                    );
                }
                function hr(e) {
                    if (
                        ((e = e || (typeof document < 'u' ? document : void 0)),
                            typeof e > 'u')
                    )
                        return null;
                    try {
                        return e.activeElement || e.body;
                    } catch {
                        return e.body;
                    }
                }
                function Sn(e) {
                    return e.replace(cN, function (t) {
                        return '\\' + t.charCodeAt(0).toString(16) + ' ';
                    });
                }
                function Pp(e, t) {
                    (t.checked === void 0 ||
                        t.defaultChecked === void 0 ||
                        ky ||
                        (console.error(
                            '%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components',
                            mr() || 'A component',
                            t.type
                        ),
                            (ky = !0)),
                        t.value === void 0 ||
                        t.defaultValue === void 0 ||
                        Oy ||
                        (console.error(
                            '%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components',
                            mr() || 'A component',
                            t.type
                        ),
                            (Oy = !0)));
                }
                function zu(e, t, n, a, o, c, f, g) {
                    ((e.name = ''),
                        f != null &&
                            typeof f != 'function' &&
                            typeof f != 'symbol' &&
                            typeof f != 'boolean'
                            ? (ue(f, 'type'), (e.type = f))
                            : e.removeAttribute('type'),
                        t != null
                            ? f === 'number'
                                ? ((t === 0 && e.value === '') || e.value != t) &&
                                (e.value = '' + vn(t))
                                : e.value !== '' + vn(t) && (e.value = '' + vn(t))
                            : (f !== 'submit' && f !== 'reset') ||
                            e.removeAttribute('value'),
                        t != null
                            ? Bu(e, f, vn(t))
                            : n != null
                                ? Bu(e, f, vn(n))
                                : a != null && e.removeAttribute('value'),
                        o == null && c != null && (e.defaultChecked = !!c),
                        o != null &&
                        (e.checked =
                            o && typeof o != 'function' && typeof o != 'symbol'),
                        g != null &&
                            typeof g != 'function' &&
                            typeof g != 'symbol' &&
                            typeof g != 'boolean'
                            ? (ue(g, 'name'), (e.name = '' + vn(g)))
                            : e.removeAttribute('name'));
                }
                function Zp(e, t, n, a, o, c, f, g) {
                    if (
                        (c != null &&
                            typeof c != 'function' &&
                            typeof c != 'symbol' &&
                            typeof c != 'boolean' &&
                            (ue(c, 'type'), (e.type = c)),
                            t != null || n != null)
                    ) {
                        if (!((c !== 'submit' && c !== 'reset') || t != null)) return;
                        ((n = n != null ? '' + vn(n) : ''),
                            (t = t != null ? '' + vn(t) : n),
                            g || t === e.value || (e.value = t),
                            (e.defaultValue = t));
                    }
                    ((a = a ?? o),
                        (a = typeof a != 'function' && typeof a != 'symbol' && !!a),
                        (e.checked = g ? e.checked : !!a),
                        (e.defaultChecked = !!a),
                        f != null &&
                        typeof f != 'function' &&
                        typeof f != 'symbol' &&
                        typeof f != 'boolean' &&
                        (ue(f, 'name'), (e.name = f)));
                }
                function Bu(e, t, n) {
                    (t === 'number' && hr(e.ownerDocument) === e) ||
                        e.defaultValue === '' + n ||
                        (e.defaultValue = '' + n);
                }
                function Wp(e, t) {
                    (t.value == null &&
                        (typeof t.children == 'object' && t.children !== null
                            ? zf.Children.forEach(t.children, function (n) {
                                n == null ||
                                    typeof n == 'string' ||
                                    typeof n == 'number' ||
                                    typeof n == 'bigint' ||
                                    Vy ||
                                    ((Vy = !0),
                                        console.error(
                                            'Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.'
                                        ));
                            })
                            : t.dangerouslySetInnerHTML == null ||
                            zy ||
                            ((zy = !0),
                                console.error(
                                    'Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.'
                                ))),
                        t.selected == null ||
                        jy ||
                        (console.error(
                            'Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.'
                        ),
                            (jy = !0)));
                }
                function Xp() {
                    var e = mr();
                    return e
                        ? `

Check the render method of \`` +
                        e +
                        '`.'
                        : '';
                }
                function xl(e, t, n, a) {
                    if (((e = e.options), t)) {
                        t = {};
                        for (var o = 0; o < n.length; o++) t['$' + n[o]] = !0;
                        for (n = 0; n < e.length; n++)
                            ((o = t.hasOwnProperty('$' + e[n].value)),
                                e[n].selected !== o && (e[n].selected = o),
                                o && a && (e[n].defaultSelected = !0));
                    } else {
                        for (n = '' + vn(n), t = null, o = 0; o < e.length; o++) {
                            if (e[o].value === n) {
                                ((e[o].selected = !0), a && (e[o].defaultSelected = !0));
                                return;
                            }
                            t !== null || e[o].disabled || (t = e[o]);
                        }
                        t !== null && (t.selected = !0);
                    }
                }
                function Qp(e, t) {
                    for (e = 0; e < Ly.length; e++) {
                        var n = Ly[e];
                        if (t[n] != null) {
                            var a = Ot(t[n]);
                            t.multiple && !a
                                ? console.error(
                                    'The `%s` prop supplied to <select> must be an array if `multiple` is true.%s',
                                    n,
                                    Xp()
                                )
                                : !t.multiple &&
                                a &&
                                console.error(
                                    'The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s',
                                    n,
                                    Xp()
                                );
                        }
                    }
                    t.value === void 0 ||
                        t.defaultValue === void 0 ||
                        By ||
                        (console.error(
                            'Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components'
                        ),
                            (By = !0));
                }
                function Jp(e, t) {
                    (t.value === void 0 ||
                        t.defaultValue === void 0 ||
                        Iy ||
                        (console.error(
                            '%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components',
                            mr() || 'A component'
                        ),
                            (Iy = !0)),
                        t.children != null &&
                        t.value == null &&
                        console.error(
                            'Use the `defaultValue` or `value` props instead of setting children on <textarea>.'
                        ));
                }
                function qp(e, t, n) {
                    if (
                        t != null &&
                        ((t = '' + vn(t)), t !== e.value && (e.value = t), n == null)
                    ) {
                        e.defaultValue !== t && (e.defaultValue = t);
                        return;
                    }
                    e.defaultValue = n != null ? '' + vn(n) : '';
                }
                function $p(e, t, n, a) {
                    if (t == null) {
                        if (a != null) {
                            if (n != null)
                                throw Error(
                                    'If you supply `defaultValue` on a <textarea>, do not pass children.'
                                );
                            if (Ot(a)) {
                                if (1 < a.length)
                                    throw Error(
                                        '<textarea> can only have at most one child.'
                                    );
                                a = a[0];
                            }
                            n = a;
                        }
                        (n == null && (n = ''), (t = n));
                    }
                    ((n = vn(t)),
                        (e.defaultValue = n),
                        (a = e.textContent),
                        a === n && a !== '' && a !== null && (e.value = a));
                }
                function Fp(e, t) {
                    return e.serverProps === void 0 &&
                        e.serverTail.length === 0 &&
                        e.children.length === 1 &&
                        3 < e.distanceFromLeaf &&
                        e.distanceFromLeaf > 15 - t
                        ? Fp(e.children[0], t)
                        : e;
                }
                function on(e) {
                    return '  ' + '  '.repeat(e);
                }
                function Nl(e) {
                    return '+ ' + '  '.repeat(e);
                }
                function ki(e) {
                    return '- ' + '  '.repeat(e);
                }
                function Kp(e) {
                    switch (e.tag) {
                        case 26:
                        case 27:
                        case 5:
                            return e.type;
                        case 16:
                            return 'Lazy';
                        case 13:
                            return 'Suspense';
                        case 19:
                            return 'SuspenseList';
                        case 0:
                        case 15:
                            return ((e = e.type), e.displayName || e.name || null);
                        case 11:
                            return ((e = e.type.render), e.displayName || e.name || null);
                        case 1:
                            return ((e = e.type), e.displayName || e.name || null);
                        default:
                            return null;
                    }
                }
                function jo(e, t) {
                    return Hy.test(e)
                        ? ((e = JSON.stringify(e)),
                            e.length > t - 2
                                ? 8 > t
                                    ? '{"..."}'
                                    : '{' + e.slice(0, t - 7) + '..."}'
                                : '{' + e + '}')
                        : e.length > t
                            ? 5 > t
                                ? '{"..."}'
                                : e.slice(0, t - 3) + '...'
                            : e;
                }
                function gr(e, t, n) {
                    var a = 120 - 2 * n;
                    if (t === null)
                        return (
                            Nl(n) +
                            jo(e, a) +
                            `
`
                        );
                    if (typeof t == 'string') {
                        for (
                            var o = 0;
                            o < t.length &&
                            o < e.length &&
                            t.charCodeAt(o) === e.charCodeAt(o);
                            o++
                        );
                        return (
                            o > a - 8 &&
                            10 < o &&
                            ((e = '...' + e.slice(o - 8)),
                                (t = '...' + t.slice(o - 8))),
                            Nl(n) +
                            jo(e, a) +
                            `
` +
                            ki(n) +
                            jo(t, a) +
                            `
`
                        );
                    }
                    return (
                        on(n) +
                        jo(e, a) +
                        `
`
                    );
                }
                function Lu(e) {
                    return Object.prototype.toString
                        .call(e)
                        .replace(/^\[object (.*)\]$/, function (t, n) {
                            return n;
                        });
                }
                function Vo(e, t) {
                    switch (typeof e) {
                        case 'string':
                            return (
                                (e = JSON.stringify(e)),
                                e.length > t
                                    ? 5 > t
                                        ? '"..."'
                                        : e.slice(0, t - 4) + '..."'
                                    : e
                            );
                        case 'object':
                            if (e === null) return 'null';
                            if (Ot(e)) return '[...]';
                            if (e.$$typeof === si)
                                return (t = q(e.type)) ? '<' + t + '>' : '<...>';
                            var n = Lu(e);
                            if (n === 'Object') {
                                ((n = ''), (t -= 2));
                                for (var a in e)
                                    if (e.hasOwnProperty(a)) {
                                        var o = JSON.stringify(a);
                                        if (
                                            (o !== '"' + a + '"' && (a = o),
                                                (t -= a.length - 2),
                                                (o = Vo(e[a], 15 > t ? t : 15)),
                                                (t -= o.length),
                                                0 > t)
                                        ) {
                                            n += n === '' ? '...' : ', ...';
                                            break;
                                        }
                                        n += (n === '' ? '' : ',') + a + ':' + o;
                                    }
                                return '{' + n + '}';
                            }
                            return n;
                        case 'function':
                            return (t = e.displayName || e.name)
                                ? 'function ' + t
                                : 'function';
                        default:
                            return String(e);
                    }
                }
                function wl(e, t) {
                    return typeof e != 'string' || Hy.test(e)
                        ? '{' + Vo(e, t - 2) + '}'
                        : e.length > t - 2
                            ? 5 > t
                                ? '"..."'
                                : '"' + e.slice(0, t - 5) + '..."'
                            : '"' + e + '"';
                }
                function Iu(e, t, n) {
                    var a = 120 - n.length - e.length,
                        o = [],
                        c;
                    for (c in t)
                        if (t.hasOwnProperty(c) && c !== 'children') {
                            var f = wl(t[c], 120 - n.length - c.length - 1);
                            ((a -= c.length + f.length + 2), o.push(c + '=' + f));
                        }
                    return o.length === 0
                        ? n +
                        '<' +
                        e +
                        `>
`
                        : 0 < a
                            ? n +
                            '<' +
                            e +
                            ' ' +
                            o.join(' ') +
                            `>
`
                            : n +
                            '<' +
                            e +
                            `
` +
                            n +
                            '  ' +
                            o.join(
                                `
` +
                                n +
                                '  '
                            ) +
                            `
` +
                            n +
                            `>
`;
                }
                function pS(e, t, n) {
                    var a = '',
                        o = Me({}, t),
                        c;
                    for (c in e)
                        if (e.hasOwnProperty(c)) {
                            delete o[c];
                            var f = 120 - 2 * n - c.length - 2,
                                g = Vo(e[c], f);
                            t.hasOwnProperty(c)
                                ? ((f = Vo(t[c], f)),
                                    (a +=
                                        Nl(n) +
                                        c +
                                        ': ' +
                                        g +
                                        `
`),
                                    (a +=
                                        ki(n) +
                                        c +
                                        ': ' +
                                        f +
                                        `
`))
                                : (a +=
                                    Nl(n) +
                                    c +
                                    ': ' +
                                    g +
                                    `
`);
                        }
                    for (var w in o)
                        o.hasOwnProperty(w) &&
                            ((e = Vo(o[w], 120 - 2 * n - w.length - 2)),
                                (a +=
                                    ki(n) +
                                    w +
                                    ': ' +
                                    e +
                                    `
`));
                    return a;
                }
                function hS(e, t, n, a) {
                    var o = '',
                        c = new Map();
                    for (A in n) n.hasOwnProperty(A) && c.set(A.toLowerCase(), A);
                    if (c.size === 1 && c.has('children')) o += Iu(e, t, on(a));
                    else {
                        for (var f in t)
                            if (t.hasOwnProperty(f) && f !== 'children') {
                                var g = 120 - 2 * (a + 1) - f.length - 1,
                                    w = c.get(f.toLowerCase());
                                if (w !== void 0) {
                                    c.delete(f.toLowerCase());
                                    var A = t[f];
                                    w = n[w];
                                    var V = wl(A, g);
                                    ((g = wl(w, g)),
                                        typeof A == 'object' &&
                                            A !== null &&
                                            typeof w == 'object' &&
                                            w !== null &&
                                            Lu(A) === 'Object' &&
                                            Lu(w) === 'Object' &&
                                            (2 < Object.keys(A).length ||
                                                2 < Object.keys(w).length ||
                                                -1 < V.indexOf('...') ||
                                                -1 < g.indexOf('...'))
                                            ? (o +=
                                                on(a + 1) +
                                                f +
                                                `={{
` +
                                                pS(A, w, a + 2) +
                                                on(a + 1) +
                                                `}}
`)
                                            : ((o +=
                                                Nl(a + 1) +
                                                f +
                                                '=' +
                                                V +
                                                `
`),
                                                (o +=
                                                    ki(a + 1) +
                                                    f +
                                                    '=' +
                                                    g +
                                                    `
`)));
                                } else
                                    o +=
                                        on(a + 1) +
                                        f +
                                        '=' +
                                        wl(t[f], g) +
                                        `
`;
                            }
                        (c.forEach(function (L) {
                            if (L !== 'children') {
                                var j = 120 - 2 * (a + 1) - L.length - 1;
                                o +=
                                    ki(a + 1) +
                                    L +
                                    '=' +
                                    wl(n[L], j) +
                                    `
`;
                            }
                        }),
                            (o =
                                o === ''
                                    ? on(a) +
                                    '<' +
                                    e +
                                    `>
`
                                    : on(a) +
                                    '<' +
                                    e +
                                    `
` +
                                    o +
                                    on(a) +
                                    `>
`));
                    }
                    return (
                        (e = n.children),
                        (t = t.children),
                        typeof e == 'string' ||
                            typeof e == 'number' ||
                            typeof e == 'bigint'
                            ? ((c = ''),
                                (typeof t == 'string' ||
                                    typeof t == 'number' ||
                                    typeof t == 'bigint') &&
                                (c = '' + t),
                                (o += gr(c, '' + e, a + 1)))
                            : (typeof t == 'string' ||
                                typeof t == 'number' ||
                                typeof t == 'bigint') &&
                            (o =
                                e == null
                                    ? o + gr('' + t, null, a + 1)
                                    : o + gr('' + t, void 0, a + 1)),
                        o
                    );
                }
                function eh(e, t) {
                    var n = Kp(e);
                    if (n === null) {
                        for (n = '', e = e.child; e;)
                            ((n += eh(e, t)), (e = e.sibling));
                        return n;
                    }
                    return (
                        on(t) +
                        '<' +
                        n +
                        `>
`
                    );
                }
                function Hu(e, t) {
                    var n = Fp(e, t);
                    if (n !== e && (e.children.length !== 1 || e.children[0] !== n))
                        return (
                            on(t) +
                            `...
` +
                            Hu(n, t + 1)
                        );
                    n = '';
                    var a = e.fiber._debugInfo;
                    if (a)
                        for (var o = 0; o < a.length; o++) {
                            var c = a[o].name;
                            typeof c == 'string' &&
                                ((n +=
                                    on(t) +
                                    '<' +
                                    c +
                                    `>
`),
                                    t++);
                        }
                    if (((a = ''), (o = e.fiber.pendingProps), e.fiber.tag === 6))
                        ((a = gr(o, e.serverProps, t)), t++);
                    else if (((c = Kp(e.fiber)), c !== null))
                        if (e.serverProps === void 0) {
                            a = t;
                            var f = 120 - 2 * a - c.length - 2,
                                g = '';
                            for (A in o)
                                if (o.hasOwnProperty(A) && A !== 'children') {
                                    var w = wl(o[A], 15);
                                    if (((f -= A.length + w.length + 2), 0 > f)) {
                                        g += ' ...';
                                        break;
                                    }
                                    g += ' ' + A + '=' + w;
                                }
                            ((a =
                                on(a) +
                                '<' +
                                c +
                                g +
                                `>
`),
                                t++);
                        } else
                            e.serverProps === null
                                ? ((a = Iu(c, o, Nl(t))), t++)
                                : typeof e.serverProps == 'string'
                                    ? console.error(
                                        'Should not have matched a non HostText fiber to a Text node. This is a bug in React.'
                                    )
                                    : ((a = hS(c, o, e.serverProps, t)), t++);
                    var A = '';
                    for (o = e.fiber.child, c = 0; o && c < e.children.length;)
                        ((f = e.children[c]),
                            f.fiber === o ? ((A += Hu(f, t)), c++) : (A += eh(o, t)),
                            (o = o.sibling));
                    for (
                        o &&
                        0 < e.children.length &&
                        (A +=
                            on(t) +
                            `...
`),
                        o = e.serverTail,
                        e.serverProps === null && t--,
                        e = 0;
                        e < o.length;
                        e++
                    )
                        ((c = o[e]),
                            (A =
                                typeof c == 'string'
                                    ? A +
                                    (ki(t) +
                                        jo(c, 120 - 2 * t) +
                                        `
`)
                                    : A + Iu(c.type, c.props, ki(t))));
                    return n + a + A;
                }
                function Uu(e) {
                    try {
                        return (
                            `

` + Hu(e, 0)
                        );
                    } catch {
                        return '';
                    }
                }
                function th(e, t, n) {
                    for (var a = t, o = null, c = 0; a;)
                        (a === e && (c = 0),
                            (o = {
                                fiber: a,
                                children: o !== null ? [o] : [],
                                serverProps: a === t ? n : a === e ? null : void 0,
                                serverTail: [],
                                distanceFromLeaf: c,
                            }),
                            c++,
                            (a = a.return));
                    return o !== null ? Uu(o).replaceAll(/^[+-]/gm, '>') : '';
                }
                function nh(e, t) {
                    var n = Me({}, e || Gy),
                        a = { tag: t };
                    return (
                        Uy.indexOf(t) !== -1 &&
                        ((n.aTagInScope = null),
                            (n.buttonTagInScope = null),
                            (n.nobrTagInScope = null)),
                        dN.indexOf(t) !== -1 && (n.pTagInButtonScope = null),
                        uN.indexOf(t) !== -1 &&
                        t !== 'address' &&
                        t !== 'div' &&
                        t !== 'p' &&
                        ((n.listItemTagAutoclosing = null),
                            (n.dlItemTagAutoclosing = null)),
                        (n.current = a),
                        t === 'form' && (n.formTag = a),
                        t === 'a' && (n.aTagInScope = a),
                        t === 'button' && (n.buttonTagInScope = a),
                        t === 'nobr' && (n.nobrTagInScope = a),
                        t === 'p' && (n.pTagInButtonScope = a),
                        t === 'li' && (n.listItemTagAutoclosing = a),
                        (t === 'dd' || t === 'dt') && (n.dlItemTagAutoclosing = a),
                        t === '#document' || t === 'html'
                            ? (n.containerTagInScope = null)
                            : n.containerTagInScope || (n.containerTagInScope = a),
                        e !== null ||
                            (t !== '#document' && t !== 'html' && t !== 'body')
                            ? n.implicitRootScope === !0 && (n.implicitRootScope = !1)
                            : (n.implicitRootScope = !0),
                        n
                    );
                }
                function ah(e, t, n) {
                    switch (t) {
                        case 'select':
                            return (
                                e === 'hr' ||
                                e === 'option' ||
                                e === 'optgroup' ||
                                e === 'script' ||
                                e === 'template' ||
                                e === '#text'
                            );
                        case 'optgroup':
                            return e === 'option' || e === '#text';
                        case 'option':
                            return e === '#text';
                        case 'tr':
                            return (
                                e === 'th' ||
                                e === 'td' ||
                                e === 'style' ||
                                e === 'script' ||
                                e === 'template'
                            );
                        case 'tbody':
                        case 'thead':
                        case 'tfoot':
                            return (
                                e === 'tr' ||
                                e === 'style' ||
                                e === 'script' ||
                                e === 'template'
                            );
                        case 'colgroup':
                            return e === 'col' || e === 'template';
                        case 'table':
                            return (
                                e === 'caption' ||
                                e === 'colgroup' ||
                                e === 'tbody' ||
                                e === 'tfoot' ||
                                e === 'thead' ||
                                e === 'style' ||
                                e === 'script' ||
                                e === 'template'
                            );
                        case 'head':
                            return (
                                e === 'base' ||
                                e === 'basefont' ||
                                e === 'bgsound' ||
                                e === 'link' ||
                                e === 'meta' ||
                                e === 'title' ||
                                e === 'noscript' ||
                                e === 'noframes' ||
                                e === 'style' ||
                                e === 'script' ||
                                e === 'template'
                            );
                        case 'html':
                            if (n) break;
                            return e === 'head' || e === 'body' || e === 'frameset';
                        case 'frameset':
                            return e === 'frame';
                        case '#document':
                            if (!n) return e === 'html';
                    }
                    switch (e) {
                        case 'h1':
                        case 'h2':
                        case 'h3':
                        case 'h4':
                        case 'h5':
                        case 'h6':
                            return (
                                t !== 'h1' &&
                                t !== 'h2' &&
                                t !== 'h3' &&
                                t !== 'h4' &&
                                t !== 'h5' &&
                                t !== 'h6'
                            );
                        case 'rp':
                        case 'rt':
                            return fN.indexOf(t) === -1;
                        case 'caption':
                        case 'col':
                        case 'colgroup':
                        case 'frameset':
                        case 'frame':
                        case 'tbody':
                        case 'td':
                        case 'tfoot':
                        case 'th':
                        case 'thead':
                        case 'tr':
                            return t == null;
                        case 'head':
                            return n || t === null;
                        case 'html':
                            return (n && t === '#document') || t === null;
                        case 'body':
                            return (
                                (n && (t === '#document' || t === 'html')) || t === null
                            );
                    }
                    return !0;
                }
                function gS(e, t) {
                    switch (e) {
                        case 'address':
                        case 'article':
                        case 'aside':
                        case 'blockquote':
                        case 'center':
                        case 'details':
                        case 'dialog':
                        case 'dir':
                        case 'div':
                        case 'dl':
                        case 'fieldset':
                        case 'figcaption':
                        case 'figure':
                        case 'footer':
                        case 'header':
                        case 'hgroup':
                        case 'main':
                        case 'menu':
                        case 'nav':
                        case 'ol':
                        case 'p':
                        case 'section':
                        case 'summary':
                        case 'ul':
                        case 'pre':
                        case 'listing':
                        case 'table':
                        case 'hr':
                        case 'xmp':
                        case 'h1':
                        case 'h2':
                        case 'h3':
                        case 'h4':
                        case 'h5':
                        case 'h6':
                            return t.pTagInButtonScope;
                        case 'form':
                            return t.formTag || t.pTagInButtonScope;
                        case 'li':
                            return t.listItemTagAutoclosing;
                        case 'dd':
                        case 'dt':
                            return t.dlItemTagAutoclosing;
                        case 'button':
                            return t.buttonTagInScope;
                        case 'a':
                            return t.aTagInScope;
                        case 'nobr':
                            return t.nobrTagInScope;
                    }
                    return null;
                }
                function ih(e, t) {
                    for (; e;) {
                        switch (e.tag) {
                            case 5:
                            case 26:
                            case 27:
                                if (e.type === t) return e;
                        }
                        e = e.return;
                    }
                    return null;
                }
                function Gu(e, t) {
                    t = t || Gy;
                    var n = t.current;
                    if (
                        ((t = (n = ah(e, n && n.tag, t.implicitRootScope) ? null : n)
                            ? null
                            : gS(e, t)),
                            (t = n || t),
                            !t)
                    )
                        return !0;
                    var a = t.tag;
                    if (((t = String(!!n) + '|' + e + '|' + a), vc[t])) return !1;
                    vc[t] = !0;
                    var o = (t = fn) ? ih(t.return, a) : null,
                        c = t !== null && o !== null ? th(o, t, null) : '',
                        f = '<' + e + '>';
                    return (
                        n
                            ? ((n = ''),
                                a === 'table' &&
                                e === 'tr' &&
                                (n +=
                                    ' Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.'),
                                console.error(
                                    `In HTML, %s cannot be a child of <%s>.%s
This will cause a hydration error.%s`,
                                    f,
                                    a,
                                    n,
                                    c
                                ))
                            : console.error(
                                `In HTML, %s cannot be a descendant of <%s>.
This will cause a hydration error.%s`,
                                f,
                                a,
                                c
                            ),
                        t &&
                        ((e = t.return),
                            o === null ||
                            e === null ||
                            (o === e && e._debugOwner === t._debugOwner) ||
                            he(o, function () {
                                console.error(
                                    `<%s> cannot contain a nested %s.
See this log for the ancestor stack trace.`,
                                    a,
                                    f
                                );
                            })),
                        !1
                    );
                }
                function br(e, t, n) {
                    if (n || ah('#text', t, !1)) return !0;
                    if (((n = '#text|' + t), vc[n])) return !1;
                    vc[n] = !0;
                    var a = (n = fn) ? ih(n, t) : null;
                    return (
                        (n =
                            n !== null && a !== null
                                ? th(a, n, n.tag !== 6 ? { children: null } : null)
                                : ''),
                        /\S/.test(e)
                            ? console.error(
                                `In HTML, text nodes cannot be a child of <%s>.
This will cause a hydration error.%s`,
                                t,
                                n
                            )
                            : console.error(
                                `In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.
This will cause a hydration error.%s`,
                                t,
                                n
                            ),
                        !1
                    );
                }
                function zo(e, t) {
                    if (t) {
                        var n = e.firstChild;
                        if (n && n === e.lastChild && n.nodeType === 3) {
                            n.nodeValue = t;
                            return;
                        }
                    }
                    e.textContent = t;
                }
                function bS(e) {
                    return e.replace(hN, function (t, n) {
                        return n.toUpperCase();
                    });
                }
                function lh(e, t, n) {
                    var a = t.indexOf('--') === 0;
                    (a ||
                        (-1 < t.indexOf('-')
                            ? (Gl.hasOwnProperty(t) && Gl[t]) ||
                            ((Gl[t] = !0),
                                console.error(
                                    'Unsupported style property %s. Did you mean %s?',
                                    t,
                                    bS(t.replace(pN, 'ms-'))
                                ))
                            : mN.test(t)
                                ? (Gl.hasOwnProperty(t) && Gl[t]) ||
                                ((Gl[t] = !0),
                                    console.error(
                                        'Unsupported vendor-prefixed style property %s. Did you mean %s?',
                                        t,
                                        t.charAt(0).toUpperCase() + t.slice(1)
                                    ))
                                : !Py.test(n) ||
                                (Kf.hasOwnProperty(n) && Kf[n]) ||
                                ((Kf[n] = !0),
                                    console.error(
                                        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
                                        t,
                                        n.replace(Py, '')
                                    )),
                            typeof n == 'number' &&
                            (isNaN(n)
                                ? Zy ||
                                ((Zy = !0),
                                    console.error(
                                        '`NaN` is an invalid value for the `%s` css style property.',
                                        t
                                    ))
                                : isFinite(n) ||
                                Wy ||
                                ((Wy = !0),
                                    console.error(
                                        '`Infinity` is an invalid value for the `%s` css style property.',
                                        t
                                    )))),
                        n == null || typeof n == 'boolean' || n === ''
                            ? a
                                ? e.setProperty(t, '')
                                : t === 'float'
                                    ? (e.cssFloat = '')
                                    : (e[t] = '')
                            : a
                                ? e.setProperty(t, n)
                                : typeof n != 'number' || n === 0 || Xy.has(t)
                                    ? t === 'float'
                                        ? (e.cssFloat = n)
                                        : (Ge(n, t), (e[t] = ('' + n).trim()))
                                    : (e[t] = n + 'px'));
                }
                function oh(e, t, n) {
                    if (t != null && typeof t != 'object')
                        throw Error(
                            "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
                        );
                    if ((t && Object.freeze(t), (e = e.style), n != null)) {
                        if (t) {
                            var a = {};
                            if (n) {
                                for (var o in n)
                                    if (n.hasOwnProperty(o) && !t.hasOwnProperty(o))
                                        for (var c = Ff[o] || [o], f = 0; f < c.length; f++)
                                            a[c[f]] = o;
                            }
                            for (var g in t)
                                if (t.hasOwnProperty(g) && (!n || n[g] !== t[g]))
                                    for (o = Ff[g] || [g], c = 0; c < o.length; c++)
                                        a[o[c]] = g;
                            g = {};
                            for (var w in t)
                                for (o = Ff[w] || [w], c = 0; c < o.length; c++)
                                    g[o[c]] = w;
                            w = {};
                            for (var A in a)
                                if (
                                    ((o = a[A]),
                                        (c = g[A]) && o !== c && ((f = o + ',' + c), !w[f]))
                                ) {
                                    ((w[f] = !0), (f = console));
                                    var V = t[o];
                                    f.error.call(
                                        f,
                                        "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                                        V == null || typeof V == 'boolean' || V === ''
                                            ? 'Removing'
                                            : 'Updating',
                                        o,
                                        c
                                    );
                                }
                        }
                        for (var L in n)
                            !n.hasOwnProperty(L) ||
                                (t != null && t.hasOwnProperty(L)) ||
                                (L.indexOf('--') === 0
                                    ? e.setProperty(L, '')
                                    : L === 'float'
                                        ? (e.cssFloat = '')
                                        : (e[L] = ''));
                        for (var j in t)
                            ((A = t[j]),
                                t.hasOwnProperty(j) && n[j] !== A && lh(e, j, A));
                    } else for (a in t) t.hasOwnProperty(a) && lh(e, a, t[a]);
                }
                function Bo(e) {
                    if (e.indexOf('-') === -1) return !1;
                    switch (e) {
                        case 'annotation-xml':
                        case 'color-profile':
                        case 'font-face':
                        case 'font-face-src':
                        case 'font-face-uri':
                        case 'font-face-format':
                        case 'font-face-name':
                        case 'missing-glyph':
                            return !1;
                        default:
                            return !0;
                    }
                }
                function sh(e) {
                    return gN.get(e) || e;
                }
                function yS(e, t) {
                    if (Oa.call(Yl, t) && Yl[t]) return !0;
                    if (yN.test(t)) {
                        if (
                            ((e = 'aria-' + t.slice(4).toLowerCase()),
                                (e = Qy.hasOwnProperty(e) ? e : null),
                                e == null)
                        )
                            return (
                                console.error(
                                    'Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.',
                                    t
                                ),
                                (Yl[t] = !0)
                            );
                        if (t !== e)
                            return (
                                console.error(
                                    'Invalid ARIA attribute `%s`. Did you mean `%s`?',
                                    t,
                                    e
                                ),
                                (Yl[t] = !0)
                            );
                    }
                    if (bN.test(t)) {
                        if (
                            ((e = t.toLowerCase()),
                                (e = Qy.hasOwnProperty(e) ? e : null),
                                e == null)
                        )
                            return ((Yl[t] = !0), !1);
                        t !== e &&
                            (console.error(
                                'Unknown ARIA attribute `%s`. Did you mean `%s`?',
                                t,
                                e
                            ),
                                (Yl[t] = !0));
                    }
                    return !0;
                }
                function vS(e, t) {
                    var n = [],
                        a;
                    for (a in t) yS(e, a) || n.push(a);
                    ((t = n
                        .map(function (o) {
                            return '`' + o + '`';
                        })
                        .join(', ')),
                        n.length === 1
                            ? console.error(
                                'Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props',
                                t,
                                e
                            )
                            : 1 < n.length &&
                            console.error(
                                'Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props',
                                t,
                                e
                            ));
                }
                function SS(e, t, n, a) {
                    if (Oa.call(_t, t) && _t[t]) return !0;
                    var o = t.toLowerCase();
                    if (o === 'onfocusin' || o === 'onfocusout')
                        return (
                            console.error(
                                'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.'
                            ),
                            (_t[t] = !0)
                        );
                    if (
                        typeof n == 'function' &&
                        ((e === 'form' && t === 'action') ||
                            (e === 'input' && t === 'formAction') ||
                            (e === 'button' && t === 'formAction'))
                    )
                        return !0;
                    if (a != null) {
                        if (
                            ((e = a.possibleRegistrationNames),
                                a.registrationNameDependencies.hasOwnProperty(t))
                        )
                            return !0;
                        if (((a = e.hasOwnProperty(o) ? e[o] : null), a != null))
                            return (
                                console.error(
                                    'Invalid event handler property `%s`. Did you mean `%s`?',
                                    t,
                                    a
                                ),
                                (_t[t] = !0)
                            );
                        if (qy.test(t))
                            return (
                                console.error(
                                    'Unknown event handler property `%s`. It will be ignored.',
                                    t
                                ),
                                (_t[t] = !0)
                            );
                    } else if (qy.test(t))
                        return (
                            vN.test(t) &&
                            console.error(
                                'Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.',
                                t
                            ),
                            (_t[t] = !0)
                        );
                    if (SN.test(t) || xN.test(t)) return !0;
                    if (o === 'innerhtml')
                        return (
                            console.error(
                                'Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.'
                            ),
                            (_t[t] = !0)
                        );
                    if (o === 'aria')
                        return (
                            console.error(
                                'The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.'
                            ),
                            (_t[t] = !0)
                        );
                    if (
                        o === 'is' &&
                        n !== null &&
                        n !== void 0 &&
                        typeof n != 'string'
                    )
                        return (
                            console.error(
                                'Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.',
                                typeof n
                            ),
                            (_t[t] = !0)
                        );
                    if (typeof n == 'number' && isNaN(n))
                        return (
                            console.error(
                                'Received NaN for the `%s` attribute. If this is expected, cast the value to a string.',
                                t
                            ),
                            (_t[t] = !0)
                        );
                    if (xc.hasOwnProperty(o)) {
                        if (((o = xc[o]), o !== t))
                            return (
                                console.error(
                                    'Invalid DOM property `%s`. Did you mean `%s`?',
                                    t,
                                    o
                                ),
                                (_t[t] = !0)
                            );
                    } else if (t !== o)
                        return (
                            console.error(
                                'React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.',
                                t,
                                o
                            ),
                            (_t[t] = !0)
                        );
                    switch (t) {
                        case 'dangerouslySetInnerHTML':
                        case 'children':
                        case 'style':
                        case 'suppressContentEditableWarning':
                        case 'suppressHydrationWarning':
                        case 'defaultValue':
                        case 'defaultChecked':
                        case 'innerHTML':
                        case 'ref':
                            return !0;
                        case 'innerText':
                        case 'textContent':
                            return !0;
                    }
                    switch (typeof n) {
                        case 'boolean':
                            switch (t) {
                                case 'autoFocus':
                                case 'checked':
                                case 'multiple':
                                case 'muted':
                                case 'selected':
                                case 'contentEditable':
                                case 'spellCheck':
                                case 'draggable':
                                case 'value':
                                case 'autoReverse':
                                case 'externalResourcesRequired':
                                case 'focusable':
                                case 'preserveAlpha':
                                case 'allowFullScreen':
                                case 'async':
                                case 'autoPlay':
                                case 'controls':
                                case 'default':
                                case 'defer':
                                case 'disabled':
                                case 'disablePictureInPicture':
                                case 'disableRemotePlayback':
                                case 'formNoValidate':
                                case 'hidden':
                                case 'loop':
                                case 'noModule':
                                case 'noValidate':
                                case 'open':
                                case 'playsInline':
                                case 'readOnly':
                                case 'required':
                                case 'reversed':
                                case 'scoped':
                                case 'seamless':
                                case 'itemScope':
                                case 'capture':
                                case 'download':
                                case 'inert':
                                    return !0;
                                default:
                                    return (
                                        (o = t.toLowerCase().slice(0, 5)),
                                        o === 'data-' || o === 'aria-'
                                            ? !0
                                            : (n
                                                ? console.error(
                                                    'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                                                    n,
                                                    t,
                                                    t,
                                                    n,
                                                    t
                                                )
                                                : console.error(
                                                    'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                                                    n,
                                                    t,
                                                    t,
                                                    n,
                                                    t,
                                                    t,
                                                    t
                                                ),
                                                (_t[t] = !0))
                                    );
                            }
                        case 'function':
                        case 'symbol':
                            return ((_t[t] = !0), !1);
                        case 'string':
                            if (n === 'false' || n === 'true') {
                                switch (t) {
                                    case 'checked':
                                    case 'selected':
                                    case 'multiple':
                                    case 'muted':
                                    case 'allowFullScreen':
                                    case 'async':
                                    case 'autoPlay':
                                    case 'controls':
                                    case 'default':
                                    case 'defer':
                                    case 'disabled':
                                    case 'disablePictureInPicture':
                                    case 'disableRemotePlayback':
                                    case 'formNoValidate':
                                    case 'hidden':
                                    case 'loop':
                                    case 'noModule':
                                    case 'noValidate':
                                    case 'open':
                                    case 'playsInline':
                                    case 'readOnly':
                                    case 'required':
                                    case 'reversed':
                                    case 'scoped':
                                    case 'seamless':
                                    case 'itemScope':
                                    case 'inert':
                                        break;
                                    default:
                                        return !0;
                                }
                                (console.error(
                                    'Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?',
                                    n,
                                    t,
                                    n === 'false'
                                        ? 'The browser will interpret it as a truthy value.'
                                        : 'Although this works, it will not work as expected if you pass the string "false".',
                                    t,
                                    n
                                ),
                                    (_t[t] = !0));
                            }
                    }
                    return !0;
                }
                function xS(e, t, n) {
                    var a = [],
                        o;
                    for (o in t) SS(e, o, t[o], n) || a.push(o);
                    ((t = a
                        .map(function (c) {
                            return '`' + c + '`';
                        })
                        .join(', ')),
                        a.length === 1
                            ? console.error(
                                'Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ',
                                t,
                                e
                            )
                            : 1 < a.length &&
                            console.error(
                                'Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ',
                                t,
                                e
                            ));
                }
                function Lo(e) {
                    return NN.test('' + e)
                        ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
                        : e;
                }
                function _u(e) {
                    return (
                        (e = e.target || e.srcElement || window),
                        e.correspondingUseElement && (e = e.correspondingUseElement),
                        e.nodeType === 3 ? e.parentNode : e
                    );
                }
                function rh(e) {
                    var t = Hn(e);
                    if (t && (e = t.stateNode)) {
                        var n = e[en] || null;
                        e: switch (((e = t.stateNode), t.type)) {
                            case 'input':
                                if (
                                    (zu(
                                        e,
                                        n.value,
                                        n.defaultValue,
                                        n.defaultValue,
                                        n.checked,
                                        n.defaultChecked,
                                        n.type,
                                        n.name
                                    ),
                                        (t = n.name),
                                        n.type === 'radio' && t != null)
                                ) {
                                    for (n = e; n.parentNode;) n = n.parentNode;
                                    for (
                                        ue(t, 'name'),
                                        n = n.querySelectorAll(
                                            'input[name="' + Sn('' + t) + '"][type="radio"]'
                                        ),
                                        t = 0;
                                        t < n.length;
                                        t++
                                    ) {
                                        var a = n[t];
                                        if (a !== e && a.form === e.form) {
                                            var o = a[en] || null;
                                            if (!o)
                                                throw Error(
                                                    'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.'
                                                );
                                            zu(
                                                a,
                                                o.value,
                                                o.defaultValue,
                                                o.defaultValue,
                                                o.checked,
                                                o.defaultChecked,
                                                o.type,
                                                o.name
                                            );
                                        }
                                    }
                                    for (t = 0; t < n.length; t++)
                                        ((a = n[t]), a.form === e.form && Yp(a));
                                }
                                break e;
                            case 'textarea':
                                qp(e, n.value, n.defaultValue);
                                break e;
                            case 'select':
                                ((t = n.value), t != null && xl(e, !!n.multiple, t, !1));
                        }
                    }
                }
                function ch(e, t, n) {
                    if (em) return e(t, n);
                    em = !0;
                    try {
                        var a = e(t);
                        return a;
                    } finally {
                        if (
                            ((em = !1),
                                (Pl !== null || Zl !== null) &&
                                (Ol(),
                                    Pl && ((t = Pl), (e = Zl), (Zl = Pl = null), rh(t), e)))
                        )
                            for (t = 0; t < e.length; t++) rh(e[t]);
                    }
                }
                function Io(e, t) {
                    var n = e.stateNode;
                    if (n === null) return null;
                    var a = n[en] || null;
                    if (a === null) return null;
                    n = a[t];
                    e: switch (t) {
                        case 'onClick':
                        case 'onClickCapture':
                        case 'onDoubleClick':
                        case 'onDoubleClickCapture':
                        case 'onMouseDown':
                        case 'onMouseDownCapture':
                        case 'onMouseMove':
                        case 'onMouseMoveCapture':
                        case 'onMouseUp':
                        case 'onMouseUpCapture':
                        case 'onMouseEnter':
                            ((a = !a.disabled) ||
                                ((e = e.type),
                                    (a = !(
                                        e === 'button' ||
                                        e === 'input' ||
                                        e === 'select' ||
                                        e === 'textarea'
                                    ))),
                                (e = !a));
                            break e;
                        default:
                            e = !1;
                    }
                    if (e) return null;
                    if (n && typeof n != 'function')
                        throw Error(
                            'Expected `' +
                            t +
                            '` listener to be a function, instead got a value of `' +
                            typeof n +
                            '` type.'
                        );
                    return n;
                }
                function uh() {
                    if (Nc) return Nc;
                    var e,
                        t = nm,
                        n = t.length,
                        a,
                        o = 'value' in fi ? fi.value : fi.textContent,
                        c = o.length;
                    for (e = 0; e < n && t[e] === o[e]; e++);
                    var f = n - e;
                    for (a = 1; a <= f && t[n - a] === o[c - a]; a++);
                    return (Nc = o.slice(e, 1 < a ? 1 - a : void 0));
                }
                function yr(e) {
                    var t = e.keyCode;
                    return (
                        'charCode' in e
                            ? ((e = e.charCode), e === 0 && t === 13 && (e = 13))
                            : (e = t),
                        e === 10 && (e = 13),
                        32 <= e || e === 13 ? e : 0
                    );
                }
                function vr() {
                    return !0;
                }
                function dh() {
                    return !1;
                }
                function qt(e) {
                    function t(n, a, o, c, f) {
                        ((this._reactName = n),
                            (this._targetInst = o),
                            (this.type = a),
                            (this.nativeEvent = c),
                            (this.target = f),
                            (this.currentTarget = null));
                        for (var g in e)
                            e.hasOwnProperty(g) &&
                                ((n = e[g]), (this[g] = n ? n(c) : c[g]));
                        return (
                            (this.isDefaultPrevented = (
                                c.defaultPrevented != null
                                    ? c.defaultPrevented
                                    : c.returnValue === !1
                            )
                                ? vr
                                : dh),
                            (this.isPropagationStopped = dh),
                            this
                        );
                    }
                    return (
                        Me(t.prototype, {
                            preventDefault: function () {
                                this.defaultPrevented = !0;
                                var n = this.nativeEvent;
                                n &&
                                    (n.preventDefault
                                        ? n.preventDefault()
                                        : typeof n.returnValue != 'unknown' &&
                                        (n.returnValue = !1),
                                        (this.isDefaultPrevented = vr));
                            },
                            stopPropagation: function () {
                                var n = this.nativeEvent;
                                n &&
                                    (n.stopPropagation
                                        ? n.stopPropagation()
                                        : typeof n.cancelBubble != 'unknown' &&
                                        (n.cancelBubble = !0),
                                        (this.isPropagationStopped = vr));
                            },
                            persist: function () { },
                            isPersistent: vr,
                        }),
                        t
                    );
                }
                function NS(e) {
                    var t = this.nativeEvent;
                    return t.getModifierState
                        ? t.getModifierState(e)
                        : (e = zN[e])
                            ? !!t[e]
                            : !1;
                }
                function Yu() {
                    return NS;
                }
                function fh(e, t) {
                    switch (e) {
                        case 'keyup':
                            return XN.indexOf(t.keyCode) !== -1;
                        case 'keydown':
                            return t.keyCode !== ev;
                        case 'keypress':
                        case 'mousedown':
                        case 'focusout':
                            return !0;
                        default:
                            return !1;
                    }
                }
                function mh(e) {
                    return (
                        (e = e.detail),
                        typeof e == 'object' && 'data' in e ? e.data : null
                    );
                }
                function wS(e, t) {
                    switch (e) {
                        case 'compositionend':
                            return mh(t);
                        case 'keypress':
                            return t.which !== nv ? null : ((iv = !0), av);
                        case 'textInput':
                            return ((e = t.data), e === av && iv ? null : e);
                        default:
                            return null;
                    }
                }
                function ES(e, t) {
                    if (Wl)
                        return e === 'compositionend' || (!om && fh(e, t))
                            ? ((e = uh()), (Nc = nm = fi = null), (Wl = !1), e)
                            : null;
                    switch (e) {
                        case 'paste':
                            return null;
                        case 'keypress':
                            if (
                                !(t.ctrlKey || t.altKey || t.metaKey) ||
                                (t.ctrlKey && t.altKey)
                            ) {
                                if (t.char && 1 < t.char.length) return t.char;
                                if (t.which) return String.fromCharCode(t.which);
                            }
                            return null;
                        case 'compositionend':
                            return tv && t.locale !== 'ko' ? null : t.data;
                        default:
                            return null;
                    }
                }
                function ph(e) {
                    var t = e && e.nodeName && e.nodeName.toLowerCase();
                    return t === 'input' ? !!JN[e.type] : t === 'textarea';
                }
                function AS(e) {
                    if (!ua) return !1;
                    e = 'on' + e;
                    var t = e in document;
                    return (
                        t ||
                        ((t = document.createElement('div')),
                            t.setAttribute(e, 'return;'),
                            (t = typeof t[e] == 'function')),
                        t
                    );
                }
                function hh(e, t, n, a) {
                    (Pl ? (Zl ? Zl.push(a) : (Zl = [a])) : (Pl = a),
                        (t = ac(t, 'onChange')),
                        0 < t.length &&
                        ((n = new wc('onChange', 'change', null, n, a)),
                            e.push({ event: n, listeners: t })));
                }
                function DS(e) {
                    Bb(e, 0);
                }
                function Sr(e) {
                    var t = $a(e);
                    if (Yp(t)) return e;
                }
                function gh(e, t) {
                    if (e === 'change') return t;
                }
                function bh() {
                    Ns && (Ns.detachEvent('onpropertychange', yh), (ws = Ns = null));
                }
                function yh(e) {
                    if (e.propertyName === 'value' && Sr(ws)) {
                        var t = [];
                        (hh(t, ws, e, _u(e)), ch(DS, t));
                    }
                }
                function TS(e, t, n) {
                    e === 'focusin'
                        ? (bh(),
                            (Ns = t),
                            (ws = n),
                            Ns.attachEvent('onpropertychange', yh))
                        : e === 'focusout' && bh();
                }
                function CS(e) {
                    if (e === 'selectionchange' || e === 'keyup' || e === 'keydown')
                        return Sr(ws);
                }
                function RS(e, t) {
                    if (e === 'click') return Sr(t);
                }
                function MS(e, t) {
                    if (e === 'input' || e === 'change') return Sr(t);
                }
                function OS(e, t) {
                    return (
                        (e === t && (e !== 0 || 1 / e === 1 / t)) ||
                        (e !== e && t !== t)
                    );
                }
                function Ho(e, t) {
                    if (Yt(e, t)) return !0;
                    if (
                        typeof e != 'object' ||
                        e === null ||
                        typeof t != 'object' ||
                        t === null
                    )
                        return !1;
                    var n = Object.keys(e),
                        a = Object.keys(t);
                    if (n.length !== a.length) return !1;
                    for (a = 0; a < n.length; a++) {
                        var o = n[a];
                        if (!Oa.call(t, o) || !Yt(e[o], t[o])) return !1;
                    }
                    return !0;
                }
                function vh(e) {
                    for (; e && e.firstChild;) e = e.firstChild;
                    return e;
                }
                function Sh(e, t) {
                    var n = vh(e);
                    e = 0;
                    for (var a; n;) {
                        if (n.nodeType === 3) {
                            if (((a = e + n.textContent.length), e <= t && a >= t))
                                return { node: n, offset: t - e };
                            e = a;
                        }
                        e: {
                            for (; n;) {
                                if (n.nextSibling) {
                                    n = n.nextSibling;
                                    break e;
                                }
                                n = n.parentNode;
                            }
                            n = void 0;
                        }
                        n = vh(n);
                    }
                }
                function xh(e, t) {
                    return e && t
                        ? e === t
                            ? !0
                            : e && e.nodeType === 3
                                ? !1
                                : t && t.nodeType === 3
                                    ? xh(e, t.parentNode)
                                    : 'contains' in e
                                        ? e.contains(t)
                                        : e.compareDocumentPosition
                                            ? !!(e.compareDocumentPosition(t) & 16)
                                            : !1
                        : !1;
                }
                function Nh(e) {
                    e =
                        e != null &&
                            e.ownerDocument != null &&
                            e.ownerDocument.defaultView != null
                            ? e.ownerDocument.defaultView
                            : window;
                    for (var t = hr(e.document); t instanceof e.HTMLIFrameElement;) {
                        try {
                            var n = typeof t.contentWindow.location.href == 'string';
                        } catch {
                            n = !1;
                        }
                        if (n) e = t.contentWindow;
                        else break;
                        t = hr(e.document);
                    }
                    return t;
                }
                function Pu(e) {
                    var t = e && e.nodeName && e.nodeName.toLowerCase();
                    return (
                        t &&
                        ((t === 'input' &&
                            (e.type === 'text' ||
                                e.type === 'search' ||
                                e.type === 'tel' ||
                                e.type === 'url' ||
                                e.type === 'password')) ||
                            t === 'textarea' ||
                            e.contentEditable === 'true')
                    );
                }
                function wh(e, t, n) {
                    var a =
                        n.window === n
                            ? n.document
                            : n.nodeType === 9
                                ? n
                                : n.ownerDocument;
                    rm ||
                        Xl == null ||
                        Xl !== hr(a) ||
                        ((a = Xl),
                            'selectionStart' in a && Pu(a)
                                ? (a = { start: a.selectionStart, end: a.selectionEnd })
                                : ((a = (
                                    (a.ownerDocument && a.ownerDocument.defaultView) ||
                                    window
                                ).getSelection()),
                                    (a = {
                                        anchorNode: a.anchorNode,
                                        anchorOffset: a.anchorOffset,
                                        focusNode: a.focusNode,
                                        focusOffset: a.focusOffset,
                                    })),
                            (Es && Ho(Es, a)) ||
                            ((Es = a),
                                (a = ac(sm, 'onSelect')),
                                0 < a.length &&
                                ((t = new wc('onSelect', 'select', null, t, n)),
                                    e.push({ event: t, listeners: a }),
                                    (t.target = Xl))));
                }
                function ji(e, t) {
                    var n = {};
                    return (
                        (n[e.toLowerCase()] = t.toLowerCase()),
                        (n['Webkit' + e] = 'webkit' + t),
                        (n['Moz' + e] = 'moz' + t),
                        n
                    );
                }
                function Vi(e) {
                    if (cm[e]) return cm[e];
                    if (!Ql[e]) return e;
                    var t = Ql[e],
                        n;
                    for (n in t)
                        if (t.hasOwnProperty(n) && n in ov) return (cm[e] = t[n]);
                    return e;
                }
                function Un(e, t) {
                    (dv.set(e, t), ee(t, [e]));
                }
                function sn(e, t) {
                    if (typeof e == 'object' && e !== null) {
                        var n = dm.get(e);
                        return n !== void 0
                            ? n
                            : ((t = { value: e, source: t, stack: Up(t) }),
                                dm.set(e, t),
                                t);
                    }
                    return { value: e, source: t, stack: Up(t) };
                }
                function xr() {
                    for (var e = Jl, t = (fm = Jl = 0); t < e;) {
                        var n = En[t];
                        En[t++] = null;
                        var a = En[t];
                        En[t++] = null;
                        var o = En[t];
                        En[t++] = null;
                        var c = En[t];
                        if (((En[t++] = null), a !== null && o !== null)) {
                            var f = a.pending;
                            (f === null
                                ? (o.next = o)
                                : ((o.next = f.next), (f.next = o)),
                                (a.pending = o));
                        }
                        c !== 0 && Eh(n, o, c);
                    }
                }
                function Nr(e, t, n, a) {
                    ((En[Jl++] = e),
                        (En[Jl++] = t),
                        (En[Jl++] = n),
                        (En[Jl++] = a),
                        (fm |= a),
                        (e.lanes |= a),
                        (e = e.alternate),
                        e !== null && (e.lanes |= a));
                }
                function Zu(e, t, n, a) {
                    return (Nr(e, t, n, a), wr(e));
                }
                function $t(e, t) {
                    return (Nr(e, null, null, t), wr(e));
                }
                function Eh(e, t, n) {
                    e.lanes |= n;
                    var a = e.alternate;
                    a !== null && (a.lanes |= n);
                    for (var o = !1, c = e.return; c !== null;)
                        ((c.childLanes |= n),
                            (a = c.alternate),
                            a !== null && (a.childLanes |= n),
                            c.tag === 22 &&
                            ((e = c.stateNode),
                                e === null || e._visibility & Ac || (o = !0)),
                            (e = c),
                            (c = c.return));
                    return e.tag === 3
                        ? ((c = e.stateNode),
                            o &&
                            t !== null &&
                            ((o = 31 - Gt(n)),
                                (e = c.hiddenUpdates),
                                (a = e[o]),
                                a === null ? (e[o] = [t]) : a.push(t),
                                (t.lane = n | 536870912)),
                            c)
                        : null;
                }
                function wr(e) {
                    if (Ws > yw)
                        throw (
                            (rl = Ws = 0),
                            (Xs = _m = null),
                            Error(
                                'Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.'
                            )
                        );
                    (rl > vw &&
                        ((rl = 0),
                            (Xs = null),
                            console.error(
                                "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
                            )),
                        e.alternate === null && (e.flags & 4098) !== 0 && Rb(e));
                    for (var t = e, n = t.return; n !== null;)
                        (t.alternate === null && (t.flags & 4098) !== 0 && Rb(e),
                            (t = n),
                            (n = t.return));
                    return t.tag === 3 ? t.stateNode : null;
                }
                function zi(e) {
                    if (An === null) return e;
                    var t = An(e);
                    return t === void 0 ? e : t.current;
                }
                function Wu(e) {
                    if (An === null) return e;
                    var t = An(e);
                    return t === void 0
                        ? e != null &&
                            typeof e.render == 'function' &&
                            ((t = zi(e.render)), e.render !== t)
                            ? ((t = { $$typeof: ms, render: t }),
                                e.displayName !== void 0 && (t.displayName = e.displayName),
                                t)
                            : e
                        : t.current;
                }
                function Ah(e, t) {
                    if (An === null) return !1;
                    var n = e.elementType;
                    t = t.type;
                    var a = !1,
                        o = typeof t == 'object' && t !== null ? t.$$typeof : null;
                    switch (e.tag) {
                        case 1:
                            typeof t == 'function' && (a = !0);
                            break;
                        case 0:
                            (typeof t == 'function' || o === dn) && (a = !0);
                            break;
                        case 11:
                            (o === ms || o === dn) && (a = !0);
                            break;
                        case 14:
                        case 15:
                            (o === pc || o === dn) && (a = !0);
                            break;
                        default:
                            return !1;
                    }
                    return !!(a && ((e = An(n)), e !== void 0 && e === An(t)));
                }
                function Dh(e) {
                    An !== null &&
                        typeof WeakSet == 'function' &&
                        (ql === null && (ql = new WeakSet()), ql.add(e));
                }
                function Xu(e, t, n) {
                    var a = e.alternate,
                        o = e.child,
                        c = e.sibling,
                        f = e.tag,
                        g = e.type,
                        w = null;
                    switch (f) {
                        case 0:
                        case 15:
                        case 1:
                            w = g;
                            break;
                        case 11:
                            w = g.render;
                    }
                    if (An === null)
                        throw Error(
                            'Expected resolveFamily to be set during hot reload.'
                        );
                    var A = !1;
                    ((g = !1),
                        w !== null &&
                        ((w = An(w)),
                            w !== void 0 &&
                            (n.has(w)
                                ? (g = !0)
                                : t.has(w) && (f === 1 ? (g = !0) : (A = !0)))),
                        ql !== null &&
                        (ql.has(e) || (a !== null && ql.has(a))) &&
                        (g = !0),
                        g && (e._debugNeedsRemount = !0),
                        (g || A) && ((a = $t(e, 2)), a !== null && ft(a, e, 2)),
                        o === null || g || Xu(o, t, n),
                        c !== null && Xu(c, t, n));
                }
                function kS(e, t, n, a) {
                    ((this.tag = e),
                        (this.key = n),
                        (this.sibling =
                            this.child =
                            this.return =
                            this.stateNode =
                            this.type =
                            this.elementType =
                            null),
                        (this.index = 0),
                        (this.refCleanup = this.ref = null),
                        (this.pendingProps = t),
                        (this.dependencies =
                            this.memoizedState =
                            this.updateQueue =
                            this.memoizedProps =
                            null),
                        (this.mode = a),
                        (this.subtreeFlags = this.flags = 0),
                        (this.deletions = null),
                        (this.childLanes = this.lanes = 0),
                        (this.alternate = null),
                        (this.actualDuration = -0),
                        (this.actualStartTime = -1.1),
                        (this.treeBaseDuration = this.selfBaseDuration = -0),
                        (this._debugTask =
                            this._debugStack =
                            this._debugOwner =
                            this._debugInfo =
                            null),
                        (this._debugNeedsRemount = !1),
                        (this._debugHookTypes = null),
                        mv ||
                        typeof Object.preventExtensions != 'function' ||
                        Object.preventExtensions(this));
                }
                function Qu(e) {
                    return ((e = e.prototype), !(!e || !e.isReactComponent));
                }
                function xa(e, t) {
                    var n = e.alternate;
                    switch (
                    (n === null
                        ? ((n = N(e.tag, t, e.key, e.mode)),
                            (n.elementType = e.elementType),
                            (n.type = e.type),
                            (n.stateNode = e.stateNode),
                            (n._debugOwner = e._debugOwner),
                            (n._debugStack = e._debugStack),
                            (n._debugTask = e._debugTask),
                            (n._debugHookTypes = e._debugHookTypes),
                            (n.alternate = e),
                            (e.alternate = n))
                        : ((n.pendingProps = t),
                            (n.type = e.type),
                            (n.flags = 0),
                            (n.subtreeFlags = 0),
                            (n.deletions = null),
                            (n.actualDuration = -0),
                            (n.actualStartTime = -1.1)),
                        (n.flags = e.flags & 65011712),
                        (n.childLanes = e.childLanes),
                        (n.lanes = e.lanes),
                        (n.child = e.child),
                        (n.memoizedProps = e.memoizedProps),
                        (n.memoizedState = e.memoizedState),
                        (n.updateQueue = e.updateQueue),
                        (t = e.dependencies),
                        (n.dependencies =
                            t === null
                                ? null
                                : {
                                    lanes: t.lanes,
                                    firstContext: t.firstContext,
                                    _debugThenableState: t._debugThenableState,
                                }),
                        (n.sibling = e.sibling),
                        (n.index = e.index),
                        (n.ref = e.ref),
                        (n.refCleanup = e.refCleanup),
                        (n.selfBaseDuration = e.selfBaseDuration),
                        (n.treeBaseDuration = e.treeBaseDuration),
                        (n._debugInfo = e._debugInfo),
                        (n._debugNeedsRemount = e._debugNeedsRemount),
                        n.tag)
                    ) {
                        case 0:
                        case 15:
                            n.type = zi(e.type);
                            break;
                        case 1:
                            n.type = zi(e.type);
                            break;
                        case 11:
                            n.type = Wu(e.type);
                    }
                    return n;
                }
                function Th(e, t) {
                    e.flags &= 65011714;
                    var n = e.alternate;
                    return (
                        n === null
                            ? ((e.childLanes = 0),
                                (e.lanes = t),
                                (e.child = null),
                                (e.subtreeFlags = 0),
                                (e.memoizedProps = null),
                                (e.memoizedState = null),
                                (e.updateQueue = null),
                                (e.dependencies = null),
                                (e.stateNode = null),
                                (e.selfBaseDuration = 0),
                                (e.treeBaseDuration = 0))
                            : ((e.childLanes = n.childLanes),
                                (e.lanes = n.lanes),
                                (e.child = n.child),
                                (e.subtreeFlags = 0),
                                (e.deletions = null),
                                (e.memoizedProps = n.memoizedProps),
                                (e.memoizedState = n.memoizedState),
                                (e.updateQueue = n.updateQueue),
                                (e.type = n.type),
                                (t = n.dependencies),
                                (e.dependencies =
                                    t === null
                                        ? null
                                        : {
                                            lanes: t.lanes,
                                            firstContext: t.firstContext,
                                            _debugThenableState: t._debugThenableState,
                                        }),
                                (e.selfBaseDuration = n.selfBaseDuration),
                                (e.treeBaseDuration = n.treeBaseDuration)),
                        e
                    );
                }
                function Ju(e, t, n, a, o, c) {
                    var f = 0,
                        g = e;
                    if (typeof e == 'function') (Qu(e) && (f = 1), (g = zi(g)));
                    else if (typeof e == 'string')
                        ((f = J()),
                            (f = kx(e, n, f)
                                ? 26
                                : e === 'html' || e === 'head' || e === 'body'
                                    ? 27
                                    : 5));
                    else
                        e: switch (e) {
                            case Uf:
                                return (
                                    (t = N(31, n, t, o)),
                                    (t.elementType = Uf),
                                    (t.lanes = c),
                                    t
                                );
                            case Il:
                                return Bi(n.children, o, c, t);
                            case mc:
                                ((f = 8), (o |= It), (o |= Yn));
                                break;
                            case Bf:
                                return (
                                    (e = n),
                                    (a = o),
                                    typeof e.id != 'string' &&
                                    console.error(
                                        'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
                                        typeof e.id
                                    ),
                                    (t = N(12, e, t, a | kt)),
                                    (t.elementType = Bf),
                                    (t.lanes = c),
                                    (t.stateNode = {
                                        effectDuration: 0,
                                        passiveEffectDuration: 0,
                                    }),
                                    t
                                );
                            case If:
                                return (
                                    (t = N(13, n, t, o)),
                                    (t.elementType = If),
                                    (t.lanes = c),
                                    t
                                );
                            case Hf:
                                return (
                                    (t = N(19, n, t, o)),
                                    (t.elementType = Hf),
                                    (t.lanes = c),
                                    t
                                );
                            default:
                                if (typeof e == 'object' && e !== null)
                                    switch (e.$$typeof) {
                                        case Wx:
                                        case la:
                                            f = 10;
                                            break e;
                                        case Lf:
                                            f = 9;
                                            break e;
                                        case ms:
                                            ((f = 11), (g = Wu(g)));
                                            break e;
                                        case pc:
                                            f = 14;
                                            break e;
                                        case dn:
                                            ((f = 16), (g = null));
                                            break e;
                                    }
                                ((g = ''),
                                    (e === void 0 ||
                                        (typeof e == 'object' &&
                                            e !== null &&
                                            Object.keys(e).length === 0)) &&
                                    (g +=
                                        " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."),
                                    e === null
                                        ? (n = 'null')
                                        : Ot(e)
                                            ? (n = 'array')
                                            : e !== void 0 && e.$$typeof === si
                                                ? ((n = '<' + (q(e.type) || 'Unknown') + ' />'),
                                                    (g =
                                                        ' Did you accidentally export a JSX literal instead of a component?'))
                                                : (n = typeof e),
                                    (f = a ? W(a) : null) &&
                                    (g +=
                                        `

Check the render method of \`` +
                                        f +
                                        '`.'),
                                    (f = 29),
                                    (n = Error(
                                        'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: ' +
                                        (n + '.' + g)
                                    )),
                                    (g = null));
                        }
                    return (
                        (t = N(f, n, t, o)),
                        (t.elementType = e),
                        (t.type = g),
                        (t.lanes = c),
                        (t._debugOwner = a),
                        t
                    );
                }
                function Er(e, t, n) {
                    return (
                        (t = Ju(e.type, e.key, e.props, e._owner, t, n)),
                        (t._debugOwner = e._owner),
                        (t._debugStack = e._debugStack),
                        (t._debugTask = e._debugTask),
                        t
                    );
                }
                function Bi(e, t, n, a) {
                    return ((e = N(7, e, a, t)), (e.lanes = n), e);
                }
                function qu(e, t, n) {
                    return ((e = N(6, e, null, t)), (e.lanes = n), e);
                }
                function $u(e, t, n) {
                    return (
                        (t = N(4, e.children !== null ? e.children : [], e.key, t)),
                        (t.lanes = n),
                        (t.stateNode = {
                            containerInfo: e.containerInfo,
                            pendingChildren: null,
                            implementation: e.implementation,
                        }),
                        t
                    );
                }
                function Li(e, t) {
                    (Ii(), ($l[Fl++] = Tc), ($l[Fl++] = Dc), (Dc = e), (Tc = t));
                }
                function Ch(e, t, n) {
                    (Ii(),
                        (Dn[Tn++] = Va),
                        (Dn[Tn++] = za),
                        (Dn[Tn++] = qi),
                        (qi = e));
                    var a = Va;
                    e = za;
                    var o = 32 - Gt(a) - 1;
                    ((a &= ~(1 << o)), (n += 1));
                    var c = 32 - Gt(t) + o;
                    if (30 < c) {
                        var f = o - (o % 5);
                        ((c = (a & ((1 << f) - 1)).toString(32)),
                            (a >>= f),
                            (o -= f),
                            (Va = (1 << (32 - Gt(t) + o)) | (n << o) | a),
                            (za = c + e));
                    } else ((Va = (1 << c) | (n << o) | a), (za = e));
                }
                function Fu(e) {
                    (Ii(), e.return !== null && (Li(e, 1), Ch(e, 1, 0)));
                }
                function Ku(e) {
                    for (; e === Dc;)
                        ((Dc = $l[--Fl]),
                            ($l[Fl] = null),
                            (Tc = $l[--Fl]),
                            ($l[Fl] = null));
                    for (; e === qi;)
                        ((qi = Dn[--Tn]),
                            (Dn[Tn] = null),
                            (za = Dn[--Tn]),
                            (Dn[Tn] = null),
                            (Va = Dn[--Tn]),
                            (Dn[Tn] = null));
                }
                function Ii() {
                    Ue ||
                        console.error(
                            'Expected to be hydrating. This is a bug in React. Please file an issue.'
                        );
                }
                function Hi(e, t) {
                    if (e.return === null) {
                        if (Cn === null)
                            Cn = {
                                fiber: e,
                                children: [],
                                serverProps: void 0,
                                serverTail: [],
                                distanceFromLeaf: t,
                            };
                        else {
                            if (Cn.fiber !== e)
                                throw Error(
                                    'Saw multiple hydration diff roots in a pass. This is a bug in React.'
                                );
                            Cn.distanceFromLeaf > t && (Cn.distanceFromLeaf = t);
                        }
                        return Cn;
                    }
                    var n = Hi(e.return, t + 1).children;
                    return 0 < n.length && n[n.length - 1].fiber === e
                        ? ((n = n[n.length - 1]),
                            n.distanceFromLeaf > t && (n.distanceFromLeaf = t),
                            n)
                        : ((t = {
                            fiber: e,
                            children: [],
                            serverProps: void 0,
                            serverTail: [],
                            distanceFromLeaf: t,
                        }),
                            n.push(t),
                            t);
                }
                function ed(e, t) {
                    Ba ||
                        ((e = Hi(e, 0)),
                            (e.serverProps = null),
                            t !== null && ((t = qb(t)), e.serverTail.push(t)));
                }
                function Ui(e) {
                    var t = '',
                        n = Cn;
                    throw (
                        n !== null && ((Cn = null), (t = Uu(n))),
                        _o(
                            sn(
                                Error(
                                    `Hydration failed because the server rendered HTML didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

https://react.dev/link/hydration-mismatch` + t
                                ),
                                e
                            )
                        ),
                        mm
                    );
                }
                function Rh(e) {
                    var t = e.stateNode,
                        n = e.type,
                        a = e.memoizedProps;
                    switch (((t[Lt] = e), (t[en] = a), yf(n, a), n)) {
                        case 'dialog':
                            (Be('cancel', t), Be('close', t));
                            break;
                        case 'iframe':
                        case 'object':
                        case 'embed':
                            Be('load', t);
                            break;
                        case 'video':
                        case 'audio':
                            for (n = 0; n < Qs.length; n++) Be(Qs[n], t);
                            break;
                        case 'source':
                            Be('error', t);
                            break;
                        case 'img':
                        case 'image':
                        case 'link':
                            (Be('error', t), Be('load', t));
                            break;
                        case 'details':
                            Be('toggle', t);
                            break;
                        case 'input':
                            (pe('input', a),
                                Be('invalid', t),
                                Pp(t, a),
                                Zp(
                                    t,
                                    a.value,
                                    a.defaultValue,
                                    a.checked,
                                    a.defaultChecked,
                                    a.type,
                                    a.name,
                                    !0
                                ),
                                pr(t));
                            break;
                        case 'option':
                            Wp(t, a);
                            break;
                        case 'select':
                            (pe('select', a), Be('invalid', t), Qp(t, a));
                            break;
                        case 'textarea':
                            (pe('textarea', a),
                                Be('invalid', t),
                                Jp(t, a),
                                $p(t, a.value, a.defaultValue, a.children),
                                pr(t));
                    }
                    ((n = a.children),
                        (typeof n != 'string' &&
                            typeof n != 'number' &&
                            typeof n != 'bigint') ||
                            t.textContent === '' + n ||
                            a.suppressHydrationWarning === !0 ||
                            Ub(t.textContent, n)
                            ? (a.popover != null &&
                                (Be('beforetoggle', t), Be('toggle', t)),
                                a.onScroll != null && Be('scroll', t),
                                a.onScrollEnd != null && Be('scrollend', t),
                                a.onClick != null && (t.onclick = ic),
                                (t = !0))
                            : (t = !1),
                        t || Ui(e));
                }
                function Mh(e) {
                    for (Pt = e.return; Pt;)
                        switch (Pt.tag) {
                            case 5:
                            case 13:
                                da = !1;
                                return;
                            case 27:
                            case 3:
                                da = !0;
                                return;
                            default:
                                Pt = Pt.return;
                        }
                }
                function Uo(e) {
                    if (e !== Pt) return !1;
                    if (!Ue) return (Mh(e), (Ue = !0), !1);
                    var t = e.tag,
                        n;
                    if (
                        ((n = t !== 3 && t !== 27) &&
                            ((n = t === 5) &&
                                ((n = e.type),
                                    (n =
                                        !(n !== 'form' && n !== 'button') ||
                                        wf(e.type, e.memoizedProps))),
                                (n = !n)),
                            n && st)
                    ) {
                        for (n = st; n;) {
                            var a = Hi(e, 0),
                                o = qb(n);
                            (a.serverTail.push(o),
                                (n = o.type === 'Suspense' ? Fb(n) : Nn(n.nextSibling)));
                        }
                        Ui(e);
                    }
                    if ((Mh(e), t === 13)) {
                        if (
                            ((e = e.memoizedState),
                                (e = e !== null ? e.dehydrated : null),
                                !e)
                        )
                            throw Error(
                                'Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.'
                            );
                        st = Fb(e);
                    } else
                        t === 27
                            ? ((t = st),
                                oi(e.type) ? ((e = ep), (ep = null), (st = e)) : (st = t))
                            : (st = Pt ? Nn(e.stateNode.nextSibling) : null);
                    return !0;
                }
                function Go() {
                    ((st = Pt = null), (Ba = Ue = !1));
                }
                function Oh() {
                    var e = $i;
                    return (
                        e !== null &&
                        (Xt === null ? (Xt = e) : Xt.push.apply(Xt, e), ($i = null)),
                        e
                    );
                }
                function _o(e) {
                    $i === null ? ($i = [e]) : $i.push(e);
                }
                function kh() {
                    var e = Cn;
                    if (e !== null) {
                        Cn = null;
                        for (var t = Uu(e); 0 < e.children.length;) e = e.children[0];
                        he(e.fiber, function () {
                            console.error(
                                `A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

%s%s`,
                                'https://react.dev/link/hydration-mismatch',
                                t
                            );
                        });
                    }
                }
                function Ar() {
                    ((Kl = Cc = null), (eo = !1));
                }
                function Fa(e, t, n) {
                    (oe(pm, t._currentValue, e),
                        (t._currentValue = n),
                        oe(hm, t._currentRenderer, e),
                        t._currentRenderer !== void 0 &&
                        t._currentRenderer !== null &&
                        t._currentRenderer !== gv &&
                        console.error(
                            'Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.'
                        ),
                        (t._currentRenderer = gv));
                }
                function Na(e, t) {
                    e._currentValue = pm.current;
                    var n = hm.current;
                    (X(hm, t), (e._currentRenderer = n), X(pm, t));
                }
                function td(e, t, n) {
                    for (; e !== null;) {
                        var a = e.alternate;
                        if (
                            ((e.childLanes & t) !== t
                                ? ((e.childLanes |= t), a !== null && (a.childLanes |= t))
                                : a !== null &&
                                (a.childLanes & t) !== t &&
                                (a.childLanes |= t),
                                e === n)
                        )
                            break;
                        e = e.return;
                    }
                    e !== n &&
                        console.error(
                            'Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.'
                        );
                }
                function nd(e, t, n, a) {
                    var o = e.child;
                    for (o !== null && (o.return = e); o !== null;) {
                        var c = o.dependencies;
                        if (c !== null) {
                            var f = o.child;
                            c = c.firstContext;
                            e: for (; c !== null;) {
                                var g = c;
                                c = o;
                                for (var w = 0; w < t.length; w++)
                                    if (g.context === t[w]) {
                                        ((c.lanes |= n),
                                            (g = c.alternate),
                                            g !== null && (g.lanes |= n),
                                            td(c.return, n, e),
                                            a || (f = null));
                                        break e;
                                    }
                                c = g.next;
                            }
                        } else if (o.tag === 18) {
                            if (((f = o.return), f === null))
                                throw Error(
                                    'We just came from a parent so we must have had a parent. This is a bug in React.'
                                );
                            ((f.lanes |= n),
                                (c = f.alternate),
                                c !== null && (c.lanes |= n),
                                td(f, n, e),
                                (f = null));
                        } else f = o.child;
                        if (f !== null) f.return = o;
                        else
                            for (f = o; f !== null;) {
                                if (f === e) {
                                    f = null;
                                    break;
                                }
                                if (((o = f.sibling), o !== null)) {
                                    ((o.return = f.return), (f = o));
                                    break;
                                }
                                f = f.return;
                            }
                        o = f;
                    }
                }
                function Yo(e, t, n, a) {
                    e = null;
                    for (var o = t, c = !1; o !== null;) {
                        if (!c) {
                            if ((o.flags & 524288) !== 0) c = !0;
                            else if ((o.flags & 262144) !== 0) break;
                        }
                        if (o.tag === 10) {
                            var f = o.alternate;
                            if (f === null)
                                throw Error(
                                    'Should have a current fiber. This is a bug in React.'
                                );
                            if (((f = f.memoizedProps), f !== null)) {
                                var g = o.type;
                                Yt(o.pendingProps.value, f.value) ||
                                    (e !== null ? e.push(g) : (e = [g]));
                            }
                        } else if (o === hc.current) {
                            if (((f = o.alternate), f === null))
                                throw Error(
                                    'Should have a current fiber. This is a bug in React.'
                                );
                            f.memoizedState.memoizedState !==
                                o.memoizedState.memoizedState &&
                                (e !== null ? e.push(Fs) : (e = [Fs]));
                        }
                        o = o.return;
                    }
                    (e !== null && nd(t, e, n, a), (t.flags |= 262144));
                }
                function Dr(e) {
                    for (e = e.firstContext; e !== null;) {
                        if (!Yt(e.context._currentValue, e.memoizedValue)) return !0;
                        e = e.next;
                    }
                    return !1;
                }
                function Gi(e) {
                    ((Cc = e),
                        (Kl = null),
                        (e = e.dependencies),
                        e !== null && (e.firstContext = null));
                }
                function it(e) {
                    return (
                        eo &&
                        console.error(
                            'Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().'
                        ),
                        jh(Cc, e)
                    );
                }
                function Tr(e, t) {
                    return (Cc === null && Gi(e), jh(e, t));
                }
                function jh(e, t) {
                    var n = t._currentValue;
                    if (
                        ((t = { context: t, memoizedValue: n, next: null }),
                            Kl === null)
                    ) {
                        if (e === null)
                            throw Error(
                                'Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().'
                            );
                        ((Kl = t),
                            (e.dependencies = {
                                lanes: 0,
                                firstContext: t,
                                _debugThenableState: null,
                            }),
                            (e.flags |= 524288));
                    } else Kl = Kl.next = t;
                    return n;
                }
                function ad() {
                    return { controller: new aw(), data: new Map(), refCount: 0 };
                }
                function _i(e) {
                    (e.controller.signal.aborted &&
                        console.warn(
                            'A cache instance was retained after it was already freed. This likely indicates a bug in React.'
                        ),
                        e.refCount++);
                }
                function Po(e) {
                    (e.refCount--,
                        0 > e.refCount &&
                        console.warn(
                            'A cache instance was released after it was already freed. This likely indicates a bug in React.'
                        ),
                        e.refCount === 0 &&
                        iw(lw, function () {
                            e.controller.abort();
                        }));
                }
                function wa() {
                    var e = Fi;
                    return ((Fi = 0), e);
                }
                function Cr(e) {
                    var t = Fi;
                    return ((Fi = e), t);
                }
                function Zo(e) {
                    var t = Fi;
                    return ((Fi += e), t);
                }
                function id(e) {
                    ((tn = to()), 0 > e.actualStartTime && (e.actualStartTime = tn));
                }
                function ld(e) {
                    if (0 <= tn) {
                        var t = to() - tn;
                        ((e.actualDuration += t), (e.selfBaseDuration = t), (tn = -1));
                    }
                }
                function Vh(e) {
                    if (0 <= tn) {
                        var t = to() - tn;
                        ((e.actualDuration += t), (tn = -1));
                    }
                }
                function Fn() {
                    if (0 <= tn) {
                        var e = to() - tn;
                        ((tn = -1), (Fi += e));
                    }
                }
                function Kn() {
                    tn = to();
                }
                function Rr(e) {
                    for (var t = e.child; t;)
                        ((e.actualDuration += t.actualDuration), (t = t.sibling));
                }
                function jS(e, t) {
                    if (As === null) {
                        var n = (As = []);
                        ((gm = 0),
                            (Ki = pf()),
                            (no = {
                                status: 'pending',
                                value: void 0,
                                then: function (a) {
                                    n.push(a);
                                },
                            }));
                    }
                    return (gm++, t.then(zh, zh), t);
                }
                function zh() {
                    if (--gm === 0 && As !== null) {
                        no !== null && (no.status = 'fulfilled');
                        var e = As;
                        ((As = null), (Ki = 0), (no = null));
                        for (var t = 0; t < e.length; t++) (0, e[t])();
                    }
                }
                function VS(e, t) {
                    var n = [],
                        a = {
                            status: 'pending',
                            value: null,
                            reason: null,
                            then: function (o) {
                                n.push(o);
                            },
                        };
                    return (
                        e.then(
                            function () {
                                ((a.status = 'fulfilled'), (a.value = t));
                                for (var o = 0; o < n.length; o++) (0, n[o])(t);
                            },
                            function (o) {
                                for (
                                    a.status = 'rejected', a.reason = o, o = 0;
                                    o < n.length;
                                    o++
                                )
                                    (0, n[o])(void 0);
                            }
                        ),
                        a
                    );
                }
                function od() {
                    var e = el.current;
                    return e !== null ? e : Fe.pooledCache;
                }
                function Mr(e, t) {
                    t === null ? oe(el, el.current, e) : oe(el, t.pool, e);
                }
                function Bh() {
                    var e = od();
                    return e === null ? null : { parent: vt._currentValue, pool: e };
                }
                function Lh() {
                    return { didWarnAboutUncachedPromise: !1, thenables: [] };
                }
                function Ih(e) {
                    return ((e = e.status), e === 'fulfilled' || e === 'rejected');
                }
                function Or() { }
                function Hh(e, t, n) {
                    B.actQueue !== null && (B.didUsePromise = !0);
                    var a = e.thenables;
                    switch (
                    ((n = a[n]),
                        n === void 0
                            ? a.push(t)
                            : n !== t &&
                            (e.didWarnAboutUncachedPromise ||
                                ((e.didWarnAboutUncachedPromise = !0),
                                    console.error(
                                        'A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework.'
                                    )),
                                t.then(Or, Or),
                                (t = n)),
                        t.status)
                    ) {
                        case 'fulfilled':
                            return t.value;
                        case 'rejected':
                            throw ((e = t.reason), Gh(e), e);
                        default:
                            if (typeof t.status == 'string') t.then(Or, Or);
                            else {
                                if (((e = Fe), e !== null && 100 < e.shellSuspendCounter))
                                    throw Error(
                                        "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
                                    );
                                ((e = t),
                                    (e.status = 'pending'),
                                    e.then(
                                        function (o) {
                                            if (t.status === 'pending') {
                                                var c = t;
                                                ((c.status = 'fulfilled'), (c.value = o));
                                            }
                                        },
                                        function (o) {
                                            if (t.status === 'pending') {
                                                var c = t;
                                                ((c.status = 'rejected'), (c.reason = o));
                                            }
                                        }
                                    ));
                            }
                            switch (t.status) {
                                case 'fulfilled':
                                    return t.value;
                                case 'rejected':
                                    throw ((e = t.reason), Gh(e), e);
                            }
                            throw ((js = t), (Vc = !0), ks);
                    }
                }
                function Uh() {
                    if (js === null)
                        throw Error(
                            'Expected a suspended thenable. This is a bug in React. Please file an issue.'
                        );
                    var e = js;
                    return ((js = null), (Vc = !1), e);
                }
                function Gh(e) {
                    if (e === ks || e === jc)
                        throw Error(
                            "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
                        );
                }
                function sd(e) {
                    e.updateQueue = {
                        baseState: e.memoizedState,
                        firstBaseUpdate: null,
                        lastBaseUpdate: null,
                        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
                        callbacks: null,
                    };
                }
                function rd(e, t) {
                    ((e = e.updateQueue),
                        t.updateQueue === e &&
                        (t.updateQueue = {
                            baseState: e.baseState,
                            firstBaseUpdate: e.firstBaseUpdate,
                            lastBaseUpdate: e.lastBaseUpdate,
                            shared: e.shared,
                            callbacks: null,
                        }));
                }
                function Ka(e) {
                    return {
                        lane: e,
                        tag: xv,
                        payload: null,
                        callback: null,
                        next: null,
                    };
                }
                function ei(e, t, n) {
                    var a = e.updateQueue;
                    if (a === null) return null;
                    if (((a = a.shared), vm === a && !Ev)) {
                        var o = K(e);
                        (console.error(
                            `An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.

Please update the following component: %s`,
                            o
                        ),
                            (Ev = !0));
                    }
                    return (Pe & Wt) !== mn
                        ? ((o = a.pending),
                            o === null ? (t.next = t) : ((t.next = o.next), (o.next = t)),
                            (a.pending = t),
                            (t = wr(e)),
                            Eh(e, null, n),
                            t)
                        : (Nr(e, a, t, n), wr(e));
                }
                function Wo(e, t, n) {
                    if (
                        ((t = t.updateQueue),
                            t !== null && ((t = t.shared), (n & 4194048) !== 0))
                    ) {
                        var a = t.lanes;
                        ((a &= e.pendingLanes), (n |= a), (t.lanes = n), fr(e, n));
                    }
                }
                function kr(e, t) {
                    var n = e.updateQueue,
                        a = e.alternate;
                    if (a !== null && ((a = a.updateQueue), n === a)) {
                        var o = null,
                            c = null;
                        if (((n = n.firstBaseUpdate), n !== null)) {
                            do {
                                var f = {
                                    lane: n.lane,
                                    tag: n.tag,
                                    payload: n.payload,
                                    callback: null,
                                    next: null,
                                };
                                (c === null ? (o = c = f) : (c = c.next = f), (n = n.next));
                            } while (n !== null);
                            c === null ? (o = c = t) : (c = c.next = t);
                        } else o = c = t;
                        ((n = {
                            baseState: a.baseState,
                            firstBaseUpdate: o,
                            lastBaseUpdate: c,
                            shared: a.shared,
                            callbacks: a.callbacks,
                        }),
                            (e.updateQueue = n));
                        return;
                    }
                    ((e = n.lastBaseUpdate),
                        e === null ? (n.firstBaseUpdate = t) : (e.next = t),
                        (n.lastBaseUpdate = t));
                }
                function Xo() {
                    if (Sm) {
                        var e = no;
                        if (e !== null) throw e;
                    }
                }
                function Qo(e, t, n, a) {
                    Sm = !1;
                    var o = e.updateQueue;
                    ((pi = !1), (vm = o.shared));
                    var c = o.firstBaseUpdate,
                        f = o.lastBaseUpdate,
                        g = o.shared.pending;
                    if (g !== null) {
                        o.shared.pending = null;
                        var w = g,
                            A = w.next;
                        ((w.next = null), f === null ? (c = A) : (f.next = A), (f = w));
                        var V = e.alternate;
                        V !== null &&
                            ((V = V.updateQueue),
                                (g = V.lastBaseUpdate),
                                g !== f &&
                                (g === null ? (V.firstBaseUpdate = A) : (g.next = A),
                                    (V.lastBaseUpdate = w)));
                    }
                    if (c !== null) {
                        var L = o.baseState;
                        ((f = 0), (V = A = w = null), (g = c));
                        do {
                            var j = g.lane & -536870913,
                                H = j !== g.lane;
                            if (H ? (Ve & j) === j : (a & j) === j) {
                                (j !== 0 && j === Ki && (Sm = !0),
                                    V !== null &&
                                    (V = V.next =
                                    {
                                        lane: 0,
                                        tag: g.tag,
                                        payload: g.payload,
                                        callback: null,
                                        next: null,
                                    }));
                                e: {
                                    j = e;
                                    var fe = g,
                                        be = t,
                                        Ke = n;
                                    switch (fe.tag) {
                                        case Nv:
                                            if (((fe = fe.payload), typeof fe == 'function')) {
                                                eo = !0;
                                                var Le = fe.call(Ke, L, be);
                                                if (j.mode & It) {
                                                    Ie(!0);
                                                    try {
                                                        fe.call(Ke, L, be);
                                                    } finally {
                                                        Ie(!1);
                                                    }
                                                }
                                                ((eo = !1), (L = Le));
                                                break e;
                                            }
                                            L = fe;
                                            break e;
                                        case ym:
                                            j.flags = (j.flags & -65537) | 128;
                                        case xv:
                                            if (((Le = fe.payload), typeof Le == 'function')) {
                                                if (
                                                    ((eo = !0),
                                                        (fe = Le.call(Ke, L, be)),
                                                        j.mode & It)
                                                ) {
                                                    Ie(!0);
                                                    try {
                                                        Le.call(Ke, L, be);
                                                    } finally {
                                                        Ie(!1);
                                                    }
                                                }
                                                eo = !1;
                                            } else fe = Le;
                                            if (fe == null) break e;
                                            L = Me({}, L, fe);
                                            break e;
                                        case wv:
                                            pi = !0;
                                    }
                                }
                                ((j = g.callback),
                                    j !== null &&
                                    ((e.flags |= 64),
                                        H && (e.flags |= 8192),
                                        (H = o.callbacks),
                                        H === null ? (o.callbacks = [j]) : H.push(j)));
                            } else
                                ((H = {
                                    lane: j,
                                    tag: g.tag,
                                    payload: g.payload,
                                    callback: g.callback,
                                    next: null,
                                }),
                                    V === null ? ((A = V = H), (w = L)) : (V = V.next = H),
                                    (f |= j));
                            if (((g = g.next), g === null)) {
                                if (((g = o.shared.pending), g === null)) break;
                                ((H = g),
                                    (g = H.next),
                                    (H.next = null),
                                    (o.lastBaseUpdate = H),
                                    (o.shared.pending = null));
                            }
                        } while (!0);
                        (V === null && (w = L),
                            (o.baseState = w),
                            (o.firstBaseUpdate = A),
                            (o.lastBaseUpdate = V),
                            c === null && (o.shared.lanes = 0),
                            (yi |= f),
                            (e.lanes = f),
                            (e.memoizedState = L));
                    }
                    vm = null;
                }
                function _h(e, t) {
                    if (typeof e != 'function')
                        throw Error(
                            'Invalid argument passed as callback. Expected a function. Instead received: ' +
                            e
                        );
                    e.call(t);
                }
                function zS(e, t) {
                    var n = e.shared.hiddenCallbacks;
                    if (n !== null)
                        for (e.shared.hiddenCallbacks = null, e = 0; e < n.length; e++)
                            _h(n[e], t);
                }
                function Yh(e, t) {
                    var n = e.callbacks;
                    if (n !== null)
                        for (e.callbacks = null, e = 0; e < n.length; e++) _h(n[e], t);
                }
                function Ph(e, t) {
                    var n = pa;
                    (oe(zc, n, e), oe(ao, t, e), (pa = n | t.baseLanes));
                }
                function cd(e) {
                    (oe(zc, pa, e), oe(ao, ao.current, e));
                }
                function ud(e) {
                    ((pa = zc.current), X(ao, e), X(zc, e));
                }
                function je() {
                    var e = z;
                    On === null ? (On = [e]) : On.push(e);
                }
                function F() {
                    var e = z;
                    if (On !== null && (Ia++, On[Ia] !== e)) {
                        var t = K(ve);
                        if (!Av.has(t) && (Av.add(t), On !== null)) {
                            for (var n = '', a = 0; a <= Ia; a++) {
                                var o = On[a],
                                    c = a === Ia ? e : o;
                                for (o = a + 1 + '. ' + o; 30 > o.length;) o += ' ';
                                ((o +=
                                    c +
                                    `
`),
                                    (n += o));
                            }
                            console.error(
                                `React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,
                                t,
                                n
                            );
                        }
                    }
                }
                function El(e) {
                    e == null ||
                        Ot(e) ||
                        console.error(
                            '%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.',
                            z,
                            typeof e
                        );
                }
                function jr() {
                    var e = K(ve);
                    Tv.has(e) ||
                        (Tv.add(e),
                            console.error(
                                'ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.',
                                e
                            ));
                }
                function dt() {
                    throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`);
                }
                function dd(e, t) {
                    if (zs) return !1;
                    if (t === null)
                        return (
                            console.error(
                                '%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.',
                                z
                            ),
                            !1
                        );
                    e.length !== t.length &&
                        console.error(
                            `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
                            z,
                            '[' + t.join(', ') + ']',
                            '[' + e.join(', ') + ']'
                        );
                    for (var n = 0; n < t.length && n < e.length; n++)
                        if (!Yt(e[n], t[n])) return !1;
                    return !0;
                }
                function fd(e, t, n, a, o, c) {
                    ((hi = c),
                        (ve = t),
                        (On = e !== null ? e._debugHookTypes : null),
                        (Ia = -1),
                        (zs = e !== null && e.type !== t.type),
                        (Object.prototype.toString.call(n) ===
                            '[object AsyncFunction]' ||
                            Object.prototype.toString.call(n) ===
                            '[object AsyncGeneratorFunction]') &&
                        ((c = K(ve)),
                            xm.has(c) ||
                            (xm.add(c),
                                console.error(
                                    "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
                                    c === null ? 'An unknown Component' : '<' + c + '>'
                                ))),
                        (t.memoizedState = null),
                        (t.updateQueue = null),
                        (t.lanes = 0),
                        (B.H =
                            e !== null && e.memoizedState !== null
                                ? wm
                                : On !== null
                                    ? Cv
                                    : Nm),
                        (nl = c = (t.mode & It) !== et));
                    var f = Em(n, a, o);
                    if (((nl = !1), lo && (f = md(t, n, a, o)), c)) {
                        Ie(!0);
                        try {
                            f = md(t, n, a, o);
                        } finally {
                            Ie(!1);
                        }
                    }
                    return (Zh(e, t), f);
                }
                function Zh(e, t) {
                    ((t._debugHookTypes = On),
                        t.dependencies === null
                            ? La !== null &&
                            (t.dependencies = {
                                lanes: 0,
                                firstContext: null,
                                _debugThenableState: La,
                            })
                            : (t.dependencies._debugThenableState = La),
                        (B.H = Ic));
                    var n = qe !== null && qe.next !== null;
                    if (
                        ((hi = 0),
                            (On = z = bt = qe = ve = null),
                            (Ia = -1),
                            e !== null &&
                            (e.flags & 65011712) !== (t.flags & 65011712) &&
                            console.error(
                                'Internal React error: Expected static flag was missing. Please notify the React team.'
                            ),
                            (Bc = !1),
                            (Vs = 0),
                            (La = null),
                            n)
                    )
                        throw Error(
                            'Rendered fewer hooks than expected. This may be caused by an accidental early return statement.'
                        );
                    (e === null ||
                        At ||
                        ((e = e.dependencies), e !== null && Dr(e) && (At = !0)),
                        Vc ? ((Vc = !1), (e = !0)) : (e = !1),
                        e &&
                        ((t = K(t) || 'Unknown'),
                            Dv.has(t) ||
                            xm.has(t) ||
                            (Dv.add(t),
                                console.error(
                                    '`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary.'
                                ))));
                }
                function md(e, t, n, a) {
                    ve = e;
                    var o = 0;
                    do {
                        if ((lo && (La = null), (Vs = 0), (lo = !1), o >= sw))
                            throw Error(
                                'Too many re-renders. React limits the number of renders to prevent an infinite loop.'
                            );
                        if (
                            ((o += 1), (zs = !1), (bt = qe = null), e.updateQueue != null)
                        ) {
                            var c = e.updateQueue;
                            ((c.lastEffect = null),
                                (c.events = null),
                                (c.stores = null),
                                c.memoCache != null && (c.memoCache.index = 0));
                        }
                        ((Ia = -1), (B.H = Rv), (c = Em(t, n, a)));
                    } while (lo);
                    return c;
                }
                function BS() {
                    var e = B.H,
                        t = e.useState()[0];
                    return (
                        (t = typeof t.then == 'function' ? Jo(t) : t),
                        (e = e.useState()[0]),
                        (qe !== null ? qe.memoizedState : null) !== e &&
                        (ve.flags |= 1024),
                        t
                    );
                }
                function pd() {
                    var e = Lc !== 0;
                    return ((Lc = 0), e);
                }
                function hd(e, t, n) {
                    ((t.updateQueue = e.updateQueue),
                        (t.flags =
                            (t.mode & Yn) !== et
                                ? t.flags & -402655237
                                : t.flags & -2053),
                        (e.lanes &= ~n));
                }
                function gd(e) {
                    if (Bc) {
                        for (e = e.memoizedState; e !== null;) {
                            var t = e.queue;
                            (t !== null && (t.pending = null), (e = e.next));
                        }
                        Bc = !1;
                    }
                    ((hi = 0),
                        (On = bt = qe = ve = null),
                        (Ia = -1),
                        (z = null),
                        (lo = !1),
                        (Vs = Lc = 0),
                        (La = null));
                }
                function Ft() {
                    var e = {
                        memoizedState: null,
                        baseState: null,
                        baseQueue: null,
                        queue: null,
                        next: null,
                    };
                    return (
                        bt === null ? (ve.memoizedState = bt = e) : (bt = bt.next = e),
                        bt
                    );
                }
                function We() {
                    if (qe === null) {
                        var e = ve.alternate;
                        e = e !== null ? e.memoizedState : null;
                    } else e = qe.next;
                    var t = bt === null ? ve.memoizedState : bt.next;
                    if (t !== null) ((bt = t), (qe = e));
                    else {
                        if (e === null)
                            throw ve.alternate === null
                                ? Error(
                                    'Update hook called on initial render. This is likely a bug in React. Please file an issue.'
                                )
                                : Error(
                                    'Rendered more hooks than during the previous render.'
                                );
                        ((qe = e),
                            (e = {
                                memoizedState: qe.memoizedState,
                                baseState: qe.baseState,
                                baseQueue: qe.baseQueue,
                                queue: qe.queue,
                                next: null,
                            }),
                            bt === null
                                ? (ve.memoizedState = bt = e)
                                : (bt = bt.next = e));
                    }
                    return bt;
                }
                function bd() {
                    return {
                        lastEffect: null,
                        events: null,
                        stores: null,
                        memoCache: null,
                    };
                }
                function Jo(e) {
                    var t = Vs;
                    return (
                        (Vs += 1),
                        La === null && (La = Lh()),
                        (e = Hh(La, e, t)),
                        (t = ve),
                        (bt === null ? t.memoizedState : bt.next) === null &&
                        ((t = t.alternate),
                            (B.H = t !== null && t.memoizedState !== null ? wm : Nm)),
                        e
                    );
                }
                function ti(e) {
                    if (e !== null && typeof e == 'object') {
                        if (typeof e.then == 'function') return Jo(e);
                        if (e.$$typeof === la) return it(e);
                    }
                    throw Error(
                        'An unsupported type was passed to use(): ' + String(e)
                    );
                }
                function Yi(e) {
                    var t = null,
                        n = ve.updateQueue;
                    if ((n !== null && (t = n.memoCache), t == null)) {
                        var a = ve.alternate;
                        a !== null &&
                            ((a = a.updateQueue),
                                a !== null &&
                                ((a = a.memoCache),
                                    a != null &&
                                    (t = {
                                        data: a.data.map(function (o) {
                                            return o.slice();
                                        }),
                                        index: 0,
                                    })));
                    }
                    if (
                        (t == null && (t = { data: [], index: 0 }),
                            n === null && ((n = bd()), (ve.updateQueue = n)),
                            (n.memoCache = t),
                            (n = t.data[t.index]),
                            n === void 0 || zs)
                    )
                        for (n = t.data[t.index] = Array(e), a = 0; a < e; a++)
                            n[a] = Xx;
                    else
                        n.length !== e &&
                            console.error(
                                'Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.',
                                n.length,
                                e
                            );
                    return (t.index++, n);
                }
                function Gn(e, t) {
                    return typeof t == 'function' ? t(e) : t;
                }
                function yd(e, t, n) {
                    var a = Ft();
                    if (n !== void 0) {
                        var o = n(t);
                        if (nl) {
                            Ie(!0);
                            try {
                                n(t);
                            } finally {
                                Ie(!1);
                            }
                        }
                    } else o = t;
                    return (
                        (a.memoizedState = a.baseState = o),
                        (e = {
                            pending: null,
                            lanes: 0,
                            dispatch: null,
                            lastRenderedReducer: e,
                            lastRenderedState: o,
                        }),
                        (a.queue = e),
                        (e = e.dispatch = US.bind(null, ve, e)),
                        [a.memoizedState, e]
                    );
                }
                function Al(e) {
                    var t = We();
                    return vd(t, qe, e);
                }
                function vd(e, t, n) {
                    var a = e.queue;
                    if (a === null)
                        throw Error(
                            'Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)'
                        );
                    a.lastRenderedReducer = n;
                    var o = e.baseQueue,
                        c = a.pending;
                    if (c !== null) {
                        if (o !== null) {
                            var f = o.next;
                            ((o.next = c.next), (c.next = f));
                        }
                        (t.baseQueue !== o &&
                            console.error(
                                'Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.'
                            ),
                            (t.baseQueue = o = c),
                            (a.pending = null));
                    }
                    if (((c = e.baseState), o === null)) e.memoizedState = c;
                    else {
                        t = o.next;
                        var g = (f = null),
                            w = null,
                            A = t,
                            V = !1;
                        do {
                            var L = A.lane & -536870913;
                            if (L !== A.lane ? (Ve & L) === L : (hi & L) === L) {
                                var j = A.revertLane;
                                if (j === 0)
                                    (w !== null &&
                                        (w = w.next =
                                        {
                                            lane: 0,
                                            revertLane: 0,
                                            action: A.action,
                                            hasEagerState: A.hasEagerState,
                                            eagerState: A.eagerState,
                                            next: null,
                                        }),
                                        L === Ki && (V = !0));
                                else if ((hi & j) === j) {
                                    ((A = A.next), j === Ki && (V = !0));
                                    continue;
                                } else
                                    ((L = {
                                        lane: 0,
                                        revertLane: A.revertLane,
                                        action: A.action,
                                        hasEagerState: A.hasEagerState,
                                        eagerState: A.eagerState,
                                        next: null,
                                    }),
                                        w === null ? ((g = w = L), (f = c)) : (w = w.next = L),
                                        (ve.lanes |= j),
                                        (yi |= j));
                                ((L = A.action),
                                    nl && n(c, L),
                                    (c = A.hasEagerState ? A.eagerState : n(c, L)));
                            } else
                                ((j = {
                                    lane: L,
                                    revertLane: A.revertLane,
                                    action: A.action,
                                    hasEagerState: A.hasEagerState,
                                    eagerState: A.eagerState,
                                    next: null,
                                }),
                                    w === null ? ((g = w = j), (f = c)) : (w = w.next = j),
                                    (ve.lanes |= L),
                                    (yi |= L));
                            A = A.next;
                        } while (A !== null && A !== t);
                        if (
                            (w === null ? (f = c) : (w.next = g),
                                !Yt(c, e.memoizedState) &&
                                ((At = !0), V && ((n = no), n !== null)))
                        )
                            throw n;
                        ((e.memoizedState = c),
                            (e.baseState = f),
                            (e.baseQueue = w),
                            (a.lastRenderedState = c));
                    }
                    return (
                        o === null && (a.lanes = 0),
                        [e.memoizedState, a.dispatch]
                    );
                }
                function qo(e) {
                    var t = We(),
                        n = t.queue;
                    if (n === null)
                        throw Error(
                            'Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)'
                        );
                    n.lastRenderedReducer = e;
                    var a = n.dispatch,
                        o = n.pending,
                        c = t.memoizedState;
                    if (o !== null) {
                        n.pending = null;
                        var f = (o = o.next);
                        do ((c = e(c, f.action)), (f = f.next));
                        while (f !== o);
                        (Yt(c, t.memoizedState) || (At = !0),
                            (t.memoizedState = c),
                            t.baseQueue === null && (t.baseState = c),
                            (n.lastRenderedState = c));
                    }
                    return [c, a];
                }
                function Sd(e, t, n) {
                    var a = ve,
                        o = Ft();
                    if (Ue) {
                        if (n === void 0)
                            throw Error(
                                'Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.'
                            );
                        var c = n();
                        io ||
                            c === n() ||
                            (console.error(
                                'The result of getServerSnapshot should be cached to avoid an infinite loop'
                            ),
                                (io = !0));
                    } else {
                        if (
                            ((c = t()),
                                io ||
                                ((n = t()),
                                    Yt(c, n) ||
                                    (console.error(
                                        'The result of getSnapshot should be cached to avoid an infinite loop'
                                    ),
                                        (io = !0))),
                                Fe === null)
                        )
                            throw Error(
                                'Expected a work-in-progress root. This is a bug in React. Please file an issue.'
                            );
                        (Ve & 124) !== 0 || Wh(a, t, c);
                    }
                    return (
                        (o.memoizedState = c),
                        (n = { value: c, getSnapshot: t }),
                        (o.queue = n),
                        Ir(Qh.bind(null, a, n, e), [e]),
                        (a.flags |= 2048),
                        Tl(Mn | St, Lr(), Xh.bind(null, a, n, c, t), null),
                        c
                    );
                }
                function Vr(e, t, n) {
                    var a = ve,
                        o = We(),
                        c = Ue;
                    if (c) {
                        if (n === void 0)
                            throw Error(
                                'Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.'
                            );
                        n = n();
                    } else if (((n = t()), !io)) {
                        var f = t();
                        Yt(n, f) ||
                            (console.error(
                                'The result of getSnapshot should be cached to avoid an infinite loop'
                            ),
                                (io = !0));
                    }
                    ((f = !Yt((qe || o).memoizedState, n)) &&
                        ((o.memoizedState = n), (At = !0)),
                        (o = o.queue));
                    var g = Qh.bind(null, a, o, e);
                    if (
                        (Kt(2048, St, g, [e]),
                            o.getSnapshot !== t ||
                            f ||
                            (bt !== null && bt.memoizedState.tag & Mn))
                    ) {
                        if (
                            ((a.flags |= 2048),
                                Tl(Mn | St, Lr(), Xh.bind(null, a, o, n, t), null),
                                Fe === null)
                        )
                            throw Error(
                                'Expected a work-in-progress root. This is a bug in React. Please file an issue.'
                            );
                        c || (hi & 124) !== 0 || Wh(a, t, n);
                    }
                    return n;
                }
                function Wh(e, t, n) {
                    ((e.flags |= 16384),
                        (e = { getSnapshot: t, value: n }),
                        (t = ve.updateQueue),
                        t === null
                            ? ((t = bd()), (ve.updateQueue = t), (t.stores = [e]))
                            : ((n = t.stores),
                                n === null ? (t.stores = [e]) : n.push(e)));
                }
                function Xh(e, t, n, a) {
                    ((t.value = n), (t.getSnapshot = a), Jh(t) && qh(e));
                }
                function Qh(e, t, n) {
                    return n(function () {
                        Jh(t) && qh(e);
                    });
                }
                function Jh(e) {
                    var t = e.getSnapshot;
                    e = e.value;
                    try {
                        var n = t();
                        return !Yt(e, n);
                    } catch {
                        return !0;
                    }
                }
                function qh(e) {
                    var t = $t(e, 2);
                    t !== null && ft(t, e, 2);
                }
                function xd(e) {
                    var t = Ft();
                    if (typeof e == 'function') {
                        var n = e;
                        if (((e = n()), nl)) {
                            Ie(!0);
                            try {
                                n();
                            } finally {
                                Ie(!1);
                            }
                        }
                    }
                    return (
                        (t.memoizedState = t.baseState = e),
                        (t.queue = {
                            pending: null,
                            lanes: 0,
                            dispatch: null,
                            lastRenderedReducer: Gn,
                            lastRenderedState: e,
                        }),
                        t
                    );
                }
                function Nd(e) {
                    e = xd(e);
                    var t = e.queue,
                        n = hg.bind(null, ve, t);
                    return ((t.dispatch = n), [e.memoizedState, n]);
                }
                function wd(e) {
                    var t = Ft();
                    t.memoizedState = t.baseState = e;
                    var n = {
                        pending: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: null,
                        lastRenderedState: null,
                    };
                    return (
                        (t.queue = n),
                        (t = Bd.bind(null, ve, !0, n)),
                        (n.dispatch = t),
                        [e, t]
                    );
                }
                function $h(e, t) {
                    var n = We();
                    return Fh(n, qe, e, t);
                }
                function Fh(e, t, n, a) {
                    return (
                        (e.baseState = n),
                        vd(e, qe, typeof a == 'function' ? a : Gn)
                    );
                }
                function Kh(e, t) {
                    var n = We();
                    return qe !== null
                        ? Fh(n, qe, e, t)
                        : ((n.baseState = e), [e, n.queue.dispatch]);
                }
                function LS(e, t, n, a, o) {
                    if (_r(e))
                        throw Error('Cannot update form state while rendering.');
                    if (((e = t.action), e !== null)) {
                        var c = {
                            payload: o,
                            action: e,
                            next: null,
                            isTransition: !0,
                            status: 'pending',
                            value: null,
                            reason: null,
                            listeners: [],
                            then: function (f) {
                                c.listeners.push(f);
                            },
                        };
                        (B.T !== null ? n(!0) : (c.isTransition = !1),
                            a(c),
                            (n = t.pending),
                            n === null
                                ? ((c.next = t.pending = c), eg(t, c))
                                : ((c.next = n.next), (t.pending = n.next = c)));
                    }
                }
                function eg(e, t) {
                    var n = t.action,
                        a = t.payload,
                        o = e.state;
                    if (t.isTransition) {
                        var c = B.T,
                            f = {};
                        ((B.T = f), (B.T._updatedFibers = new Set()));
                        try {
                            var g = n(o, a),
                                w = B.S;
                            (w !== null && w(f, g), tg(e, t, g));
                        } catch (A) {
                            Ed(e, t, A);
                        } finally {
                            ((B.T = c),
                                c === null &&
                                f._updatedFibers &&
                                ((e = f._updatedFibers.size),
                                    f._updatedFibers.clear(),
                                    10 < e &&
                                    console.warn(
                                        'Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.'
                                    )));
                        }
                    } else
                        try {
                            ((f = n(o, a)), tg(e, t, f));
                        } catch (A) {
                            Ed(e, t, A);
                        }
                }
                function tg(e, t, n) {
                    n !== null && typeof n == 'object' && typeof n.then == 'function'
                        ? (n.then(
                            function (a) {
                                ng(e, t, a);
                            },
                            function (a) {
                                return Ed(e, t, a);
                            }
                        ),
                            t.isTransition ||
                            console.error(
                                'An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop.'
                            ))
                        : ng(e, t, n);
                }
                function ng(e, t, n) {
                    ((t.status = 'fulfilled'),
                        (t.value = n),
                        ag(t),
                        (e.state = n),
                        (t = e.pending),
                        t !== null &&
                        ((n = t.next),
                            n === t
                                ? (e.pending = null)
                                : ((n = n.next), (t.next = n), eg(e, n))));
                }
                function Ed(e, t, n) {
                    var a = e.pending;
                    if (((e.pending = null), a !== null)) {
                        a = a.next;
                        do
                            ((t.status = 'rejected'),
                                (t.reason = n),
                                ag(t),
                                (t = t.next));
                        while (t !== a);
                    }
                    e.action = null;
                }
                function ag(e) {
                    e = e.listeners;
                    for (var t = 0; t < e.length; t++) (0, e[t])();
                }
                function ig(e, t) {
                    return t;
                }
                function Dl(e, t) {
                    if (Ue) {
                        var n = Fe.formState;
                        if (n !== null) {
                            e: {
                                var a = ve;
                                if (Ue) {
                                    if (st) {
                                        t: {
                                            for (var o = st, c = da; o.nodeType !== 8;) {
                                                if (!c) {
                                                    o = null;
                                                    break t;
                                                }
                                                if (((o = Nn(o.nextSibling)), o === null)) {
                                                    o = null;
                                                    break t;
                                                }
                                            }
                                            ((c = o.data), (o = c === qm || c === T1 ? o : null));
                                        }
                                        if (o) {
                                            ((st = Nn(o.nextSibling)), (a = o.data === qm));
                                            break e;
                                        }
                                    }
                                    Ui(a);
                                }
                                a = !1;
                            }
                            a && (t = n[0]);
                        }
                    }
                    return (
                        (n = Ft()),
                        (n.memoizedState = n.baseState = t),
                        (a = {
                            pending: null,
                            lanes: 0,
                            dispatch: null,
                            lastRenderedReducer: ig,
                            lastRenderedState: t,
                        }),
                        (n.queue = a),
                        (n = hg.bind(null, ve, a)),
                        (a.dispatch = n),
                        (a = xd(!1)),
                        (c = Bd.bind(null, ve, !1, a.queue)),
                        (a = Ft()),
                        (o = { state: t, dispatch: null, action: e, pending: null }),
                        (a.queue = o),
                        (n = LS.bind(null, ve, o, c, n)),
                        (o.dispatch = n),
                        (a.memoizedState = e),
                        [t, n, !1]
                    );
                }
                function zr(e) {
                    var t = We();
                    return lg(t, qe, e);
                }
                function lg(e, t, n) {
                    if (
                        ((t = vd(e, t, ig)[0]),
                            (e = Al(Gn)[0]),
                            typeof t == 'object' &&
                            t !== null &&
                            typeof t.then == 'function')
                    )
                        try {
                            var a = Jo(t);
                        } catch (f) {
                            throw f === ks ? jc : f;
                        }
                    else a = t;
                    t = We();
                    var o = t.queue,
                        c = o.dispatch;
                    return (
                        n !== t.memoizedState &&
                        ((ve.flags |= 2048),
                            Tl(Mn | St, Lr(), IS.bind(null, o, n), null)),
                        [a, c, e]
                    );
                }
                function IS(e, t) {
                    e.action = t;
                }
                function Br(e) {
                    var t = We(),
                        n = qe;
                    if (n !== null) return lg(t, n, e);
                    (We(), (t = t.memoizedState), (n = We()));
                    var a = n.queue.dispatch;
                    return ((n.memoizedState = e), [t, a, !1]);
                }
                function Tl(e, t, n, a) {
                    return (
                        (e = { tag: e, create: n, deps: a, inst: t, next: null }),
                        (t = ve.updateQueue),
                        t === null && ((t = bd()), (ve.updateQueue = t)),
                        (n = t.lastEffect),
                        n === null
                            ? (t.lastEffect = e.next = e)
                            : ((a = n.next),
                                (n.next = e),
                                (e.next = a),
                                (t.lastEffect = e)),
                        e
                    );
                }
                function Lr() {
                    return { destroy: void 0, resource: void 0 };
                }
                function Ad(e) {
                    var t = Ft();
                    return ((e = { current: e }), (t.memoizedState = e));
                }
                function Pi(e, t, n, a) {
                    var o = Ft();
                    ((a = a === void 0 ? null : a),
                        (ve.flags |= e),
                        (o.memoizedState = Tl(Mn | t, Lr(), n, a)));
                }
                function Kt(e, t, n, a) {
                    var o = We();
                    a = a === void 0 ? null : a;
                    var c = o.memoizedState.inst;
                    qe !== null && a !== null && dd(a, qe.memoizedState.deps)
                        ? (o.memoizedState = Tl(t, c, n, a))
                        : ((ve.flags |= e), (o.memoizedState = Tl(Mn | t, c, n, a)));
                }
                function Ir(e, t) {
                    (ve.mode & Yn) !== et && (ve.mode & fv) === et
                        ? Pi(276826112, St, e, t)
                        : Pi(8390656, St, e, t);
                }
                function Dd(e, t) {
                    var n = 4194308;
                    return (
                        (ve.mode & Yn) !== et && (n |= 134217728),
                        Pi(n, jt, e, t)
                    );
                }
                function og(e, t) {
                    if (typeof t == 'function') {
                        e = e();
                        var n = t(e);
                        return function () {
                            typeof n == 'function' ? n() : t(null);
                        };
                    }
                    if (t != null)
                        return (
                            t.hasOwnProperty('current') ||
                            console.error(
                                'Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.',
                                'an object with keys {' + Object.keys(t).join(', ') + '}'
                            ),
                            (e = e()),
                            (t.current = e),
                            function () {
                                t.current = null;
                            }
                        );
                }
                function Td(e, t, n) {
                    (typeof t != 'function' &&
                        console.error(
                            'Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.',
                            t !== null ? typeof t : 'null'
                        ),
                        (n = n != null ? n.concat([e]) : null));
                    var a = 4194308;
                    ((ve.mode & Yn) !== et && (a |= 134217728),
                        Pi(a, jt, og.bind(null, t, e), n));
                }
                function Hr(e, t, n) {
                    (typeof t != 'function' &&
                        console.error(
                            'Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.',
                            t !== null ? typeof t : 'null'
                        ),
                        (n = n != null ? n.concat([e]) : null),
                        Kt(4, jt, og.bind(null, t, e), n));
                }
                function Cd(e, t) {
                    return ((Ft().memoizedState = [e, t === void 0 ? null : t]), e);
                }
                function Ur(e, t) {
                    var n = We();
                    t = t === void 0 ? null : t;
                    var a = n.memoizedState;
                    return t !== null && dd(t, a[1])
                        ? a[0]
                        : ((n.memoizedState = [e, t]), e);
                }
                function Rd(e, t) {
                    var n = Ft();
                    t = t === void 0 ? null : t;
                    var a = e();
                    if (nl) {
                        Ie(!0);
                        try {
                            e();
                        } finally {
                            Ie(!1);
                        }
                    }
                    return ((n.memoizedState = [a, t]), a);
                }
                function Gr(e, t) {
                    var n = We();
                    t = t === void 0 ? null : t;
                    var a = n.memoizedState;
                    if (t !== null && dd(t, a[1])) return a[0];
                    if (((a = e()), nl)) {
                        Ie(!0);
                        try {
                            e();
                        } finally {
                            Ie(!1);
                        }
                    }
                    return ((n.memoizedState = [a, t]), a);
                }
                function Md(e, t) {
                    var n = Ft();
                    return Od(n, e, t);
                }
                function sg(e, t) {
                    var n = We();
                    return cg(n, qe.memoizedState, e, t);
                }
                function rg(e, t) {
                    var n = We();
                    return qe === null ? Od(n, e, t) : cg(n, qe.memoizedState, e, t);
                }
                function Od(e, t, n) {
                    return n === void 0 || (hi & 1073741824) !== 0
                        ? (e.memoizedState = t)
                        : ((e.memoizedState = n),
                            (e = ub()),
                            (ve.lanes |= e),
                            (yi |= e),
                            n);
                }
                function cg(e, t, n, a) {
                    return Yt(n, t)
                        ? n
                        : ao.current !== null
                            ? ((e = Od(e, n, a)), Yt(e, t) || (At = !0), e)
                            : (hi & 42) === 0
                                ? ((At = !0), (e.memoizedState = n))
                                : ((e = ub()), (ve.lanes |= e), (yi |= e), t);
                }
                function ug(e, t, n, a, o) {
                    var c = Ye.p;
                    Ye.p = c !== 0 && c < ra ? c : ra;
                    var f = B.T,
                        g = {};
                    ((B.T = g), Bd(e, !1, t, n), (g._updatedFibers = new Set()));
                    try {
                        var w = o(),
                            A = B.S;
                        if (
                            (A !== null && A(g, w),
                                w !== null &&
                                typeof w == 'object' &&
                                typeof w.then == 'function')
                        ) {
                            var V = VS(w, a);
                            $o(e, t, V, un(e));
                        } else $o(e, t, a, un(e));
                    } catch (L) {
                        $o(
                            e,
                            t,
                            { then: function () { }, status: 'rejected', reason: L },
                            un(e)
                        );
                    } finally {
                        ((Ye.p = c),
                            (B.T = f),
                            f === null &&
                            g._updatedFibers &&
                            ((e = g._updatedFibers.size),
                                g._updatedFibers.clear(),
                                10 < e &&
                                console.warn(
                                    'Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.'
                                )));
                    }
                }
                function kd(e, t, n, a) {
                    if (e.tag !== 5)
                        throw Error(
                            'Expected the form instance to be a HostComponent. This is a bug in React.'
                        );
                    var o = dg(e).queue;
                    ug(
                        e,
                        o,
                        t,
                        ml,
                        n === null
                            ? E
                            : function () {
                                return (fg(e), n(a));
                            }
                    );
                }
                function dg(e) {
                    var t = e.memoizedState;
                    if (t !== null) return t;
                    t = {
                        memoizedState: ml,
                        baseState: ml,
                        baseQueue: null,
                        queue: {
                            pending: null,
                            lanes: 0,
                            dispatch: null,
                            lastRenderedReducer: Gn,
                            lastRenderedState: ml,
                        },
                        next: null,
                    };
                    var n = {};
                    return (
                        (t.next = {
                            memoizedState: n,
                            baseState: n,
                            baseQueue: null,
                            queue: {
                                pending: null,
                                lanes: 0,
                                dispatch: null,
                                lastRenderedReducer: Gn,
                                lastRenderedState: n,
                            },
                            next: null,
                        }),
                        (e.memoizedState = t),
                        (e = e.alternate),
                        e !== null && (e.memoizedState = t),
                        t
                    );
                }
                function fg(e) {
                    B.T === null &&
                        console.error(
                            'requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition.'
                        );
                    var t = dg(e).next.queue;
                    $o(e, t, {}, un(e));
                }
                function jd() {
                    var e = xd(!1);
                    return (
                        (e = ug.bind(null, ve, e.queue, !0, !1)),
                        (Ft().memoizedState = e),
                        [!1, e]
                    );
                }
                function mg() {
                    var e = Al(Gn)[0],
                        t = We().memoizedState;
                    return [typeof e == 'boolean' ? e : Jo(e), t];
                }
                function pg() {
                    var e = qo(Gn)[0],
                        t = We().memoizedState;
                    return [typeof e == 'boolean' ? e : Jo(e), t];
                }
                function Zi() {
                    return it(Fs);
                }
                function Vd() {
                    var e = Ft(),
                        t = Fe.identifierPrefix;
                    if (Ue) {
                        var n = za,
                            a = Va;
                        ((n = (a & ~(1 << (32 - Gt(a) - 1))).toString(32) + n),
                            (t = '«' + t + 'R' + n),
                            (n = Lc++),
                            0 < n && (t += 'H' + n.toString(32)),
                            (t += '»'));
                    } else ((n = ow++), (t = '«' + t + 'r' + n.toString(32) + '»'));
                    return (e.memoizedState = t);
                }
                function zd() {
                    return (Ft().memoizedState = HS.bind(null, ve));
                }
                function HS(e, t) {
                    for (var n = e.return; n !== null;) {
                        switch (n.tag) {
                            case 24:
                            case 3:
                                var a = un(n);
                                e = Ka(a);
                                var o = ei(n, e, a);
                                (o !== null && (ft(o, n, a), Wo(o, n, a)),
                                    (n = ad()),
                                    t != null &&
                                    o !== null &&
                                    console.error(
                                        'The seed argument is not enabled outside experimental channels.'
                                    ),
                                    (e.payload = { cache: n }));
                                return;
                        }
                        n = n.return;
                    }
                }
                function US(e, t, n) {
                    var a = arguments;
                    (typeof a[3] == 'function' &&
                        console.error(
                            "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
                        ),
                        (a = un(e)));
                    var o = {
                        lane: a,
                        revertLane: 0,
                        action: n,
                        hasEagerState: !1,
                        eagerState: null,
                        next: null,
                    };
                    (_r(e)
                        ? gg(t, o)
                        : ((o = Zu(e, t, o, a)),
                            o !== null && (ft(o, e, a), bg(o, t, a))),
                        Xa(e, a));
                }
                function hg(e, t, n) {
                    var a = arguments;
                    (typeof a[3] == 'function' &&
                        console.error(
                            "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
                        ),
                        (a = un(e)),
                        $o(e, t, n, a),
                        Xa(e, a));
                }
                function $o(e, t, n, a) {
                    var o = {
                        lane: a,
                        revertLane: 0,
                        action: n,
                        hasEagerState: !1,
                        eagerState: null,
                        next: null,
                    };
                    if (_r(e)) gg(t, o);
                    else {
                        var c = e.alternate;
                        if (
                            e.lanes === 0 &&
                            (c === null || c.lanes === 0) &&
                            ((c = t.lastRenderedReducer), c !== null)
                        ) {
                            var f = B.H;
                            B.H = Zn;
                            try {
                                var g = t.lastRenderedState,
                                    w = c(g, n);
                                if (((o.hasEagerState = !0), (o.eagerState = w), Yt(w, g)))
                                    return (Nr(e, t, o, 0), Fe === null && xr(), !1);
                            } catch {
                            } finally {
                                B.H = f;
                            }
                        }
                        if (((n = Zu(e, t, o, a)), n !== null))
                            return (ft(n, e, a), bg(n, t, a), !0);
                    }
                    return !1;
                }
                function Bd(e, t, n, a) {
                    if (
                        (B.T === null &&
                            Ki === 0 &&
                            console.error(
                                'An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition.'
                            ),
                            (a = {
                                lane: 2,
                                revertLane: pf(),
                                action: a,
                                hasEagerState: !1,
                                eagerState: null,
                                next: null,
                            }),
                            _r(e))
                    ) {
                        if (t)
                            throw Error(
                                'Cannot update optimistic state while rendering.'
                            );
                        console.error('Cannot call startTransition while rendering.');
                    } else ((t = Zu(e, n, a, 2)), t !== null && ft(t, e, 2));
                    Xa(e, 2);
                }
                function _r(e) {
                    var t = e.alternate;
                    return e === ve || (t !== null && t === ve);
                }
                function gg(e, t) {
                    lo = Bc = !0;
                    var n = e.pending;
                    (n === null ? (t.next = t) : ((t.next = n.next), (n.next = t)),
                        (e.pending = t));
                }
                function bg(e, t, n) {
                    if ((n & 4194048) !== 0) {
                        var a = t.lanes;
                        ((a &= e.pendingLanes), (n |= a), (t.lanes = n), fr(e, n));
                    }
                }
                function Ct(e) {
                    var t = Ce;
                    return (e != null && (Ce = t === null ? e : t.concat(e)), t);
                }
                function Yr(e, t, n) {
                    for (var a = Object.keys(e.props), o = 0; o < a.length; o++) {
                        var c = a[o];
                        if (c !== 'children' && c !== 'key') {
                            (t === null &&
                                ((t = Er(e, n.mode, 0)),
                                    (t._debugInfo = Ce),
                                    (t.return = n)),
                                he(
                                    t,
                                    function (f) {
                                        console.error(
                                            'Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.',
                                            f
                                        );
                                    },
                                    c
                                ));
                            break;
                        }
                    }
                }
                function Pr(e) {
                    var t = Bs;
                    return ((Bs += 1), oo === null && (oo = Lh()), Hh(oo, e, t));
                }
                function Fo(e, t) {
                    ((t = t.props.ref), (e.ref = t !== void 0 ? t : null));
                }
                function Zr(e, t) {
                    throw t.$$typeof === Zx
                        ? Error(`A React Element from an older version of React was rendered. This is not supported. It can happen if:
- Multiple copies of the "react" package is used.
- A library pre-bundled an old copy of "react" or "react/jsx-runtime".
- A compiler tries to "inline" JSX instead of using the runtime.`)
                        : ((e = Object.prototype.toString.call(t)),
                            Error(
                                'Objects are not valid as a React child (found: ' +
                                (e === '[object Object]'
                                    ? 'object with keys {' + Object.keys(t).join(', ') + '}'
                                    : e) +
                                '). If you meant to render a collection of children, use an array instead.'
                            ));
                }
                function Wr(e, t) {
                    var n = K(e) || 'Component';
                    Pv[n] ||
                        ((Pv[n] = !0),
                            (t = t.displayName || t.name || 'Component'),
                            e.tag === 3
                                ? console.error(
                                    `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  root.render(%s)`,
                                    t,
                                    t,
                                    t
                                )
                                : console.error(
                                    `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  <%s>{%s}</%s>`,
                                    t,
                                    t,
                                    n,
                                    t,
                                    n
                                ));
                }
                function Xr(e, t) {
                    var n = K(e) || 'Component';
                    Zv[n] ||
                        ((Zv[n] = !0),
                            (t = String(t)),
                            e.tag === 3
                                ? console.error(
                                    `Symbols are not valid as a React child.
  root.render(%s)`,
                                    t
                                )
                                : console.error(
                                    `Symbols are not valid as a React child.
  <%s>%s</%s>`,
                                    n,
                                    t,
                                    n
                                ));
                }
                function yg(e) {
                    function t(T, C) {
                        if (e) {
                            var R = T.deletions;
                            R === null
                                ? ((T.deletions = [C]), (T.flags |= 16))
                                : R.push(C);
                        }
                    }
                    function n(T, C) {
                        if (!e) return null;
                        for (; C !== null;) (t(T, C), (C = C.sibling));
                        return null;
                    }
                    function a(T) {
                        for (var C = new Map(); T !== null;)
                            (T.key !== null ? C.set(T.key, T) : C.set(T.index, T),
                                (T = T.sibling));
                        return C;
                    }
                    function o(T, C) {
                        return ((T = xa(T, C)), (T.index = 0), (T.sibling = null), T);
                    }
                    function c(T, C, R) {
                        return (
                            (T.index = R),
                            e
                                ? ((R = T.alternate),
                                    R !== null
                                        ? ((R = R.index),
                                            R < C ? ((T.flags |= 67108866), C) : R)
                                        : ((T.flags |= 67108866), C))
                                : ((T.flags |= 1048576), C)
                        );
                    }
                    function f(T) {
                        return (e && T.alternate === null && (T.flags |= 67108866), T);
                    }
                    function g(T, C, R, G) {
                        return C === null || C.tag !== 6
                            ? ((C = qu(R, T.mode, G)),
                                (C.return = T),
                                (C._debugOwner = T),
                                (C._debugTask = T._debugTask),
                                (C._debugInfo = Ce),
                                C)
                            : ((C = o(C, R)), (C.return = T), (C._debugInfo = Ce), C);
                    }
                    function w(T, C, R, G) {
                        var ae = R.type;
                        return ae === Il
                            ? ((C = V(T, C, R.props.children, G, R.key)), Yr(R, C, T), C)
                            : C !== null &&
                                (C.elementType === ae ||
                                    Ah(C, R) ||
                                    (typeof ae == 'object' &&
                                        ae !== null &&
                                        ae.$$typeof === dn &&
                                        gi(ae) === C.type))
                                ? ((C = o(C, R.props)),
                                    Fo(C, R),
                                    (C.return = T),
                                    (C._debugOwner = R._owner),
                                    (C._debugInfo = Ce),
                                    C)
                                : ((C = Er(R, T.mode, G)),
                                    Fo(C, R),
                                    (C.return = T),
                                    (C._debugInfo = Ce),
                                    C);
                    }
                    function A(T, C, R, G) {
                        return C === null ||
                            C.tag !== 4 ||
                            C.stateNode.containerInfo !== R.containerInfo ||
                            C.stateNode.implementation !== R.implementation
                            ? ((C = $u(R, T.mode, G)),
                                (C.return = T),
                                (C._debugInfo = Ce),
                                C)
                            : ((C = o(C, R.children || [])),
                                (C.return = T),
                                (C._debugInfo = Ce),
                                C);
                    }
                    function V(T, C, R, G, ae) {
                        return C === null || C.tag !== 7
                            ? ((C = Bi(R, T.mode, G, ae)),
                                (C.return = T),
                                (C._debugOwner = T),
                                (C._debugTask = T._debugTask),
                                (C._debugInfo = Ce),
                                C)
                            : ((C = o(C, R)), (C.return = T), (C._debugInfo = Ce), C);
                    }
                    function L(T, C, R) {
                        if (
                            (typeof C == 'string' && C !== '') ||
                            typeof C == 'number' ||
                            typeof C == 'bigint'
                        )
                            return (
                                (C = qu('' + C, T.mode, R)),
                                (C.return = T),
                                (C._debugOwner = T),
                                (C._debugTask = T._debugTask),
                                (C._debugInfo = Ce),
                                C
                            );
                        if (typeof C == 'object' && C !== null) {
                            switch (C.$$typeof) {
                                case si:
                                    return (
                                        (R = Er(C, T.mode, R)),
                                        Fo(R, C),
                                        (R.return = T),
                                        (T = Ct(C._debugInfo)),
                                        (R._debugInfo = Ce),
                                        (Ce = T),
                                        R
                                    );
                                case Ll:
                                    return (
                                        (C = $u(C, T.mode, R)),
                                        (C.return = T),
                                        (C._debugInfo = Ce),
                                        C
                                    );
                                case dn:
                                    var G = Ct(C._debugInfo);
                                    return ((C = gi(C)), (T = L(T, C, R)), (Ce = G), T);
                            }
                            if (Ot(C) || le(C))
                                return (
                                    (R = Bi(C, T.mode, R, null)),
                                    (R.return = T),
                                    (R._debugOwner = T),
                                    (R._debugTask = T._debugTask),
                                    (T = Ct(C._debugInfo)),
                                    (R._debugInfo = Ce),
                                    (Ce = T),
                                    R
                                );
                            if (typeof C.then == 'function')
                                return (
                                    (G = Ct(C._debugInfo)),
                                    (T = L(T, Pr(C), R)),
                                    (Ce = G),
                                    T
                                );
                            if (C.$$typeof === la) return L(T, Tr(T, C), R);
                            Zr(T, C);
                        }
                        return (
                            typeof C == 'function' && Wr(T, C),
                            typeof C == 'symbol' && Xr(T, C),
                            null
                        );
                    }
                    function j(T, C, R, G) {
                        var ae = C !== null ? C.key : null;
                        if (
                            (typeof R == 'string' && R !== '') ||
                            typeof R == 'number' ||
                            typeof R == 'bigint'
                        )
                            return ae !== null ? null : g(T, C, '' + R, G);
                        if (typeof R == 'object' && R !== null) {
                            switch (R.$$typeof) {
                                case si:
                                    return R.key === ae
                                        ? ((ae = Ct(R._debugInfo)),
                                            (T = w(T, C, R, G)),
                                            (Ce = ae),
                                            T)
                                        : null;
                                case Ll:
                                    return R.key === ae ? A(T, C, R, G) : null;
                                case dn:
                                    return (
                                        (ae = Ct(R._debugInfo)),
                                        (R = gi(R)),
                                        (T = j(T, C, R, G)),
                                        (Ce = ae),
                                        T
                                    );
                            }
                            if (Ot(R) || le(R))
                                return ae !== null
                                    ? null
                                    : ((ae = Ct(R._debugInfo)),
                                        (T = V(T, C, R, G, null)),
                                        (Ce = ae),
                                        T);
                            if (typeof R.then == 'function')
                                return (
                                    (ae = Ct(R._debugInfo)),
                                    (T = j(T, C, Pr(R), G)),
                                    (Ce = ae),
                                    T
                                );
                            if (R.$$typeof === la) return j(T, C, Tr(T, R), G);
                            Zr(T, R);
                        }
                        return (
                            typeof R == 'function' && Wr(T, R),
                            typeof R == 'symbol' && Xr(T, R),
                            null
                        );
                    }
                    function H(T, C, R, G, ae) {
                        if (
                            (typeof G == 'string' && G !== '') ||
                            typeof G == 'number' ||
                            typeof G == 'bigint'
                        )
                            return ((T = T.get(R) || null), g(C, T, '' + G, ae));
                        if (typeof G == 'object' && G !== null) {
                            switch (G.$$typeof) {
                                case si:
                                    return (
                                        (R = T.get(G.key === null ? R : G.key) || null),
                                        (T = Ct(G._debugInfo)),
                                        (C = w(C, R, G, ae)),
                                        (Ce = T),
                                        C
                                    );
                                case Ll:
                                    return (
                                        (T = T.get(G.key === null ? R : G.key) || null),
                                        A(C, T, G, ae)
                                    );
                                case dn:
                                    var xe = Ct(G._debugInfo);
                                    return (
                                        (G = gi(G)),
                                        (C = H(T, C, R, G, ae)),
                                        (Ce = xe),
                                        C
                                    );
                            }
                            if (Ot(G) || le(G))
                                return (
                                    (R = T.get(R) || null),
                                    (T = Ct(G._debugInfo)),
                                    (C = V(C, R, G, ae, null)),
                                    (Ce = T),
                                    C
                                );
                            if (typeof G.then == 'function')
                                return (
                                    (xe = Ct(G._debugInfo)),
                                    (C = H(T, C, R, Pr(G), ae)),
                                    (Ce = xe),
                                    C
                                );
                            if (G.$$typeof === la) return H(T, C, R, Tr(C, G), ae);
                            Zr(C, G);
                        }
                        return (
                            typeof G == 'function' && Wr(C, G),
                            typeof G == 'symbol' && Xr(C, G),
                            null
                        );
                    }
                    function fe(T, C, R, G) {
                        if (typeof R != 'object' || R === null) return G;
                        switch (R.$$typeof) {
                            case si:
                            case Ll:
                                h(T, C, R);
                                var ae = R.key;
                                if (typeof ae != 'string') break;
                                if (G === null) {
                                    ((G = new Set()), G.add(ae));
                                    break;
                                }
                                if (!G.has(ae)) {
                                    G.add(ae);
                                    break;
                                }
                                he(C, function () {
                                    console.error(
                                        'Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.',
                                        ae
                                    );
                                });
                                break;
                            case dn:
                                ((R = gi(R)), fe(T, C, R, G));
                        }
                        return G;
                    }
                    function be(T, C, R, G) {
                        for (
                            var ae = null,
                            xe = null,
                            de = null,
                            Ne = C,
                            Ae = (C = 0),
                            tt = null;
                            Ne !== null && Ae < R.length;
                            Ae++
                        ) {
                            Ne.index > Ae ? ((tt = Ne), (Ne = null)) : (tt = Ne.sibling);
                            var pt = j(T, Ne, R[Ae], G);
                            if (pt === null) {
                                Ne === null && (Ne = tt);
                                break;
                            }
                            ((ae = fe(T, pt, R[Ae], ae)),
                                e && Ne && pt.alternate === null && t(T, Ne),
                                (C = c(pt, C, Ae)),
                                de === null ? (xe = pt) : (de.sibling = pt),
                                (de = pt),
                                (Ne = tt));
                        }
                        if (Ae === R.length) return (n(T, Ne), Ue && Li(T, Ae), xe);
                        if (Ne === null) {
                            for (; Ae < R.length; Ae++)
                                ((Ne = L(T, R[Ae], G)),
                                    Ne !== null &&
                                    ((ae = fe(T, Ne, R[Ae], ae)),
                                        (C = c(Ne, C, Ae)),
                                        de === null ? (xe = Ne) : (de.sibling = Ne),
                                        (de = Ne)));
                            return (Ue && Li(T, Ae), xe);
                        }
                        for (Ne = a(Ne); Ae < R.length; Ae++)
                            ((tt = H(Ne, T, Ae, R[Ae], G)),
                                tt !== null &&
                                ((ae = fe(T, tt, R[Ae], ae)),
                                    e &&
                                    tt.alternate !== null &&
                                    Ne.delete(tt.key === null ? Ae : tt.key),
                                    (C = c(tt, C, Ae)),
                                    de === null ? (xe = tt) : (de.sibling = tt),
                                    (de = tt)));
                        return (
                            e &&
                            Ne.forEach(function (Pa) {
                                return t(T, Pa);
                            }),
                            Ue && Li(T, Ae),
                            xe
                        );
                    }
                    function Ke(T, C, R, G) {
                        if (R == null)
                            throw Error('An iterable object provided no iterator.');
                        for (
                            var ae = null,
                            xe = null,
                            de = C,
                            Ne = (C = 0),
                            Ae = null,
                            tt = null,
                            pt = R.next();
                            de !== null && !pt.done;
                            Ne++, pt = R.next()
                        ) {
                            de.index > Ne ? ((Ae = de), (de = null)) : (Ae = de.sibling);
                            var Pa = j(T, de, pt.value, G);
                            if (Pa === null) {
                                de === null && (de = Ae);
                                break;
                            }
                            ((tt = fe(T, Pa, pt.value, tt)),
                                e && de && Pa.alternate === null && t(T, de),
                                (C = c(Pa, C, Ne)),
                                xe === null ? (ae = Pa) : (xe.sibling = Pa),
                                (xe = Pa),
                                (de = Ae));
                        }
                        if (pt.done) return (n(T, de), Ue && Li(T, Ne), ae);
                        if (de === null) {
                            for (; !pt.done; Ne++, pt = R.next())
                                ((de = L(T, pt.value, G)),
                                    de !== null &&
                                    ((tt = fe(T, de, pt.value, tt)),
                                        (C = c(de, C, Ne)),
                                        xe === null ? (ae = de) : (xe.sibling = de),
                                        (xe = de)));
                            return (Ue && Li(T, Ne), ae);
                        }
                        for (de = a(de); !pt.done; Ne++, pt = R.next())
                            ((Ae = H(de, T, Ne, pt.value, G)),
                                Ae !== null &&
                                ((tt = fe(T, Ae, pt.value, tt)),
                                    e &&
                                    Ae.alternate !== null &&
                                    de.delete(Ae.key === null ? Ne : Ae.key),
                                    (C = c(Ae, C, Ne)),
                                    xe === null ? (ae = Ae) : (xe.sibling = Ae),
                                    (xe = Ae)));
                        return (
                            e &&
                            de.forEach(function (jw) {
                                return t(T, jw);
                            }),
                            Ue && Li(T, Ne),
                            ae
                        );
                    }
                    function Le(T, C, R, G) {
                        if (
                            (typeof R == 'object' &&
                                R !== null &&
                                R.type === Il &&
                                R.key === null &&
                                (Yr(R, null, T), (R = R.props.children)),
                                typeof R == 'object' && R !== null)
                        ) {
                            switch (R.$$typeof) {
                                case si:
                                    var ae = Ct(R._debugInfo);
                                    e: {
                                        for (var xe = R.key; C !== null;) {
                                            if (C.key === xe) {
                                                if (((xe = R.type), xe === Il)) {
                                                    if (C.tag === 7) {
                                                        (n(T, C.sibling),
                                                            (G = o(C, R.props.children)),
                                                            (G.return = T),
                                                            (G._debugOwner = R._owner),
                                                            (G._debugInfo = Ce),
                                                            Yr(R, G, T),
                                                            (T = G));
                                                        break e;
                                                    }
                                                } else if (
                                                    C.elementType === xe ||
                                                    Ah(C, R) ||
                                                    (typeof xe == 'object' &&
                                                        xe !== null &&
                                                        xe.$$typeof === dn &&
                                                        gi(xe) === C.type)
                                                ) {
                                                    (n(T, C.sibling),
                                                        (G = o(C, R.props)),
                                                        Fo(G, R),
                                                        (G.return = T),
                                                        (G._debugOwner = R._owner),
                                                        (G._debugInfo = Ce),
                                                        (T = G));
                                                    break e;
                                                }
                                                n(T, C);
                                                break;
                                            } else t(T, C);
                                            C = C.sibling;
                                        }
                                        R.type === Il
                                            ? ((G = Bi(R.props.children, T.mode, G, R.key)),
                                                (G.return = T),
                                                (G._debugOwner = T),
                                                (G._debugTask = T._debugTask),
                                                (G._debugInfo = Ce),
                                                Yr(R, G, T),
                                                (T = G))
                                            : ((G = Er(R, T.mode, G)),
                                                Fo(G, R),
                                                (G.return = T),
                                                (G._debugInfo = Ce),
                                                (T = G));
                                    }
                                    return ((T = f(T)), (Ce = ae), T);
                                case Ll:
                                    e: {
                                        for (ae = R, R = ae.key; C !== null;) {
                                            if (C.key === R)
                                                if (
                                                    C.tag === 4 &&
                                                    C.stateNode.containerInfo === ae.containerInfo &&
                                                    C.stateNode.implementation === ae.implementation
                                                ) {
                                                    (n(T, C.sibling),
                                                        (G = o(C, ae.children || [])),
                                                        (G.return = T),
                                                        (T = G));
                                                    break e;
                                                } else {
                                                    n(T, C);
                                                    break;
                                                }
                                            else t(T, C);
                                            C = C.sibling;
                                        }
                                        ((G = $u(ae, T.mode, G)), (G.return = T), (T = G));
                                    }
                                    return f(T);
                                case dn:
                                    return (
                                        (ae = Ct(R._debugInfo)),
                                        (R = gi(R)),
                                        (T = Le(T, C, R, G)),
                                        (Ce = ae),
                                        T
                                    );
                            }
                            if (Ot(R))
                                return (
                                    (ae = Ct(R._debugInfo)),
                                    (T = be(T, C, R, G)),
                                    (Ce = ae),
                                    T
                                );
                            if (le(R)) {
                                if (
                                    ((ae = Ct(R._debugInfo)),
                                        (xe = le(R)),
                                        typeof xe != 'function')
                                )
                                    throw Error(
                                        'An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.'
                                    );
                                var de = xe.call(R);
                                return (
                                    de === R
                                        ? (T.tag !== 0 ||
                                            Object.prototype.toString.call(T.type) !==
                                            '[object GeneratorFunction]' ||
                                            Object.prototype.toString.call(de) !==
                                            '[object Generator]') &&
                                        (_v ||
                                            console.error(
                                                'Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items.'
                                            ),
                                            (_v = !0))
                                        : R.entries !== xe ||
                                        Dm ||
                                        (console.error(
                                            'Using Maps as children is not supported. Use an array of keyed ReactElements instead.'
                                        ),
                                            (Dm = !0)),
                                    (T = Ke(T, C, de, G)),
                                    (Ce = ae),
                                    T
                                );
                            }
                            if (typeof R.then == 'function')
                                return (
                                    (ae = Ct(R._debugInfo)),
                                    (T = Le(T, C, Pr(R), G)),
                                    (Ce = ae),
                                    T
                                );
                            if (R.$$typeof === la) return Le(T, C, Tr(T, R), G);
                            Zr(T, R);
                        }
                        return (typeof R == 'string' && R !== '') ||
                            typeof R == 'number' ||
                            typeof R == 'bigint'
                            ? ((ae = '' + R),
                                C !== null && C.tag === 6
                                    ? (n(T, C.sibling),
                                        (G = o(C, ae)),
                                        (G.return = T),
                                        (T = G))
                                    : (n(T, C),
                                        (G = qu(ae, T.mode, G)),
                                        (G.return = T),
                                        (G._debugOwner = T),
                                        (G._debugTask = T._debugTask),
                                        (G._debugInfo = Ce),
                                        (T = G)),
                                f(T))
                            : (typeof R == 'function' && Wr(T, R),
                                typeof R == 'symbol' && Xr(T, R),
                                n(T, C));
                    }
                    return function (T, C, R, G) {
                        var ae = Ce;
                        Ce = null;
                        try {
                            Bs = 0;
                            var xe = Le(T, C, R, G);
                            return ((oo = null), xe);
                        } catch (tt) {
                            if (tt === ks || tt === jc) throw tt;
                            var de = N(29, tt, null, T.mode);
                            ((de.lanes = G), (de.return = T));
                            var Ne = (de._debugInfo = Ce);
                            if (
                                ((de._debugOwner = T._debugOwner),
                                    (de._debugTask = T._debugTask),
                                    Ne != null)
                            ) {
                                for (var Ae = Ne.length - 1; 0 <= Ae; Ae--)
                                    if (typeof Ne[Ae].stack == 'string') {
                                        ((de._debugOwner = Ne[Ae]),
                                            (de._debugTask = Ne[Ae].debugTask));
                                        break;
                                    }
                            }
                            return de;
                        } finally {
                            Ce = ae;
                        }
                    };
                }
                function ni(e) {
                    var t = e.alternate;
                    (oe(xt, xt.current & ro, e),
                        oe(kn, e, e),
                        ma === null &&
                        (t === null ||
                            ao.current !== null ||
                            t.memoizedState !== null) &&
                        (ma = e));
                }
                function vg(e) {
                    if (e.tag === 22) {
                        if ((oe(xt, xt.current, e), oe(kn, e, e), ma === null)) {
                            var t = e.alternate;
                            t !== null && t.memoizedState !== null && (ma = e);
                        }
                    } else ai(e);
                }
                function ai(e) {
                    (oe(xt, xt.current, e), oe(kn, kn.current, e));
                }
                function Ea(e) {
                    (X(kn, e), ma === e && (ma = null), X(xt, e));
                }
                function Qr(e) {
                    for (var t = e; t !== null;) {
                        if (t.tag === 13) {
                            var n = t.memoizedState;
                            if (
                                n !== null &&
                                ((n = n.dehydrated), n === null || n.data === Ga || Af(n))
                            )
                                return t;
                        } else if (
                            t.tag === 19 &&
                            t.memoizedProps.revealOrder !== void 0
                        ) {
                            if ((t.flags & 128) !== 0) return t;
                        } else if (t.child !== null) {
                            ((t.child.return = t), (t = t.child));
                            continue;
                        }
                        if (t === e) break;
                        for (; t.sibling === null;) {
                            if (t.return === null || t.return === e) return null;
                            t = t.return;
                        }
                        ((t.sibling.return = t.return), (t = t.sibling));
                    }
                    return null;
                }
                function Ld(e) {
                    if (e !== null && typeof e != 'function') {
                        var t = String(e);
                        a1.has(t) ||
                            (a1.add(t),
                                console.error(
                                    'Expected the last optional `callback` argument to be a function. Instead received: %s.',
                                    e
                                ));
                    }
                }
                function Id(e, t, n, a) {
                    var o = e.memoizedState,
                        c = n(a, o);
                    if (e.mode & It) {
                        Ie(!0);
                        try {
                            c = n(a, o);
                        } finally {
                            Ie(!1);
                        }
                    }
                    (c === void 0 &&
                        ((t = q(t) || 'Component'),
                            Kv.has(t) ||
                            (Kv.add(t),
                                console.error(
                                    '%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.',
                                    t
                                ))),
                        (o = c == null ? o : Me({}, o, c)),
                        (e.memoizedState = o),
                        e.lanes === 0 && (e.updateQueue.baseState = o));
                }
                function Sg(e, t, n, a, o, c, f) {
                    var g = e.stateNode;
                    if (typeof g.shouldComponentUpdate == 'function') {
                        if (((n = g.shouldComponentUpdate(a, c, f)), e.mode & It)) {
                            Ie(!0);
                            try {
                                n = g.shouldComponentUpdate(a, c, f);
                            } finally {
                                Ie(!1);
                            }
                        }
                        return (
                            n === void 0 &&
                            console.error(
                                '%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.',
                                q(t) || 'Component'
                            ),
                            n
                        );
                    }
                    return t.prototype && t.prototype.isPureReactComponent
                        ? !Ho(n, a) || !Ho(o, c)
                        : !0;
                }
                function xg(e, t, n, a) {
                    var o = t.state;
                    (typeof t.componentWillReceiveProps == 'function' &&
                        t.componentWillReceiveProps(n, a),
                        typeof t.UNSAFE_componentWillReceiveProps == 'function' &&
                        t.UNSAFE_componentWillReceiveProps(n, a),
                        t.state !== o &&
                        ((e = K(e) || 'Component'),
                            Qv.has(e) ||
                            (Qv.add(e),
                                console.error(
                                    "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
                                    e
                                )),
                            Tm.enqueueReplaceState(t, t.state, null)));
                }
                function Wi(e, t) {
                    var n = t;
                    if ('ref' in t) {
                        n = {};
                        for (var a in t) a !== 'ref' && (n[a] = t[a]);
                    }
                    if ((e = e.defaultProps)) {
                        n === t && (n = Me({}, n));
                        for (var o in e) n[o] === void 0 && (n[o] = e[o]);
                    }
                    return n;
                }
                function Ng(e) {
                    (Cm(e),
                        console.warn(
                            `%s

%s
`,
                            co
                                ? 'An error occurred in the <' + co + '> component.'
                                : 'An error occurred in one of your React components.',
                            `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://react.dev/link/error-boundaries to learn more about error boundaries.`
                        ));
                }
                function wg(e) {
                    var t = co
                        ? 'The above error occurred in the <' + co + '> component.'
                        : 'The above error occurred in one of your React components.',
                        n =
                            'React will try to recreate this component tree from scratch using the error boundary you provided, ' +
                            ((Rm || 'Anonymous') + '.');
                    if (
                        typeof e == 'object' &&
                        e !== null &&
                        typeof e.environmentName == 'string'
                    ) {
                        var a = e.environmentName;
                        ((e = [
                            `%o

%s

%s
`,
                            e,
                            t,
                            n,
                        ].slice(0)),
                            typeof e[0] == 'string'
                                ? e.splice(0, 1, z1 + e[0], B1, au + a + au, L1)
                                : e.splice(0, 0, z1, B1, au + a + au, L1),
                            e.unshift(console),
                            (a = Ow.apply(console.error, e)),
                            a());
                    } else
                        console.error(
                            `%o

%s

%s
`,
                            e,
                            t,
                            n
                        );
                }
                function Eg(e) {
                    Cm(e);
                }
                function Jr(e, t) {
                    try {
                        ((co = t.source ? K(t.source) : null), (Rm = null));
                        var n = t.value;
                        if (B.actQueue !== null) B.thrownErrors.push(n);
                        else {
                            var a = e.onUncaughtError;
                            a(n, { componentStack: t.stack });
                        }
                    } catch (o) {
                        setTimeout(function () {
                            throw o;
                        });
                    }
                }
                function Ag(e, t, n) {
                    try {
                        ((co = n.source ? K(n.source) : null), (Rm = K(t)));
                        var a = e.onCaughtError;
                        a(n.value, {
                            componentStack: n.stack,
                            errorBoundary: t.tag === 1 ? t.stateNode : null,
                        });
                    } catch (o) {
                        setTimeout(function () {
                            throw o;
                        });
                    }
                }
                function Hd(e, t, n) {
                    return (
                        (n = Ka(n)),
                        (n.tag = ym),
                        (n.payload = { element: null }),
                        (n.callback = function () {
                            he(t.source, Jr, e, t);
                        }),
                        n
                    );
                }
                function Ud(e) {
                    return ((e = Ka(e)), (e.tag = ym), e);
                }
                function Gd(e, t, n, a) {
                    var o = n.type.getDerivedStateFromError;
                    if (typeof o == 'function') {
                        var c = a.value;
                        ((e.payload = function () {
                            return o(c);
                        }),
                            (e.callback = function () {
                                (Dh(n), he(a.source, Ag, t, n, a));
                            }));
                    }
                    var f = n.stateNode;
                    f !== null &&
                        typeof f.componentDidCatch == 'function' &&
                        (e.callback = function () {
                            (Dh(n),
                                he(a.source, Ag, t, n, a),
                                typeof o != 'function' &&
                                (Si === null ? (Si = new Set([this])) : Si.add(this)),
                                rw(this, a),
                                typeof o == 'function' ||
                                ((n.lanes & 2) === 0 &&
                                    console.error(
                                        '%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.',
                                        K(n) || 'Unknown'
                                    )));
                        });
                }
                function GS(e, t, n, a, o) {
                    if (
                        ((n.flags |= 32768),
                            _n && ls(e, o),
                            a !== null &&
                            typeof a == 'object' &&
                            typeof a.then == 'function')
                    ) {
                        if (
                            ((t = n.alternate),
                                t !== null && Yo(t, n, o, !0),
                                Ue && (Ba = !0),
                                (n = kn.current),
                                n !== null)
                        ) {
                            switch (n.tag) {
                                case 13:
                                    return (
                                        ma === null
                                            ? sf()
                                            : n.alternate === null && rt === Ua && (rt = jm),
                                        (n.flags &= -257),
                                        (n.flags |= 65536),
                                        (n.lanes = o),
                                        a === bm
                                            ? (n.flags |= 16384)
                                            : ((t = n.updateQueue),
                                                t === null
                                                    ? (n.updateQueue = new Set([a]))
                                                    : t.add(a),
                                                uf(e, a, o)),
                                        !1
                                    );
                                case 22:
                                    return (
                                        (n.flags |= 65536),
                                        a === bm
                                            ? (n.flags |= 16384)
                                            : ((t = n.updateQueue),
                                                t === null
                                                    ? ((t = {
                                                        transitions: null,
                                                        markerInstances: null,
                                                        retryQueue: new Set([a]),
                                                    }),
                                                        (n.updateQueue = t))
                                                    : ((n = t.retryQueue),
                                                        n === null
                                                            ? (t.retryQueue = new Set([a]))
                                                            : n.add(a)),
                                                uf(e, a, o)),
                                        !1
                                    );
                            }
                            throw Error(
                                'Unexpected Suspense handler tag (' +
                                n.tag +
                                '). This is a bug in React.'
                            );
                        }
                        return (uf(e, a, o), sf(), !1);
                    }
                    if (Ue)
                        return (
                            (Ba = !0),
                            (t = kn.current),
                            t !== null
                                ? ((t.flags & 65536) === 0 && (t.flags |= 256),
                                    (t.flags |= 65536),
                                    (t.lanes = o),
                                    a !== mm &&
                                    _o(
                                        sn(
                                            Error(
                                                'There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.',
                                                { cause: a }
                                            ),
                                            n
                                        )
                                    ))
                                : (a !== mm &&
                                    _o(
                                        sn(
                                            Error(
                                                'There was an error while hydrating but React was able to recover by instead client rendering the entire root.',
                                                { cause: a }
                                            ),
                                            n
                                        )
                                    ),
                                    (e = e.current.alternate),
                                    (e.flags |= 65536),
                                    (o &= -o),
                                    (e.lanes |= o),
                                    (a = sn(a, n)),
                                    (o = Hd(e.stateNode, a, o)),
                                    kr(e, o),
                                    rt !== al && (rt = po)),
                            !1
                        );
                    var c = sn(
                        Error(
                            'There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.',
                            { cause: a }
                        ),
                        n
                    );
                    if (
                        (Ps === null ? (Ps = [c]) : Ps.push(c),
                            rt !== al && (rt = po),
                            t === null)
                    )
                        return !0;
                    ((a = sn(a, n)), (n = t));
                    do {
                        switch (n.tag) {
                            case 3:
                                return (
                                    (n.flags |= 65536),
                                    (e = o & -o),
                                    (n.lanes |= e),
                                    (e = Hd(n.stateNode, a, e)),
                                    kr(n, e),
                                    !1
                                );
                            case 1:
                                if (
                                    ((t = n.type),
                                        (c = n.stateNode),
                                        (n.flags & 128) === 0 &&
                                        (typeof t.getDerivedStateFromError == 'function' ||
                                            (c !== null &&
                                                typeof c.componentDidCatch == 'function' &&
                                                (Si === null || !Si.has(c)))))
                                )
                                    return (
                                        (n.flags |= 65536),
                                        (o &= -o),
                                        (n.lanes |= o),
                                        (o = Ud(o)),
                                        Gd(o, e, n, a),
                                        kr(n, o),
                                        !1
                                    );
                        }
                        n = n.return;
                    } while (n !== null);
                    return !1;
                }
                function Rt(e, t, n, a) {
                    t.child = e === null ? Wv(t, null, n, a) : so(t, e.child, n, a);
                }
                function Dg(e, t, n, a, o) {
                    n = n.render;
                    var c = t.ref;
                    if ('ref' in a) {
                        var f = {};
                        for (var g in a) g !== 'ref' && (f[g] = a[g]);
                    } else f = a;
                    return (
                        Gi(t),
                        Tt(t),
                        (a = fd(e, t, n, f, c, o)),
                        (g = pd()),
                        bn(),
                        e !== null && !At
                            ? (hd(e, t, o), Aa(e, t, o))
                            : (Ue && g && Fu(t), (t.flags |= 1), Rt(e, t, a, o), t.child)
                    );
                }
                function Tg(e, t, n, a, o) {
                    if (e === null) {
                        var c = n.type;
                        return typeof c == 'function' &&
                            !Qu(c) &&
                            c.defaultProps === void 0 &&
                            n.compare === null
                            ? ((n = zi(c)),
                                (t.tag = 15),
                                (t.type = n),
                                Yd(t, c),
                                Cg(e, t, n, a, o))
                            : ((e = Ju(n.type, null, a, t, t.mode, o)),
                                (e.ref = t.ref),
                                (e.return = t),
                                (t.child = e));
                    }
                    if (((c = e.child), !Jd(e, o))) {
                        var f = c.memoizedProps;
                        if (
                            ((n = n.compare),
                                (n = n !== null ? n : Ho),
                                n(f, a) && e.ref === t.ref)
                        )
                            return Aa(e, t, o);
                    }
                    return (
                        (t.flags |= 1),
                        (e = xa(c, a)),
                        (e.ref = t.ref),
                        (e.return = t),
                        (t.child = e)
                    );
                }
                function Cg(e, t, n, a, o) {
                    if (e !== null) {
                        var c = e.memoizedProps;
                        if (Ho(c, a) && e.ref === t.ref && t.type === e.type)
                            if (((At = !1), (t.pendingProps = a = c), Jd(e, o)))
                                (e.flags & 131072) !== 0 && (At = !0);
                            else return ((t.lanes = e.lanes), Aa(e, t, o));
                    }
                    return _d(e, t, n, a, o);
                }
                function Rg(e, t, n) {
                    var a = t.pendingProps,
                        o = a.children,
                        c = e !== null ? e.memoizedState : null;
                    if (a.mode === 'hidden') {
                        if ((t.flags & 128) !== 0) {
                            if (((a = c !== null ? c.baseLanes | n : n), e !== null)) {
                                for (o = t.child = e.child, c = 0; o !== null;)
                                    ((c = c | o.lanes | o.childLanes), (o = o.sibling));
                                t.childLanes = c & ~a;
                            } else ((t.childLanes = 0), (t.child = null));
                            return Mg(e, t, a, n);
                        }
                        if ((n & 536870912) !== 0)
                            ((t.memoizedState = { baseLanes: 0, cachePool: null }),
                                e !== null && Mr(t, c !== null ? c.cachePool : null),
                                c !== null ? Ph(t, c) : cd(t),
                                vg(t));
                        else
                            return (
                                (t.lanes = t.childLanes = 536870912),
                                Mg(e, t, c !== null ? c.baseLanes | n : n, n)
                            );
                    } else
                        c !== null
                            ? (Mr(t, c.cachePool),
                                Ph(t, c),
                                ai(t),
                                (t.memoizedState = null))
                            : (e !== null && Mr(t, null), cd(t), ai(t));
                    return (Rt(e, t, o, n), t.child);
                }
                function Mg(e, t, n, a) {
                    var o = od();
                    return (
                        (o = o === null ? null : { parent: vt._currentValue, pool: o }),
                        (t.memoizedState = { baseLanes: n, cachePool: o }),
                        e !== null && Mr(t, null),
                        cd(t),
                        vg(t),
                        e !== null && Yo(e, t, a, !0),
                        null
                    );
                }
                function qr(e, t) {
                    var n = t.ref;
                    if (n === null)
                        e !== null && e.ref !== null && (t.flags |= 4194816);
                    else {
                        if (typeof n != 'function' && typeof n != 'object')
                            throw Error(
                                'Expected ref to be a function, an object returned by React.createRef(), or undefined/null.'
                            );
                        (e === null || e.ref !== n) && (t.flags |= 4194816);
                    }
                }
                function _d(e, t, n, a, o) {
                    if (n.prototype && typeof n.prototype.render == 'function') {
                        var c = q(n) || 'Unknown';
                        l1[c] ||
                            (console.error(
                                "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
                                c,
                                c
                            ),
                                (l1[c] = !0));
                    }
                    return (
                        t.mode & It && Pn.recordLegacyContextWarning(t, null),
                        e === null &&
                        (Yd(t, t.type),
                            n.contextTypes &&
                            ((c = q(n) || 'Unknown'),
                                s1[c] ||
                                ((s1[c] = !0),
                                    console.error(
                                        '%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)',
                                        c
                                    )))),
                        Gi(t),
                        Tt(t),
                        (n = fd(e, t, n, a, void 0, o)),
                        (a = pd()),
                        bn(),
                        e !== null && !At
                            ? (hd(e, t, o), Aa(e, t, o))
                            : (Ue && a && Fu(t), (t.flags |= 1), Rt(e, t, n, o), t.child)
                    );
                }
                function Og(e, t, n, a, o, c) {
                    return (
                        Gi(t),
                        Tt(t),
                        (Ia = -1),
                        (zs = e !== null && e.type !== t.type),
                        (t.updateQueue = null),
                        (n = md(t, a, n, o)),
                        Zh(e, t),
                        (a = pd()),
                        bn(),
                        e !== null && !At
                            ? (hd(e, t, c), Aa(e, t, c))
                            : (Ue && a && Fu(t), (t.flags |= 1), Rt(e, t, n, c), t.child)
                    );
                }
                function kg(e, t, n, a, o) {
                    switch (p(t)) {
                        case !1:
                            var c = t.stateNode,
                                f = new t.type(t.memoizedProps, c.context).state;
                            c.updater.enqueueSetState(c, f, null);
                            break;
                        case !0:
                            ((t.flags |= 128),
                                (t.flags |= 65536),
                                (c = Error('Simulated error coming from DevTools')));
                            var g = o & -o;
                            if (((t.lanes |= g), (f = Fe), f === null))
                                throw Error(
                                    'Expected a work-in-progress root. This is a bug in React. Please file an issue.'
                                );
                            ((g = Ud(g)), Gd(g, f, t, sn(c, t)), kr(t, g));
                    }
                    if ((Gi(t), t.stateNode === null)) {
                        if (
                            ((f = mi),
                                (c = n.contextType),
                                'contextType' in n &&
                                c !== null &&
                                (c === void 0 || c.$$typeof !== la) &&
                                !n1.has(n) &&
                                (n1.add(n),
                                    (g =
                                        c === void 0
                                            ? ' However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.'
                                            : typeof c != 'object'
                                                ? ' However, it is set to a ' + typeof c + '.'
                                                : c.$$typeof === Lf
                                                    ? ' Did you accidentally pass the Context.Consumer instead?'
                                                    : ' However, it is set to an object with keys {' +
                                                    Object.keys(c).join(', ') +
                                                    '}.'),
                                    console.error(
                                        '%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s',
                                        q(n) || 'Component',
                                        g
                                    )),
                                typeof c == 'object' && c !== null && (f = it(c)),
                                (c = new n(a, f)),
                                t.mode & It)
                        ) {
                            Ie(!0);
                            try {
                                c = new n(a, f);
                            } finally {
                                Ie(!1);
                            }
                        }
                        if (
                            ((f = t.memoizedState =
                                c.state !== null && c.state !== void 0 ? c.state : null),
                                (c.updater = Tm),
                                (t.stateNode = c),
                                (c._reactInternals = t),
                                (c._reactInternalInstance = Xv),
                                typeof n.getDerivedStateFromProps == 'function' &&
                                f === null &&
                                ((f = q(n) || 'Component'),
                                    Jv.has(f) ||
                                    (Jv.add(f),
                                        console.error(
                                            '`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.',
                                            f,
                                            c.state === null ? 'null' : 'undefined',
                                            f
                                        ))),
                                typeof n.getDerivedStateFromProps == 'function' ||
                                typeof c.getSnapshotBeforeUpdate == 'function')
                        ) {
                            var w = (g = f = null);
                            if (
                                (typeof c.componentWillMount == 'function' &&
                                    c.componentWillMount.__suppressDeprecationWarning !== !0
                                    ? (f = 'componentWillMount')
                                    : typeof c.UNSAFE_componentWillMount == 'function' &&
                                    (f = 'UNSAFE_componentWillMount'),
                                    typeof c.componentWillReceiveProps == 'function' &&
                                        c.componentWillReceiveProps.__suppressDeprecationWarning !==
                                        !0
                                        ? (g = 'componentWillReceiveProps')
                                        : typeof c.UNSAFE_componentWillReceiveProps ==
                                        'function' &&
                                        (g = 'UNSAFE_componentWillReceiveProps'),
                                    typeof c.componentWillUpdate == 'function' &&
                                        c.componentWillUpdate.__suppressDeprecationWarning !== !0
                                        ? (w = 'componentWillUpdate')
                                        : typeof c.UNSAFE_componentWillUpdate == 'function' &&
                                        (w = 'UNSAFE_componentWillUpdate'),
                                    f !== null || g !== null || w !== null)
                            ) {
                                c = q(n) || 'Component';
                                var A =
                                    typeof n.getDerivedStateFromProps == 'function'
                                        ? 'getDerivedStateFromProps()'
                                        : 'getSnapshotBeforeUpdate()';
                                $v.has(c) ||
                                    ($v.add(c),
                                        console.error(
                                            `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`,
                                            c,
                                            A,
                                            f !== null
                                                ? `
  ` + f
                                                : '',
                                            g !== null
                                                ? `
  ` + g
                                                : '',
                                            w !== null
                                                ? `
  ` + w
                                                : ''
                                        ));
                            }
                        }
                        ((c = t.stateNode),
                            (f = q(n) || 'Component'),
                            c.render ||
                            (n.prototype && typeof n.prototype.render == 'function'
                                ? console.error(
                                    'No `render` method found on the %s instance: did you accidentally return an object from the constructor?',
                                    f
                                )
                                : console.error(
                                    'No `render` method found on the %s instance: you may have forgotten to define `render`.',
                                    f
                                )),
                            !c.getInitialState ||
                            c.getInitialState.isReactClassApproved ||
                            c.state ||
                            console.error(
                                'getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?',
                                f
                            ),
                            c.getDefaultProps &&
                            !c.getDefaultProps.isReactClassApproved &&
                            console.error(
                                'getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.',
                                f
                            ),
                            c.contextType &&
                            console.error(
                                'contextType was defined as an instance property on %s. Use a static property to define contextType instead.',
                                f
                            ),
                            n.childContextTypes &&
                            !t1.has(n) &&
                            (t1.add(n),
                                console.error(
                                    '%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)',
                                    f
                                )),
                            n.contextTypes &&
                            !e1.has(n) &&
                            (e1.add(n),
                                console.error(
                                    '%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)',
                                    f
                                )),
                            typeof c.componentShouldUpdate == 'function' &&
                            console.error(
                                '%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.',
                                f
                            ),
                            n.prototype &&
                            n.prototype.isPureReactComponent &&
                            typeof c.shouldComponentUpdate < 'u' &&
                            console.error(
                                '%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.',
                                q(n) || 'A pure component'
                            ),
                            typeof c.componentDidUnmount == 'function' &&
                            console.error(
                                '%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?',
                                f
                            ),
                            typeof c.componentDidReceiveProps == 'function' &&
                            console.error(
                                '%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().',
                                f
                            ),
                            typeof c.componentWillRecieveProps == 'function' &&
                            console.error(
                                '%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
                                f
                            ),
                            typeof c.UNSAFE_componentWillRecieveProps == 'function' &&
                            console.error(
                                '%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?',
                                f
                            ),
                            (g = c.props !== a),
                            c.props !== void 0 &&
                            g &&
                            console.error(
                                "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
                                f
                            ),
                            c.defaultProps &&
                            console.error(
                                'Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.',
                                f,
                                f
                            ),
                            typeof c.getSnapshotBeforeUpdate != 'function' ||
                            typeof c.componentDidUpdate == 'function' ||
                            qv.has(n) ||
                            (qv.add(n),
                                console.error(
                                    '%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.',
                                    q(n)
                                )),
                            typeof c.getDerivedStateFromProps == 'function' &&
                            console.error(
                                '%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.',
                                f
                            ),
                            typeof c.getDerivedStateFromError == 'function' &&
                            console.error(
                                '%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.',
                                f
                            ),
                            typeof n.getSnapshotBeforeUpdate == 'function' &&
                            console.error(
                                '%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.',
                                f
                            ),
                            (g = c.state) &&
                            (typeof g != 'object' || Ot(g)) &&
                            console.error(
                                '%s.state: must be set to an object or null',
                                f
                            ),
                            typeof c.getChildContext == 'function' &&
                            typeof n.childContextTypes != 'object' &&
                            console.error(
                                '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().',
                                f
                            ),
                            (c = t.stateNode),
                            (c.props = a),
                            (c.state = t.memoizedState),
                            (c.refs = {}),
                            sd(t),
                            (f = n.contextType),
                            (c.context = typeof f == 'object' && f !== null ? it(f) : mi),
                            c.state === a &&
                            ((f = q(n) || 'Component'),
                                Fv.has(f) ||
                                (Fv.add(f),
                                    console.error(
                                        "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
                                        f
                                    ))),
                            t.mode & It && Pn.recordLegacyContextWarning(t, c),
                            Pn.recordUnsafeLifecycleWarnings(t, c),
                            (c.state = t.memoizedState),
                            (f = n.getDerivedStateFromProps),
                            typeof f == 'function' &&
                            (Id(t, n, f, a), (c.state = t.memoizedState)),
                            typeof n.getDerivedStateFromProps == 'function' ||
                            typeof c.getSnapshotBeforeUpdate == 'function' ||
                            (typeof c.UNSAFE_componentWillMount != 'function' &&
                                typeof c.componentWillMount != 'function') ||
                            ((f = c.state),
                                typeof c.componentWillMount == 'function' &&
                                c.componentWillMount(),
                                typeof c.UNSAFE_componentWillMount == 'function' &&
                                c.UNSAFE_componentWillMount(),
                                f !== c.state &&
                                (console.error(
                                    "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
                                    K(t) || 'Component'
                                ),
                                    Tm.enqueueReplaceState(c, c.state, null)),
                                Qo(t, a, c, o),
                                Xo(),
                                (c.state = t.memoizedState)),
                            typeof c.componentDidMount == 'function' &&
                            (t.flags |= 4194308),
                            (t.mode & Yn) !== et && (t.flags |= 134217728),
                            (c = !0));
                    } else if (e === null) {
                        c = t.stateNode;
                        var V = t.memoizedProps;
                        ((g = Wi(n, V)), (c.props = g));
                        var L = c.context;
                        ((w = n.contextType),
                            (f = mi),
                            typeof w == 'object' && w !== null && (f = it(w)),
                            (A = n.getDerivedStateFromProps),
                            (w =
                                typeof A == 'function' ||
                                typeof c.getSnapshotBeforeUpdate == 'function'),
                            (V = t.pendingProps !== V),
                            w ||
                            (typeof c.UNSAFE_componentWillReceiveProps != 'function' &&
                                typeof c.componentWillReceiveProps != 'function') ||
                            ((V || L !== f) && xg(t, c, a, f)),
                            (pi = !1));
                        var j = t.memoizedState;
                        ((c.state = j),
                            Qo(t, a, c, o),
                            Xo(),
                            (L = t.memoizedState),
                            V || j !== L || pi
                                ? (typeof A == 'function' &&
                                    (Id(t, n, A, a), (L = t.memoizedState)),
                                    (g = pi || Sg(t, n, g, a, j, L, f))
                                        ? (w ||
                                            (typeof c.UNSAFE_componentWillMount != 'function' &&
                                                typeof c.componentWillMount != 'function') ||
                                            (typeof c.componentWillMount == 'function' &&
                                                c.componentWillMount(),
                                                typeof c.UNSAFE_componentWillMount == 'function' &&
                                                c.UNSAFE_componentWillMount()),
                                            typeof c.componentDidMount == 'function' &&
                                            (t.flags |= 4194308),
                                            (t.mode & Yn) !== et && (t.flags |= 134217728))
                                        : (typeof c.componentDidMount == 'function' &&
                                            (t.flags |= 4194308),
                                            (t.mode & Yn) !== et && (t.flags |= 134217728),
                                            (t.memoizedProps = a),
                                            (t.memoizedState = L)),
                                    (c.props = a),
                                    (c.state = L),
                                    (c.context = f),
                                    (c = g))
                                : (typeof c.componentDidMount == 'function' &&
                                    (t.flags |= 4194308),
                                    (t.mode & Yn) !== et && (t.flags |= 134217728),
                                    (c = !1)));
                    } else {
                        ((c = t.stateNode),
                            rd(e, t),
                            (f = t.memoizedProps),
                            (w = Wi(n, f)),
                            (c.props = w),
                            (A = t.pendingProps),
                            (j = c.context),
                            (L = n.contextType),
                            (g = mi),
                            typeof L == 'object' && L !== null && (g = it(L)),
                            (V = n.getDerivedStateFromProps),
                            (L =
                                typeof V == 'function' ||
                                typeof c.getSnapshotBeforeUpdate == 'function') ||
                            (typeof c.UNSAFE_componentWillReceiveProps != 'function' &&
                                typeof c.componentWillReceiveProps != 'function') ||
                            ((f !== A || j !== g) && xg(t, c, a, g)),
                            (pi = !1),
                            (j = t.memoizedState),
                            (c.state = j),
                            Qo(t, a, c, o),
                            Xo());
                        var H = t.memoizedState;
                        f !== A ||
                            j !== H ||
                            pi ||
                            (e !== null && e.dependencies !== null && Dr(e.dependencies))
                            ? (typeof V == 'function' &&
                                (Id(t, n, V, a), (H = t.memoizedState)),
                                (w =
                                    pi ||
                                    Sg(t, n, w, a, j, H, g) ||
                                    (e !== null &&
                                        e.dependencies !== null &&
                                        Dr(e.dependencies)))
                                    ? (L ||
                                        (typeof c.UNSAFE_componentWillUpdate != 'function' &&
                                            typeof c.componentWillUpdate != 'function') ||
                                        (typeof c.componentWillUpdate == 'function' &&
                                            c.componentWillUpdate(a, H, g),
                                            typeof c.UNSAFE_componentWillUpdate == 'function' &&
                                            c.UNSAFE_componentWillUpdate(a, H, g)),
                                        typeof c.componentDidUpdate == 'function' &&
                                        (t.flags |= 4),
                                        typeof c.getSnapshotBeforeUpdate == 'function' &&
                                        (t.flags |= 1024))
                                    : (typeof c.componentDidUpdate != 'function' ||
                                        (f === e.memoizedProps && j === e.memoizedState) ||
                                        (t.flags |= 4),
                                        typeof c.getSnapshotBeforeUpdate != 'function' ||
                                        (f === e.memoizedProps && j === e.memoizedState) ||
                                        (t.flags |= 1024),
                                        (t.memoizedProps = a),
                                        (t.memoizedState = H)),
                                (c.props = a),
                                (c.state = H),
                                (c.context = g),
                                (c = w))
                            : (typeof c.componentDidUpdate != 'function' ||
                                (f === e.memoizedProps && j === e.memoizedState) ||
                                (t.flags |= 4),
                                typeof c.getSnapshotBeforeUpdate != 'function' ||
                                (f === e.memoizedProps && j === e.memoizedState) ||
                                (t.flags |= 1024),
                                (c = !1));
                    }
                    if (((g = c), qr(e, t), (f = (t.flags & 128) !== 0), g || f)) {
                        if (
                            ((g = t.stateNode),
                                Vu(t),
                                f && typeof n.getDerivedStateFromError != 'function')
                        )
                            ((n = null), (tn = -1));
                        else {
                            if ((Tt(t), (n = kv(g)), t.mode & It)) {
                                Ie(!0);
                                try {
                                    kv(g);
                                } finally {
                                    Ie(!1);
                                }
                            }
                            bn();
                        }
                        ((t.flags |= 1),
                            e !== null && f
                                ? ((t.child = so(t, e.child, null, o)),
                                    (t.child = so(t, null, n, o)))
                                : Rt(e, t, n, o),
                            (t.memoizedState = g.state),
                            (e = t.child));
                    } else e = Aa(e, t, o);
                    return (
                        (o = t.stateNode),
                        c &&
                        o.props !== a &&
                        (uo ||
                            console.error(
                                'It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.',
                                K(t) || 'a component'
                            ),
                            (uo = !0)),
                        e
                    );
                }
                function jg(e, t, n, a) {
                    return (Go(), (t.flags |= 256), Rt(e, t, n, a), t.child);
                }
                function Yd(e, t) {
                    (t &&
                        t.childContextTypes &&
                        console.error(
                            `childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`,
                            t.displayName || t.name || 'Component'
                        ),
                        typeof t.getDerivedStateFromProps == 'function' &&
                        ((e = q(t) || 'Unknown'),
                            r1[e] ||
                            (console.error(
                                '%s: Function components do not support getDerivedStateFromProps.',
                                e
                            ),
                                (r1[e] = !0))),
                        typeof t.contextType == 'object' &&
                        t.contextType !== null &&
                        ((t = q(t) || 'Unknown'),
                            o1[t] ||
                            (console.error(
                                '%s: Function components do not support contextType.',
                                t
                            ),
                                (o1[t] = !0))));
                }
                function Pd(e) {
                    return { baseLanes: e, cachePool: Bh() };
                }
                function Zd(e, t, n) {
                    return (
                        (e = e !== null ? e.childLanes & ~n : 0),
                        t && (e |= hn),
                        e
                    );
                }
                function Vg(e, t, n) {
                    var a,
                        o = t.pendingProps;
                    d(t) && (t.flags |= 128);
                    var c = !1,
                        f = (t.flags & 128) !== 0;
                    if (
                        ((a = f) ||
                            (a =
                                e !== null && e.memoizedState === null
                                    ? !1
                                    : (xt.current & Ls) !== 0),
                            a && ((c = !0), (t.flags &= -129)),
                            (a = (t.flags & 32) !== 0),
                            (t.flags &= -33),
                            e === null)
                    ) {
                        if (Ue) {
                            if ((c ? ni(t) : ai(t), Ue)) {
                                var g = st,
                                    w;
                                if (!(w = !g)) {
                                    e: {
                                        var A = g;
                                        for (w = da; A.nodeType !== 8;) {
                                            if (!w) {
                                                w = null;
                                                break e;
                                            }
                                            if (((A = Nn(A.nextSibling)), A === null)) {
                                                w = null;
                                                break e;
                                            }
                                        }
                                        w = A;
                                    }
                                    (w !== null
                                        ? (Ii(),
                                            (t.memoizedState = {
                                                dehydrated: w,
                                                treeContext:
                                                    qi !== null ? { id: Va, overflow: za } : null,
                                                retryLane: 536870912,
                                                hydrationErrors: null,
                                            }),
                                            (A = N(18, null, null, et)),
                                            (A.stateNode = w),
                                            (A.return = t),
                                            (t.child = A),
                                            (Pt = t),
                                            (st = null),
                                            (w = !0))
                                        : (w = !1),
                                        (w = !w));
                                }
                                w && (ed(t, g), Ui(t));
                            }
                            if (
                                ((g = t.memoizedState),
                                    g !== null && ((g = g.dehydrated), g !== null))
                            )
                                return (
                                    Af(g) ? (t.lanes = 32) : (t.lanes = 536870912),
                                    null
                                );
                            Ea(t);
                        }
                        return (
                            (g = o.children),
                            (o = o.fallback),
                            c
                                ? (ai(t),
                                    (c = t.mode),
                                    (g = $r({ mode: 'hidden', children: g }, c)),
                                    (o = Bi(o, c, n, null)),
                                    (g.return = t),
                                    (o.return = t),
                                    (g.sibling = o),
                                    (t.child = g),
                                    (c = t.child),
                                    (c.memoizedState = Pd(n)),
                                    (c.childLanes = Zd(e, a, n)),
                                    (t.memoizedState = Om),
                                    o)
                                : (ni(t), Wd(t, g))
                        );
                    }
                    var V = e.memoizedState;
                    if (V !== null && ((g = V.dehydrated), g !== null)) {
                        if (f)
                            t.flags & 256
                                ? (ni(t), (t.flags &= -257), (t = Xd(e, t, n)))
                                : t.memoizedState !== null
                                    ? (ai(t),
                                        (t.child = e.child),
                                        (t.flags |= 128),
                                        (t = null))
                                    : (ai(t),
                                        (c = o.fallback),
                                        (g = t.mode),
                                        (o = $r({ mode: 'visible', children: o.children }, g)),
                                        (c = Bi(c, g, n, null)),
                                        (c.flags |= 2),
                                        (o.return = t),
                                        (c.return = t),
                                        (o.sibling = c),
                                        (t.child = o),
                                        so(t, e.child, null, n),
                                        (o = t.child),
                                        (o.memoizedState = Pd(n)),
                                        (o.childLanes = Zd(e, a, n)),
                                        (t.memoizedState = Om),
                                        (t = c));
                        else if (
                            (ni(t),
                                Ue &&
                                console.error(
                                    'We should not be hydrating here. This is a bug in React. Please file a bug.'
                                ),
                                Af(g))
                        ) {
                            if (((a = g.nextSibling && g.nextSibling.dataset), a)) {
                                w = a.dgst;
                                var L = a.msg;
                                A = a.stck;
                                var j = a.cstck;
                            }
                            ((g = L),
                                (a = w),
                                (o = A),
                                (w = c = j),
                                (c = Error(
                                    g ||
                                    'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.'
                                )),
                                (c.stack = o || ''),
                                (c.digest = a),
                                (a = w === void 0 ? null : w),
                                (o = { value: c, source: null, stack: a }),
                                typeof a == 'string' && dm.set(c, o),
                                _o(o),
                                (t = Xd(e, t, n)));
                        } else if (
                            (At || Yo(e, t, n, !1),
                                (a = (n & e.childLanes) !== 0),
                                At || a)
                        ) {
                            if (
                                ((a = Fe),
                                    a !== null &&
                                    ((o = n & -n),
                                        (o = (o & 42) !== 0 ? 1 : Ro(o)),
                                        (o = (o & (a.suspendedLanes | n)) !== 0 ? 0 : o),
                                        o !== 0 && o !== V.retryLane))
                            )
                                throw ((V.retryLane = o), $t(e, o), ft(a, e, o), i1);
                            (g.data === Ga || sf(), (t = Xd(e, t, n)));
                        } else
                            g.data === Ga
                                ? ((t.flags |= 192), (t.child = e.child), (t = null))
                                : ((e = V.treeContext),
                                    (st = Nn(g.nextSibling)),
                                    (Pt = t),
                                    (Ue = !0),
                                    ($i = null),
                                    (Ba = !1),
                                    (Cn = null),
                                    (da = !1),
                                    e !== null &&
                                    (Ii(),
                                        (Dn[Tn++] = Va),
                                        (Dn[Tn++] = za),
                                        (Dn[Tn++] = qi),
                                        (Va = e.id),
                                        (za = e.overflow),
                                        (qi = t)),
                                    (t = Wd(t, o.children)),
                                    (t.flags |= 4096));
                        return t;
                    }
                    return c
                        ? (ai(t),
                            (c = o.fallback),
                            (g = t.mode),
                            (w = e.child),
                            (A = w.sibling),
                            (o = xa(w, { mode: 'hidden', children: o.children })),
                            (o.subtreeFlags = w.subtreeFlags & 65011712),
                            A !== null
                                ? (c = xa(A, c))
                                : ((c = Bi(c, g, n, null)), (c.flags |= 2)),
                            (c.return = t),
                            (o.return = t),
                            (o.sibling = c),
                            (t.child = o),
                            (o = c),
                            (c = t.child),
                            (g = e.child.memoizedState),
                            g === null
                                ? (g = Pd(n))
                                : ((w = g.cachePool),
                                    w !== null
                                        ? ((A = vt._currentValue),
                                            (w = w.parent !== A ? { parent: A, pool: A } : w))
                                        : (w = Bh()),
                                    (g = { baseLanes: g.baseLanes | n, cachePool: w })),
                            (c.memoizedState = g),
                            (c.childLanes = Zd(e, a, n)),
                            (t.memoizedState = Om),
                            o)
                        : (ni(t),
                            (n = e.child),
                            (e = n.sibling),
                            (n = xa(n, { mode: 'visible', children: o.children })),
                            (n.return = t),
                            (n.sibling = null),
                            e !== null &&
                            ((a = t.deletions),
                                a === null
                                    ? ((t.deletions = [e]), (t.flags |= 16))
                                    : a.push(e)),
                            (t.child = n),
                            (t.memoizedState = null),
                            n);
                }
                function Wd(e, t) {
                    return (
                        (t = $r({ mode: 'visible', children: t }, e.mode)),
                        (t.return = e),
                        (e.child = t)
                    );
                }
                function $r(e, t) {
                    return (
                        (e = N(22, e, null, t)),
                        (e.lanes = 0),
                        (e.stateNode = {
                            _visibility: Ac,
                            _pendingMarkers: null,
                            _retryCache: null,
                            _transitions: null,
                        }),
                        e
                    );
                }
                function Xd(e, t, n) {
                    return (
                        so(t, e.child, null, n),
                        (e = Wd(t, t.pendingProps.children)),
                        (e.flags |= 2),
                        (t.memoizedState = null),
                        e
                    );
                }
                function zg(e, t, n) {
                    e.lanes |= t;
                    var a = e.alternate;
                    (a !== null && (a.lanes |= t), td(e.return, t, n));
                }
                function Bg(e, t) {
                    var n = Ot(e);
                    return (
                        (e = !n && typeof le(e) == 'function'),
                        n || e
                            ? ((n = n ? 'array' : 'iterable'),
                                console.error(
                                    'A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>',
                                    n,
                                    t,
                                    n
                                ),
                                !1)
                            : !0
                    );
                }
                function Qd(e, t, n, a, o) {
                    var c = e.memoizedState;
                    c === null
                        ? (e.memoizedState = {
                            isBackwards: t,
                            rendering: null,
                            renderingStartTime: 0,
                            last: a,
                            tail: n,
                            tailMode: o,
                        })
                        : ((c.isBackwards = t),
                            (c.rendering = null),
                            (c.renderingStartTime = 0),
                            (c.last = a),
                            (c.tail = n),
                            (c.tailMode = o));
                }
                function Lg(e, t, n) {
                    var a = t.pendingProps,
                        o = a.revealOrder,
                        c = a.tail;
                    if (
                        ((a = a.children),
                            o !== void 0 &&
                            o !== 'forwards' &&
                            o !== 'backwards' &&
                            o !== 'together' &&
                            !c1[o])
                    )
                        if (((c1[o] = !0), typeof o == 'string'))
                            switch (o.toLowerCase()) {
                                case 'together':
                                case 'forwards':
                                case 'backwards':
                                    console.error(
                                        '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                                        o,
                                        o.toLowerCase()
                                    );
                                    break;
                                case 'forward':
                                case 'backward':
                                    console.error(
                                        '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                                        o,
                                        o.toLowerCase()
                                    );
                                    break;
                                default:
                                    console.error(
                                        '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                                        o
                                    );
                            }
                        else
                            console.error(
                                '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                                o
                            );
                    c === void 0 ||
                        Mm[c] ||
                        (c !== 'collapsed' && c !== 'hidden'
                            ? ((Mm[c] = !0),
                                console.error(
                                    '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?',
                                    c
                                ))
                            : o !== 'forwards' &&
                            o !== 'backwards' &&
                            ((Mm[c] = !0),
                                console.error(
                                    '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
                                    c
                                )));
                    e: if (
                        (o === 'forwards' || o === 'backwards') &&
                        a !== void 0 &&
                        a !== null &&
                        a !== !1
                    )
                        if (Ot(a)) {
                            for (var f = 0; f < a.length; f++) if (!Bg(a[f], f)) break e;
                        } else if (((f = le(a)), typeof f == 'function')) {
                            if ((f = f.call(a)))
                                for (var g = f.next(), w = 0; !g.done; g = f.next()) {
                                    if (!Bg(g.value, w)) break e;
                                    w++;
                                }
                        } else
                            console.error(
                                'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
                                o
                            );
                    if ((Rt(e, t, a, n), (a = xt.current), (a & Ls) !== 0))
                        ((a = (a & ro) | Ls), (t.flags |= 128));
                    else {
                        if (e !== null && (e.flags & 128) !== 0)
                            e: for (e = t.child; e !== null;) {
                                if (e.tag === 13) e.memoizedState !== null && zg(e, n, t);
                                else if (e.tag === 19) zg(e, n, t);
                                else if (e.child !== null) {
                                    ((e.child.return = e), (e = e.child));
                                    continue;
                                }
                                if (e === t) break e;
                                for (; e.sibling === null;) {
                                    if (e.return === null || e.return === t) break e;
                                    e = e.return;
                                }
                                ((e.sibling.return = e.return), (e = e.sibling));
                            }
                        a &= ro;
                    }
                    switch ((oe(xt, a, t), o)) {
                        case 'forwards':
                            for (n = t.child, o = null; n !== null;)
                                ((e = n.alternate),
                                    e !== null && Qr(e) === null && (o = n),
                                    (n = n.sibling));
                            ((n = o),
                                n === null
                                    ? ((o = t.child), (t.child = null))
                                    : ((o = n.sibling), (n.sibling = null)),
                                Qd(t, !1, o, n, c));
                            break;
                        case 'backwards':
                            for (n = null, o = t.child, t.child = null; o !== null;) {
                                if (((e = o.alternate), e !== null && Qr(e) === null)) {
                                    t.child = o;
                                    break;
                                }
                                ((e = o.sibling), (o.sibling = n), (n = o), (o = e));
                            }
                            Qd(t, !0, n, null, c);
                            break;
                        case 'together':
                            Qd(t, !1, null, null, void 0);
                            break;
                        default:
                            t.memoizedState = null;
                    }
                    return t.child;
                }
                function Aa(e, t, n) {
                    if (
                        (e !== null && (t.dependencies = e.dependencies),
                            (tn = -1),
                            (yi |= t.lanes),
                            (n & t.childLanes) === 0)
                    )
                        if (e !== null) {
                            if ((Yo(e, t, n, !1), (n & t.childLanes) === 0)) return null;
                        } else return null;
                    if (e !== null && t.child !== e.child)
                        throw Error('Resuming work not yet implemented.');
                    if (t.child !== null) {
                        for (
                            e = t.child,
                            n = xa(e, e.pendingProps),
                            t.child = n,
                            n.return = t;
                            e.sibling !== null;
                        )
                            ((e = e.sibling),
                                (n = n.sibling = xa(e, e.pendingProps)),
                                (n.return = t));
                        n.sibling = null;
                    }
                    return t.child;
                }
                function Jd(e, t) {
                    return (e.lanes & t) !== 0
                        ? !0
                        : ((e = e.dependencies), !!(e !== null && Dr(e)));
                }
                function _S(e, t, n) {
                    switch (t.tag) {
                        case 3:
                            (Ee(t, t.stateNode.containerInfo),
                                Fa(t, vt, e.memoizedState.cache),
                                Go());
                            break;
                        case 27:
                        case 5:
                            ce(t);
                            break;
                        case 4:
                            Ee(t, t.stateNode.containerInfo);
                            break;
                        case 10:
                            Fa(t, t.type, t.memoizedProps.value);
                            break;
                        case 12:
                            ((n & t.childLanes) !== 0 && (t.flags |= 4),
                                (t.flags |= 2048));
                            var a = t.stateNode;
                            ((a.effectDuration = -0), (a.passiveEffectDuration = -0));
                            break;
                        case 13:
                            if (((a = t.memoizedState), a !== null))
                                return a.dehydrated !== null
                                    ? (ni(t), (t.flags |= 128), null)
                                    : (n & t.child.childLanes) !== 0
                                        ? Vg(e, t, n)
                                        : (ni(t),
                                            (e = Aa(e, t, n)),
                                            e !== null ? e.sibling : null);
                            ni(t);
                            break;
                        case 19:
                            var o = (e.flags & 128) !== 0;
                            if (
                                ((a = (n & t.childLanes) !== 0),
                                    a || (Yo(e, t, n, !1), (a = (n & t.childLanes) !== 0)),
                                    o)
                            ) {
                                if (a) return Lg(e, t, n);
                                t.flags |= 128;
                            }
                            if (
                                ((o = t.memoizedState),
                                    o !== null &&
                                    ((o.rendering = null),
                                        (o.tail = null),
                                        (o.lastEffect = null)),
                                    oe(xt, xt.current, t),
                                    a)
                            )
                                break;
                            return null;
                        case 22:
                        case 23:
                            return ((t.lanes = 0), Rg(e, t, n));
                        case 24:
                            Fa(t, vt, e.memoizedState.cache);
                    }
                    return Aa(e, t, n);
                }
                function qd(e, t, n) {
                    if (t._debugNeedsRemount && e !== null) {
                        ((n = Ju(
                            t.type,
                            t.key,
                            t.pendingProps,
                            t._debugOwner || null,
                            t.mode,
                            t.lanes
                        )),
                            (n._debugStack = t._debugStack),
                            (n._debugTask = t._debugTask));
                        var a = t.return;
                        if (a === null) throw Error('Cannot swap the root fiber.');
                        if (
                            ((e.alternate = null),
                                (t.alternate = null),
                                (n.index = t.index),
                                (n.sibling = t.sibling),
                                (n.return = t.return),
                                (n.ref = t.ref),
                                (n._debugInfo = t._debugInfo),
                                t === a.child)
                        )
                            a.child = n;
                        else {
                            var o = a.child;
                            if (o === null)
                                throw Error('Expected parent to have a child.');
                            for (; o.sibling !== t;)
                                if (((o = o.sibling), o === null))
                                    throw Error('Expected to find the previous sibling.');
                            o.sibling = n;
                        }
                        return (
                            (t = a.deletions),
                            t === null
                                ? ((a.deletions = [e]), (a.flags |= 16))
                                : t.push(e),
                            (n.flags |= 2),
                            n
                        );
                    }
                    if (e !== null)
                        if (e.memoizedProps !== t.pendingProps || t.type !== e.type)
                            At = !0;
                        else {
                            if (!Jd(e, n) && (t.flags & 128) === 0)
                                return ((At = !1), _S(e, t, n));
                            At = (e.flags & 131072) !== 0;
                        }
                    else
                        ((At = !1),
                            (a = Ue) && (Ii(), (a = (t.flags & 1048576) !== 0)),
                            a && ((a = t.index), Ii(), Ch(t, Tc, a)));
                    switch (((t.lanes = 0), t.tag)) {
                        case 16:
                            e: if (
                                ((a = t.pendingProps),
                                    (e = gi(t.elementType)),
                                    (t.type = e),
                                    typeof e == 'function')
                            )
                                Qu(e)
                                    ? ((a = Wi(e, a)),
                                        (t.tag = 1),
                                        (t.type = e = zi(e)),
                                        (t = kg(null, t, e, a, n)))
                                    : ((t.tag = 0),
                                        Yd(t, e),
                                        (t.type = e = zi(e)),
                                        (t = _d(null, t, e, a, n)));
                            else {
                                if (e != null) {
                                    if (((o = e.$$typeof), o === ms)) {
                                        ((t.tag = 11),
                                            (t.type = e = Wu(e)),
                                            (t = Dg(null, t, e, a, n)));
                                        break e;
                                    } else if (o === pc) {
                                        ((t.tag = 14), (t = Tg(null, t, e, a, n)));
                                        break e;
                                    }
                                }
                                throw (
                                    (t = ''),
                                    e !== null &&
                                    typeof e == 'object' &&
                                    e.$$typeof === dn &&
                                    (t =
                                        ' Did you wrap a component in React.lazy() more than once?'),
                                    (e = q(e) || e),
                                    Error(
                                        'Element type is invalid. Received a promise that resolves to: ' +
                                        e +
                                        '. Lazy element type must resolve to a class or function.' +
                                        t
                                    )
                                );
                            }
                            return t;
                        case 0:
                            return _d(e, t, t.type, t.pendingProps, n);
                        case 1:
                            return (
                                (a = t.type),
                                (o = Wi(a, t.pendingProps)),
                                kg(e, t, a, o, n)
                            );
                        case 3:
                            e: {
                                if ((Ee(t, t.stateNode.containerInfo), e === null))
                                    throw Error(
                                        'Should have a current fiber. This is a bug in React.'
                                    );
                                a = t.pendingProps;
                                var c = t.memoizedState;
                                ((o = c.element), rd(e, t), Qo(t, a, null, n));
                                var f = t.memoizedState;
                                if (
                                    ((a = f.cache),
                                        Fa(t, vt, a),
                                        a !== c.cache && nd(t, [vt], n, !0),
                                        Xo(),
                                        (a = f.element),
                                        c.isDehydrated)
                                )
                                    if (
                                        ((c = { element: a, isDehydrated: !1, cache: f.cache }),
                                            (t.updateQueue.baseState = c),
                                            (t.memoizedState = c),
                                            t.flags & 256)
                                    ) {
                                        t = jg(e, t, a, n);
                                        break e;
                                    } else if (a !== o) {
                                        ((o = sn(
                                            Error(
                                                'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.'
                                            ),
                                            t
                                        )),
                                            _o(o),
                                            (t = jg(e, t, a, n)));
                                        break e;
                                    } else {
                                        switch (((e = t.stateNode.containerInfo), e.nodeType)) {
                                            case 9:
                                                e = e.body;
                                                break;
                                            default:
                                                e =
                                                    e.nodeName === 'HTML' ? e.ownerDocument.body : e;
                                        }
                                        for (
                                            st = Nn(e.firstChild),
                                            Pt = t,
                                            Ue = !0,
                                            $i = null,
                                            Ba = !1,
                                            Cn = null,
                                            da = !0,
                                            e = Wv(t, null, a, n),
                                            t.child = e;
                                            e;
                                        )
                                            ((e.flags = (e.flags & -3) | 4096), (e = e.sibling));
                                    }
                                else {
                                    if ((Go(), a === o)) {
                                        t = Aa(e, t, n);
                                        break e;
                                    }
                                    Rt(e, t, a, n);
                                }
                                t = t.child;
                            }
                            return t;
                        case 26:
                            return (
                                qr(e, t),
                                e === null
                                    ? (e = ny(t.type, null, t.pendingProps, null))
                                        ? (t.memoizedState = e)
                                        : Ue ||
                                        ((e = t.type),
                                            (n = t.pendingProps),
                                            (a = ge(ci.current)),
                                            (a = lc(a).createElement(e)),
                                            (a[Lt] = t),
                                            (a[en] = n),
                                            Mt(a, e, n),
                                            M(a),
                                            (t.stateNode = a))
                                    : (t.memoizedState = ny(
                                        t.type,
                                        e.memoizedProps,
                                        t.pendingProps,
                                        e.memoizedState
                                    )),
                                null
                            );
                        case 27:
                            return (
                                ce(t),
                                e === null &&
                                Ue &&
                                ((a = ge(ci.current)),
                                    (o = J()),
                                    (a = t.stateNode = ey(t.type, t.pendingProps, a, o, !1)),
                                    Ba ||
                                    ((o = Zb(a, t.type, t.pendingProps, o)),
                                        o !== null && (Hi(t, 0).serverProps = o)),
                                    (Pt = t),
                                    (da = !0),
                                    (o = st),
                                    oi(t.type)
                                        ? ((ep = o), (st = Nn(a.firstChild)))
                                        : (st = o)),
                                Rt(e, t, t.pendingProps.children, n),
                                qr(e, t),
                                e === null && (t.flags |= 4194304),
                                t.child
                            );
                        case 5:
                            return (
                                e === null &&
                                Ue &&
                                ((c = J()),
                                    (a = Gu(t.type, c.ancestorInfo)),
                                    (o = st),
                                    (f = !o) ||
                                    ((f = Ax(o, t.type, t.pendingProps, da)),
                                        f !== null
                                            ? ((t.stateNode = f),
                                                Ba ||
                                                ((c = Zb(f, t.type, t.pendingProps, c)),
                                                    c !== null && (Hi(t, 0).serverProps = c)),
                                                (Pt = t),
                                                (st = Nn(f.firstChild)),
                                                (da = !1),
                                                (c = !0))
                                            : (c = !1),
                                        (f = !c)),
                                    f && (a && ed(t, o), Ui(t))),
                                ce(t),
                                (o = t.type),
                                (c = t.pendingProps),
                                (f = e !== null ? e.memoizedProps : null),
                                (a = c.children),
                                wf(o, c)
                                    ? (a = null)
                                    : f !== null && wf(o, f) && (t.flags |= 32),
                                t.memoizedState !== null &&
                                ((o = fd(e, t, BS, null, null, n)),
                                    (Fs._currentValue = o)),
                                qr(e, t),
                                Rt(e, t, a, n),
                                t.child
                            );
                        case 6:
                            return (
                                e === null &&
                                Ue &&
                                ((e = t.pendingProps),
                                    (n = J()),
                                    (a = n.ancestorInfo.current),
                                    (e =
                                        a != null
                                            ? br(e, a.tag, n.ancestorInfo.implicitRootScope)
                                            : !0),
                                    (n = st),
                                    (a = !n) ||
                                    ((a = Dx(n, t.pendingProps, da)),
                                        a !== null
                                            ? ((t.stateNode = a), (Pt = t), (st = null), (a = !0))
                                            : (a = !1),
                                        (a = !a)),
                                    a && (e && ed(t, n), Ui(t))),
                                null
                            );
                        case 13:
                            return Vg(e, t, n);
                        case 4:
                            return (
                                Ee(t, t.stateNode.containerInfo),
                                (a = t.pendingProps),
                                e === null ? (t.child = so(t, null, a, n)) : Rt(e, t, a, n),
                                t.child
                            );
                        case 11:
                            return Dg(e, t, t.type, t.pendingProps, n);
                        case 7:
                            return (Rt(e, t, t.pendingProps, n), t.child);
                        case 8:
                            return (Rt(e, t, t.pendingProps.children, n), t.child);
                        case 12:
                            return (
                                (t.flags |= 4),
                                (t.flags |= 2048),
                                (a = t.stateNode),
                                (a.effectDuration = -0),
                                (a.passiveEffectDuration = -0),
                                Rt(e, t, t.pendingProps.children, n),
                                t.child
                            );
                        case 10:
                            return (
                                (a = t.type),
                                (o = t.pendingProps),
                                (c = o.value),
                                'value' in o ||
                                u1 ||
                                ((u1 = !0),
                                    console.error(
                                        'The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?'
                                    )),
                                Fa(t, a, c),
                                Rt(e, t, o.children, n),
                                t.child
                            );
                        case 9:
                            return (
                                (o = t.type._context),
                                (a = t.pendingProps.children),
                                typeof a != 'function' &&
                                console.error(
                                    "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
                                ),
                                Gi(t),
                                (o = it(o)),
                                Tt(t),
                                (a = Em(a, o, void 0)),
                                bn(),
                                (t.flags |= 1),
                                Rt(e, t, a, n),
                                t.child
                            );
                        case 14:
                            return Tg(e, t, t.type, t.pendingProps, n);
                        case 15:
                            return Cg(e, t, t.type, t.pendingProps, n);
                        case 19:
                            return Lg(e, t, n);
                        case 31:
                            return (
                                (a = t.pendingProps),
                                (n = t.mode),
                                (a = { mode: a.mode, children: a.children }),
                                e === null
                                    ? ((e = $r(a, n)),
                                        (e.ref = t.ref),
                                        (t.child = e),
                                        (e.return = t),
                                        (t = e))
                                    : ((e = xa(e.child, a)),
                                        (e.ref = t.ref),
                                        (t.child = e),
                                        (e.return = t),
                                        (t = e)),
                                t
                            );
                        case 22:
                            return Rg(e, t, n);
                        case 24:
                            return (
                                Gi(t),
                                (a = it(vt)),
                                e === null
                                    ? ((o = od()),
                                        o === null &&
                                        ((o = Fe),
                                            (c = ad()),
                                            (o.pooledCache = c),
                                            _i(c),
                                            c !== null && (o.pooledCacheLanes |= n),
                                            (o = c)),
                                        (t.memoizedState = { parent: a, cache: o }),
                                        sd(t),
                                        Fa(t, vt, o))
                                    : ((e.lanes & n) !== 0 &&
                                        (rd(e, t), Qo(t, null, null, n), Xo()),
                                        (o = e.memoizedState),
                                        (c = t.memoizedState),
                                        o.parent !== a
                                            ? ((o = { parent: a, cache: a }),
                                                (t.memoizedState = o),
                                                t.lanes === 0 &&
                                                (t.memoizedState = t.updateQueue.baseState = o),
                                                Fa(t, vt, a))
                                            : ((a = c.cache),
                                                Fa(t, vt, a),
                                                a !== o.cache && nd(t, [vt], n, !0))),
                                Rt(e, t, t.pendingProps.children, n),
                                t.child
                            );
                        case 29:
                            throw t.pendingProps;
                    }
                    throw Error(
                        'Unknown unit of work tag (' +
                        t.tag +
                        '). This error is likely caused by a bug in React. Please file an issue.'
                    );
                }
                function Da(e) {
                    e.flags |= 4;
                }
                function Ig(e, t) {
                    if (t.type !== 'stylesheet' || (t.state.loading & jn) !== fl)
                        e.flags &= -16777217;
                    else if (((e.flags |= 16777216), !sy(t))) {
                        if (
                            ((t = kn.current),
                                t !== null &&
                                ((Ve & 4194048) === Ve
                                    ? ma !== null
                                    : ((Ve & 62914560) !== Ve && (Ve & 536870912) === 0) ||
                                    t !== ma))
                        )
                            throw ((js = bm), Sv);
                        e.flags |= 8192;
                    }
                }
                function Fr(e, t) {
                    (t !== null && (e.flags |= 4),
                        e.flags & 16384 &&
                        ((t = e.tag !== 22 ? Oi() : 536870912),
                            (e.lanes |= t),
                            (ol |= t)));
                }
                function Ko(e, t) {
                    if (!Ue)
                        switch (e.tailMode) {
                            case 'hidden':
                                t = e.tail;
                                for (var n = null; t !== null;)
                                    (t.alternate !== null && (n = t), (t = t.sibling));
                                n === null ? (e.tail = null) : (n.sibling = null);
                                break;
                            case 'collapsed':
                                n = e.tail;
                                for (var a = null; n !== null;)
                                    (n.alternate !== null && (a = n), (n = n.sibling));
                                a === null
                                    ? t || e.tail === null
                                        ? (e.tail = null)
                                        : (e.tail.sibling = null)
                                    : (a.sibling = null);
                        }
                }
                function lt(e) {
                    var t = e.alternate !== null && e.alternate.child === e.child,
                        n = 0,
                        a = 0;
                    if (t)
                        if ((e.mode & kt) !== et) {
                            for (var o = e.selfBaseDuration, c = e.child; c !== null;)
                                ((n |= c.lanes | c.childLanes),
                                    (a |= c.subtreeFlags & 65011712),
                                    (a |= c.flags & 65011712),
                                    (o += c.treeBaseDuration),
                                    (c = c.sibling));
                            e.treeBaseDuration = o;
                        } else
                            for (o = e.child; o !== null;)
                                ((n |= o.lanes | o.childLanes),
                                    (a |= o.subtreeFlags & 65011712),
                                    (a |= o.flags & 65011712),
                                    (o.return = e),
                                    (o = o.sibling));
                    else if ((e.mode & kt) !== et) {
                        ((o = e.actualDuration), (c = e.selfBaseDuration));
                        for (var f = e.child; f !== null;)
                            ((n |= f.lanes | f.childLanes),
                                (a |= f.subtreeFlags),
                                (a |= f.flags),
                                (o += f.actualDuration),
                                (c += f.treeBaseDuration),
                                (f = f.sibling));
                        ((e.actualDuration = o), (e.treeBaseDuration = c));
                    } else
                        for (o = e.child; o !== null;)
                            ((n |= o.lanes | o.childLanes),
                                (a |= o.subtreeFlags),
                                (a |= o.flags),
                                (o.return = e),
                                (o = o.sibling));
                    return ((e.subtreeFlags |= a), (e.childLanes = n), t);
                }
                function YS(e, t, n) {
                    var a = t.pendingProps;
                    switch ((Ku(t), t.tag)) {
                        case 31:
                        case 16:
                        case 15:
                        case 0:
                        case 11:
                        case 7:
                        case 8:
                        case 12:
                        case 9:
                        case 14:
                            return (lt(t), null);
                        case 1:
                            return (lt(t), null);
                        case 3:
                            return (
                                (n = t.stateNode),
                                (a = null),
                                e !== null && (a = e.memoizedState.cache),
                                t.memoizedState.cache !== a && (t.flags |= 2048),
                                Na(vt, t),
                                _e(t),
                                n.pendingContext &&
                                ((n.context = n.pendingContext),
                                    (n.pendingContext = null)),
                                (e === null || e.child === null) &&
                                (Uo(t)
                                    ? (kh(), Da(t))
                                    : e === null ||
                                    (e.memoizedState.isDehydrated &&
                                        (t.flags & 256) === 0) ||
                                    ((t.flags |= 1024), Oh())),
                                lt(t),
                                null
                            );
                        case 26:
                            return (
                                (n = t.memoizedState),
                                e === null
                                    ? (Da(t),
                                        n !== null
                                            ? (lt(t), Ig(t, n))
                                            : (lt(t), (t.flags &= -16777217)))
                                    : n
                                        ? n !== e.memoizedState
                                            ? (Da(t), lt(t), Ig(t, n))
                                            : (lt(t), (t.flags &= -16777217))
                                        : (e.memoizedProps !== a && Da(t),
                                            lt(t),
                                            (t.flags &= -16777217)),
                                null
                            );
                        case 27:
                            (Q(t), (n = ge(ci.current)));
                            var o = t.type;
                            if (e !== null && t.stateNode != null)
                                e.memoizedProps !== a && Da(t);
                            else {
                                if (!a) {
                                    if (t.stateNode === null)
                                        throw Error(
                                            'We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.'
                                        );
                                    return (lt(t), null);
                                }
                                ((e = J()),
                                    Uo(t)
                                        ? Rh(t)
                                        : ((e = ey(o, a, n, e, !0)), (t.stateNode = e), Da(t)));
                            }
                            return (lt(t), null);
                        case 5:
                            if ((Q(t), (n = t.type), e !== null && t.stateNode != null))
                                e.memoizedProps !== a && Da(t);
                            else {
                                if (!a) {
                                    if (t.stateNode === null)
                                        throw Error(
                                            'We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.'
                                        );
                                    return (lt(t), null);
                                }
                                if (((o = J()), Uo(t))) Rh(t);
                                else {
                                    switch (
                                    ((e = ge(ci.current)),
                                        Gu(n, o.ancestorInfo),
                                        (o = o.context),
                                        (e = lc(e)),
                                        o)
                                    ) {
                                        case So:
                                            e = e.createElementNS(_l, n);
                                            break;
                                        case eu:
                                            e = e.createElementNS(Sc, n);
                                            break;
                                        default:
                                            switch (n) {
                                                case 'svg':
                                                    e = e.createElementNS(_l, n);
                                                    break;
                                                case 'math':
                                                    e = e.createElementNS(Sc, n);
                                                    break;
                                                case 'script':
                                                    ((e = e.createElement('div')),
                                                        (e.innerHTML = '<script><\/script>'),
                                                        (e = e.removeChild(e.firstChild)));
                                                    break;
                                                case 'select':
                                                    ((e =
                                                        typeof a.is == 'string'
                                                            ? e.createElement('select', { is: a.is })
                                                            : e.createElement('select')),
                                                        a.multiple
                                                            ? (e.multiple = !0)
                                                            : a.size && (e.size = a.size));
                                                    break;
                                                default:
                                                    ((e =
                                                        typeof a.is == 'string'
                                                            ? e.createElement(n, { is: a.is })
                                                            : e.createElement(n)),
                                                        n.indexOf('-') === -1 &&
                                                        (n !== n.toLowerCase() &&
                                                            console.error(
                                                                '<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.',
                                                                n
                                                            ),
                                                            Object.prototype.toString.call(e) !==
                                                            '[object HTMLUnknownElement]' ||
                                                            Oa.call(R1, n) ||
                                                            ((R1[n] = !0),
                                                                console.error(
                                                                    'The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.',
                                                                    n
                                                                ))));
                                            }
                                    }
                                    ((e[Lt] = t), (e[en] = a));
                                    e: for (o = t.child; o !== null;) {
                                        if (o.tag === 5 || o.tag === 6)
                                            e.appendChild(o.stateNode);
                                        else if (
                                            o.tag !== 4 &&
                                            o.tag !== 27 &&
                                            o.child !== null
                                        ) {
                                            ((o.child.return = o), (o = o.child));
                                            continue;
                                        }
                                        if (o === t) break e;
                                        for (; o.sibling === null;) {
                                            if (o.return === null || o.return === t) break e;
                                            o = o.return;
                                        }
                                        ((o.sibling.return = o.return), (o = o.sibling));
                                    }
                                    t.stateNode = e;
                                    e: switch ((Mt(e, n, a), n)) {
                                        case 'button':
                                        case 'input':
                                        case 'select':
                                        case 'textarea':
                                            e = !!a.autoFocus;
                                            break e;
                                        case 'img':
                                            e = !0;
                                            break e;
                                        default:
                                            e = !1;
                                    }
                                    e && Da(t);
                                }
                            }
                            return (lt(t), (t.flags &= -16777217), null);
                        case 6:
                            if (e && t.stateNode != null) e.memoizedProps !== a && Da(t);
                            else {
                                if (typeof a != 'string' && t.stateNode === null)
                                    throw Error(
                                        'We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.'
                                    );
                                if (((e = ge(ci.current)), (n = J()), Uo(t))) {
                                    ((e = t.stateNode),
                                        (n = t.memoizedProps),
                                        (o = !Ba),
                                        (a = null));
                                    var c = Pt;
                                    if (c !== null)
                                        switch (c.tag) {
                                            case 3:
                                                o &&
                                                    ((o = $b(e, n, a)),
                                                        o !== null && (Hi(t, 0).serverProps = o));
                                                break;
                                            case 27:
                                            case 5:
                                                ((a = c.memoizedProps),
                                                    o &&
                                                    ((o = $b(e, n, a)),
                                                        o !== null && (Hi(t, 0).serverProps = o)));
                                        }
                                    ((e[Lt] = t),
                                        (e = !!(
                                            e.nodeValue === n ||
                                            (a !== null && a.suppressHydrationWarning === !0) ||
                                            Ub(e.nodeValue, n)
                                        )),
                                        e || Ui(t));
                                } else
                                    ((o = n.ancestorInfo.current),
                                        o != null &&
                                        br(a, o.tag, n.ancestorInfo.implicitRootScope),
                                        (e = lc(e).createTextNode(a)),
                                        (e[Lt] = t),
                                        (t.stateNode = e));
                            }
                            return (lt(t), null);
                        case 13:
                            if (
                                ((a = t.memoizedState),
                                    e === null ||
                                    (e.memoizedState !== null &&
                                        e.memoizedState.dehydrated !== null))
                            ) {
                                if (((o = Uo(t)), a !== null && a.dehydrated !== null)) {
                                    if (e === null) {
                                        if (!o)
                                            throw Error(
                                                'A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.'
                                            );
                                        if (
                                            ((o = t.memoizedState),
                                                (o = o !== null ? o.dehydrated : null),
                                                !o)
                                        )
                                            throw Error(
                                                'Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.'
                                            );
                                        ((o[Lt] = t),
                                            lt(t),
                                            (t.mode & kt) !== et &&
                                            a !== null &&
                                            ((o = t.child),
                                                o !== null &&
                                                (t.treeBaseDuration -= o.treeBaseDuration)));
                                    } else
                                        (kh(),
                                            Go(),
                                            (t.flags & 128) === 0 && (t.memoizedState = null),
                                            (t.flags |= 4),
                                            lt(t),
                                            (t.mode & kt) !== et &&
                                            a !== null &&
                                            ((o = t.child),
                                                o !== null &&
                                                (t.treeBaseDuration -= o.treeBaseDuration)));
                                    o = !1;
                                } else
                                    ((o = Oh()),
                                        e !== null &&
                                        e.memoizedState !== null &&
                                        (e.memoizedState.hydrationErrors = o),
                                        (o = !0));
                                if (!o) return t.flags & 256 ? (Ea(t), t) : (Ea(t), null);
                            }
                            return (
                                Ea(t),
                                (t.flags & 128) !== 0
                                    ? ((t.lanes = n), (t.mode & kt) !== et && Rr(t), t)
                                    : ((n = a !== null),
                                        (e = e !== null && e.memoizedState !== null),
                                        n &&
                                        ((a = t.child),
                                            (o = null),
                                            a.alternate !== null &&
                                            a.alternate.memoizedState !== null &&
                                            a.alternate.memoizedState.cachePool !== null &&
                                            (o = a.alternate.memoizedState.cachePool.pool),
                                            (c = null),
                                            a.memoizedState !== null &&
                                            a.memoizedState.cachePool !== null &&
                                            (c = a.memoizedState.cachePool.pool),
                                            c !== o && (a.flags |= 2048)),
                                        n !== e && n && (t.child.flags |= 8192),
                                        Fr(t, t.updateQueue),
                                        lt(t),
                                        (t.mode & kt) !== et &&
                                        n &&
                                        ((e = t.child),
                                            e !== null &&
                                            (t.treeBaseDuration -= e.treeBaseDuration)),
                                        null)
                            );
                        case 4:
                            return (
                                _e(t),
                                e === null && gf(t.stateNode.containerInfo),
                                lt(t),
                                null
                            );
                        case 10:
                            return (Na(t.type, t), lt(t), null);
                        case 19:
                            if ((X(xt, t), (o = t.memoizedState), o === null))
                                return (lt(t), null);
                            if (
                                ((a = (t.flags & 128) !== 0), (c = o.rendering), c === null)
                            )
                                if (a) Ko(o, !1);
                                else {
                                    if (rt !== Ua || (e !== null && (e.flags & 128) !== 0))
                                        for (e = t.child; e !== null;) {
                                            if (((c = Qr(e)), c !== null)) {
                                                for (
                                                    t.flags |= 128,
                                                    Ko(o, !1),
                                                    e = c.updateQueue,
                                                    t.updateQueue = e,
                                                    Fr(t, e),
                                                    t.subtreeFlags = 0,
                                                    e = n,
                                                    n = t.child;
                                                    n !== null;
                                                )
                                                    (Th(n, e), (n = n.sibling));
                                                return (oe(xt, (xt.current & ro) | Ls, t), t.child);
                                            }
                                            e = e.sibling;
                                        }
                                    o.tail !== null &&
                                        oa() > _c &&
                                        ((t.flags |= 128),
                                            (a = !0),
                                            Ko(o, !1),
                                            (t.lanes = 4194304));
                                }
                            else {
                                if (!a)
                                    if (((e = Qr(c)), e !== null)) {
                                        if (
                                            ((t.flags |= 128),
                                                (a = !0),
                                                (e = e.updateQueue),
                                                (t.updateQueue = e),
                                                Fr(t, e),
                                                Ko(o, !0),
                                                o.tail === null &&
                                                o.tailMode === 'hidden' &&
                                                !c.alternate &&
                                                !Ue)
                                        )
                                            return (lt(t), null);
                                    } else
                                        2 * oa() - o.renderingStartTime > _c &&
                                            n !== 536870912 &&
                                            ((t.flags |= 128),
                                                (a = !0),
                                                Ko(o, !1),
                                                (t.lanes = 4194304));
                                o.isBackwards
                                    ? ((c.sibling = t.child), (t.child = c))
                                    : ((e = o.last),
                                        e !== null ? (e.sibling = c) : (t.child = c),
                                        (o.last = c));
                            }
                            return o.tail !== null
                                ? ((e = o.tail),
                                    (o.rendering = e),
                                    (o.tail = e.sibling),
                                    (o.renderingStartTime = oa()),
                                    (e.sibling = null),
                                    (n = xt.current),
                                    (n = a ? (n & ro) | Ls : n & ro),
                                    oe(xt, n, t),
                                    e)
                                : (lt(t), null);
                        case 22:
                        case 23:
                            return (
                                Ea(t),
                                ud(t),
                                (a = t.memoizedState !== null),
                                e !== null
                                    ? (e.memoizedState !== null) !== a && (t.flags |= 8192)
                                    : a && (t.flags |= 8192),
                                a
                                    ? (n & 536870912) !== 0 &&
                                    (t.flags & 128) === 0 &&
                                    (lt(t), t.subtreeFlags & 6 && (t.flags |= 8192))
                                    : lt(t),
                                (n = t.updateQueue),
                                n !== null && Fr(t, n.retryQueue),
                                (n = null),
                                e !== null &&
                                e.memoizedState !== null &&
                                e.memoizedState.cachePool !== null &&
                                (n = e.memoizedState.cachePool.pool),
                                (a = null),
                                t.memoizedState !== null &&
                                t.memoizedState.cachePool !== null &&
                                (a = t.memoizedState.cachePool.pool),
                                a !== n && (t.flags |= 2048),
                                e !== null && X(el, t),
                                null
                            );
                        case 24:
                            return (
                                (n = null),
                                e !== null && (n = e.memoizedState.cache),
                                t.memoizedState.cache !== n && (t.flags |= 2048),
                                Na(vt, t),
                                lt(t),
                                null
                            );
                        case 25:
                            return null;
                        case 30:
                            return null;
                    }
                    throw Error(
                        'Unknown unit of work tag (' +
                        t.tag +
                        '). This error is likely caused by a bug in React. Please file an issue.'
                    );
                }
                function PS(e, t) {
                    switch ((Ku(t), t.tag)) {
                        case 1:
                            return (
                                (e = t.flags),
                                e & 65536
                                    ? ((t.flags = (e & -65537) | 128),
                                        (t.mode & kt) !== et && Rr(t),
                                        t)
                                    : null
                            );
                        case 3:
                            return (
                                Na(vt, t),
                                _e(t),
                                (e = t.flags),
                                (e & 65536) !== 0 && (e & 128) === 0
                                    ? ((t.flags = (e & -65537) | 128), t)
                                    : null
                            );
                        case 26:
                        case 27:
                        case 5:
                            return (Q(t), null);
                        case 13:
                            if (
                                (Ea(t),
                                    (e = t.memoizedState),
                                    e !== null && e.dehydrated !== null)
                            ) {
                                if (t.alternate === null)
                                    throw Error(
                                        'Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.'
                                    );
                                Go();
                            }
                            return (
                                (e = t.flags),
                                e & 65536
                                    ? ((t.flags = (e & -65537) | 128),
                                        (t.mode & kt) !== et && Rr(t),
                                        t)
                                    : null
                            );
                        case 19:
                            return (X(xt, t), null);
                        case 4:
                            return (_e(t), null);
                        case 10:
                            return (Na(t.type, t), null);
                        case 22:
                        case 23:
                            return (
                                Ea(t),
                                ud(t),
                                e !== null && X(el, t),
                                (e = t.flags),
                                e & 65536
                                    ? ((t.flags = (e & -65537) | 128),
                                        (t.mode & kt) !== et && Rr(t),
                                        t)
                                    : null
                            );
                        case 24:
                            return (Na(vt, t), null);
                        case 25:
                            return null;
                        default:
                            return null;
                    }
                }
                function Hg(e, t) {
                    switch ((Ku(t), t.tag)) {
                        case 3:
                            (Na(vt, t), _e(t));
                            break;
                        case 26:
                        case 27:
                        case 5:
                            Q(t);
                            break;
                        case 4:
                            _e(t);
                            break;
                        case 13:
                            Ea(t);
                            break;
                        case 19:
                            X(xt, t);
                            break;
                        case 10:
                            Na(t.type, t);
                            break;
                        case 22:
                        case 23:
                            (Ea(t), ud(t), e !== null && X(el, t));
                            break;
                        case 24:
                            Na(vt, t);
                    }
                }
                function ea(e) {
                    return (e.mode & kt) !== et;
                }
                function Ug(e, t) {
                    ea(e) ? (Kn(), es(t, e), Fn()) : es(t, e);
                }
                function $d(e, t, n) {
                    ea(e) ? (Kn(), Cl(n, e, t), Fn()) : Cl(n, e, t);
                }
                function es(e, t) {
                    try {
                        var n = t.updateQueue,
                            a = n !== null ? n.lastEffect : null;
                        if (a !== null) {
                            var o = a.next;
                            n = o;
                            do {
                                if (
                                    (n.tag & e) === e &&
                                    ((e & St) !== Rn
                                        ? se !== null &&
                                        typeof se.markComponentPassiveEffectMountStarted ==
                                        'function' &&
                                        se.markComponentPassiveEffectMountStarted(t)
                                        : (e & jt) !== Rn &&
                                        se !== null &&
                                        typeof se.markComponentLayoutEffectMountStarted ==
                                        'function' &&
                                        se.markComponentLayoutEffectMountStarted(t),
                                        (a = void 0),
                                        (e & Zt) !== Rn && (yo = !0),
                                        (a = he(t, cw, n)),
                                        (e & Zt) !== Rn && (yo = !1),
                                        (e & St) !== Rn
                                            ? se !== null &&
                                            typeof se.markComponentPassiveEffectMountStopped ==
                                            'function' &&
                                            se.markComponentPassiveEffectMountStopped()
                                            : (e & jt) !== Rn &&
                                            se !== null &&
                                            typeof se.markComponentLayoutEffectMountStopped ==
                                            'function' &&
                                            se.markComponentLayoutEffectMountStopped(),
                                        a !== void 0 && typeof a != 'function')
                                ) {
                                    var c = void 0;
                                    c =
                                        (n.tag & jt) !== 0
                                            ? 'useLayoutEffect'
                                            : (n.tag & Zt) !== 0
                                                ? 'useInsertionEffect'
                                                : 'useEffect';
                                    var f = void 0;
                                    ((f =
                                        a === null
                                            ? ' You returned null. If your effect does not require clean up, return undefined (or nothing).'
                                            : typeof a.then == 'function'
                                                ? `

It looks like you wrote ` +
                                                c +
                                                `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` +
                                                c +
                                                `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching`
                                                : ' You returned: ' + a),
                                        he(
                                            t,
                                            function (g, w) {
                                                console.error(
                                                    '%s must not return anything besides a function, which is used for clean-up.%s',
                                                    g,
                                                    w
                                                );
                                            },
                                            c,
                                            f
                                        ));
                                }
                                n = n.next;
                            } while (n !== o);
                        }
                    } catch (g) {
                        Qe(t, t.return, g);
                    }
                }
                function Cl(e, t, n) {
                    try {
                        var a = t.updateQueue,
                            o = a !== null ? a.lastEffect : null;
                        if (o !== null) {
                            var c = o.next;
                            a = c;
                            do {
                                if ((a.tag & e) === e) {
                                    var f = a.inst,
                                        g = f.destroy;
                                    g !== void 0 &&
                                        ((f.destroy = void 0),
                                            (e & St) !== Rn
                                                ? se !== null &&
                                                typeof se.markComponentPassiveEffectUnmountStarted ==
                                                'function' &&
                                                se.markComponentPassiveEffectUnmountStarted(t)
                                                : (e & jt) !== Rn &&
                                                se !== null &&
                                                typeof se.markComponentLayoutEffectUnmountStarted ==
                                                'function' &&
                                                se.markComponentLayoutEffectUnmountStarted(t),
                                            (e & Zt) !== Rn && (yo = !0),
                                            (o = t),
                                            he(o, uw, o, n, g),
                                            (e & Zt) !== Rn && (yo = !1),
                                            (e & St) !== Rn
                                                ? se !== null &&
                                                typeof se.markComponentPassiveEffectUnmountStopped ==
                                                'function' &&
                                                se.markComponentPassiveEffectUnmountStopped()
                                                : (e & jt) !== Rn &&
                                                se !== null &&
                                                typeof se.markComponentLayoutEffectUnmountStopped ==
                                                'function' &&
                                                se.markComponentLayoutEffectUnmountStopped());
                                }
                                a = a.next;
                            } while (a !== c);
                        }
                    } catch (w) {
                        Qe(t, t.return, w);
                    }
                }
                function Gg(e, t) {
                    ea(e) ? (Kn(), es(t, e), Fn()) : es(t, e);
                }
                function Fd(e, t, n) {
                    ea(e) ? (Kn(), Cl(n, e, t), Fn()) : Cl(n, e, t);
                }
                function _g(e) {
                    var t = e.updateQueue;
                    if (t !== null) {
                        var n = e.stateNode;
                        e.type.defaultProps ||
                            'ref' in e.memoizedProps ||
                            uo ||
                            (n.props !== e.memoizedProps &&
                                console.error(
                                    'Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.',
                                    K(e) || 'instance'
                                ),
                                n.state !== e.memoizedState &&
                                console.error(
                                    'Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.',
                                    K(e) || 'instance'
                                ));
                        try {
                            he(e, Yh, t, n);
                        } catch (a) {
                            Qe(e, e.return, a);
                        }
                    }
                }
                function ZS(e, t, n) {
                    return e.getSnapshotBeforeUpdate(t, n);
                }
                function WS(e, t) {
                    var n = t.memoizedProps,
                        a = t.memoizedState;
                    ((t = e.stateNode),
                        e.type.defaultProps ||
                        'ref' in e.memoizedProps ||
                        uo ||
                        (t.props !== e.memoizedProps &&
                            console.error(
                                'Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.',
                                K(e) || 'instance'
                            ),
                            t.state !== e.memoizedState &&
                            console.error(
                                'Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.',
                                K(e) || 'instance'
                            )));
                    try {
                        var o = Wi(e.type, n),
                            c = he(e, ZS, t, o, a);
                        ((n = d1),
                            c !== void 0 ||
                            n.has(e.type) ||
                            (n.add(e.type),
                                he(e, function () {
                                    console.error(
                                        '%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.',
                                        K(e)
                                    );
                                })),
                            (t.__reactInternalSnapshotBeforeUpdate = c));
                    } catch (f) {
                        Qe(e, e.return, f);
                    }
                }
                function Yg(e, t, n) {
                    ((n.props = Wi(e.type, e.memoizedProps)),
                        (n.state = e.memoizedState),
                        ea(e) ? (Kn(), he(e, Iv, e, t, n), Fn()) : he(e, Iv, e, t, n));
                }
                function XS(e) {
                    var t = e.ref;
                    if (t !== null) {
                        switch (e.tag) {
                            case 26:
                            case 27:
                            case 5:
                                var n = e.stateNode;
                                break;
                            case 30:
                                n = e.stateNode;
                                break;
                            default:
                                n = e.stateNode;
                        }
                        if (typeof t == 'function')
                            if (ea(e))
                                try {
                                    (Kn(), (e.refCleanup = t(n)));
                                } finally {
                                    Fn();
                                }
                            else e.refCleanup = t(n);
                        else
                            (typeof t == 'string'
                                ? console.error('String refs are no longer supported.')
                                : t.hasOwnProperty('current') ||
                                console.error(
                                    'Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().',
                                    K(e)
                                ),
                                (t.current = n));
                    }
                }
                function ts(e, t) {
                    try {
                        he(e, XS, e);
                    } catch (n) {
                        Qe(e, t, n);
                    }
                }
                function ta(e, t) {
                    var n = e.ref,
                        a = e.refCleanup;
                    if (n !== null)
                        if (typeof a == 'function')
                            try {
                                if (ea(e))
                                    try {
                                        (Kn(), he(e, a));
                                    } finally {
                                        Fn();
                                    }
                                else he(e, a);
                            } catch (o) {
                                Qe(e, t, o);
                            } finally {
                                ((e.refCleanup = null),
                                    (e = e.alternate),
                                    e != null && (e.refCleanup = null));
                            }
                        else if (typeof n == 'function')
                            try {
                                if (ea(e))
                                    try {
                                        (Kn(), he(e, n, null));
                                    } finally {
                                        Fn();
                                    }
                                else he(e, n, null);
                            } catch (o) {
                                Qe(e, t, o);
                            }
                        else n.current = null;
                }
                function Pg(e, t, n, a) {
                    var o = e.memoizedProps,
                        c = o.id,
                        f = o.onCommit;
                    ((o = o.onRender),
                        (t = t === null ? 'mount' : 'update'),
                        Mc && (t = 'nested-update'),
                        typeof o == 'function' &&
                        o(
                            c,
                            t,
                            e.actualDuration,
                            e.treeBaseDuration,
                            e.actualStartTime,
                            n
                        ),
                        typeof f == 'function' && f(e.memoizedProps.id, t, a, n));
                }
                function QS(e, t, n, a) {
                    var o = e.memoizedProps;
                    ((e = o.id),
                        (o = o.onPostCommit),
                        (t = t === null ? 'mount' : 'update'),
                        Mc && (t = 'nested-update'),
                        typeof o == 'function' && o(e, t, a, n));
                }
                function Zg(e) {
                    var t = e.type,
                        n = e.memoizedProps,
                        a = e.stateNode;
                    try {
                        he(e, gx, a, t, n, e);
                    } catch (o) {
                        Qe(e, e.return, o);
                    }
                }
                function Kd(e, t, n) {
                    try {
                        he(e, bx, e.stateNode, e.type, n, t, e);
                    } catch (a) {
                        Qe(e, e.return, a);
                    }
                }
                function Wg(e) {
                    return (
                        e.tag === 5 ||
                        e.tag === 3 ||
                        e.tag === 26 ||
                        (e.tag === 27 && oi(e.type)) ||
                        e.tag === 4
                    );
                }
                function ef(e) {
                    e: for (; ;) {
                        for (; e.sibling === null;) {
                            if (e.return === null || Wg(e.return)) return null;
                            e = e.return;
                        }
                        for (
                            e.sibling.return = e.return, e = e.sibling;
                            e.tag !== 5 && e.tag !== 6 && e.tag !== 18;
                        ) {
                            if (
                                (e.tag === 27 && oi(e.type)) ||
                                e.flags & 2 ||
                                e.child === null ||
                                e.tag === 4
                            )
                                continue e;
                            ((e.child.return = e), (e = e.child));
                        }
                        if (!(e.flags & 2)) return e.stateNode;
                    }
                }
                function tf(e, t, n) {
                    var a = e.tag;
                    if (a === 5 || a === 6)
                        ((e = e.stateNode),
                            t
                                ? (n.nodeType === 9
                                    ? n.body
                                    : n.nodeName === 'HTML'
                                        ? n.ownerDocument.body
                                        : n
                                ).insertBefore(e, t)
                                : ((t =
                                    n.nodeType === 9
                                        ? n.body
                                        : n.nodeName === 'HTML'
                                            ? n.ownerDocument.body
                                            : n),
                                    t.appendChild(e),
                                    (n = n._reactRootContainer),
                                    n != null || t.onclick !== null || (t.onclick = ic)));
                    else if (
                        a !== 4 &&
                        (a === 27 && oi(e.type) && ((n = e.stateNode), (t = null)),
                            (e = e.child),
                            e !== null)
                    )
                        for (tf(e, t, n), e = e.sibling; e !== null;)
                            (tf(e, t, n), (e = e.sibling));
                }
                function Kr(e, t, n) {
                    var a = e.tag;
                    if (a === 5 || a === 6)
                        ((e = e.stateNode),
                            t ? n.insertBefore(e, t) : n.appendChild(e));
                    else if (
                        a !== 4 &&
                        (a === 27 && oi(e.type) && (n = e.stateNode),
                            (e = e.child),
                            e !== null)
                    )
                        for (Kr(e, t, n), e = e.sibling; e !== null;)
                            (Kr(e, t, n), (e = e.sibling));
                }
                function JS(e) {
                    for (var t, n = e.return; n !== null;) {
                        if (Wg(n)) {
                            t = n;
                            break;
                        }
                        n = n.return;
                    }
                    if (t == null)
                        throw Error(
                            'Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.'
                        );
                    switch (t.tag) {
                        case 27:
                            ((t = t.stateNode), (n = ef(e)), Kr(e, n, t));
                            break;
                        case 5:
                            ((n = t.stateNode),
                                t.flags & 32 && (Qb(n), (t.flags &= -33)),
                                (t = ef(e)),
                                Kr(e, t, n));
                            break;
                        case 3:
                        case 4:
                            ((t = t.stateNode.containerInfo), (n = ef(e)), tf(e, n, t));
                            break;
                        default:
                            throw Error(
                                'Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.'
                            );
                    }
                }
                function Xg(e) {
                    var t = e.stateNode,
                        n = e.memoizedProps;
                    try {
                        he(e, Mx, e.type, n, t, e);
                    } catch (a) {
                        Qe(e, e.return, a);
                    }
                }
                function qS(e, t) {
                    if (((e = e.containerInfo), ($m = iu), (e = Nh(e)), Pu(e))) {
                        if ('selectionStart' in e)
                            var n = { start: e.selectionStart, end: e.selectionEnd };
                        else {
                            n = ((n = e.ownerDocument) && n.defaultView) || window;
                            var a = n.getSelection && n.getSelection();
                            if (a && a.rangeCount !== 0) {
                                n = a.anchorNode;
                                var o = a.anchorOffset,
                                    c = a.focusNode;
                                a = a.focusOffset;
                                var f = 0,
                                    g = -1,
                                    w = -1,
                                    A = 0,
                                    V = 0,
                                    L = e,
                                    j = null;
                                e: for (; ;) {
                                    for (
                                        var H;
                                        L !== n || (o !== 0 && L.nodeType !== 3) || (g = f + o),
                                        L !== c ||
                                        (a !== 0 && L.nodeType !== 3) ||
                                        (w = f + a),
                                        L.nodeType === 3 && (f += L.nodeValue.length),
                                        (H = L.firstChild) !== null;
                                    )
                                        ((j = L), (L = H));
                                    for (; ;) {
                                        if (L === e) break e;
                                        if (
                                            (j === n && ++A === o && (g = f),
                                                j === c && ++V === a && (w = f),
                                                (H = L.nextSibling) !== null)
                                        )
                                            break;
                                        ((L = j), (j = L.parentNode));
                                    }
                                    L = H;
                                }
                                n = g === -1 || w === -1 ? null : { start: g, end: w };
                            } else n = null;
                        }
                        n = n || { start: 0, end: 0 };
                    } else n = null;
                    for (
                        Fm = { focusedElem: e, selectionRange: n }, iu = !1, Dt = t;
                        Dt !== null;
                    )
                        if (
                            ((t = Dt),
                                (e = t.child),
                                (t.subtreeFlags & 1024) !== 0 && e !== null)
                        )
                            ((e.return = t), (Dt = e));
                        else
                            for (; Dt !== null;) {
                                switch (
                                ((e = t = Dt), (n = e.alternate), (o = e.flags), e.tag)
                                ) {
                                    case 0:
                                        break;
                                    case 11:
                                    case 15:
                                        break;
                                    case 1:
                                        (o & 1024) !== 0 && n !== null && WS(e, n);
                                        break;
                                    case 3:
                                        if ((o & 1024) !== 0) {
                                            if (
                                                ((e = e.stateNode.containerInfo),
                                                    (n = e.nodeType),
                                                    n === 9)
                                            )
                                                Ef(e);
                                            else if (n === 1)
                                                switch (e.nodeName) {
                                                    case 'HEAD':
                                                    case 'HTML':
                                                    case 'BODY':
                                                        Ef(e);
                                                        break;
                                                    default:
                                                        e.textContent = '';
                                                }
                                        }
                                        break;
                                    case 5:
                                    case 26:
                                    case 27:
                                    case 6:
                                    case 4:
                                    case 17:
                                        break;
                                    default:
                                        if ((o & 1024) !== 0)
                                            throw Error(
                                                'This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.'
                                            );
                                }
                                if (((e = t.sibling), e !== null)) {
                                    ((e.return = t.return), (Dt = e));
                                    break;
                                }
                                Dt = t.return;
                            }
                }
                function Qg(e, t, n) {
                    var a = n.flags;
                    switch (n.tag) {
                        case 0:
                        case 11:
                        case 15:
                            (Ca(e, n), a & 4 && Ug(n, jt | Mn));
                            break;
                        case 1:
                            if ((Ca(e, n), a & 4))
                                if (((e = n.stateNode), t === null))
                                    (n.type.defaultProps ||
                                        'ref' in n.memoizedProps ||
                                        uo ||
                                        (e.props !== n.memoizedProps &&
                                            console.error(
                                                'Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.',
                                                K(n) || 'instance'
                                            ),
                                            e.state !== n.memoizedState &&
                                            console.error(
                                                'Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.',
                                                K(n) || 'instance'
                                            )),
                                        ea(n)
                                            ? (Kn(), he(n, Am, n, e), Fn())
                                            : he(n, Am, n, e));
                                else {
                                    var o = Wi(n.type, t.memoizedProps);
                                    ((t = t.memoizedState),
                                        n.type.defaultProps ||
                                        'ref' in n.memoizedProps ||
                                        uo ||
                                        (e.props !== n.memoizedProps &&
                                            console.error(
                                                'Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.',
                                                K(n) || 'instance'
                                            ),
                                            e.state !== n.memoizedState &&
                                            console.error(
                                                'Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.',
                                                K(n) || 'instance'
                                            )),
                                        ea(n)
                                            ? (Kn(),
                                                he(
                                                    n,
                                                    zv,
                                                    n,
                                                    e,
                                                    o,
                                                    t,
                                                    e.__reactInternalSnapshotBeforeUpdate
                                                ),
                                                Fn())
                                            : he(
                                                n,
                                                zv,
                                                n,
                                                e,
                                                o,
                                                t,
                                                e.__reactInternalSnapshotBeforeUpdate
                                            ));
                                }
                            (a & 64 && _g(n), a & 512 && ts(n, n.return));
                            break;
                        case 3:
                            if (
                                ((t = wa()),
                                    Ca(e, n),
                                    a & 64 && ((a = n.updateQueue), a !== null))
                            ) {
                                if (((o = null), n.child !== null))
                                    switch (n.child.tag) {
                                        case 27:
                                        case 5:
                                            o = n.child.stateNode;
                                            break;
                                        case 1:
                                            o = n.child.stateNode;
                                    }
                                try {
                                    he(n, Yh, a, o);
                                } catch (f) {
                                    Qe(n, n.return, f);
                                }
                            }
                            e.effectDuration += Cr(t);
                            break;
                        case 27:
                            t === null && a & 4 && Xg(n);
                        case 26:
                        case 5:
                            (Ca(e, n),
                                t === null && a & 4 && Zg(n),
                                a & 512 && ts(n, n.return));
                            break;
                        case 12:
                            if (a & 4) {
                                ((a = wa()),
                                    Ca(e, n),
                                    (e = n.stateNode),
                                    (e.effectDuration += Zo(a)));
                                try {
                                    he(n, Pg, n, t, Rc, e.effectDuration);
                                } catch (f) {
                                    Qe(n, n.return, f);
                                }
                            } else Ca(e, n);
                            break;
                        case 13:
                            (Ca(e, n),
                                a & 4 && $g(e, n),
                                a & 64 &&
                                ((e = n.memoizedState),
                                    e !== null &&
                                    ((e = e.dehydrated),
                                        e !== null && ((n = lx.bind(null, n)), Tx(e, n)))));
                            break;
                        case 22:
                            if (((a = n.memoizedState !== null || Ha), !a)) {
                                ((t = (t !== null && t.memoizedState !== null) || mt),
                                    (o = Ha));
                                var c = mt;
                                ((Ha = a),
                                    (mt = t) && !c
                                        ? Ra(e, n, (n.subtreeFlags & 8772) !== 0)
                                        : Ca(e, n),
                                    (Ha = o),
                                    (mt = c));
                            }
                            break;
                        case 30:
                            break;
                        default:
                            Ca(e, n);
                    }
                }
                function Jg(e) {
                    var t = e.alternate;
                    (t !== null && ((e.alternate = null), Jg(t)),
                        (e.child = null),
                        (e.deletions = null),
                        (e.sibling = null),
                        e.tag === 5 && ((t = e.stateNode), t !== null && qa(t)),
                        (e.stateNode = null),
                        (e._debugOwner = null),
                        (e.return = null),
                        (e.dependencies = null),
                        (e.memoizedProps = null),
                        (e.memoizedState = null),
                        (e.pendingProps = null),
                        (e.stateNode = null),
                        (e.updateQueue = null));
                }
                function Ta(e, t, n) {
                    for (n = n.child; n !== null;) (qg(e, t, n), (n = n.sibling));
                }
                function qg(e, t, n) {
                    if (Bt && typeof Bt.onCommitFiberUnmount == 'function')
                        try {
                            Bt.onCommitFiberUnmount(Ul, n);
                        } catch (c) {
                            sa ||
                                ((sa = !0),
                                    console.error(
                                        'React instrumentation encountered an error: %s',
                                        c
                                    ));
                        }
                    switch (n.tag) {
                        case 26:
                            (mt || ta(n, t),
                                Ta(e, t, n),
                                n.memoizedState
                                    ? n.memoizedState.count--
                                    : n.stateNode &&
                                    ((n = n.stateNode), n.parentNode.removeChild(n)));
                            break;
                        case 27:
                            mt || ta(n, t);
                            var a = yt,
                                o = nn;
                            (oi(n.type) && ((yt = n.stateNode), (nn = !1)),
                                Ta(e, t, n),
                                he(n, rs, n.stateNode),
                                (yt = a),
                                (nn = o));
                            break;
                        case 5:
                            mt || ta(n, t);
                        case 6:
                            if (
                                ((a = yt),
                                    (o = nn),
                                    (yt = null),
                                    Ta(e, t, n),
                                    (yt = a),
                                    (nn = o),
                                    yt !== null)
                            )
                                if (nn)
                                    try {
                                        he(n, Sx, yt, n.stateNode);
                                    } catch (c) {
                                        Qe(n, t, c);
                                    }
                                else
                                    try {
                                        he(n, vx, yt, n.stateNode);
                                    } catch (c) {
                                        Qe(n, t, c);
                                    }
                            break;
                        case 18:
                            yt !== null &&
                                (nn
                                    ? ((e = yt),
                                        Jb(
                                            e.nodeType === 9
                                                ? e.body
                                                : e.nodeName === 'HTML'
                                                    ? e.ownerDocument.body
                                                    : e,
                                            n.stateNode
                                        ),
                                        fs(e))
                                    : Jb(yt, n.stateNode));
                            break;
                        case 4:
                            ((a = yt),
                                (o = nn),
                                (yt = n.stateNode.containerInfo),
                                (nn = !0),
                                Ta(e, t, n),
                                (yt = a),
                                (nn = o));
                            break;
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            (mt || Cl(Zt, n, t), mt || $d(n, t, jt), Ta(e, t, n));
                            break;
                        case 1:
                            (mt ||
                                (ta(n, t),
                                    (a = n.stateNode),
                                    typeof a.componentWillUnmount == 'function' && Yg(n, t, a)),
                                Ta(e, t, n));
                            break;
                        case 21:
                            Ta(e, t, n);
                            break;
                        case 22:
                            ((mt = (a = mt) || n.memoizedState !== null),
                                Ta(e, t, n),
                                (mt = a));
                            break;
                        default:
                            Ta(e, t, n);
                    }
                }
                function $g(e, t) {
                    if (
                        t.memoizedState === null &&
                        ((e = t.alternate),
                            e !== null &&
                            ((e = e.memoizedState),
                                e !== null && ((e = e.dehydrated), e !== null)))
                    )
                        try {
                            he(t, Rx, e);
                        } catch (n) {
                            Qe(t, t.return, n);
                        }
                }
                function $S(e) {
                    switch (e.tag) {
                        case 13:
                        case 19:
                            var t = e.stateNode;
                            return (t === null && (t = e.stateNode = new f1()), t);
                        case 22:
                            return (
                                (e = e.stateNode),
                                (t = e._retryCache),
                                t === null && (t = e._retryCache = new f1()),
                                t
                            );
                        default:
                            throw Error(
                                'Unexpected Suspense handler tag (' +
                                e.tag +
                                '). This is a bug in React.'
                            );
                    }
                }
                function nf(e, t) {
                    var n = $S(e);
                    t.forEach(function (a) {
                        var o = ox.bind(null, e, a);
                        if (!n.has(a)) {
                            if ((n.add(a), _n))
                                if (fo !== null && mo !== null) ls(mo, fo);
                                else
                                    throw Error(
                                        'Expected finished root and lanes to be set. This is a bug in React.'
                                    );
                            a.then(o, o);
                        }
                    });
                }
                function rn(e, t) {
                    var n = t.deletions;
                    if (n !== null)
                        for (var a = 0; a < n.length; a++) {
                            var o = e,
                                c = t,
                                f = n[a],
                                g = c;
                            e: for (; g !== null;) {
                                switch (g.tag) {
                                    case 27:
                                        if (oi(g.type)) {
                                            ((yt = g.stateNode), (nn = !1));
                                            break e;
                                        }
                                        break;
                                    case 5:
                                        ((yt = g.stateNode), (nn = !1));
                                        break e;
                                    case 3:
                                    case 4:
                                        ((yt = g.stateNode.containerInfo), (nn = !0));
                                        break e;
                                }
                                g = g.return;
                            }
                            if (yt === null)
                                throw Error(
                                    'Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.'
                                );
                            (qg(o, c, f),
                                (yt = null),
                                (nn = !1),
                                (o = f),
                                (c = o.alternate),
                                c !== null && (c.return = null),
                                (o.return = null));
                        }
                    if (t.subtreeFlags & 13878)
                        for (t = t.child; t !== null;) (Fg(t, e), (t = t.sibling));
                }
                function Fg(e, t) {
                    var n = e.alternate,
                        a = e.flags;
                    switch (e.tag) {
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            (rn(t, e),
                                cn(e),
                                a & 4 &&
                                (Cl(Zt | Mn, e, e.return),
                                    es(Zt | Mn, e),
                                    $d(e, e.return, jt | Mn)));
                            break;
                        case 1:
                            (rn(t, e),
                                cn(e),
                                a & 512 && (mt || n === null || ta(n, n.return)),
                                a & 64 &&
                                Ha &&
                                ((e = e.updateQueue),
                                    e !== null &&
                                    ((a = e.callbacks),
                                        a !== null &&
                                        ((n = e.shared.hiddenCallbacks),
                                            (e.shared.hiddenCallbacks =
                                                n === null ? a : n.concat(a))))));
                            break;
                        case 26:
                            var o = Wn;
                            if (
                                (rn(t, e),
                                    cn(e),
                                    a & 512 && (mt || n === null || ta(n, n.return)),
                                    a & 4)
                            )
                                if (
                                    ((t = n !== null ? n.memoizedState : null),
                                        (a = e.memoizedState),
                                        n === null)
                                )
                                    if (a === null)
                                        if (e.stateNode === null) {
                                            e: {
                                                ((a = e.type),
                                                    (n = e.memoizedProps),
                                                    (t = o.ownerDocument || o));
                                                t: switch (a) {
                                                    case 'title':
                                                        ((o = t.getElementsByTagName('title')[0]),
                                                            (!o ||
                                                                o[hs] ||
                                                                o[Lt] ||
                                                                o.namespaceURI === _l ||
                                                                o.hasAttribute('itemprop')) &&
                                                            ((o = t.createElement(a)),
                                                                t.head.insertBefore(
                                                                    o,
                                                                    t.querySelector('head > title')
                                                                )),
                                                            Mt(o, a, n),
                                                            (o[Lt] = e),
                                                            M(o),
                                                            (a = o));
                                                        break e;
                                                    case 'link':
                                                        var c = ly('link', 'href', t).get(
                                                            a + (n.href || '')
                                                        );
                                                        if (c) {
                                                            for (var f = 0; f < c.length; f++)
                                                                if (
                                                                    ((o = c[f]),
                                                                        o.getAttribute('href') ===
                                                                        (n.href == null || n.href === ''
                                                                            ? null
                                                                            : n.href) &&
                                                                        o.getAttribute('rel') ===
                                                                        (n.rel == null ? null : n.rel) &&
                                                                        o.getAttribute('title') ===
                                                                        (n.title == null ? null : n.title) &&
                                                                        o.getAttribute('crossorigin') ===
                                                                        (n.crossOrigin == null
                                                                            ? null
                                                                            : n.crossOrigin))
                                                                ) {
                                                                    c.splice(f, 1);
                                                                    break t;
                                                                }
                                                        }
                                                        ((o = t.createElement(a)),
                                                            Mt(o, a, n),
                                                            t.head.appendChild(o));
                                                        break;
                                                    case 'meta':
                                                        if (
                                                            (c = ly('meta', 'content', t).get(
                                                                a + (n.content || '')
                                                            ))
                                                        ) {
                                                            for (f = 0; f < c.length; f++)
                                                                if (
                                                                    ((o = c[f]),
                                                                        ue(n.content, 'content'),
                                                                        o.getAttribute('content') ===
                                                                        (n.content == null
                                                                            ? null
                                                                            : '' + n.content) &&
                                                                        o.getAttribute('name') ===
                                                                        (n.name == null ? null : n.name) &&
                                                                        o.getAttribute('property') ===
                                                                        (n.property == null
                                                                            ? null
                                                                            : n.property) &&
                                                                        o.getAttribute('http-equiv') ===
                                                                        (n.httpEquiv == null
                                                                            ? null
                                                                            : n.httpEquiv) &&
                                                                        o.getAttribute('charset') ===
                                                                        (n.charSet == null
                                                                            ? null
                                                                            : n.charSet))
                                                                ) {
                                                                    c.splice(f, 1);
                                                                    break t;
                                                                }
                                                        }
                                                        ((o = t.createElement(a)),
                                                            Mt(o, a, n),
                                                            t.head.appendChild(o));
                                                        break;
                                                    default:
                                                        throw Error(
                                                            'getNodesForType encountered a type it did not expect: "' +
                                                            a +
                                                            '". This is a bug in React.'
                                                        );
                                                }
                                                ((o[Lt] = e), M(o), (a = o));
                                            }
                                            e.stateNode = a;
                                        } else oy(o, e.type, e.stateNode);
                                    else e.stateNode = iy(o, a, e.memoizedProps);
                                else
                                    t !== a
                                        ? (t === null
                                            ? n.stateNode !== null &&
                                            ((n = n.stateNode), n.parentNode.removeChild(n))
                                            : t.count--,
                                            a === null
                                                ? oy(o, e.type, e.stateNode)
                                                : iy(o, a, e.memoizedProps))
                                        : a === null &&
                                        e.stateNode !== null &&
                                        Kd(e, e.memoizedProps, n.memoizedProps);
                            break;
                        case 27:
                            (rn(t, e),
                                cn(e),
                                a & 512 && (mt || n === null || ta(n, n.return)),
                                n !== null &&
                                a & 4 &&
                                Kd(e, e.memoizedProps, n.memoizedProps));
                            break;
                        case 5:
                            if (
                                (rn(t, e),
                                    cn(e),
                                    a & 512 && (mt || n === null || ta(n, n.return)),
                                    e.flags & 32)
                            ) {
                                t = e.stateNode;
                                try {
                                    he(e, Qb, t);
                                } catch (V) {
                                    Qe(e, e.return, V);
                                }
                            }
                            (a & 4 &&
                                e.stateNode != null &&
                                ((t = e.memoizedProps),
                                    Kd(e, t, n !== null ? n.memoizedProps : t)),
                                a & 1024 &&
                                ((km = !0),
                                    e.type !== 'form' &&
                                    console.error(
                                        'Unexpected host component type. Expected a form. This is a bug in React.'
                                    )));
                            break;
                        case 6:
                            if ((rn(t, e), cn(e), a & 4)) {
                                if (e.stateNode === null)
                                    throw Error(
                                        'This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.'
                                    );
                                ((a = e.memoizedProps),
                                    (n = n !== null ? n.memoizedProps : a),
                                    (t = e.stateNode));
                                try {
                                    he(e, yx, t, n, a);
                                } catch (V) {
                                    Qe(e, e.return, V);
                                }
                            }
                            break;
                        case 3:
                            if (
                                ((o = wa()),
                                    (tu = null),
                                    (c = Wn),
                                    (Wn = oc(t.containerInfo)),
                                    rn(t, e),
                                    (Wn = c),
                                    cn(e),
                                    a & 4 && n !== null && n.memoizedState.isDehydrated)
                            )
                                try {
                                    he(e, Cx, t.containerInfo);
                                } catch (V) {
                                    Qe(e, e.return, V);
                                }
                            (km && ((km = !1), Kg(e)), (t.effectDuration += Cr(o)));
                            break;
                        case 4:
                            ((a = Wn),
                                (Wn = oc(e.stateNode.containerInfo)),
                                rn(t, e),
                                cn(e),
                                (Wn = a));
                            break;
                        case 12:
                            ((a = wa()),
                                rn(t, e),
                                cn(e),
                                (e.stateNode.effectDuration += Zo(a)));
                            break;
                        case 13:
                            (rn(t, e),
                                cn(e),
                                e.child.flags & 8192 &&
                                (e.memoizedState !== null) !=
                                (n !== null && n.memoizedState !== null) &&
                                (Im = oa()),
                                a & 4 &&
                                ((a = e.updateQueue),
                                    a !== null && ((e.updateQueue = null), nf(e, a))));
                            break;
                        case 22:
                            o = e.memoizedState !== null;
                            var g = n !== null && n.memoizedState !== null,
                                w = Ha,
                                A = mt;
                            if (
                                ((Ha = w || o),
                                    (mt = A || g),
                                    rn(t, e),
                                    (mt = A),
                                    (Ha = w),
                                    cn(e),
                                    a & 8192)
                            )
                                e: for (
                                    t = e.stateNode,
                                    t._visibility = o
                                        ? t._visibility & ~Ac
                                        : t._visibility | Ac,
                                    o && (n === null || g || Ha || mt || Xi(e)),
                                    n = null,
                                    t = e;
                                    ;
                                ) {
                                    if (t.tag === 5 || t.tag === 26) {
                                        if (n === null) {
                                            g = n = t;
                                            try {
                                                ((c = g.stateNode),
                                                    o
                                                        ? he(g, xx, c)
                                                        : he(g, wx, g.stateNode, g.memoizedProps));
                                            } catch (V) {
                                                Qe(g, g.return, V);
                                            }
                                        }
                                    } else if (t.tag === 6) {
                                        if (n === null) {
                                            g = t;
                                            try {
                                                ((f = g.stateNode),
                                                    o ? he(g, Nx, f) : he(g, Ex, f, g.memoizedProps));
                                            } catch (V) {
                                                Qe(g, g.return, V);
                                            }
                                        }
                                    } else if (
                                        ((t.tag !== 22 && t.tag !== 23) ||
                                            t.memoizedState === null ||
                                            t === e) &&
                                        t.child !== null
                                    ) {
                                        ((t.child.return = t), (t = t.child));
                                        continue;
                                    }
                                    if (t === e) break e;
                                    for (; t.sibling === null;) {
                                        if (t.return === null || t.return === e) break e;
                                        (n === t && (n = null), (t = t.return));
                                    }
                                    (n === t && (n = null),
                                        (t.sibling.return = t.return),
                                        (t = t.sibling));
                                }
                            a & 4 &&
                                ((a = e.updateQueue),
                                    a !== null &&
                                    ((n = a.retryQueue),
                                        n !== null && ((a.retryQueue = null), nf(e, n))));
                            break;
                        case 19:
                            (rn(t, e),
                                cn(e),
                                a & 4 &&
                                ((a = e.updateQueue),
                                    a !== null && ((e.updateQueue = null), nf(e, a))));
                            break;
                        case 30:
                            break;
                        case 21:
                            break;
                        default:
                            (rn(t, e), cn(e));
                    }
                }
                function cn(e) {
                    var t = e.flags;
                    if (t & 2) {
                        try {
                            he(e, JS, e);
                        } catch (n) {
                            Qe(e, e.return, n);
                        }
                        e.flags &= -3;
                    }
                    t & 4096 && (e.flags &= -4097);
                }
                function Kg(e) {
                    if (e.subtreeFlags & 1024)
                        for (e = e.child; e !== null;) {
                            var t = e;
                            (Kg(t),
                                t.tag === 5 && t.flags & 1024 && t.stateNode.reset(),
                                (e = e.sibling));
                        }
                }
                function Ca(e, t) {
                    if (t.subtreeFlags & 8772)
                        for (t = t.child; t !== null;)
                            (Qg(e, t.alternate, t), (t = t.sibling));
                }
                function eb(e) {
                    switch (e.tag) {
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            ($d(e, e.return, jt), Xi(e));
                            break;
                        case 1:
                            ta(e, e.return);
                            var t = e.stateNode;
                            (typeof t.componentWillUnmount == 'function' &&
                                Yg(e, e.return, t),
                                Xi(e));
                            break;
                        case 27:
                            he(e, rs, e.stateNode);
                        case 26:
                        case 5:
                            (ta(e, e.return), Xi(e));
                            break;
                        case 22:
                            e.memoizedState === null && Xi(e);
                            break;
                        case 30:
                            Xi(e);
                            break;
                        default:
                            Xi(e);
                    }
                }
                function Xi(e) {
                    for (e = e.child; e !== null;) (eb(e), (e = e.sibling));
                }
                function tb(e, t, n, a) {
                    var o = n.flags;
                    switch (n.tag) {
                        case 0:
                        case 11:
                        case 15:
                            (Ra(e, n, a), Ug(n, jt));
                            break;
                        case 1:
                            if (
                                (Ra(e, n, a),
                                    (t = n.stateNode),
                                    typeof t.componentDidMount == 'function' && he(n, Am, n, t),
                                    (t = n.updateQueue),
                                    t !== null)
                            ) {
                                e = n.stateNode;
                                try {
                                    he(n, zS, t, e);
                                } catch (c) {
                                    Qe(n, n.return, c);
                                }
                            }
                            (a && o & 64 && _g(n), ts(n, n.return));
                            break;
                        case 27:
                            Xg(n);
                        case 26:
                        case 5:
                            (Ra(e, n, a),
                                a && t === null && o & 4 && Zg(n),
                                ts(n, n.return));
                            break;
                        case 12:
                            if (a && o & 4) {
                                ((o = wa()),
                                    Ra(e, n, a),
                                    (a = n.stateNode),
                                    (a.effectDuration += Zo(o)));
                                try {
                                    he(n, Pg, n, t, Rc, a.effectDuration);
                                } catch (c) {
                                    Qe(n, n.return, c);
                                }
                            } else Ra(e, n, a);
                            break;
                        case 13:
                            (Ra(e, n, a), a && o & 4 && $g(e, n));
                            break;
                        case 22:
                            (n.memoizedState === null && Ra(e, n, a), ts(n, n.return));
                            break;
                        case 30:
                            break;
                        default:
                            Ra(e, n, a);
                    }
                }
                function Ra(e, t, n) {
                    for (
                        n = n && (t.subtreeFlags & 8772) !== 0, t = t.child;
                        t !== null;
                    )
                        (tb(e, t.alternate, t, n), (t = t.sibling));
                }
                function af(e, t) {
                    var n = null;
                    (e !== null &&
                        e.memoizedState !== null &&
                        e.memoizedState.cachePool !== null &&
                        (n = e.memoizedState.cachePool.pool),
                        (e = null),
                        t.memoizedState !== null &&
                        t.memoizedState.cachePool !== null &&
                        (e = t.memoizedState.cachePool.pool),
                        e !== n && (e != null && _i(e), n != null && Po(n)));
                }
                function lf(e, t) {
                    ((e = null),
                        t.alternate !== null && (e = t.alternate.memoizedState.cache),
                        (t = t.memoizedState.cache),
                        t !== e && (_i(t), e != null && Po(e)));
                }
                function na(e, t, n, a) {
                    if (t.subtreeFlags & 10256)
                        for (t = t.child; t !== null;)
                            (nb(e, t, n, a), (t = t.sibling));
                }
                function nb(e, t, n, a) {
                    var o = t.flags;
                    switch (t.tag) {
                        case 0:
                        case 11:
                        case 15:
                            (na(e, t, n, a), o & 2048 && Gg(t, St | Mn));
                            break;
                        case 1:
                            na(e, t, n, a);
                            break;
                        case 3:
                            var c = wa();
                            (na(e, t, n, a),
                                o & 2048 &&
                                ((n = null),
                                    t.alternate !== null &&
                                    (n = t.alternate.memoizedState.cache),
                                    (t = t.memoizedState.cache),
                                    t !== n && (_i(t), n != null && Po(n))),
                                (e.passiveEffectDuration += Cr(c)));
                            break;
                        case 12:
                            if (o & 2048) {
                                ((o = wa()),
                                    na(e, t, n, a),
                                    (e = t.stateNode),
                                    (e.passiveEffectDuration += Zo(o)));
                                try {
                                    he(t, QS, t, t.alternate, Rc, e.passiveEffectDuration);
                                } catch (g) {
                                    Qe(t, t.return, g);
                                }
                            } else na(e, t, n, a);
                            break;
                        case 13:
                            na(e, t, n, a);
                            break;
                        case 23:
                            break;
                        case 22:
                            c = t.stateNode;
                            var f = t.alternate;
                            (t.memoizedState !== null
                                ? c._visibility & ja
                                    ? na(e, t, n, a)
                                    : ns(e, t)
                                : c._visibility & ja
                                    ? na(e, t, n, a)
                                    : ((c._visibility |= ja),
                                        Rl(e, t, n, a, (t.subtreeFlags & 10256) !== 0)),
                                o & 2048 && af(f, t));
                            break;
                        case 24:
                            (na(e, t, n, a), o & 2048 && lf(t.alternate, t));
                            break;
                        default:
                            na(e, t, n, a);
                    }
                }
                function Rl(e, t, n, a, o) {
                    for (
                        o = o && (t.subtreeFlags & 10256) !== 0, t = t.child;
                        t !== null;
                    )
                        (ab(e, t, n, a, o), (t = t.sibling));
                }
                function ab(e, t, n, a, o) {
                    var c = t.flags;
                    switch (t.tag) {
                        case 0:
                        case 11:
                        case 15:
                            (Rl(e, t, n, a, o), Gg(t, St));
                            break;
                        case 23:
                            break;
                        case 22:
                            var f = t.stateNode;
                            (t.memoizedState !== null
                                ? f._visibility & ja
                                    ? Rl(e, t, n, a, o)
                                    : ns(e, t)
                                : ((f._visibility |= ja), Rl(e, t, n, a, o)),
                                o && c & 2048 && af(t.alternate, t));
                            break;
                        case 24:
                            (Rl(e, t, n, a, o), o && c & 2048 && lf(t.alternate, t));
                            break;
                        default:
                            Rl(e, t, n, a, o);
                    }
                }
                function ns(e, t) {
                    if (t.subtreeFlags & 10256)
                        for (t = t.child; t !== null;) {
                            var n = e,
                                a = t,
                                o = a.flags;
                            switch (a.tag) {
                                case 22:
                                    (ns(n, a), o & 2048 && af(a.alternate, a));
                                    break;
                                case 24:
                                    (ns(n, a), o & 2048 && lf(a.alternate, a));
                                    break;
                                default:
                                    ns(n, a);
                            }
                            t = t.sibling;
                        }
                }
                function Ml(e) {
                    if (e.subtreeFlags & Is)
                        for (e = e.child; e !== null;) (ib(e), (e = e.sibling));
                }
                function ib(e) {
                    switch (e.tag) {
                        case 26:
                            (Ml(e),
                                e.flags & Is &&
                                e.memoizedState !== null &&
                                Vx(Wn, e.memoizedState, e.memoizedProps));
                            break;
                        case 5:
                            Ml(e);
                            break;
                        case 3:
                        case 4:
                            var t = Wn;
                            ((Wn = oc(e.stateNode.containerInfo)), Ml(e), (Wn = t));
                            break;
                        case 22:
                            e.memoizedState === null &&
                                ((t = e.alternate),
                                    t !== null && t.memoizedState !== null
                                        ? ((t = Is), (Is = 16777216), Ml(e), (Is = t))
                                        : Ml(e));
                            break;
                        default:
                            Ml(e);
                    }
                }
                function lb(e) {
                    var t = e.alternate;
                    if (t !== null && ((e = t.child), e !== null)) {
                        t.child = null;
                        do ((t = e.sibling), (e.sibling = null), (e = t));
                        while (e !== null);
                    }
                }
                function as(e) {
                    var t = e.deletions;
                    if ((e.flags & 16) !== 0) {
                        if (t !== null)
                            for (var n = 0; n < t.length; n++) {
                                var a = t[n];
                                ((Dt = a), rb(a, e));
                            }
                        lb(e);
                    }
                    if (e.subtreeFlags & 10256)
                        for (e = e.child; e !== null;) (ob(e), (e = e.sibling));
                }
                function ob(e) {
                    switch (e.tag) {
                        case 0:
                        case 11:
                        case 15:
                            (as(e), e.flags & 2048 && Fd(e, e.return, St | Mn));
                            break;
                        case 3:
                            var t = wa();
                            (as(e), (e.stateNode.passiveEffectDuration += Cr(t)));
                            break;
                        case 12:
                            ((t = wa()),
                                as(e),
                                (e.stateNode.passiveEffectDuration += Zo(t)));
                            break;
                        case 22:
                            ((t = e.stateNode),
                                e.memoizedState !== null &&
                                    t._visibility & ja &&
                                    (e.return === null || e.return.tag !== 13)
                                    ? ((t._visibility &= ~ja), ec(e))
                                    : as(e));
                            break;
                        default:
                            as(e);
                    }
                }
                function ec(e) {
                    var t = e.deletions;
                    if ((e.flags & 16) !== 0) {
                        if (t !== null)
                            for (var n = 0; n < t.length; n++) {
                                var a = t[n];
                                ((Dt = a), rb(a, e));
                            }
                        lb(e);
                    }
                    for (e = e.child; e !== null;) (sb(e), (e = e.sibling));
                }
                function sb(e) {
                    switch (e.tag) {
                        case 0:
                        case 11:
                        case 15:
                            (Fd(e, e.return, St), ec(e));
                            break;
                        case 22:
                            var t = e.stateNode;
                            t._visibility & ja && ((t._visibility &= ~ja), ec(e));
                            break;
                        default:
                            ec(e);
                    }
                }
                function rb(e, t) {
                    for (; Dt !== null;) {
                        var n = Dt,
                            a = n;
                        switch (a.tag) {
                            case 0:
                            case 11:
                            case 15:
                                Fd(a, t, St);
                                break;
                            case 23:
                            case 22:
                                a.memoizedState !== null &&
                                    a.memoizedState.cachePool !== null &&
                                    ((a = a.memoizedState.cachePool.pool),
                                        a != null && _i(a));
                                break;
                            case 24:
                                Po(a.memoizedState.cache);
                        }
                        if (((a = n.child), a !== null)) ((a.return = n), (Dt = a));
                        else
                            e: for (n = e; Dt !== null;) {
                                a = Dt;
                                var o = a.sibling,
                                    c = a.return;
                                if ((Jg(a), a === n)) {
                                    Dt = null;
                                    break e;
                                }
                                if (o !== null) {
                                    ((o.return = c), (Dt = o));
                                    break e;
                                }
                                Dt = c;
                            }
                    }
                }
                function FS() {
                    fw.forEach(function (e) {
                        return e();
                    });
                }
                function cb() {
                    var e =
                        typeof IS_REACT_ACT_ENVIRONMENT < 'u'
                            ? IS_REACT_ACT_ENVIRONMENT
                            : void 0;
                    return (
                        e ||
                        B.actQueue === null ||
                        console.error(
                            'The current testing environment is not configured to support act(...)'
                        ),
                        e
                    );
                }
                function un(e) {
                    if ((Pe & Wt) !== mn && Ve !== 0) return Ve & -Ve;
                    var t = B.T;
                    return t !== null
                        ? (t._updatedFibers || (t._updatedFibers = new Set()),
                            t._updatedFibers.add(e),
                            (e = Ki),
                            e !== 0 ? e : pf())
                        : ko();
                }
                function ub() {
                    hn === 0 &&
                        (hn = (Ve & 536870912) === 0 || Ue ? Oe() : 536870912);
                    var e = kn.current;
                    return (e !== null && (e.flags |= 32), hn);
                }
                function ft(e, t, n) {
                    if (
                        (yo &&
                            console.error(
                                'useInsertionEffect must not schedule updates.'
                            ),
                            Ym && (Yc = !0),
                            ((e === Fe && (Ze === il || Ze === ll)) ||
                                e.cancelPendingCommit !== null) &&
                            (kl(e, 0), ii(e, Ve, hn, !1)),
                            Ja(e, n),
                            (Pe & Wt) !== 0 && e === Fe)
                    ) {
                        if (ca)
                            switch (t.tag) {
                                case 0:
                                case 11:
                                case 15:
                                    ((e = (ke && K(ke)) || 'Unknown'),
                                        N1.has(e) ||
                                        (N1.add(e),
                                            (t = K(t) || 'Unknown'),
                                            console.error(
                                                'Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render',
                                                t,
                                                e,
                                                e
                                            )));
                                    break;
                                case 1:
                                    x1 ||
                                        (console.error(
                                            'Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.'
                                        ),
                                            (x1 = !0));
                            }
                    } else
                        (_n && Mo(e, t, n),
                            rx(t),
                            e === Fe &&
                            ((Pe & Wt) === mn && (vi |= n),
                                rt === al && ii(e, Ve, hn, !1)),
                            aa(e));
                }
                function db(e, t, n) {
                    if ((Pe & (Wt | Xn)) !== mn)
                        throw Error('Should not already be working.');
                    var a =
                        (!n && (t & 124) === 0 && (t & e.expiredLanes) === 0) ||
                        Qa(e, t),
                        o = a ? ex(e, t) : rf(e, t, !0),
                        c = a;
                    do {
                        if (o === Ua) {
                            go && !a && ii(e, t, 0, !1);
                            break;
                        } else {
                            if (((n = e.current.alternate), c && !KS(n))) {
                                ((o = rf(e, t, !1)), (c = !1));
                                continue;
                            }
                            if (o === po) {
                                if (((c = t), e.errorRecoveryDisabledLanes & c)) var f = 0;
                                else
                                    ((f = e.pendingLanes & -536870913),
                                        (f = f !== 0 ? f : f & 536870912 ? 536870912 : 0));
                                if (f !== 0) {
                                    t = f;
                                    e: {
                                        o = e;
                                        var g = f;
                                        f = Ps;
                                        var w = o.current.memoizedState.isDehydrated;
                                        if (
                                            (w && (kl(o, g).flags |= 256),
                                                (g = rf(o, g, !1)),
                                                g !== po)
                                        ) {
                                            if (Bm && !w) {
                                                ((o.errorRecoveryDisabledLanes |= c),
                                                    (vi |= c),
                                                    (o = al));
                                                break e;
                                            }
                                            ((o = Xt),
                                                (Xt = f),
                                                o !== null &&
                                                (Xt === null ? (Xt = o) : Xt.push.apply(Xt, o)));
                                        }
                                        o = g;
                                    }
                                    if (((c = !1), o !== po)) continue;
                                }
                            }
                            if (o === Us) {
                                (kl(e, 0), ii(e, t, 0, !0));
                                break;
                            }
                            e: {
                                switch (((a = e), o)) {
                                    case Ua:
                                    case Us:
                                        throw Error(
                                            'Root did not complete. This is a bug in React.'
                                        );
                                    case al:
                                        if ((t & 4194048) !== t) break;
                                    case Uc:
                                        ii(a, t, hn, !bi);
                                        break e;
                                    case po:
                                        Xt = null;
                                        break;
                                    case jm:
                                    case m1:
                                        break;
                                    default:
                                        throw Error('Unknown root exit status.');
                                }
                                if (B.actQueue !== null)
                                    cf(a, n, t, Xt, Zs, Gc, hn, vi, ol);
                                else {
                                    if (
                                        (t & 62914560) === t &&
                                        ((c = Im + h1 - oa()), 10 < c)
                                    ) {
                                        if ((ii(a, t, hn, !bi), va(a, 0, !0) !== 0)) break e;
                                        a.timeoutHandle = M1(
                                            fb.bind(
                                                null,
                                                a,
                                                n,
                                                Xt,
                                                Zs,
                                                Gc,
                                                t,
                                                hn,
                                                vi,
                                                ol,
                                                bi,
                                                o,
                                                gw,
                                                bv,
                                                0
                                            ),
                                            c
                                        );
                                        break e;
                                    }
                                    fb(a, n, Xt, Zs, Gc, t, hn, vi, ol, bi, o, pw, bv, 0);
                                }
                            }
                        }
                        break;
                    } while (!0);
                    aa(e);
                }
                function fb(e, t, n, a, o, c, f, g, w, A, V, L, j, H) {
                    if (
                        ((e.timeoutHandle = dl),
                            (L = t.subtreeFlags),
                            (L & 8192 || (L & 16785408) === 16785408) &&
                            (($s = { stylesheets: null, count: 0, unsuspend: jx }),
                                ib(t),
                                (L = zx()),
                                L !== null))
                    ) {
                        ((e.cancelPendingCommit = L(
                            cf.bind(null, e, t, c, n, a, o, f, g, w, V, hw, j, H)
                        )),
                            ii(e, c, f, !A));
                        return;
                    }
                    cf(e, t, c, n, a, o, f, g, w);
                }
                function KS(e) {
                    for (var t = e; ;) {
                        var n = t.tag;
                        if (
                            (n === 0 || n === 11 || n === 15) &&
                            t.flags & 16384 &&
                            ((n = t.updateQueue),
                                n !== null && ((n = n.stores), n !== null))
                        )
                            for (var a = 0; a < n.length; a++) {
                                var o = n[a],
                                    c = o.getSnapshot;
                                o = o.value;
                                try {
                                    if (!Yt(c(), o)) return !1;
                                } catch {
                                    return !1;
                                }
                            }
                        if (((n = t.child), t.subtreeFlags & 16384 && n !== null))
                            ((n.return = t), (t = n));
                        else {
                            if (t === e) break;
                            for (; t.sibling === null;) {
                                if (t.return === null || t.return === e) return !0;
                                t = t.return;
                            }
                            ((t.sibling.return = t.return), (t = t.sibling));
                        }
                    }
                    return !0;
                }
                function ii(e, t, n, a) {
                    ((t &= ~Lm),
                        (t &= ~vi),
                        (e.suspendedLanes |= t),
                        (e.pingedLanes &= ~t),
                        a && (e.warmLanes |= t),
                        (a = e.expirationTimes));
                    for (var o = t; 0 < o;) {
                        var c = 31 - Gt(o),
                            f = 1 << c;
                        ((a[c] = -1), (o &= ~f));
                    }
                    n !== 0 && Co(e, n, t);
                }
                function Ol() {
                    return (Pe & (Wt | Xn)) === mn ? (os(0), !1) : !0;
                }
                function of() {
                    if (ke !== null) {
                        if (Ze === an) var e = ke.return;
                        else ((e = ke), Ar(), gd(e), (oo = null), (Bs = 0), (e = ke));
                        for (; e !== null;) (Hg(e.alternate, e), (e = e.return));
                        ke = null;
                    }
                }
                function kl(e, t) {
                    var n = e.timeoutHandle;
                    (n !== dl && ((e.timeoutHandle = dl), Rw(n)),
                        (n = e.cancelPendingCommit),
                        n !== null && ((e.cancelPendingCommit = null), n()),
                        of(),
                        (Fe = e),
                        (ke = n = xa(e.current, null)),
                        (Ve = t),
                        (Ze = an),
                        (pn = null),
                        (bi = !1),
                        (go = Qa(e, t)),
                        (Bm = !1),
                        (rt = Ua),
                        (ol = hn = Lm = vi = yi = 0),
                        (Xt = Ps = null),
                        (Gc = !1),
                        (t & 8) !== 0 && (t |= t & 32));
                    var a = e.entangledLanes;
                    if (a !== 0)
                        for (e = e.entanglements, a &= t; 0 < a;) {
                            var o = 31 - Gt(a),
                                c = 1 << o;
                            ((t |= e[o]), (a &= ~c));
                        }
                    return (
                        (pa = t),
                        xr(),
                        (t = hv()),
                        1e3 < t - pv && ((B.recentlyCreatedOwnerStacks = 0), (pv = t)),
                        Pn.discardPendingWarnings(),
                        n
                    );
                }
                function mb(e, t) {
                    ((ve = null),
                        (B.H = Ic),
                        (B.getCurrentStack = null),
                        (ca = !1),
                        (fn = null),
                        t === ks || t === jc
                            ? ((t = Uh()), (Ze = _s))
                            : t === Sv
                                ? ((t = Uh()), (Ze = p1))
                                : (Ze =
                                    t === i1
                                        ? zm
                                        : t !== null &&
                                            typeof t == 'object' &&
                                            typeof t.then == 'function'
                                            ? ho
                                            : Gs),
                        (pn = t));
                    var n = ke;
                    if (n === null) ((rt = Us), Jr(e, sn(t, e.current)));
                    else
                        switch ((n.mode & kt && ld(n), bn(), Ze)) {
                            case Gs:
                                se !== null &&
                                    typeof se.markComponentErrored == 'function' &&
                                    se.markComponentErrored(n, t, Ve);
                                break;
                            case il:
                            case ll:
                            case _s:
                            case ho:
                            case Ys:
                                se !== null &&
                                    typeof se.markComponentSuspended == 'function' &&
                                    se.markComponentSuspended(n, t, Ve);
                        }
                }
                function pb() {
                    var e = B.H;
                    return ((B.H = Ic), e === null ? Ic : e);
                }
                function hb() {
                    var e = B.A;
                    return ((B.A = dw), e);
                }
                function sf() {
                    ((rt = al),
                        bi ||
                        ((Ve & 4194048) !== Ve && kn.current !== null) ||
                        (go = !0),
                        ((yi & 134217727) === 0 && (vi & 134217727) === 0) ||
                        Fe === null ||
                        ii(Fe, Ve, hn, !1));
                }
                function rf(e, t, n) {
                    var a = Pe;
                    Pe |= Wt;
                    var o = pb(),
                        c = hb();
                    if (Fe !== e || Ve !== t) {
                        if (_n) {
                            var f = e.memoizedUpdaters;
                            (0 < f.size && (ls(e, Ve), f.clear()), Oo(e, t));
                        }
                        ((Zs = null), kl(e, t));
                    }
                    (Mi(t), (t = !1), (f = rt));
                    e: do
                        try {
                            if (Ze !== an && ke !== null) {
                                var g = ke,
                                    w = pn;
                                switch (Ze) {
                                    case zm:
                                        (of(), (f = Uc));
                                        break e;
                                    case _s:
                                    case il:
                                    case ll:
                                    case ho:
                                        kn.current === null && (t = !0);
                                        var A = Ze;
                                        if (((Ze = an), (pn = null), jl(e, g, w, A), n && go)) {
                                            f = Ua;
                                            break e;
                                        }
                                        break;
                                    default:
                                        ((A = Ze), (Ze = an), (pn = null), jl(e, g, w, A));
                                }
                            }
                            (gb(), (f = rt));
                            break;
                        } catch (V) {
                            mb(e, V);
                        }
                    while (!0);
                    return (
                        t && e.shellSuspendCounter++,
                        Ar(),
                        (Pe = a),
                        (B.H = o),
                        (B.A = c),
                        Do(),
                        ke === null && ((Fe = null), (Ve = 0), xr()),
                        f
                    );
                }
                function gb() {
                    for (; ke !== null;) bb(ke);
                }
                function ex(e, t) {
                    var n = Pe;
                    Pe |= Wt;
                    var a = pb(),
                        o = hb();
                    if (Fe !== e || Ve !== t) {
                        if (_n) {
                            var c = e.memoizedUpdaters;
                            (0 < c.size && (ls(e, Ve), c.clear()), Oo(e, t));
                        }
                        ((Zs = null), (_c = oa() + g1), kl(e, t));
                    } else go = Qa(e, t);
                    Mi(t);
                    e: do
                        try {
                            if (Ze !== an && ke !== null)
                                t: switch (((t = ke), (c = pn), Ze)) {
                                    case Gs:
                                        ((Ze = an), (pn = null), jl(e, t, c, Gs));
                                        break;
                                    case il:
                                    case ll:
                                        if (Ih(c)) {
                                            ((Ze = an), (pn = null), yb(t));
                                            break;
                                        }
                                        ((t = function () {
                                            ((Ze !== il && Ze !== ll) || Fe !== e || (Ze = Ys),
                                                aa(e));
                                        }),
                                            c.then(t, t));
                                        break e;
                                    case _s:
                                        Ze = Ys;
                                        break e;
                                    case p1:
                                        Ze = Vm;
                                        break e;
                                    case Ys:
                                        Ih(c)
                                            ? ((Ze = an), (pn = null), yb(t))
                                            : ((Ze = an), (pn = null), jl(e, t, c, Ys));
                                        break;
                                    case Vm:
                                        var f = null;
                                        switch (ke.tag) {
                                            case 26:
                                                f = ke.memoizedState;
                                            case 5:
                                            case 27:
                                                var g = ke;
                                                if (!f || sy(f)) {
                                                    ((Ze = an), (pn = null));
                                                    var w = g.sibling;
                                                    if (w !== null) ke = w;
                                                    else {
                                                        var A = g.return;
                                                        A !== null ? ((ke = A), tc(A)) : (ke = null);
                                                    }
                                                    break t;
                                                }
                                                break;
                                            default:
                                                console.error(
                                                    'Unexpected type of fiber triggered a suspensey commit. This is a bug in React.'
                                                );
                                        }
                                        ((Ze = an), (pn = null), jl(e, t, c, Vm));
                                        break;
                                    case ho:
                                        ((Ze = an), (pn = null), jl(e, t, c, ho));
                                        break;
                                    case zm:
                                        (of(), (rt = Uc));
                                        break e;
                                    default:
                                        throw Error(
                                            'Unexpected SuspendedReason. This is a bug in React.'
                                        );
                                }
                            B.actQueue !== null ? gb() : tx();
                            break;
                        } catch (V) {
                            mb(e, V);
                        }
                    while (!0);
                    return (
                        Ar(),
                        (B.H = a),
                        (B.A = o),
                        (Pe = n),
                        ke !== null
                            ? (se !== null &&
                                typeof se.markRenderYielded == 'function' &&
                                se.markRenderYielded(),
                                Ua)
                            : (Do(), (Fe = null), (Ve = 0), xr(), rt)
                    );
                }
                function tx() {
                    for (; ke !== null && !$x();) bb(ke);
                }
                function bb(e) {
                    var t = e.alternate;
                    ((e.mode & kt) !== et
                        ? (id(e), (t = he(e, qd, t, e, pa)), ld(e))
                        : (t = he(e, qd, t, e, pa)),
                        (e.memoizedProps = e.pendingProps),
                        t === null ? tc(e) : (ke = t));
                }
                function yb(e) {
                    var t = he(e, nx, e);
                    ((e.memoizedProps = e.pendingProps),
                        t === null ? tc(e) : (ke = t));
                }
                function nx(e) {
                    var t = e.alternate,
                        n = (e.mode & kt) !== et;
                    switch ((n && id(e), e.tag)) {
                        case 15:
                        case 0:
                            t = Og(t, e, e.pendingProps, e.type, void 0, Ve);
                            break;
                        case 11:
                            t = Og(t, e, e.pendingProps, e.type.render, e.ref, Ve);
                            break;
                        case 5:
                            gd(e);
                        default:
                            (Hg(t, e), (e = ke = Th(e, pa)), (t = qd(t, e, pa)));
                    }
                    return (n && ld(e), t);
                }
                function jl(e, t, n, a) {
                    (Ar(), gd(t), (oo = null), (Bs = 0));
                    var o = t.return;
                    try {
                        if (GS(e, o, t, n, Ve)) {
                            ((rt = Us), Jr(e, sn(n, e.current)), (ke = null));
                            return;
                        }
                    } catch (c) {
                        if (o !== null) throw ((ke = o), c);
                        ((rt = Us), Jr(e, sn(n, e.current)), (ke = null));
                        return;
                    }
                    t.flags & 32768
                        ? (Ue || a === Gs
                            ? (e = !0)
                            : go || (Ve & 536870912) !== 0
                                ? (e = !1)
                                : ((bi = e = !0),
                                    (a === il || a === ll || a === _s || a === ho) &&
                                    ((a = kn.current),
                                        a !== null && a.tag === 13 && (a.flags |= 16384))),
                            vb(t, e))
                        : tc(t);
                }
                function tc(e) {
                    var t = e;
                    do {
                        if ((t.flags & 32768) !== 0) {
                            vb(t, bi);
                            return;
                        }
                        var n = t.alternate;
                        if (
                            ((e = t.return),
                                id(t),
                                (n = he(t, YS, n, t, pa)),
                                (t.mode & kt) !== et && Vh(t),
                                n !== null)
                        ) {
                            ke = n;
                            return;
                        }
                        if (((t = t.sibling), t !== null)) {
                            ke = t;
                            return;
                        }
                        ke = t = e;
                    } while (t !== null);
                    rt === Ua && (rt = m1);
                }
                function vb(e, t) {
                    do {
                        var n = PS(e.alternate, e);
                        if (n !== null) {
                            ((n.flags &= 32767), (ke = n));
                            return;
                        }
                        if ((e.mode & kt) !== et) {
                            (Vh(e), (n = e.actualDuration));
                            for (var a = e.child; a !== null;)
                                ((n += a.actualDuration), (a = a.sibling));
                            e.actualDuration = n;
                        }
                        if (
                            ((n = e.return),
                                n !== null &&
                                ((n.flags |= 32768),
                                    (n.subtreeFlags = 0),
                                    (n.deletions = null)),
                                !t && ((e = e.sibling), e !== null))
                        ) {
                            ke = e;
                            return;
                        }
                        ke = e = n;
                    } while (e !== null);
                    ((rt = Uc), (ke = null));
                }
                function cf(e, t, n, a, o, c, f, g, w) {
                    e.cancelPendingCommit = null;
                    do is();
                    while (Vt !== sl);
                    if (
                        (Pn.flushLegacyContextWarning(),
                            Pn.flushPendingUnsafeLifecycleWarnings(),
                            (Pe & (Wt | Xn)) !== mn)
                    )
                        throw Error('Should not already be working.');
                    if (
                        (se !== null &&
                            typeof se.markCommitStarted == 'function' &&
                            se.markCommitStarted(n),
                            t === null)
                    )
                        ot();
                    else {
                        if (
                            (n === 0 &&
                                console.error(
                                    'finishedLanes should not be empty during a commit. This is a bug in React.'
                                ),
                                t === e.current)
                        )
                            throw Error(
                                'Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.'
                            );
                        if (
                            ((c = t.lanes | t.childLanes),
                                (c |= fm),
                                dr(e, n, c, f, g, w),
                                e === Fe && ((ke = Fe = null), (Ve = 0)),
                                (bo = t),
                                (xi = e),
                                (Ni = n),
                                (Um = c),
                                (Gm = o),
                                (S1 = a),
                                (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
                                    ? ((e.callbackNode = null),
                                        (e.callbackPriority = 0),
                                        sx(Hl, function () {
                                            return (Eb(), null);
                                        }))
                                    : ((e.callbackNode = null), (e.callbackPriority = 0)),
                                (Rc = to()),
                                (a = (t.flags & 13878) !== 0),
                                (t.subtreeFlags & 13878) !== 0 || a)
                        ) {
                            ((a = B.T),
                                (B.T = null),
                                (o = Ye.p),
                                (Ye.p = wn),
                                (f = Pe),
                                (Pe |= Xn));
                            try {
                                qS(e, t);
                            } finally {
                                ((Pe = f), (Ye.p = o), (B.T = a));
                            }
                        }
                        ((Vt = b1), Sb(), xb(), Nb());
                    }
                }
                function Sb() {
                    if (Vt === b1) {
                        Vt = sl;
                        var e = xi,
                            t = bo,
                            n = Ni,
                            a = (t.flags & 13878) !== 0;
                        if ((t.subtreeFlags & 13878) !== 0 || a) {
                            ((a = B.T), (B.T = null));
                            var o = Ye.p;
                            Ye.p = wn;
                            var c = Pe;
                            Pe |= Xn;
                            try {
                                ((fo = n), (mo = e), Fg(t, e), (mo = fo = null), (n = Fm));
                                var f = Nh(e.containerInfo),
                                    g = n.focusedElem,
                                    w = n.selectionRange;
                                if (
                                    f !== g &&
                                    g &&
                                    g.ownerDocument &&
                                    xh(g.ownerDocument.documentElement, g)
                                ) {
                                    if (w !== null && Pu(g)) {
                                        var A = w.start,
                                            V = w.end;
                                        if ((V === void 0 && (V = A), 'selectionStart' in g))
                                            ((g.selectionStart = A),
                                                (g.selectionEnd = Math.min(V, g.value.length)));
                                        else {
                                            var L = g.ownerDocument || document,
                                                j = (L && L.defaultView) || window;
                                            if (j.getSelection) {
                                                var H = j.getSelection(),
                                                    fe = g.textContent.length,
                                                    be = Math.min(w.start, fe),
                                                    Ke = w.end === void 0 ? be : Math.min(w.end, fe);
                                                !H.extend &&
                                                    be > Ke &&
                                                    ((f = Ke), (Ke = be), (be = f));
                                                var Le = Sh(g, be),
                                                    T = Sh(g, Ke);
                                                if (
                                                    Le &&
                                                    T &&
                                                    (H.rangeCount !== 1 ||
                                                        H.anchorNode !== Le.node ||
                                                        H.anchorOffset !== Le.offset ||
                                                        H.focusNode !== T.node ||
                                                        H.focusOffset !== T.offset)
                                                ) {
                                                    var C = L.createRange();
                                                    (C.setStart(Le.node, Le.offset),
                                                        H.removeAllRanges(),
                                                        be > Ke
                                                            ? (H.addRange(C), H.extend(T.node, T.offset))
                                                            : (C.setEnd(T.node, T.offset),
                                                                H.addRange(C)));
                                                }
                                            }
                                        }
                                    }
                                    for (L = [], H = g; (H = H.parentNode);)
                                        H.nodeType === 1 &&
                                            L.push({
                                                element: H,
                                                left: H.scrollLeft,
                                                top: H.scrollTop,
                                            });
                                    for (
                                        typeof g.focus == 'function' && g.focus(), g = 0;
                                        g < L.length;
                                        g++
                                    ) {
                                        var R = L[g];
                                        ((R.element.scrollLeft = R.left),
                                            (R.element.scrollTop = R.top));
                                    }
                                }
                                ((iu = !!$m), (Fm = $m = null));
                            } finally {
                                ((Pe = c), (Ye.p = o), (B.T = a));
                            }
                        }
                        ((e.current = t), (Vt = y1));
                    }
                }
                function xb() {
                    if (Vt === y1) {
                        Vt = sl;
                        var e = xi,
                            t = bo,
                            n = Ni,
                            a = (t.flags & 8772) !== 0;
                        if ((t.subtreeFlags & 8772) !== 0 || a) {
                            ((a = B.T), (B.T = null));
                            var o = Ye.p;
                            Ye.p = wn;
                            var c = Pe;
                            Pe |= Xn;
                            try {
                                (se !== null &&
                                    typeof se.markLayoutEffectsStarted == 'function' &&
                                    se.markLayoutEffectsStarted(n),
                                    (fo = n),
                                    (mo = e),
                                    Qg(e, t.alternate, t),
                                    (mo = fo = null),
                                    se !== null &&
                                    typeof se.markLayoutEffectsStopped == 'function' &&
                                    se.markLayoutEffectsStopped());
                            } finally {
                                ((Pe = c), (Ye.p = o), (B.T = a));
                            }
                        }
                        Vt = v1;
                    }
                }
                function Nb() {
                    if (Vt === bw || Vt === v1) {
                        ((Vt = sl), Fx());
                        var e = xi,
                            t = bo,
                            n = Ni,
                            a = S1,
                            o = (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0;
                        o
                            ? (Vt = Hm)
                            : ((Vt = sl),
                                (bo = xi = null),
                                wb(e, e.pendingLanes),
                                (rl = 0),
                                (Xs = null));
                        var c = e.pendingLanes;
                        if (
                            (c === 0 && (Si = null),
                                o || Cb(e),
                                (o = vl(n)),
                                (t = t.stateNode),
                                Bt && typeof Bt.onCommitFiberRoot == 'function')
                        )
                            try {
                                var f = (t.current.flags & 128) === 128;
                                switch (o) {
                                    case wn:
                                        var g = Pf;
                                        break;
                                    case ra:
                                        g = Zf;
                                        break;
                                    case ka:
                                        g = Hl;
                                        break;
                                    case yc:
                                        g = Wf;
                                        break;
                                    default:
                                        g = Hl;
                                }
                                Bt.onCommitFiberRoot(Ul, t, g, f);
                            } catch (L) {
                                sa ||
                                    ((sa = !0),
                                        console.error(
                                            'React instrumentation encountered an error: %s',
                                            L
                                        ));
                            }
                        if ((_n && e.memoizedUpdaters.clear(), FS(), a !== null)) {
                            ((f = B.T), (g = Ye.p), (Ye.p = wn), (B.T = null));
                            try {
                                var w = e.onRecoverableError;
                                for (t = 0; t < a.length; t++) {
                                    var A = a[t],
                                        V = ax(A.stack);
                                    he(A.source, w, A.value, V);
                                }
                            } finally {
                                ((B.T = f), (Ye.p = g));
                            }
                        }
                        ((Ni & 3) !== 0 && is(),
                            aa(e),
                            (c = e.pendingLanes),
                            (n & 4194090) !== 0 && (c & 42) !== 0
                                ? ((Oc = !0), e === _m ? Ws++ : ((Ws = 0), (_m = e)))
                                : (Ws = 0),
                            os(0),
                            ot());
                    }
                }
                function ax(e) {
                    return (
                        (e = { componentStack: e }),
                        Object.defineProperty(e, 'digest', {
                            get: function () {
                                console.error(
                                    'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
                                );
                            },
                        }),
                        e
                    );
                }
                function wb(e, t) {
                    (e.pooledCacheLanes &= t) === 0 &&
                        ((t = e.pooledCache),
                            t != null && ((e.pooledCache = null), Po(t)));
                }
                function is(e) {
                    return (Sb(), xb(), Nb(), Eb());
                }
                function Eb() {
                    if (Vt !== Hm) return !1;
                    var e = xi,
                        t = Um;
                    Um = 0;
                    var n = vl(Ni),
                        a = ka > n ? ka : n;
                    n = B.T;
                    var o = Ye.p;
                    try {
                        ((Ye.p = a), (B.T = null), (a = Gm), (Gm = null));
                        var c = xi,
                            f = Ni;
                        if (
                            ((Vt = sl),
                                (bo = xi = null),
                                (Ni = 0),
                                (Pe & (Wt | Xn)) !== mn)
                        )
                            throw Error(
                                'Cannot flush passive effects while already rendering.'
                            );
                        ((Ym = !0),
                            (Yc = !1),
                            se !== null &&
                            typeof se.markPassiveEffectsStarted == 'function' &&
                            se.markPassiveEffectsStarted(f));
                        var g = Pe;
                        if (
                            ((Pe |= Xn),
                                ob(c.current),
                                nb(c, c.current, f, a),
                                se !== null &&
                                typeof se.markPassiveEffectsStopped == 'function' &&
                                se.markPassiveEffectsStopped(),
                                Cb(c),
                                (Pe = g),
                                os(0),
                                Yc ? (c === Xs ? rl++ : ((rl = 0), (Xs = c))) : (rl = 0),
                                (Yc = Ym = !1),
                                Bt && typeof Bt.onPostCommitFiberRoot == 'function')
                        )
                            try {
                                Bt.onPostCommitFiberRoot(Ul, c);
                            } catch (A) {
                                sa ||
                                    ((sa = !0),
                                        console.error(
                                            'React instrumentation encountered an error: %s',
                                            A
                                        ));
                            }
                        var w = c.current.stateNode;
                        return (
                            (w.effectDuration = 0),
                            (w.passiveEffectDuration = 0),
                            !0
                        );
                    } finally {
                        ((Ye.p = o), (B.T = n), wb(e, t));
                    }
                }
                function Ab(e, t, n) {
                    ((t = sn(n, t)),
                        (t = Hd(e.stateNode, t, 2)),
                        (e = ei(e, t, 2)),
                        e !== null && (Ja(e, 2), aa(e)));
                }
                function Qe(e, t, n) {
                    if (((yo = !1), e.tag === 3)) Ab(e, e, n);
                    else {
                        for (; t !== null;) {
                            if (t.tag === 3) {
                                Ab(t, e, n);
                                return;
                            }
                            if (t.tag === 1) {
                                var a = t.stateNode;
                                if (
                                    typeof t.type.getDerivedStateFromError == 'function' ||
                                    (typeof a.componentDidCatch == 'function' &&
                                        (Si === null || !Si.has(a)))
                                ) {
                                    ((e = sn(n, e)),
                                        (n = Ud(2)),
                                        (a = ei(t, n, 2)),
                                        a !== null && (Gd(n, a, t, e), Ja(a, 2), aa(a)));
                                    return;
                                }
                            }
                            t = t.return;
                        }
                        console.error(
                            `Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,
                            n
                        );
                    }
                }
                function uf(e, t, n) {
                    var a = e.pingCache;
                    if (a === null) {
                        a = e.pingCache = new mw();
                        var o = new Set();
                        a.set(t, o);
                    } else
                        ((o = a.get(t)),
                            o === void 0 && ((o = new Set()), a.set(t, o)));
                    o.has(n) ||
                        ((Bm = !0),
                            o.add(n),
                            (a = ix.bind(null, e, t, n)),
                            _n && ls(e, n),
                            t.then(a, a));
                }
                function ix(e, t, n) {
                    var a = e.pingCache;
                    (a !== null && a.delete(t),
                        (e.pingedLanes |= e.suspendedLanes & n),
                        (e.warmLanes &= ~n),
                        cb() &&
                        B.actQueue === null &&
                        console.error(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`),
                        Fe === e &&
                        (Ve & n) === n &&
                        (rt === al ||
                            (rt === jm && (Ve & 62914560) === Ve && oa() - Im < h1)
                            ? (Pe & Wt) === mn && kl(e, 0)
                            : (Lm |= n),
                            ol === Ve && (ol = 0)),
                        aa(e));
                }
                function Db(e, t) {
                    (t === 0 && (t = Oi()),
                        (e = $t(e, t)),
                        e !== null && (Ja(e, t), aa(e)));
                }
                function lx(e) {
                    var t = e.memoizedState,
                        n = 0;
                    (t !== null && (n = t.retryLane), Db(e, n));
                }
                function ox(e, t) {
                    var n = 0;
                    switch (e.tag) {
                        case 13:
                            var a = e.stateNode,
                                o = e.memoizedState;
                            o !== null && (n = o.retryLane);
                            break;
                        case 19:
                            a = e.stateNode;
                            break;
                        case 22:
                            a = e.stateNode._retryCache;
                            break;
                        default:
                            throw Error(
                                'Pinged unknown suspense boundary type. This is probably a bug in React.'
                            );
                    }
                    (a !== null && a.delete(t), Db(e, n));
                }
                function df(e, t, n) {
                    if ((t.subtreeFlags & 67117056) !== 0)
                        for (t = t.child; t !== null;) {
                            var a = e,
                                o = t,
                                c = o.type === mc;
                            ((c = n || c),
                                o.tag !== 22
                                    ? o.flags & 67108864
                                        ? c && he(o, Tb, a, o, (o.mode & fv) === et)
                                        : df(a, o, c)
                                    : o.memoizedState === null &&
                                    (c && o.flags & 8192
                                        ? he(o, Tb, a, o)
                                        : o.subtreeFlags & 67108864 && he(o, df, a, o, c)),
                                (t = t.sibling));
                        }
                }
                function Tb(e, t) {
                    var n =
                        2 < arguments.length && arguments[2] !== void 0
                            ? arguments[2]
                            : !0;
                    Ie(!0);
                    try {
                        (eb(t),
                            n && sb(t),
                            tb(e, t.alternate, t, !1),
                            n && ab(e, t, 0, null, !1));
                    } finally {
                        Ie(!1);
                    }
                }
                function Cb(e) {
                    var t = !0;
                    (e.current.mode & (It | Yn) || (t = !1), df(e, e.current, t));
                }
                function Rb(e) {
                    if ((Pe & Wt) === mn) {
                        var t = e.tag;
                        if (
                            t === 3 ||
                            t === 1 ||
                            t === 0 ||
                            t === 11 ||
                            t === 14 ||
                            t === 15
                        ) {
                            if (((t = K(e) || 'ReactComponent'), Pc !== null)) {
                                if (Pc.has(t)) return;
                                Pc.add(t);
                            } else Pc = new Set([t]);
                            he(e, function () {
                                console.error(
                                    "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead."
                                );
                            });
                        }
                    }
                }
                function ls(e, t) {
                    _n &&
                        e.memoizedUpdaters.forEach(function (n) {
                            Mo(e, n, t);
                        });
                }
                function sx(e, t) {
                    var n = B.actQueue;
                    return n !== null ? (n.push(t), Sw) : Yf(e, t);
                }
                function rx(e) {
                    cb() &&
                        B.actQueue === null &&
                        he(e, function () {
                            console.error(
                                `An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`,
                                K(e)
                            );
                        });
                }
                function aa(e) {
                    (e !== vo &&
                        e.next === null &&
                        (vo === null ? (Zc = vo = e) : (vo = vo.next = e)),
                        (Wc = !0),
                        B.actQueue !== null
                            ? Zm || ((Zm = !0), jb())
                            : Pm || ((Pm = !0), jb()));
                }
                function os(e, t) {
                    if (!Wm && Wc) {
                        Wm = !0;
                        do
                            for (var n = !1, a = Zc; a !== null;) {
                                if (e !== 0) {
                                    var o = a.pendingLanes;
                                    if (o === 0) var c = 0;
                                    else {
                                        var f = a.suspendedLanes,
                                            g = a.pingedLanes;
                                        ((c = (1 << (31 - Gt(42 | e) + 1)) - 1),
                                            (c &= o & ~(f & ~g)),
                                            (c =
                                                c & 201326741
                                                    ? (c & 201326741) | 1
                                                    : c
                                                        ? c | 2
                                                        : 0));
                                    }
                                    c !== 0 && ((n = !0), kb(a, c));
                                } else
                                    ((c = Ve),
                                        (c = va(
                                            a,
                                            a === Fe ? c : 0,
                                            a.cancelPendingCommit !== null ||
                                            a.timeoutHandle !== dl
                                        )),
                                        (c & 3) === 0 || Qa(a, c) || ((n = !0), kb(a, c)));
                                a = a.next;
                            }
                        while (n);
                        Wm = !1;
                    }
                }
                function cx() {
                    ff();
                }
                function ff() {
                    Wc = Zm = Pm = !1;
                    var e = 0;
                    cl !== 0 && (px() && (e = cl), (cl = 0));
                    for (var t = oa(), n = null, a = Zc; a !== null;) {
                        var o = a.next,
                            c = Mb(a, t);
                        (c === 0
                            ? ((a.next = null),
                                n === null ? (Zc = o) : (n.next = o),
                                o === null && (vo = n))
                            : ((n = a), (e !== 0 || (c & 3) !== 0) && (Wc = !0)),
                            (a = o));
                    }
                    os(e);
                }
                function Mb(e, t) {
                    for (
                        var n = e.suspendedLanes,
                        a = e.pingedLanes,
                        o = e.expirationTimes,
                        c = e.pendingLanes & -62914561;
                        0 < c;
                    ) {
                        var f = 31 - Gt(c),
                            g = 1 << f,
                            w = o[f];
                        (w === -1
                            ? ((g & n) === 0 || (g & a) !== 0) && (o[f] = Mu(g, t))
                            : w <= t && (e.expiredLanes |= g),
                            (c &= ~g));
                    }
                    if (
                        ((t = Fe),
                            (n = Ve),
                            (n = va(
                                e,
                                e === t ? n : 0,
                                e.cancelPendingCommit !== null || e.timeoutHandle !== dl
                            )),
                            (a = e.callbackNode),
                            n === 0 ||
                            (e === t && (Ze === il || Ze === ll)) ||
                            e.cancelPendingCommit !== null)
                    )
                        return (
                            a !== null && mf(a),
                            (e.callbackNode = null),
                            (e.callbackPriority = 0)
                        );
                    if ((n & 3) === 0 || Qa(e, n)) {
                        if (
                            ((t = n & -n),
                                t !== e.callbackPriority || (B.actQueue !== null && a !== Xm))
                        )
                            mf(a);
                        else return t;
                        switch (vl(n)) {
                            case wn:
                            case ra:
                                n = Zf;
                                break;
                            case ka:
                                n = Hl;
                                break;
                            case yc:
                                n = Wf;
                                break;
                            default:
                                n = Hl;
                        }
                        return (
                            (a = Ob.bind(null, e)),
                            B.actQueue !== null
                                ? (B.actQueue.push(a), (n = Xm))
                                : (n = Yf(n, a)),
                            (e.callbackPriority = t),
                            (e.callbackNode = n),
                            t
                        );
                    }
                    return (
                        a !== null && mf(a),
                        (e.callbackPriority = 2),
                        (e.callbackNode = null),
                        2
                    );
                }
                function Ob(e, t) {
                    if (((Oc = Mc = !1), Vt !== sl && Vt !== Hm))
                        return (
                            (e.callbackNode = null),
                            (e.callbackPriority = 0),
                            null
                        );
                    var n = e.callbackNode;
                    if (is() && e.callbackNode !== n) return null;
                    var a = Ve;
                    return (
                        (a = va(
                            e,
                            e === Fe ? a : 0,
                            e.cancelPendingCommit !== null || e.timeoutHandle !== dl
                        )),
                        a === 0
                            ? null
                            : (db(e, a, t),
                                Mb(e, oa()),
                                e.callbackNode != null && e.callbackNode === n
                                    ? Ob.bind(null, e)
                                    : null)
                    );
                }
                function kb(e, t) {
                    if (is()) return null;
                    ((Mc = Oc), (Oc = !1), db(e, t, !0));
                }
                function mf(e) {
                    e !== Xm && e !== null && qx(e);
                }
                function jb() {
                    (B.actQueue !== null &&
                        B.actQueue.push(function () {
                            return (ff(), null);
                        }),
                        Mw(function () {
                            (Pe & (Wt | Xn)) !== mn ? Yf(Pf, cx) : ff();
                        }));
                }
                function pf() {
                    return (cl === 0 && (cl = Oe()), cl);
                }
                function Vb(e) {
                    return e == null || typeof e == 'symbol' || typeof e == 'boolean'
                        ? null
                        : typeof e == 'function'
                            ? e
                            : (ue(e, 'action'), Lo('' + e));
                }
                function zb(e, t) {
                    var n = t.ownerDocument.createElement('input');
                    return (
                        (n.name = t.name),
                        (n.value = t.value),
                        e.id && n.setAttribute('form', e.id),
                        t.parentNode.insertBefore(n, t),
                        (e = new FormData(e)),
                        n.parentNode.removeChild(n),
                        e
                    );
                }
                function ux(e, t, n, a, o) {
                    if (t === 'submit' && n && n.stateNode === o) {
                        var c = Vb((o[en] || null).action),
                            f = a.submitter;
                        f &&
                            ((t = (t = f[en] || null)
                                ? Vb(t.formAction)
                                : f.getAttribute('formAction')),
                                t !== null && ((c = t), (f = null)));
                        var g = new wc('action', 'action', null, a, o);
                        e.push({
                            event: g,
                            listeners: [
                                {
                                    instance: null,
                                    listener: function () {
                                        if (a.defaultPrevented) {
                                            if (cl !== 0) {
                                                var w = f ? zb(o, f) : new FormData(o),
                                                    A = {
                                                        pending: !0,
                                                        data: w,
                                                        method: o.method,
                                                        action: c,
                                                    };
                                                (Object.freeze(A), kd(n, A, null, w));
                                            }
                                        } else
                                            typeof c == 'function' &&
                                                (g.preventDefault(),
                                                    (w = f ? zb(o, f) : new FormData(o)),
                                                    (A = {
                                                        pending: !0,
                                                        data: w,
                                                        method: o.method,
                                                        action: c,
                                                    }),
                                                    Object.freeze(A),
                                                    kd(n, A, c, w));
                                    },
                                    currentTarget: o,
                                },
                            ],
                        });
                    }
                }
                function nc(e, t, n) {
                    e.currentTarget = n;
                    try {
                        t(e);
                    } catch (a) {
                        Cm(a);
                    }
                    e.currentTarget = null;
                }
                function Bb(e, t) {
                    t = (t & 4) !== 0;
                    for (var n = 0; n < e.length; n++) {
                        var a = e[n];
                        e: {
                            var o = void 0,
                                c = a.event;
                            if (((a = a.listeners), t))
                                for (var f = a.length - 1; 0 <= f; f--) {
                                    var g = a[f],
                                        w = g.instance,
                                        A = g.currentTarget;
                                    if (
                                        ((g = g.listener), w !== o && c.isPropagationStopped())
                                    )
                                        break e;
                                    (w !== null ? he(w, nc, c, g, A) : nc(c, g, A), (o = w));
                                }
                            else
                                for (f = 0; f < a.length; f++) {
                                    if (
                                        ((g = a[f]),
                                            (w = g.instance),
                                            (A = g.currentTarget),
                                            (g = g.listener),
                                            w !== o && c.isPropagationStopped())
                                    )
                                        break e;
                                    (w !== null ? he(w, nc, c, g, A) : nc(c, g, A), (o = w));
                                }
                        }
                    }
                }
                function Be(e, t) {
                    Qm.has(e) ||
                        console.error(
                            'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
                            e
                        );
                    var n = t[Xf];
                    n === void 0 && (n = t[Xf] = new Set());
                    var a = e + '__bubble';
                    n.has(a) || (Lb(t, e, 2, !1), n.add(a));
                }
                function hf(e, t, n) {
                    Qm.has(e) &&
                        !t &&
                        console.error(
                            'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
                            e
                        );
                    var a = 0;
                    (t && (a |= 4), Lb(n, e, a, t));
                }
                function gf(e) {
                    if (!e[Xc]) {
                        ((e[Xc] = !0),
                            Sy.forEach(function (n) {
                                n !== 'selectionchange' &&
                                    (Qm.has(n) || hf(n, !1, e), hf(n, !0, e));
                            }));
                        var t = e.nodeType === 9 ? e : e.ownerDocument;
                        t === null ||
                            t[Xc] ||
                            ((t[Xc] = !0), hf('selectionchange', !1, t));
                    }
                }
                function Lb(e, t, n, a) {
                    switch (fy(t)) {
                        case wn:
                            var o = Ux;
                            break;
                        case ra:
                            o = Gx;
                            break;
                        default:
                            o = Of;
                    }
                    ((n = o.bind(null, t, n, e)),
                        (o = void 0),
                        !tm ||
                        (t !== 'touchstart' && t !== 'touchmove' && t !== 'wheel') ||
                        (o = !0),
                        a
                            ? o !== void 0
                                ? e.addEventListener(t, n, { capture: !0, passive: o })
                                : e.addEventListener(t, n, !0)
                            : o !== void 0
                                ? e.addEventListener(t, n, { passive: o })
                                : e.addEventListener(t, n, !1));
                }
                function bf(e, t, n, a, o) {
                    var c = a;
                    if ((t & 1) === 0 && (t & 2) === 0 && a !== null)
                        e: for (; ;) {
                            if (a === null) return;
                            var f = a.tag;
                            if (f === 3 || f === 4) {
                                var g = a.stateNode.containerInfo;
                                if (g === o) break;
                                if (f === 4)
                                    for (f = a.return; f !== null;) {
                                        var w = f.tag;
                                        if (
                                            (w === 3 || w === 4) &&
                                            f.stateNode.containerInfo === o
                                        )
                                            return;
                                        f = f.return;
                                    }
                                for (; g !== null;) {
                                    if (((f = In(g)), f === null)) return;
                                    if (
                                        ((w = f.tag),
                                            w === 5 || w === 6 || w === 26 || w === 27)
                                    ) {
                                        a = c = f;
                                        continue e;
                                    }
                                    g = g.parentNode;
                                }
                            }
                            a = a.return;
                        }
                    ch(function () {
                        var A = c,
                            V = _u(n),
                            L = [];
                        e: {
                            var j = dv.get(e);
                            if (j !== void 0) {
                                var H = wc,
                                    fe = e;
                                switch (e) {
                                    case 'keypress':
                                        if (yr(n) === 0) break e;
                                    case 'keydown':
                                    case 'keyup':
                                        H = LN;
                                        break;
                                    case 'focusin':
                                        ((fe = 'focus'), (H = lm));
                                        break;
                                    case 'focusout':
                                        ((fe = 'blur'), (H = lm));
                                        break;
                                    case 'beforeblur':
                                    case 'afterblur':
                                        H = lm;
                                        break;
                                    case 'click':
                                        if (n.button === 2) break e;
                                    case 'auxclick':
                                    case 'dblclick':
                                    case 'mousedown':
                                    case 'mousemove':
                                    case 'mouseup':
                                    case 'mouseout':
                                    case 'mouseover':
                                    case 'contextmenu':
                                        H = $y;
                                        break;
                                    case 'drag':
                                    case 'dragend':
                                    case 'dragenter':
                                    case 'dragexit':
                                    case 'dragleave':
                                    case 'dragover':
                                    case 'dragstart':
                                    case 'drop':
                                        H = AN;
                                        break;
                                    case 'touchcancel':
                                    case 'touchend':
                                    case 'touchmove':
                                    case 'touchstart':
                                        H = UN;
                                        break;
                                    case sv:
                                    case rv:
                                    case cv:
                                        H = CN;
                                        break;
                                    case uv:
                                        H = _N;
                                        break;
                                    case 'scroll':
                                    case 'scrollend':
                                        H = wN;
                                        break;
                                    case 'wheel':
                                        H = PN;
                                        break;
                                    case 'copy':
                                    case 'cut':
                                    case 'paste':
                                        H = MN;
                                        break;
                                    case 'gotpointercapture':
                                    case 'lostpointercapture':
                                    case 'pointercancel':
                                    case 'pointerdown':
                                    case 'pointermove':
                                    case 'pointerout':
                                    case 'pointerover':
                                    case 'pointerup':
                                        H = Ky;
                                        break;
                                    case 'toggle':
                                    case 'beforetoggle':
                                        H = WN;
                                }
                                var be = (t & 4) !== 0,
                                    Ke = !be && (e === 'scroll' || e === 'scrollend'),
                                    Le = be ? (j !== null ? j + 'Capture' : null) : j;
                                be = [];
                                for (var T = A, C; T !== null;) {
                                    var R = T;
                                    if (
                                        ((C = R.stateNode),
                                            (R = R.tag),
                                            (R !== 5 && R !== 26 && R !== 27) ||
                                            C === null ||
                                            Le === null ||
                                            ((R = Io(T, Le)), R != null && be.push(ss(T, R, C))),
                                            Ke)
                                    )
                                        break;
                                    T = T.return;
                                }
                                0 < be.length &&
                                    ((j = new H(j, fe, null, n, V)),
                                        L.push({ event: j, listeners: be }));
                            }
                        }
                        if ((t & 7) === 0) {
                            e: {
                                if (
                                    ((j = e === 'mouseover' || e === 'pointerover'),
                                        (H = e === 'mouseout' || e === 'pointerout'),
                                        j &&
                                        n !== bs &&
                                        (fe = n.relatedTarget || n.fromElement) &&
                                        (In(fe) || fe[di]))
                                )
                                    break e;
                                if (
                                    (H || j) &&
                                    ((j =
                                        V.window === V
                                            ? V
                                            : (j = V.ownerDocument)
                                                ? j.defaultView || j.parentWindow
                                                : window),
                                        H
                                            ? ((fe = n.relatedTarget || n.toElement),
                                                (H = A),
                                                (fe = fe ? In(fe) : null),
                                                fe !== null &&
                                                ((Ke = _(fe)),
                                                    (be = fe.tag),
                                                    fe !== Ke || (be !== 5 && be !== 27 && be !== 6)) &&
                                                (fe = null))
                                            : ((H = null), (fe = A)),
                                        H !== fe)
                                ) {
                                    if (
                                        ((be = $y),
                                            (R = 'onMouseLeave'),
                                            (Le = 'onMouseEnter'),
                                            (T = 'mouse'),
                                            (e === 'pointerout' || e === 'pointerover') &&
                                            ((be = Ky),
                                                (R = 'onPointerLeave'),
                                                (Le = 'onPointerEnter'),
                                                (T = 'pointer')),
                                            (Ke = H == null ? j : $a(H)),
                                            (C = fe == null ? j : $a(fe)),
                                            (j = new be(R, T + 'leave', H, n, V)),
                                            (j.target = Ke),
                                            (j.relatedTarget = C),
                                            (R = null),
                                            In(V) === A &&
                                            ((be = new be(Le, T + 'enter', fe, n, V)),
                                                (be.target = C),
                                                (be.relatedTarget = Ke),
                                                (R = be)),
                                            (Ke = R),
                                            H && fe)
                                    )
                                        t: {
                                            for (be = H, Le = fe, T = 0, C = be; C; C = Vl(C))
                                                T++;
                                            for (C = 0, R = Le; R; R = Vl(R)) C++;
                                            for (; 0 < T - C;) ((be = Vl(be)), T--);
                                            for (; 0 < C - T;) ((Le = Vl(Le)), C--);
                                            for (; T--;) {
                                                if (
                                                    be === Le ||
                                                    (Le !== null && be === Le.alternate)
                                                )
                                                    break t;
                                                ((be = Vl(be)), (Le = Vl(Le)));
                                            }
                                            be = null;
                                        }
                                    else be = null;
                                    (H !== null && Ib(L, j, H, be, !1),
                                        fe !== null && Ke !== null && Ib(L, Ke, fe, be, !0));
                                }
                            }
                            e: {
                                if (
                                    ((j = A ? $a(A) : window),
                                        (H = j.nodeName && j.nodeName.toLowerCase()),
                                        H === 'select' || (H === 'input' && j.type === 'file'))
                                )
                                    var G = gh;
                                else if (ph(j))
                                    if (lv) G = MS;
                                    else {
                                        G = CS;
                                        var ae = TS;
                                    }
                                else
                                    ((H = j.nodeName),
                                        !H ||
                                            H.toLowerCase() !== 'input' ||
                                            (j.type !== 'checkbox' && j.type !== 'radio')
                                            ? A && Bo(A.elementType) && (G = gh)
                                            : (G = RS));
                                if (G && (G = G(e, A))) {
                                    hh(L, G, n, V);
                                    break e;
                                }
                                (ae && ae(e, j, A),
                                    e === 'focusout' &&
                                    A &&
                                    j.type === 'number' &&
                                    A.memoizedProps.value != null &&
                                    Bu(j, 'number', j.value));
                            }
                            switch (((ae = A ? $a(A) : window), e)) {
                                case 'focusin':
                                    (ph(ae) || ae.contentEditable === 'true') &&
                                        ((Xl = ae), (sm = A), (Es = null));
                                    break;
                                case 'focusout':
                                    Es = sm = Xl = null;
                                    break;
                                case 'mousedown':
                                    rm = !0;
                                    break;
                                case 'contextmenu':
                                case 'mouseup':
                                case 'dragend':
                                    ((rm = !1), wh(L, n, V));
                                    break;
                                case 'selectionchange':
                                    if (qN) break;
                                case 'keydown':
                                case 'keyup':
                                    wh(L, n, V);
                            }
                            var xe;
                            if (om)
                                e: {
                                    switch (e) {
                                        case 'compositionstart':
                                            var de = 'onCompositionStart';
                                            break e;
                                        case 'compositionend':
                                            de = 'onCompositionEnd';
                                            break e;
                                        case 'compositionupdate':
                                            de = 'onCompositionUpdate';
                                            break e;
                                    }
                                    de = void 0;
                                }
                            else
                                Wl
                                    ? fh(e, n) && (de = 'onCompositionEnd')
                                    : e === 'keydown' &&
                                    n.keyCode === ev &&
                                    (de = 'onCompositionStart');
                            (de &&
                                (tv &&
                                    n.locale !== 'ko' &&
                                    (Wl || de !== 'onCompositionStart'
                                        ? de === 'onCompositionEnd' && Wl && (xe = uh())
                                        : ((fi = V),
                                            (nm = 'value' in fi ? fi.value : fi.textContent),
                                            (Wl = !0))),
                                    (ae = ac(A, de)),
                                    0 < ae.length &&
                                    ((de = new Fy(de, e, null, n, V)),
                                        L.push({ event: de, listeners: ae }),
                                        xe
                                            ? (de.data = xe)
                                            : ((xe = mh(n)), xe !== null && (de.data = xe)))),
                                (xe = QN ? wS(e, n) : ES(e, n)) &&
                                ((de = ac(A, 'onBeforeInput')),
                                    0 < de.length &&
                                    ((ae = new kN(
                                        'onBeforeInput',
                                        'beforeinput',
                                        null,
                                        n,
                                        V
                                    )),
                                        L.push({ event: ae, listeners: de }),
                                        (ae.data = xe))),
                                ux(L, e, A, n, V));
                        }
                        Bb(L, t);
                    });
                }
                function ss(e, t, n) {
                    return { instance: e, listener: t, currentTarget: n };
                }
                function ac(e, t) {
                    for (var n = t + 'Capture', a = []; e !== null;) {
                        var o = e,
                            c = o.stateNode;
                        if (
                            ((o = o.tag),
                                (o !== 5 && o !== 26 && o !== 27) ||
                                c === null ||
                                ((o = Io(e, n)),
                                    o != null && a.unshift(ss(e, o, c)),
                                    (o = Io(e, t)),
                                    o != null && a.push(ss(e, o, c))),
                                e.tag === 3)
                        )
                            return a;
                        e = e.return;
                    }
                    return [];
                }
                function Vl(e) {
                    if (e === null) return null;
                    do e = e.return;
                    while (e && e.tag !== 5 && e.tag !== 27);
                    return e || null;
                }
                function Ib(e, t, n, a, o) {
                    for (var c = t._reactName, f = []; n !== null && n !== a;) {
                        var g = n,
                            w = g.alternate,
                            A = g.stateNode;
                        if (((g = g.tag), w !== null && w === a)) break;
                        ((g !== 5 && g !== 26 && g !== 27) ||
                            A === null ||
                            ((w = A),
                                o
                                    ? ((A = Io(n, c)), A != null && f.unshift(ss(n, A, w)))
                                    : o || ((A = Io(n, c)), A != null && f.push(ss(n, A, w)))),
                            (n = n.return));
                    }
                    f.length !== 0 && e.push({ event: t, listeners: f });
                }
                function yf(e, t) {
                    (vS(e, t),
                        (e !== 'input' && e !== 'textarea' && e !== 'select') ||
                        t == null ||
                        t.value !== null ||
                        Jy ||
                        ((Jy = !0),
                            e === 'select' && t.multiple
                                ? console.error(
                                    '`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.',
                                    e
                                )
                                : console.error(
                                    '`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.',
                                    e
                                )));
                    var n = {
                        registrationNameDependencies: Qi,
                        possibleRegistrationNames: Qf,
                    };
                    (Bo(e) || typeof t.is == 'string' || xS(e, t, n),
                        t.contentEditable &&
                        !t.suppressContentEditableWarning &&
                        t.children != null &&
                        console.error(
                            'A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.'
                        ));
                }
                function Et(e, t, n, a) {
                    t !== n && ((n = li(n)), li(t) !== n && (a[e] = t));
                }
                function dx(e, t, n) {
                    t.forEach(function (a) {
                        n[Gb(a)] = a === 'style' ? Sf(e) : e.getAttribute(a);
                    });
                }
                function ia(e, t) {
                    t === !1
                        ? console.error(
                            'Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                            e,
                            e,
                            e
                        )
                        : console.error(
                            'Expected `%s` listener to be a function, instead got a value of `%s` type.',
                            e,
                            typeof t
                        );
                }
                function Hb(e, t) {
                    return (
                        (e =
                            e.namespaceURI === Sc || e.namespaceURI === _l
                                ? e.ownerDocument.createElementNS(e.namespaceURI, e.tagName)
                                : e.ownerDocument.createElement(e.tagName)),
                        (e.innerHTML = t),
                        e.innerHTML
                    );
                }
                function li(e) {
                    return (
                        U() &&
                        (console.error(
                            'The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.',
                            me(e)
                        ),
                            re(e)),
                        (typeof e == 'string' ? e : '' + e)
                            .replace(
                                xw,
                                `
`
                            )
                            .replace(Nw, '')
                    );
                }
                function Ub(e, t) {
                    return ((t = li(t)), li(e) === t);
                }
                function ic() { }
                function Je(e, t, n, a, o, c) {
                    switch (n) {
                        case 'children':
                            typeof a == 'string'
                                ? (br(a, t, !1),
                                    t === 'body' ||
                                    (t === 'textarea' && a === '') ||
                                    zo(e, a))
                                : (typeof a == 'number' || typeof a == 'bigint') &&
                                (br('' + a, t, !1), t !== 'body' && zo(e, '' + a));
                            break;
                        case 'className':
                            Te(e, 'class', a);
                            break;
                        case 'tabIndex':
                            Te(e, 'tabindex', a);
                            break;
                        case 'dir':
                        case 'role':
                        case 'viewBox':
                        case 'width':
                        case 'height':
                            Te(e, n, a);
                            break;
                        case 'style':
                            oh(e, a, c);
                            break;
                        case 'data':
                            if (t !== 'object') {
                                Te(e, 'data', a);
                                break;
                            }
                        case 'src':
                        case 'href':
                            if (a === '' && (t !== 'a' || n !== 'href')) {
                                (console.error(
                                    n === 'src'
                                        ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.'
                                        : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                                    n,
                                    n
                                ),
                                    e.removeAttribute(n));
                                break;
                            }
                            if (
                                a == null ||
                                typeof a == 'function' ||
                                typeof a == 'symbol' ||
                                typeof a == 'boolean'
                            ) {
                                e.removeAttribute(n);
                                break;
                            }
                            (ue(a, n), (a = Lo('' + a)), e.setAttribute(n, a));
                            break;
                        case 'action':
                        case 'formAction':
                            if (
                                (a != null &&
                                    (t === 'form'
                                        ? n === 'formAction'
                                            ? console.error(
                                                'You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>.'
                                            )
                                            : typeof a == 'function' &&
                                            ((o.encType == null && o.method == null) ||
                                                qc ||
                                                ((qc = !0),
                                                    console.error(
                                                        'Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden.'
                                                    )),
                                                o.target == null ||
                                                Jc ||
                                                ((Jc = !0),
                                                    console.error(
                                                        'Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window.'
                                                    )))
                                        : t === 'input' || t === 'button'
                                            ? n === 'action'
                                                ? console.error(
                                                    'You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>.'
                                                )
                                                : t !== 'input' ||
                                                    o.type === 'submit' ||
                                                    o.type === 'image' ||
                                                    Qc
                                                    ? t !== 'button' ||
                                                        o.type == null ||
                                                        o.type === 'submit' ||
                                                        Qc
                                                        ? typeof a == 'function' &&
                                                        (o.name == null ||
                                                            A1 ||
                                                            ((A1 = !0),
                                                                console.error(
                                                                    'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
                                                                )),
                                                            (o.formEncType == null &&
                                                                o.formMethod == null) ||
                                                            qc ||
                                                            ((qc = !0),
                                                                console.error(
                                                                    'Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden.'
                                                                )),
                                                            o.formTarget == null ||
                                                            Jc ||
                                                            ((Jc = !0),
                                                                console.error(
                                                                    'Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window.'
                                                                )))
                                                        : ((Qc = !0),
                                                            console.error(
                                                                'A button can only specify a formAction along with type="submit" or no type.'
                                                            ))
                                                    : ((Qc = !0),
                                                        console.error(
                                                            'An input can only specify a formAction along with type="submit" or type="image".'
                                                        ))
                                            : console.error(
                                                n === 'action'
                                                    ? 'You can only pass the action prop to <form>.'
                                                    : 'You can only pass the formAction prop to <input> or <button>.'
                                            )),
                                    typeof a == 'function')
                            ) {
                                e.setAttribute(
                                    n,
                                    "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
                                );
                                break;
                            } else
                                typeof c == 'function' &&
                                    (n === 'formAction'
                                        ? (t !== 'input' && Je(e, t, 'name', o.name, o, null),
                                            Je(e, t, 'formEncType', o.formEncType, o, null),
                                            Je(e, t, 'formMethod', o.formMethod, o, null),
                                            Je(e, t, 'formTarget', o.formTarget, o, null))
                                        : (Je(e, t, 'encType', o.encType, o, null),
                                            Je(e, t, 'method', o.method, o, null),
                                            Je(e, t, 'target', o.target, o, null)));
                            if (
                                a == null ||
                                typeof a == 'symbol' ||
                                typeof a == 'boolean'
                            ) {
                                e.removeAttribute(n);
                                break;
                            }
                            (ue(a, n), (a = Lo('' + a)), e.setAttribute(n, a));
                            break;
                        case 'onClick':
                            a != null &&
                                (typeof a != 'function' && ia(n, a), (e.onclick = ic));
                            break;
                        case 'onScroll':
                            a != null &&
                                (typeof a != 'function' && ia(n, a), Be('scroll', e));
                            break;
                        case 'onScrollEnd':
                            a != null &&
                                (typeof a != 'function' && ia(n, a), Be('scrollend', e));
                            break;
                        case 'dangerouslySetInnerHTML':
                            if (a != null) {
                                if (typeof a != 'object' || !('__html' in a))
                                    throw Error(
                                        '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.'
                                    );
                                if (((n = a.__html), n != null)) {
                                    if (o.children != null)
                                        throw Error(
                                            'Can only set one of `children` or `props.dangerouslySetInnerHTML`.'
                                        );
                                    e.innerHTML = n;
                                }
                            }
                            break;
                        case 'multiple':
                            e.multiple =
                                a && typeof a != 'function' && typeof a != 'symbol';
                            break;
                        case 'muted':
                            e.muted = a && typeof a != 'function' && typeof a != 'symbol';
                            break;
                        case 'suppressContentEditableWarning':
                        case 'suppressHydrationWarning':
                        case 'defaultValue':
                        case 'defaultChecked':
                        case 'innerHTML':
                        case 'ref':
                            break;
                        case 'autoFocus':
                            break;
                        case 'xlinkHref':
                            if (
                                a == null ||
                                typeof a == 'function' ||
                                typeof a == 'boolean' ||
                                typeof a == 'symbol'
                            ) {
                                e.removeAttribute('xlink:href');
                                break;
                            }
                            (ue(a, n),
                                (n = Lo('' + a)),
                                e.setAttributeNS(ul, 'xlink:href', n));
                            break;
                        case 'contentEditable':
                        case 'spellCheck':
                        case 'draggable':
                        case 'value':
                        case 'autoReverse':
                        case 'externalResourcesRequired':
                        case 'focusable':
                        case 'preserveAlpha':
                            a != null && typeof a != 'function' && typeof a != 'symbol'
                                ? (ue(a, n), e.setAttribute(n, '' + a))
                                : e.removeAttribute(n);
                            break;
                        case 'inert':
                            a !== '' ||
                                $c[n] ||
                                (($c[n] = !0),
                                    console.error(
                                        'Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.',
                                        n
                                    ));
                        case 'allowFullScreen':
                        case 'async':
                        case 'autoPlay':
                        case 'controls':
                        case 'default':
                        case 'defer':
                        case 'disabled':
                        case 'disablePictureInPicture':
                        case 'disableRemotePlayback':
                        case 'formNoValidate':
                        case 'hidden':
                        case 'loop':
                        case 'noModule':
                        case 'noValidate':
                        case 'open':
                        case 'playsInline':
                        case 'readOnly':
                        case 'required':
                        case 'reversed':
                        case 'scoped':
                        case 'seamless':
                        case 'itemScope':
                            a && typeof a != 'function' && typeof a != 'symbol'
                                ? e.setAttribute(n, '')
                                : e.removeAttribute(n);
                            break;
                        case 'capture':
                        case 'download':
                            a === !0
                                ? e.setAttribute(n, '')
                                : a !== !1 &&
                                    a != null &&
                                    typeof a != 'function' &&
                                    typeof a != 'symbol'
                                    ? (ue(a, n), e.setAttribute(n, a))
                                    : e.removeAttribute(n);
                            break;
                        case 'cols':
                        case 'rows':
                        case 'size':
                        case 'span':
                            a != null &&
                                typeof a != 'function' &&
                                typeof a != 'symbol' &&
                                !isNaN(a) &&
                                1 <= a
                                ? (ue(a, n), e.setAttribute(n, a))
                                : e.removeAttribute(n);
                            break;
                        case 'rowSpan':
                        case 'start':
                            a == null ||
                                typeof a == 'function' ||
                                typeof a == 'symbol' ||
                                isNaN(a)
                                ? e.removeAttribute(n)
                                : (ue(a, n), e.setAttribute(n, a));
                            break;
                        case 'popover':
                            (Be('beforetoggle', e), Be('toggle', e), He(e, 'popover', a));
                            break;
                        case 'xlinkActuate':
                            wt(e, ul, 'xlink:actuate', a);
                            break;
                        case 'xlinkArcrole':
                            wt(e, ul, 'xlink:arcrole', a);
                            break;
                        case 'xlinkRole':
                            wt(e, ul, 'xlink:role', a);
                            break;
                        case 'xlinkShow':
                            wt(e, ul, 'xlink:show', a);
                            break;
                        case 'xlinkTitle':
                            wt(e, ul, 'xlink:title', a);
                            break;
                        case 'xlinkType':
                            wt(e, ul, 'xlink:type', a);
                            break;
                        case 'xmlBase':
                            wt(e, Jm, 'xml:base', a);
                            break;
                        case 'xmlLang':
                            wt(e, Jm, 'xml:lang', a);
                            break;
                        case 'xmlSpace':
                            wt(e, Jm, 'xml:space', a);
                            break;
                        case 'is':
                            (c != null &&
                                console.error(
                                    'Cannot update the "is" prop after it has been initialized.'
                                ),
                                He(e, 'is', a));
                            break;
                        case 'innerText':
                        case 'textContent':
                            break;
                        case 'popoverTarget':
                            D1 ||
                                a == null ||
                                typeof a != 'object' ||
                                ((D1 = !0),
                                    console.error(
                                        'The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.',
                                        a
                                    ));
                        default:
                            !(2 < n.length) ||
                                (n[0] !== 'o' && n[0] !== 'O') ||
                                (n[1] !== 'n' && n[1] !== 'N')
                                ? ((n = sh(n)), He(e, n, a))
                                : Qi.hasOwnProperty(n) &&
                                a != null &&
                                typeof a != 'function' &&
                                ia(n, a);
                    }
                }
                function vf(e, t, n, a, o, c) {
                    switch (n) {
                        case 'style':
                            oh(e, a, c);
                            break;
                        case 'dangerouslySetInnerHTML':
                            if (a != null) {
                                if (typeof a != 'object' || !('__html' in a))
                                    throw Error(
                                        '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.'
                                    );
                                if (((n = a.__html), n != null)) {
                                    if (o.children != null)
                                        throw Error(
                                            'Can only set one of `children` or `props.dangerouslySetInnerHTML`.'
                                        );
                                    e.innerHTML = n;
                                }
                            }
                            break;
                        case 'children':
                            typeof a == 'string'
                                ? zo(e, a)
                                : (typeof a == 'number' || typeof a == 'bigint') &&
                                zo(e, '' + a);
                            break;
                        case 'onScroll':
                            a != null &&
                                (typeof a != 'function' && ia(n, a), Be('scroll', e));
                            break;
                        case 'onScrollEnd':
                            a != null &&
                                (typeof a != 'function' && ia(n, a), Be('scrollend', e));
                            break;
                        case 'onClick':
                            a != null &&
                                (typeof a != 'function' && ia(n, a), (e.onclick = ic));
                            break;
                        case 'suppressContentEditableWarning':
                        case 'suppressHydrationWarning':
                        case 'innerHTML':
                        case 'ref':
                            break;
                        case 'innerText':
                        case 'textContent':
                            break;
                        default:
                            if (Qi.hasOwnProperty(n))
                                a != null && typeof a != 'function' && ia(n, a);
                            else
                                e: {
                                    if (
                                        n[0] === 'o' &&
                                        n[1] === 'n' &&
                                        ((o = n.endsWith('Capture')),
                                            (t = n.slice(2, o ? n.length - 7 : void 0)),
                                            (c = e[en] || null),
                                            (c = c != null ? c[n] : null),
                                            typeof c == 'function' &&
                                            e.removeEventListener(t, c, o),
                                            typeof a == 'function')
                                    ) {
                                        (typeof c != 'function' &&
                                            c !== null &&
                                            (n in e
                                                ? (e[n] = null)
                                                : e.hasAttribute(n) && e.removeAttribute(n)),
                                            e.addEventListener(t, a, o));
                                        break e;
                                    }
                                    n in e
                                        ? (e[n] = a)
                                        : a === !0
                                            ? e.setAttribute(n, '')
                                            : He(e, n, a);
                                }
                    }
                }
                function Mt(e, t, n) {
                    switch ((yf(t, n), t)) {
                        case 'div':
                        case 'span':
                        case 'svg':
                        case 'path':
                        case 'a':
                        case 'g':
                        case 'p':
                        case 'li':
                            break;
                        case 'img':
                            (Be('error', e), Be('load', e));
                            var a = !1,
                                o = !1,
                                c;
                            for (c in n)
                                if (n.hasOwnProperty(c)) {
                                    var f = n[c];
                                    if (f != null)
                                        switch (c) {
                                            case 'src':
                                                a = !0;
                                                break;
                                            case 'srcSet':
                                                o = !0;
                                                break;
                                            case 'children':
                                            case 'dangerouslySetInnerHTML':
                                                throw Error(
                                                    t +
                                                    ' is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.'
                                                );
                                            default:
                                                Je(e, t, c, f, n, null);
                                        }
                                }
                            (o && Je(e, t, 'srcSet', n.srcSet, n, null),
                                a && Je(e, t, 'src', n.src, n, null));
                            return;
                        case 'input':
                            (pe('input', n), Be('invalid', e));
                            var g = (c = f = o = null),
                                w = null,
                                A = null;
                            for (a in n)
                                if (n.hasOwnProperty(a)) {
                                    var V = n[a];
                                    if (V != null)
                                        switch (a) {
                                            case 'name':
                                                o = V;
                                                break;
                                            case 'type':
                                                f = V;
                                                break;
                                            case 'checked':
                                                w = V;
                                                break;
                                            case 'defaultChecked':
                                                A = V;
                                                break;
                                            case 'value':
                                                c = V;
                                                break;
                                            case 'defaultValue':
                                                g = V;
                                                break;
                                            case 'children':
                                            case 'dangerouslySetInnerHTML':
                                                if (V != null)
                                                    throw Error(
                                                        t +
                                                        ' is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.'
                                                    );
                                                break;
                                            default:
                                                Je(e, t, a, V, n, null);
                                        }
                                }
                            (Pp(e, n), Zp(e, c, g, w, A, f, o, !1), pr(e));
                            return;
                        case 'select':
                            (pe('select', n), Be('invalid', e), (a = f = c = null));
                            for (o in n)
                                if (n.hasOwnProperty(o) && ((g = n[o]), g != null))
                                    switch (o) {
                                        case 'value':
                                            c = g;
                                            break;
                                        case 'defaultValue':
                                            f = g;
                                            break;
                                        case 'multiple':
                                            a = g;
                                        default:
                                            Je(e, t, o, g, n, null);
                                    }
                            (Qp(e, n),
                                (t = c),
                                (n = f),
                                (e.multiple = !!a),
                                t != null
                                    ? xl(e, !!a, t, !1)
                                    : n != null && xl(e, !!a, n, !0));
                            return;
                        case 'textarea':
                            (pe('textarea', n), Be('invalid', e), (c = o = a = null));
                            for (f in n)
                                if (n.hasOwnProperty(f) && ((g = n[f]), g != null))
                                    switch (f) {
                                        case 'value':
                                            a = g;
                                            break;
                                        case 'defaultValue':
                                            o = g;
                                            break;
                                        case 'children':
                                            c = g;
                                            break;
                                        case 'dangerouslySetInnerHTML':
                                            if (g != null)
                                                throw Error(
                                                    '`dangerouslySetInnerHTML` does not make sense on <textarea>.'
                                                );
                                            break;
                                        default:
                                            Je(e, t, f, g, n, null);
                                    }
                            (Jp(e, n), $p(e, a, o, c), pr(e));
                            return;
                        case 'option':
                            Wp(e, n);
                            for (w in n)
                                if (n.hasOwnProperty(w) && ((a = n[w]), a != null))
                                    switch (w) {
                                        case 'selected':
                                            e.selected =
                                                a && typeof a != 'function' && typeof a != 'symbol';
                                            break;
                                        default:
                                            Je(e, t, w, a, n, null);
                                    }
                            return;
                        case 'dialog':
                            (Be('beforetoggle', e),
                                Be('toggle', e),
                                Be('cancel', e),
                                Be('close', e));
                            break;
                        case 'iframe':
                        case 'object':
                            Be('load', e);
                            break;
                        case 'video':
                        case 'audio':
                            for (a = 0; a < Qs.length; a++) Be(Qs[a], e);
                            break;
                        case 'image':
                            (Be('error', e), Be('load', e));
                            break;
                        case 'details':
                            Be('toggle', e);
                            break;
                        case 'embed':
                        case 'source':
                        case 'link':
                            (Be('error', e), Be('load', e));
                        case 'area':
                        case 'base':
                        case 'br':
                        case 'col':
                        case 'hr':
                        case 'keygen':
                        case 'meta':
                        case 'param':
                        case 'track':
                        case 'wbr':
                        case 'menuitem':
                            for (A in n)
                                if (n.hasOwnProperty(A) && ((a = n[A]), a != null))
                                    switch (A) {
                                        case 'children':
                                        case 'dangerouslySetInnerHTML':
                                            throw Error(
                                                t +
                                                ' is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.'
                                            );
                                        default:
                                            Je(e, t, A, a, n, null);
                                    }
                            return;
                        default:
                            if (Bo(t)) {
                                for (V in n)
                                    n.hasOwnProperty(V) &&
                                        ((a = n[V]), a !== void 0 && vf(e, t, V, a, n, void 0));
                                return;
                            }
                    }
                    for (g in n)
                        n.hasOwnProperty(g) &&
                            ((a = n[g]), a != null && Je(e, t, g, a, n, null));
                }
                function fx(e, t, n, a) {
                    switch ((yf(t, a), t)) {
                        case 'div':
                        case 'span':
                        case 'svg':
                        case 'path':
                        case 'a':
                        case 'g':
                        case 'p':
                        case 'li':
                            break;
                        case 'input':
                            var o = null,
                                c = null,
                                f = null,
                                g = null,
                                w = null,
                                A = null,
                                V = null;
                            for (H in n) {
                                var L = n[H];
                                if (n.hasOwnProperty(H) && L != null)
                                    switch (H) {
                                        case 'checked':
                                            break;
                                        case 'value':
                                            break;
                                        case 'defaultValue':
                                            w = L;
                                        default:
                                            a.hasOwnProperty(H) || Je(e, t, H, null, a, L);
                                    }
                            }
                            for (var j in a) {
                                var H = a[j];
                                if (
                                    ((L = n[j]),
                                        a.hasOwnProperty(j) && (H != null || L != null))
                                )
                                    switch (j) {
                                        case 'type':
                                            c = H;
                                            break;
                                        case 'name':
                                            o = H;
                                            break;
                                        case 'checked':
                                            A = H;
                                            break;
                                        case 'defaultChecked':
                                            V = H;
                                            break;
                                        case 'value':
                                            f = H;
                                            break;
                                        case 'defaultValue':
                                            g = H;
                                            break;
                                        case 'children':
                                        case 'dangerouslySetInnerHTML':
                                            if (H != null)
                                                throw Error(
                                                    t +
                                                    ' is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.'
                                                );
                                            break;
                                        default:
                                            H !== L && Je(e, t, j, H, a, L);
                                    }
                            }
                            ((t =
                                n.type === 'checkbox' || n.type === 'radio'
                                    ? n.checked != null
                                    : n.value != null),
                                (a =
                                    a.type === 'checkbox' || a.type === 'radio'
                                        ? a.checked != null
                                        : a.value != null),
                                t ||
                                !a ||
                                E1 ||
                                (console.error(
                                    'A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components'
                                ),
                                    (E1 = !0)),
                                !t ||
                                a ||
                                w1 ||
                                (console.error(
                                    'A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components'
                                ),
                                    (w1 = !0)),
                                zu(e, f, g, w, A, V, c, o));
                            return;
                        case 'select':
                            H = f = g = j = null;
                            for (c in n)
                                if (((w = n[c]), n.hasOwnProperty(c) && w != null))
                                    switch (c) {
                                        case 'value':
                                            break;
                                        case 'multiple':
                                            H = w;
                                        default:
                                            a.hasOwnProperty(c) || Je(e, t, c, null, a, w);
                                    }
                            for (o in a)
                                if (
                                    ((c = a[o]),
                                        (w = n[o]),
                                        a.hasOwnProperty(o) && (c != null || w != null))
                                )
                                    switch (o) {
                                        case 'value':
                                            j = c;
                                            break;
                                        case 'defaultValue':
                                            g = c;
                                            break;
                                        case 'multiple':
                                            f = c;
                                        default:
                                            c !== w && Je(e, t, o, c, a, w);
                                    }
                            ((a = g),
                                (t = f),
                                (n = H),
                                j != null
                                    ? xl(e, !!t, j, !1)
                                    : !!n != !!t &&
                                    (a != null
                                        ? xl(e, !!t, a, !0)
                                        : xl(e, !!t, t ? [] : '', !1)));
                            return;
                        case 'textarea':
                            H = j = null;
                            for (g in n)
                                if (
                                    ((o = n[g]),
                                        n.hasOwnProperty(g) && o != null && !a.hasOwnProperty(g))
                                )
                                    switch (g) {
                                        case 'value':
                                            break;
                                        case 'children':
                                            break;
                                        default:
                                            Je(e, t, g, null, a, o);
                                    }
                            for (f in a)
                                if (
                                    ((o = a[f]),
                                        (c = n[f]),
                                        a.hasOwnProperty(f) && (o != null || c != null))
                                )
                                    switch (f) {
                                        case 'value':
                                            j = o;
                                            break;
                                        case 'defaultValue':
                                            H = o;
                                            break;
                                        case 'children':
                                            break;
                                        case 'dangerouslySetInnerHTML':
                                            if (o != null)
                                                throw Error(
                                                    '`dangerouslySetInnerHTML` does not make sense on <textarea>.'
                                                );
                                            break;
                                        default:
                                            o !== c && Je(e, t, f, o, a, c);
                                    }
                            qp(e, j, H);
                            return;
                        case 'option':
                            for (var fe in n)
                                if (
                                    ((j = n[fe]),
                                        n.hasOwnProperty(fe) &&
                                        j != null &&
                                        !a.hasOwnProperty(fe))
                                )
                                    switch (fe) {
                                        case 'selected':
                                            e.selected = !1;
                                            break;
                                        default:
                                            Je(e, t, fe, null, a, j);
                                    }
                            for (w in a)
                                if (
                                    ((j = a[w]),
                                        (H = n[w]),
                                        a.hasOwnProperty(w) &&
                                        j !== H &&
                                        (j != null || H != null))
                                )
                                    switch (w) {
                                        case 'selected':
                                            e.selected =
                                                j && typeof j != 'function' && typeof j != 'symbol';
                                            break;
                                        default:
                                            Je(e, t, w, j, a, H);
                                    }
                            return;
                        case 'img':
                        case 'link':
                        case 'area':
                        case 'base':
                        case 'br':
                        case 'col':
                        case 'embed':
                        case 'hr':
                        case 'keygen':
                        case 'meta':
                        case 'param':
                        case 'source':
                        case 'track':
                        case 'wbr':
                        case 'menuitem':
                            for (var be in n)
                                ((j = n[be]),
                                    n.hasOwnProperty(be) &&
                                    j != null &&
                                    !a.hasOwnProperty(be) &&
                                    Je(e, t, be, null, a, j));
                            for (A in a)
                                if (
                                    ((j = a[A]),
                                        (H = n[A]),
                                        a.hasOwnProperty(A) &&
                                        j !== H &&
                                        (j != null || H != null))
                                )
                                    switch (A) {
                                        case 'children':
                                        case 'dangerouslySetInnerHTML':
                                            if (j != null)
                                                throw Error(
                                                    t +
                                                    ' is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.'
                                                );
                                            break;
                                        default:
                                            Je(e, t, A, j, a, H);
                                    }
                            return;
                        default:
                            if (Bo(t)) {
                                for (var Ke in n)
                                    ((j = n[Ke]),
                                        n.hasOwnProperty(Ke) &&
                                        j !== void 0 &&
                                        !a.hasOwnProperty(Ke) &&
                                        vf(e, t, Ke, void 0, a, j));
                                for (V in a)
                                    ((j = a[V]),
                                        (H = n[V]),
                                        !a.hasOwnProperty(V) ||
                                        j === H ||
                                        (j === void 0 && H === void 0) ||
                                        vf(e, t, V, j, a, H));
                                return;
                            }
                    }
                    for (var Le in n)
                        ((j = n[Le]),
                            n.hasOwnProperty(Le) &&
                            j != null &&
                            !a.hasOwnProperty(Le) &&
                            Je(e, t, Le, null, a, j));
                    for (L in a)
                        ((j = a[L]),
                            (H = n[L]),
                            !a.hasOwnProperty(L) ||
                            j === H ||
                            (j == null && H == null) ||
                            Je(e, t, L, j, a, H));
                }
                function Gb(e) {
                    switch (e) {
                        case 'class':
                            return 'className';
                        case 'for':
                            return 'htmlFor';
                        default:
                            return e;
                    }
                }
                function Sf(e) {
                    var t = {};
                    e = e.style;
                    for (var n = 0; n < e.length; n++) {
                        var a = e[n];
                        t[a] = e.getPropertyValue(a);
                    }
                    return t;
                }
                function _b(e, t, n) {
                    if (t != null && typeof t != 'object')
                        console.error(
                            "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
                        );
                    else {
                        var a,
                            o = (a = ''),
                            c;
                        for (c in t)
                            if (t.hasOwnProperty(c)) {
                                var f = t[c];
                                f != null &&
                                    typeof f != 'boolean' &&
                                    f !== '' &&
                                    (c.indexOf('--') === 0
                                        ? (Ge(f, c), (a += o + c + ':' + ('' + f).trim()))
                                        : typeof f != 'number' || f === 0 || Xy.has(c)
                                            ? (Ge(f, c),
                                                (a +=
                                                    o +
                                                    c
                                                        .replace(_y, '-$1')
                                                        .toLowerCase()
                                                        .replace(Yy, '-ms-') +
                                                    ':' +
                                                    ('' + f).trim()))
                                            : (a +=
                                                o +
                                                c
                                                    .replace(_y, '-$1')
                                                    .toLowerCase()
                                                    .replace(Yy, '-ms-') +
                                                ':' +
                                                f +
                                                'px'),
                                        (o = ';'));
                            }
                        ((a = a || null),
                            (t = e.getAttribute('style')),
                            t !== a && ((a = li(a)), li(t) !== a && (n.style = Sf(e))));
                    }
                }
                function xn(e, t, n, a, o, c) {
                    if ((o.delete(n), (e = e.getAttribute(n)), e === null))
                        switch (typeof a) {
                            case 'undefined':
                            case 'function':
                            case 'symbol':
                            case 'boolean':
                                return;
                        }
                    else if (a != null)
                        switch (typeof a) {
                            case 'function':
                            case 'symbol':
                            case 'boolean':
                                break;
                            default:
                                if ((ue(a, t), e === '' + a)) return;
                        }
                    Et(t, e, a, c);
                }
                function Yb(e, t, n, a, o, c) {
                    if ((o.delete(n), (e = e.getAttribute(n)), e === null)) {
                        switch (typeof a) {
                            case 'function':
                            case 'symbol':
                                return;
                        }
                        if (!a) return;
                    } else
                        switch (typeof a) {
                            case 'function':
                            case 'symbol':
                                break;
                            default:
                                if (a) return;
                        }
                    Et(t, e, a, c);
                }
                function xf(e, t, n, a, o, c) {
                    if ((o.delete(n), (e = e.getAttribute(n)), e === null))
                        switch (typeof a) {
                            case 'undefined':
                            case 'function':
                            case 'symbol':
                                return;
                        }
                    else if (a != null)
                        switch (typeof a) {
                            case 'function':
                            case 'symbol':
                                break;
                            default:
                                if ((ue(a, n), e === '' + a)) return;
                        }
                    Et(t, e, a, c);
                }
                function Pb(e, t, n, a, o, c) {
                    if ((o.delete(n), (e = e.getAttribute(n)), e === null))
                        switch (typeof a) {
                            case 'undefined':
                            case 'function':
                            case 'symbol':
                            case 'boolean':
                                return;
                            default:
                                if (isNaN(a)) return;
                        }
                    else if (a != null)
                        switch (typeof a) {
                            case 'function':
                            case 'symbol':
                            case 'boolean':
                                break;
                            default:
                                if (!isNaN(a) && (ue(a, t), e === '' + a)) return;
                        }
                    Et(t, e, a, c);
                }
                function Nf(e, t, n, a, o, c) {
                    if ((o.delete(n), (e = e.getAttribute(n)), e === null))
                        switch (typeof a) {
                            case 'undefined':
                            case 'function':
                            case 'symbol':
                            case 'boolean':
                                return;
                        }
                    else if (a != null)
                        switch (typeof a) {
                            case 'function':
                            case 'symbol':
                            case 'boolean':
                                break;
                            default:
                                if ((ue(a, t), (n = Lo('' + a)), e === n)) return;
                        }
                    Et(t, e, a, c);
                }
                function Zb(e, t, n, a) {
                    for (
                        var o = {}, c = new Set(), f = e.attributes, g = 0;
                        g < f.length;
                        g++
                    )
                        switch (f[g].name.toLowerCase()) {
                            case 'value':
                                break;
                            case 'checked':
                                break;
                            case 'selected':
                                break;
                            default:
                                c.add(f[g].name);
                        }
                    if (Bo(t)) {
                        for (var w in n)
                            if (n.hasOwnProperty(w)) {
                                var A = n[w];
                                if (A != null) {
                                    if (Qi.hasOwnProperty(w))
                                        typeof A != 'function' && ia(w, A);
                                    else if (n.suppressHydrationWarning !== !0)
                                        switch (w) {
                                            case 'children':
                                                (typeof A != 'string' && typeof A != 'number') ||
                                                    Et('children', e.textContent, A, o);
                                                continue;
                                            case 'suppressContentEditableWarning':
                                            case 'suppressHydrationWarning':
                                            case 'defaultValue':
                                            case 'defaultChecked':
                                            case 'innerHTML':
                                            case 'ref':
                                                continue;
                                            case 'dangerouslySetInnerHTML':
                                                ((f = e.innerHTML),
                                                    (A = A ? A.__html : void 0),
                                                    A != null && ((A = Hb(e, A)), Et(w, f, A, o)));
                                                continue;
                                            case 'style':
                                                (c.delete(w), _b(e, A, o));
                                                continue;
                                            case 'offsetParent':
                                            case 'offsetTop':
                                            case 'offsetLeft':
                                            case 'offsetWidth':
                                            case 'offsetHeight':
                                            case 'isContentEditable':
                                            case 'outerText':
                                            case 'outerHTML':
                                                (c.delete(w.toLowerCase()),
                                                    console.error(
                                                        'Assignment to read-only property will result in a no-op: `%s`',
                                                        w
                                                    ));
                                                continue;
                                            case 'className':
                                                (c.delete('class'),
                                                    (f = De(e, 'class', A)),
                                                    Et('className', f, A, o));
                                                continue;
                                            default:
                                                (a.context === _a && t !== 'svg' && t !== 'math'
                                                    ? c.delete(w.toLowerCase())
                                                    : c.delete(w),
                                                    (f = De(e, w, A)),
                                                    Et(w, f, A, o));
                                        }
                                }
                            }
                    } else
                        for (A in n)
                            if (n.hasOwnProperty(A) && ((w = n[A]), w != null)) {
                                if (Qi.hasOwnProperty(A))
                                    typeof w != 'function' && ia(A, w);
                                else if (n.suppressHydrationWarning !== !0)
                                    switch (A) {
                                        case 'children':
                                            (typeof w != 'string' && typeof w != 'number') ||
                                                Et('children', e.textContent, w, o);
                                            continue;
                                        case 'suppressContentEditableWarning':
                                        case 'suppressHydrationWarning':
                                        case 'value':
                                        case 'checked':
                                        case 'selected':
                                        case 'defaultValue':
                                        case 'defaultChecked':
                                        case 'innerHTML':
                                        case 'ref':
                                            continue;
                                        case 'dangerouslySetInnerHTML':
                                            ((f = e.innerHTML),
                                                (w = w ? w.__html : void 0),
                                                w != null &&
                                                ((w = Hb(e, w)),
                                                    f !== w && (o[A] = { __html: f })));
                                            continue;
                                        case 'className':
                                            xn(e, A, 'class', w, c, o);
                                            continue;
                                        case 'tabIndex':
                                            xn(e, A, 'tabindex', w, c, o);
                                            continue;
                                        case 'style':
                                            (c.delete(A), _b(e, w, o));
                                            continue;
                                        case 'multiple':
                                            (c.delete(A), Et(A, e.multiple, w, o));
                                            continue;
                                        case 'muted':
                                            (c.delete(A), Et(A, e.muted, w, o));
                                            continue;
                                        case 'autoFocus':
                                            (c.delete('autofocus'), Et(A, e.autofocus, w, o));
                                            continue;
                                        case 'data':
                                            if (t !== 'object') {
                                                (c.delete(A),
                                                    (f = e.getAttribute('data')),
                                                    Et(A, f, w, o));
                                                continue;
                                            }
                                        case 'src':
                                        case 'href':
                                            if (
                                                !(
                                                    w !== '' ||
                                                    (t === 'a' && A === 'href') ||
                                                    (t === 'object' && A === 'data')
                                                )
                                            ) {
                                                console.error(
                                                    A === 'src'
                                                        ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.'
                                                        : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                                                    A,
                                                    A
                                                );
                                                continue;
                                            }
                                            Nf(e, A, A, w, c, o);
                                            continue;
                                        case 'action':
                                        case 'formAction':
                                            if (
                                                ((f = e.getAttribute(A)), typeof w == 'function')
                                            ) {
                                                (c.delete(A.toLowerCase()),
                                                    A === 'formAction'
                                                        ? (c.delete('name'),
                                                            c.delete('formenctype'),
                                                            c.delete('formmethod'),
                                                            c.delete('formtarget'))
                                                        : (c.delete('enctype'),
                                                            c.delete('method'),
                                                            c.delete('target')));
                                                continue;
                                            } else if (f === ww) {
                                                (c.delete(A.toLowerCase()),
                                                    Et(A, 'function', w, o));
                                                continue;
                                            }
                                            Nf(e, A, A.toLowerCase(), w, c, o);
                                            continue;
                                        case 'xlinkHref':
                                            Nf(e, A, 'xlink:href', w, c, o);
                                            continue;
                                        case 'contentEditable':
                                            xf(e, A, 'contenteditable', w, c, o);
                                            continue;
                                        case 'spellCheck':
                                            xf(e, A, 'spellcheck', w, c, o);
                                            continue;
                                        case 'draggable':
                                        case 'autoReverse':
                                        case 'externalResourcesRequired':
                                        case 'focusable':
                                        case 'preserveAlpha':
                                            xf(e, A, A, w, c, o);
                                            continue;
                                        case 'allowFullScreen':
                                        case 'async':
                                        case 'autoPlay':
                                        case 'controls':
                                        case 'default':
                                        case 'defer':
                                        case 'disabled':
                                        case 'disablePictureInPicture':
                                        case 'disableRemotePlayback':
                                        case 'formNoValidate':
                                        case 'hidden':
                                        case 'loop':
                                        case 'noModule':
                                        case 'noValidate':
                                        case 'open':
                                        case 'playsInline':
                                        case 'readOnly':
                                        case 'required':
                                        case 'reversed':
                                        case 'scoped':
                                        case 'seamless':
                                        case 'itemScope':
                                            Yb(e, A, A.toLowerCase(), w, c, o);
                                            continue;
                                        case 'capture':
                                        case 'download':
                                            e: {
                                                g = e;
                                                var V = (f = A),
                                                    L = o;
                                                if (
                                                    (c.delete(V), (g = g.getAttribute(V)), g === null)
                                                )
                                                    switch (typeof w) {
                                                        case 'undefined':
                                                        case 'function':
                                                        case 'symbol':
                                                            break e;
                                                        default:
                                                            if (w === !1) break e;
                                                    }
                                                else if (w != null)
                                                    switch (typeof w) {
                                                        case 'function':
                                                        case 'symbol':
                                                            break;
                                                        case 'boolean':
                                                            if (w === !0 && g === '') break e;
                                                            break;
                                                        default:
                                                            if ((ue(w, f), g === '' + w)) break e;
                                                    }
                                                Et(f, g, w, L);
                                            }
                                            continue;
                                        case 'cols':
                                        case 'rows':
                                        case 'size':
                                        case 'span':
                                            e: {
                                                if (
                                                    ((g = e),
                                                        (V = f = A),
                                                        (L = o),
                                                        c.delete(V),
                                                        (g = g.getAttribute(V)),
                                                        g === null)
                                                )
                                                    switch (typeof w) {
                                                        case 'undefined':
                                                        case 'function':
                                                        case 'symbol':
                                                        case 'boolean':
                                                            break e;
                                                        default:
                                                            if (isNaN(w) || 1 > w) break e;
                                                    }
                                                else if (w != null)
                                                    switch (typeof w) {
                                                        case 'function':
                                                        case 'symbol':
                                                        case 'boolean':
                                                            break;
                                                        default:
                                                            if (
                                                                !(isNaN(w) || 1 > w) &&
                                                                (ue(w, f), g === '' + w)
                                                            )
                                                                break e;
                                                    }
                                                Et(f, g, w, L);
                                            }
                                            continue;
                                        case 'rowSpan':
                                            Pb(e, A, 'rowspan', w, c, o);
                                            continue;
                                        case 'start':
                                            Pb(e, A, A, w, c, o);
                                            continue;
                                        case 'xHeight':
                                            xn(e, A, 'x-height', w, c, o);
                                            continue;
                                        case 'xlinkActuate':
                                            xn(e, A, 'xlink:actuate', w, c, o);
                                            continue;
                                        case 'xlinkArcrole':
                                            xn(e, A, 'xlink:arcrole', w, c, o);
                                            continue;
                                        case 'xlinkRole':
                                            xn(e, A, 'xlink:role', w, c, o);
                                            continue;
                                        case 'xlinkShow':
                                            xn(e, A, 'xlink:show', w, c, o);
                                            continue;
                                        case 'xlinkTitle':
                                            xn(e, A, 'xlink:title', w, c, o);
                                            continue;
                                        case 'xlinkType':
                                            xn(e, A, 'xlink:type', w, c, o);
                                            continue;
                                        case 'xmlBase':
                                            xn(e, A, 'xml:base', w, c, o);
                                            continue;
                                        case 'xmlLang':
                                            xn(e, A, 'xml:lang', w, c, o);
                                            continue;
                                        case 'xmlSpace':
                                            xn(e, A, 'xml:space', w, c, o);
                                            continue;
                                        case 'inert':
                                            (w !== '' ||
                                                $c[A] ||
                                                (($c[A] = !0),
                                                    console.error(
                                                        'Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.',
                                                        A
                                                    )),
                                                Yb(e, A, A, w, c, o));
                                            continue;
                                        default:
                                            if (
                                                !(2 < A.length) ||
                                                (A[0] !== 'o' && A[0] !== 'O') ||
                                                (A[1] !== 'n' && A[1] !== 'N')
                                            ) {
                                                ((g = sh(A)),
                                                    (f = !1),
                                                    a.context === _a && t !== 'svg' && t !== 'math'
                                                        ? c.delete(g.toLowerCase())
                                                        : ((V = A.toLowerCase()),
                                                            (V = (xc.hasOwnProperty(V) && xc[V]) || null),
                                                            V !== null &&
                                                            V !== A &&
                                                            ((f = !0), c.delete(V)),
                                                            c.delete(g)));
                                                e: if (((V = e), (L = g), (g = w), Re(L)))
                                                    if (V.hasAttribute(L))
                                                        ((V = V.getAttribute(L)),
                                                            ue(g, L),
                                                            (g = V === '' + g ? g : V));
                                                    else {
                                                        switch (typeof g) {
                                                            case 'function':
                                                            case 'symbol':
                                                                break e;
                                                            case 'boolean':
                                                                if (
                                                                    ((V = L.toLowerCase().slice(0, 5)),
                                                                        V !== 'data-' && V !== 'aria-')
                                                                )
                                                                    break e;
                                                        }
                                                        g = g === void 0 ? void 0 : null;
                                                    }
                                                else g = void 0;
                                                f || Et(A, g, w, o);
                                            }
                                    }
                            }
                    return (
                        0 < c.size && n.suppressHydrationWarning !== !0 && dx(e, c, o),
                        Object.keys(o).length === 0 ? null : o
                    );
                }
                function mx(e, t) {
                    switch (e.length) {
                        case 0:
                            return '';
                        case 1:
                            return e[0];
                        case 2:
                            return e[0] + ' ' + t + ' ' + e[1];
                        default:
                            return (
                                e.slice(0, -1).join(', ') + ', ' + t + ' ' + e[e.length - 1]
                            );
                    }
                }
                function lc(e) {
                    return e.nodeType === 9 ? e : e.ownerDocument;
                }
                function Wb(e) {
                    switch (e) {
                        case _l:
                            return So;
                        case Sc:
                            return eu;
                        default:
                            return _a;
                    }
                }
                function Xb(e, t) {
                    if (e === _a)
                        switch (t) {
                            case 'svg':
                                return So;
                            case 'math':
                                return eu;
                            default:
                                return _a;
                        }
                    return e === So && t === 'foreignObject' ? _a : e;
                }
                function wf(e, t) {
                    return (
                        e === 'textarea' ||
                        e === 'noscript' ||
                        typeof t.children == 'string' ||
                        typeof t.children == 'number' ||
                        typeof t.children == 'bigint' ||
                        (typeof t.dangerouslySetInnerHTML == 'object' &&
                            t.dangerouslySetInnerHTML !== null &&
                            t.dangerouslySetInnerHTML.__html != null)
                    );
                }
                function px() {
                    var e = window.event;
                    return e && e.type === 'popstate'
                        ? e === Km
                            ? !1
                            : ((Km = e), !0)
                        : ((Km = null), !1);
                }
                function hx(e) {
                    setTimeout(function () {
                        throw e;
                    });
                }
                function gx(e, t, n) {
                    switch (t) {
                        case 'button':
                        case 'input':
                        case 'select':
                        case 'textarea':
                            n.autoFocus && e.focus();
                            break;
                        case 'img':
                            n.src ? (e.src = n.src) : n.srcSet && (e.srcset = n.srcSet);
                    }
                }
                function bx(e, t, n, a) {
                    (fx(e, t, n, a), (e[en] = a));
                }
                function Qb(e) {
                    zo(e, '');
                }
                function yx(e, t, n) {
                    e.nodeValue = n;
                }
                function oi(e) {
                    return e === 'head';
                }
                function vx(e, t) {
                    e.removeChild(t);
                }
                function Sx(e, t) {
                    (e.nodeType === 9
                        ? e.body
                        : e.nodeName === 'HTML'
                            ? e.ownerDocument.body
                            : e
                    ).removeChild(t);
                }
                function Jb(e, t) {
                    var n = t,
                        a = 0,
                        o = 0;
                    do {
                        var c = n.nextSibling;
                        if ((e.removeChild(n), c && c.nodeType === 8))
                            if (((n = c.data), n === Kc)) {
                                if (0 < a && 8 > a) {
                                    n = a;
                                    var f = e.ownerDocument;
                                    if (
                                        (n & Aw && rs(f.documentElement),
                                            n & Dw && rs(f.body),
                                            n & Tw)
                                    )
                                        for (n = f.head, rs(n), f = n.firstChild; f;) {
                                            var g = f.nextSibling,
                                                w = f.nodeName;
                                            (f[hs] ||
                                                w === 'SCRIPT' ||
                                                w === 'STYLE' ||
                                                (w === 'LINK' &&
                                                    f.rel.toLowerCase() === 'stylesheet') ||
                                                n.removeChild(f),
                                                (f = g));
                                        }
                                }
                                if (o === 0) {
                                    (e.removeChild(c), fs(t));
                                    return;
                                }
                                o--;
                            } else
                                n === Fc || n === Ga || n === Js
                                    ? o++
                                    : (a = n.charCodeAt(0) - 48);
                        else a = 0;
                        n = c;
                    } while (n);
                    fs(t);
                }
                function xx(e) {
                    ((e = e.style),
                        typeof e.setProperty == 'function'
                            ? e.setProperty('display', 'none', 'important')
                            : (e.display = 'none'));
                }
                function Nx(e) {
                    e.nodeValue = '';
                }
                function wx(e, t) {
                    ((t = t[Cw]),
                        (t =
                            t != null && t.hasOwnProperty('display') ? t.display : null),
                        (e.style.display =
                            t == null || typeof t == 'boolean' ? '' : ('' + t).trim()));
                }
                function Ex(e, t) {
                    e.nodeValue = t;
                }
                function Ef(e) {
                    var t = e.firstChild;
                    for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
                        var n = t;
                        switch (((t = t.nextSibling), n.nodeName)) {
                            case 'HTML':
                            case 'HEAD':
                            case 'BODY':
                                (Ef(n), qa(n));
                                continue;
                            case 'SCRIPT':
                            case 'STYLE':
                                continue;
                            case 'LINK':
                                if (n.rel.toLowerCase() === 'stylesheet') continue;
                        }
                        e.removeChild(n);
                    }
                }
                function Ax(e, t, n, a) {
                    for (; e.nodeType === 1;) {
                        var o = n;
                        if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
                            if (!a && (e.nodeName !== 'INPUT' || e.type !== 'hidden'))
                                break;
                        } else if (a) {
                            if (!e[hs])
                                switch (t) {
                                    case 'meta':
                                        if (!e.hasAttribute('itemprop')) break;
                                        return e;
                                    case 'link':
                                        if (
                                            ((c = e.getAttribute('rel')),
                                                c === 'stylesheet' &&
                                                e.hasAttribute('data-precedence'))
                                        )
                                            break;
                                        if (
                                            c !== o.rel ||
                                            e.getAttribute('href') !==
                                            (o.href == null || o.href === '' ? null : o.href) ||
                                            e.getAttribute('crossorigin') !==
                                            (o.crossOrigin == null ? null : o.crossOrigin) ||
                                            e.getAttribute('title') !==
                                            (o.title == null ? null : o.title)
                                        )
                                            break;
                                        return e;
                                    case 'style':
                                        if (e.hasAttribute('data-precedence')) break;
                                        return e;
                                    case 'script':
                                        if (
                                            ((c = e.getAttribute('src')),
                                                (c !== (o.src == null ? null : o.src) ||
                                                    e.getAttribute('type') !==
                                                    (o.type == null ? null : o.type) ||
                                                    e.getAttribute('crossorigin') !==
                                                    (o.crossOrigin == null ? null : o.crossOrigin)) &&
                                                c &&
                                                e.hasAttribute('async') &&
                                                !e.hasAttribute('itemprop'))
                                        )
                                            break;
                                        return e;
                                    default:
                                        return e;
                                }
                        } else if (t === 'input' && e.type === 'hidden') {
                            ue(o.name, 'name');
                            var c = o.name == null ? null : '' + o.name;
                            if (o.type === 'hidden' && e.getAttribute('name') === c)
                                return e;
                        } else return e;
                        if (((e = Nn(e.nextSibling)), e === null)) break;
                    }
                    return null;
                }
                function Dx(e, t, n) {
                    if (t === '') return null;
                    for (; e.nodeType !== 3;)
                        if (
                            ((e.nodeType !== 1 ||
                                e.nodeName !== 'INPUT' ||
                                e.type !== 'hidden') &&
                                !n) ||
                            ((e = Nn(e.nextSibling)), e === null)
                        )
                            return null;
                    return e;
                }
                function Af(e) {
                    return (
                        e.data === Js ||
                        (e.data === Ga && e.ownerDocument.readyState === C1)
                    );
                }
                function Tx(e, t) {
                    var n = e.ownerDocument;
                    if (e.data !== Ga || n.readyState === C1) t();
                    else {
                        var a = function () {
                            (t(), n.removeEventListener('DOMContentLoaded', a));
                        };
                        (n.addEventListener('DOMContentLoaded', a),
                            (e._reactRetry = a));
                    }
                }
                function Nn(e) {
                    for (; e != null; e = e.nextSibling) {
                        var t = e.nodeType;
                        if (t === 1 || t === 3) break;
                        if (t === 8) {
                            if (
                                ((t = e.data),
                                    t === Fc || t === Js || t === Ga || t === qm || t === T1)
                            )
                                break;
                            if (t === Kc) return null;
                        }
                    }
                    return e;
                }
                function qb(e) {
                    if (e.nodeType === 1) {
                        for (
                            var t = e.nodeName.toLowerCase(),
                            n = {},
                            a = e.attributes,
                            o = 0;
                            o < a.length;
                            o++
                        ) {
                            var c = a[o];
                            n[Gb(c.name)] =
                                c.name.toLowerCase() === 'style' ? Sf(e) : c.value;
                        }
                        return { type: t, props: n };
                    }
                    return e.nodeType === 8
                        ? { type: 'Suspense', props: {} }
                        : e.nodeValue;
                }
                function $b(e, t, n) {
                    return n === null || n[Ew] !== !0
                        ? (e.nodeValue === t
                            ? (e = null)
                            : ((t = li(t)),
                                (e = li(e.nodeValue) === t ? null : e.nodeValue)),
                            e)
                        : null;
                }
                function Fb(e) {
                    e = e.nextSibling;
                    for (var t = 0; e;) {
                        if (e.nodeType === 8) {
                            var n = e.data;
                            if (n === Kc) {
                                if (t === 0) return Nn(e.nextSibling);
                                t--;
                            } else (n !== Fc && n !== Js && n !== Ga) || t++;
                        }
                        e = e.nextSibling;
                    }
                    return null;
                }
                function Kb(e) {
                    e = e.previousSibling;
                    for (var t = 0; e;) {
                        if (e.nodeType === 8) {
                            var n = e.data;
                            if (n === Fc || n === Js || n === Ga) {
                                if (t === 0) return e;
                                t--;
                            } else n === Kc && t++;
                        }
                        e = e.previousSibling;
                    }
                    return null;
                }
                function Cx(e) {
                    fs(e);
                }
                function Rx(e) {
                    fs(e);
                }
                function ey(e, t, n, a, o) {
                    switch ((o && Gu(e, a.ancestorInfo), (t = lc(n)), e)) {
                        case 'html':
                            if (((e = t.documentElement), !e))
                                throw Error(
                                    'React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page.'
                                );
                            return e;
                        case 'head':
                            if (((e = t.head), !e))
                                throw Error(
                                    'React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page.'
                                );
                            return e;
                        case 'body':
                            if (((e = t.body), !e))
                                throw Error(
                                    'React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page.'
                                );
                            return e;
                        default:
                            throw Error(
                                'resolveSingletonInstance was called with an element type that is not supported. This is a bug in React.'
                            );
                    }
                }
                function Mx(e, t, n, a) {
                    if (!n[di] && Hn(n)) {
                        var o = n.tagName.toLowerCase();
                        console.error(
                            'You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.',
                            o,
                            o,
                            o
                        );
                    }
                    switch (e) {
                        case 'html':
                        case 'head':
                        case 'body':
                            break;
                        default:
                            console.error(
                                'acquireSingletonInstance was called with an element type that is not supported. This is a bug in React.'
                            );
                    }
                    for (o = n.attributes; o.length;) n.removeAttributeNode(o[0]);
                    (Mt(n, e, t), (n[Lt] = a), (n[en] = t));
                }
                function rs(e) {
                    for (var t = e.attributes; t.length;)
                        e.removeAttributeNode(t[0]);
                    qa(e);
                }
                function oc(e) {
                    return typeof e.getRootNode == 'function'
                        ? e.getRootNode()
                        : e.nodeType === 9
                            ? e
                            : e.ownerDocument;
                }
                function ty(e, t, n) {
                    var a = xo;
                    if (a && typeof t == 'string' && t) {
                        var o = Sn(t);
                        ((o = 'link[rel="' + e + '"][href="' + o + '"]'),
                            typeof n == 'string' && (o += '[crossorigin="' + n + '"]'),
                            V1.has(o) ||
                            (V1.add(o),
                                (e = { rel: e, crossOrigin: n, href: t }),
                                a.querySelector(o) === null &&
                                ((t = a.createElement('link')),
                                    Mt(t, 'link', e),
                                    M(t),
                                    a.head.appendChild(t))));
                    }
                }
                function ny(e, t, n, a) {
                    var o = (o = ci.current) ? oc(o) : null;
                    if (!o)
                        throw Error(
                            '"resourceRoot" was expected to exist. This is a bug in React.'
                        );
                    switch (e) {
                        case 'meta':
                        case 'title':
                            return null;
                        case 'style':
                            return typeof n.precedence == 'string' &&
                                typeof n.href == 'string'
                                ? ((n = zl(n.href)),
                                    (t = x(o).hoistableStyles),
                                    (a = t.get(n)),
                                    a ||
                                    ((a = {
                                        type: 'style',
                                        instance: null,
                                        count: 0,
                                        state: null,
                                    }),
                                        t.set(n, a)),
                                    a)
                                : { type: 'void', instance: null, count: 0, state: null };
                        case 'link':
                            if (
                                n.rel === 'stylesheet' &&
                                typeof n.href == 'string' &&
                                typeof n.precedence == 'string'
                            ) {
                                e = zl(n.href);
                                var c = x(o).hoistableStyles,
                                    f = c.get(e);
                                if (
                                    !f &&
                                    ((o = o.ownerDocument || o),
                                        (f = {
                                            type: 'stylesheet',
                                            instance: null,
                                            count: 0,
                                            state: { loading: fl, preload: null },
                                        }),
                                        c.set(e, f),
                                        (c = o.querySelector(cs(e))) &&
                                        !c._p &&
                                        ((f.instance = c), (f.state.loading = qs | jn)),
                                        !Vn.has(e))
                                ) {
                                    var g = {
                                        rel: 'preload',
                                        as: 'style',
                                        href: n.href,
                                        crossOrigin: n.crossOrigin,
                                        integrity: n.integrity,
                                        media: n.media,
                                        hrefLang: n.hrefLang,
                                        referrerPolicy: n.referrerPolicy,
                                    };
                                    (Vn.set(e, g), c || Ox(o, e, g, f.state));
                                }
                                if (t && a === null)
                                    throw (
                                        (n =
                                            `

  - ` +
                                            sc(t) +
                                            `
  + ` +
                                            sc(n)),
                                        Error(
                                            'Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key.' +
                                            n
                                        )
                                    );
                                return f;
                            }
                            if (t && a !== null)
                                throw (
                                    (n =
                                        `

  - ` +
                                        sc(t) +
                                        `
  + ` +
                                        sc(n)),
                                    Error(
                                        'Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key.' +
                                        n
                                    )
                                );
                            return null;
                        case 'script':
                            return (
                                (t = n.async),
                                (n = n.src),
                                typeof n == 'string' &&
                                    t &&
                                    typeof t != 'function' &&
                                    typeof t != 'symbol'
                                    ? ((n = Bl(n)),
                                        (t = x(o).hoistableScripts),
                                        (a = t.get(n)),
                                        a ||
                                        ((a = {
                                            type: 'script',
                                            instance: null,
                                            count: 0,
                                            state: null,
                                        }),
                                            t.set(n, a)),
                                        a)
                                    : { type: 'void', instance: null, count: 0, state: null }
                            );
                        default:
                            throw Error(
                                'getResource encountered a type it did not expect: "' +
                                e +
                                '". this is a bug in React.'
                            );
                    }
                }
                function sc(e) {
                    var t = 0,
                        n = '<link';
                    return (
                        typeof e.rel == 'string'
                            ? (t++, (n += ' rel="' + e.rel + '"'))
                            : Oa.call(e, 'rel') &&
                            (t++,
                                (n +=
                                    ' rel="' +
                                    (e.rel === null
                                        ? 'null'
                                        : 'invalid type ' + typeof e.rel) +
                                    '"')),
                        typeof e.href == 'string'
                            ? (t++, (n += ' href="' + e.href + '"'))
                            : Oa.call(e, 'href') &&
                            (t++,
                                (n +=
                                    ' href="' +
                                    (e.href === null
                                        ? 'null'
                                        : 'invalid type ' + typeof e.href) +
                                    '"')),
                        typeof e.precedence == 'string'
                            ? (t++, (n += ' precedence="' + e.precedence + '"'))
                            : Oa.call(e, 'precedence') &&
                            (t++,
                                (n +=
                                    ' precedence={' +
                                    (e.precedence === null
                                        ? 'null'
                                        : 'invalid type ' + typeof e.precedence) +
                                    '}')),
                        Object.getOwnPropertyNames(e).length > t && (n += ' ...'),
                        n + ' />'
                    );
                }
                function zl(e) {
                    return 'href="' + Sn(e) + '"';
                }
                function cs(e) {
                    return 'link[rel="stylesheet"][' + e + ']';
                }
                function ay(e) {
                    return Me({}, e, {
                        'data-precedence': e.precedence,
                        precedence: null,
                    });
                }
                function Ox(e, t, n, a) {
                    e.querySelector('link[rel="preload"][as="style"][' + t + ']')
                        ? (a.loading = qs)
                        : ((t = e.createElement('link')),
                            (a.preload = t),
                            t.addEventListener('load', function () {
                                return (a.loading |= qs);
                            }),
                            t.addEventListener('error', function () {
                                return (a.loading |= k1);
                            }),
                            Mt(t, 'link', n),
                            M(t),
                            e.head.appendChild(t));
                }
                function Bl(e) {
                    return '[src="' + Sn(e) + '"]';
                }
                function us(e) {
                    return 'script[async]' + e;
                }
                function iy(e, t, n) {
                    if ((t.count++, t.instance === null))
                        switch (t.type) {
                            case 'style':
                                var a = e.querySelector(
                                    'style[data-href~="' + Sn(n.href) + '"]'
                                );
                                if (a) return ((t.instance = a), M(a), a);
                                var o = Me({}, n, {
                                    'data-href': n.href,
                                    'data-precedence': n.precedence,
                                    href: null,
                                    precedence: null,
                                });
                                return (
                                    (a = (e.ownerDocument || e).createElement('style')),
                                    M(a),
                                    Mt(a, 'style', o),
                                    rc(a, n.precedence, e),
                                    (t.instance = a)
                                );
                            case 'stylesheet':
                                o = zl(n.href);
                                var c = e.querySelector(cs(o));
                                if (c)
                                    return (
                                        (t.state.loading |= jn),
                                        (t.instance = c),
                                        M(c),
                                        c
                                    );
                                ((a = ay(n)),
                                    (o = Vn.get(o)) && Df(a, o),
                                    (c = (e.ownerDocument || e).createElement('link')),
                                    M(c));
                                var f = c;
                                return (
                                    (f._p = new Promise(function (g, w) {
                                        ((f.onload = g), (f.onerror = w));
                                    })),
                                    Mt(c, 'link', a),
                                    (t.state.loading |= jn),
                                    rc(c, n.precedence, e),
                                    (t.instance = c)
                                );
                            case 'script':
                                return (
                                    (c = Bl(n.src)),
                                    (o = e.querySelector(us(c)))
                                        ? ((t.instance = o), M(o), o)
                                        : ((a = n),
                                            (o = Vn.get(c)) && ((a = Me({}, n)), Tf(a, o)),
                                            (e = e.ownerDocument || e),
                                            (o = e.createElement('script')),
                                            M(o),
                                            Mt(o, 'link', a),
                                            e.head.appendChild(o),
                                            (t.instance = o))
                                );
                            case 'void':
                                return null;
                            default:
                                throw Error(
                                    'acquireResource encountered a resource type it did not expect: "' +
                                    t.type +
                                    '". this is a bug in React.'
                                );
                        }
                    else
                        t.type === 'stylesheet' &&
                            (t.state.loading & jn) === fl &&
                            ((a = t.instance),
                                (t.state.loading |= jn),
                                rc(a, n.precedence, e));
                    return t.instance;
                }
                function rc(e, t, n) {
                    for (
                        var a = n.querySelectorAll(
                            'link[rel="stylesheet"][data-precedence],style[data-precedence]'
                        ),
                        o = a.length ? a[a.length - 1] : null,
                        c = o,
                        f = 0;
                        f < a.length;
                        f++
                    ) {
                        var g = a[f];
                        if (g.dataset.precedence === t) c = g;
                        else if (c !== o) break;
                    }
                    c
                        ? c.parentNode.insertBefore(e, c.nextSibling)
                        : ((t = n.nodeType === 9 ? n.head : n),
                            t.insertBefore(e, t.firstChild));
                }
                function Df(e, t) {
                    (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
                        e.referrerPolicy == null &&
                        (e.referrerPolicy = t.referrerPolicy),
                        e.title == null && (e.title = t.title));
                }
                function Tf(e, t) {
                    (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
                        e.referrerPolicy == null &&
                        (e.referrerPolicy = t.referrerPolicy),
                        e.integrity == null && (e.integrity = t.integrity));
                }
                function ly(e, t, n) {
                    if (tu === null) {
                        var a = new Map(),
                            o = (tu = new Map());
                        o.set(n, a);
                    } else
                        ((o = tu), (a = o.get(n)), a || ((a = new Map()), o.set(n, a)));
                    if (a.has(e)) return a;
                    for (
                        a.set(e, null), n = n.getElementsByTagName(e), o = 0;
                        o < n.length;
                        o++
                    ) {
                        var c = n[o];
                        if (
                            !(
                                c[hs] ||
                                c[Lt] ||
                                (e === 'link' && c.getAttribute('rel') === 'stylesheet')
                            ) &&
                            c.namespaceURI !== _l
                        ) {
                            var f = c.getAttribute(t) || '';
                            f = e + f;
                            var g = a.get(f);
                            g ? g.push(c) : a.set(f, [c]);
                        }
                    }
                    return a;
                }
                function oy(e, t, n) {
                    ((e = e.ownerDocument || e),
                        e.head.insertBefore(
                            n,
                            t === 'title' ? e.querySelector('head > title') : null
                        ));
                }
                function kx(e, t, n) {
                    var a = !n.ancestorInfo.containerTagInScope;
                    if (n.context === So || t.itemProp != null)
                        return (
                            !a ||
                            t.itemProp == null ||
                            (e !== 'meta' &&
                                e !== 'title' &&
                                e !== 'style' &&
                                e !== 'link' &&
                                e !== 'script') ||
                            console.error(
                                'Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.',
                                e,
                                e
                            ),
                            !1
                        );
                    switch (e) {
                        case 'meta':
                        case 'title':
                            return !0;
                        case 'style':
                            if (
                                typeof t.precedence != 'string' ||
                                typeof t.href != 'string' ||
                                t.href === ''
                            ) {
                                a &&
                                    console.error(
                                        'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
                                    );
                                break;
                            }
                            return !0;
                        case 'link':
                            if (
                                typeof t.rel != 'string' ||
                                typeof t.href != 'string' ||
                                t.href === '' ||
                                t.onLoad ||
                                t.onError
                            ) {
                                if (
                                    t.rel === 'stylesheet' &&
                                    typeof t.precedence == 'string'
                                ) {
                                    e = t.href;
                                    var o = t.onError,
                                        c = t.disabled;
                                    ((n = []),
                                        t.onLoad && n.push('`onLoad`'),
                                        o && n.push('`onError`'),
                                        c != null && n.push('`disabled`'),
                                        (o = mx(n, 'and')),
                                        (o += n.length === 1 ? ' prop' : ' props'),
                                        (c = n.length === 1 ? 'an ' + o : 'the ' + o),
                                        n.length &&
                                        console.error(
                                            'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                                            e,
                                            c,
                                            o
                                        ));
                                }
                                a &&
                                    (typeof t.rel != 'string' ||
                                        typeof t.href != 'string' ||
                                        t.href === ''
                                        ? console.error(
                                            'Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag'
                                        )
                                        : (t.onError || t.onLoad) &&
                                        console.error(
                                            'Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>.'
                                        ));
                                break;
                            }
                            switch (t.rel) {
                                case 'stylesheet':
                                    return (
                                        (e = t.precedence),
                                        (t = t.disabled),
                                        typeof e != 'string' &&
                                        a &&
                                        console.error(
                                            'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
                                        ),
                                        typeof e == 'string' && t == null
                                    );
                                default:
                                    return !0;
                            }
                        case 'script':
                            if (
                                ((e =
                                    t.async &&
                                    typeof t.async != 'function' &&
                                    typeof t.async != 'symbol'),
                                    !e ||
                                    t.onLoad ||
                                    t.onError ||
                                    !t.src ||
                                    typeof t.src != 'string')
                            ) {
                                a &&
                                    (e
                                        ? t.onLoad || t.onError
                                            ? console.error(
                                                'Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>.'
                                            )
                                            : console.error(
                                                'Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>.'
                                            )
                                        : console.error(
                                            'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
                                        ));
                                break;
                            }
                            return !0;
                        case 'noscript':
                        case 'template':
                            a &&
                                console.error(
                                    'Cannot render <%s> outside the main document. Try moving it into the root <head> tag.',
                                    e
                                );
                    }
                    return !1;
                }
                function sy(e) {
                    return !(
                        e.type === 'stylesheet' && (e.state.loading & j1) === fl
                    );
                }
                function jx() { }
                function Vx(e, t, n) {
                    if ($s === null)
                        throw Error(
                            'Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug.'
                        );
                    var a = $s;
                    if (
                        t.type === 'stylesheet' &&
                        (typeof n.media != 'string' ||
                            matchMedia(n.media).matches !== !1) &&
                        (t.state.loading & jn) === fl
                    ) {
                        if (t.instance === null) {
                            var o = zl(n.href),
                                c = e.querySelector(cs(o));
                            if (c) {
                                ((e = c._p),
                                    e !== null &&
                                    typeof e == 'object' &&
                                    typeof e.then == 'function' &&
                                    (a.count++, (a = cc.bind(a)), e.then(a, a)),
                                    (t.state.loading |= jn),
                                    (t.instance = c),
                                    M(c));
                                return;
                            }
                            ((c = e.ownerDocument || e),
                                (n = ay(n)),
                                (o = Vn.get(o)) && Df(n, o),
                                (c = c.createElement('link')),
                                M(c));
                            var f = c;
                            ((f._p = new Promise(function (g, w) {
                                ((f.onload = g), (f.onerror = w));
                            })),
                                Mt(c, 'link', n),
                                (t.instance = c));
                        }
                        (a.stylesheets === null && (a.stylesheets = new Map()),
                            a.stylesheets.set(t, e),
                            (e = t.state.preload) &&
                            (t.state.loading & j1) === fl &&
                            (a.count++,
                                (t = cc.bind(a)),
                                e.addEventListener('load', t),
                                e.addEventListener('error', t)));
                    }
                }
                function zx() {
                    if ($s === null)
                        throw Error(
                            'Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug.'
                        );
                    var e = $s;
                    return (
                        e.stylesheets && e.count === 0 && Cf(e, e.stylesheets),
                        0 < e.count
                            ? function (t) {
                                var n = setTimeout(function () {
                                    if (
                                        (e.stylesheets && Cf(e, e.stylesheets), e.unsuspend)
                                    ) {
                                        var a = e.unsuspend;
                                        ((e.unsuspend = null), a());
                                    }
                                }, 6e4);
                                return (
                                    (e.unsuspend = t),
                                    function () {
                                        ((e.unsuspend = null), clearTimeout(n));
                                    }
                                );
                            }
                            : null
                    );
                }
                function cc() {
                    if ((this.count--, this.count === 0)) {
                        if (this.stylesheets) Cf(this, this.stylesheets);
                        else if (this.unsuspend) {
                            var e = this.unsuspend;
                            ((this.unsuspend = null), e());
                        }
                    }
                }
                function Cf(e, t) {
                    ((e.stylesheets = null),
                        e.unsuspend !== null &&
                        (e.count++,
                            (nu = new Map()),
                            t.forEach(Bx, e),
                            (nu = null),
                            cc.call(e)));
                }
                function Bx(e, t) {
                    if (!(t.state.loading & jn)) {
                        var n = nu.get(e);
                        if (n) var a = n.get(tp);
                        else {
                            ((n = new Map()), nu.set(e, n));
                            for (
                                var o = e.querySelectorAll(
                                    'link[data-precedence],style[data-precedence]'
                                ),
                                c = 0;
                                c < o.length;
                                c++
                            ) {
                                var f = o[c];
                                (f.nodeName === 'LINK' ||
                                    f.getAttribute('media') !== 'not all') &&
                                    (n.set(f.dataset.precedence, f), (a = f));
                            }
                            a && n.set(tp, a);
                        }
                        ((o = t.instance),
                            (f = o.getAttribute('data-precedence')),
                            (c = n.get(f) || a),
                            c === a && n.set(tp, o),
                            n.set(f, o),
                            this.count++,
                            (a = cc.bind(this)),
                            o.addEventListener('load', a),
                            o.addEventListener('error', a),
                            c
                                ? c.parentNode.insertBefore(o, c.nextSibling)
                                : ((e = e.nodeType === 9 ? e.head : e),
                                    e.insertBefore(o, e.firstChild)),
                            (t.state.loading |= jn));
                    }
                }
                function Lx(e, t, n, a, o, c, f, g) {
                    for (
                        this.tag = 1,
                        this.containerInfo = e,
                        this.pingCache = this.current = this.pendingChildren = null,
                        this.timeoutHandle = dl,
                        this.callbackNode =
                        this.next =
                        this.pendingContext =
                        this.context =
                        this.cancelPendingCommit =
                        null,
                        this.callbackPriority = 0,
                        this.expirationTimes = yl(-1),
                        this.entangledLanes =
                        this.shellSuspendCounter =
                        this.errorRecoveryDisabledLanes =
                        this.expiredLanes =
                        this.warmLanes =
                        this.pingedLanes =
                        this.suspendedLanes =
                        this.pendingLanes =
                        0,
                        this.entanglements = yl(0),
                        this.hiddenUpdates = yl(null),
                        this.identifierPrefix = a,
                        this.onUncaughtError = o,
                        this.onCaughtError = c,
                        this.onRecoverableError = f,
                        this.pooledCache = null,
                        this.pooledCacheLanes = 0,
                        this.formState = g,
                        this.incompleteTransitions = new Map(),
                        this.passiveEffectDuration = this.effectDuration = -0,
                        this.memoizedUpdaters = new Set(),
                        e = this.pendingUpdatersLaneMap = [],
                        t = 0;
                        31 > t;
                        t++
                    )
                        e.push(new Set());
                    this._debugRootType = n ? 'hydrateRoot()' : 'createRoot()';
                }
                function ry(e, t, n, a, o, c, f, g, w, A, V, L) {
                    return (
                        (e = new Lx(e, t, n, f, g, w, A, L)),
                        (t = ew),
                        c === !0 && (t |= It | Yn),
                        _n && (t |= kt),
                        (c = N(3, null, null, t)),
                        (e.current = c),
                        (c.stateNode = e),
                        (t = ad()),
                        _i(t),
                        (e.pooledCache = t),
                        _i(t),
                        (c.memoizedState = { element: a, isDehydrated: n, cache: t }),
                        sd(c),
                        e
                    );
                }
                function cy(e) {
                    return e ? ((e = mi), e) : mi;
                }
                function Rf(e, t, n, a, o, c) {
                    if (Bt && typeof Bt.onScheduleFiberRoot == 'function')
                        try {
                            Bt.onScheduleFiberRoot(Ul, a, n);
                        } catch (f) {
                            sa ||
                                ((sa = !0),
                                    console.error(
                                        'React instrumentation encountered an error: %s',
                                        f
                                    ));
                        }
                    (se !== null &&
                        typeof se.markRenderScheduled == 'function' &&
                        se.markRenderScheduled(t),
                        (o = cy(o)),
                        a.context === null ? (a.context = o) : (a.pendingContext = o),
                        ca &&
                        fn !== null &&
                        !I1 &&
                        ((I1 = !0),
                            console.error(
                                `Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,
                                K(fn) || 'Unknown'
                            )),
                        (a = Ka(t)),
                        (a.payload = { element: n }),
                        (c = c === void 0 ? null : c),
                        c !== null &&
                        (typeof c != 'function' &&
                            console.error(
                                'Expected the last optional `callback` argument to be a function. Instead received: %s.',
                                c
                            ),
                            (a.callback = c)),
                        (n = ei(e, a, t)),
                        n !== null && (ft(n, e, t), Wo(n, e, t)));
                }
                function uy(e, t) {
                    if (
                        ((e = e.memoizedState), e !== null && e.dehydrated !== null)
                    ) {
                        var n = e.retryLane;
                        e.retryLane = n !== 0 && n < t ? n : t;
                    }
                }
                function Mf(e, t) {
                    (uy(e, t), (e = e.alternate) && uy(e, t));
                }
                function dy(e) {
                    if (e.tag === 13) {
                        var t = $t(e, 67108864);
                        (t !== null && ft(t, e, 67108864), Mf(e, 67108864));
                    }
                }
                function Ix() {
                    return fn;
                }
                function Hx() {
                    for (var e = new Map(), t = 1, n = 0; 31 > n; n++) {
                        var a = To(t);
                        (e.set(t, a), (t *= 2));
                    }
                    return e;
                }
                function Ux(e, t, n, a) {
                    var o = B.T;
                    B.T = null;
                    var c = Ye.p;
                    try {
                        ((Ye.p = wn), Of(e, t, n, a));
                    } finally {
                        ((Ye.p = c), (B.T = o));
                    }
                }
                function Gx(e, t, n, a) {
                    var o = B.T;
                    B.T = null;
                    var c = Ye.p;
                    try {
                        ((Ye.p = ra), Of(e, t, n, a));
                    } finally {
                        ((Ye.p = c), (B.T = o));
                    }
                }
                function Of(e, t, n, a) {
                    if (iu) {
                        var o = kf(a);
                        if (o === null) (bf(e, t, a, lu, n), my(e, a));
                        else if (_x(o, e, t, n, a)) a.stopPropagation();
                        else if ((my(e, a), t & 4 && -1 < kw.indexOf(e))) {
                            for (; o !== null;) {
                                var c = Hn(o);
                                if (c !== null)
                                    switch (c.tag) {
                                        case 3:
                                            if (
                                                ((c = c.stateNode),
                                                    c.current.memoizedState.isDehydrated)
                                            ) {
                                                var f = ht(c.pendingLanes);
                                                if (f !== 0) {
                                                    var g = c;
                                                    for (
                                                        g.pendingLanes |= 2, g.entangledLanes |= 2;
                                                        f;
                                                    ) {
                                                        var w = 1 << (31 - Gt(f));
                                                        ((g.entanglements[1] |= w), (f &= ~w));
                                                    }
                                                    (aa(c),
                                                        (Pe & (Wt | Xn)) === mn &&
                                                        ((_c = oa() + g1), os(0)));
                                                }
                                            }
                                            break;
                                        case 13:
                                            ((g = $t(c, 2)),
                                                g !== null && ft(g, c, 2),
                                                Ol(),
                                                Mf(c, 2));
                                    }
                                if (
                                    ((c = kf(a)), c === null && bf(e, t, a, lu, n), c === o)
                                )
                                    break;
                                o = c;
                            }
                            o !== null && a.stopPropagation();
                        } else bf(e, t, a, null, n);
                    }
                }
                function kf(e) {
                    return ((e = _u(e)), jf(e));
                }
                function jf(e) {
                    if (((lu = null), (e = In(e)), e !== null)) {
                        var t = _(e);
                        if (t === null) e = null;
                        else {
                            var n = t.tag;
                            if (n === 13) {
                                if (((e = I(t)), e !== null)) return e;
                                e = null;
                            } else if (n === 3) {
                                if (t.stateNode.current.memoizedState.isDehydrated)
                                    return t.tag === 3 ? t.stateNode.containerInfo : null;
                                e = null;
                            } else t !== e && (e = null);
                        }
                    }
                    return ((lu = e), null);
                }
                function fy(e) {
                    switch (e) {
                        case 'beforetoggle':
                        case 'cancel':
                        case 'click':
                        case 'close':
                        case 'contextmenu':
                        case 'copy':
                        case 'cut':
                        case 'auxclick':
                        case 'dblclick':
                        case 'dragend':
                        case 'dragstart':
                        case 'drop':
                        case 'focusin':
                        case 'focusout':
                        case 'input':
                        case 'invalid':
                        case 'keydown':
                        case 'keypress':
                        case 'keyup':
                        case 'mousedown':
                        case 'mouseup':
                        case 'paste':
                        case 'pause':
                        case 'play':
                        case 'pointercancel':
                        case 'pointerdown':
                        case 'pointerup':
                        case 'ratechange':
                        case 'reset':
                        case 'resize':
                        case 'seeked':
                        case 'submit':
                        case 'toggle':
                        case 'touchcancel':
                        case 'touchend':
                        case 'touchstart':
                        case 'volumechange':
                        case 'change':
                        case 'selectionchange':
                        case 'textInput':
                        case 'compositionstart':
                        case 'compositionend':
                        case 'compositionupdate':
                        case 'beforeblur':
                        case 'afterblur':
                        case 'beforeinput':
                        case 'blur':
                        case 'fullscreenchange':
                        case 'focus':
                        case 'hashchange':
                        case 'popstate':
                        case 'select':
                        case 'selectstart':
                            return wn;
                        case 'drag':
                        case 'dragenter':
                        case 'dragexit':
                        case 'dragleave':
                        case 'dragover':
                        case 'mousemove':
                        case 'mouseout':
                        case 'mouseover':
                        case 'pointermove':
                        case 'pointerout':
                        case 'pointerover':
                        case 'scroll':
                        case 'touchmove':
                        case 'wheel':
                        case 'mouseenter':
                        case 'mouseleave':
                        case 'pointerenter':
                        case 'pointerleave':
                            return ra;
                        case 'message':
                            switch (Kx()) {
                                case Pf:
                                    return wn;
                                case Zf:
                                    return ra;
                                case Hl:
                                case eN:
                                    return ka;
                                case Wf:
                                    return yc;
                                default:
                                    return ka;
                            }
                        default:
                            return ka;
                    }
                }
                function my(e, t) {
                    switch (e) {
                        case 'focusin':
                        case 'focusout':
                            wi = null;
                            break;
                        case 'dragenter':
                        case 'dragleave':
                            Ei = null;
                            break;
                        case 'mouseover':
                        case 'mouseout':
                            Ai = null;
                            break;
                        case 'pointerover':
                        case 'pointerout':
                            Ks.delete(t.pointerId);
                            break;
                        case 'gotpointercapture':
                        case 'lostpointercapture':
                            er.delete(t.pointerId);
                    }
                }
                function ds(e, t, n, a, o, c) {
                    return e === null || e.nativeEvent !== c
                        ? ((e = {
                            blockedOn: t,
                            domEventName: n,
                            eventSystemFlags: a,
                            nativeEvent: c,
                            targetContainers: [o],
                        }),
                            t !== null && ((t = Hn(t)), t !== null && dy(t)),
                            e)
                        : ((e.eventSystemFlags |= a),
                            (t = e.targetContainers),
                            o !== null && t.indexOf(o) === -1 && t.push(o),
                            e);
                }
                function _x(e, t, n, a, o) {
                    switch (t) {
                        case 'focusin':
                            return ((wi = ds(wi, e, t, n, a, o)), !0);
                        case 'dragenter':
                            return ((Ei = ds(Ei, e, t, n, a, o)), !0);
                        case 'mouseover':
                            return ((Ai = ds(Ai, e, t, n, a, o)), !0);
                        case 'pointerover':
                            var c = o.pointerId;
                            return (Ks.set(c, ds(Ks.get(c) || null, e, t, n, a, o)), !0);
                        case 'gotpointercapture':
                            return (
                                (c = o.pointerId),
                                er.set(c, ds(er.get(c) || null, e, t, n, a, o)),
                                !0
                            );
                    }
                    return !1;
                }
                function py(e) {
                    var t = In(e.target);
                    if (t !== null) {
                        var n = _(t);
                        if (n !== null) {
                            if (((t = n.tag), t === 13)) {
                                if (((t = I(n)), t !== null)) {
                                    ((e.blockedOn = t),
                                        Sl(e.priority, function () {
                                            if (n.tag === 13) {
                                                var a = un(n);
                                                a = Ro(a);
                                                var o = $t(n, a);
                                                (o !== null && ft(o, n, a), Mf(n, a));
                                            }
                                        }));
                                    return;
                                }
                            } else if (
                                t === 3 &&
                                n.stateNode.current.memoizedState.isDehydrated
                            ) {
                                e.blockedOn =
                                    n.tag === 3 ? n.stateNode.containerInfo : null;
                                return;
                            }
                        }
                    }
                    e.blockedOn = null;
                }
                function uc(e) {
                    if (e.blockedOn !== null) return !1;
                    for (var t = e.targetContainers; 0 < t.length;) {
                        var n = kf(e.nativeEvent);
                        if (n === null) {
                            n = e.nativeEvent;
                            var a = new n.constructor(n.type, n),
                                o = a;
                            (bs !== null &&
                                console.error(
                                    'Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.'
                                ),
                                (bs = o),
                                n.target.dispatchEvent(a),
                                bs === null &&
                                console.error(
                                    'Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.'
                                ),
                                (bs = null));
                        } else
                            return (
                                (t = Hn(n)),
                                t !== null && dy(t),
                                (e.blockedOn = n),
                                !1
                            );
                        t.shift();
                    }
                    return !0;
                }
                function hy(e, t, n) {
                    uc(e) && n.delete(t);
                }
                function Yx() {
                    ((np = !1),
                        wi !== null && uc(wi) && (wi = null),
                        Ei !== null && uc(Ei) && (Ei = null),
                        Ai !== null && uc(Ai) && (Ai = null),
                        Ks.forEach(hy),
                        er.forEach(hy));
                }
                function dc(e, t) {
                    e.blockedOn === t &&
                        ((e.blockedOn = null),
                            np ||
                            ((np = !0),
                                gt.unstable_scheduleCallback(
                                    gt.unstable_NormalPriority,
                                    Yx
                                )));
                }
                function gy(e) {
                    ou !== e &&
                        ((ou = e),
                            gt.unstable_scheduleCallback(
                                gt.unstable_NormalPriority,
                                function () {
                                    ou === e && (ou = null);
                                    for (var t = 0; t < e.length; t += 3) {
                                        var n = e[t],
                                            a = e[t + 1],
                                            o = e[t + 2];
                                        if (typeof a != 'function') {
                                            if (jf(a || n) === null) continue;
                                            break;
                                        }
                                        var c = Hn(n);
                                        c !== null &&
                                            (e.splice(t, 3),
                                                (t -= 3),
                                                (n = {
                                                    pending: !0,
                                                    data: o,
                                                    method: n.method,
                                                    action: a,
                                                }),
                                                Object.freeze(n),
                                                kd(c, n, a, o));
                                    }
                                }
                            ));
                }
                function fs(e) {
                    function t(w) {
                        return dc(w, e);
                    }
                    (wi !== null && dc(wi, e),
                        Ei !== null && dc(Ei, e),
                        Ai !== null && dc(Ai, e),
                        Ks.forEach(t),
                        er.forEach(t));
                    for (var n = 0; n < Di.length; n++) {
                        var a = Di[n];
                        a.blockedOn === e && (a.blockedOn = null);
                    }
                    for (; 0 < Di.length && ((n = Di[0]), n.blockedOn === null);)
                        (py(n), n.blockedOn === null && Di.shift());
                    if (((n = (e.ownerDocument || e).$$reactFormReplay), n != null))
                        for (a = 0; a < n.length; a += 3) {
                            var o = n[a],
                                c = n[a + 1],
                                f = o[en] || null;
                            if (typeof c == 'function') f || gy(n);
                            else if (f) {
                                var g = null;
                                if (c && c.hasAttribute('formAction')) {
                                    if (((o = c), (f = c[en] || null))) g = f.formAction;
                                    else if (jf(o) !== null) continue;
                                } else g = f.action;
                                (typeof g == 'function'
                                    ? (n[a + 1] = g)
                                    : (n.splice(a, 3), (a -= 3)),
                                    gy(n));
                            }
                        }
                }
                function Vf(e) {
                    this._internalRoot = e;
                }
                function fc(e) {
                    this._internalRoot = e;
                }
                function by(e) {
                    e[di] &&
                        (e._reactRootContainer
                            ? console.error(
                                'You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.'
                            )
                            : console.error(
                                'You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.'
                            ));
                }
                typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ==
                    'function' &&
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(
                        Error()
                    );
                var gt = Hw(),
                    zf = Nu(),
                    Px = z0(),
                    Me = Object.assign,
                    Zx = Symbol.for('react.element'),
                    si = Symbol.for('react.transitional.element'),
                    Ll = Symbol.for('react.portal'),
                    Il = Symbol.for('react.fragment'),
                    mc = Symbol.for('react.strict_mode'),
                    Bf = Symbol.for('react.profiler'),
                    Wx = Symbol.for('react.provider'),
                    Lf = Symbol.for('react.consumer'),
                    la = Symbol.for('react.context'),
                    ms = Symbol.for('react.forward_ref'),
                    If = Symbol.for('react.suspense'),
                    Hf = Symbol.for('react.suspense_list'),
                    pc = Symbol.for('react.memo'),
                    dn = Symbol.for('react.lazy'),
                    Uf = Symbol.for('react.activity'),
                    Xx = Symbol.for('react.memo_cache_sentinel'),
                    yy = Symbol.iterator,
                    Qx = Symbol.for('react.client.reference'),
                    Ot = Array.isArray,
                    B =
                        zf.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
                    Ye =
                        Px.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
                    Jx = Object.freeze({
                        pending: !1,
                        data: null,
                        method: null,
                        action: null,
                    }),
                    Gf = [],
                    _f = [],
                    Ma = -1,
                    ri = te(null),
                    ps = te(null),
                    ci = te(null),
                    hc = te(null),
                    Oa = Object.prototype.hasOwnProperty,
                    Yf = gt.unstable_scheduleCallback,
                    qx = gt.unstable_cancelCallback,
                    $x = gt.unstable_shouldYield,
                    Fx = gt.unstable_requestPaint,
                    oa = gt.unstable_now,
                    Kx = gt.unstable_getCurrentPriorityLevel,
                    Pf = gt.unstable_ImmediatePriority,
                    Zf = gt.unstable_UserBlockingPriority,
                    Hl = gt.unstable_NormalPriority,
                    eN = gt.unstable_LowPriority,
                    Wf = gt.unstable_IdlePriority,
                    tN = gt.log,
                    nN = gt.unstable_setDisableYieldValue,
                    Ul = null,
                    Bt = null,
                    se = null,
                    sa = !1,
                    _n = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u',
                    Gt = Math.clz32 ? Math.clz32 : ur,
                    aN = Math.log,
                    iN = Math.LN2,
                    gc = 256,
                    bc = 4194304,
                    wn = 2,
                    ra = 8,
                    ka = 32,
                    yc = 268435456,
                    ui = Math.random().toString(36).slice(2),
                    Lt = '__reactFiber$' + ui,
                    en = '__reactProps$' + ui,
                    di = '__reactContainer$' + ui,
                    Xf = '__reactEvents$' + ui,
                    lN = '__reactListeners$' + ui,
                    oN = '__reactHandles$' + ui,
                    vy = '__reactResources$' + ui,
                    hs = '__reactMarker$' + ui,
                    Sy = new Set(),
                    Qi = {},
                    Qf = {},
                    sN = {
                        button: !0,
                        checkbox: !0,
                        image: !0,
                        hidden: !0,
                        radio: !0,
                        reset: !0,
                        submit: !0,
                    },
                    rN = RegExp(
                        '^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
                    ),
                    xy = {},
                    Ny = {},
                    gs = 0,
                    wy,
                    Ey,
                    Ay,
                    Dy,
                    Ty,
                    Cy,
                    Ry;
                Sa.__reactDisabledLog = !0;
                var Jf,
                    My,
                    qf = !1,
                    $f = new (typeof WeakMap == 'function' ? WeakMap : Map)(),
                    fn = null,
                    ca = !1,
                    cN = /[\n"\\]/g,
                    Oy = !1,
                    ky = !1,
                    jy = !1,
                    Vy = !1,
                    zy = !1,
                    By = !1,
                    Ly = ['value', 'defaultValue'],
                    Iy = !1,
                    Hy = /["'&<>\n\t]|^\s|\s$/,
                    uN =
                        'address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp'.split(
                            ' '
                        ),
                    Uy =
                        'applet caption html table td th marquee object template foreignObject desc title'.split(
                            ' '
                        ),
                    dN = Uy.concat(['button']),
                    fN = 'dd dt li option optgroup p rp rt'.split(' '),
                    Gy = {
                        current: null,
                        formTag: null,
                        aTagInScope: null,
                        buttonTagInScope: null,
                        nobrTagInScope: null,
                        pTagInButtonScope: null,
                        listItemTagAutoclosing: null,
                        dlItemTagAutoclosing: null,
                        containerTagInScope: null,
                        implicitRootScope: !1,
                    },
                    vc = {},
                    Ff = {
                        animation:
                            'animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction'.split(
                                ' '
                            ),
                        background:
                            'backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize'.split(
                                ' '
                            ),
                        backgroundPosition: [
                            'backgroundPositionX',
                            'backgroundPositionY',
                        ],
                        border:
                            'borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth'.split(
                                ' '
                            ),
                        borderBlockEnd: [
                            'borderBlockEndColor',
                            'borderBlockEndStyle',
                            'borderBlockEndWidth',
                        ],
                        borderBlockStart: [
                            'borderBlockStartColor',
                            'borderBlockStartStyle',
                            'borderBlockStartWidth',
                        ],
                        borderBottom: [
                            'borderBottomColor',
                            'borderBottomStyle',
                            'borderBottomWidth',
                        ],
                        borderColor: [
                            'borderBottomColor',
                            'borderLeftColor',
                            'borderRightColor',
                            'borderTopColor',
                        ],
                        borderImage: [
                            'borderImageOutset',
                            'borderImageRepeat',
                            'borderImageSlice',
                            'borderImageSource',
                            'borderImageWidth',
                        ],
                        borderInlineEnd: [
                            'borderInlineEndColor',
                            'borderInlineEndStyle',
                            'borderInlineEndWidth',
                        ],
                        borderInlineStart: [
                            'borderInlineStartColor',
                            'borderInlineStartStyle',
                            'borderInlineStartWidth',
                        ],
                        borderLeft: [
                            'borderLeftColor',
                            'borderLeftStyle',
                            'borderLeftWidth',
                        ],
                        borderRadius: [
                            'borderBottomLeftRadius',
                            'borderBottomRightRadius',
                            'borderTopLeftRadius',
                            'borderTopRightRadius',
                        ],
                        borderRight: [
                            'borderRightColor',
                            'borderRightStyle',
                            'borderRightWidth',
                        ],
                        borderStyle: [
                            'borderBottomStyle',
                            'borderLeftStyle',
                            'borderRightStyle',
                            'borderTopStyle',
                        ],
                        borderTop: [
                            'borderTopColor',
                            'borderTopStyle',
                            'borderTopWidth',
                        ],
                        borderWidth: [
                            'borderBottomWidth',
                            'borderLeftWidth',
                            'borderRightWidth',
                            'borderTopWidth',
                        ],
                        columnRule: [
                            'columnRuleColor',
                            'columnRuleStyle',
                            'columnRuleWidth',
                        ],
                        columns: ['columnCount', 'columnWidth'],
                        flex: ['flexBasis', 'flexGrow', 'flexShrink'],
                        flexFlow: ['flexDirection', 'flexWrap'],
                        font: 'fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight'.split(
                            ' '
                        ),
                        fontVariant:
                            'fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition'.split(
                                ' '
                            ),
                        gap: ['columnGap', 'rowGap'],
                        grid: 'gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows'.split(
                            ' '
                        ),
                        gridArea: [
                            'gridColumnEnd',
                            'gridColumnStart',
                            'gridRowEnd',
                            'gridRowStart',
                        ],
                        gridColumn: ['gridColumnEnd', 'gridColumnStart'],
                        gridColumnGap: ['columnGap'],
                        gridGap: ['columnGap', 'rowGap'],
                        gridRow: ['gridRowEnd', 'gridRowStart'],
                        gridRowGap: ['rowGap'],
                        gridTemplate: [
                            'gridTemplateAreas',
                            'gridTemplateColumns',
                            'gridTemplateRows',
                        ],
                        listStyle: [
                            'listStyleImage',
                            'listStylePosition',
                            'listStyleType',
                        ],
                        margin: [
                            'marginBottom',
                            'marginLeft',
                            'marginRight',
                            'marginTop',
                        ],
                        marker: ['markerEnd', 'markerMid', 'markerStart'],
                        mask: 'maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize'.split(
                            ' '
                        ),
                        maskPosition: ['maskPositionX', 'maskPositionY'],
                        outline: ['outlineColor', 'outlineStyle', 'outlineWidth'],
                        overflow: ['overflowX', 'overflowY'],
                        padding: [
                            'paddingBottom',
                            'paddingLeft',
                            'paddingRight',
                            'paddingTop',
                        ],
                        placeContent: ['alignContent', 'justifyContent'],
                        placeItems: ['alignItems', 'justifyItems'],
                        placeSelf: ['alignSelf', 'justifySelf'],
                        textDecoration: [
                            'textDecorationColor',
                            'textDecorationLine',
                            'textDecorationStyle',
                        ],
                        textEmphasis: ['textEmphasisColor', 'textEmphasisStyle'],
                        transition: [
                            'transitionDelay',
                            'transitionDuration',
                            'transitionProperty',
                            'transitionTimingFunction',
                        ],
                        wordWrap: ['overflowWrap'],
                    },
                    _y = /([A-Z])/g,
                    Yy = /^ms-/,
                    mN = /^(?:webkit|moz|o)[A-Z]/,
                    pN = /^-ms-/,
                    hN = /-(.)/g,
                    Py = /;\s*$/,
                    Gl = {},
                    Kf = {},
                    Zy = !1,
                    Wy = !1,
                    Xy = new Set(
                        'animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp'.split(
                            ' '
                        )
                    ),
                    Sc = 'http://www.w3.org/1998/Math/MathML',
                    _l = 'http://www.w3.org/2000/svg',
                    gN = new Map([
                        ['acceptCharset', 'accept-charset'],
                        ['htmlFor', 'for'],
                        ['httpEquiv', 'http-equiv'],
                        ['crossOrigin', 'crossorigin'],
                        ['accentHeight', 'accent-height'],
                        ['alignmentBaseline', 'alignment-baseline'],
                        ['arabicForm', 'arabic-form'],
                        ['baselineShift', 'baseline-shift'],
                        ['capHeight', 'cap-height'],
                        ['clipPath', 'clip-path'],
                        ['clipRule', 'clip-rule'],
                        ['colorInterpolation', 'color-interpolation'],
                        ['colorInterpolationFilters', 'color-interpolation-filters'],
                        ['colorProfile', 'color-profile'],
                        ['colorRendering', 'color-rendering'],
                        ['dominantBaseline', 'dominant-baseline'],
                        ['enableBackground', 'enable-background'],
                        ['fillOpacity', 'fill-opacity'],
                        ['fillRule', 'fill-rule'],
                        ['floodColor', 'flood-color'],
                        ['floodOpacity', 'flood-opacity'],
                        ['fontFamily', 'font-family'],
                        ['fontSize', 'font-size'],
                        ['fontSizeAdjust', 'font-size-adjust'],
                        ['fontStretch', 'font-stretch'],
                        ['fontStyle', 'font-style'],
                        ['fontVariant', 'font-variant'],
                        ['fontWeight', 'font-weight'],
                        ['glyphName', 'glyph-name'],
                        ['glyphOrientationHorizontal', 'glyph-orientation-horizontal'],
                        ['glyphOrientationVertical', 'glyph-orientation-vertical'],
                        ['horizAdvX', 'horiz-adv-x'],
                        ['horizOriginX', 'horiz-origin-x'],
                        ['imageRendering', 'image-rendering'],
                        ['letterSpacing', 'letter-spacing'],
                        ['lightingColor', 'lighting-color'],
                        ['markerEnd', 'marker-end'],
                        ['markerMid', 'marker-mid'],
                        ['markerStart', 'marker-start'],
                        ['overlinePosition', 'overline-position'],
                        ['overlineThickness', 'overline-thickness'],
                        ['paintOrder', 'paint-order'],
                        ['panose-1', 'panose-1'],
                        ['pointerEvents', 'pointer-events'],
                        ['renderingIntent', 'rendering-intent'],
                        ['shapeRendering', 'shape-rendering'],
                        ['stopColor', 'stop-color'],
                        ['stopOpacity', 'stop-opacity'],
                        ['strikethroughPosition', 'strikethrough-position'],
                        ['strikethroughThickness', 'strikethrough-thickness'],
                        ['strokeDasharray', 'stroke-dasharray'],
                        ['strokeDashoffset', 'stroke-dashoffset'],
                        ['strokeLinecap', 'stroke-linecap'],
                        ['strokeLinejoin', 'stroke-linejoin'],
                        ['strokeMiterlimit', 'stroke-miterlimit'],
                        ['strokeOpacity', 'stroke-opacity'],
                        ['strokeWidth', 'stroke-width'],
                        ['textAnchor', 'text-anchor'],
                        ['textDecoration', 'text-decoration'],
                        ['textRendering', 'text-rendering'],
                        ['transformOrigin', 'transform-origin'],
                        ['underlinePosition', 'underline-position'],
                        ['underlineThickness', 'underline-thickness'],
                        ['unicodeBidi', 'unicode-bidi'],
                        ['unicodeRange', 'unicode-range'],
                        ['unitsPerEm', 'units-per-em'],
                        ['vAlphabetic', 'v-alphabetic'],
                        ['vHanging', 'v-hanging'],
                        ['vIdeographic', 'v-ideographic'],
                        ['vMathematical', 'v-mathematical'],
                        ['vectorEffect', 'vector-effect'],
                        ['vertAdvY', 'vert-adv-y'],
                        ['vertOriginX', 'vert-origin-x'],
                        ['vertOriginY', 'vert-origin-y'],
                        ['wordSpacing', 'word-spacing'],
                        ['writingMode', 'writing-mode'],
                        ['xmlnsXlink', 'xmlns:xlink'],
                        ['xHeight', 'x-height'],
                    ]),
                    xc = {
                        accept: 'accept',
                        acceptcharset: 'acceptCharset',
                        'accept-charset': 'acceptCharset',
                        accesskey: 'accessKey',
                        action: 'action',
                        allowfullscreen: 'allowFullScreen',
                        alt: 'alt',
                        as: 'as',
                        async: 'async',
                        autocapitalize: 'autoCapitalize',
                        autocomplete: 'autoComplete',
                        autocorrect: 'autoCorrect',
                        autofocus: 'autoFocus',
                        autoplay: 'autoPlay',
                        autosave: 'autoSave',
                        capture: 'capture',
                        cellpadding: 'cellPadding',
                        cellspacing: 'cellSpacing',
                        challenge: 'challenge',
                        charset: 'charSet',
                        checked: 'checked',
                        children: 'children',
                        cite: 'cite',
                        class: 'className',
                        classid: 'classID',
                        classname: 'className',
                        cols: 'cols',
                        colspan: 'colSpan',
                        content: 'content',
                        contenteditable: 'contentEditable',
                        contextmenu: 'contextMenu',
                        controls: 'controls',
                        controlslist: 'controlsList',
                        coords: 'coords',
                        crossorigin: 'crossOrigin',
                        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
                        data: 'data',
                        datetime: 'dateTime',
                        default: 'default',
                        defaultchecked: 'defaultChecked',
                        defaultvalue: 'defaultValue',
                        defer: 'defer',
                        dir: 'dir',
                        disabled: 'disabled',
                        disablepictureinpicture: 'disablePictureInPicture',
                        disableremoteplayback: 'disableRemotePlayback',
                        download: 'download',
                        draggable: 'draggable',
                        enctype: 'encType',
                        enterkeyhint: 'enterKeyHint',
                        fetchpriority: 'fetchPriority',
                        for: 'htmlFor',
                        form: 'form',
                        formmethod: 'formMethod',
                        formaction: 'formAction',
                        formenctype: 'formEncType',
                        formnovalidate: 'formNoValidate',
                        formtarget: 'formTarget',
                        frameborder: 'frameBorder',
                        headers: 'headers',
                        height: 'height',
                        hidden: 'hidden',
                        high: 'high',
                        href: 'href',
                        hreflang: 'hrefLang',
                        htmlfor: 'htmlFor',
                        httpequiv: 'httpEquiv',
                        'http-equiv': 'httpEquiv',
                        icon: 'icon',
                        id: 'id',
                        imagesizes: 'imageSizes',
                        imagesrcset: 'imageSrcSet',
                        inert: 'inert',
                        innerhtml: 'innerHTML',
                        inputmode: 'inputMode',
                        integrity: 'integrity',
                        is: 'is',
                        itemid: 'itemID',
                        itemprop: 'itemProp',
                        itemref: 'itemRef',
                        itemscope: 'itemScope',
                        itemtype: 'itemType',
                        keyparams: 'keyParams',
                        keytype: 'keyType',
                        kind: 'kind',
                        label: 'label',
                        lang: 'lang',
                        list: 'list',
                        loop: 'loop',
                        low: 'low',
                        manifest: 'manifest',
                        marginwidth: 'marginWidth',
                        marginheight: 'marginHeight',
                        max: 'max',
                        maxlength: 'maxLength',
                        media: 'media',
                        mediagroup: 'mediaGroup',
                        method: 'method',
                        min: 'min',
                        minlength: 'minLength',
                        multiple: 'multiple',
                        muted: 'muted',
                        name: 'name',
                        nomodule: 'noModule',
                        nonce: 'nonce',
                        novalidate: 'noValidate',
                        open: 'open',
                        optimum: 'optimum',
                        pattern: 'pattern',
                        placeholder: 'placeholder',
                        playsinline: 'playsInline',
                        poster: 'poster',
                        preload: 'preload',
                        profile: 'profile',
                        radiogroup: 'radioGroup',
                        readonly: 'readOnly',
                        referrerpolicy: 'referrerPolicy',
                        rel: 'rel',
                        required: 'required',
                        reversed: 'reversed',
                        role: 'role',
                        rows: 'rows',
                        rowspan: 'rowSpan',
                        sandbox: 'sandbox',
                        scope: 'scope',
                        scoped: 'scoped',
                        scrolling: 'scrolling',
                        seamless: 'seamless',
                        selected: 'selected',
                        shape: 'shape',
                        size: 'size',
                        sizes: 'sizes',
                        span: 'span',
                        spellcheck: 'spellCheck',
                        src: 'src',
                        srcdoc: 'srcDoc',
                        srclang: 'srcLang',
                        srcset: 'srcSet',
                        start: 'start',
                        step: 'step',
                        style: 'style',
                        summary: 'summary',
                        tabindex: 'tabIndex',
                        target: 'target',
                        title: 'title',
                        type: 'type',
                        usemap: 'useMap',
                        value: 'value',
                        width: 'width',
                        wmode: 'wmode',
                        wrap: 'wrap',
                        about: 'about',
                        accentheight: 'accentHeight',
                        'accent-height': 'accentHeight',
                        accumulate: 'accumulate',
                        additive: 'additive',
                        alignmentbaseline: 'alignmentBaseline',
                        'alignment-baseline': 'alignmentBaseline',
                        allowreorder: 'allowReorder',
                        alphabetic: 'alphabetic',
                        amplitude: 'amplitude',
                        arabicform: 'arabicForm',
                        'arabic-form': 'arabicForm',
                        ascent: 'ascent',
                        attributename: 'attributeName',
                        attributetype: 'attributeType',
                        autoreverse: 'autoReverse',
                        azimuth: 'azimuth',
                        basefrequency: 'baseFrequency',
                        baselineshift: 'baselineShift',
                        'baseline-shift': 'baselineShift',
                        baseprofile: 'baseProfile',
                        bbox: 'bbox',
                        begin: 'begin',
                        bias: 'bias',
                        by: 'by',
                        calcmode: 'calcMode',
                        capheight: 'capHeight',
                        'cap-height': 'capHeight',
                        clip: 'clip',
                        clippath: 'clipPath',
                        'clip-path': 'clipPath',
                        clippathunits: 'clipPathUnits',
                        cliprule: 'clipRule',
                        'clip-rule': 'clipRule',
                        color: 'color',
                        colorinterpolation: 'colorInterpolation',
                        'color-interpolation': 'colorInterpolation',
                        colorinterpolationfilters: 'colorInterpolationFilters',
                        'color-interpolation-filters': 'colorInterpolationFilters',
                        colorprofile: 'colorProfile',
                        'color-profile': 'colorProfile',
                        colorrendering: 'colorRendering',
                        'color-rendering': 'colorRendering',
                        contentscripttype: 'contentScriptType',
                        contentstyletype: 'contentStyleType',
                        cursor: 'cursor',
                        cx: 'cx',
                        cy: 'cy',
                        d: 'd',
                        datatype: 'datatype',
                        decelerate: 'decelerate',
                        descent: 'descent',
                        diffuseconstant: 'diffuseConstant',
                        direction: 'direction',
                        display: 'display',
                        divisor: 'divisor',
                        dominantbaseline: 'dominantBaseline',
                        'dominant-baseline': 'dominantBaseline',
                        dur: 'dur',
                        dx: 'dx',
                        dy: 'dy',
                        edgemode: 'edgeMode',
                        elevation: 'elevation',
                        enablebackground: 'enableBackground',
                        'enable-background': 'enableBackground',
                        end: 'end',
                        exponent: 'exponent',
                        externalresourcesrequired: 'externalResourcesRequired',
                        fill: 'fill',
                        fillopacity: 'fillOpacity',
                        'fill-opacity': 'fillOpacity',
                        fillrule: 'fillRule',
                        'fill-rule': 'fillRule',
                        filter: 'filter',
                        filterres: 'filterRes',
                        filterunits: 'filterUnits',
                        floodopacity: 'floodOpacity',
                        'flood-opacity': 'floodOpacity',
                        floodcolor: 'floodColor',
                        'flood-color': 'floodColor',
                        focusable: 'focusable',
                        fontfamily: 'fontFamily',
                        'font-family': 'fontFamily',
                        fontsize: 'fontSize',
                        'font-size': 'fontSize',
                        fontsizeadjust: 'fontSizeAdjust',
                        'font-size-adjust': 'fontSizeAdjust',
                        fontstretch: 'fontStretch',
                        'font-stretch': 'fontStretch',
                        fontstyle: 'fontStyle',
                        'font-style': 'fontStyle',
                        fontvariant: 'fontVariant',
                        'font-variant': 'fontVariant',
                        fontweight: 'fontWeight',
                        'font-weight': 'fontWeight',
                        format: 'format',
                        from: 'from',
                        fx: 'fx',
                        fy: 'fy',
                        g1: 'g1',
                        g2: 'g2',
                        glyphname: 'glyphName',
                        'glyph-name': 'glyphName',
                        glyphorientationhorizontal: 'glyphOrientationHorizontal',
                        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
                        glyphorientationvertical: 'glyphOrientationVertical',
                        'glyph-orientation-vertical': 'glyphOrientationVertical',
                        glyphref: 'glyphRef',
                        gradienttransform: 'gradientTransform',
                        gradientunits: 'gradientUnits',
                        hanging: 'hanging',
                        horizadvx: 'horizAdvX',
                        'horiz-adv-x': 'horizAdvX',
                        horizoriginx: 'horizOriginX',
                        'horiz-origin-x': 'horizOriginX',
                        ideographic: 'ideographic',
                        imagerendering: 'imageRendering',
                        'image-rendering': 'imageRendering',
                        in2: 'in2',
                        in: 'in',
                        inlist: 'inlist',
                        intercept: 'intercept',
                        k1: 'k1',
                        k2: 'k2',
                        k3: 'k3',
                        k4: 'k4',
                        k: 'k',
                        kernelmatrix: 'kernelMatrix',
                        kernelunitlength: 'kernelUnitLength',
                        kerning: 'kerning',
                        keypoints: 'keyPoints',
                        keysplines: 'keySplines',
                        keytimes: 'keyTimes',
                        lengthadjust: 'lengthAdjust',
                        letterspacing: 'letterSpacing',
                        'letter-spacing': 'letterSpacing',
                        lightingcolor: 'lightingColor',
                        'lighting-color': 'lightingColor',
                        limitingconeangle: 'limitingConeAngle',
                        local: 'local',
                        markerend: 'markerEnd',
                        'marker-end': 'markerEnd',
                        markerheight: 'markerHeight',
                        markermid: 'markerMid',
                        'marker-mid': 'markerMid',
                        markerstart: 'markerStart',
                        'marker-start': 'markerStart',
                        markerunits: 'markerUnits',
                        markerwidth: 'markerWidth',
                        mask: 'mask',
                        maskcontentunits: 'maskContentUnits',
                        maskunits: 'maskUnits',
                        mathematical: 'mathematical',
                        mode: 'mode',
                        numoctaves: 'numOctaves',
                        offset: 'offset',
                        opacity: 'opacity',
                        operator: 'operator',
                        order: 'order',
                        orient: 'orient',
                        orientation: 'orientation',
                        origin: 'origin',
                        overflow: 'overflow',
                        overlineposition: 'overlinePosition',
                        'overline-position': 'overlinePosition',
                        overlinethickness: 'overlineThickness',
                        'overline-thickness': 'overlineThickness',
                        paintorder: 'paintOrder',
                        'paint-order': 'paintOrder',
                        panose1: 'panose1',
                        'panose-1': 'panose1',
                        pathlength: 'pathLength',
                        patterncontentunits: 'patternContentUnits',
                        patterntransform: 'patternTransform',
                        patternunits: 'patternUnits',
                        pointerevents: 'pointerEvents',
                        'pointer-events': 'pointerEvents',
                        points: 'points',
                        pointsatx: 'pointsAtX',
                        pointsaty: 'pointsAtY',
                        pointsatz: 'pointsAtZ',
                        popover: 'popover',
                        popovertarget: 'popoverTarget',
                        popovertargetaction: 'popoverTargetAction',
                        prefix: 'prefix',
                        preservealpha: 'preserveAlpha',
                        preserveaspectratio: 'preserveAspectRatio',
                        primitiveunits: 'primitiveUnits',
                        property: 'property',
                        r: 'r',
                        radius: 'radius',
                        refx: 'refX',
                        refy: 'refY',
                        renderingintent: 'renderingIntent',
                        'rendering-intent': 'renderingIntent',
                        repeatcount: 'repeatCount',
                        repeatdur: 'repeatDur',
                        requiredextensions: 'requiredExtensions',
                        requiredfeatures: 'requiredFeatures',
                        resource: 'resource',
                        restart: 'restart',
                        result: 'result',
                        results: 'results',
                        rotate: 'rotate',
                        rx: 'rx',
                        ry: 'ry',
                        scale: 'scale',
                        security: 'security',
                        seed: 'seed',
                        shaperendering: 'shapeRendering',
                        'shape-rendering': 'shapeRendering',
                        slope: 'slope',
                        spacing: 'spacing',
                        specularconstant: 'specularConstant',
                        specularexponent: 'specularExponent',
                        speed: 'speed',
                        spreadmethod: 'spreadMethod',
                        startoffset: 'startOffset',
                        stddeviation: 'stdDeviation',
                        stemh: 'stemh',
                        stemv: 'stemv',
                        stitchtiles: 'stitchTiles',
                        stopcolor: 'stopColor',
                        'stop-color': 'stopColor',
                        stopopacity: 'stopOpacity',
                        'stop-opacity': 'stopOpacity',
                        strikethroughposition: 'strikethroughPosition',
                        'strikethrough-position': 'strikethroughPosition',
                        strikethroughthickness: 'strikethroughThickness',
                        'strikethrough-thickness': 'strikethroughThickness',
                        string: 'string',
                        stroke: 'stroke',
                        strokedasharray: 'strokeDasharray',
                        'stroke-dasharray': 'strokeDasharray',
                        strokedashoffset: 'strokeDashoffset',
                        'stroke-dashoffset': 'strokeDashoffset',
                        strokelinecap: 'strokeLinecap',
                        'stroke-linecap': 'strokeLinecap',
                        strokelinejoin: 'strokeLinejoin',
                        'stroke-linejoin': 'strokeLinejoin',
                        strokemiterlimit: 'strokeMiterlimit',
                        'stroke-miterlimit': 'strokeMiterlimit',
                        strokewidth: 'strokeWidth',
                        'stroke-width': 'strokeWidth',
                        strokeopacity: 'strokeOpacity',
                        'stroke-opacity': 'strokeOpacity',
                        suppresscontenteditablewarning:
                            'suppressContentEditableWarning',
                        suppresshydrationwarning: 'suppressHydrationWarning',
                        surfacescale: 'surfaceScale',
                        systemlanguage: 'systemLanguage',
                        tablevalues: 'tableValues',
                        targetx: 'targetX',
                        targety: 'targetY',
                        textanchor: 'textAnchor',
                        'text-anchor': 'textAnchor',
                        textdecoration: 'textDecoration',
                        'text-decoration': 'textDecoration',
                        textlength: 'textLength',
                        textrendering: 'textRendering',
                        'text-rendering': 'textRendering',
                        to: 'to',
                        transform: 'transform',
                        transformorigin: 'transformOrigin',
                        'transform-origin': 'transformOrigin',
                        typeof: 'typeof',
                        u1: 'u1',
                        u2: 'u2',
                        underlineposition: 'underlinePosition',
                        'underline-position': 'underlinePosition',
                        underlinethickness: 'underlineThickness',
                        'underline-thickness': 'underlineThickness',
                        unicode: 'unicode',
                        unicodebidi: 'unicodeBidi',
                        'unicode-bidi': 'unicodeBidi',
                        unicoderange: 'unicodeRange',
                        'unicode-range': 'unicodeRange',
                        unitsperem: 'unitsPerEm',
                        'units-per-em': 'unitsPerEm',
                        unselectable: 'unselectable',
                        valphabetic: 'vAlphabetic',
                        'v-alphabetic': 'vAlphabetic',
                        values: 'values',
                        vectoreffect: 'vectorEffect',
                        'vector-effect': 'vectorEffect',
                        version: 'version',
                        vertadvy: 'vertAdvY',
                        'vert-adv-y': 'vertAdvY',
                        vertoriginx: 'vertOriginX',
                        'vert-origin-x': 'vertOriginX',
                        vertoriginy: 'vertOriginY',
                        'vert-origin-y': 'vertOriginY',
                        vhanging: 'vHanging',
                        'v-hanging': 'vHanging',
                        videographic: 'vIdeographic',
                        'v-ideographic': 'vIdeographic',
                        viewbox: 'viewBox',
                        viewtarget: 'viewTarget',
                        visibility: 'visibility',
                        vmathematical: 'vMathematical',
                        'v-mathematical': 'vMathematical',
                        vocab: 'vocab',
                        widths: 'widths',
                        wordspacing: 'wordSpacing',
                        'word-spacing': 'wordSpacing',
                        writingmode: 'writingMode',
                        'writing-mode': 'writingMode',
                        x1: 'x1',
                        x2: 'x2',
                        x: 'x',
                        xchannelselector: 'xChannelSelector',
                        xheight: 'xHeight',
                        'x-height': 'xHeight',
                        xlinkactuate: 'xlinkActuate',
                        'xlink:actuate': 'xlinkActuate',
                        xlinkarcrole: 'xlinkArcrole',
                        'xlink:arcrole': 'xlinkArcrole',
                        xlinkhref: 'xlinkHref',
                        'xlink:href': 'xlinkHref',
                        xlinkrole: 'xlinkRole',
                        'xlink:role': 'xlinkRole',
                        xlinkshow: 'xlinkShow',
                        'xlink:show': 'xlinkShow',
                        xlinktitle: 'xlinkTitle',
                        'xlink:title': 'xlinkTitle',
                        xlinktype: 'xlinkType',
                        'xlink:type': 'xlinkType',
                        xmlbase: 'xmlBase',
                        'xml:base': 'xmlBase',
                        xmllang: 'xmlLang',
                        'xml:lang': 'xmlLang',
                        xmlns: 'xmlns',
                        'xml:space': 'xmlSpace',
                        xmlnsxlink: 'xmlnsXlink',
                        'xmlns:xlink': 'xmlnsXlink',
                        xmlspace: 'xmlSpace',
                        y1: 'y1',
                        y2: 'y2',
                        y: 'y',
                        ychannelselector: 'yChannelSelector',
                        z: 'z',
                        zoomandpan: 'zoomAndPan',
                    },
                    Qy = {
                        'aria-current': 0,
                        'aria-description': 0,
                        'aria-details': 0,
                        'aria-disabled': 0,
                        'aria-hidden': 0,
                        'aria-invalid': 0,
                        'aria-keyshortcuts': 0,
                        'aria-label': 0,
                        'aria-roledescription': 0,
                        'aria-autocomplete': 0,
                        'aria-checked': 0,
                        'aria-expanded': 0,
                        'aria-haspopup': 0,
                        'aria-level': 0,
                        'aria-modal': 0,
                        'aria-multiline': 0,
                        'aria-multiselectable': 0,
                        'aria-orientation': 0,
                        'aria-placeholder': 0,
                        'aria-pressed': 0,
                        'aria-readonly': 0,
                        'aria-required': 0,
                        'aria-selected': 0,
                        'aria-sort': 0,
                        'aria-valuemax': 0,
                        'aria-valuemin': 0,
                        'aria-valuenow': 0,
                        'aria-valuetext': 0,
                        'aria-atomic': 0,
                        'aria-busy': 0,
                        'aria-live': 0,
                        'aria-relevant': 0,
                        'aria-dropeffect': 0,
                        'aria-grabbed': 0,
                        'aria-activedescendant': 0,
                        'aria-colcount': 0,
                        'aria-colindex': 0,
                        'aria-colspan': 0,
                        'aria-controls': 0,
                        'aria-describedby': 0,
                        'aria-errormessage': 0,
                        'aria-flowto': 0,
                        'aria-labelledby': 0,
                        'aria-owns': 0,
                        'aria-posinset': 0,
                        'aria-rowcount': 0,
                        'aria-rowindex': 0,
                        'aria-rowspan': 0,
                        'aria-setsize': 0,
                    },
                    Yl = {},
                    bN = RegExp(
                        '^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
                    ),
                    yN = RegExp(
                        '^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
                    ),
                    Jy = !1,
                    _t = {},
                    qy = /^on./,
                    vN = /^on[^A-Z]/,
                    SN = RegExp(
                        '^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
                    ),
                    xN = RegExp(
                        '^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
                    ),
                    NN =
                        /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i,
                    bs = null,
                    Pl = null,
                    Zl = null,
                    em = !1,
                    ua = !(
                        typeof window > 'u' ||
                        typeof window.document > 'u' ||
                        typeof window.document.createElement > 'u'
                    ),
                    tm = !1;
                if (ua)
                    try {
                        var ys = {};
                        (Object.defineProperty(ys, 'passive', {
                            get: function () {
                                tm = !0;
                            },
                        }),
                            window.addEventListener('test', ys, ys),
                            window.removeEventListener('test', ys, ys));
                    } catch {
                        tm = !1;
                    }
                var fi = null,
                    nm = null,
                    Nc = null,
                    Ji = {
                        eventPhase: 0,
                        bubbles: 0,
                        cancelable: 0,
                        timeStamp: function (e) {
                            return e.timeStamp || Date.now();
                        },
                        defaultPrevented: 0,
                        isTrusted: 0,
                    },
                    wc = qt(Ji),
                    vs = Me({}, Ji, { view: 0, detail: 0 }),
                    wN = qt(vs),
                    am,
                    im,
                    Ss,
                    Ec = Me({}, vs, {
                        screenX: 0,
                        screenY: 0,
                        clientX: 0,
                        clientY: 0,
                        pageX: 0,
                        pageY: 0,
                        ctrlKey: 0,
                        shiftKey: 0,
                        altKey: 0,
                        metaKey: 0,
                        getModifierState: Yu,
                        button: 0,
                        buttons: 0,
                        relatedTarget: function (e) {
                            return e.relatedTarget === void 0
                                ? e.fromElement === e.srcElement
                                    ? e.toElement
                                    : e.fromElement
                                : e.relatedTarget;
                        },
                        movementX: function (e) {
                            return 'movementX' in e
                                ? e.movementX
                                : (e !== Ss &&
                                    (Ss && e.type === 'mousemove'
                                        ? ((am = e.screenX - Ss.screenX),
                                            (im = e.screenY - Ss.screenY))
                                        : (im = am = 0),
                                        (Ss = e)),
                                    am);
                        },
                        movementY: function (e) {
                            return 'movementY' in e ? e.movementY : im;
                        },
                    }),
                    $y = qt(Ec),
                    EN = Me({}, Ec, { dataTransfer: 0 }),
                    AN = qt(EN),
                    DN = Me({}, vs, { relatedTarget: 0 }),
                    lm = qt(DN),
                    TN = Me({}, Ji, {
                        animationName: 0,
                        elapsedTime: 0,
                        pseudoElement: 0,
                    }),
                    CN = qt(TN),
                    RN = Me({}, Ji, {
                        clipboardData: function (e) {
                            return 'clipboardData' in e
                                ? e.clipboardData
                                : window.clipboardData;
                        },
                    }),
                    MN = qt(RN),
                    ON = Me({}, Ji, { data: 0 }),
                    Fy = qt(ON),
                    kN = Fy,
                    jN = {
                        Esc: 'Escape',
                        Spacebar: ' ',
                        Left: 'ArrowLeft',
                        Up: 'ArrowUp',
                        Right: 'ArrowRight',
                        Down: 'ArrowDown',
                        Del: 'Delete',
                        Win: 'OS',
                        Menu: 'ContextMenu',
                        Apps: 'ContextMenu',
                        Scroll: 'ScrollLock',
                        MozPrintableKey: 'Unidentified',
                    },
                    VN = {
                        8: 'Backspace',
                        9: 'Tab',
                        12: 'Clear',
                        13: 'Enter',
                        16: 'Shift',
                        17: 'Control',
                        18: 'Alt',
                        19: 'Pause',
                        20: 'CapsLock',
                        27: 'Escape',
                        32: ' ',
                        33: 'PageUp',
                        34: 'PageDown',
                        35: 'End',
                        36: 'Home',
                        37: 'ArrowLeft',
                        38: 'ArrowUp',
                        39: 'ArrowRight',
                        40: 'ArrowDown',
                        45: 'Insert',
                        46: 'Delete',
                        112: 'F1',
                        113: 'F2',
                        114: 'F3',
                        115: 'F4',
                        116: 'F5',
                        117: 'F6',
                        118: 'F7',
                        119: 'F8',
                        120: 'F9',
                        121: 'F10',
                        122: 'F11',
                        123: 'F12',
                        144: 'NumLock',
                        145: 'ScrollLock',
                        224: 'Meta',
                    },
                    zN = {
                        Alt: 'altKey',
                        Control: 'ctrlKey',
                        Meta: 'metaKey',
                        Shift: 'shiftKey',
                    },
                    BN = Me({}, vs, {
                        key: function (e) {
                            if (e.key) {
                                var t = jN[e.key] || e.key;
                                if (t !== 'Unidentified') return t;
                            }
                            return e.type === 'keypress'
                                ? ((e = yr(e)), e === 13 ? 'Enter' : String.fromCharCode(e))
                                : e.type === 'keydown' || e.type === 'keyup'
                                    ? VN[e.keyCode] || 'Unidentified'
                                    : '';
                        },
                        code: 0,
                        location: 0,
                        ctrlKey: 0,
                        shiftKey: 0,
                        altKey: 0,
                        metaKey: 0,
                        repeat: 0,
                        locale: 0,
                        getModifierState: Yu,
                        charCode: function (e) {
                            return e.type === 'keypress' ? yr(e) : 0;
                        },
                        keyCode: function (e) {
                            return e.type === 'keydown' || e.type === 'keyup'
                                ? e.keyCode
                                : 0;
                        },
                        which: function (e) {
                            return e.type === 'keypress'
                                ? yr(e)
                                : e.type === 'keydown' || e.type === 'keyup'
                                    ? e.keyCode
                                    : 0;
                        },
                    }),
                    LN = qt(BN),
                    IN = Me({}, Ec, {
                        pointerId: 0,
                        width: 0,
                        height: 0,
                        pressure: 0,
                        tangentialPressure: 0,
                        tiltX: 0,
                        tiltY: 0,
                        twist: 0,
                        pointerType: 0,
                        isPrimary: 0,
                    }),
                    Ky = qt(IN),
                    HN = Me({}, vs, {
                        touches: 0,
                        targetTouches: 0,
                        changedTouches: 0,
                        altKey: 0,
                        metaKey: 0,
                        ctrlKey: 0,
                        shiftKey: 0,
                        getModifierState: Yu,
                    }),
                    UN = qt(HN),
                    GN = Me({}, Ji, {
                        propertyName: 0,
                        elapsedTime: 0,
                        pseudoElement: 0,
                    }),
                    _N = qt(GN),
                    YN = Me({}, Ec, {
                        deltaX: function (e) {
                            return 'deltaX' in e
                                ? e.deltaX
                                : 'wheelDeltaX' in e
                                    ? -e.wheelDeltaX
                                    : 0;
                        },
                        deltaY: function (e) {
                            return 'deltaY' in e
                                ? e.deltaY
                                : 'wheelDeltaY' in e
                                    ? -e.wheelDeltaY
                                    : 'wheelDelta' in e
                                        ? -e.wheelDelta
                                        : 0;
                        },
                        deltaZ: 0,
                        deltaMode: 0,
                    }),
                    PN = qt(YN),
                    ZN = Me({}, Ji, { newState: 0, oldState: 0 }),
                    WN = qt(ZN),
                    XN = [9, 13, 27, 32],
                    ev = 229,
                    om = ua && 'CompositionEvent' in window,
                    xs = null;
                ua && 'documentMode' in document && (xs = document.documentMode);
                var QN = ua && 'TextEvent' in window && !xs,
                    tv = ua && (!om || (xs && 8 < xs && 11 >= xs)),
                    nv = 32,
                    av = String.fromCharCode(nv),
                    iv = !1,
                    Wl = !1,
                    JN = {
                        color: !0,
                        date: !0,
                        datetime: !0,
                        'datetime-local': !0,
                        email: !0,
                        month: !0,
                        number: !0,
                        password: !0,
                        range: !0,
                        search: !0,
                        tel: !0,
                        text: !0,
                        time: !0,
                        url: !0,
                        week: !0,
                    },
                    Ns = null,
                    ws = null,
                    lv = !1;
                ua &&
                    (lv =
                        AS('input') &&
                        (!document.documentMode || 9 < document.documentMode));
                var Yt = typeof Object.is == 'function' ? Object.is : OS,
                    qN =
                        ua && 'documentMode' in document && 11 >= document.documentMode,
                    Xl = null,
                    sm = null,
                    Es = null,
                    rm = !1,
                    Ql = {
                        animationend: ji('Animation', 'AnimationEnd'),
                        animationiteration: ji('Animation', 'AnimationIteration'),
                        animationstart: ji('Animation', 'AnimationStart'),
                        transitionrun: ji('Transition', 'TransitionRun'),
                        transitionstart: ji('Transition', 'TransitionStart'),
                        transitioncancel: ji('Transition', 'TransitionCancel'),
                        transitionend: ji('Transition', 'TransitionEnd'),
                    },
                    cm = {},
                    ov = {};
                ua &&
                    ((ov = document.createElement('div').style),
                        'AnimationEvent' in window ||
                        (delete Ql.animationend.animation,
                            delete Ql.animationiteration.animation,
                            delete Ql.animationstart.animation),
                        'TransitionEvent' in window ||
                        delete Ql.transitionend.transition);
                var sv = Vi('animationend'),
                    rv = Vi('animationiteration'),
                    cv = Vi('animationstart'),
                    $N = Vi('transitionrun'),
                    FN = Vi('transitionstart'),
                    KN = Vi('transitioncancel'),
                    uv = Vi('transitionend'),
                    dv = new Map(),
                    um =
                        'abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel'.split(
                            ' '
                        );
                um.push('scrollEnd');
                var dm = new WeakMap(),
                    Ac = 1,
                    ja = 2,
                    En = [],
                    Jl = 0,
                    fm = 0,
                    mi = {};
                Object.freeze(mi);
                var An = null,
                    ql = null,
                    et = 0,
                    ew = 1,
                    kt = 2,
                    It = 8,
                    Yn = 16,
                    fv = 64,
                    mv = !1;
                try {
                    Object.preventExtensions({});
                } catch {
                    mv = !0;
                }
                var $l = [],
                    Fl = 0,
                    Dc = null,
                    Tc = 0,
                    Dn = [],
                    Tn = 0,
                    qi = null,
                    Va = 1,
                    za = '',
                    Pt = null,
                    st = null,
                    Ue = !1,
                    Ba = !1,
                    Cn = null,
                    $i = null,
                    da = !1,
                    mm = Error(
                        "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
                    ),
                    pv = 0;
                if (
                    typeof performance == 'object' &&
                    typeof performance.now == 'function'
                )
                    var tw = performance,
                        hv = function () {
                            return tw.now();
                        };
                else {
                    var nw = Date;
                    hv = function () {
                        return nw.now();
                    };
                }
                var pm = te(null),
                    hm = te(null),
                    gv = {},
                    Cc = null,
                    Kl = null,
                    eo = !1,
                    aw =
                        typeof AbortController < 'u'
                            ? AbortController
                            : function () {
                                var e = [],
                                    t = (this.signal = {
                                        aborted: !1,
                                        addEventListener: function (n, a) {
                                            e.push(a);
                                        },
                                    });
                                this.abort = function () {
                                    ((t.aborted = !0),
                                        e.forEach(function (n) {
                                            return n();
                                        }));
                                };
                            },
                    iw = gt.unstable_scheduleCallback,
                    lw = gt.unstable_NormalPriority,
                    vt = {
                        $$typeof: la,
                        Consumer: null,
                        Provider: null,
                        _currentValue: null,
                        _currentValue2: null,
                        _threadCount: 0,
                        _currentRenderer: null,
                        _currentRenderer2: null,
                    },
                    to = gt.unstable_now,
                    bv = -0,
                    Rc = -0,
                    tn = -1.1,
                    Fi = -0,
                    Mc = !1,
                    Oc = !1,
                    As = null,
                    gm = 0,
                    Ki = 0,
                    no = null,
                    yv = B.S;
                B.S = function (e, t) {
                    (typeof t == 'object' &&
                        t !== null &&
                        typeof t.then == 'function' &&
                        jS(e, t),
                        yv !== null && yv(e, t));
                };
                var el = te(null),
                    Pn = {
                        recordUnsafeLifecycleWarnings: function () { },
                        flushPendingUnsafeLifecycleWarnings: function () { },
                        recordLegacyContextWarning: function () { },
                        flushLegacyContextWarning: function () { },
                        discardPendingWarnings: function () { },
                    },
                    Ds = [],
                    Ts = [],
                    Cs = [],
                    Rs = [],
                    Ms = [],
                    Os = [],
                    tl = new Set();
                ((Pn.recordUnsafeLifecycleWarnings = function (e, t) {
                    tl.has(e.type) ||
                        (typeof t.componentWillMount == 'function' &&
                            t.componentWillMount.__suppressDeprecationWarning !== !0 &&
                            Ds.push(e),
                            e.mode & It &&
                            typeof t.UNSAFE_componentWillMount == 'function' &&
                            Ts.push(e),
                            typeof t.componentWillReceiveProps == 'function' &&
                            t.componentWillReceiveProps.__suppressDeprecationWarning !==
                            !0 &&
                            Cs.push(e),
                            e.mode & It &&
                            typeof t.UNSAFE_componentWillReceiveProps == 'function' &&
                            Rs.push(e),
                            typeof t.componentWillUpdate == 'function' &&
                            t.componentWillUpdate.__suppressDeprecationWarning !== !0 &&
                            Ms.push(e),
                            e.mode & It &&
                            typeof t.UNSAFE_componentWillUpdate == 'function' &&
                            Os.push(e));
                }),
                    (Pn.flushPendingUnsafeLifecycleWarnings = function () {
                        var e = new Set();
                        0 < Ds.length &&
                            (Ds.forEach(function (g) {
                                (e.add(K(g) || 'Component'), tl.add(g.type));
                            }),
                                (Ds = []));
                        var t = new Set();
                        0 < Ts.length &&
                            (Ts.forEach(function (g) {
                                (t.add(K(g) || 'Component'), tl.add(g.type));
                            }),
                                (Ts = []));
                        var n = new Set();
                        0 < Cs.length &&
                            (Cs.forEach(function (g) {
                                (n.add(K(g) || 'Component'), tl.add(g.type));
                            }),
                                (Cs = []));
                        var a = new Set();
                        0 < Rs.length &&
                            (Rs.forEach(function (g) {
                                (a.add(K(g) || 'Component'), tl.add(g.type));
                            }),
                                (Rs = []));
                        var o = new Set();
                        0 < Ms.length &&
                            (Ms.forEach(function (g) {
                                (o.add(K(g) || 'Component'), tl.add(g.type));
                            }),
                                (Ms = []));
                        var c = new Set();
                        if (
                            (0 < Os.length &&
                                (Os.forEach(function (g) {
                                    (c.add(K(g) || 'Component'), tl.add(g.type));
                                }),
                                    (Os = [])),
                                0 < t.size)
                        ) {
                            var f = v(t);
                            console.error(
                                `Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,
                                f
                            );
                        }
                        (0 < a.size &&
                            ((f = v(a)),
                                console.error(
                                    `Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state

Please update the following components: %s`,
                                    f
                                )),
                            0 < c.size &&
                            ((f = v(c)),
                                console.error(
                                    `Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,
                                    f
                                )),
                            0 < e.size &&
                            ((f = v(e)),
                                console.warn(
                                    `componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
                                    f
                                )),
                            0 < n.size &&
                            ((f = v(n)),
                                console.warn(
                                    `componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
                                    f
                                )),
                            0 < o.size &&
                            ((f = v(o)),
                                console.warn(
                                    `componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
                                    f
                                )));
                    }));
                var kc = new Map(),
                    vv = new Set();
                ((Pn.recordLegacyContextWarning = function (e, t) {
                    for (var n = null, a = e; a !== null;)
                        (a.mode & It && (n = a), (a = a.return));
                    n === null
                        ? console.error(
                            'Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.'
                        )
                        : !vv.has(e.type) &&
                        ((a = kc.get(n)),
                            e.type.contextTypes != null ||
                            e.type.childContextTypes != null ||
                            (t !== null && typeof t.getChildContext == 'function')) &&
                        (a === void 0 && ((a = []), kc.set(n, a)), a.push(e));
                }),
                    (Pn.flushLegacyContextWarning = function () {
                        kc.forEach(function (e) {
                            if (e.length !== 0) {
                                var t = e[0],
                                    n = new Set();
                                e.forEach(function (o) {
                                    (n.add(K(o) || 'Component'), vv.add(o.type));
                                });
                                var a = v(n);
                                he(t, function () {
                                    console.error(
                                        `Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://react.dev/link/legacy-context`,
                                        a
                                    );
                                });
                            }
                        });
                    }),
                    (Pn.discardPendingWarnings = function () {
                        ((Ds = []),
                            (Ts = []),
                            (Cs = []),
                            (Rs = []),
                            (Ms = []),
                            (Os = []),
                            (kc = new Map()));
                    }));
                var ks = Error(
                    "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
                ),
                    Sv = Error(
                        "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
                    ),
                    jc = Error(
                        "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
                    ),
                    bm = {
                        then: function () {
                            console.error(
                                'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
                            );
                        },
                    },
                    js = null,
                    Vc = !1,
                    Rn = 0,
                    Mn = 1,
                    Zt = 2,
                    jt = 4,
                    St = 8,
                    xv = 0,
                    Nv = 1,
                    wv = 2,
                    ym = 3,
                    pi = !1,
                    Ev = !1,
                    vm = null,
                    Sm = !1,
                    ao = te(null),
                    zc = te(0),
                    io,
                    Av = new Set(),
                    Dv = new Set(),
                    xm = new Set(),
                    Tv = new Set(),
                    hi = 0,
                    ve = null,
                    qe = null,
                    bt = null,
                    Bc = !1,
                    lo = !1,
                    nl = !1,
                    Lc = 0,
                    Vs = 0,
                    La = null,
                    ow = 0,
                    sw = 25,
                    z = null,
                    On = null,
                    Ia = -1,
                    zs = !1,
                    Ic = {
                        readContext: it,
                        use: ti,
                        useCallback: dt,
                        useContext: dt,
                        useEffect: dt,
                        useImperativeHandle: dt,
                        useLayoutEffect: dt,
                        useInsertionEffect: dt,
                        useMemo: dt,
                        useReducer: dt,
                        useRef: dt,
                        useState: dt,
                        useDebugValue: dt,
                        useDeferredValue: dt,
                        useTransition: dt,
                        useSyncExternalStore: dt,
                        useId: dt,
                        useHostTransitionStatus: dt,
                        useFormState: dt,
                        useActionState: dt,
                        useOptimistic: dt,
                        useMemoCache: dt,
                        useCacheRefresh: dt,
                    },
                    Nm = null,
                    Cv = null,
                    wm = null,
                    Rv = null,
                    fa = null,
                    Zn = null,
                    Hc = null;
                ((Nm = {
                    readContext: function (e) {
                        return it(e);
                    },
                    use: ti,
                    useCallback: function (e, t) {
                        return ((z = 'useCallback'), je(), El(t), Cd(e, t));
                    },
                    useContext: function (e) {
                        return ((z = 'useContext'), je(), it(e));
                    },
                    useEffect: function (e, t) {
                        return ((z = 'useEffect'), je(), El(t), Ir(e, t));
                    },
                    useImperativeHandle: function (e, t, n) {
                        return ((z = 'useImperativeHandle'), je(), El(n), Td(e, t, n));
                    },
                    useInsertionEffect: function (e, t) {
                        ((z = 'useInsertionEffect'), je(), El(t), Pi(4, Zt, e, t));
                    },
                    useLayoutEffect: function (e, t) {
                        return ((z = 'useLayoutEffect'), je(), El(t), Dd(e, t));
                    },
                    useMemo: function (e, t) {
                        ((z = 'useMemo'), je(), El(t));
                        var n = B.H;
                        B.H = fa;
                        try {
                            return Rd(e, t);
                        } finally {
                            B.H = n;
                        }
                    },
                    useReducer: function (e, t, n) {
                        ((z = 'useReducer'), je());
                        var a = B.H;
                        B.H = fa;
                        try {
                            return yd(e, t, n);
                        } finally {
                            B.H = a;
                        }
                    },
                    useRef: function (e) {
                        return ((z = 'useRef'), je(), Ad(e));
                    },
                    useState: function (e) {
                        ((z = 'useState'), je());
                        var t = B.H;
                        B.H = fa;
                        try {
                            return Nd(e);
                        } finally {
                            B.H = t;
                        }
                    },
                    useDebugValue: function () {
                        ((z = 'useDebugValue'), je());
                    },
                    useDeferredValue: function (e, t) {
                        return ((z = 'useDeferredValue'), je(), Md(e, t));
                    },
                    useTransition: function () {
                        return ((z = 'useTransition'), je(), jd());
                    },
                    useSyncExternalStore: function (e, t, n) {
                        return ((z = 'useSyncExternalStore'), je(), Sd(e, t, n));
                    },
                    useId: function () {
                        return ((z = 'useId'), je(), Vd());
                    },
                    useFormState: function (e, t) {
                        return ((z = 'useFormState'), je(), jr(), Dl(e, t));
                    },
                    useActionState: function (e, t) {
                        return ((z = 'useActionState'), je(), Dl(e, t));
                    },
                    useOptimistic: function (e) {
                        return ((z = 'useOptimistic'), je(), wd(e));
                    },
                    useHostTransitionStatus: Zi,
                    useMemoCache: Yi,
                    useCacheRefresh: function () {
                        return ((z = 'useCacheRefresh'), je(), zd());
                    },
                }),
                    (Cv = {
                        readContext: function (e) {
                            return it(e);
                        },
                        use: ti,
                        useCallback: function (e, t) {
                            return ((z = 'useCallback'), F(), Cd(e, t));
                        },
                        useContext: function (e) {
                            return ((z = 'useContext'), F(), it(e));
                        },
                        useEffect: function (e, t) {
                            return ((z = 'useEffect'), F(), Ir(e, t));
                        },
                        useImperativeHandle: function (e, t, n) {
                            return ((z = 'useImperativeHandle'), F(), Td(e, t, n));
                        },
                        useInsertionEffect: function (e, t) {
                            ((z = 'useInsertionEffect'), F(), Pi(4, Zt, e, t));
                        },
                        useLayoutEffect: function (e, t) {
                            return ((z = 'useLayoutEffect'), F(), Dd(e, t));
                        },
                        useMemo: function (e, t) {
                            ((z = 'useMemo'), F());
                            var n = B.H;
                            B.H = fa;
                            try {
                                return Rd(e, t);
                            } finally {
                                B.H = n;
                            }
                        },
                        useReducer: function (e, t, n) {
                            ((z = 'useReducer'), F());
                            var a = B.H;
                            B.H = fa;
                            try {
                                return yd(e, t, n);
                            } finally {
                                B.H = a;
                            }
                        },
                        useRef: function (e) {
                            return ((z = 'useRef'), F(), Ad(e));
                        },
                        useState: function (e) {
                            ((z = 'useState'), F());
                            var t = B.H;
                            B.H = fa;
                            try {
                                return Nd(e);
                            } finally {
                                B.H = t;
                            }
                        },
                        useDebugValue: function () {
                            ((z = 'useDebugValue'), F());
                        },
                        useDeferredValue: function (e, t) {
                            return ((z = 'useDeferredValue'), F(), Md(e, t));
                        },
                        useTransition: function () {
                            return ((z = 'useTransition'), F(), jd());
                        },
                        useSyncExternalStore: function (e, t, n) {
                            return ((z = 'useSyncExternalStore'), F(), Sd(e, t, n));
                        },
                        useId: function () {
                            return ((z = 'useId'), F(), Vd());
                        },
                        useActionState: function (e, t) {
                            return ((z = 'useActionState'), F(), Dl(e, t));
                        },
                        useFormState: function (e, t) {
                            return ((z = 'useFormState'), F(), jr(), Dl(e, t));
                        },
                        useOptimistic: function (e) {
                            return ((z = 'useOptimistic'), F(), wd(e));
                        },
                        useHostTransitionStatus: Zi,
                        useMemoCache: Yi,
                        useCacheRefresh: function () {
                            return ((z = 'useCacheRefresh'), F(), zd());
                        },
                    }),
                    (wm = {
                        readContext: function (e) {
                            return it(e);
                        },
                        use: ti,
                        useCallback: function (e, t) {
                            return ((z = 'useCallback'), F(), Ur(e, t));
                        },
                        useContext: function (e) {
                            return ((z = 'useContext'), F(), it(e));
                        },
                        useEffect: function (e, t) {
                            ((z = 'useEffect'), F(), Kt(2048, St, e, t));
                        },
                        useImperativeHandle: function (e, t, n) {
                            return ((z = 'useImperativeHandle'), F(), Hr(e, t, n));
                        },
                        useInsertionEffect: function (e, t) {
                            return ((z = 'useInsertionEffect'), F(), Kt(4, Zt, e, t));
                        },
                        useLayoutEffect: function (e, t) {
                            return ((z = 'useLayoutEffect'), F(), Kt(4, jt, e, t));
                        },
                        useMemo: function (e, t) {
                            ((z = 'useMemo'), F());
                            var n = B.H;
                            B.H = Zn;
                            try {
                                return Gr(e, t);
                            } finally {
                                B.H = n;
                            }
                        },
                        useReducer: function (e, t, n) {
                            ((z = 'useReducer'), F());
                            var a = B.H;
                            B.H = Zn;
                            try {
                                return Al(e);
                            } finally {
                                B.H = a;
                            }
                        },
                        useRef: function () {
                            return ((z = 'useRef'), F(), We().memoizedState);
                        },
                        useState: function () {
                            ((z = 'useState'), F());
                            var e = B.H;
                            B.H = Zn;
                            try {
                                return Al(Gn);
                            } finally {
                                B.H = e;
                            }
                        },
                        useDebugValue: function () {
                            ((z = 'useDebugValue'), F());
                        },
                        useDeferredValue: function (e, t) {
                            return ((z = 'useDeferredValue'), F(), sg(e, t));
                        },
                        useTransition: function () {
                            return ((z = 'useTransition'), F(), mg());
                        },
                        useSyncExternalStore: function (e, t, n) {
                            return ((z = 'useSyncExternalStore'), F(), Vr(e, t, n));
                        },
                        useId: function () {
                            return ((z = 'useId'), F(), We().memoizedState);
                        },
                        useFormState: function (e) {
                            return ((z = 'useFormState'), F(), jr(), zr(e));
                        },
                        useActionState: function (e) {
                            return ((z = 'useActionState'), F(), zr(e));
                        },
                        useOptimistic: function (e, t) {
                            return ((z = 'useOptimistic'), F(), $h(e, t));
                        },
                        useHostTransitionStatus: Zi,
                        useMemoCache: Yi,
                        useCacheRefresh: function () {
                            return ((z = 'useCacheRefresh'), F(), We().memoizedState);
                        },
                    }),
                    (Rv = {
                        readContext: function (e) {
                            return it(e);
                        },
                        use: ti,
                        useCallback: function (e, t) {
                            return ((z = 'useCallback'), F(), Ur(e, t));
                        },
                        useContext: function (e) {
                            return ((z = 'useContext'), F(), it(e));
                        },
                        useEffect: function (e, t) {
                            ((z = 'useEffect'), F(), Kt(2048, St, e, t));
                        },
                        useImperativeHandle: function (e, t, n) {
                            return ((z = 'useImperativeHandle'), F(), Hr(e, t, n));
                        },
                        useInsertionEffect: function (e, t) {
                            return ((z = 'useInsertionEffect'), F(), Kt(4, Zt, e, t));
                        },
                        useLayoutEffect: function (e, t) {
                            return ((z = 'useLayoutEffect'), F(), Kt(4, jt, e, t));
                        },
                        useMemo: function (e, t) {
                            ((z = 'useMemo'), F());
                            var n = B.H;
                            B.H = Hc;
                            try {
                                return Gr(e, t);
                            } finally {
                                B.H = n;
                            }
                        },
                        useReducer: function (e, t, n) {
                            ((z = 'useReducer'), F());
                            var a = B.H;
                            B.H = Hc;
                            try {
                                return qo(e);
                            } finally {
                                B.H = a;
                            }
                        },
                        useRef: function () {
                            return ((z = 'useRef'), F(), We().memoizedState);
                        },
                        useState: function () {
                            ((z = 'useState'), F());
                            var e = B.H;
                            B.H = Hc;
                            try {
                                return qo(Gn);
                            } finally {
                                B.H = e;
                            }
                        },
                        useDebugValue: function () {
                            ((z = 'useDebugValue'), F());
                        },
                        useDeferredValue: function (e, t) {
                            return ((z = 'useDeferredValue'), F(), rg(e, t));
                        },
                        useTransition: function () {
                            return ((z = 'useTransition'), F(), pg());
                        },
                        useSyncExternalStore: function (e, t, n) {
                            return ((z = 'useSyncExternalStore'), F(), Vr(e, t, n));
                        },
                        useId: function () {
                            return ((z = 'useId'), F(), We().memoizedState);
                        },
                        useFormState: function (e) {
                            return ((z = 'useFormState'), F(), jr(), Br(e));
                        },
                        useActionState: function (e) {
                            return ((z = 'useActionState'), F(), Br(e));
                        },
                        useOptimistic: function (e, t) {
                            return ((z = 'useOptimistic'), F(), Kh(e, t));
                        },
                        useHostTransitionStatus: Zi,
                        useMemoCache: Yi,
                        useCacheRefresh: function () {
                            return ((z = 'useCacheRefresh'), F(), We().memoizedState);
                        },
                    }),
                    (fa = {
                        readContext: function (e) {
                            return (y(), it(e));
                        },
                        use: function (e) {
                            return (m(), ti(e));
                        },
                        useCallback: function (e, t) {
                            return ((z = 'useCallback'), m(), je(), Cd(e, t));
                        },
                        useContext: function (e) {
                            return ((z = 'useContext'), m(), je(), it(e));
                        },
                        useEffect: function (e, t) {
                            return ((z = 'useEffect'), m(), je(), Ir(e, t));
                        },
                        useImperativeHandle: function (e, t, n) {
                            return ((z = 'useImperativeHandle'), m(), je(), Td(e, t, n));
                        },
                        useInsertionEffect: function (e, t) {
                            ((z = 'useInsertionEffect'), m(), je(), Pi(4, Zt, e, t));
                        },
                        useLayoutEffect: function (e, t) {
                            return ((z = 'useLayoutEffect'), m(), je(), Dd(e, t));
                        },
                        useMemo: function (e, t) {
                            ((z = 'useMemo'), m(), je());
                            var n = B.H;
                            B.H = fa;
                            try {
                                return Rd(e, t);
                            } finally {
                                B.H = n;
                            }
                        },
                        useReducer: function (e, t, n) {
                            ((z = 'useReducer'), m(), je());
                            var a = B.H;
                            B.H = fa;
                            try {
                                return yd(e, t, n);
                            } finally {
                                B.H = a;
                            }
                        },
                        useRef: function (e) {
                            return ((z = 'useRef'), m(), je(), Ad(e));
                        },
                        useState: function (e) {
                            ((z = 'useState'), m(), je());
                            var t = B.H;
                            B.H = fa;
                            try {
                                return Nd(e);
                            } finally {
                                B.H = t;
                            }
                        },
                        useDebugValue: function () {
                            ((z = 'useDebugValue'), m(), je());
                        },
                        useDeferredValue: function (e, t) {
                            return ((z = 'useDeferredValue'), m(), je(), Md(e, t));
                        },
                        useTransition: function () {
                            return ((z = 'useTransition'), m(), je(), jd());
                        },
                        useSyncExternalStore: function (e, t, n) {
                            return ((z = 'useSyncExternalStore'), m(), je(), Sd(e, t, n));
                        },
                        useId: function () {
                            return ((z = 'useId'), m(), je(), Vd());
                        },
                        useFormState: function (e, t) {
                            return ((z = 'useFormState'), m(), je(), Dl(e, t));
                        },
                        useActionState: function (e, t) {
                            return ((z = 'useActionState'), m(), je(), Dl(e, t));
                        },
                        useOptimistic: function (e) {
                            return ((z = 'useOptimistic'), m(), je(), wd(e));
                        },
                        useMemoCache: function (e) {
                            return (m(), Yi(e));
                        },
                        useHostTransitionStatus: Zi,
                        useCacheRefresh: function () {
                            return ((z = 'useCacheRefresh'), je(), zd());
                        },
                    }),
                    (Zn = {
                        readContext: function (e) {
                            return (y(), it(e));
                        },
                        use: function (e) {
                            return (m(), ti(e));
                        },
                        useCallback: function (e, t) {
                            return ((z = 'useCallback'), m(), F(), Ur(e, t));
                        },
                        useContext: function (e) {
                            return ((z = 'useContext'), m(), F(), it(e));
                        },
                        useEffect: function (e, t) {
                            ((z = 'useEffect'), m(), F(), Kt(2048, St, e, t));
                        },
                        useImperativeHandle: function (e, t, n) {
                            return ((z = 'useImperativeHandle'), m(), F(), Hr(e, t, n));
                        },
                        useInsertionEffect: function (e, t) {
                            return (
                                (z = 'useInsertionEffect'),
                                m(),
                                F(),
                                Kt(4, Zt, e, t)
                            );
                        },
                        useLayoutEffect: function (e, t) {
                            return ((z = 'useLayoutEffect'), m(), F(), Kt(4, jt, e, t));
                        },
                        useMemo: function (e, t) {
                            ((z = 'useMemo'), m(), F());
                            var n = B.H;
                            B.H = Zn;
                            try {
                                return Gr(e, t);
                            } finally {
                                B.H = n;
                            }
                        },
                        useReducer: function (e, t, n) {
                            ((z = 'useReducer'), m(), F());
                            var a = B.H;
                            B.H = Zn;
                            try {
                                return Al(e);
                            } finally {
                                B.H = a;
                            }
                        },
                        useRef: function () {
                            return ((z = 'useRef'), m(), F(), We().memoizedState);
                        },
                        useState: function () {
                            ((z = 'useState'), m(), F());
                            var e = B.H;
                            B.H = Zn;
                            try {
                                return Al(Gn);
                            } finally {
                                B.H = e;
                            }
                        },
                        useDebugValue: function () {
                            ((z = 'useDebugValue'), m(), F());
                        },
                        useDeferredValue: function (e, t) {
                            return ((z = 'useDeferredValue'), m(), F(), sg(e, t));
                        },
                        useTransition: function () {
                            return ((z = 'useTransition'), m(), F(), mg());
                        },
                        useSyncExternalStore: function (e, t, n) {
                            return ((z = 'useSyncExternalStore'), m(), F(), Vr(e, t, n));
                        },
                        useId: function () {
                            return ((z = 'useId'), m(), F(), We().memoizedState);
                        },
                        useFormState: function (e) {
                            return ((z = 'useFormState'), m(), F(), zr(e));
                        },
                        useActionState: function (e) {
                            return ((z = 'useActionState'), m(), F(), zr(e));
                        },
                        useOptimistic: function (e, t) {
                            return ((z = 'useOptimistic'), m(), F(), $h(e, t));
                        },
                        useMemoCache: function (e) {
                            return (m(), Yi(e));
                        },
                        useHostTransitionStatus: Zi,
                        useCacheRefresh: function () {
                            return ((z = 'useCacheRefresh'), F(), We().memoizedState);
                        },
                    }),
                    (Hc = {
                        readContext: function (e) {
                            return (y(), it(e));
                        },
                        use: function (e) {
                            return (m(), ti(e));
                        },
                        useCallback: function (e, t) {
                            return ((z = 'useCallback'), m(), F(), Ur(e, t));
                        },
                        useContext: function (e) {
                            return ((z = 'useContext'), m(), F(), it(e));
                        },
                        useEffect: function (e, t) {
                            ((z = 'useEffect'), m(), F(), Kt(2048, St, e, t));
                        },
                        useImperativeHandle: function (e, t, n) {
                            return ((z = 'useImperativeHandle'), m(), F(), Hr(e, t, n));
                        },
                        useInsertionEffect: function (e, t) {
                            return (
                                (z = 'useInsertionEffect'),
                                m(),
                                F(),
                                Kt(4, Zt, e, t)
                            );
                        },
                        useLayoutEffect: function (e, t) {
                            return ((z = 'useLayoutEffect'), m(), F(), Kt(4, jt, e, t));
                        },
                        useMemo: function (e, t) {
                            ((z = 'useMemo'), m(), F());
                            var n = B.H;
                            B.H = Zn;
                            try {
                                return Gr(e, t);
                            } finally {
                                B.H = n;
                            }
                        },
                        useReducer: function (e, t, n) {
                            ((z = 'useReducer'), m(), F());
                            var a = B.H;
                            B.H = Zn;
                            try {
                                return qo(e);
                            } finally {
                                B.H = a;
                            }
                        },
                        useRef: function () {
                            return ((z = 'useRef'), m(), F(), We().memoizedState);
                        },
                        useState: function () {
                            ((z = 'useState'), m(), F());
                            var e = B.H;
                            B.H = Zn;
                            try {
                                return qo(Gn);
                            } finally {
                                B.H = e;
                            }
                        },
                        useDebugValue: function () {
                            ((z = 'useDebugValue'), m(), F());
                        },
                        useDeferredValue: function (e, t) {
                            return ((z = 'useDeferredValue'), m(), F(), rg(e, t));
                        },
                        useTransition: function () {
                            return ((z = 'useTransition'), m(), F(), pg());
                        },
                        useSyncExternalStore: function (e, t, n) {
                            return ((z = 'useSyncExternalStore'), m(), F(), Vr(e, t, n));
                        },
                        useId: function () {
                            return ((z = 'useId'), m(), F(), We().memoizedState);
                        },
                        useFormState: function (e) {
                            return ((z = 'useFormState'), m(), F(), Br(e));
                        },
                        useActionState: function (e) {
                            return ((z = 'useActionState'), m(), F(), Br(e));
                        },
                        useOptimistic: function (e, t) {
                            return ((z = 'useOptimistic'), m(), F(), Kh(e, t));
                        },
                        useMemoCache: function (e) {
                            return (m(), Yi(e));
                        },
                        useHostTransitionStatus: Zi,
                        useCacheRefresh: function () {
                            return ((z = 'useCacheRefresh'), F(), We().memoizedState);
                        },
                    }));
                var Mv = {
                    react_stack_bottom_frame: function (e, t, n) {
                        var a = ca;
                        ca = !0;
                        try {
                            return e(t, n);
                        } finally {
                            ca = a;
                        }
                    },
                },
                    Em = Mv.react_stack_bottom_frame.bind(Mv),
                    Ov = {
                        react_stack_bottom_frame: function (e) {
                            var t = ca;
                            ca = !0;
                            try {
                                return e.render();
                            } finally {
                                ca = t;
                            }
                        },
                    },
                    kv = Ov.react_stack_bottom_frame.bind(Ov),
                    jv = {
                        react_stack_bottom_frame: function (e, t) {
                            try {
                                t.componentDidMount();
                            } catch (n) {
                                Qe(e, e.return, n);
                            }
                        },
                    },
                    Am = jv.react_stack_bottom_frame.bind(jv),
                    Vv = {
                        react_stack_bottom_frame: function (e, t, n, a, o) {
                            try {
                                t.componentDidUpdate(n, a, o);
                            } catch (c) {
                                Qe(e, e.return, c);
                            }
                        },
                    },
                    zv = Vv.react_stack_bottom_frame.bind(Vv),
                    Bv = {
                        react_stack_bottom_frame: function (e, t) {
                            var n = t.stack;
                            e.componentDidCatch(t.value, {
                                componentStack: n !== null ? n : '',
                            });
                        },
                    },
                    rw = Bv.react_stack_bottom_frame.bind(Bv),
                    Lv = {
                        react_stack_bottom_frame: function (e, t, n) {
                            try {
                                n.componentWillUnmount();
                            } catch (a) {
                                Qe(e, t, a);
                            }
                        },
                    },
                    Iv = Lv.react_stack_bottom_frame.bind(Lv),
                    Hv = {
                        react_stack_bottom_frame: function (e) {
                            e.resourceKind != null &&
                                console.error(
                                    'Expected only SimpleEffects when enableUseEffectCRUDOverload is disabled, got %s',
                                    e.resourceKind
                                );
                            var t = e.create;
                            return ((e = e.inst), (t = t()), (e.destroy = t));
                        },
                    },
                    cw = Hv.react_stack_bottom_frame.bind(Hv),
                    Uv = {
                        react_stack_bottom_frame: function (e, t, n) {
                            try {
                                n();
                            } catch (a) {
                                Qe(e, t, a);
                            }
                        },
                    },
                    uw = Uv.react_stack_bottom_frame.bind(Uv),
                    Gv = {
                        react_stack_bottom_frame: function (e) {
                            var t = e._init;
                            return t(e._payload);
                        },
                    },
                    gi = Gv.react_stack_bottom_frame.bind(Gv),
                    oo = null,
                    Bs = 0,
                    Ce = null,
                    Dm,
                    _v = (Dm = !1),
                    Yv = {},
                    Pv = {},
                    Zv = {};
                h = function (e, t, n) {
                    if (
                        n !== null &&
                        typeof n == 'object' &&
                        n._store &&
                        ((!n._store.validated && n.key == null) ||
                            n._store.validated === 2)
                    ) {
                        if (typeof n._store != 'object')
                            throw Error(
                                'React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.'
                            );
                        n._store.validated = 1;
                        var a = K(e),
                            o = a || 'null';
                        if (!Yv[o]) {
                            ((Yv[o] = !0), (n = n._owner), (e = e._debugOwner));
                            var c = '';
                            (e &&
                                typeof e.tag == 'number' &&
                                (o = K(e)) &&
                                (c =
                                    `

Check the render method of \`` +
                                    o +
                                    '`.'),
                                c ||
                                (a &&
                                    (c =
                                        `

Check the top-level render call using <` +
                                        a +
                                        '>.')));
                            var f = '';
                            (n != null &&
                                e !== n &&
                                ((a = null),
                                    typeof n.tag == 'number'
                                        ? (a = K(n))
                                        : typeof n.name == 'string' && (a = n.name),
                                    a && (f = ' It was passed a child from ' + a + '.')),
                                he(t, function () {
                                    console.error(
                                        'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
                                        c,
                                        f
                                    );
                                }));
                        }
                    }
                };
                var so = yg(!0),
                    Wv = yg(!1),
                    kn = te(null),
                    ma = null,
                    ro = 1,
                    Ls = 2,
                    xt = te(0),
                    Xv = {},
                    Qv = new Set(),
                    Jv = new Set(),
                    qv = new Set(),
                    $v = new Set(),
                    Fv = new Set(),
                    Kv = new Set(),
                    e1 = new Set(),
                    t1 = new Set(),
                    n1 = new Set(),
                    a1 = new Set();
                Object.freeze(Xv);
                var Tm = {
                    enqueueSetState: function (e, t, n) {
                        e = e._reactInternals;
                        var a = un(e),
                            o = Ka(a);
                        ((o.payload = t),
                            n != null && (Ld(n), (o.callback = n)),
                            (t = ei(e, o, a)),
                            t !== null && (ft(t, e, a), Wo(t, e, a)),
                            Xa(e, a));
                    },
                    enqueueReplaceState: function (e, t, n) {
                        e = e._reactInternals;
                        var a = un(e),
                            o = Ka(a);
                        ((o.tag = Nv),
                            (o.payload = t),
                            n != null && (Ld(n), (o.callback = n)),
                            (t = ei(e, o, a)),
                            t !== null && (ft(t, e, a), Wo(t, e, a)),
                            Xa(e, a));
                    },
                    enqueueForceUpdate: function (e, t) {
                        e = e._reactInternals;
                        var n = un(e),
                            a = Ka(n);
                        ((a.tag = wv),
                            t != null && (Ld(t), (a.callback = t)),
                            (t = ei(e, a, n)),
                            t !== null && (ft(t, e, n), Wo(t, e, n)),
                            se !== null &&
                            typeof se.markForceUpdateScheduled == 'function' &&
                            se.markForceUpdateScheduled(e, n));
                    },
                },
                    Cm =
                        typeof reportError == 'function'
                            ? reportError
                            : function (e) {
                                if (
                                    typeof window == 'object' &&
                                    typeof window.ErrorEvent == 'function'
                                ) {
                                    var t = new window.ErrorEvent('error', {
                                        bubbles: !0,
                                        cancelable: !0,
                                        message:
                                            typeof e == 'object' &&
                                                e !== null &&
                                                typeof e.message == 'string'
                                                ? String(e.message)
                                                : String(e),
                                        error: e,
                                    });
                                    if (!window.dispatchEvent(t)) return;
                                } else if (
                                    typeof process == 'object' &&
                                    typeof process.emit == 'function'
                                ) {
                                    process.emit('uncaughtException', e);
                                    return;
                                }
                                console.error(e);
                            },
                    co = null,
                    Rm = null,
                    i1 = Error(
                        "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
                    ),
                    At = !1,
                    l1 = {},
                    o1 = {},
                    s1 = {},
                    r1 = {},
                    uo = !1,
                    c1 = {},
                    Mm = {},
                    Om = {
                        dehydrated: null,
                        treeContext: null,
                        retryLane: 0,
                        hydrationErrors: null,
                    },
                    u1 = !1,
                    d1 = null;
                d1 = new Set();
                var Ha = !1,
                    mt = !1,
                    km = !1,
                    f1 = typeof WeakSet == 'function' ? WeakSet : Set,
                    Dt = null,
                    fo = null,
                    mo = null,
                    yt = null,
                    nn = !1,
                    Wn = null,
                    Is = 8192,
                    dw = {
                        getCacheForType: function (e) {
                            var t = it(vt),
                                n = t.data.get(e);
                            return (n === void 0 && ((n = e()), t.data.set(e, n)), n);
                        },
                        getOwner: function () {
                            return fn;
                        },
                    };
                if (typeof Symbol == 'function' && Symbol.for) {
                    var Hs = Symbol.for;
                    (Hs('selector.component'),
                        Hs('selector.has_pseudo_class'),
                        Hs('selector.role'),
                        Hs('selector.test_id'),
                        Hs('selector.text'));
                }
                var fw = [],
                    mw = typeof WeakMap == 'function' ? WeakMap : Map,
                    mn = 0,
                    Wt = 2,
                    Xn = 4,
                    Ua = 0,
                    Us = 1,
                    po = 2,
                    jm = 3,
                    al = 4,
                    Uc = 6,
                    m1 = 5,
                    Pe = mn,
                    Fe = null,
                    ke = null,
                    Ve = 0,
                    an = 0,
                    Gs = 1,
                    il = 2,
                    _s = 3,
                    p1 = 4,
                    Vm = 5,
                    ho = 6,
                    Ys = 7,
                    zm = 8,
                    ll = 9,
                    Ze = an,
                    pn = null,
                    bi = !1,
                    go = !1,
                    Bm = !1,
                    pa = 0,
                    rt = Ua,
                    yi = 0,
                    vi = 0,
                    Lm = 0,
                    hn = 0,
                    ol = 0,
                    Ps = null,
                    Xt = null,
                    Gc = !1,
                    Im = 0,
                    h1 = 300,
                    _c = 1 / 0,
                    g1 = 500,
                    Zs = null,
                    Si = null,
                    pw = 0,
                    hw = 1,
                    gw = 2,
                    sl = 0,
                    b1 = 1,
                    y1 = 2,
                    v1 = 3,
                    bw = 4,
                    Hm = 5,
                    Vt = 0,
                    xi = null,
                    bo = null,
                    Ni = 0,
                    Um = 0,
                    Gm = null,
                    S1 = null,
                    yw = 50,
                    Ws = 0,
                    _m = null,
                    Ym = !1,
                    Yc = !1,
                    vw = 50,
                    rl = 0,
                    Xs = null,
                    yo = !1,
                    Pc = null,
                    x1 = !1,
                    N1 = new Set(),
                    Sw = {},
                    Zc = null,
                    vo = null,
                    Pm = !1,
                    Zm = !1,
                    Wc = !1,
                    Wm = !1,
                    cl = 0,
                    Xm = {};
                ((function () {
                    for (var e = 0; e < um.length; e++) {
                        var t = um[e],
                            n = t.toLowerCase();
                        ((t = t[0].toUpperCase() + t.slice(1)), Un(n, 'on' + t));
                    }
                    (Un(sv, 'onAnimationEnd'),
                        Un(rv, 'onAnimationIteration'),
                        Un(cv, 'onAnimationStart'),
                        Un('dblclick', 'onDoubleClick'),
                        Un('focusin', 'onFocus'),
                        Un('focusout', 'onBlur'),
                        Un($N, 'onTransitionRun'),
                        Un(FN, 'onTransitionStart'),
                        Un(KN, 'onTransitionCancel'),
                        Un(uv, 'onTransitionEnd'));
                })(),
                    ie('onMouseEnter', ['mouseout', 'mouseover']),
                    ie('onMouseLeave', ['mouseout', 'mouseover']),
                    ie('onPointerEnter', ['pointerout', 'pointerover']),
                    ie('onPointerLeave', ['pointerout', 'pointerover']),
                    ee(
                        'onChange',
                        'change click focusin focusout input keydown keyup selectionchange'.split(
                            ' '
                        )
                    ),
                    ee(
                        'onSelect',
                        'focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange'.split(
                            ' '
                        )
                    ),
                    ee('onBeforeInput', [
                        'compositionend',
                        'keypress',
                        'textInput',
                        'paste',
                    ]),
                    ee(
                        'onCompositionEnd',
                        'compositionend focusout keydown keypress keyup mousedown'.split(
                            ' '
                        )
                    ),
                    ee(
                        'onCompositionStart',
                        'compositionstart focusout keydown keypress keyup mousedown'.split(
                            ' '
                        )
                    ),
                    ee(
                        'onCompositionUpdate',
                        'compositionupdate focusout keydown keypress keyup mousedown'.split(
                            ' '
                        )
                    ));
                var Qs =
                    'abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting'.split(
                        ' '
                    ),
                    Qm = new Set(
                        'beforetoggle cancel close invalid load scroll scrollend toggle'
                            .split(' ')
                            .concat(Qs)
                    ),
                    Xc = '_reactListening' + Math.random().toString(36).slice(2),
                    w1 = !1,
                    E1 = !1,
                    Qc = !1,
                    A1 = !1,
                    Jc = !1,
                    qc = !1,
                    D1 = !1,
                    $c = {},
                    xw = /\r\n?/g,
                    Nw = /\u0000|\uFFFD/g,
                    ul = 'http://www.w3.org/1999/xlink',
                    Jm = 'http://www.w3.org/XML/1998/namespace',
                    ww =
                        "javascript:throw new Error('React form unexpectedly submitted.')",
                    Ew = 'suppressHydrationWarning',
                    Fc = '$',
                    Kc = '/$',
                    Ga = '$?',
                    Js = '$!',
                    Aw = 1,
                    Dw = 2,
                    Tw = 4,
                    qm = 'F!',
                    T1 = 'F',
                    C1 = 'complete',
                    Cw = 'style',
                    _a = 0,
                    So = 1,
                    eu = 2,
                    $m = null,
                    Fm = null,
                    R1 = { dialog: !0, webview: !0 },
                    Km = null,
                    M1 = typeof setTimeout == 'function' ? setTimeout : void 0,
                    Rw = typeof clearTimeout == 'function' ? clearTimeout : void 0,
                    dl = -1,
                    O1 = typeof Promise == 'function' ? Promise : void 0,
                    Mw =
                        typeof queueMicrotask == 'function'
                            ? queueMicrotask
                            : typeof O1 < 'u'
                                ? function (e) {
                                    return O1.resolve(null).then(e).catch(hx);
                                }
                                : M1,
                    ep = null,
                    fl = 0,
                    qs = 1,
                    k1 = 2,
                    j1 = 3,
                    jn = 4,
                    Vn = new Map(),
                    V1 = new Set(),
                    Ya = Ye.d;
                Ye.d = {
                    f: function () {
                        var e = Ya.f(),
                            t = Ol();
                        return e || t;
                    },
                    r: function (e) {
                        var t = Hn(e);
                        t !== null && t.tag === 5 && t.type === 'form'
                            ? fg(t)
                            : Ya.r(e);
                    },
                    D: function (e) {
                        (Ya.D(e), ty('dns-prefetch', e, null));
                    },
                    C: function (e, t) {
                        (Ya.C(e, t), ty('preconnect', e, t));
                    },
                    L: function (e, t, n) {
                        Ya.L(e, t, n);
                        var a = xo;
                        if (a && e && t) {
                            var o = 'link[rel="preload"][as="' + Sn(t) + '"]';
                            t === 'image' && n && n.imageSrcSet
                                ? ((o += '[imagesrcset="' + Sn(n.imageSrcSet) + '"]'),
                                    typeof n.imageSizes == 'string' &&
                                    (o += '[imagesizes="' + Sn(n.imageSizes) + '"]'))
                                : (o += '[href="' + Sn(e) + '"]');
                            var c = o;
                            switch (t) {
                                case 'style':
                                    c = zl(e);
                                    break;
                                case 'script':
                                    c = Bl(e);
                            }
                            Vn.has(c) ||
                                ((e = Me(
                                    {
                                        rel: 'preload',
                                        href: t === 'image' && n && n.imageSrcSet ? void 0 : e,
                                        as: t,
                                    },
                                    n
                                )),
                                    Vn.set(c, e),
                                    a.querySelector(o) !== null ||
                                    (t === 'style' && a.querySelector(cs(c))) ||
                                    (t === 'script' && a.querySelector(us(c))) ||
                                    ((t = a.createElement('link')),
                                        Mt(t, 'link', e),
                                        M(t),
                                        a.head.appendChild(t)));
                        }
                    },
                    m: function (e, t) {
                        Ya.m(e, t);
                        var n = xo;
                        if (n && e) {
                            var a = t && typeof t.as == 'string' ? t.as : 'script',
                                o =
                                    'link[rel="modulepreload"][as="' +
                                    Sn(a) +
                                    '"][href="' +
                                    Sn(e) +
                                    '"]',
                                c = o;
                            switch (a) {
                                case 'audioworklet':
                                case 'paintworklet':
                                case 'serviceworker':
                                case 'sharedworker':
                                case 'worker':
                                case 'script':
                                    c = Bl(e);
                            }
                            if (
                                !Vn.has(c) &&
                                ((e = Me({ rel: 'modulepreload', href: e }, t)),
                                    Vn.set(c, e),
                                    n.querySelector(o) === null)
                            ) {
                                switch (a) {
                                    case 'audioworklet':
                                    case 'paintworklet':
                                    case 'serviceworker':
                                    case 'sharedworker':
                                    case 'worker':
                                    case 'script':
                                        if (n.querySelector(us(c))) return;
                                }
                                ((a = n.createElement('link')),
                                    Mt(a, 'link', e),
                                    M(a),
                                    n.head.appendChild(a));
                            }
                        }
                    },
                    X: function (e, t) {
                        Ya.X(e, t);
                        var n = xo;
                        if (n && e) {
                            var a = x(n).hoistableScripts,
                                o = Bl(e),
                                c = a.get(o);
                            c ||
                                ((c = n.querySelector(us(o))),
                                    c ||
                                    ((e = Me({ src: e, async: !0 }, t)),
                                        (t = Vn.get(o)) && Tf(e, t),
                                        (c = n.createElement('script')),
                                        M(c),
                                        Mt(c, 'link', e),
                                        n.head.appendChild(c)),
                                    (c = {
                                        type: 'script',
                                        instance: c,
                                        count: 1,
                                        state: null,
                                    }),
                                    a.set(o, c));
                        }
                    },
                    S: function (e, t, n) {
                        Ya.S(e, t, n);
                        var a = xo;
                        if (a && e) {
                            var o = x(a).hoistableStyles,
                                c = zl(e);
                            t = t || 'default';
                            var f = o.get(c);
                            if (!f) {
                                var g = { loading: fl, preload: null };
                                if ((f = a.querySelector(cs(c)))) g.loading = qs | jn;
                                else {
                                    ((e = Me(
                                        { rel: 'stylesheet', href: e, 'data-precedence': t },
                                        n
                                    )),
                                        (n = Vn.get(c)) && Df(e, n));
                                    var w = (f = a.createElement('link'));
                                    (M(w),
                                        Mt(w, 'link', e),
                                        (w._p = new Promise(function (A, V) {
                                            ((w.onload = A), (w.onerror = V));
                                        })),
                                        w.addEventListener('load', function () {
                                            g.loading |= qs;
                                        }),
                                        w.addEventListener('error', function () {
                                            g.loading |= k1;
                                        }),
                                        (g.loading |= jn),
                                        rc(f, t, a));
                                }
                                ((f = {
                                    type: 'stylesheet',
                                    instance: f,
                                    count: 1,
                                    state: g,
                                }),
                                    o.set(c, f));
                            }
                        }
                    },
                    M: function (e, t) {
                        Ya.M(e, t);
                        var n = xo;
                        if (n && e) {
                            var a = x(n).hoistableScripts,
                                o = Bl(e),
                                c = a.get(o);
                            c ||
                                ((c = n.querySelector(us(o))),
                                    c ||
                                    ((e = Me({ src: e, async: !0, type: 'module' }, t)),
                                        (t = Vn.get(o)) && Tf(e, t),
                                        (c = n.createElement('script')),
                                        M(c),
                                        Mt(c, 'link', e),
                                        n.head.appendChild(c)),
                                    (c = {
                                        type: 'script',
                                        instance: c,
                                        count: 1,
                                        state: null,
                                    }),
                                    a.set(o, c));
                        }
                    },
                };
                var xo = typeof document > 'u' ? null : document,
                    tu = null,
                    $s = null,
                    tp = null,
                    nu = null,
                    ml = Jx,
                    Fs = {
                        $$typeof: la,
                        Provider: null,
                        Consumer: null,
                        _currentValue: ml,
                        _currentValue2: ml,
                        _threadCount: 0,
                    },
                    z1 = '%c%s%c ',
                    B1 =
                        'background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px',
                    L1 = '',
                    au = ' ',
                    Ow = Function.prototype.bind,
                    I1 = !1,
                    H1 = null,
                    U1 = null,
                    G1 = null,
                    _1 = null,
                    Y1 = null,
                    P1 = null,
                    Z1 = null,
                    W1 = null,
                    X1 = null;
                ((H1 = function (e, t, n, a) {
                    ((t = i(e, t)),
                        t !== null &&
                        ((n = l(t.memoizedState, n, 0, a)),
                            (t.memoizedState = n),
                            (t.baseState = n),
                            (e.memoizedProps = Me({}, e.memoizedProps)),
                            (n = $t(e, 2)),
                            n !== null && ft(n, e, 2)));
                }),
                    (U1 = function (e, t, n) {
                        ((t = i(e, t)),
                            t !== null &&
                            ((n = u(t.memoizedState, n, 0)),
                                (t.memoizedState = n),
                                (t.baseState = n),
                                (e.memoizedProps = Me({}, e.memoizedProps)),
                                (n = $t(e, 2)),
                                n !== null && ft(n, e, 2)));
                    }),
                    (G1 = function (e, t, n, a) {
                        ((t = i(e, t)),
                            t !== null &&
                            ((n = s(t.memoizedState, n, a)),
                                (t.memoizedState = n),
                                (t.baseState = n),
                                (e.memoizedProps = Me({}, e.memoizedProps)),
                                (n = $t(e, 2)),
                                n !== null && ft(n, e, 2)));
                    }),
                    (_1 = function (e, t, n) {
                        ((e.pendingProps = l(e.memoizedProps, t, 0, n)),
                            e.alternate && (e.alternate.pendingProps = e.pendingProps),
                            (t = $t(e, 2)),
                            t !== null && ft(t, e, 2));
                    }),
                    (Y1 = function (e, t) {
                        ((e.pendingProps = u(e.memoizedProps, t, 0)),
                            e.alternate && (e.alternate.pendingProps = e.pendingProps),
                            (t = $t(e, 2)),
                            t !== null && ft(t, e, 2));
                    }),
                    (P1 = function (e, t, n) {
                        ((e.pendingProps = s(e.memoizedProps, t, n)),
                            e.alternate && (e.alternate.pendingProps = e.pendingProps),
                            (t = $t(e, 2)),
                            t !== null && ft(t, e, 2));
                    }),
                    (Z1 = function (e) {
                        var t = $t(e, 2);
                        t !== null && ft(t, e, 2);
                    }),
                    (W1 = function (e) {
                        p = e;
                    }),
                    (X1 = function (e) {
                        d = e;
                    }));
                var iu = !0,
                    lu = null,
                    np = !1,
                    wi = null,
                    Ei = null,
                    Ai = null,
                    Ks = new Map(),
                    er = new Map(),
                    Di = [],
                    kw =
                        'mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset'.split(
                            ' '
                        ),
                    ou = null;
                if (
                    ((fc.prototype.render = Vf.prototype.render =
                        function (e) {
                            var t = this._internalRoot;
                            if (t === null)
                                throw Error('Cannot update an unmounted root.');
                            var n = arguments;
                            (typeof n[1] == 'function'
                                ? console.error(
                                    'does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().'
                                )
                                : k(n[1])
                                    ? console.error(
                                        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
                                    )
                                    : typeof n[1] < 'u' &&
                                    console.error(
                                        'You passed a second argument to root.render(...) but it only accepts one argument.'
                                    ),
                                (n = e));
                            var a = t.current,
                                o = un(a);
                            Rf(a, o, n, t, null, null);
                        }),
                        (fc.prototype.unmount = Vf.prototype.unmount =
                            function () {
                                var e = arguments;
                                if (
                                    (typeof e[0] == 'function' &&
                                        console.error(
                                            'does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().'
                                        ),
                                        (e = this._internalRoot),
                                        e !== null)
                                ) {
                                    this._internalRoot = null;
                                    var t = e.containerInfo;
                                    ((Pe & (Wt | Xn)) !== mn &&
                                        console.error(
                                            'Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.'
                                        ),
                                        Rf(e.current, 2, null, e, null, null),
                                        Ol(),
                                        (t[di] = null));
                                }
                            }),
                        (fc.prototype.unstable_scheduleHydration = function (e) {
                            if (e) {
                                var t = ko();
                                e = { blockedOn: null, target: e, priority: t };
                                for (
                                    var n = 0;
                                    n < Di.length && t !== 0 && t < Di[n].priority;
                                    n++
                                );
                                (Di.splice(n, 0, e), n === 0 && py(e));
                            }
                        }),
                        (function () {
                            var e = zf.version;
                            if (e !== '19.1.1')
                                throw Error(
                                    `Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:
  - react:      ` +
                                    (e +
                                        `
  - react-dom:  19.1.1
Learn more: https://react.dev/warnings/version-mismatch`)
                                );
                        })(),
                        (typeof Map == 'function' &&
                            Map.prototype != null &&
                            typeof Map.prototype.forEach == 'function' &&
                            typeof Set == 'function' &&
                            Set.prototype != null &&
                            typeof Set.prototype.clear == 'function' &&
                            typeof Set.prototype.forEach == 'function') ||
                        console.error(
                            'React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills'
                        ),
                        (Ye.findDOMNode = function (e) {
                            var t = e._reactInternals;
                            if (t === void 0)
                                throw typeof e.render == 'function'
                                    ? Error('Unable to find node on an unmounted component.')
                                    : ((e = Object.keys(e).join(',')),
                                        Error(
                                            'Argument appears to not be a ReactComponent. Keys: ' +
                                            e
                                        ));
                            return (
                                (e = Z(t)),
                                (e = e !== null ? P(e) : null),
                                (e = e === null ? null : e.stateNode),
                                e
                            );
                        }),
                        !(function () {
                            var e = {
                                bundleType: 1,
                                version: '19.1.1',
                                rendererPackageName: 'react-dom',
                                currentDispatcherRef: B,
                                reconcilerVersion: '19.1.1',
                            };
                            return (
                                (e.overrideHookState = H1),
                                (e.overrideHookStateDeletePath = U1),
                                (e.overrideHookStateRenamePath = G1),
                                (e.overrideProps = _1),
                                (e.overridePropsDeletePath = Y1),
                                (e.overridePropsRenamePath = P1),
                                (e.scheduleUpdate = Z1),
                                (e.setErrorHandler = W1),
                                (e.setSuspenseHandler = X1),
                                (e.scheduleRefresh = D),
                                (e.scheduleRoot = S),
                                (e.setRefreshHandler = O),
                                (e.getCurrentFiber = Ix),
                                (e.getLaneLabelMap = Hx),
                                (e.injectProfilingHooks = Ri),
                                zt(e)
                            );
                        })() &&
                        ua &&
                        window.top === window.self &&
                        ((-1 < navigator.userAgent.indexOf('Chrome') &&
                            navigator.userAgent.indexOf('Edge') === -1) ||
                            -1 < navigator.userAgent.indexOf('Firefox')))
                ) {
                    var Q1 = window.location.protocol;
                    /^(https?|file):$/.test(Q1) &&
                        console.info(
                            '%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools' +
                            (Q1 === 'file:'
                                ? `
You might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq`
                                : ''),
                            'font-weight:bold'
                        );
                }
                ((tr.createRoot = function (e, t) {
                    if (!k(e)) throw Error('Target container is not a DOM element.');
                    by(e);
                    var n = !1,
                        a = '',
                        o = Ng,
                        c = wg,
                        f = Eg,
                        g = null;
                    return (
                        t != null &&
                        (t.hydrate
                            ? console.warn(
                                'hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.'
                            )
                            : typeof t == 'object' &&
                            t !== null &&
                            t.$$typeof === si &&
                            console.error(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`),
                            t.unstable_strictMode === !0 && (n = !0),
                            t.identifierPrefix !== void 0 && (a = t.identifierPrefix),
                            t.onUncaughtError !== void 0 && (o = t.onUncaughtError),
                            t.onCaughtError !== void 0 && (c = t.onCaughtError),
                            t.onRecoverableError !== void 0 && (f = t.onRecoverableError),
                            t.unstable_transitionCallbacks !== void 0 &&
                            (g = t.unstable_transitionCallbacks)),
                        (t = ry(e, 1, !1, null, null, n, a, o, c, f, g, null)),
                        (e[di] = t.current),
                        gf(e),
                        new Vf(t)
                    );
                }),
                    (tr.hydrateRoot = function (e, t, n) {
                        if (!k(e))
                            throw Error('Target container is not a DOM element.');
                        (by(e),
                            t === void 0 &&
                            console.error(
                                'Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)'
                            ));
                        var a = !1,
                            o = '',
                            c = Ng,
                            f = wg,
                            g = Eg,
                            w = null,
                            A = null;
                        return (
                            n != null &&
                            (n.unstable_strictMode === !0 && (a = !0),
                                n.identifierPrefix !== void 0 && (o = n.identifierPrefix),
                                n.onUncaughtError !== void 0 && (c = n.onUncaughtError),
                                n.onCaughtError !== void 0 && (f = n.onCaughtError),
                                n.onRecoverableError !== void 0 &&
                                (g = n.onRecoverableError),
                                n.unstable_transitionCallbacks !== void 0 &&
                                (w = n.unstable_transitionCallbacks),
                                n.formState !== void 0 && (A = n.formState)),
                            (t = ry(e, 1, !0, t, n ?? null, a, o, c, f, g, w, A)),
                            (t.context = cy(null)),
                            (n = t.current),
                            (a = un(n)),
                            (a = Ro(a)),
                            (o = Ka(a)),
                            (o.callback = null),
                            ei(n, o, a),
                            (n = a),
                            (t.current.lanes = n),
                            Ja(t, n),
                            aa(t),
                            (e[di] = t.current),
                            gf(e),
                            new fc(t)
                        );
                    }),
                    (tr.version = '19.1.1'),
                    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ==
                    'function' &&
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(
                        Error()
                    ));
            })(),
            tr
        );
    }
    var i0;
    function _w() {
        return (i0 || ((i0 = 1), (lp.exports = Gw())), lp.exports);
    }
    var l0 = _w();
    const Se = i => typeof i == 'string',
        nr = () => {
            let i, l;
            const s = new Promise((r, u) => {
                ((i = r), (l = u));
            });
            return ((s.resolve = i), (s.reject = l), s);
        },
        o0 = i => (i == null ? '' : '' + i),
        Yw = (i, l, s) => {
            i.forEach(r => {
                l[r] && (s[r] = l[r]);
            });
        },
        Pw = /###/g,
        s0 = i => (i && i.indexOf('###') > -1 ? i.replace(Pw, '.') : i),
        r0 = i => !i || Se(i),
        ir = (i, l, s) => {
            const r = Se(l) ? l.split('.') : l;
            let u = 0;
            for (; u < r.length - 1;) {
                if (r0(i)) return {};
                const d = s0(r[u]);
                (!i[d] && s && (i[d] = new s()),
                    Object.prototype.hasOwnProperty.call(i, d)
                        ? (i = i[d])
                        : (i = {}),
                    ++u);
            }
            return r0(i) ? {} : { obj: i, k: s0(r[u]) };
        },
        c0 = (i, l, s) => {
            const { obj: r, k: u } = ir(i, l, Object);
            if (r !== void 0 || l.length === 1) {
                r[u] = s;
                return;
            }
            let d = l[l.length - 1],
                p = l.slice(0, l.length - 1),
                h = ir(i, p, Object);
            for (; h.obj === void 0 && p.length;)
                ((d = `${p[p.length - 1]}.${d}`),
                    (p = p.slice(0, p.length - 1)),
                    (h = ir(i, p, Object)),
                    h?.obj && typeof h.obj[`${h.k}.${d}`] < 'u' && (h.obj = void 0));
            h.obj[`${h.k}.${d}`] = s;
        },
        Zw = (i, l, s, r) => {
            const { obj: u, k: d } = ir(i, l, Object);
            ((u[d] = u[d] || []), u[d].push(s));
        },
        pu = (i, l) => {
            const { obj: s, k: r } = ir(i, l);
            if (s && Object.prototype.hasOwnProperty.call(s, r)) return s[r];
        },
        Ww = (i, l, s) => {
            const r = pu(i, s);
            return r !== void 0 ? r : pu(l, s);
        },
        B0 = (i, l, s) => {
            for (const r in l)
                r !== '__proto__' &&
                    r !== 'constructor' &&
                    (r in i
                        ? Se(i[r]) ||
                            i[r] instanceof String ||
                            Se(l[r]) ||
                            l[r] instanceof String
                            ? s && (i[r] = l[r])
                            : B0(i[r], l[r], s)
                        : (i[r] = l[r]));
            return i;
        },
        No = i => i.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    var Xw = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
    };
    const Qw = i => (Se(i) ? i.replace(/[&<>"'\/]/g, l => Xw[l]) : i);
    class Jw {
        constructor(l) {
            ((this.capacity = l),
                (this.regExpMap = new Map()),
                (this.regExpQueue = []));
        }
        getRegExp(l) {
            const s = this.regExpMap.get(l);
            if (s !== void 0) return s;
            const r = new RegExp(l);
            return (
                this.regExpQueue.length === this.capacity &&
                this.regExpMap.delete(this.regExpQueue.shift()),
                this.regExpMap.set(l, r),
                this.regExpQueue.push(l),
                r
            );
        }
    }
    const qw = [' ', ',', '?', '!', ';'],
        $w = new Jw(20),
        Fw = (i, l, s) => {
            ((l = l || ''), (s = s || ''));
            const r = qw.filter(p => l.indexOf(p) < 0 && s.indexOf(p) < 0);
            if (r.length === 0) return !0;
            const u = $w.getRegExp(
                `(${r.map(p => (p === '?' ? '\\?' : p)).join('|')})`
            );
            let d = !u.test(i);
            if (!d) {
                const p = i.indexOf(s);
                p > 0 && !u.test(i.substring(0, p)) && (d = !0);
            }
            return d;
        },
        Ep = (i, l, s = '.') => {
            if (!i) return;
            if (i[l])
                return Object.prototype.hasOwnProperty.call(i, l) ? i[l] : void 0;
            const r = l.split(s);
            let u = i;
            for (let d = 0; d < r.length;) {
                if (!u || typeof u != 'object') return;
                let p,
                    h = '';
                for (let m = d; m < r.length; ++m)
                    if (
                        (m !== d && (h += s), (h += r[m]), (p = u[h]), p !== void 0)
                    ) {
                        if (
                            ['string', 'number', 'boolean'].indexOf(typeof p) > -1 &&
                            m < r.length - 1
                        )
                            continue;
                        d += m - d + 1;
                        break;
                    }
                u = p;
            }
            return u;
        },
        or = i => i?.replace('_', '-'),
        Kw = {
            type: 'logger',
            log(i) {
                this.output('log', i);
            },
            warn(i) {
                this.output('warn', i);
            },
            error(i) {
                this.output('error', i);
            },
            output(i, l) {
                console?.[i]?.apply?.(console, l);
            },
        };
    class hu {
        constructor(l, s = {}) {
            this.init(l, s);
        }
        init(l, s = {}) {
            ((this.prefix = s.prefix || 'i18next:'),
                (this.logger = l || Kw),
                (this.options = s),
                (this.debug = s.debug));
        }
        log(...l) {
            return this.forward(l, 'log', '', !0);
        }
        warn(...l) {
            return this.forward(l, 'warn', '', !0);
        }
        error(...l) {
            return this.forward(l, 'error', '');
        }
        deprecate(...l) {
            return this.forward(l, 'warn', 'WARNING DEPRECATED: ', !0);
        }
        forward(l, s, r, u) {
            return u && !this.debug
                ? null
                : (Se(l[0]) && (l[0] = `${r}${this.prefix} ${l[0]}`),
                    this.logger[s](l));
        }
        create(l) {
            return new hu(this.logger, {
                prefix: `${this.prefix}:${l}:`,
                ...this.options,
            });
        }
        clone(l) {
            return (
                (l = l || this.options),
                (l.prefix = l.prefix || this.prefix),
                new hu(this.logger, l)
            );
        }
    }
    var ba = new hu();
    class wu {
        constructor() {
            this.observers = {};
        }
        on(l, s) {
            return (
                l.split(' ').forEach(r => {
                    this.observers[r] || (this.observers[r] = new Map());
                    const u = this.observers[r].get(s) || 0;
                    this.observers[r].set(s, u + 1);
                }),
                this
            );
        }
        off(l, s) {
            if (this.observers[l]) {
                if (!s) {
                    delete this.observers[l];
                    return;
                }
                this.observers[l].delete(s);
            }
        }
        emit(l, ...s) {
            (this.observers[l] &&
                Array.from(this.observers[l].entries()).forEach(([u, d]) => {
                    for (let p = 0; p < d; p++) u(...s);
                }),
                this.observers['*'] &&
                Array.from(this.observers['*'].entries()).forEach(([u, d]) => {
                    for (let p = 0; p < d; p++) u.apply(u, [l, ...s]);
                }));
        }
    }
    class u0 extends wu {
        constructor(l, s = { ns: ['translation'], defaultNS: 'translation' }) {
            (super(),
                (this.data = l || {}),
                (this.options = s),
                this.options.keySeparator === void 0 &&
                (this.options.keySeparator = '.'),
                this.options.ignoreJSONStructure === void 0 &&
                (this.options.ignoreJSONStructure = !0));
        }
        addNamespaces(l) {
            this.options.ns.indexOf(l) < 0 && this.options.ns.push(l);
        }
        removeNamespaces(l) {
            const s = this.options.ns.indexOf(l);
            s > -1 && this.options.ns.splice(s, 1);
        }
        getResource(l, s, r, u = {}) {
            const d =
                u.keySeparator !== void 0
                    ? u.keySeparator
                    : this.options.keySeparator,
                p =
                    u.ignoreJSONStructure !== void 0
                        ? u.ignoreJSONStructure
                        : this.options.ignoreJSONStructure;
            let h;
            l.indexOf('.') > -1
                ? (h = l.split('.'))
                : ((h = [l, s]),
                    r &&
                    (Array.isArray(r)
                        ? h.push(...r)
                        : Se(r) && d
                            ? h.push(...r.split(d))
                            : h.push(r)));
            const m = pu(this.data, h);
            return (
                !m &&
                !s &&
                !r &&
                l.indexOf('.') > -1 &&
                ((l = h[0]), (s = h[1]), (r = h.slice(2).join('.'))),
                m || !p || !Se(r) ? m : Ep(this.data?.[l]?.[s], r, d)
            );
        }
        addResource(l, s, r, u, d = { silent: !1 }) {
            const p =
                d.keySeparator !== void 0
                    ? d.keySeparator
                    : this.options.keySeparator;
            let h = [l, s];
            (r && (h = h.concat(p ? r.split(p) : r)),
                l.indexOf('.') > -1 && ((h = l.split('.')), (u = s), (s = h[1])),
                this.addNamespaces(s),
                c0(this.data, h, u),
                d.silent || this.emit('added', l, s, r, u));
        }
        addResources(l, s, r, u = { silent: !1 }) {
            for (const d in r)
                (Se(r[d]) || Array.isArray(r[d])) &&
                    this.addResource(l, s, d, r[d], { silent: !0 });
            u.silent || this.emit('added', l, s, r);
        }
        addResourceBundle(l, s, r, u, d, p = { silent: !1, skipCopy: !1 }) {
            let h = [l, s];
            (l.indexOf('.') > -1 &&
                ((h = l.split('.')), (u = r), (r = s), (s = h[1])),
                this.addNamespaces(s));
            let m = pu(this.data, h) || {};
            (p.skipCopy || (r = JSON.parse(JSON.stringify(r))),
                u ? B0(m, r, d) : (m = { ...m, ...r }),
                c0(this.data, h, m),
                p.silent || this.emit('added', l, s, r));
        }
        removeResourceBundle(l, s) {
            (this.hasResourceBundle(l, s) && delete this.data[l][s],
                this.removeNamespaces(s),
                this.emit('removed', l, s));
        }
        hasResourceBundle(l, s) {
            return this.getResource(l, s) !== void 0;
        }
        getResourceBundle(l, s) {
            return (s || (s = this.options.defaultNS), this.getResource(l, s));
        }
        getDataByLanguage(l) {
            return this.data[l];
        }
        hasLanguageSomeTranslations(l) {
            const s = this.getDataByLanguage(l);
            return !!((s && Object.keys(s)) || []).find(
                u => s[u] && Object.keys(s[u]).length > 0
            );
        }
        toJSON() {
            return this.data;
        }
    }
    var L0 = {
        processors: {},
        addPostProcessor(i) {
            this.processors[i.name] = i;
        },
        handle(i, l, s, r, u) {
            return (
                i.forEach(d => {
                    l = this.processors[d]?.process(l, s, r, u) ?? l;
                }),
                l
            );
        },
    };
    const I0 = Symbol('i18next/PATH_KEY');
    function eE() {
        const i = [],
            l = Object.create(null);
        let s;
        return (
            (l.get = (r, u) => (
                s?.revoke?.(),
                u === I0 ? i : (i.push(u), (s = Proxy.revocable(r, l)), s.proxy)
            )),
            Proxy.revocable(Object.create(null), l).proxy
        );
    }
    function Ap(i, l) {
        const { [I0]: s } = i(eE());
        return s.join(l?.keySeparator ?? '.');
    }
    const d0 = {},
        cp = i => !Se(i) && typeof i != 'boolean' && typeof i != 'number';
    class gu extends wu {
        constructor(l, s = {}) {
            (super(),
                Yw(
                    [
                        'resourceStore',
                        'languageUtils',
                        'pluralResolver',
                        'interpolator',
                        'backendConnector',
                        'i18nFormat',
                        'utils',
                    ],
                    l,
                    this
                ),
                (this.options = s),
                this.options.keySeparator === void 0 &&
                (this.options.keySeparator = '.'),
                (this.logger = ba.create('translator')));
        }
        changeLanguage(l) {
            l && (this.language = l);
        }
        exists(l, s = { interpolation: {} }) {
            const r = { ...s };
            if (l == null) return !1;
            const u = this.resolve(l, r);
            if (u?.res === void 0) return !1;
            const d = cp(u.res);
            return !(r.returnObjects === !1 && d);
        }
        extractFromKey(l, s) {
            let r =
                s.nsSeparator !== void 0 ? s.nsSeparator : this.options.nsSeparator;
            r === void 0 && (r = ':');
            const u =
                s.keySeparator !== void 0
                    ? s.keySeparator
                    : this.options.keySeparator;
            let d = s.ns || this.options.defaultNS || [];
            const p = r && l.indexOf(r) > -1,
                h =
                    !this.options.userDefinedKeySeparator &&
                    !s.keySeparator &&
                    !this.options.userDefinedNsSeparator &&
                    !s.nsSeparator &&
                    !Fw(l, r, u);
            if (p && !h) {
                const m = l.match(this.interpolator.nestingRegexp);
                if (m && m.length > 0)
                    return { key: l, namespaces: Se(d) ? [d] : d };
                const y = l.split(r);
                ((r !== u || (r === u && this.options.ns.indexOf(y[0]) > -1)) &&
                    (d = y.shift()),
                    (l = y.join(u)));
            }
            return { key: l, namespaces: Se(d) ? [d] : d };
        }
        translate(l, s, r) {
            let u = typeof s == 'object' ? { ...s } : s;
            if (
                (typeof u != 'object' &&
                    this.options.overloadTranslationOptionHandler &&
                    (u = this.options.overloadTranslationOptionHandler(arguments)),
                    typeof u == 'object' && (u = { ...u }),
                    u || (u = {}),
                    l == null)
            )
                return '';
            (typeof l == 'function' && (l = Ap(l, { ...this.options, ...u })),
                Array.isArray(l) || (l = [String(l)]));
            const d =
                u.returnDetails !== void 0
                    ? u.returnDetails
                    : this.options.returnDetails,
                p =
                    u.keySeparator !== void 0
                        ? u.keySeparator
                        : this.options.keySeparator,
                { key: h, namespaces: m } = this.extractFromKey(l[l.length - 1], u),
                y = m[m.length - 1];
            let E =
                u.nsSeparator !== void 0 ? u.nsSeparator : this.options.nsSeparator;
            E === void 0 && (E = ':');
            const v = u.lng || this.language,
                N =
                    u.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
            if (v?.toLowerCase() === 'cimode')
                return N
                    ? d
                        ? {
                            res: `${y}${E}${h}`,
                            usedKey: h,
                            exactUsedKey: h,
                            usedLng: v,
                            usedNS: y,
                            usedParams: this.getUsedParamsDetails(u),
                        }
                        : `${y}${E}${h}`
                    : d
                        ? {
                            res: h,
                            usedKey: h,
                            exactUsedKey: h,
                            usedLng: v,
                            usedNS: y,
                            usedParams: this.getUsedParamsDetails(u),
                        }
                        : h;
            const S = this.resolve(l, u);
            let D = S?.res;
            const O = S?.usedKey || h,
                k = S?.exactUsedKey || h,
                _ = ['[object Number]', '[object Function]', '[object RegExp]'],
                I =
                    u.joinArrays !== void 0 ? u.joinArrays : this.options.joinArrays,
                Y = !this.i18nFormat || this.i18nFormat.handleAsObject,
                Z = u.count !== void 0 && !Se(u.count),
                P = gu.hasDefaultValue(u),
                le = Z ? this.pluralResolver.getSuffix(v, u.count, u) : '',
                q =
                    u.ordinal && Z
                        ? this.pluralResolver.getSuffix(v, u.count, { ordinal: !1 })
                        : '',
                W = Z && !u.ordinal && u.count === 0,
                K =
                    (W && u[`defaultValue${this.options.pluralSeparator}zero`]) ||
                    u[`defaultValue${le}`] ||
                    u[`defaultValue${q}`] ||
                    u.defaultValue;
            let te = D;
            Y && !D && P && (te = K);
            const X = cp(te),
                oe = Object.prototype.toString.apply(te);
            if (
                Y &&
                te &&
                X &&
                _.indexOf(oe) < 0 &&
                !(Se(I) && Array.isArray(te))
            ) {
                if (!u.returnObjects && !this.options.returnObjects) {
                    this.options.returnedObjectHandler ||
                        this.logger.warn(
                            'accessing an object - but returnObjects options is not enabled!'
                        );
                    const ge = this.options.returnedObjectHandler
                        ? this.options.returnedObjectHandler(O, te, { ...u, ns: m })
                        : `key '${h} (${this.language})' returned an object instead of string.`;
                    return d
                        ? ((S.res = ge),
                            (S.usedParams = this.getUsedParamsDetails(u)),
                            S)
                        : ge;
                }
                if (p) {
                    const ge = Array.isArray(te),
                        Ee = ge ? [] : {},
                        _e = ge ? k : O;
                    for (const J in te)
                        if (Object.prototype.hasOwnProperty.call(te, J)) {
                            const ce = `${_e}${p}${J}`;
                            (P && !D
                                ? (Ee[J] = this.translate(ce, {
                                    ...u,
                                    defaultValue: cp(K) ? K[J] : void 0,
                                    joinArrays: !1,
                                    ns: m,
                                }))
                                : (Ee[J] = this.translate(ce, {
                                    ...u,
                                    joinArrays: !1,
                                    ns: m,
                                })),
                                Ee[J] === ce && (Ee[J] = te[J]));
                        }
                    D = Ee;
                }
            } else if (Y && Se(I) && Array.isArray(D))
                ((D = D.join(I)), D && (D = this.extendTranslation(D, l, u, r)));
            else {
                let ge = !1,
                    Ee = !1;
                (!this.isValidLookup(D) && P && ((ge = !0), (D = K)),
                    this.isValidLookup(D) || ((Ee = !0), (D = h)));
                const J =
                    (u.missingKeyNoValueFallbackToKey ||
                        this.options.missingKeyNoValueFallbackToKey) &&
                        Ee
                        ? void 0
                        : D,
                    ce = P && K !== D && this.options.updateMissing;
                if (Ee || ge || ce) {
                    if (
                        (this.logger.log(
                            ce ? 'updateKey' : 'missingKey',
                            v,
                            y,
                            h,
                            ce ? K : D
                        ),
                            p)
                    ) {
                        const re = this.resolve(h, { ...u, keySeparator: !1 });
                        re &&
                            re.res &&
                            this.logger.warn(
                                'Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.'
                            );
                    }
                    let Q = [];
                    const me = this.languageUtils.getFallbackCodes(
                        this.options.fallbackLng,
                        u.lng || this.language
                    );
                    if (this.options.saveMissingTo === 'fallback' && me && me[0])
                        for (let re = 0; re < me.length; re++) Q.push(me[re]);
                    else
                        this.options.saveMissingTo === 'all'
                            ? (Q = this.languageUtils.toResolveHierarchy(
                                u.lng || this.language
                            ))
                            : Q.push(u.lng || this.language);
                    const U = (re, ue, Ge) => {
                        const at = P && Ge !== D ? Ge : J;
                        (this.options.missingKeyHandler
                            ? this.options.missingKeyHandler(re, y, ue, at, ce, u)
                            : this.backendConnector?.saveMissing &&
                            this.backendConnector.saveMissing(re, y, ue, at, ce, u),
                            this.emit('missingKey', re, y, ue, D));
                    };
                    this.options.saveMissing &&
                        (this.options.saveMissingPlurals && Z
                            ? Q.forEach(re => {
                                const ue = this.pluralResolver.getSuffixes(re, u);
                                (W &&
                                    u[`defaultValue${this.options.pluralSeparator}zero`] &&
                                    ue.indexOf(`${this.options.pluralSeparator}zero`) < 0 &&
                                    ue.push(`${this.options.pluralSeparator}zero`),
                                    ue.forEach(Ge => {
                                        U([re], h + Ge, u[`defaultValue${Ge}`] || K);
                                    }));
                            })
                            : U(Q, h, K));
                }
                ((D = this.extendTranslation(D, l, u, S, r)),
                    Ee &&
                    D === h &&
                    this.options.appendNamespaceToMissingKey &&
                    (D = `${y}${E}${h}`),
                    (Ee || ge) &&
                    this.options.parseMissingKeyHandler &&
                    (D = this.options.parseMissingKeyHandler(
                        this.options.appendNamespaceToMissingKey ? `${y}${E}${h}` : h,
                        ge ? D : void 0,
                        u
                    )));
            }
            return d
                ? ((S.res = D), (S.usedParams = this.getUsedParamsDetails(u)), S)
                : D;
        }
        extendTranslation(l, s, r, u, d) {
            if (this.i18nFormat?.parse)
                l = this.i18nFormat.parse(
                    l,
                    { ...this.options.interpolation.defaultVariables, ...r },
                    r.lng || this.language || u.usedLng,
                    u.usedNS,
                    u.usedKey,
                    { resolved: u }
                );
            else if (!r.skipInterpolation) {
                r.interpolation &&
                    this.interpolator.init({
                        ...r,
                        interpolation: {
                            ...this.options.interpolation,
                            ...r.interpolation,
                        },
                    });
                const m =
                    Se(l) &&
                    (r?.interpolation?.skipOnVariables !== void 0
                        ? r.interpolation.skipOnVariables
                        : this.options.interpolation.skipOnVariables);
                let y;
                if (m) {
                    const v = l.match(this.interpolator.nestingRegexp);
                    y = v && v.length;
                }
                let E = r.replace && !Se(r.replace) ? r.replace : r;
                if (
                    (this.options.interpolation.defaultVariables &&
                        (E = { ...this.options.interpolation.defaultVariables, ...E }),
                        (l = this.interpolator.interpolate(
                            l,
                            E,
                            r.lng || this.language || u.usedLng,
                            r
                        )),
                        m)
                ) {
                    const v = l.match(this.interpolator.nestingRegexp),
                        N = v && v.length;
                    y < N && (r.nest = !1);
                }
                (!r.lng && u && u.res && (r.lng = this.language || u.usedLng),
                    r.nest !== !1 &&
                    (l = this.interpolator.nest(
                        l,
                        (...v) =>
                            d?.[0] === v[0] && !r.context
                                ? (this.logger.warn(
                                    `It seems you are nesting recursively key: ${v[0]} in key: ${s[0]}`
                                ),
                                    null)
                                : this.translate(...v, s),
                        r
                    )),
                    r.interpolation && this.interpolator.reset());
            }
            const p = r.postProcess || this.options.postProcess,
                h = Se(p) ? [p] : p;
            return (
                l != null &&
                h?.length &&
                r.applyPostProcessor !== !1 &&
                (l = L0.handle(
                    h,
                    l,
                    s,
                    this.options && this.options.postProcessPassResolved
                        ? {
                            i18nResolved: {
                                ...u,
                                usedParams: this.getUsedParamsDetails(r),
                            },
                            ...r,
                        }
                        : r,
                    this
                )),
                l
            );
        }
        resolve(l, s = {}) {
            let r, u, d, p, h;
            return (
                Se(l) && (l = [l]),
                l.forEach(m => {
                    if (this.isValidLookup(r)) return;
                    const y = this.extractFromKey(m, s),
                        E = y.key;
                    u = E;
                    let v = y.namespaces;
                    this.options.fallbackNS &&
                        (v = v.concat(this.options.fallbackNS));
                    const N = s.count !== void 0 && !Se(s.count),
                        S = N && !s.ordinal && s.count === 0,
                        D =
                            s.context !== void 0 &&
                            (Se(s.context) || typeof s.context == 'number') &&
                            s.context !== '',
                        O = s.lngs
                            ? s.lngs
                            : this.languageUtils.toResolveHierarchy(
                                s.lng || this.language,
                                s.fallbackLng
                            );
                    v.forEach(k => {
                        this.isValidLookup(r) ||
                            ((h = k),
                                !d0[`${O[0]}-${k}`] &&
                                this.utils?.hasLoadedNamespace &&
                                !this.utils?.hasLoadedNamespace(h) &&
                                ((d0[`${O[0]}-${k}`] = !0),
                                    this.logger.warn(
                                        `key "${u}" for languages "${O.join(', ')}" won't get resolved as namespace "${h}" was not yet loaded`,
                                        'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
                                    )),
                                O.forEach(_ => {
                                    if (this.isValidLookup(r)) return;
                                    p = _;
                                    const I = [E];
                                    if (this.i18nFormat?.addLookupKeys)
                                        this.i18nFormat.addLookupKeys(I, E, _, k, s);
                                    else {
                                        let Z;
                                        N && (Z = this.pluralResolver.getSuffix(_, s.count, s));
                                        const P = `${this.options.pluralSeparator}zero`,
                                            le = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                                        if (
                                            (N &&
                                                (s.ordinal &&
                                                    Z.indexOf(le) === 0 &&
                                                    I.push(
                                                        E + Z.replace(le, this.options.pluralSeparator)
                                                    ),
                                                    I.push(E + Z),
                                                    S && I.push(E + P)),
                                                D)
                                        ) {
                                            const q = `${E}${this.options.contextSeparator || '_'}${s.context}`;
                                            (I.push(q),
                                                N &&
                                                (s.ordinal &&
                                                    Z.indexOf(le) === 0 &&
                                                    I.push(
                                                        q + Z.replace(le, this.options.pluralSeparator)
                                                    ),
                                                    I.push(q + Z),
                                                    S && I.push(q + P)));
                                        }
                                    }
                                    let Y;
                                    for (; (Y = I.pop());)
                                        this.isValidLookup(r) ||
                                            ((d = Y), (r = this.getResource(_, k, Y, s)));
                                }));
                    });
                }),
                { res: r, usedKey: u, exactUsedKey: d, usedLng: p, usedNS: h }
            );
        }
        isValidLookup(l) {
            return (
                l !== void 0 &&
                !(!this.options.returnNull && l === null) &&
                !(!this.options.returnEmptyString && l === '')
            );
        }
        getResource(l, s, r, u = {}) {
            return this.i18nFormat?.getResource
                ? this.i18nFormat.getResource(l, s, r, u)
                : this.resourceStore.getResource(l, s, r, u);
        }
        getUsedParamsDetails(l = {}) {
            const s = [
                'defaultValue',
                'ordinal',
                'context',
                'replace',
                'lng',
                'lngs',
                'fallbackLng',
                'ns',
                'keySeparator',
                'nsSeparator',
                'returnObjects',
                'returnDetails',
                'joinArrays',
                'postProcess',
                'interpolation',
            ],
                r = l.replace && !Se(l.replace);
            let u = r ? l.replace : l;
            if (
                (r && typeof l.count < 'u' && (u.count = l.count),
                    this.options.interpolation.defaultVariables &&
                    (u = { ...this.options.interpolation.defaultVariables, ...u }),
                    !r)
            ) {
                u = { ...u };
                for (const d of s) delete u[d];
            }
            return u;
        }
        static hasDefaultValue(l) {
            const s = 'defaultValue';
            for (const r in l)
                if (
                    Object.prototype.hasOwnProperty.call(l, r) &&
                    s === r.substring(0, s.length) &&
                    l[r] !== void 0
                )
                    return !0;
            return !1;
        }
    }
    class f0 {
        constructor(l) {
            ((this.options = l),
                (this.supportedLngs = this.options.supportedLngs || !1),
                (this.logger = ba.create('languageUtils')));
        }
        getScriptPartFromCode(l) {
            if (((l = or(l)), !l || l.indexOf('-') < 0)) return null;
            const s = l.split('-');
            return s.length === 2 ||
                (s.pop(), s[s.length - 1].toLowerCase() === 'x')
                ? null
                : this.formatLanguageCode(s.join('-'));
        }
        getLanguagePartFromCode(l) {
            if (((l = or(l)), !l || l.indexOf('-') < 0)) return l;
            const s = l.split('-');
            return this.formatLanguageCode(s[0]);
        }
        formatLanguageCode(l) {
            if (Se(l) && l.indexOf('-') > -1) {
                let s;
                try {
                    s = Intl.getCanonicalLocales(l)[0];
                } catch { }
                return (
                    s && this.options.lowerCaseLng && (s = s.toLowerCase()),
                    s || (this.options.lowerCaseLng ? l.toLowerCase() : l)
                );
            }
            return this.options.cleanCode || this.options.lowerCaseLng
                ? l.toLowerCase()
                : l;
        }
        isSupportedCode(l) {
            return (
                (this.options.load === 'languageOnly' ||
                    this.options.nonExplicitSupportedLngs) &&
                (l = this.getLanguagePartFromCode(l)),
                !this.supportedLngs ||
                !this.supportedLngs.length ||
                this.supportedLngs.indexOf(l) > -1
            );
        }
        getBestMatchFromCodes(l) {
            if (!l) return null;
            let s;
            return (
                l.forEach(r => {
                    if (s) return;
                    const u = this.formatLanguageCode(r);
                    (!this.options.supportedLngs || this.isSupportedCode(u)) &&
                        (s = u);
                }),
                !s &&
                this.options.supportedLngs &&
                l.forEach(r => {
                    if (s) return;
                    const u = this.getScriptPartFromCode(r);
                    if (this.isSupportedCode(u)) return (s = u);
                    const d = this.getLanguagePartFromCode(r);
                    if (this.isSupportedCode(d)) return (s = d);
                    s = this.options.supportedLngs.find(p => {
                        if (p === d) return p;
                        if (
                            !(p.indexOf('-') < 0 && d.indexOf('-') < 0) &&
                            ((p.indexOf('-') > 0 &&
                                d.indexOf('-') < 0 &&
                                p.substring(0, p.indexOf('-')) === d) ||
                                (p.indexOf(d) === 0 && d.length > 1))
                        )
                            return p;
                    });
                }),
                s || (s = this.getFallbackCodes(this.options.fallbackLng)[0]),
                s
            );
        }
        getFallbackCodes(l, s) {
            if (!l) return [];
            if (
                (typeof l == 'function' && (l = l(s)),
                    Se(l) && (l = [l]),
                    Array.isArray(l))
            )
                return l;
            if (!s) return l.default || [];
            let r = l[s];
            return (
                r || (r = l[this.getScriptPartFromCode(s)]),
                r || (r = l[this.formatLanguageCode(s)]),
                r || (r = l[this.getLanguagePartFromCode(s)]),
                r || (r = l.default),
                r || []
            );
        }
        toResolveHierarchy(l, s) {
            const r = this.getFallbackCodes(
                (s === !1 ? [] : s) || this.options.fallbackLng || [],
                l
            ),
                u = [],
                d = p => {
                    p &&
                        (this.isSupportedCode(p)
                            ? u.push(p)
                            : this.logger.warn(
                                `rejecting language code not found in supportedLngs: ${p}`
                            ));
                };
            return (
                Se(l) && (l.indexOf('-') > -1 || l.indexOf('_') > -1)
                    ? (this.options.load !== 'languageOnly' &&
                        d(this.formatLanguageCode(l)),
                        this.options.load !== 'languageOnly' &&
                        this.options.load !== 'currentOnly' &&
                        d(this.getScriptPartFromCode(l)),
                        this.options.load !== 'currentOnly' &&
                        d(this.getLanguagePartFromCode(l)))
                    : Se(l) && d(this.formatLanguageCode(l)),
                r.forEach(p => {
                    u.indexOf(p) < 0 && d(this.formatLanguageCode(p));
                }),
                u
            );
        }
    }
    const m0 = { zero: 0, one: 1, two: 2, few: 3, many: 4, other: 5 },
        p0 = {
            select: i => (i === 1 ? 'one' : 'other'),
            resolvedOptions: () => ({ pluralCategories: ['one', 'other'] }),
        };
    class tE {
        constructor(l, s = {}) {
            ((this.languageUtils = l),
                (this.options = s),
                (this.logger = ba.create('pluralResolver')),
                (this.pluralRulesCache = {}));
        }
        addRule(l, s) {
            this.rules[l] = s;
        }
        clearCache() {
            this.pluralRulesCache = {};
        }
        getRule(l, s = {}) {
            const r = or(l === 'dev' ? 'en' : l),
                u = s.ordinal ? 'ordinal' : 'cardinal',
                d = JSON.stringify({ cleanedCode: r, type: u });
            if (d in this.pluralRulesCache) return this.pluralRulesCache[d];
            let p;
            try {
                p = new Intl.PluralRules(r, { type: u });
            } catch {
                if (!Intl)
                    return (
                        this.logger.error(
                            'No Intl support, please use an Intl polyfill!'
                        ),
                        p0
                    );
                if (!l.match(/-|_/)) return p0;
                const m = this.languageUtils.getLanguagePartFromCode(l);
                p = this.getRule(m, s);
            }
            return ((this.pluralRulesCache[d] = p), p);
        }
        needsPlural(l, s = {}) {
            let r = this.getRule(l, s);
            return (
                r || (r = this.getRule('dev', s)),
                r?.resolvedOptions().pluralCategories.length > 1
            );
        }
        getPluralFormsOfKey(l, s, r = {}) {
            return this.getSuffixes(l, r).map(u => `${s}${u}`);
        }
        getSuffixes(l, s = {}) {
            let r = this.getRule(l, s);
            return (
                r || (r = this.getRule('dev', s)),
                r
                    ? r
                        .resolvedOptions()
                        .pluralCategories.sort((u, d) => m0[u] - m0[d])
                        .map(
                            u =>
                                `${this.options.prepend}${s.ordinal ? `ordinal${this.options.prepend}` : ''}${u}`
                        )
                    : []
            );
        }
        getSuffix(l, s, r = {}) {
            const u = this.getRule(l, r);
            return u
                ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ''}${u.select(s)}`
                : (this.logger.warn(`no plural rule found for: ${l}`),
                    this.getSuffix('dev', s, r));
        }
    }
    const h0 = (i, l, s, r = '.', u = !0) => {
        let d = Ww(i, l, s);
        return (
            !d &&
            u &&
            Se(s) &&
            ((d = Ep(i, s, r)), d === void 0 && (d = Ep(l, s, r))),
            d
        );
    },
        up = i => i.replace(/\$/g, '$$$$');
    class nE {
        constructor(l = {}) {
            ((this.logger = ba.create('interpolator')),
                (this.options = l),
                (this.format = l?.interpolation?.format || (s => s)),
                this.init(l));
        }
        init(l = {}) {
            l.interpolation || (l.interpolation = { escapeValue: !0 });
            const {
                escape: s,
                escapeValue: r,
                useRawValueToEscape: u,
                prefix: d,
                prefixEscaped: p,
                suffix: h,
                suffixEscaped: m,
                formatSeparator: y,
                unescapeSuffix: E,
                unescapePrefix: v,
                nestingPrefix: N,
                nestingPrefixEscaped: S,
                nestingSuffix: D,
                nestingSuffixEscaped: O,
                nestingOptionsSeparator: k,
                maxReplaces: _,
                alwaysFormat: I,
            } = l.interpolation;
            ((this.escape = s !== void 0 ? s : Qw),
                (this.escapeValue = r !== void 0 ? r : !0),
                (this.useRawValueToEscape = u !== void 0 ? u : !1),
                (this.prefix = d ? No(d) : p || '{{'),
                (this.suffix = h ? No(h) : m || '}}'),
                (this.formatSeparator = y || ','),
                (this.unescapePrefix = E ? '' : v || '-'),
                (this.unescapeSuffix = this.unescapePrefix ? '' : E || ''),
                (this.nestingPrefix = N ? No(N) : S || No('$t(')),
                (this.nestingSuffix = D ? No(D) : O || No(')')),
                (this.nestingOptionsSeparator = k || ','),
                (this.maxReplaces = _ || 1e3),
                (this.alwaysFormat = I !== void 0 ? I : !1),
                this.resetRegExp());
        }
        reset() {
            this.options && this.init(this.options);
        }
        resetRegExp() {
            const l = (s, r) =>
                s?.source === r ? ((s.lastIndex = 0), s) : new RegExp(r, 'g');
            ((this.regexp = l(this.regexp, `${this.prefix}(.+?)${this.suffix}`)),
                (this.regexpUnescape = l(
                    this.regexpUnescape,
                    `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`
                )),
                (this.nestingRegexp = l(
                    this.nestingRegexp,
                    `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`
                )));
        }
        interpolate(l, s, r, u) {
            let d, p, h;
            const m =
                (this.options &&
                    this.options.interpolation &&
                    this.options.interpolation.defaultVariables) ||
                {},
                y = S => {
                    if (S.indexOf(this.formatSeparator) < 0) {
                        const _ = h0(
                            s,
                            m,
                            S,
                            this.options.keySeparator,
                            this.options.ignoreJSONStructure
                        );
                        return this.alwaysFormat
                            ? this.format(_, void 0, r, {
                                ...u,
                                ...s,
                                interpolationkey: S,
                            })
                            : _;
                    }
                    const D = S.split(this.formatSeparator),
                        O = D.shift().trim(),
                        k = D.join(this.formatSeparator).trim();
                    return this.format(
                        h0(
                            s,
                            m,
                            O,
                            this.options.keySeparator,
                            this.options.ignoreJSONStructure
                        ),
                        k,
                        r,
                        { ...u, ...s, interpolationkey: O }
                    );
                };
            this.resetRegExp();
            const E =
                u?.missingInterpolationHandler ||
                this.options.missingInterpolationHandler,
                v =
                    u?.interpolation?.skipOnVariables !== void 0
                        ? u.interpolation.skipOnVariables
                        : this.options.interpolation.skipOnVariables;
            return (
                [
                    { regex: this.regexpUnescape, safeValue: S => up(S) },
                    {
                        regex: this.regexp,
                        safeValue: S => (this.escapeValue ? up(this.escape(S)) : up(S)),
                    },
                ].forEach(S => {
                    for (h = 0; (d = S.regex.exec(l));) {
                        const D = d[1].trim();
                        if (((p = y(D)), p === void 0))
                            if (typeof E == 'function') {
                                const k = E(l, d, u);
                                p = Se(k) ? k : '';
                            } else if (u && Object.prototype.hasOwnProperty.call(u, D))
                                p = '';
                            else if (v) {
                                p = d[0];
                                continue;
                            } else
                                (this.logger.warn(
                                    `missed to pass in variable ${D} for interpolating ${l}`
                                ),
                                    (p = ''));
                        else !Se(p) && !this.useRawValueToEscape && (p = o0(p));
                        const O = S.safeValue(p);
                        if (
                            ((l = l.replace(d[0], O)),
                                v
                                    ? ((S.regex.lastIndex += p.length),
                                        (S.regex.lastIndex -= d[0].length))
                                    : (S.regex.lastIndex = 0),
                                h++,
                                h >= this.maxReplaces)
                        )
                            break;
                    }
                }),
                l
            );
        }
        nest(l, s, r = {}) {
            let u, d, p;
            const h = (m, y) => {
                const E = this.nestingOptionsSeparator;
                if (m.indexOf(E) < 0) return m;
                const v = m.split(new RegExp(`${E}[ ]*{`));
                let N = `{${v[1]}`;
                ((m = v[0]), (N = this.interpolate(N, p)));
                const S = N.match(/'/g),
                    D = N.match(/"/g);
                (((S?.length ?? 0) % 2 === 0 && !D) || D.length % 2 !== 0) &&
                    (N = N.replace(/'/g, '"'));
                try {
                    ((p = JSON.parse(N)), y && (p = { ...y, ...p }));
                } catch (O) {
                    return (
                        this.logger.warn(
                            `failed parsing options string in nesting for key ${m}`,
                            O
                        ),
                        `${m}${E}${N}`
                    );
                }
                return (
                    p.defaultValue &&
                    p.defaultValue.indexOf(this.prefix) > -1 &&
                    delete p.defaultValue,
                    m
                );
            };
            for (; (u = this.nestingRegexp.exec(l));) {
                let m = [];
                ((p = { ...r }),
                    (p = p.replace && !Se(p.replace) ? p.replace : p),
                    (p.applyPostProcessor = !1),
                    delete p.defaultValue);
                const y = /{.*}/.test(u[1])
                    ? u[1].lastIndexOf('}') + 1
                    : u[1].indexOf(this.formatSeparator);
                if (
                    (y !== -1 &&
                        ((m = u[1]
                            .slice(y)
                            .split(this.formatSeparator)
                            .map(E => E.trim())
                            .filter(Boolean)),
                            (u[1] = u[1].slice(0, y))),
                        (d = s(h.call(this, u[1].trim(), p), p)),
                        d && u[0] === l && !Se(d))
                )
                    return d;
                (Se(d) || (d = o0(d)),
                    d ||
                    (this.logger.warn(`missed to resolve ${u[1]} for nesting ${l}`),
                        (d = '')),
                    m.length &&
                    (d = m.reduce(
                        (E, v) =>
                            this.format(E, v, r.lng, {
                                ...r,
                                interpolationkey: u[1].trim(),
                            }),
                        d.trim()
                    )),
                    (l = l.replace(u[0], d)),
                    (this.regexp.lastIndex = 0));
            }
            return l;
        }
    }
    const aE = i => {
        let l = i.toLowerCase().trim();
        const s = {};
        if (i.indexOf('(') > -1) {
            const r = i.split('(');
            l = r[0].toLowerCase().trim();
            const u = r[1].substring(0, r[1].length - 1);
            l === 'currency' && u.indexOf(':') < 0
                ? s.currency || (s.currency = u.trim())
                : l === 'relativetime' && u.indexOf(':') < 0
                    ? s.range || (s.range = u.trim())
                    : u.split(';').forEach(p => {
                        if (p) {
                            const [h, ...m] = p.split(':'),
                                y = m
                                    .join(':')
                                    .trim()
                                    .replace(/^'+|'+$/g, ''),
                                E = h.trim();
                            (s[E] || (s[E] = y),
                                y === 'false' && (s[E] = !1),
                                y === 'true' && (s[E] = !0),
                                isNaN(y) || (s[E] = parseInt(y, 10)));
                        }
                    });
        }
        return { formatName: l, formatOptions: s };
    },
        g0 = i => {
            const l = {};
            return (s, r, u) => {
                let d = u;
                u &&
                    u.interpolationkey &&
                    u.formatParams &&
                    u.formatParams[u.interpolationkey] &&
                    u[u.interpolationkey] &&
                    (d = { ...d, [u.interpolationkey]: void 0 });
                const p = r + JSON.stringify(d);
                let h = l[p];
                return (h || ((h = i(or(r), u)), (l[p] = h)), h(s));
            };
        },
        iE = i => (l, s, r) => i(or(s), r)(l);
    class lE {
        constructor(l = {}) {
            ((this.logger = ba.create('formatter')),
                (this.options = l),
                this.init(l));
        }
        init(l, s = { interpolation: {} }) {
            this.formatSeparator = s.interpolation.formatSeparator || ',';
            const r = s.cacheInBuiltFormats ? g0 : iE;
            this.formats = {
                number: r((u, d) => {
                    const p = new Intl.NumberFormat(u, { ...d });
                    return h => p.format(h);
                }),
                currency: r((u, d) => {
                    const p = new Intl.NumberFormat(u, { ...d, style: 'currency' });
                    return h => p.format(h);
                }),
                datetime: r((u, d) => {
                    const p = new Intl.DateTimeFormat(u, { ...d });
                    return h => p.format(h);
                }),
                relativetime: r((u, d) => {
                    const p = new Intl.RelativeTimeFormat(u, { ...d });
                    return h => p.format(h, d.range || 'day');
                }),
                list: r((u, d) => {
                    const p = new Intl.ListFormat(u, { ...d });
                    return h => p.format(h);
                }),
            };
        }
        add(l, s) {
            this.formats[l.toLowerCase().trim()] = s;
        }
        addCached(l, s) {
            this.formats[l.toLowerCase().trim()] = g0(s);
        }
        format(l, s, r, u = {}) {
            const d = s.split(this.formatSeparator);
            if (
                d.length > 1 &&
                d[0].indexOf('(') > 1 &&
                d[0].indexOf(')') < 0 &&
                d.find(h => h.indexOf(')') > -1)
            ) {
                const h = d.findIndex(m => m.indexOf(')') > -1);
                d[0] = [d[0], ...d.splice(1, h)].join(this.formatSeparator);
            }
            return d.reduce((h, m) => {
                const { formatName: y, formatOptions: E } = aE(m);
                if (this.formats[y]) {
                    let v = h;
                    try {
                        const N = u?.formatParams?.[u.interpolationkey] || {},
                            S = N.locale || N.lng || u.locale || u.lng || r;
                        v = this.formats[y](h, S, { ...E, ...u, ...N });
                    } catch (N) {
                        this.logger.warn(N);
                    }
                    return v;
                } else this.logger.warn(`there was no format function for ${y}`);
                return h;
            }, l);
        }
    }
    const oE = (i, l) => {
        i.pending[l] !== void 0 && (delete i.pending[l], i.pendingCount--);
    };
    class sE extends wu {
        constructor(l, s, r, u = {}) {
            (super(),
                (this.backend = l),
                (this.store = s),
                (this.services = r),
                (this.languageUtils = r.languageUtils),
                (this.options = u),
                (this.logger = ba.create('backendConnector')),
                (this.waitingReads = []),
                (this.maxParallelReads = u.maxParallelReads || 10),
                (this.readingCalls = 0),
                (this.maxRetries = u.maxRetries >= 0 ? u.maxRetries : 5),
                (this.retryTimeout = u.retryTimeout >= 1 ? u.retryTimeout : 350),
                (this.state = {}),
                (this.queue = []),
                this.backend?.init?.(r, u.backend, u));
        }
        queueLoad(l, s, r, u) {
            const d = {},
                p = {},
                h = {},
                m = {};
            return (
                l.forEach(y => {
                    let E = !0;
                    (s.forEach(v => {
                        const N = `${y}|${v}`;
                        !r.reload && this.store.hasResourceBundle(y, v)
                            ? (this.state[N] = 2)
                            : this.state[N] < 0 ||
                            (this.state[N] === 1
                                ? p[N] === void 0 && (p[N] = !0)
                                : ((this.state[N] = 1),
                                    (E = !1),
                                    p[N] === void 0 && (p[N] = !0),
                                    d[N] === void 0 && (d[N] = !0),
                                    m[v] === void 0 && (m[v] = !0)));
                    }),
                        E || (h[y] = !0));
                }),
                (Object.keys(d).length || Object.keys(p).length) &&
                this.queue.push({
                    pending: p,
                    pendingCount: Object.keys(p).length,
                    loaded: {},
                    errors: [],
                    callback: u,
                }),
                {
                    toLoad: Object.keys(d),
                    pending: Object.keys(p),
                    toLoadLanguages: Object.keys(h),
                    toLoadNamespaces: Object.keys(m),
                }
            );
        }
        loaded(l, s, r) {
            const u = l.split('|'),
                d = u[0],
                p = u[1];
            (s && this.emit('failedLoading', d, p, s),
                !s &&
                r &&
                this.store.addResourceBundle(d, p, r, void 0, void 0, {
                    skipCopy: !0,
                }),
                (this.state[l] = s ? -1 : 2),
                s && r && (this.state[l] = 0));
            const h = {};
            (this.queue.forEach(m => {
                (Zw(m.loaded, [d], p),
                    oE(m, l),
                    s && m.errors.push(s),
                    m.pendingCount === 0 &&
                    !m.done &&
                    (Object.keys(m.loaded).forEach(y => {
                        h[y] || (h[y] = {});
                        const E = m.loaded[y];
                        E.length &&
                            E.forEach(v => {
                                h[y][v] === void 0 && (h[y][v] = !0);
                            });
                    }),
                        (m.done = !0),
                        m.errors.length ? m.callback(m.errors) : m.callback()));
            }),
                this.emit('loaded', h),
                (this.queue = this.queue.filter(m => !m.done)));
        }
        read(l, s, r, u = 0, d = this.retryTimeout, p) {
            if (!l.length) return p(null, {});
            if (this.readingCalls >= this.maxParallelReads) {
                this.waitingReads.push({
                    lng: l,
                    ns: s,
                    fcName: r,
                    tried: u,
                    wait: d,
                    callback: p,
                });
                return;
            }
            this.readingCalls++;
            const h = (y, E) => {
                if ((this.readingCalls--, this.waitingReads.length > 0)) {
                    const v = this.waitingReads.shift();
                    this.read(v.lng, v.ns, v.fcName, v.tried, v.wait, v.callback);
                }
                if (y && E && u < this.maxRetries) {
                    setTimeout(() => {
                        this.read.call(this, l, s, r, u + 1, d * 2, p);
                    }, d);
                    return;
                }
                p(y, E);
            },
                m = this.backend[r].bind(this.backend);
            if (m.length === 2) {
                try {
                    const y = m(l, s);
                    y && typeof y.then == 'function'
                        ? y.then(E => h(null, E)).catch(h)
                        : h(null, y);
                } catch (y) {
                    h(y);
                }
                return;
            }
            return m(l, s, h);
        }
        prepareLoading(l, s, r = {}, u) {
            if (!this.backend)
                return (
                    this.logger.warn(
                        'No backend was added via i18next.use. Will not load resources.'
                    ),
                    u && u()
                );
            (Se(l) && (l = this.languageUtils.toResolveHierarchy(l)),
                Se(s) && (s = [s]));
            const d = this.queueLoad(l, s, r, u);
            if (!d.toLoad.length) return (d.pending.length || u(), null);
            d.toLoad.forEach(p => {
                this.loadOne(p);
            });
        }
        load(l, s, r) {
            this.prepareLoading(l, s, {}, r);
        }
        reload(l, s, r) {
            this.prepareLoading(l, s, { reload: !0 }, r);
        }
        loadOne(l, s = '') {
            const r = l.split('|'),
                u = r[0],
                d = r[1];
            this.read(u, d, 'read', void 0, void 0, (p, h) => {
                (p &&
                    this.logger.warn(
                        `${s}loading namespace ${d} for language ${u} failed`,
                        p
                    ),
                    !p &&
                    h &&
                    this.logger.log(
                        `${s}loaded namespace ${d} for language ${u}`,
                        h
                    ),
                    this.loaded(l, p, h));
            });
        }
        saveMissing(l, s, r, u, d, p = {}, h = () => { }) {
            if (
                this.services?.utils?.hasLoadedNamespace &&
                !this.services?.utils?.hasLoadedNamespace(s)
            ) {
                this.logger.warn(
                    `did not save key "${r}" as the namespace "${s}" was not yet loaded`,
                    'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
                );
                return;
            }
            if (!(r == null || r === '')) {
                if (this.backend?.create) {
                    const m = { ...p, isUpdate: d },
                        y = this.backend.create.bind(this.backend);
                    if (y.length < 6)
                        try {
                            let E;
                            (y.length === 5
                                ? (E = y(l, s, r, u, m))
                                : (E = y(l, s, r, u)),
                                E && typeof E.then == 'function'
                                    ? E.then(v => h(null, v)).catch(h)
                                    : h(null, E));
                        } catch (E) {
                            h(E);
                        }
                    else y(l, s, r, u, h, m);
                }
                !l || !l[0] || this.store.addResource(l[0], s, r, u);
            }
        }
    }
    const b0 = () => ({
        debug: !1,
        initAsync: !0,
        ns: ['translation'],
        defaultNS: ['translation'],
        fallbackLng: ['dev'],
        fallbackNS: !1,
        supportedLngs: !1,
        nonExplicitSupportedLngs: !1,
        load: 'all',
        preload: !1,
        simplifyPluralSuffix: !0,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: !1,
        saveMissing: !1,
        updateMissing: !1,
        saveMissingTo: 'fallback',
        saveMissingPlurals: !0,
        missingKeyHandler: !1,
        missingInterpolationHandler: !1,
        postProcess: !1,
        postProcessPassResolved: !1,
        returnNull: !1,
        returnEmptyString: !0,
        returnObjects: !1,
        joinArrays: !1,
        returnedObjectHandler: !1,
        parseMissingKeyHandler: !1,
        appendNamespaceToMissingKey: !1,
        appendNamespaceToCIMode: !1,
        overloadTranslationOptionHandler: i => {
            let l = {};
            if (
                (typeof i[1] == 'object' && (l = i[1]),
                    Se(i[1]) && (l.defaultValue = i[1]),
                    Se(i[2]) && (l.tDescription = i[2]),
                    typeof i[2] == 'object' || typeof i[3] == 'object')
            ) {
                const s = i[3] || i[2];
                Object.keys(s).forEach(r => {
                    l[r] = s[r];
                });
            }
            return l;
        },
        interpolation: {
            escapeValue: !0,
            format: i => i,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1e3,
            skipOnVariables: !0,
        },
        cacheInBuiltFormats: !0,
    }),
        y0 = i => (
            Se(i.ns) && (i.ns = [i.ns]),
            Se(i.fallbackLng) && (i.fallbackLng = [i.fallbackLng]),
            Se(i.fallbackNS) && (i.fallbackNS = [i.fallbackNS]),
            i.supportedLngs?.indexOf?.('cimode') < 0 &&
            (i.supportedLngs = i.supportedLngs.concat(['cimode'])),
            typeof i.initImmediate == 'boolean' &&
            (i.initAsync = i.initImmediate),
            i
        ),
        cu = () => { },
        rE = i => {
            Object.getOwnPropertyNames(Object.getPrototypeOf(i)).forEach(s => {
                typeof i[s] == 'function' && (i[s] = i[s].bind(i));
            });
        };
    class sr extends wu {
        constructor(l = {}, s) {
            if (
                (super(),
                    (this.options = y0(l)),
                    (this.services = {}),
                    (this.logger = ba),
                    (this.modules = { external: [] }),
                    rE(this),
                    s && !this.isInitialized && !l.isClone)
            ) {
                if (!this.options.initAsync) return (this.init(l, s), this);
                setTimeout(() => {
                    this.init(l, s);
                }, 0);
            }
        }
        init(l = {}, s) {
            ((this.isInitializing = !0),
                typeof l == 'function' && ((s = l), (l = {})),
                l.defaultNS == null &&
                l.ns &&
                (Se(l.ns)
                    ? (l.defaultNS = l.ns)
                    : l.ns.indexOf('translation') < 0 && (l.defaultNS = l.ns[0])));
            const r = b0();
            ((this.options = { ...r, ...this.options, ...y0(l) }),
                (this.options.interpolation = {
                    ...r.interpolation,
                    ...this.options.interpolation,
                }),
                l.keySeparator !== void 0 &&
                (this.options.userDefinedKeySeparator = l.keySeparator),
                l.nsSeparator !== void 0 &&
                (this.options.userDefinedNsSeparator = l.nsSeparator));
            const u = y => (y ? (typeof y == 'function' ? new y() : y) : null);
            if (!this.options.isClone) {
                this.modules.logger
                    ? ba.init(u(this.modules.logger), this.options)
                    : ba.init(null, this.options);
                let y;
                this.modules.formatter ? (y = this.modules.formatter) : (y = lE);
                const E = new f0(this.options);
                this.store = new u0(this.options.resources, this.options);
                const v = this.services;
                ((v.logger = ba),
                    (v.resourceStore = this.store),
                    (v.languageUtils = E),
                    (v.pluralResolver = new tE(E, {
                        prepend: this.options.pluralSeparator,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix,
                    })),
                    this.options.interpolation.format &&
                    this.options.interpolation.format !== r.interpolation.format &&
                    this.logger.deprecate(
                        'init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting'
                    ),
                    y &&
                    (!this.options.interpolation.format ||
                        this.options.interpolation.format ===
                        r.interpolation.format) &&
                    ((v.formatter = u(y)),
                        v.formatter.init && v.formatter.init(v, this.options),
                        (this.options.interpolation.format = v.formatter.format.bind(
                            v.formatter
                        ))),
                    (v.interpolator = new nE(this.options)),
                    (v.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this),
                    }),
                    (v.backendConnector = new sE(
                        u(this.modules.backend),
                        v.resourceStore,
                        v,
                        this.options
                    )),
                    v.backendConnector.on('*', (S, ...D) => {
                        this.emit(S, ...D);
                    }),
                    this.modules.languageDetector &&
                    ((v.languageDetector = u(this.modules.languageDetector)),
                        v.languageDetector.init &&
                        v.languageDetector.init(
                            v,
                            this.options.detection,
                            this.options
                        )),
                    this.modules.i18nFormat &&
                    ((v.i18nFormat = u(this.modules.i18nFormat)),
                        v.i18nFormat.init && v.i18nFormat.init(this)),
                    (this.translator = new gu(this.services, this.options)),
                    this.translator.on('*', (S, ...D) => {
                        this.emit(S, ...D);
                    }),
                    this.modules.external.forEach(S => {
                        S.init && S.init(this);
                    }));
            }
            if (
                ((this.format = this.options.interpolation.format),
                    s || (s = cu),
                    this.options.fallbackLng &&
                    !this.services.languageDetector &&
                    !this.options.lng)
            ) {
                const y = this.services.languageUtils.getFallbackCodes(
                    this.options.fallbackLng
                );
                y.length > 0 && y[0] !== 'dev' && (this.options.lng = y[0]);
            }
            (!this.services.languageDetector &&
                !this.options.lng &&
                this.logger.warn(
                    'init: no languageDetector is used and no lng is defined'
                ),
                [
                    'getResource',
                    'hasResourceBundle',
                    'getResourceBundle',
                    'getDataByLanguage',
                ].forEach(y => {
                    this[y] = (...E) => this.store[y](...E);
                }),
                [
                    'addResource',
                    'addResources',
                    'addResourceBundle',
                    'removeResourceBundle',
                ].forEach(y => {
                    this[y] = (...E) => (this.store[y](...E), this);
                }));
            const h = nr(),
                m = () => {
                    const y = (E, v) => {
                        ((this.isInitializing = !1),
                            this.isInitialized &&
                            !this.initializedStoreOnce &&
                            this.logger.warn(
                                'init: i18next is already initialized. You should call init just once!'
                            ),
                            (this.isInitialized = !0),
                            this.options.isClone ||
                            this.logger.log('initialized', this.options),
                            this.emit('initialized', this.options),
                            h.resolve(v),
                            s(E, v));
                    };
                    if (this.languages && !this.isInitialized)
                        return y(null, this.t.bind(this));
                    this.changeLanguage(this.options.lng, y);
                };
            return (
                this.options.resources || !this.options.initAsync
                    ? m()
                    : setTimeout(m, 0),
                h
            );
        }
        loadResources(l, s = cu) {
            let r = s;
            const u = Se(l) ? l : this.language;
            if (
                (typeof l == 'function' && (r = l),
                    !this.options.resources || this.options.partialBundledLanguages)
            ) {
                if (
                    u?.toLowerCase() === 'cimode' &&
                    (!this.options.preload || this.options.preload.length === 0)
                )
                    return r();
                const d = [],
                    p = h => {
                        if (!h || h === 'cimode') return;
                        this.services.languageUtils.toResolveHierarchy(h).forEach(y => {
                            y !== 'cimode' && d.indexOf(y) < 0 && d.push(y);
                        });
                    };
                (u
                    ? p(u)
                    : this.services.languageUtils
                        .getFallbackCodes(this.options.fallbackLng)
                        .forEach(m => p(m)),
                    this.options.preload?.forEach?.(h => p(h)),
                    this.services.backendConnector.load(d, this.options.ns, h => {
                        (!h &&
                            !this.resolvedLanguage &&
                            this.language &&
                            this.setResolvedLanguage(this.language),
                            r(h));
                    }));
            } else r(null);
        }
        reloadResources(l, s, r) {
            const u = nr();
            return (
                typeof l == 'function' && ((r = l), (l = void 0)),
                typeof s == 'function' && ((r = s), (s = void 0)),
                l || (l = this.languages),
                s || (s = this.options.ns),
                r || (r = cu),
                this.services.backendConnector.reload(l, s, d => {
                    (u.resolve(), r(d));
                }),
                u
            );
        }
        use(l) {
            if (!l)
                throw new Error(
                    'You are passing an undefined module! Please check the object you are passing to i18next.use()'
                );
            if (!l.type)
                throw new Error(
                    'You are passing a wrong module! Please check the object you are passing to i18next.use()'
                );
            return (
                l.type === 'backend' && (this.modules.backend = l),
                (l.type === 'logger' || (l.log && l.warn && l.error)) &&
                (this.modules.logger = l),
                l.type === 'languageDetector' &&
                (this.modules.languageDetector = l),
                l.type === 'i18nFormat' && (this.modules.i18nFormat = l),
                l.type === 'postProcessor' && L0.addPostProcessor(l),
                l.type === 'formatter' && (this.modules.formatter = l),
                l.type === '3rdParty' && this.modules.external.push(l),
                this
            );
        }
        setResolvedLanguage(l) {
            if (
                !(!l || !this.languages) &&
                !(['cimode', 'dev'].indexOf(l) > -1)
            ) {
                for (let s = 0; s < this.languages.length; s++) {
                    const r = this.languages[s];
                    if (
                        !(['cimode', 'dev'].indexOf(r) > -1) &&
                        this.store.hasLanguageSomeTranslations(r)
                    ) {
                        this.resolvedLanguage = r;
                        break;
                    }
                }
                !this.resolvedLanguage &&
                    this.languages.indexOf(l) < 0 &&
                    this.store.hasLanguageSomeTranslations(l) &&
                    ((this.resolvedLanguage = l), this.languages.unshift(l));
            }
        }
        changeLanguage(l, s) {
            this.isLanguageChangingTo = l;
            const r = nr();
            this.emit('languageChanging', l);
            const u = h => {
                ((this.language = h),
                    (this.languages =
                        this.services.languageUtils.toResolveHierarchy(h)),
                    (this.resolvedLanguage = void 0),
                    this.setResolvedLanguage(h));
            },
                d = (h, m) => {
                    (m
                        ? this.isLanguageChangingTo === l &&
                        (u(m),
                            this.translator.changeLanguage(m),
                            (this.isLanguageChangingTo = void 0),
                            this.emit('languageChanged', m),
                            this.logger.log('languageChanged', m))
                        : (this.isLanguageChangingTo = void 0),
                        r.resolve((...y) => this.t(...y)),
                        s && s(h, (...y) => this.t(...y)));
                },
                p = h => {
                    !l && !h && this.services.languageDetector && (h = []);
                    const m = Se(h) ? h : h && h[0],
                        y = this.store.hasLanguageSomeTranslations(m)
                            ? m
                            : this.services.languageUtils.getBestMatchFromCodes(
                                Se(h) ? [h] : h
                            );
                    (y &&
                        (this.language || u(y),
                            this.translator.language || this.translator.changeLanguage(y),
                            this.services.languageDetector?.cacheUserLanguage?.(y)),
                        this.loadResources(y, E => {
                            d(E, y);
                        }));
                };
            return (
                !l &&
                    this.services.languageDetector &&
                    !this.services.languageDetector.async
                    ? p(this.services.languageDetector.detect())
                    : !l &&
                        this.services.languageDetector &&
                        this.services.languageDetector.async
                        ? this.services.languageDetector.detect.length === 0
                            ? this.services.languageDetector.detect().then(p)
                            : this.services.languageDetector.detect(p)
                        : p(l),
                r
            );
        }
        getFixedT(l, s, r) {
            const u = (d, p, ...h) => {
                let m;
                (typeof p != 'object'
                    ? (m = this.options.overloadTranslationOptionHandler(
                        [d, p].concat(h)
                    ))
                    : (m = { ...p }),
                    (m.lng = m.lng || u.lng),
                    (m.lngs = m.lngs || u.lngs),
                    (m.ns = m.ns || u.ns),
                    m.keyPrefix !== '' &&
                    (m.keyPrefix = m.keyPrefix || r || u.keyPrefix));
                const y = this.options.keySeparator || '.';
                let E;
                return (
                    m.keyPrefix && Array.isArray(d)
                        ? (E = d.map(
                            v => (
                                typeof v == 'function' &&
                                (v = Ap(v, { ...this.options, ...p })),
                                `${m.keyPrefix}${y}${v}`
                            )
                        ))
                        : (typeof d == 'function' &&
                            (d = Ap(d, { ...this.options, ...p })),
                            (E = m.keyPrefix ? `${m.keyPrefix}${y}${d}` : d)),
                    this.t(E, m)
                );
            };
            return (
                Se(l) ? (u.lng = l) : (u.lngs = l),
                (u.ns = s),
                (u.keyPrefix = r),
                u
            );
        }
        t(...l) {
            return this.translator?.translate(...l);
        }
        exists(...l) {
            return this.translator?.exists(...l);
        }
        setDefaultNamespace(l) {
            this.options.defaultNS = l;
        }
        hasLoadedNamespace(l, s = {}) {
            if (!this.isInitialized)
                return (
                    this.logger.warn(
                        'hasLoadedNamespace: i18next was not initialized',
                        this.languages
                    ),
                    !1
                );
            if (!this.languages || !this.languages.length)
                return (
                    this.logger.warn(
                        'hasLoadedNamespace: i18n.languages were undefined or empty',
                        this.languages
                    ),
                    !1
                );
            const r = s.lng || this.resolvedLanguage || this.languages[0],
                u = this.options ? this.options.fallbackLng : !1,
                d = this.languages[this.languages.length - 1];
            if (r.toLowerCase() === 'cimode') return !0;
            const p = (h, m) => {
                const y = this.services.backendConnector.state[`${h}|${m}`];
                return y === -1 || y === 0 || y === 2;
            };
            if (s.precheck) {
                const h = s.precheck(this, p);
                if (h !== void 0) return h;
            }
            return !!(
                this.hasResourceBundle(r, l) ||
                !this.services.backendConnector.backend ||
                (this.options.resources && !this.options.partialBundledLanguages) ||
                (p(r, l) && (!u || p(d, l)))
            );
        }
        loadNamespaces(l, s) {
            const r = nr();
            return this.options.ns
                ? (Se(l) && (l = [l]),
                    l.forEach(u => {
                        this.options.ns.indexOf(u) < 0 && this.options.ns.push(u);
                    }),
                    this.loadResources(u => {
                        (r.resolve(), s && s(u));
                    }),
                    r)
                : (s && s(), Promise.resolve());
        }
        loadLanguages(l, s) {
            const r = nr();
            Se(l) && (l = [l]);
            const u = this.options.preload || [],
                d = l.filter(
                    p =>
                        u.indexOf(p) < 0 &&
                        this.services.languageUtils.isSupportedCode(p)
                );
            return d.length
                ? ((this.options.preload = u.concat(d)),
                    this.loadResources(p => {
                        (r.resolve(), s && s(p));
                    }),
                    r)
                : (s && s(), Promise.resolve());
        }
        dir(l) {
            if (
                (l ||
                    (l =
                        this.resolvedLanguage ||
                        (this.languages?.length > 0
                            ? this.languages[0]
                            : this.language)),
                    !l)
            )
                return 'rtl';
            try {
                const u = new Intl.Locale(l);
                if (u && u.getTextInfo) {
                    const d = u.getTextInfo();
                    if (d && d.direction) return d.direction;
                }
            } catch { }
            const s = [
                'ar',
                'shu',
                'sqr',
                'ssh',
                'xaa',
                'yhd',
                'yud',
                'aao',
                'abh',
                'abv',
                'acm',
                'acq',
                'acw',
                'acx',
                'acy',
                'adf',
                'ads',
                'aeb',
                'aec',
                'afb',
                'ajp',
                'apc',
                'apd',
                'arb',
                'arq',
                'ars',
                'ary',
                'arz',
                'auz',
                'avl',
                'ayh',
                'ayl',
                'ayn',
                'ayp',
                'bbz',
                'pga',
                'he',
                'iw',
                'ps',
                'pbt',
                'pbu',
                'pst',
                'prp',
                'prd',
                'ug',
                'ur',
                'ydd',
                'yds',
                'yih',
                'ji',
                'yi',
                'hbo',
                'men',
                'xmn',
                'fa',
                'jpr',
                'peo',
                'pes',
                'prs',
                'dv',
                'sam',
                'ckb',
            ],
                r = this.services?.languageUtils || new f0(b0());
            return l.toLowerCase().indexOf('-latn') > 1
                ? 'ltr'
                : s.indexOf(r.getLanguagePartFromCode(l)) > -1 ||
                    l.toLowerCase().indexOf('-arab') > 1
                    ? 'rtl'
                    : 'ltr';
        }
        static createInstance(l = {}, s) {
            return new sr(l, s);
        }
        cloneInstance(l = {}, s = cu) {
            const r = l.forkResourceStore;
            r && delete l.forkResourceStore;
            const u = { ...this.options, ...l, isClone: !0 },
                d = new sr(u);
            if (
                ((l.debug !== void 0 || l.prefix !== void 0) &&
                    (d.logger = d.logger.clone(l)),
                    ['store', 'services', 'language'].forEach(h => {
                        d[h] = this[h];
                    }),
                    (d.services = { ...this.services }),
                    (d.services.utils = {
                        hasLoadedNamespace: d.hasLoadedNamespace.bind(d),
                    }),
                    r)
            ) {
                const h = Object.keys(this.store.data).reduce(
                    (m, y) => (
                        (m[y] = { ...this.store.data[y] }),
                        (m[y] = Object.keys(m[y]).reduce(
                            (E, v) => ((E[v] = { ...m[y][v] }), E),
                            m[y]
                        )),
                        m
                    ),
                    {}
                );
                ((d.store = new u0(h, u)), (d.services.resourceStore = d.store));
            }
            return (
                (d.translator = new gu(d.services, u)),
                d.translator.on('*', (h, ...m) => {
                    d.emit(h, ...m);
                }),
                d.init(u, s),
                (d.translator.options = u),
                (d.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: d.hasLoadedNamespace.bind(d),
                }),
                d
            );
        }
        toJSON() {
            return {
                options: this.options,
                store: this.store,
                language: this.language,
                languages: this.languages,
                resolvedLanguage: this.resolvedLanguage,
            };
        }
    }
    const Eu = sr.createInstance();
    Eu.createInstance = sr.createInstance;
    const cE = (i, l, s, r) => {
        const u = [s, { code: l, ...(r || {}) }];
        if (i?.services?.logger?.forward)
            return i.services.logger.forward(u, 'warn', 'react-i18next::', !0);
        (hl(u[0]) && (u[0] = `react-i18next:: ${u[0]}`),
            i?.services?.logger?.warn
                ? i.services.logger.warn(...u)
                : console?.warn && console.warn(...u));
    },
        v0 = {},
        Dp = (i, l, s, r) => {
            (hl(s) && v0[s]) || (hl(s) && (v0[s] = new Date()), cE(i, l, s, r));
        },
        H0 = (i, l) => () => {
            if (i.isInitialized) l();
            else {
                const s = () => {
                    (setTimeout(() => {
                        i.off('initialized', s);
                    }, 0),
                        l());
                };
                i.on('initialized', s);
            }
        },
        Tp = (i, l, s) => {
            i.loadNamespaces(l, H0(i, s));
        },
        S0 = (i, l, s, r) => {
            if (
                (hl(s) && (s = [s]),
                    i.options.preload && i.options.preload.indexOf(l) > -1)
            )
                return Tp(i, s, r);
            (s.forEach(u => {
                i.options.ns.indexOf(u) < 0 && i.options.ns.push(u);
            }),
                i.loadLanguages(l, H0(i, r)));
        },
        uE = (i, l, s = {}) =>
            !l.languages || !l.languages.length
                ? (Dp(l, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
                    languages: l.languages,
                }),
                    !0)
                : l.hasLoadedNamespace(i, {
                    lng: s.lng,
                    precheck: (r, u) => {
                        if (
                            s.bindI18n &&
                            s.bindI18n.indexOf('languageChanging') > -1 &&
                            r.services.backendConnector.backend &&
                            r.isLanguageChangingTo &&
                            !u(r.isLanguageChangingTo, i)
                        )
                            return !1;
                    },
                }),
        hl = i => typeof i == 'string',
        dE = i => typeof i == 'object' && i !== null,
        fE =
            /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g,
        mE = {
            '&amp;': '&',
            '&#38;': '&',
            '&lt;': '<',
            '&#60;': '<',
            '&gt;': '>',
            '&#62;': '>',
            '&apos;': "'",
            '&#39;': "'",
            '&quot;': '"',
            '&#34;': '"',
            '&nbsp;': ' ',
            '&#160;': ' ',
            '&copy;': '©',
            '&#169;': '©',
            '&reg;': '®',
            '&#174;': '®',
            '&hellip;': '…',
            '&#8230;': '…',
            '&#x2F;': '/',
            '&#47;': '/',
        },
        pE = i => mE[i],
        hE = i => i.replace(fE, pE);
    let Cp = {
        bindI18n: 'languageChanged',
        bindI18nStore: '',
        transEmptyNodeValue: '',
        transSupportBasicHtmlNodes: !0,
        transWrapTextNodes: '',
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
        useSuspense: !0,
        unescape: hE,
    };
    const gE = (i = {}) => {
        Cp = { ...Cp, ...i };
    },
        bE = () => Cp;
    let U0;
    const yE = i => {
        U0 = i;
    },
        vE = () => U0,
        SE = {
            type: '3rdParty',
            init(i) {
                (gE(i.options.react), yE(i));
            },
        },
        G0 = $.createContext();
    class xE {
        constructor() {
            this.usedNamespaces = {};
        }
        addUsedNamespaces(l) {
            l.forEach(s => {
                this.usedNamespaces[s] || (this.usedNamespaces[s] = !0);
            });
        }
        getUsedNamespaces() {
            return Object.keys(this.usedNamespaces);
        }
    }
    const NE = (i, l) => {
        const s = $.useRef();
        return (
            $.useEffect(() => {
                s.current = i;
            }, [i, l]),
            s.current
        );
    },
        _0 = (i, l, s, r) => i.getFixedT(l, s, r),
        wE = (i, l, s, r) => $.useCallback(_0(i, l, s, r), [i, l, s, r]),
        ze = (i, l = {}) => {
            const { i18n: s } = l,
                { i18n: r, defaultNS: u } = $.useContext(G0) || {},
                d = s || r || vE();
            if (
                (d && !d.reportNamespaces && (d.reportNamespaces = new xE()), !d)
            ) {
                Dp(
                    d,
                    'NO_I18NEXT_INSTANCE',
                    'useTranslation: You will need to pass in an i18next instance by using initReactI18next'
                );
                const Z = (le, q) =>
                    hl(q)
                        ? q
                        : dE(q) && hl(q.defaultValue)
                            ? q.defaultValue
                            : Array.isArray(le)
                                ? le[le.length - 1]
                                : le,
                    P = [Z, {}, !1];
                return ((P.t = Z), (P.i18n = {}), (P.ready = !1), P);
            }
            d.options.react?.wait &&
                Dp(
                    d,
                    'DEPRECATED_OPTION',
                    'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.'
                );
            const p = { ...bE(), ...d.options.react, ...l },
                { useSuspense: h, keyPrefix: m } = p;
            let y = i || u || d.options?.defaultNS;
            ((y = hl(y) ? [y] : y || ['translation']),
                d.reportNamespaces.addUsedNamespaces?.(y));
            const E =
                (d.isInitialized || d.initializedStoreOnce) &&
                y.every(Z => uE(Z, d, p)),
                v = wE(d, l.lng || null, p.nsMode === 'fallback' ? y : y[0], m),
                N = () => v,
                S = () =>
                    _0(d, l.lng || null, p.nsMode === 'fallback' ? y : y[0], m),
                [D, O] = $.useState(N);
            let k = y.join();
            l.lng && (k = `${l.lng}${k}`);
            const _ = NE(k),
                I = $.useRef(!0);
            ($.useEffect(() => {
                const { bindI18n: Z, bindI18nStore: P } = p;
                ((I.current = !0),
                    !E &&
                    !h &&
                    (l.lng
                        ? S0(d, l.lng, y, () => {
                            I.current && O(S);
                        })
                        : Tp(d, y, () => {
                            I.current && O(S);
                        })),
                    E && _ && _ !== k && I.current && O(S));
                const le = () => {
                    I.current && O(S);
                };
                return (
                    Z && d?.on(Z, le),
                    P && d?.store.on(P, le),
                    () => {
                        ((I.current = !1),
                            d && Z && Z?.split(' ').forEach(q => d.off(q, le)),
                            P && d && P.split(' ').forEach(q => d.store.off(q, le)));
                    }
                );
            }, [d, k]),
                $.useEffect(() => {
                    I.current && E && O(N);
                }, [d, m, E]));
            const Y = [D, d, E];
            if (((Y.t = D), (Y.i18n = d), (Y.ready = E), E || (!E && !h)))
                return Y;
            throw new Promise(Z => {
                l.lng ? S0(d, l.lng, y, () => Z()) : Tp(d, y, () => Z());
            });
        };
    function EE({ i18n: i, defaultNS: l, children: s }) {
        const r = $.useMemo(() => ({ i18n: i, defaultNS: l }), [i, l]);
        return $.createElement(G0.Provider, { value: r }, s);
    }
    const AE = 'page_klbwq',
        DE = { page: AE };
    function $n(i = 768) {
        const l = `(max-width: ${i}px)`,
            [s, r] = $.useState(() =>
                typeof window > 'u' ? !1 : window.matchMedia(l).matches
            );
        return (
            $.useEffect(() => {
                const u = window.matchMedia(l),
                    d = () => r(u.matches);
                return (
                    d(),
                    u.addEventListener('change', d),
                    () => u.removeEventListener('change', d)
                );
            }, [l]),
            s
        );
    }
    function Au(i, l, s, r) {
        return i(r ? s : l);
    }
    const TE = 'badge_8sFrq',
        CE = 'title_Klsg0',
        RE = 'subtitle_-Ihim',
        ME = 'section1_rMyuL',
        OE = 'stickyHero_wyX5j',
        kE = 'overlaySection_I-8cA',
        jE = 'overlayContent_cwIjS',
        VE = 'heroBg_xfR9c',
        zE = 'initialContent_GadfP',
        BE = 'scrollTitle_VLWYk',
        LE = 'scrollSubtitle_OwsPT',
        Qn = {
            badge: TE,
            title: CE,
            subtitle: RE,
            section1: ME,
            stickyHero: OE,
            overlaySection: kE,
            overlayContent: jE,
            heroBg: VE,
            initialContent: zE,
            scrollTitle: BE,
            scrollSubtitle: LE,
        };
    function IE({ heroBg: i }) {
        const { t: l } = ze(),
            s = $.useRef(null),
            r = $.useRef(null),
            [u, d] = $.useState(0);
        $.useEffect(() => {
            const h = () => {
                const m = s.current,
                    y = r.current;
                if (!m || !y) return;
                const E = m.offsetHeight - y.offsetHeight;
                if (E <= 0) {
                    d(0);
                    return;
                }
                const v = Math.min(E, Math.max(0, -m.getBoundingClientRect().top));
                d(v / E);
            };
            return (
                h(),
                window.addEventListener('scroll', h, { passive: !0 }),
                window.addEventListener('resize', h),
                () => {
                    (window.removeEventListener('scroll', h),
                        window.removeEventListener('resize', h));
                }
            );
        }, []);
        const p = Math.max(0, 1 - u * 1.2);
        return b.jsxDEV(
            'section',
            {
                ref: s,
                className: Qn.section1,
                children: [
                    b.jsxDEV(
                        'div',
                        {
                            ref: r,
                            className: Qn.stickyHero,
                            children: [
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: Qn.heroBg,
                                        style: { backgroundImage: `url(${i})` },
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section1/index.tsx',
                                        lineNumber: 44,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: Qn.initialContent,
                                        style: { opacity: p },
                                        children: [
                                            b.jsxDEV(
                                                'span',
                                                {
                                                    className: Qn.badge,
                                                    children: l('section1.badge'),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section1/index.tsx',
                                                    lineNumber: 47,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'h1',
                                                {
                                                    className: Qn.title,
                                                    children: l('section1.title'),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section1/index.tsx',
                                                    lineNumber: 48,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'p',
                                                {
                                                    className: Qn.subtitle,
                                                    dangerouslySetInnerHTML: {
                                                        __html: l('section1.subtitle'),
                                                    },
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section1/index.tsx',
                                                    lineNumber: 49,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section1/index.tsx',
                                        lineNumber: 46,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section1/index.tsx',
                            lineNumber: 43,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: Qn.overlaySection,
                            children: b.jsxDEV(
                                'div',
                                {
                                    className: Qn.overlayContent,
                                    children: [
                                        b.jsxDEV(
                                            'p',
                                            {
                                                className: Qn.scrollTitle,
                                                dangerouslySetInnerHTML: {
                                                    __html: l('section1.scrollTitle'),
                                                },
                                            },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section1/index.tsx',
                                                lineNumber: 58,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                        b.jsxDEV(
                                            'p',
                                            {
                                                className: Qn.scrollSubtitle,
                                                dangerouslySetInnerHTML: {
                                                    __html: l('section1.scrollSubtitle'),
                                                },
                                            },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section1/index.tsx',
                                                lineNumber: 62,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                    ],
                                },
                                void 0,
                                !0,
                                {
                                    fileName:
                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section1/index.tsx',
                                    lineNumber: 57,
                                    columnNumber: 9,
                                },
                                this
                            ),
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section1/index.tsx',
                            lineNumber: 56,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section1/index.tsx',
                lineNumber: 42,
                columnNumber: 5,
            },
            this
        );
    }
    function HE() {
        const { t: i } = ze('imageUrl'),
            l = $n(),
            s = Au(i, 'heroBg', 'heroBgMobile', l);
        return b.jsxDEV(
            IE,
            { heroBg: s },
            void 0,
            !1,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section1/index.tsx',
                lineNumber: 77,
                columnNumber: 10,
            },
            this
        );
    }
    const Qt = ({ name: i, className: l = '', style: s, size: r, ...u }) => {
        const d = { lineHeight: '1', fontSize: r, ...s };
        return b.jsxDEV(
            'i',
            {
                className: `creality-product-info-iconfont ${i} ${l}`,
                style: d,
                ...u,
            },
            void 0,
            !1,
            {
                fileName:
                    'D:/works/creality-offical-product/src/components/Icon.tsx',
                lineNumber: 29,
                columnNumber: 5,
            },
            void 0
        );
    };
      /*! lozad.js - v1.16.0 - 2020-09-06
       * https://github.com/ApoorvSaxena/lozad.js
       * Copyright (c) 2020 Apoorv Saxena; Licensed MIT */ const UE =
        typeof document < 'u' && document.documentMode,
        GE = {
            rootMargin: '0px',
            threshold: 0,
            load(i) {
                if (i.nodeName.toLowerCase() === 'picture') {
                    let s = i.querySelector('img'),
                        r = !1;
                    (s === null && ((s = document.createElement('img')), (r = !0)),
                        UE &&
                        i.getAttribute('data-iesrc') &&
                        (s.src = i.getAttribute('data-iesrc')),
                        i.getAttribute('data-alt') &&
                        (s.alt = i.getAttribute('data-alt')),
                        r && i.append(s));
                }
                if (
                    i.nodeName.toLowerCase() === 'video' &&
                    !i.getAttribute('data-src') &&
                    i.children
                ) {
                    const s = i.children;
                    let r;
                    for (let u = 0; u <= s.length - 1; u++)
                        ((r = s[u].getAttribute('data-src')), r && (s[u].src = r));
                    i.load();
                }
                (i.getAttribute('data-poster') &&
                    (i.poster = i.getAttribute('data-poster')),
                    i.getAttribute('data-src') &&
                    (i.src = i.getAttribute('data-src')),
                    i.getAttribute('data-srcset') &&
                    i.setAttribute('srcset', i.getAttribute('data-srcset')));
                let l = ',';
                if (
                    (i.getAttribute('data-background-delimiter') &&
                        (l = i.getAttribute('data-background-delimiter')),
                        i.getAttribute('data-background-image'))
                )
                    i.style.backgroundImage = `url('${i.getAttribute('data-background-image').split(l).join("'),url('")}')`;
                else if (i.getAttribute('data-background-image-set')) {
                    const s = i.getAttribute('data-background-image-set').split(l);
                    let r = s[0].substr(0, s[0].indexOf(' ')) || s[0];
                    ((r = r.indexOf('url(') === -1 ? `url(${r})` : r),
                        s.length === 1
                            ? (i.style.backgroundImage = r)
                            : i.setAttribute(
                                'style',
                                (i.getAttribute('style') || '') +
                                `background-image: ${r}; background-image: -webkit-image-set(${s}); background-image: image-set(${s})`
                            ));
                }
                i.getAttribute('data-toggle-class') &&
                    i.classList.toggle(i.getAttribute('data-toggle-class'));
            },
            loaded() { },
        };
    function Rp(i) {
        i.setAttribute('data-loaded', !0);
    }
    function _E(i) {
        i.getAttribute('data-placeholder-background') &&
            (i.style.background = i.getAttribute('data-placeholder-background'));
    }
    const Mp = i => i.getAttribute('data-loaded') === 'true',
        YE = (i, l) => (s, r) => {
            s.forEach(u => {
                (u.intersectionRatio > 0 || u.isIntersecting) &&
                    (r.unobserve(u.target),
                        Mp(u.target) || (i(u.target), Rp(u.target), l(u.target)));
            });
        },
        x0 = (i, l = document) =>
            i instanceof Element
                ? [i]
                : i instanceof NodeList
                    ? i
                    : l.querySelectorAll(i);
    function PE(i = '.lozad', l = {}) {
        const {
            root: s,
            rootMargin: r,
            threshold: u,
            load: d,
            loaded: p,
        } = Object.assign({}, GE, l);
        let h;
        typeof window < 'u' &&
            window.IntersectionObserver &&
            (h = new IntersectionObserver(YE(d, p), {
                root: s,
                rootMargin: r,
                threshold: u,
            }));
        const m = x0(i, s);
        for (let y = 0; y < m.length; y++) _E(m[y]);
        return {
            observe() {
                const y = x0(i, s);
                for (let E = 0; E < y.length; E++)
                    if (!Mp(y[E])) {
                        if (h) {
                            h.observe(y[E]);
                            continue;
                        }
                        (d(y[E]), Rp(y[E]), p(y[E]));
                    }
            },
            triggerLoad(y) {
                Mp(y) || (d(y), Rp(y), p(y));
            },
            observer: h,
        };
    }
    const ZE = 'safaImage_VwBX8',
        WE = { safaImage: ZE };
    function Y0(...i) {
        const l = [];
        for (const s of i)
            if (s) {
                if (typeof s == 'string' || typeof s == 'number') l.push(s);
                else if (Array.isArray(s)) {
                    const r = Y0(...s);
                    r && l.push(r);
                } else if (typeof s == 'object')
                    for (const r in s) s.hasOwnProperty(r) && s[r] && l.push(r);
            }
        return l.join(' ');
    }
    const XE = () => {
        if (typeof window > 'u') {
            const i = globalThis.__SSR_LANG__;
            if (i) return i;
        }
        if (typeof window < 'u') {
            const i = window.location.pathname.match(/\/([^\/]+)\/?$/),
                l = i ? i[1] : '';
            return [
                'cn',
                'en',
                'br',
                'de',
                'es',
                'fr',
                'it',
                'jp',
                'kr',
                'ru',
                'au',
                'ar',
                'mx',
            ].includes(l)
                ? l
                : 'en';
        }
        return 'en';
    };
    function Ut({
        src: i,
        fallback: l,
        showFallbackText: s = !0,
        aspectRatio: r,
        alt: u = '',
        enableLazyLoad: d = !1,
        rootMargin: p = '400px',
        threshold: h = 0,
        ...m
    }) {
        const [y, E] = $.useState(!1),
            [v, N] = $.useState(!1),
            S = $.useRef(null);
        ($.useEffect(() => {
            N(!0);
        }, []),
            $.useEffect(() => {
                E(!1);
            }, [i]),
            $.useEffect(
                () =>
                    !d || !v || !S.current
                        ? void 0
                        : (PE(S.current, {
                            rootMargin: p,
                            threshold: h,
                            loaded: I => {
                                I.classList.add('lozad-loaded');
                            },
                        }).observe(),
                            () => { }),
                [v, d, p, h, i]
            ));
        let D = i;
        (typeof D == 'object' && D !== null && 'src' in D && (D = D.src),
            typeof D == 'string' && D.startsWith('//') && (D = 'https:' + D));
        const O = typeof D == 'string' && D.trim() !== '',
            k = b.jsxDEV(
                'div',
                {
                    style: {
                        width: m.width || '100%',
                        height: m.height || '100%',
                        aspectRatio: r,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(243,244,246)',
                        ...m.style,
                    },
                    children: b.jsxDEV(
                        Qt,
                        {
                            name: 'icon-zhanweifu',
                            style: {
                                fontSize: '36px',
                                lineHeight: '40px',
                                color: 'rgba(156,163,175)',
                                opacity: 0.2,
                            },
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/components/SafaImage/index.tsx',
                            lineNumber: 91,
                            columnNumber: 7,
                        },
                        this
                    ),
                },
                void 0,
                !1,
                {
                    fileName:
                        'D:/works/creality-offical-product/src/components/SafaImage/index.tsx',
                    lineNumber: 78,
                    columnNumber: 5,
                },
                this
            );
        return O
            ? v && y
                ? l
                    ? b.jsxDEV(
                        b.Fragment,
                        { children: l },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/components/SafaImage/index.tsx',
                            lineNumber: 119,
                            columnNumber: 14,
                        },
                        this
                    )
                    : s
                        ? k
                        : null
                : b.jsxDEV(
                    'img',
                    {
                        ref: S,
                        'data-src': d ? D : void 0,
                        src: d ? void 0 : D,
                        alt: u || '',
                        className: Y0('lozad', WE.safaImage, m.className),
                        onError: () => E(!0),
                        ...m,
                        style: {
                            ...(m.width ? { width: m.width } : {}),
                            ...(m.height ? { height: m.height } : {}),
                            ...(r ? { aspectRatio: r } : {}),
                            objectFit: 'cover',
                            display: 'block',
                            ...m.style,
                        },
                    },
                    void 0,
                    !1,
                    {
                        fileName:
                            'D:/works/creality-offical-product/src/components/SafaImage/index.tsx',
                        lineNumber: 131,
                        columnNumber: 5,
                    },
                    this
                )
            : l
                ? b.jsxDEV(
                    b.Fragment,
                    { children: l },
                    void 0,
                    !1,
                    {
                        fileName:
                            'D:/works/creality-offical-product/src/components/SafaImage/index.tsx',
                        lineNumber: 106,
                        columnNumber: 14,
                    },
                    this
                )
                : s
                    ? k
                    : null;
    }
    const QE = 'section2_RMzUF',
        JE = 'title_nHX6n',
        qE = 'mbGrid_K2rZE',
        $E = 'mbLaserModules_z2bUb',
        FE = 'mbRowTall_MmxAK',
        KE = 'mbRowLifting_1e3yj',
        eA = 'mbRowCamera_c3dvR',
        tA = 'mbAutoFocus_illT-',
        nA = 'mbLifting_dYINt',
        aA = 'mbAiCamera_QhCJ8',
        iA = 'mbHighSpeed_jgBiO',
        lA = 'mbAiExperience_eVwdz',
        oA = 'mbRightCol_ECPe0',
        sA = 'mbIoT_u3mIm',
        rA = 'mbSafety_CtEjk',
        cA = 'safetyTitle_vnAIi',
        uA = 'class1_n2yf9',
        dA = 'cardTitle_gMc3c',
        fA = 'cardAccent_oub2I',
        mA = 'iotTitle_poj6Z',
        pA = 'aiCameraDesc_6tnel',
        hA = 'iotDesc_BTuTy',
        gA = 'workingAreaLabel_6jdn1',
        bA = 'workingAreaValue_WV4ng',
        yA = 'upTo_jy67B',
        vA = 'speedNum_NDQ9d',
        SA = 'speedUnit_wzpfL',
        xA = 'aiExperienceTitle_sHP1z',
        NA = 'laserBadge_GHUlh',
        wA = 'laserModulesTitle_XG68K',
        EA = 'laserRow_-TmLG',
        AA = 'laserPower_VOXu2',
        DA = 'laserType_wkGNi',
        TA = 'materialsIcon_C22mS',
        CA = 'materialsLabel_k9Ltm',
        RA = 'grid_Z9hKT',
        MA = 'colLeft_Fv-eg',
        OA = 'colMiddle_9NqRO',
        kA = 'colRight_hiXYS',
        jA = 'cardAutoFocus_abFzY',
        VA = 'cardLifting_VX44X',
        zA = 'cardLaserModules_JzEqN',
        BA = 'materialsBlock_-1xya',
        LA = 'bottomRow_wBo7x',
        IA = 'bottomLeft_gEpK0',
        HA = 'cardSafety_UfDVk',
        UA = 'cardIoT_jkRsq',
        GA = 'cardAiCamera_Oummn',
        _A = 'cardHighSpeed_G2S3e',
        YA = 'cardAiExperience_4Y10E',
        PA = 'workingArea_BvQMe',
        ZA = 'speedBlock_-V74l',
        WA = 'speedValue_NUxdl',
        ne = {
            section2: QE,
            title: JE,
            mbGrid: qE,
            mbLaserModules: $E,
            mbRowTall: FE,
            mbRowLifting: KE,
            mbRowCamera: eA,
            mbAutoFocus: tA,
            mbLifting: nA,
            mbAiCamera: aA,
            mbHighSpeed: iA,
            mbAiExperience: lA,
            mbRightCol: oA,
            mbIoT: sA,
            mbSafety: rA,
            safetyTitle: cA,
            class1: uA,
            cardTitle: dA,
            cardAccent: fA,
            iotTitle: mA,
            aiCameraDesc: pA,
            iotDesc: hA,
            workingAreaLabel: gA,
            workingAreaValue: bA,
            upTo: yA,
            speedNum: vA,
            speedUnit: SA,
            aiExperienceTitle: xA,
            laserBadge: NA,
            laserModulesTitle: wA,
            laserRow: EA,
            laserPower: AA,
            laserType: DA,
            materialsIcon: TA,
            materialsLabel: CA,
            grid: RA,
            colLeft: MA,
            colMiddle: OA,
            colRight: kA,
            cardAutoFocus: jA,
            cardLifting: VA,
            cardLaserModules: zA,
            materialsBlock: BA,
            bottomRow: LA,
            bottomLeft: IA,
            cardSafety: HA,
            cardIoT: UA,
            cardAiCamera: GA,
            cardHighSpeed: _A,
            cardAiExperience: YA,
            workingArea: PA,
            speedBlock: ZA,
            speedValue: WA,
        };
    function XA() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            s = $n(),
            r = [
                { power: 'section2.laser5w', type: 'section2.laser5wType' },
                { power: 'section2.laser10w', type: 'section2.laser10wType' },
                { power: 'section2.laserIR', type: 'section2.laserIRType' },
            ],
            u = p => ({ backgroundImage: `url(${l(p)})` }),
            d = Au(l, 'materialsIcon', 'materialsIcon', s);
        return s
            ? b.jsxDEV(
                'section',
                {
                    className: ne.section2,
                    children: [
                        b.jsxDEV(
                            'h2',
                            { className: ne.title, children: i('section2.title') },
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                lineNumber: 27,
                                columnNumber: 9,
                            },
                            this
                        ),
                        b.jsxDEV(
                            'div',
                            {
                                className: ne.mbGrid,
                                children: [
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ne.mbLaserModules,
                                            style: u('highlight2'),
                                            children: [
                                                b.jsxDEV(
                                                    'h3',
                                                    {
                                                        className: ne.laserModulesTitle,
                                                        children: i('section2.laserModulesTitle'),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 31,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.laserRow,
                                                        children: r.map(p =>
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ne.laserBadge,
                                                                    children: [
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.laserPower,
                                                                                children: i(p.power),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 35,
                                                                                columnNumber: 19,
                                                                            },
                                                                            this
                                                                        ),
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.laserType,
                                                                                children: i(p.type),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 36,
                                                                                columnNumber: 19,
                                                                            },
                                                                            this
                                                                        ),
                                                                    ],
                                                                },
                                                                p.power,
                                                                !0,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 34,
                                                                    columnNumber: 17,
                                                                },
                                                                this
                                                            )
                                                        ),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 32,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.materialsBlock,
                                                        children: [
                                                            b.jsxDEV(
                                                                Ut,
                                                                {
                                                                    className: ne.materialsIcon,
                                                                    src: d,
                                                                    alt: '',
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 41,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: ne.materialsLabel,
                                                                    children: i('section2.materials'),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 42,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 40,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                            lineNumber: 30,
                                            columnNumber: 11,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ne.mbRowTall,
                                            children: [
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.mbAutoFocus,
                                                        style: u('highlight1'),
                                                        children: b.jsxDEV(
                                                            'span',
                                                            {
                                                                className: ne.cardTitle,
                                                                children: i('section2.autoFocus'),
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                lineNumber: 48,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 47,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.mbHighSpeed,
                                                        style: u('highlight3'),
                                                        children: [
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: ne.cardTitle,
                                                                    children: i('section2.highSpeed'),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 51,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ne.speedBlock,
                                                                    children: b.jsxDEV(
                                                                        'div',
                                                                        {
                                                                            className: ne.speedValue,
                                                                            children: [
                                                                                b.jsxDEV(
                                                                                    'span',
                                                                                    {
                                                                                        className: ne.upTo,
                                                                                        children: i('section2.upTo'),
                                                                                    },
                                                                                    void 0,
                                                                                    !1,
                                                                                    {
                                                                                        fileName:
                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                        lineNumber: 54,
                                                                                        columnNumber: 19,
                                                                                    },
                                                                                    this
                                                                                ),
                                                                                b.jsxDEV(
                                                                                    'span',
                                                                                    {
                                                                                        className: ne.speedNum,
                                                                                        children: i(
                                                                                            'section2.speedValue'
                                                                                        ),
                                                                                    },
                                                                                    void 0,
                                                                                    !1,
                                                                                    {
                                                                                        fileName:
                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                        lineNumber: 55,
                                                                                        columnNumber: 19,
                                                                                    },
                                                                                    this
                                                                                ),
                                                                                b.jsxDEV(
                                                                                    'span',
                                                                                    {
                                                                                        className: ne.speedUnit,
                                                                                        children:
                                                                                            i('section2.speedUnit'),
                                                                                    },
                                                                                    void 0,
                                                                                    !1,
                                                                                    {
                                                                                        fileName:
                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                        lineNumber: 56,
                                                                                        columnNumber: 19,
                                                                                    },
                                                                                    this
                                                                                ),
                                                                            ],
                                                                        },
                                                                        void 0,
                                                                        !0,
                                                                        {
                                                                            fileName:
                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                            lineNumber: 53,
                                                                            columnNumber: 17,
                                                                        },
                                                                        this
                                                                    ),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 52,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 50,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                            lineNumber: 46,
                                            columnNumber: 11,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ne.mbRowLifting,
                                            children: [
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.mbLifting,
                                                        style: u('highlight4'),
                                                        children: [
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: ne.cardAccent,
                                                                    children: i('section2.liftingPlatform'),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 64,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ne.workingArea,
                                                                    children: [
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.workingAreaLabel,
                                                                                children: i(
                                                                                    'section2.workingAreaLabel'
                                                                                ),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 66,
                                                                                columnNumber: 17,
                                                                            },
                                                                            this
                                                                        ),
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.workingAreaValue,
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: i(
                                                                                        'section2.workingAreaValue'
                                                                                    ),
                                                                                },
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 67,
                                                                                columnNumber: 17,
                                                                            },
                                                                            this
                                                                        ),
                                                                    ],
                                                                },
                                                                void 0,
                                                                !0,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 65,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 63,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.mbAiExperience,
                                                        style: u('highlight8'),
                                                        children: b.jsxDEV(
                                                            'div',
                                                            {
                                                                className: ne.aiExperienceTitle,
                                                                children: [
                                                                    b.jsxDEV(
                                                                        'span',
                                                                        {
                                                                            className: ne.cardAccent,
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: i('section2.aiPowered'),
                                                                            },
                                                                        },
                                                                        void 0,
                                                                        !1,
                                                                        {
                                                                            fileName:
                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                            lineNumber: 75,
                                                                            columnNumber: 17,
                                                                        },
                                                                        this
                                                                    ),
                                                                    b.jsxDEV(
                                                                        'span',
                                                                        {
                                                                            children: i(
                                                                                'section2.smartExperience'
                                                                            ),
                                                                        },
                                                                        void 0,
                                                                        !1,
                                                                        {
                                                                            fileName:
                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                            lineNumber: 79,
                                                                            columnNumber: 17,
                                                                        },
                                                                        this
                                                                    ),
                                                                ],
                                                            },
                                                            void 0,
                                                            !0,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                lineNumber: 74,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 73,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                            lineNumber: 62,
                                            columnNumber: 11,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ne.mbRowCamera,
                                            children: [
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.mbAiCamera,
                                                        style: u('highlight7'),
                                                        children: [
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: ne.cardAccent,
                                                                    children: i('section2.aiCamera'),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 86,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: ne.aiCameraDesc,
                                                                    children: i('section2.aiCameraDesc'),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 87,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 85,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.mbRightCol,
                                                        children: [
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ne.mbIoT,
                                                                    style: u('highlight6'),
                                                                    children: [
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.iotTitle,
                                                                                children: i('section2.smartIoT'),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 91,
                                                                                columnNumber: 17,
                                                                            },
                                                                            this
                                                                        ),
                                                                        b.jsxDEV(
                                                                            'p',
                                                                            {
                                                                                className: ne.iotDesc,
                                                                                children: i(
                                                                                    'section2.smartIoTDesc'
                                                                                ),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 92,
                                                                                columnNumber: 17,
                                                                            },
                                                                            this
                                                                        ),
                                                                    ],
                                                                },
                                                                void 0,
                                                                !0,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 90,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ne.mbSafety,
                                                                    style: u('highlight5'),
                                                                    children: [
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.safetyTitle,
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: i(
                                                                                        'section2.laserSafety'
                                                                                    ),
                                                                                },
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 95,
                                                                                columnNumber: 17,
                                                                            },
                                                                            this
                                                                        ),
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.class1,
                                                                                children: i('section2.class1'),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 99,
                                                                                columnNumber: 17,
                                                                            },
                                                                            this
                                                                        ),
                                                                    ],
                                                                },
                                                                void 0,
                                                                !0,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 94,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 89,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                            lineNumber: 84,
                                            columnNumber: 11,
                                        },
                                        this
                                    ),
                                ],
                            },
                            void 0,
                            !0,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                lineNumber: 29,
                                columnNumber: 9,
                            },
                            this
                        ),
                    ],
                },
                void 0,
                !0,
                {
                    fileName:
                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                    lineNumber: 26,
                    columnNumber: 7,
                },
                this
            )
            : b.jsxDEV(
                'section',
                {
                    className: ne.section2,
                    children: [
                        b.jsxDEV(
                            'h2',
                            { className: ne.title, children: i('section2.title') },
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                lineNumber: 110,
                                columnNumber: 7,
                            },
                            this
                        ),
                        b.jsxDEV(
                            'div',
                            {
                                className: ne.grid,
                                children: [
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ne.colLeft,
                                            children: [
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.cardAutoFocus,
                                                        style: u('highlight1'),
                                                        children: b.jsxDEV(
                                                            'span',
                                                            {
                                                                className: ne.cardTitle,
                                                                children: i('section2.autoFocus'),
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                lineNumber: 115,
                                                                columnNumber: 13,
                                                            },
                                                            this
                                                        ),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 114,
                                                        columnNumber: 11,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.cardLifting,
                                                        style: u('highlight4'),
                                                        children: [
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: ne.cardAccent,
                                                                    children: i('section2.liftingPlatform'),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 118,
                                                                    columnNumber: 13,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ne.workingArea,
                                                                    children: [
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.workingAreaLabel,
                                                                                children: i(
                                                                                    'section2.workingAreaLabel'
                                                                                ),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 120,
                                                                                columnNumber: 15,
                                                                            },
                                                                            this
                                                                        ),
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.workingAreaValue,
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: i(
                                                                                        'section2.workingAreaValue'
                                                                                    ),
                                                                                },
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 121,
                                                                                columnNumber: 15,
                                                                            },
                                                                            this
                                                                        ),
                                                                    ],
                                                                },
                                                                void 0,
                                                                !0,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 119,
                                                                    columnNumber: 13,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 117,
                                                        columnNumber: 11,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                            lineNumber: 113,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ne.colMiddle,
                                            children: [
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.cardLaserModules,
                                                        style: u('highlight2'),
                                                        children: [
                                                            b.jsxDEV(
                                                                'h3',
                                                                {
                                                                    className: ne.laserModulesTitle,
                                                                    children: i(
                                                                        'section2.laserModulesTitle'
                                                                    ),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 131,
                                                                    columnNumber: 13,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ne.laserRow,
                                                                    children: r.map(p =>
                                                                        b.jsxDEV(
                                                                            'div',
                                                                            {
                                                                                className: ne.laserBadge,
                                                                                children: [
                                                                                    b.jsxDEV(
                                                                                        'span',
                                                                                        {
                                                                                            className: ne.laserPower,
                                                                                            children: i(p.power),
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                            lineNumber: 135,
                                                                                            columnNumber: 19,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                    b.jsxDEV(
                                                                                        'span',
                                                                                        {
                                                                                            className: ne.laserType,
                                                                                            children: i(p.type),
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                            lineNumber: 136,
                                                                                            columnNumber: 19,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                ],
                                                                            },
                                                                            p.power,
                                                                            !0,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 134,
                                                                                columnNumber: 17,
                                                                            },
                                                                            this
                                                                        )
                                                                    ),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 132,
                                                                    columnNumber: 13,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ne.materialsBlock,
                                                                    children: [
                                                                        b.jsxDEV(
                                                                            Ut,
                                                                            {
                                                                                className: ne.materialsIcon,
                                                                                src: d,
                                                                                alt: '',
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 141,
                                                                                columnNumber: 15,
                                                                            },
                                                                            this
                                                                        ),
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.materialsLabel,
                                                                                children: i('section2.materials'),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 142,
                                                                                columnNumber: 15,
                                                                            },
                                                                            this
                                                                        ),
                                                                    ],
                                                                },
                                                                void 0,
                                                                !0,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 140,
                                                                    columnNumber: 13,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 130,
                                                        columnNumber: 11,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.bottomRow,
                                                        children: [
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ne.bottomLeft,
                                                                    children: [
                                                                        b.jsxDEV(
                                                                            'div',
                                                                            {
                                                                                className: ne.cardSafety,
                                                                                style: u('highlight5'),
                                                                                children: [
                                                                                    b.jsxDEV(
                                                                                        'span',
                                                                                        {
                                                                                            className: ne.safetyTitle,
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: i(
                                                                                                    'section2.laserSafety'
                                                                                                ),
                                                                                            },
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                            lineNumber: 149,
                                                                                            columnNumber: 17,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                    b.jsxDEV(
                                                                                        'span',
                                                                                        {
                                                                                            className: ne.class1,
                                                                                            children:
                                                                                                i('section2.class1'),
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                            lineNumber: 153,
                                                                                            columnNumber: 17,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                ],
                                                                            },
                                                                            void 0,
                                                                            !0,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 148,
                                                                                columnNumber: 15,
                                                                            },
                                                                            this
                                                                        ),
                                                                        b.jsxDEV(
                                                                            'div',
                                                                            {
                                                                                className: ne.cardIoT,
                                                                                style: u('highlight6'),
                                                                                children: [
                                                                                    b.jsxDEV(
                                                                                        'span',
                                                                                        {
                                                                                            className: ne.iotTitle,
                                                                                            children:
                                                                                                i('section2.smartIoT'),
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                            lineNumber: 156,
                                                                                            columnNumber: 17,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                    b.jsxDEV(
                                                                                        'p',
                                                                                        {
                                                                                            className: ne.iotDesc,
                                                                                            children: i(
                                                                                                'section2.smartIoTDesc'
                                                                                            ),
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                            lineNumber: 157,
                                                                                            columnNumber: 17,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                ],
                                                                            },
                                                                            void 0,
                                                                            !0,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 155,
                                                                                columnNumber: 15,
                                                                            },
                                                                            this
                                                                        ),
                                                                    ],
                                                                },
                                                                void 0,
                                                                !0,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 147,
                                                                    columnNumber: 13,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ne.cardAiCamera,
                                                                    style: u('highlight7'),
                                                                    children: [
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.cardAccent,
                                                                                children: i('section2.aiCamera'),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 161,
                                                                                columnNumber: 15,
                                                                            },
                                                                            this
                                                                        ),
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.aiCameraDesc,
                                                                                children: i(
                                                                                    'section2.aiCameraDesc'
                                                                                ),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 162,
                                                                                columnNumber: 15,
                                                                            },
                                                                            this
                                                                        ),
                                                                    ],
                                                                },
                                                                void 0,
                                                                !0,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 160,
                                                                    columnNumber: 13,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 146,
                                                        columnNumber: 11,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                            lineNumber: 129,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ne.colRight,
                                            children: [
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.cardHighSpeed,
                                                        style: u('highlight3'),
                                                        children: [
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: ne.cardTitle,
                                                                    children: i('section2.highSpeed'),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 169,
                                                                    columnNumber: 13,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ne.speedBlock,
                                                                    children: [
                                                                        b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ne.upTo,
                                                                                children: i('section2.upTo'),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 171,
                                                                                columnNumber: 15,
                                                                            },
                                                                            this
                                                                        ),
                                                                        b.jsxDEV(
                                                                            'div',
                                                                            {
                                                                                className: ne.speedValue,
                                                                                children: [
                                                                                    b.jsxDEV(
                                                                                        'span',
                                                                                        {
                                                                                            className: ne.speedNum,
                                                                                            children: i(
                                                                                                'section2.speedValue'
                                                                                            ),
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                            lineNumber: 173,
                                                                                            columnNumber: 17,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                    b.jsxDEV(
                                                                                        'span',
                                                                                        {
                                                                                            className: ne.speedUnit,
                                                                                            children:
                                                                                                i('section2.speedUnit'),
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                            lineNumber: 174,
                                                                                            columnNumber: 17,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                ],
                                                                            },
                                                                            void 0,
                                                                            !0,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                                lineNumber: 172,
                                                                                columnNumber: 15,
                                                                            },
                                                                            this
                                                                        ),
                                                                    ],
                                                                },
                                                                void 0,
                                                                !0,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                    lineNumber: 170,
                                                                    columnNumber: 13,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 168,
                                                        columnNumber: 11,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ne.cardAiExperience,
                                                        style: u('highlight8'),
                                                        children: b.jsxDEV(
                                                            'div',
                                                            {
                                                                className: ne.aiExperienceTitle,
                                                                children: [
                                                                    b.jsxDEV(
                                                                        'span',
                                                                        {
                                                                            className: ne.cardAccent,
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: i('section2.aiPowered'),
                                                                            },
                                                                        },
                                                                        void 0,
                                                                        !1,
                                                                        {
                                                                            fileName:
                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                            lineNumber: 180,
                                                                            columnNumber: 15,
                                                                        },
                                                                        this
                                                                    ),
                                                                    b.jsxDEV(
                                                                        'span',
                                                                        {
                                                                            children: i(
                                                                                'section2.smartExperience'
                                                                            ),
                                                                        },
                                                                        void 0,
                                                                        !1,
                                                                        {
                                                                            fileName:
                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                            lineNumber: 184,
                                                                            columnNumber: 15,
                                                                        },
                                                                        this
                                                                    ),
                                                                ],
                                                            },
                                                            void 0,
                                                            !0,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                                lineNumber: 179,
                                                                columnNumber: 13,
                                                            },
                                                            this
                                                        ),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                                        lineNumber: 178,
                                                        columnNumber: 11,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                            lineNumber: 167,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                ],
                            },
                            void 0,
                            !0,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                                lineNumber: 112,
                                columnNumber: 7,
                            },
                            this
                        ),
                    ],
                },
                void 0,
                !0,
                {
                    fileName:
                        'D:/works/creality-offical-product/src/pages/A1C/components/Section2/index.tsx',
                    lineNumber: 109,
                    columnNumber: 5,
                },
                this
            );
    }
    const QA = 'section3_3pMMG',
        JA = 'title_CtuPS',
        qA = 'subtitle_GUihv',
        $A = 'list_Zzaui',
        FA = 'row_QLaCD',
        KA = 'image_rYNaF',
        eD = 'text_2Yr5g',
        Ti = {
            section3: QA,
            title: JA,
            subtitle: qA,
            list: $A,
            row: FA,
            image: KA,
            text: eD,
        },
        N0 = ['scenario1', 'scenario2', 'scenario3', 'scenario4'];
    function tD() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            s = i('section3.scenarios', { returnObjects: !0 });
        return b.jsxDEV(
            'section',
            {
                className: Ti.section3,
                children: [
                    b.jsxDEV(
                        'h2',
                        { className: Ti.title, children: i('section3.title') },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section3/index.tsx',
                            lineNumber: 18,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'p',
                        { className: Ti.subtitle, children: i('section3.subtitle') },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section3/index.tsx',
                            lineNumber: 19,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: Ti.list,
                            children: s.map((r, u) =>
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: Ti.row,
                                        style: { backgroundColor: r.bgColor },
                                        'data-reverse': r.imagePosition === 'left',
                                        children: [
                                            r.imagePosition === 'left' &&
                                            b.jsxDEV(
                                                'div',
                                                {
                                                    className: Ti.image,
                                                    style: { backgroundImage: `url(${l(N0[u])})` },
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section3/index.tsx',
                                                    lineNumber: 29,
                                                    columnNumber: 15,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'div',
                                                {
                                                    className: Ti.text,
                                                    children: [
                                                        b.jsxDEV(
                                                            'h3',
                                                            {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: r.title,
                                                                },
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section3/index.tsx',
                                                                lineNumber: 35,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                        b.jsxDEV(
                                                            'p',
                                                            {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: r.description,
                                                                },
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section3/index.tsx',
                                                                lineNumber: 36,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                    ],
                                                },
                                                void 0,
                                                !0,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section3/index.tsx',
                                                    lineNumber: 34,
                                                    columnNumber: 13,
                                                },
                                                this
                                            ),
                                            r.imagePosition === 'right' &&
                                            b.jsxDEV(
                                                'div',
                                                {
                                                    className: Ti.image,
                                                    style: { backgroundImage: `url(${l(N0[u])})` },
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section3/index.tsx',
                                                    lineNumber: 39,
                                                    columnNumber: 15,
                                                },
                                                this
                                            ),
                                        ],
                                    },
                                    u,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section3/index.tsx',
                                        lineNumber: 22,
                                        columnNumber: 11,
                                    },
                                    this
                                )
                            ),
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section3/index.tsx',
                            lineNumber: 20,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section3/index.tsx',
                lineNumber: 17,
                columnNumber: 5,
            },
            this
        );
    }
    const nD = 'carousel_d4d-Z',
        aD = 'media_EDrkO',
        iD = 'mediaInner_QGqES',
        lD = 'mediaAsset_5ZHYL',
        oD = 'mediaPlaceholder_aqVTr',
        sD = 'swapDecor_ZJkwZ',
        rD = 'swapArrowLeft_jeZ-w',
        cD = 'swapArrowCenter_qheTZ',
        uD = 'swapArrowRight_r7luV',
        dD = 'mediaNavBtn_oTUhn',
        fD = 'mediaNavBtnPrev_N2wfT',
        mD = 'mediaNavBtnNext_4yF5w',
        pD = 'panel_-fB-g',
        hD = 'sideBtn_HTiJq',
        gD = 'sideBtnLeft_SGAE5',
        bD = 'sidePill_lqANL',
        yD = 'sidePlus_9gn2i',
        vD = 'sideBtnRight_sioAq',
        SD = 'sideBtnDisabled_W6t8H',
        xD = 'card_HMZMb',
        ND = 'cardTitle_rQcuU',
        wD = 'cardDesc_Fl7Sn',
        $e = {
            carousel: nD,
            media: aD,
            mediaInner: iD,
            mediaAsset: lD,
            mediaPlaceholder: oD,
            swapDecor: sD,
            swapArrowLeft: rD,
            swapArrowCenter: cD,
            swapArrowRight: uD,
            mediaNavBtn: dD,
            mediaNavBtnPrev: fD,
            mediaNavBtnNext: mD,
            panel: pD,
            sideBtn: hD,
            sideBtnLeft: gD,
            sidePill: bD,
            sidePlus: yD,
            sideBtnRight: vD,
            sideBtnDisabled: SD,
            card: xD,
            cardTitle: ND,
            cardDesc: wD,
        };
    function w0(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
    }
    function ED() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            [s, r] = $.useState(0),
            u = $.useRef(null),
            d = i('section4.easyUseTabs', { returnObjects: !0 }),
            p = d[s],
            h = w0(p?.video, l),
            m = w0(p?.image, l),
            y = s <= 0,
            E = s >= d.length - 1,
            v = () => {
                y || r(S => Math.max(0, S - 1));
            },
            N = () => {
                E || r(S => Math.min(d.length - 1, S + 1));
            };
        return (
            $.useEffect(() => {
                const S = u.current;
                if (!S || !h) return;
                const D = requestAnimationFrame(() => {
                    S.src !== h && ((S.src = h), S.load(), S.play().catch(() => { }));
                });
                return () => cancelAnimationFrame(D);
            }, [h]),
            b.jsxDEV(
                'div',
                {
                    className: $e.carousel,
                    children: [
                        b.jsxDEV(
                            'div',
                            {
                                className: $e.media,
                                children: [
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: $e.mediaInner,
                                            children: [
                                                h
                                                    ? b.jsxDEV(
                                                        'video',
                                                        {
                                                            ref: u,
                                                            className: $e.mediaAsset,
                                                            src: h,
                                                            autoPlay: !0,
                                                            loop: !0,
                                                            muted: !0,
                                                            playsInline: !0,
                                                        },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                            lineNumber: 64,
                                                            columnNumber: 13,
                                                        },
                                                        this
                                                    )
                                                    : m
                                                        ? b.jsxDEV(
                                                            'div',
                                                            {
                                                                className: $e.mediaAsset,
                                                                style: { backgroundImage: `url(${m})` },
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                                lineNumber: 74,
                                                                columnNumber: 13,
                                                            },
                                                            this
                                                        )
                                                        : b.jsxDEV(
                                                            'div',
                                                            { className: $e.mediaPlaceholder },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                                lineNumber: 79,
                                                                columnNumber: 13,
                                                            },
                                                            this
                                                        ),
                                                s === 0 &&
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: $e.swapDecor,
                                                        'aria-hidden': 'true',
                                                        children: [
                                                            b.jsxDEV(
                                                                Ut,
                                                                {
                                                                    className: $e.swapArrowLeft,
                                                                    src: l('easyUseMobile1'),
                                                                    alt: '',
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                                    lineNumber: 84,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: $e.swapArrowCenter,
                                                                    style: {
                                                                        backgroundImage: `url(${l('easyUseSwapBg')})`,
                                                                    },
                                                                    children: b.jsxDEV(
                                                                        Ut,
                                                                        {
                                                                            className: $e.swapArrowRight,
                                                                            src: l('easyUseMobile2'),
                                                                            alt: '',
                                                                        },
                                                                        void 0,
                                                                        !1,
                                                                        {
                                                                            fileName:
                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                                            lineNumber: 89,
                                                                            columnNumber: 17,
                                                                        },
                                                                        this
                                                                    ),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                                    lineNumber: 85,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                        lineNumber: 83,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                            lineNumber: 62,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'button',
                                        {
                                            type: 'button',
                                            className: `${$e.mediaNavBtn} ${$e.mediaNavBtnPrev}`,
                                            onClick: v,
                                            disabled: y,
                                            'aria-label': 'Previous slide',
                                            children: b.jsxDEV(
                                                Qt,
                                                { name: 'icon-left' },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                    lineNumber: 102,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                        },
                                        void 0,
                                        !1,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                            lineNumber: 95,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'button',
                                        {
                                            type: 'button',
                                            className: `${$e.mediaNavBtn} ${$e.mediaNavBtnNext}`,
                                            onClick: N,
                                            disabled: E,
                                            'aria-label': 'Next slide',
                                            children: b.jsxDEV(
                                                Qt,
                                                { name: 'icon-More' },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                    lineNumber: 111,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                        },
                                        void 0,
                                        !1,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                            lineNumber: 104,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                ],
                            },
                            void 0,
                            !0,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                lineNumber: 61,
                                columnNumber: 7,
                            },
                            this
                        ),
                        b.jsxDEV(
                            'div',
                            {
                                className: $e.panel,
                                children: [
                                    b.jsxDEV(
                                        'button',
                                        {
                                            type: 'button',
                                            className: `${$e.sideBtn} ${$e.sideBtnLeft} ${y ? $e.sideBtnDisabled : ''}`,
                                            onClick: v,
                                            disabled: y,
                                            'aria-label': 'Previous feature',
                                            children: [
                                                b.jsxDEV(
                                                    'span',
                                                    { className: $e.sidePill },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                        lineNumber: 123,
                                                        columnNumber: 11,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'span',
                                                    { className: $e.sidePlus, 'aria-hidden': 'true' },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                        lineNumber: 124,
                                                        columnNumber: 11,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                            lineNumber: 116,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: $e.card,
                                            children: [
                                                b.jsxDEV(
                                                    'h3',
                                                    {
                                                        className: $e.cardTitle,
                                                        dangerouslySetInnerHTML: { __html: p.title },
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                        lineNumber: 128,
                                                        columnNumber: 11,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'p',
                                                    {
                                                        className: $e.cardDesc,
                                                        dangerouslySetInnerHTML: {
                                                            __html: p.description,
                                                        },
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                        lineNumber: 132,
                                                        columnNumber: 11,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                            lineNumber: 127,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'button',
                                        {
                                            type: 'button',
                                            className: `${$e.sideBtn} ${$e.sideBtnRight} ${E ? $e.sideBtnDisabled : ''}`,
                                            onClick: N,
                                            disabled: E,
                                            'aria-label': 'Next feature',
                                            children: [
                                                b.jsxDEV(
                                                    'span',
                                                    { className: $e.sidePill },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                        lineNumber: 145,
                                                        columnNumber: 11,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'span',
                                                    { className: $e.sidePlus, 'aria-hidden': 'true' },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                                        lineNumber: 146,
                                                        columnNumber: 11,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                            lineNumber: 138,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                ],
                            },
                            void 0,
                            !0,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                                lineNumber: 115,
                                columnNumber: 7,
                            },
                            this
                        ),
                    ],
                },
                void 0,
                !0,
                {
                    fileName:
                        'D:/works/creality-offical-product/src/pages/A1C/components/Section4/EasyUseMobileCarousel.tsx',
                    lineNumber: 60,
                    columnNumber: 5,
                },
                this
            )
        );
    }
    const AD = 'section4_PMrR1',
        DD = 'title_Yqf9h',
        TD = 'subtitle_mTLP-',
        CD = 'content_NrON5',
        RD = 'features_R6-a9',
        MD = 'tabItem_BK1BO',
        OD = 'tabCollapsed_JBrk9',
        kD = 'plus_Qj2uP',
        jD = 'tabContent_moWIa',
        VD = 'tabActive_N-Q--',
        zD = 'tabTitle_nod0-',
        BD = 'tabDesc_lDmbx',
        LD = 'tabDescWrap_BEDxQ',
        ID = 'tabDescOpen_biW0j',
        HD = 'plusHidden_LxRBq',
        UD = 'image_aQwz-',
        GD = 'imageBg_XRmKR',
        _D = 'imagePlaceholder_ZtCOa',
        YD = 'video_EtrPo',
        PD = 'playPauseBtn_91jGT',
        ZD = 'pauseIcon_-Fu3G',
        WD = 'playIcon_Exiqw',
        ct = {
            section4: AD,
            title: DD,
            subtitle: TD,
            content: CD,
            features: RD,
            tabItem: MD,
            tabCollapsed: OD,
            plus: kD,
            tabContent: jD,
            tabActive: VD,
            tabTitle: zD,
            tabDesc: BD,
            tabDescWrap: LD,
            tabDescOpen: ID,
            plusHidden: HD,
            image: UD,
            imageBg: GD,
            imagePlaceholder: _D,
            video: YD,
            playPauseBtn: PD,
            pauseIcon: ZD,
            playIcon: WD,
        };
    function uu(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
    }
    function dp(i, l = 3e3) {
        return typeof window.requestIdleCallback == 'function'
            ? window.requestIdleCallback(i, { timeout: l })
            : window.setTimeout(i, 1500);
    }
    function XD(i) {
        if (typeof window.cancelIdleCallback == 'function') {
            window.cancelIdleCallback(i);
            return;
        }
        window.clearTimeout(i);
    }
    function QD(i) {
        const l = document.createElement('video');
        ((l.preload = 'auto'), (l.muted = !0), (l.src = i), l.load());
    }
    function JD(i) {
        const l = new Image();
        l.src = i;
    }
    function qD() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            s = $n(),
            [r, u] = $.useState(0),
            [d, p] = $.useState(!0),
            h = $.useRef(null),
            m = $.useRef(new Set()),
            y = i('section4.easyUseTabs', { returnObjects: !0 }),
            E = y[r],
            v = uu(E?.video, l),
            N = uu(E?.image, l);
        ($.useEffect(() => {
            p(!0);
        }, [r, v]),
            $.useEffect(() => {
                const D = h.current;
                if (!D || !v) return;
                const O = requestAnimationFrame(() => {
                    D.src !== v && ((D.src = v), D.load(), D.play().catch(() => { }));
                });
                return () => cancelAnimationFrame(O);
            }, [v]),
            $.useEffect(() => {
                const D = v || N,
                    O = y.flatMap(Y => {
                        const Z = uu(Y.video, l),
                            P = uu(Y.image, l);
                        return [
                            Z && Z !== D ? { url: Z, type: 'video' } : null,
                            P && P !== D ? { url: P, type: 'image' } : null,
                        ].filter(Boolean);
                    });
                let k = !1,
                    _;
                const I = Y => {
                    if (k || Y >= O.length) return;
                    const Z = O[Y];
                    if (!Z || m.current.has(Z.url)) {
                        _ = dp(() => I(Y + 1));
                        return;
                    }
                    (m.current.add(Z.url),
                        Z.type === 'video' ? QD(Z.url) : JD(Z.url),
                        (_ = dp(() => I(Y + 1))));
                };
                return (
                    (_ = dp(() => I(0))),
                    () => {
                        ((k = !0), _ !== void 0 && XD(_));
                    }
                );
            }, [y, v, N, l]));
        const S = () => {
            const D = h.current;
            if (D) {
                if (D.paused) {
                    (D.play(), p(!0));
                    return;
                }
                (D.pause(), p(!1));
            }
        };
        return b.jsxDEV(
            'section',
            {
                className: ct.section4,
                children: [
                    b.jsxDEV(
                        'h2',
                        { className: ct.title, children: i('section4.title') },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                            lineNumber: 143,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'p',
                        { className: ct.subtitle, children: i('section4.subtitle') },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                            lineNumber: 144,
                            columnNumber: 7,
                        },
                        this
                    ),
                    s
                        ? b.jsxDEV(
                            ED,
                            {},
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                lineNumber: 147,
                                columnNumber: 9,
                            },
                            this
                        )
                        : b.jsxDEV(
                            'div',
                            {
                                className: ct.content,
                                children: [
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ct.features,
                                            children: y.map((D, O) => {
                                                const k = r === O;
                                                return b.jsxDEV(
                                                    'button',
                                                    {
                                                        type: 'button',
                                                        className: `${ct.tabItem} ${k ? ct.tabActive : ct.tabCollapsed}`,
                                                        onClick: () => u(O),
                                                        children: [
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: `${ct.plus} ${k ? ct.plusHidden : ''}`,
                                                                    'aria-hidden': 'true',
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                                    lineNumber: 161,
                                                                    columnNumber: 17,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ct.tabContent,
                                                                    children: [
                                                                        b.jsxDEV(
                                                                            'h3',
                                                                            {
                                                                                className: ct.tabTitle,
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: D.title,
                                                                                },
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                                                lineNumber: 166,
                                                                                columnNumber: 19,
                                                                            },
                                                                            this
                                                                        ),
                                                                        b.jsxDEV(
                                                                            'div',
                                                                            {
                                                                                className: `${ct.tabDescWrap} ${k ? ct.tabDescOpen : ''}`,
                                                                                children: b.jsxDEV(
                                                                                    'p',
                                                                                    {
                                                                                        className: ct.tabDesc,
                                                                                        dangerouslySetInnerHTML: {
                                                                                            __html: D.description,
                                                                                        },
                                                                                    },
                                                                                    void 0,
                                                                                    !1,
                                                                                    {
                                                                                        fileName:
                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                                                        lineNumber: 168,
                                                                                        columnNumber: 21,
                                                                                    },
                                                                                    this
                                                                                ),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                                                lineNumber: 167,
                                                                                columnNumber: 19,
                                                                            },
                                                                            this
                                                                        ),
                                                                    ],
                                                                },
                                                                void 0,
                                                                !0,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                                    lineNumber: 165,
                                                                    columnNumber: 17,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    D.title,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                        lineNumber: 155,
                                                        columnNumber: 15,
                                                    },
                                                    this
                                                );
                                            }),
                                        },
                                        void 0,
                                        !1,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                            lineNumber: 150,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ct.image,
                                            children: v
                                                ? b.jsxDEV(
                                                    b.Fragment,
                                                    {
                                                        children: [
                                                            b.jsxDEV(
                                                                'video',
                                                                {
                                                                    ref: h,
                                                                    className: ct.video,
                                                                    src: v,
                                                                    autoPlay: !0,
                                                                    loop: !0,
                                                                    muted: !0,
                                                                    playsInline: !0,
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                                    lineNumber: 182,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'button',
                                                                {
                                                                    type: 'button',
                                                                    className: ct.playPauseBtn,
                                                                    onClick: S,
                                                                    'aria-label': d
                                                                        ? 'Pause video'
                                                                        : 'Play video',
                                                                    children: d
                                                                        ? b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ct.pauseIcon,
                                                                                'aria-hidden': 'true',
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                                                lineNumber: 198,
                                                                                columnNumber: 19,
                                                                            },
                                                                            this
                                                                        )
                                                                        : b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ct.playIcon,
                                                                                'aria-hidden': 'true',
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                                                lineNumber: 200,
                                                                                columnNumber: 19,
                                                                            },
                                                                            this
                                                                        ),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                                    lineNumber: 191,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                        lineNumber: 181,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                )
                                                : N
                                                    ? b.jsxDEV(
                                                        'div',
                                                        {
                                                            className: ct.imageBg,
                                                            style: { backgroundImage: `url(${N})` },
                                                        },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                            lineNumber: 205,
                                                            columnNumber: 13,
                                                        },
                                                        this
                                                    )
                                                    : b.jsxDEV(
                                                        'div',
                                                        { className: ct.imagePlaceholder },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                                            lineNumber: 210,
                                                            columnNumber: 13,
                                                        },
                                                        this
                                                    ),
                                        },
                                        void 0,
                                        !1,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                            lineNumber: 179,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                ],
                            },
                            void 0,
                            !0,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                                lineNumber: 149,
                                columnNumber: 7,
                            },
                            this
                        ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section4/index.tsx',
                lineNumber: 142,
                columnNumber: 5,
            },
            this
        );
    }
    function E0(i) {
        return (
            i !== null &&
            typeof i == 'object' &&
            'constructor' in i &&
            i.constructor === Object
        );
    }
    function zp(i = {}, l = {}) {
        const s = ['__proto__', 'constructor', 'prototype'];
        Object.keys(l)
            .filter(r => s.indexOf(r) < 0)
            .forEach(r => {
                typeof i[r] > 'u'
                    ? (i[r] = l[r])
                    : E0(l[r]) &&
                    E0(i[r]) &&
                    Object.keys(l[r]).length > 0 &&
                    zp(i[r], l[r]);
            });
    }
    const P0 = {
        body: {},
        addEventListener() { },
        removeEventListener() { },
        activeElement: { blur() { }, nodeName: '' },
        querySelector() {
            return null;
        },
        querySelectorAll() {
            return [];
        },
        getElementById() {
            return null;
        },
        createEvent() {
            return { initEvent() { } };
        },
        createElement() {
            return {
                children: [],
                childNodes: [],
                style: {},
                setAttribute() { },
                getElementsByTagName() {
                    return [];
                },
            };
        },
        createElementNS() {
            return {};
        },
        importNode() {
            return null;
        },
        location: {
            hash: '',
            host: '',
            hostname: '',
            href: '',
            origin: '',
            pathname: '',
            protocol: '',
            search: '',
        },
    };
    function bl() {
        const i = typeof document < 'u' ? document : {};
        return (zp(i, P0), i);
    }
    const $D = {
        document: P0,
        navigator: { userAgent: '' },
        location: {
            hash: '',
            host: '',
            hostname: '',
            href: '',
            origin: '',
            pathname: '',
            protocol: '',
            search: '',
        },
        history: { replaceState() { }, pushState() { }, go() { }, back() { } },
        CustomEvent: function () {
            return this;
        },
        addEventListener() { },
        removeEventListener() { },
        getComputedStyle() {
            return {
                getPropertyValue() {
                    return '';
                },
            };
        },
        Image() { },
        Date() { },
        screen: {},
        setTimeout() { },
        clearTimeout() { },
        matchMedia() {
            return {};
        },
        requestAnimationFrame(i) {
            return typeof setTimeout > 'u' ? (i(), null) : setTimeout(i, 0);
        },
        cancelAnimationFrame(i) {
            typeof setTimeout > 'u' || clearTimeout(i);
        },
    };
    function Jt() {
        const i = typeof window < 'u' ? window : {};
        return (zp(i, $D), i);
    }
    function FD(i = '') {
        return i
            .trim()
            .split(' ')
            .filter(l => !!l.trim());
    }
    function KD(i) {
        const l = i;
        Object.keys(l).forEach(s => {
            try {
                l[s] = null;
            } catch { }
            try {
                delete l[s];
            } catch { }
        });
    }
    function Z0(i, l = 0) {
        return setTimeout(i, l);
    }
    function bu() {
        return Date.now();
    }
    function eT(i) {
        const l = Jt();
        let s;
        return (
            l.getComputedStyle && (s = l.getComputedStyle(i, null)),
            !s && i.currentStyle && (s = i.currentStyle),
            s || (s = i.style),
            s
        );
    }
    function tT(i, l = 'x') {
        const s = Jt();
        let r, u, d;
        const p = eT(i);
        return (
            s.WebKitCSSMatrix
                ? ((u = p.transform || p.webkitTransform),
                    u.split(',').length > 6 &&
                    (u = u
                        .split(', ')
                        .map(h => h.replace(',', '.'))
                        .join(', ')),
                    (d = new s.WebKitCSSMatrix(u === 'none' ? '' : u)))
                : ((d =
                    p.MozTransform ||
                    p.OTransform ||
                    p.MsTransform ||
                    p.msTransform ||
                    p.transform ||
                    p
                        .getPropertyValue('transform')
                        .replace('translate(', 'matrix(1, 0, 0, 1,')),
                    (r = d.toString().split(','))),
            l === 'x' &&
            (s.WebKitCSSMatrix
                ? (u = d.m41)
                : r.length === 16
                    ? (u = parseFloat(r[12]))
                    : (u = parseFloat(r[4]))),
            l === 'y' &&
            (s.WebKitCSSMatrix
                ? (u = d.m42)
                : r.length === 16
                    ? (u = parseFloat(r[13]))
                    : (u = parseFloat(r[5]))),
            u || 0
        );
    }
    function du(i) {
        return (
            typeof i == 'object' &&
            i !== null &&
            i.constructor &&
            Object.prototype.toString.call(i).slice(8, -1) === 'Object'
        );
    }
    function nT(i) {
        return typeof window < 'u' && typeof window.HTMLElement < 'u'
            ? i instanceof HTMLElement
            : i && (i.nodeType === 1 || i.nodeType === 11);
    }
    function gn(...i) {
        const l = Object(i[0]),
            s = ['__proto__', 'constructor', 'prototype'];
        for (let r = 1; r < i.length; r += 1) {
            const u = i[r];
            if (u != null && !nT(u)) {
                const d = Object.keys(Object(u)).filter(p => s.indexOf(p) < 0);
                for (let p = 0, h = d.length; p < h; p += 1) {
                    const m = d[p],
                        y = Object.getOwnPropertyDescriptor(u, m);
                    y !== void 0 &&
                        y.enumerable &&
                        (du(l[m]) && du(u[m])
                            ? u[m].__swiper__
                                ? (l[m] = u[m])
                                : gn(l[m], u[m])
                            : !du(l[m]) && du(u[m])
                                ? ((l[m] = {}),
                                    u[m].__swiper__ ? (l[m] = u[m]) : gn(l[m], u[m]))
                                : (l[m] = u[m]));
                }
            }
        }
        return l;
    }
    function fu(i, l, s) {
        i.style.setProperty(l, s);
    }
    function W0({ swiper: i, targetPosition: l, side: s }) {
        const r = Jt(),
            u = -i.translate;
        let d = null,
            p;
        const h = i.params.speed;
        ((i.wrapperEl.style.scrollSnapType = 'none'),
            r.cancelAnimationFrame(i.cssModeFrameID));
        const m = l > u ? 'next' : 'prev',
            y = (v, N) => (m === 'next' && v >= N) || (m === 'prev' && v <= N),
            E = () => {
                ((p = new Date().getTime()), d === null && (d = p));
                const v = Math.max(Math.min((p - d) / h, 1), 0),
                    N = 0.5 - Math.cos(v * Math.PI) / 2;
                let S = u + N * (l - u);
                if (
                    (y(S, l) && (S = l), i.wrapperEl.scrollTo({ [s]: S }), y(S, l))
                ) {
                    ((i.wrapperEl.style.overflow = 'hidden'),
                        (i.wrapperEl.style.scrollSnapType = ''),
                        setTimeout(() => {
                            ((i.wrapperEl.style.overflow = ''),
                                i.wrapperEl.scrollTo({ [s]: S }));
                        }),
                        r.cancelAnimationFrame(i.cssModeFrameID));
                    return;
                }
                i.cssModeFrameID = r.requestAnimationFrame(E);
            };
        E();
    }
    function ya(i, l = '') {
        const s = Jt(),
            r = [...i.children];
        return (
            s.HTMLSlotElement &&
            i instanceof HTMLSlotElement &&
            r.push(...i.assignedElements()),
            l ? r.filter(u => u.matches(l)) : r
        );
    }
    function aT(i, l) {
        const s = [l];
        for (; s.length > 0;) {
            const r = s.shift();
            if (i === r) return !0;
            s.push(
                ...r.children,
                ...(r.shadowRoot ? r.shadowRoot.children : []),
                ...(r.assignedElements ? r.assignedElements() : [])
            );
        }
    }
    function iT(i, l) {
        const s = Jt();
        let r = l.contains(i);
        return (
            !r &&
            s.HTMLSlotElement &&
            l instanceof HTMLSlotElement &&
            ((r = [...l.assignedElements()].includes(i)), r || (r = aT(i, l))),
            r
        );
    }
    function yu(i) {
        try {
            console.warn(i);
            return;
        } catch { }
    }
    function vu(i, l = []) {
        const s = document.createElement(i);
        return (s.classList.add(...(Array.isArray(l) ? l : FD(l))), s);
    }
    function lT(i, l) {
        const s = [];
        for (; i.previousElementSibling;) {
            const r = i.previousElementSibling;
            (l ? r.matches(l) && s.push(r) : s.push(r), (i = r));
        }
        return s;
    }
    function oT(i, l) {
        const s = [];
        for (; i.nextElementSibling;) {
            const r = i.nextElementSibling;
            (l ? r.matches(l) && s.push(r) : s.push(r), (i = r));
        }
        return s;
    }
    function Ci(i, l) {
        return Jt().getComputedStyle(i, null).getPropertyValue(l);
    }
    function A0(i) {
        let l = i,
            s;
        if (l) {
            for (s = 0; (l = l.previousSibling) !== null;)
                l.nodeType === 1 && (s += 1);
            return s;
        }
    }
    function sT(i, l) {
        const s = [];
        let r = i.parentElement;
        for (; r;) (s.push(r), (r = r.parentElement));
        return s;
    }
    function D0(i, l, s) {
        const r = Jt();
        return (
            i[l === 'width' ? 'offsetWidth' : 'offsetHeight'] +
            parseFloat(
                r
                    .getComputedStyle(i, null)
                    .getPropertyValue(l === 'width' ? 'margin-right' : 'margin-top')
            ) +
            parseFloat(
                r
                    .getComputedStyle(i, null)
                    .getPropertyValue(l === 'width' ? 'margin-left' : 'margin-bottom')
            )
        );
    }
    function Za(i) {
        return (Array.isArray(i) ? i : [i]).filter(l => !!l);
    }
    function Op(i, l = '') {
        typeof trustedTypes < 'u'
            ? (i.innerHTML = trustedTypes
                .createPolicy('html', { createHTML: s => s })
                .createHTML(l))
            : (i.innerHTML = l);
    }
    let fp;
    function rT() {
        const i = Jt(),
            l = bl();
        return {
            smoothScroll:
                l.documentElement &&
                l.documentElement.style &&
                'scrollBehavior' in l.documentElement.style,
            touch: !!(
                'ontouchstart' in i ||
                (i.DocumentTouch && l instanceof i.DocumentTouch)
            ),
        };
    }
    function X0() {
        return (fp || (fp = rT()), fp);
    }
    let mp;
    function cT({ userAgent: i } = {}) {
        const l = X0(),
            s = Jt(),
            r = s.navigator.platform,
            u = i || s.navigator.userAgent,
            d = { ios: !1, android: !1 },
            p = s.screen.width,
            h = s.screen.height,
            m = u.match(/(Android);?[\s\/]+([\d.]+)?/);
        let y = u.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
        const E = u.match(/(iPod)(.*OS\s([\d_]+))?/),
            v = !y && u.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
            N = r === 'Win32';
        let S = r === 'MacIntel';
        const D = [
            '1024x1366',
            '1366x1024',
            '834x1194',
            '1194x834',
            '834x1112',
            '1112x834',
            '768x1024',
            '1024x768',
            '820x1180',
            '1180x820',
            '810x1080',
            '1080x810',
        ];
        return (
            !y &&
            S &&
            l.touch &&
            D.indexOf(`${p}x${h}`) >= 0 &&
            ((y = u.match(/(Version)\/([\d.]+)/)),
                y || (y = [0, 1, '13_0_0']),
                (S = !1)),
            m && !N && ((d.os = 'android'), (d.android = !0)),
            (y || v || E) && ((d.os = 'ios'), (d.ios = !0)),
            d
        );
    }
    function Q0(i = {}) {
        return (mp || (mp = cT(i)), mp);
    }
    let pp;
    function uT() {
        const i = Jt(),
            l = Q0();
        let s = !1;
        function r() {
            const h = i.navigator.userAgent.toLowerCase();
            return (
                h.indexOf('safari') >= 0 &&
                h.indexOf('chrome') < 0 &&
                h.indexOf('android') < 0
            );
        }
        if (r()) {
            const h = String(i.navigator.userAgent);
            if (h.includes('Version/')) {
                const [m, y] = h
                    .split('Version/')[1]
                    .split(' ')[0]
                    .split('.')
                    .map(E => Number(E));
                s = m < 16 || (m === 16 && y < 2);
            }
        }
        const u = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
            i.navigator.userAgent
        ),
            d = r(),
            p = d || (u && l.ios);
        return {
            isSafari: s || d,
            needPerspectiveFix: s,
            need3dFix: p,
            isWebView: u,
        };
    }
    function J0() {
        return (pp || (pp = uT()), pp);
    }
    function dT({ swiper: i, on: l, emit: s }) {
        const r = Jt();
        let u = null,
            d = null;
        const p = () => {
            !i ||
                i.destroyed ||
                !i.initialized ||
                (s('beforeResize'), s('resize'));
        },
            h = () => {
                !i ||
                    i.destroyed ||
                    !i.initialized ||
                    ((u = new ResizeObserver(E => {
                        d = r.requestAnimationFrame(() => {
                            const { width: v, height: N } = i;
                            let S = v,
                                D = N;
                            (E.forEach(
                                ({ contentBoxSize: O, contentRect: k, target: _ }) => {
                                    (_ && _ !== i.el) ||
                                        ((S = k ? k.width : (O[0] || O).inlineSize),
                                            (D = k ? k.height : (O[0] || O).blockSize));
                                }
                            ),
                                (S !== v || D !== N) && p());
                        });
                    })),
                        u.observe(i.el));
            },
            m = () => {
                (d && r.cancelAnimationFrame(d),
                    u && u.unobserve && i.el && (u.unobserve(i.el), (u = null)));
            },
            y = () => {
                !i || i.destroyed || !i.initialized || s('orientationchange');
            };
        (l('init', () => {
            if (i.params.resizeObserver && typeof r.ResizeObserver < 'u') {
                h();
                return;
            }
            (r.addEventListener('resize', p),
                r.addEventListener('orientationchange', y));
        }),
            l('destroy', () => {
                (m(),
                    r.removeEventListener('resize', p),
                    r.removeEventListener('orientationchange', y));
            }));
    }
    function fT({ swiper: i, extendParams: l, on: s, emit: r }) {
        const u = [],
            d = Jt(),
            p = (y, E = {}) => {
                const v = d.MutationObserver || d.WebkitMutationObserver,
                    N = new v(S => {
                        if (i.__preventObserver__) return;
                        if (S.length === 1) {
                            r('observerUpdate', S[0]);
                            return;
                        }
                        const D = function () {
                            r('observerUpdate', S[0]);
                        };
                        d.requestAnimationFrame
                            ? d.requestAnimationFrame(D)
                            : d.setTimeout(D, 0);
                    });
                (N.observe(y, {
                    attributes: typeof E.attributes > 'u' ? !0 : E.attributes,
                    childList:
                        i.isElement || (typeof E.childList > 'u' ? !0 : E).childList,
                    characterData:
                        typeof E.characterData > 'u' ? !0 : E.characterData,
                }),
                    u.push(N));
            },
            h = () => {
                if (i.params.observer) {
                    if (i.params.observeParents) {
                        const y = sT(i.hostEl);
                        for (let E = 0; E < y.length; E += 1) p(y[E]);
                    }
                    (p(i.hostEl, { childList: i.params.observeSlideChildren }),
                        p(i.wrapperEl, { attributes: !1 }));
                }
            },
            m = () => {
                (u.forEach(y => {
                    y.disconnect();
                }),
                    u.splice(0, u.length));
            };
        (l({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
            s('init', h),
            s('destroy', m));
    }
    var mT = {
        on(i, l, s) {
            const r = this;
            if (!r.eventsListeners || r.destroyed || typeof l != 'function')
                return r;
            const u = s ? 'unshift' : 'push';
            return (
                i.split(' ').forEach(d => {
                    (r.eventsListeners[d] || (r.eventsListeners[d] = []),
                        r.eventsListeners[d][u](l));
                }),
                r
            );
        },
        once(i, l, s) {
            const r = this;
            if (!r.eventsListeners || r.destroyed || typeof l != 'function')
                return r;
            function u(...d) {
                (r.off(i, u),
                    u.__emitterProxy && delete u.__emitterProxy,
                    l.apply(r, d));
            }
            return ((u.__emitterProxy = l), r.on(i, u, s));
        },
        onAny(i, l) {
            const s = this;
            if (!s.eventsListeners || s.destroyed || typeof i != 'function')
                return s;
            const r = l ? 'unshift' : 'push';
            return (
                s.eventsAnyListeners.indexOf(i) < 0 && s.eventsAnyListeners[r](i),
                s
            );
        },
        offAny(i) {
            const l = this;
            if (!l.eventsListeners || l.destroyed || !l.eventsAnyListeners)
                return l;
            const s = l.eventsAnyListeners.indexOf(i);
            return (s >= 0 && l.eventsAnyListeners.splice(s, 1), l);
        },
        off(i, l) {
            const s = this;
            return (
                !s.eventsListeners ||
                s.destroyed ||
                !s.eventsListeners ||
                i.split(' ').forEach(r => {
                    typeof l > 'u'
                        ? (s.eventsListeners[r] = [])
                        : s.eventsListeners[r] &&
                        s.eventsListeners[r].forEach((u, d) => {
                            (u === l ||
                                (u.__emitterProxy && u.__emitterProxy === l)) &&
                                s.eventsListeners[r].splice(d, 1);
                        });
                }),
                s
            );
        },
        emit(...i) {
            const l = this;
            if (!l.eventsListeners || l.destroyed || !l.eventsListeners) return l;
            let s, r, u;
            return (
                typeof i[0] == 'string' || Array.isArray(i[0])
                    ? ((s = i[0]), (r = i.slice(1, i.length)), (u = l))
                    : ((s = i[0].events), (r = i[0].data), (u = i[0].context || l)),
                r.unshift(u),
                (Array.isArray(s) ? s : s.split(' ')).forEach(p => {
                    (l.eventsAnyListeners &&
                        l.eventsAnyListeners.length &&
                        l.eventsAnyListeners.forEach(h => {
                            h.apply(u, [p, ...r]);
                        }),
                        l.eventsListeners &&
                        l.eventsListeners[p] &&
                        l.eventsListeners[p].forEach(h => {
                            h.apply(u, r);
                        }));
                }),
                l
            );
        },
    };
    function pT() {
        const i = this;
        let l, s;
        const r = i.el;
        (typeof i.params.width < 'u' && i.params.width !== null
            ? (l = i.params.width)
            : (l = r.clientWidth),
            typeof i.params.height < 'u' && i.params.height !== null
                ? (s = i.params.height)
                : (s = r.clientHeight),
            !((l === 0 && i.isHorizontal()) || (s === 0 && i.isVertical())) &&
            ((l =
                l -
                parseInt(Ci(r, 'padding-left') || 0, 10) -
                parseInt(Ci(r, 'padding-right') || 0, 10)),
                (s =
                    s -
                    parseInt(Ci(r, 'padding-top') || 0, 10) -
                    parseInt(Ci(r, 'padding-bottom') || 0, 10)),
                Number.isNaN(l) && (l = 0),
                Number.isNaN(s) && (s = 0),
                Object.assign(i, {
                    width: l,
                    height: s,
                    size: i.isHorizontal() ? l : s,
                })));
    }
    function hT() {
        const i = this;
        function l(te, X) {
            return parseFloat(te.getPropertyValue(i.getDirectionLabel(X)) || 0);
        }
        const s = i.params,
            { wrapperEl: r, slidesEl: u, rtlTranslate: d, wrongRTL: p } = i,
            h = i.virtual && s.virtual.enabled,
            m = h ? i.virtual.slides.length : i.slides.length,
            y = ya(u, `.${i.params.slideClass}, swiper-slide`),
            E = h ? i.virtual.slides.length : y.length;
        let v = [];
        const N = [],
            S = [];
        let D = s.slidesOffsetBefore;
        typeof D == 'function' && (D = s.slidesOffsetBefore.call(i));
        let O = s.slidesOffsetAfter;
        typeof O == 'function' && (O = s.slidesOffsetAfter.call(i));
        const k = i.snapGrid.length,
            _ = i.slidesGrid.length,
            I = i.size - D - O;
        let Y = s.spaceBetween,
            Z = -D,
            P = 0,
            le = 0;
        if (typeof I > 'u') return;
        (typeof Y == 'string' && Y.indexOf('%') >= 0
            ? (Y = (parseFloat(Y.replace('%', '')) / 100) * I)
            : typeof Y == 'string' && (Y = parseFloat(Y)),
            (i.virtualSize = -Y - D - O),
            y.forEach(te => {
                (d ? (te.style.marginLeft = '') : (te.style.marginRight = ''),
                    (te.style.marginBottom = ''),
                    (te.style.marginTop = ''));
            }),
            s.centeredSlides &&
            s.cssMode &&
            (fu(r, '--swiper-centered-offset-before', ''),
                fu(r, '--swiper-centered-offset-after', '')));
        const q = s.grid && s.grid.rows > 1 && i.grid;
        q ? i.grid.initSlides(y) : i.grid && i.grid.unsetSlides();
        let W;
        const K =
            s.slidesPerView === 'auto' &&
            s.breakpoints &&
            Object.keys(s.breakpoints).filter(
                te => typeof s.breakpoints[te].slidesPerView < 'u'
            ).length > 0;
        for (let te = 0; te < E; te += 1) {
            W = 0;
            const X = y[te];
            if (
                !(
                    X &&
                    (q && i.grid.updateSlide(te, X, y), Ci(X, 'display') === 'none')
                )
            ) {
                if (h && s.slidesPerView === 'auto')
                    (s.virtual.slidesPerViewAutoSlideSize &&
                        (W = s.virtual.slidesPerViewAutoSlideSize),
                        W &&
                        X &&
                        (s.roundLengths && (W = Math.floor(W)),
                            (X.style[i.getDirectionLabel('width')] = `${W}px`)));
                else if (s.slidesPerView === 'auto') {
                    K && (X.style[i.getDirectionLabel('width')] = '');
                    const oe = getComputedStyle(X),
                        ge = X.style.transform,
                        Ee = X.style.webkitTransform;
                    if (
                        (ge && (X.style.transform = 'none'),
                            Ee && (X.style.webkitTransform = 'none'),
                            s.roundLengths)
                    )
                        W = i.isHorizontal() ? D0(X, 'width') : D0(X, 'height');
                    else {
                        const _e = l(oe, 'width'),
                            J = l(oe, 'padding-left'),
                            ce = l(oe, 'padding-right'),
                            Q = l(oe, 'margin-left'),
                            me = l(oe, 'margin-right'),
                            U = oe.getPropertyValue('box-sizing');
                        if (U && U === 'border-box') W = _e + Q + me;
                        else {
                            const { clientWidth: re, offsetWidth: ue } = X;
                            W = _e + J + ce + Q + me + (ue - re);
                        }
                    }
                    (ge && (X.style.transform = ge),
                        Ee && (X.style.webkitTransform = Ee),
                        s.roundLengths && (W = Math.floor(W)));
                } else
                    ((W = (I - (s.slidesPerView - 1) * Y) / s.slidesPerView),
                        s.roundLengths && (W = Math.floor(W)),
                        X && (X.style[i.getDirectionLabel('width')] = `${W}px`));
                (X && (X.swiperSlideSize = W),
                    S.push(W),
                    s.centeredSlides
                        ? ((Z = Z + W / 2 + P / 2 + Y),
                            P === 0 && te !== 0 && (Z = Z - I / 2 - Y),
                            te === 0 && (Z = Z - I / 2 - Y),
                            Math.abs(Z) < 1 / 1e3 && (Z = 0),
                            s.roundLengths && (Z = Math.floor(Z)),
                            le % s.slidesPerGroup === 0 && v.push(Z),
                            N.push(Z))
                        : (s.roundLengths && (Z = Math.floor(Z)),
                            (le - Math.min(i.params.slidesPerGroupSkip, le)) %
                            i.params.slidesPerGroup ===
                            0 && v.push(Z),
                            N.push(Z),
                            (Z = Z + W + Y)),
                    (i.virtualSize += W + Y),
                    (P = W),
                    (le += 1));
            }
        }
        if (
            ((i.virtualSize = Math.max(i.virtualSize, I) + O),
                d &&
                p &&
                (s.effect === 'slide' || s.effect === 'coverflow') &&
                (r.style.width = `${i.virtualSize + Y}px`),
                s.setWrapperSize &&
                (r.style[i.getDirectionLabel('width')] = `${i.virtualSize + Y}px`),
                q && i.grid.updateWrapperSize(W, v),
                !s.centeredSlides)
        ) {
            const te = [];
            for (let X = 0; X < v.length; X += 1) {
                let oe = v[X];
                (s.roundLengths && (oe = Math.floor(oe)),
                    v[X] <= i.virtualSize - I && te.push(oe));
            }
            ((v = te),
                Math.floor(i.virtualSize - I) - Math.floor(v[v.length - 1]) > 1 &&
                v.push(i.virtualSize - I));
        }
        if (h && s.loop) {
            const te = S[0] + Y;
            if (s.slidesPerGroup > 1) {
                const X = Math.ceil(
                    (i.virtual.slidesBefore + i.virtual.slidesAfter) /
                    s.slidesPerGroup
                ),
                    oe = te * s.slidesPerGroup;
                for (let ge = 0; ge < X; ge += 1) v.push(v[v.length - 1] + oe);
            }
            for (
                let X = 0;
                X < i.virtual.slidesBefore + i.virtual.slidesAfter;
                X += 1
            )
                (s.slidesPerGroup === 1 && v.push(v[v.length - 1] + te),
                    N.push(N[N.length - 1] + te),
                    (i.virtualSize += te));
        }
        if ((v.length === 0 && (v = [0]), Y !== 0)) {
            const te =
                i.isHorizontal() && d
                    ? 'marginLeft'
                    : i.getDirectionLabel('marginRight');
            y.filter((X, oe) =>
                !s.cssMode || s.loop ? !0 : oe !== y.length - 1
            ).forEach(X => {
                X.style[te] = `${Y}px`;
            });
        }
        if (s.centeredSlides && s.centeredSlidesBounds) {
            let te = 0;
            (S.forEach(oe => {
                te += oe + (Y || 0);
            }),
                (te -= Y));
            const X = te > I ? te - I : 0;
            v = v.map(oe => (oe <= 0 ? -D : oe > X ? X + O : oe));
        }
        if (s.centerInsufficientSlides) {
            let te = 0;
            (S.forEach(oe => {
                te += oe + (Y || 0);
            }),
                (te -= Y));
            const X = (D || 0) + (O || 0);
            if (te + X < I) {
                const oe = (I - te - X) / 2;
                (v.forEach((ge, Ee) => {
                    v[Ee] = ge - oe;
                }),
                    N.forEach((ge, Ee) => {
                        N[Ee] = ge + oe;
                    }));
            }
        }
        if (
            (Object.assign(i, {
                slides: y,
                snapGrid: v,
                slidesGrid: N,
                slidesSizesGrid: S,
            }),
                s.centeredSlides && s.cssMode && !s.centeredSlidesBounds)
        ) {
            (fu(r, '--swiper-centered-offset-before', `${-v[0]}px`),
                fu(
                    r,
                    '--swiper-centered-offset-after',
                    `${i.size / 2 - S[S.length - 1] / 2}px`
                ));
            const te = -i.snapGrid[0],
                X = -i.slidesGrid[0];
            ((i.snapGrid = i.snapGrid.map(oe => oe + te)),
                (i.slidesGrid = i.slidesGrid.map(oe => oe + X)));
        }
        if (
            (E !== m && i.emit('slidesLengthChange'),
                v.length !== k &&
                (i.params.watchOverflow && i.checkOverflow(),
                    i.emit('snapGridLengthChange')),
                N.length !== _ && i.emit('slidesGridLengthChange'),
                s.watchSlidesProgress && i.updateSlidesOffset(),
                i.emit('slidesUpdated'),
                !h && !s.cssMode && (s.effect === 'slide' || s.effect === 'fade'))
        ) {
            const te = `${s.containerModifierClass}backface-hidden`,
                X = i.el.classList.contains(te);
            E <= s.maxBackfaceHiddenSlides
                ? X || i.el.classList.add(te)
                : X && i.el.classList.remove(te);
        }
    }
    function gT(i) {
        const l = this,
            s = [],
            r = l.virtual && l.params.virtual.enabled;
        let u = 0,
            d;
        typeof i == 'number'
            ? l.setTransition(i)
            : i === !0 && l.setTransition(l.params.speed);
        const p = h => (r ? l.slides[l.getSlideIndexByData(h)] : l.slides[h]);
        if (l.params.slidesPerView !== 'auto' && l.params.slidesPerView > 1)
            if (l.params.centeredSlides)
                (l.visibleSlides || []).forEach(h => {
                    s.push(h);
                });
            else
                for (d = 0; d < Math.ceil(l.params.slidesPerView); d += 1) {
                    const h = l.activeIndex + d;
                    if (h > l.slides.length && !r) break;
                    s.push(p(h));
                }
        else s.push(p(l.activeIndex));
        for (d = 0; d < s.length; d += 1)
            if (typeof s[d] < 'u') {
                const h = s[d].offsetHeight;
                u = h > u ? h : u;
            }
        (u || u === 0) && (l.wrapperEl.style.height = `${u}px`);
    }
    function bT() {
        const i = this,
            l = i.slides,
            s = i.isElement
                ? i.isHorizontal()
                    ? i.wrapperEl.offsetLeft
                    : i.wrapperEl.offsetTop
                : 0;
        for (let r = 0; r < l.length; r += 1)
            l[r].swiperSlideOffset =
                (i.isHorizontal() ? l[r].offsetLeft : l[r].offsetTop) -
                s -
                i.cssOverflowAdjustment();
    }
    const T0 = (i, l, s) => {
        l && !i.classList.contains(s)
            ? i.classList.add(s)
            : !l && i.classList.contains(s) && i.classList.remove(s);
    };
    function yT(i = (this && this.translate) || 0) {
        const l = this,
            s = l.params,
            { slides: r, rtlTranslate: u, snapGrid: d } = l;
        if (r.length === 0) return;
        typeof r[0].swiperSlideOffset > 'u' && l.updateSlidesOffset();
        let p = -i;
        (u && (p = i), (l.visibleSlidesIndexes = []), (l.visibleSlides = []));
        let h = s.spaceBetween;
        typeof h == 'string' && h.indexOf('%') >= 0
            ? (h = (parseFloat(h.replace('%', '')) / 100) * l.size)
            : typeof h == 'string' && (h = parseFloat(h));
        for (let m = 0; m < r.length; m += 1) {
            const y = r[m];
            let E = y.swiperSlideOffset;
            s.cssMode && s.centeredSlides && (E -= r[0].swiperSlideOffset);
            const v =
                (p + (s.centeredSlides ? l.minTranslate() : 0) - E) /
                (y.swiperSlideSize + h),
                N =
                    (p - d[0] + (s.centeredSlides ? l.minTranslate() : 0) - E) /
                    (y.swiperSlideSize + h),
                S = -(p - E),
                D = S + l.slidesSizesGrid[m],
                O = S >= 0 && S <= l.size - l.slidesSizesGrid[m],
                k =
                    (S >= 0 && S < l.size - 1) ||
                    (D > 1 && D <= l.size) ||
                    (S <= 0 && D >= l.size);
            (k && (l.visibleSlides.push(y), l.visibleSlidesIndexes.push(m)),
                T0(y, k, s.slideVisibleClass),
                T0(y, O, s.slideFullyVisibleClass),
                (y.progress = u ? -v : v),
                (y.originalProgress = u ? -N : N));
        }
    }
    function vT(i) {
        const l = this;
        if (typeof i > 'u') {
            const E = l.rtlTranslate ? -1 : 1;
            i = (l && l.translate && l.translate * E) || 0;
        }
        const s = l.params,
            r = l.maxTranslate() - l.minTranslate();
        let { progress: u, isBeginning: d, isEnd: p, progressLoop: h } = l;
        const m = d,
            y = p;
        if (r === 0) ((u = 0), (d = !0), (p = !0));
        else {
            u = (i - l.minTranslate()) / r;
            const E = Math.abs(i - l.minTranslate()) < 1,
                v = Math.abs(i - l.maxTranslate()) < 1;
            ((d = E || u <= 0), (p = v || u >= 1), E && (u = 0), v && (u = 1));
        }
        if (s.loop) {
            const E = l.getSlideIndexByData(0),
                v = l.getSlideIndexByData(l.slides.length - 1),
                N = l.slidesGrid[E],
                S = l.slidesGrid[v],
                D = l.slidesGrid[l.slidesGrid.length - 1],
                O = Math.abs(i);
            (O >= N ? (h = (O - N) / D) : (h = (O + D - S) / D),
                h > 1 && (h -= 1));
        }
        (Object.assign(l, {
            progress: u,
            progressLoop: h,
            isBeginning: d,
            isEnd: p,
        }),
            (s.watchSlidesProgress || (s.centeredSlides && s.autoHeight)) &&
            l.updateSlidesProgress(i),
            d && !m && l.emit('reachBeginning toEdge'),
            p && !y && l.emit('reachEnd toEdge'),
            ((m && !d) || (y && !p)) && l.emit('fromEdge'),
            l.emit('progress', u));
    }
    const hp = (i, l, s) => {
        l && !i.classList.contains(s)
            ? i.classList.add(s)
            : !l && i.classList.contains(s) && i.classList.remove(s);
    };
    function ST() {
        const i = this,
            { slides: l, params: s, slidesEl: r, activeIndex: u } = i,
            d = i.virtual && s.virtual.enabled,
            p = i.grid && s.grid && s.grid.rows > 1,
            h = v => ya(r, `.${s.slideClass}${v}, swiper-slide${v}`)[0];
        let m, y, E;
        if (d)
            if (s.loop) {
                let v = u - i.virtual.slidesBefore;
                (v < 0 && (v = i.virtual.slides.length + v),
                    v >= i.virtual.slides.length && (v -= i.virtual.slides.length),
                    (m = h(`[data-swiper-slide-index="${v}"]`)));
            } else m = h(`[data-swiper-slide-index="${u}"]`);
        else
            p
                ? ((m = l.find(v => v.column === u)),
                    (E = l.find(v => v.column === u + 1)),
                    (y = l.find(v => v.column === u - 1)))
                : (m = l[u]);
        (m &&
            (p ||
                ((E = oT(m, `.${s.slideClass}, swiper-slide`)[0]),
                    s.loop && !E && (E = l[0]),
                    (y = lT(m, `.${s.slideClass}, swiper-slide`)[0]),
                    s.loop && !y === 0 && (y = l[l.length - 1]))),
            l.forEach(v => {
                (hp(v, v === m, s.slideActiveClass),
                    hp(v, v === E, s.slideNextClass),
                    hp(v, v === y, s.slidePrevClass));
            }),
            i.emitSlidesClasses());
    }
    const mu = (i, l) => {
        if (!i || i.destroyed || !i.params) return;
        const s = () =>
            i.isElement ? 'swiper-slide' : `.${i.params.slideClass}`,
            r = l.closest(s());
        if (r) {
            let u = r.querySelector(`.${i.params.lazyPreloaderClass}`);
            (!u &&
                i.isElement &&
                (r.shadowRoot
                    ? (u = r.shadowRoot.querySelector(
                        `.${i.params.lazyPreloaderClass}`
                    ))
                    : requestAnimationFrame(() => {
                        r.shadowRoot &&
                            ((u = r.shadowRoot.querySelector(
                                `.${i.params.lazyPreloaderClass}`
                            )),
                                u && u.remove());
                    })),
                u && u.remove());
        }
    },
        gp = (i, l) => {
            if (!i.slides[l]) return;
            const s = i.slides[l].querySelector('[loading="lazy"]');
            s && s.removeAttribute('loading');
        },
        kp = i => {
            if (!i || i.destroyed || !i.params) return;
            let l = i.params.lazyPreloadPrevNext;
            const s = i.slides.length;
            if (!s || !l || l < 0) return;
            l = Math.min(l, s);
            const r =
                i.params.slidesPerView === 'auto'
                    ? i.slidesPerViewDynamic()
                    : Math.ceil(i.params.slidesPerView),
                u = i.activeIndex;
            if (i.params.grid && i.params.grid.rows > 1) {
                const p = u,
                    h = [p - l];
                (h.push(...Array.from({ length: l }).map((m, y) => p + r + y)),
                    i.slides.forEach((m, y) => {
                        h.includes(m.column) && gp(i, y);
                    }));
                return;
            }
            const d = u + r - 1;
            if (i.params.rewind || i.params.loop)
                for (let p = u - l; p <= d + l; p += 1) {
                    const h = ((p % s) + s) % s;
                    (h < u || h > d) && gp(i, h);
                }
            else
                for (
                    let p = Math.max(u - l, 0);
                    p <= Math.min(d + l, s - 1);
                    p += 1
                )
                    p !== u && (p > d || p < u) && gp(i, p);
        };
    function xT(i) {
        const { slidesGrid: l, params: s } = i,
            r = i.rtlTranslate ? i.translate : -i.translate;
        let u;
        for (let d = 0; d < l.length; d += 1)
            typeof l[d + 1] < 'u'
                ? r >= l[d] && r < l[d + 1] - (l[d + 1] - l[d]) / 2
                    ? (u = d)
                    : r >= l[d] && r < l[d + 1] && (u = d + 1)
                : r >= l[d] && (u = d);
        return (
            s.normalizeSlideIndex && (u < 0 || typeof u > 'u') && (u = 0),
            u
        );
    }
    function NT(i) {
        const l = this,
            s = l.rtlTranslate ? l.translate : -l.translate,
            {
                snapGrid: r,
                params: u,
                activeIndex: d,
                realIndex: p,
                snapIndex: h,
            } = l;
        let m = i,
            y;
        const E = S => {
            let D = S - l.virtual.slidesBefore;
            return (
                D < 0 && (D = l.virtual.slides.length + D),
                D >= l.virtual.slides.length && (D -= l.virtual.slides.length),
                D
            );
        };
        if ((typeof m > 'u' && (m = xT(l)), r.indexOf(s) >= 0))
            y = r.indexOf(s);
        else {
            const S = Math.min(u.slidesPerGroupSkip, m);
            y = S + Math.floor((m - S) / u.slidesPerGroup);
        }
        if ((y >= r.length && (y = r.length - 1), m === d && !l.params.loop)) {
            y !== h && ((l.snapIndex = y), l.emit('snapIndexChange'));
            return;
        }
        if (m === d && l.params.loop && l.virtual && l.params.virtual.enabled) {
            l.realIndex = E(m);
            return;
        }
        const v = l.grid && u.grid && u.grid.rows > 1;
        let N;
        if (l.virtual && u.virtual.enabled && u.loop) N = E(m);
        else if (v) {
            const S = l.slides.find(O => O.column === m);
            let D = parseInt(S.getAttribute('data-swiper-slide-index'), 10);
            (Number.isNaN(D) && (D = Math.max(l.slides.indexOf(S), 0)),
                (N = Math.floor(D / u.grid.rows)));
        } else if (l.slides[m]) {
            const S = l.slides[m].getAttribute('data-swiper-slide-index');
            S ? (N = parseInt(S, 10)) : (N = m);
        } else N = m;
        (Object.assign(l, {
            previousSnapIndex: h,
            snapIndex: y,
            previousRealIndex: p,
            realIndex: N,
            previousIndex: d,
            activeIndex: m,
        }),
            l.initialized && kp(l),
            l.emit('activeIndexChange'),
            l.emit('snapIndexChange'),
            (l.initialized || l.params.runCallbacksOnInit) &&
            (p !== N && l.emit('realIndexChange'), l.emit('slideChange')));
    }
    function wT(i, l) {
        const s = this,
            r = s.params;
        let u = i.closest(`.${r.slideClass}, swiper-slide`);
        !u &&
            s.isElement &&
            l &&
            l.length > 1 &&
            l.includes(i) &&
            [...l.slice(l.indexOf(i) + 1, l.length)].forEach(h => {
                !u &&
                    h.matches &&
                    h.matches(`.${r.slideClass}, swiper-slide`) &&
                    (u = h);
            });
        let d = !1,
            p;
        if (u) {
            for (let h = 0; h < s.slides.length; h += 1)
                if (s.slides[h] === u) {
                    ((d = !0), (p = h));
                    break;
                }
        }
        if (u && d)
            ((s.clickedSlide = u),
                s.virtual && s.params.virtual.enabled
                    ? (s.clickedIndex = parseInt(
                        u.getAttribute('data-swiper-slide-index'),
                        10
                    ))
                    : (s.clickedIndex = p));
        else {
            ((s.clickedSlide = void 0), (s.clickedIndex = void 0));
            return;
        }
        r.slideToClickedSlide &&
            s.clickedIndex !== void 0 &&
            s.clickedIndex !== s.activeIndex &&
            s.slideToClickedSlide();
    }
    var ET = {
        updateSize: pT,
        updateSlides: hT,
        updateAutoHeight: gT,
        updateSlidesOffset: bT,
        updateSlidesProgress: yT,
        updateProgress: vT,
        updateSlidesClasses: ST,
        updateActiveIndex: NT,
        updateClickedSlide: wT,
    };
    function AT(i = this.isHorizontal() ? 'x' : 'y') {
        const l = this,
            { params: s, rtlTranslate: r, translate: u, wrapperEl: d } = l;
        if (s.virtualTranslate) return r ? -u : u;
        if (s.cssMode) return u;
        let p = tT(d, i);
        return ((p += l.cssOverflowAdjustment()), r && (p = -p), p || 0);
    }
    function DT(i, l) {
        const s = this,
            { rtlTranslate: r, params: u, wrapperEl: d, progress: p } = s;
        let h = 0,
            m = 0;
        const y = 0;
        (s.isHorizontal() ? (h = r ? -i : i) : (m = i),
            u.roundLengths && ((h = Math.floor(h)), (m = Math.floor(m))),
            (s.previousTranslate = s.translate),
            (s.translate = s.isHorizontal() ? h : m),
            u.cssMode
                ? (d[s.isHorizontal() ? 'scrollLeft' : 'scrollTop'] =
                    s.isHorizontal() ? -h : -m)
                : u.virtualTranslate ||
                (s.isHorizontal()
                    ? (h -= s.cssOverflowAdjustment())
                    : (m -= s.cssOverflowAdjustment()),
                    (d.style.transform = `translate3d(${h}px, ${m}px, ${y}px)`)));
        let E;
        const v = s.maxTranslate() - s.minTranslate();
        (v === 0 ? (E = 0) : (E = (i - s.minTranslate()) / v),
            E !== p && s.updateProgress(i),
            s.emit('setTranslate', s.translate, l));
    }
    function TT() {
        return -this.snapGrid[0];
    }
    function CT() {
        return -this.snapGrid[this.snapGrid.length - 1];
    }
    function RT(i = 0, l = this.params.speed, s = !0, r = !0, u) {
        const d = this,
            { params: p, wrapperEl: h } = d;
        if (d.animating && p.preventInteractionOnTransition) return !1;
        const m = d.minTranslate(),
            y = d.maxTranslate();
        let E;
        if (
            (r && i > m ? (E = m) : r && i < y ? (E = y) : (E = i),
                d.updateProgress(E),
                p.cssMode)
        ) {
            const v = d.isHorizontal();
            if (l === 0) h[v ? 'scrollLeft' : 'scrollTop'] = -E;
            else {
                if (!d.support.smoothScroll)
                    return (
                        W0({ swiper: d, targetPosition: -E, side: v ? 'left' : 'top' }),
                        !0
                    );
                h.scrollTo({ [v ? 'left' : 'top']: -E, behavior: 'smooth' });
            }
            return !0;
        }
        return (
            l === 0
                ? (d.setTransition(0),
                    d.setTranslate(E),
                    s &&
                    (d.emit('beforeTransitionStart', l, u),
                        d.emit('transitionEnd')))
                : (d.setTransition(l),
                    d.setTranslate(E),
                    s &&
                    (d.emit('beforeTransitionStart', l, u),
                        d.emit('transitionStart')),
                    d.animating ||
                    ((d.animating = !0),
                        d.onTranslateToWrapperTransitionEnd ||
                        (d.onTranslateToWrapperTransitionEnd = function (N) {
                            !d ||
                                d.destroyed ||
                                (N.target === this &&
                                    (d.wrapperEl.removeEventListener(
                                        'transitionend',
                                        d.onTranslateToWrapperTransitionEnd
                                    ),
                                        (d.onTranslateToWrapperTransitionEnd = null),
                                        delete d.onTranslateToWrapperTransitionEnd,
                                        (d.animating = !1),
                                        s && d.emit('transitionEnd')));
                        }),
                        d.wrapperEl.addEventListener(
                            'transitionend',
                            d.onTranslateToWrapperTransitionEnd
                        ))),
            !0
        );
    }
    var MT = {
        getTranslate: AT,
        setTranslate: DT,
        minTranslate: TT,
        maxTranslate: CT,
        translateTo: RT,
    };
    function OT(i, l) {
        const s = this;
        (s.params.cssMode ||
            ((s.wrapperEl.style.transitionDuration = `${i}ms`),
                (s.wrapperEl.style.transitionDelay = i === 0 ? '0ms' : '')),
            s.emit('setTransition', i, l));
    }
    function q0({ swiper: i, runCallbacks: l, direction: s, step: r }) {
        const { activeIndex: u, previousIndex: d } = i;
        let p = s;
        (p || (u > d ? (p = 'next') : u < d ? (p = 'prev') : (p = 'reset')),
            i.emit(`transition${r}`),
            l && p === 'reset'
                ? i.emit(`slideResetTransition${r}`)
                : l &&
                u !== d &&
                (i.emit(`slideChangeTransition${r}`),
                    p === 'next'
                        ? i.emit(`slideNextTransition${r}`)
                        : i.emit(`slidePrevTransition${r}`)));
    }
    function kT(i = !0, l) {
        const s = this,
            { params: r } = s;
        r.cssMode ||
            (r.autoHeight && s.updateAutoHeight(),
                q0({ swiper: s, runCallbacks: i, direction: l, step: 'Start' }));
    }
    function jT(i = !0, l) {
        const s = this,
            { params: r } = s;
        ((s.animating = !1),
            !r.cssMode &&
            (s.setTransition(0),
                q0({ swiper: s, runCallbacks: i, direction: l, step: 'End' })));
    }
    var VT = { setTransition: OT, transitionStart: kT, transitionEnd: jT };
    function zT(i = 0, l, s = !0, r, u) {
        typeof i == 'string' && (i = parseInt(i, 10));
        const d = this;
        let p = i;
        p < 0 && (p = 0);
        const {
            params: h,
            snapGrid: m,
            slidesGrid: y,
            previousIndex: E,
            activeIndex: v,
            rtlTranslate: N,
            wrapperEl: S,
            enabled: D,
        } = d;
        if (
            (!D && !r && !u) ||
            d.destroyed ||
            (d.animating && h.preventInteractionOnTransition)
        )
            return !1;
        typeof l > 'u' && (l = d.params.speed);
        const O = Math.min(d.params.slidesPerGroupSkip, p);
        let k = O + Math.floor((p - O) / d.params.slidesPerGroup);
        k >= m.length && (k = m.length - 1);
        const _ = -m[k];
        if (h.normalizeSlideIndex)
            for (let q = 0; q < y.length; q += 1) {
                const W = -Math.floor(_ * 100),
                    K = Math.floor(y[q] * 100),
                    te = Math.floor(y[q + 1] * 100);
                typeof y[q + 1] < 'u'
                    ? W >= K && W < te - (te - K) / 2
                        ? (p = q)
                        : W >= K && W < te && (p = q + 1)
                    : W >= K && (p = q);
            }
        if (
            d.initialized &&
            p !== v &&
            ((!d.allowSlideNext &&
                (N
                    ? _ > d.translate && _ > d.minTranslate()
                    : _ < d.translate && _ < d.minTranslate())) ||
                (!d.allowSlidePrev &&
                    _ > d.translate &&
                    _ > d.maxTranslate() &&
                    (v || 0) !== p))
        )
            return !1;
        (p !== (E || 0) && s && d.emit('beforeSlideChangeStart'),
            d.updateProgress(_));
        let I;
        p > v ? (I = 'next') : p < v ? (I = 'prev') : (I = 'reset');
        const Y = d.virtual && d.params.virtual.enabled;
        if (
            !(Y && u) &&
            ((N && -_ === d.translate) || (!N && _ === d.translate))
        )
            return (
                d.updateActiveIndex(p),
                h.autoHeight && d.updateAutoHeight(),
                d.updateSlidesClasses(),
                h.effect !== 'slide' && d.setTranslate(_),
                I !== 'reset' && (d.transitionStart(s, I), d.transitionEnd(s, I)),
                !1
            );
        if (h.cssMode) {
            const q = d.isHorizontal(),
                W = N ? _ : -_;
            if (l === 0)
                (Y &&
                    ((d.wrapperEl.style.scrollSnapType = 'none'),
                        (d._immediateVirtual = !0)),
                    Y && !d._cssModeVirtualInitialSet && d.params.initialSlide > 0
                        ? ((d._cssModeVirtualInitialSet = !0),
                            requestAnimationFrame(() => {
                                S[q ? 'scrollLeft' : 'scrollTop'] = W;
                            }))
                        : (S[q ? 'scrollLeft' : 'scrollTop'] = W),
                    Y &&
                    requestAnimationFrame(() => {
                        ((d.wrapperEl.style.scrollSnapType = ''),
                            (d._immediateVirtual = !1));
                    }));
            else {
                if (!d.support.smoothScroll)
                    return (
                        W0({ swiper: d, targetPosition: W, side: q ? 'left' : 'top' }),
                        !0
                    );
                S.scrollTo({ [q ? 'left' : 'top']: W, behavior: 'smooth' });
            }
            return !0;
        }
        const le = J0().isSafari;
        return (
            Y && !u && le && d.isElement && d.virtual.update(!1, !1, p),
            d.setTransition(l),
            d.setTranslate(_),
            d.updateActiveIndex(p),
            d.updateSlidesClasses(),
            d.emit('beforeTransitionStart', l, r),
            d.transitionStart(s, I),
            l === 0
                ? d.transitionEnd(s, I)
                : d.animating ||
                ((d.animating = !0),
                    d.onSlideToWrapperTransitionEnd ||
                    (d.onSlideToWrapperTransitionEnd = function (W) {
                        !d ||
                            d.destroyed ||
                            (W.target === this &&
                                (d.wrapperEl.removeEventListener(
                                    'transitionend',
                                    d.onSlideToWrapperTransitionEnd
                                ),
                                    (d.onSlideToWrapperTransitionEnd = null),
                                    delete d.onSlideToWrapperTransitionEnd,
                                    d.transitionEnd(s, I)));
                    }),
                    d.wrapperEl.addEventListener(
                        'transitionend',
                        d.onSlideToWrapperTransitionEnd
                    )),
            !0
        );
    }
    function BT(i = 0, l, s = !0, r) {
        typeof i == 'string' && (i = parseInt(i, 10));
        const u = this;
        if (u.destroyed) return;
        typeof l > 'u' && (l = u.params.speed);
        const d = u.grid && u.params.grid && u.params.grid.rows > 1;
        let p = i;
        if (u.params.loop)
            if (u.virtual && u.params.virtual.enabled)
                p = p + u.virtual.slidesBefore;
            else {
                let h;
                if (d) {
                    const O = p * u.params.grid.rows;
                    h = u.slides.find(
                        k => k.getAttribute('data-swiper-slide-index') * 1 === O
                    ).column;
                } else h = u.getSlideIndexByData(p);
                const m = d
                    ? Math.ceil(u.slides.length / u.params.grid.rows)
                    : u.slides.length,
                    {
                        centeredSlides: y,
                        slidesOffsetBefore: E,
                        slidesOffsetAfter: v,
                    } = u.params,
                    N = y || !!E || !!v;
                let S = u.params.slidesPerView;
                S === 'auto'
                    ? (S = u.slidesPerViewDynamic())
                    : ((S = Math.ceil(parseFloat(u.params.slidesPerView, 10))),
                        N && S % 2 === 0 && (S = S + 1));
                let D = m - h < S;
                if (
                    (N && (D = D || h < Math.ceil(S / 2)),
                        r && N && u.params.slidesPerView !== 'auto' && !d && (D = !1),
                        D)
                ) {
                    const O = N
                        ? h < u.activeIndex
                            ? 'prev'
                            : 'next'
                        : h - u.activeIndex - 1 < u.params.slidesPerView
                            ? 'next'
                            : 'prev';
                    u.loopFix({
                        direction: O,
                        slideTo: !0,
                        activeSlideIndex: O === 'next' ? h + 1 : h - m + 1,
                        slideRealIndex: O === 'next' ? u.realIndex : void 0,
                    });
                }
                if (d) {
                    const O = p * u.params.grid.rows;
                    p = u.slides.find(
                        k => k.getAttribute('data-swiper-slide-index') * 1 === O
                    ).column;
                } else p = u.getSlideIndexByData(p);
            }
        return (
            requestAnimationFrame(() => {
                u.slideTo(p, l, s, r);
            }),
            u
        );
    }
    function LT(i, l = !0, s) {
        const r = this,
            { enabled: u, params: d, animating: p } = r;
        if (!u || r.destroyed) return r;
        typeof i > 'u' && (i = r.params.speed);
        let h = d.slidesPerGroup;
        d.slidesPerView === 'auto' &&
            d.slidesPerGroup === 1 &&
            d.slidesPerGroupAuto &&
            (h = Math.max(r.slidesPerViewDynamic('current', !0), 1));
        const m = r.activeIndex < d.slidesPerGroupSkip ? 1 : h,
            y = r.virtual && d.virtual.enabled;
        if (d.loop) {
            if (p && !y && d.loopPreventsSliding) return !1;
            if (
                (r.loopFix({ direction: 'next' }),
                    (r._clientLeft = r.wrapperEl.clientLeft),
                    r.activeIndex === r.slides.length - 1 && d.cssMode)
            )
                return (
                    requestAnimationFrame(() => {
                        r.slideTo(r.activeIndex + m, i, l, s);
                    }),
                    !0
                );
        }
        return d.rewind && r.isEnd
            ? r.slideTo(0, i, l, s)
            : r.slideTo(r.activeIndex + m, i, l, s);
    }
    function IT(i, l = !0, s) {
        const r = this,
            {
                params: u,
                snapGrid: d,
                slidesGrid: p,
                rtlTranslate: h,
                enabled: m,
                animating: y,
            } = r;
        if (!m || r.destroyed) return r;
        typeof i > 'u' && (i = r.params.speed);
        const E = r.virtual && u.virtual.enabled;
        if (u.loop) {
            if (y && !E && u.loopPreventsSliding) return !1;
            (r.loopFix({ direction: 'prev' }),
                (r._clientLeft = r.wrapperEl.clientLeft));
        }
        const v = h ? r.translate : -r.translate;
        function N(I) {
            return I < 0 ? -Math.floor(Math.abs(I)) : Math.floor(I);
        }
        const S = N(v),
            D = d.map(I => N(I)),
            O = u.freeMode && u.freeMode.enabled;
        let k = d[D.indexOf(S) - 1];
        if (typeof k > 'u' && (u.cssMode || O)) {
            let I;
            (d.forEach((Y, Z) => {
                S >= Y && (I = Z);
            }),
                typeof I < 'u' && (k = O ? d[I] : d[I > 0 ? I - 1 : I]));
        }
        let _ = 0;
        if (
            (typeof k < 'u' &&
                ((_ = p.indexOf(k)),
                    _ < 0 && (_ = r.activeIndex - 1),
                    u.slidesPerView === 'auto' &&
                    u.slidesPerGroup === 1 &&
                    u.slidesPerGroupAuto &&
                    ((_ = _ - r.slidesPerViewDynamic('previous', !0) + 1),
                        (_ = Math.max(_, 0)))),
                u.rewind && r.isBeginning)
        ) {
            const I =
                r.params.virtual && r.params.virtual.enabled && r.virtual
                    ? r.virtual.slides.length - 1
                    : r.slides.length - 1;
            return r.slideTo(I, i, l, s);
        } else if (u.loop && r.activeIndex === 0 && u.cssMode)
            return (
                requestAnimationFrame(() => {
                    r.slideTo(_, i, l, s);
                }),
                !0
            );
        return r.slideTo(_, i, l, s);
    }
    function HT(i, l = !0, s) {
        const r = this;
        if (!r.destroyed)
            return (
                typeof i > 'u' && (i = r.params.speed),
                r.slideTo(r.activeIndex, i, l, s)
            );
    }
    function UT(i, l = !0, s, r = 0.5) {
        const u = this;
        if (u.destroyed) return;
        typeof i > 'u' && (i = u.params.speed);
        let d = u.activeIndex;
        const p = Math.min(u.params.slidesPerGroupSkip, d),
            h = p + Math.floor((d - p) / u.params.slidesPerGroup),
            m = u.rtlTranslate ? u.translate : -u.translate;
        if (m >= u.snapGrid[h]) {
            const y = u.snapGrid[h],
                E = u.snapGrid[h + 1];
            m - y > (E - y) * r && (d += u.params.slidesPerGroup);
        } else {
            const y = u.snapGrid[h - 1],
                E = u.snapGrid[h];
            m - y <= (E - y) * r && (d -= u.params.slidesPerGroup);
        }
        return (
            (d = Math.max(d, 0)),
            (d = Math.min(d, u.slidesGrid.length - 1)),
            u.slideTo(d, i, l, s)
        );
    }
    function GT() {
        const i = this;
        if (i.destroyed) return;
        const { params: l, slidesEl: s } = i,
            r =
                l.slidesPerView === 'auto'
                    ? i.slidesPerViewDynamic()
                    : l.slidesPerView;
        let u = i.getSlideIndexWhenGrid(i.clickedIndex),
            d;
        const p = i.isElement ? 'swiper-slide' : `.${l.slideClass}`,
            h = i.grid && i.params.grid && i.params.grid.rows > 1;
        if (l.loop) {
            if (i.animating) return;
            ((d = parseInt(
                i.clickedSlide.getAttribute('data-swiper-slide-index'),
                10
            )),
                l.centeredSlides
                    ? i.slideToLoop(d)
                    : u >
                        (h
                            ? (i.slides.length - r) / 2 - (i.params.grid.rows - 1)
                            : i.slides.length - r)
                        ? (i.loopFix(),
                            (u = i.getSlideIndex(
                                ya(s, `${p}[data-swiper-slide-index="${d}"]`)[0]
                            )),
                            Z0(() => {
                                i.slideTo(u);
                            }))
                        : i.slideTo(u));
        } else i.slideTo(u);
    }
    var _T = {
        slideTo: zT,
        slideToLoop: BT,
        slideNext: LT,
        slidePrev: IT,
        slideReset: HT,
        slideToClosest: UT,
        slideToClickedSlide: GT,
    };
    function YT(i, l) {
        const s = this,
            { params: r, slidesEl: u } = s;
        if (!r.loop || (s.virtual && s.params.virtual.enabled)) return;
        const d = () => {
            ya(u, `.${r.slideClass}, swiper-slide`).forEach((D, O) => {
                D.setAttribute('data-swiper-slide-index', O);
            });
        },
            p = () => {
                const S = ya(u, `.${r.slideBlankClass}`);
                (S.forEach(D => {
                    D.remove();
                }),
                    S.length > 0 && (s.recalcSlides(), s.updateSlides()));
            },
            h = s.grid && r.grid && r.grid.rows > 1;
        r.loopAddBlankSlides && (r.slidesPerGroup > 1 || h) && p();
        const m = r.slidesPerGroup * (h ? r.grid.rows : 1),
            y = s.slides.length % m !== 0,
            E = h && s.slides.length % r.grid.rows !== 0,
            v = S => {
                for (let D = 0; D < S; D += 1) {
                    const O = s.isElement
                        ? vu('swiper-slide', [r.slideBlankClass])
                        : vu('div', [r.slideClass, r.slideBlankClass]);
                    s.slidesEl.append(O);
                }
            };
        if (y) {
            if (r.loopAddBlankSlides) {
                const S = m - (s.slides.length % m);
                (v(S), s.recalcSlides(), s.updateSlides());
            } else
                yu(
                    'Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
                );
            d();
        } else if (E) {
            if (r.loopAddBlankSlides) {
                const S = r.grid.rows - (s.slides.length % r.grid.rows);
                (v(S), s.recalcSlides(), s.updateSlides());
            } else
                yu(
                    'Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
                );
            d();
        } else d();
        const N =
            r.centeredSlides || !!r.slidesOffsetBefore || !!r.slidesOffsetAfter;
        s.loopFix({
            slideRealIndex: i,
            direction: N ? void 0 : 'next',
            initial: l,
        });
    }
    function PT({
        slideRealIndex: i,
        slideTo: l = !0,
        direction: s,
        setTranslate: r,
        activeSlideIndex: u,
        initial: d,
        byController: p,
        byMousewheel: h,
    } = {}) {
        const m = this;
        if (!m.params.loop) return;
        m.emit('beforeLoopFix');
        const {
            slides: y,
            allowSlidePrev: E,
            allowSlideNext: v,
            slidesEl: N,
            params: S,
        } = m,
            {
                centeredSlides: D,
                slidesOffsetBefore: O,
                slidesOffsetAfter: k,
                initialSlide: _,
            } = S,
            I = D || !!O || !!k;
        if (
            ((m.allowSlidePrev = !0),
                (m.allowSlideNext = !0),
                m.virtual && S.virtual.enabled)
        ) {
            (l &&
                (!I && m.snapIndex === 0
                    ? m.slideTo(m.virtual.slides.length, 0, !1, !0)
                    : I && m.snapIndex < S.slidesPerView
                        ? m.slideTo(m.virtual.slides.length + m.snapIndex, 0, !1, !0)
                        : m.snapIndex === m.snapGrid.length - 1 &&
                        m.slideTo(m.virtual.slidesBefore, 0, !1, !0)),
                (m.allowSlidePrev = E),
                (m.allowSlideNext = v),
                m.emit('loopFix'));
            return;
        }
        let Y = S.slidesPerView;
        Y === 'auto'
            ? (Y = m.slidesPerViewDynamic())
            : ((Y = Math.ceil(parseFloat(S.slidesPerView, 10))),
                I && Y % 2 === 0 && (Y = Y + 1));
        const Z = S.slidesPerGroupAuto ? Y : S.slidesPerGroup;
        let P = I ? Math.max(Z, Math.ceil(Y / 2)) : Z;
        (P % Z !== 0 && (P += Z - (P % Z)),
            (P += S.loopAdditionalSlides),
            (m.loopedSlides = P));
        const le = m.grid && S.grid && S.grid.rows > 1;
        y.length < Y + P ||
            (m.params.effect === 'cards' && y.length < Y + P * 2)
            ? yu(
                'Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters'
            )
            : le &&
            S.grid.fill === 'row' &&
            yu(
                'Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`'
            );
        const q = [],
            W = [],
            K = le ? Math.ceil(y.length / S.grid.rows) : y.length,
            te = d && K - _ < Y && !I;
        let X = te ? _ : m.activeIndex;
        typeof u > 'u'
            ? (u = m.getSlideIndex(
                y.find(Q => Q.classList.contains(S.slideActiveClass))
            ))
            : (X = u);
        const oe = s === 'next' || !s,
            ge = s === 'prev' || !s;
        let Ee = 0,
            _e = 0;
        const ce =
            (le ? y[u].column : u) + (I && typeof r > 'u' ? -Y / 2 + 0.5 : 0);
        if (ce < P) {
            Ee = Math.max(P - ce, Z);
            for (let Q = 0; Q < P - ce; Q += 1) {
                const me = Q - Math.floor(Q / K) * K;
                if (le) {
                    const U = K - me - 1;
                    for (let re = y.length - 1; re >= 0; re -= 1)
                        y[re].column === U && q.push(re);
                } else q.push(K - me - 1);
            }
        } else if (ce + Y > K - P) {
            ((_e = Math.max(ce - (K - P * 2), Z)),
                te && (_e = Math.max(_e, Y - K + _ + 1)));
            for (let Q = 0; Q < _e; Q += 1) {
                const me = Q - Math.floor(Q / K) * K;
                le
                    ? y.forEach((U, re) => {
                        U.column === me && W.push(re);
                    })
                    : W.push(me);
            }
        }
        if (
            ((m.__preventObserver__ = !0),
                requestAnimationFrame(() => {
                    m.__preventObserver__ = !1;
                }),
                m.params.effect === 'cards' &&
                y.length < Y + P * 2 &&
                (W.includes(u) && W.splice(W.indexOf(u), 1),
                    q.includes(u) && q.splice(q.indexOf(u), 1)),
                ge &&
                q.forEach(Q => {
                    ((y[Q].swiperLoopMoveDOM = !0),
                        N.prepend(y[Q]),
                        (y[Q].swiperLoopMoveDOM = !1));
                }),
                oe &&
                W.forEach(Q => {
                    ((y[Q].swiperLoopMoveDOM = !0),
                        N.append(y[Q]),
                        (y[Q].swiperLoopMoveDOM = !1));
                }),
                m.recalcSlides(),
                S.slidesPerView === 'auto'
                    ? m.updateSlides()
                    : le &&
                    ((q.length > 0 && ge) || (W.length > 0 && oe)) &&
                    m.slides.forEach((Q, me) => {
                        m.grid.updateSlide(me, Q, m.slides);
                    }),
                S.watchSlidesProgress && m.updateSlidesOffset(),
                l)
        ) {
            if (q.length > 0 && ge) {
                if (typeof i > 'u') {
                    const Q = m.slidesGrid[X],
                        U = m.slidesGrid[X + Ee] - Q;
                    h
                        ? m.setTranslate(m.translate - U)
                        : (m.slideTo(X + Math.ceil(Ee), 0, !1, !0),
                            r &&
                            ((m.touchEventsData.startTranslate =
                                m.touchEventsData.startTranslate - U),
                                (m.touchEventsData.currentTranslate =
                                    m.touchEventsData.currentTranslate - U)));
                } else if (r) {
                    const Q = le ? q.length / S.grid.rows : q.length;
                    (m.slideTo(m.activeIndex + Q, 0, !1, !0),
                        (m.touchEventsData.currentTranslate = m.translate));
                }
            } else if (W.length > 0 && oe)
                if (typeof i > 'u') {
                    const Q = m.slidesGrid[X],
                        U = m.slidesGrid[X - _e] - Q;
                    h
                        ? m.setTranslate(m.translate - U)
                        : (m.slideTo(X - _e, 0, !1, !0),
                            r &&
                            ((m.touchEventsData.startTranslate =
                                m.touchEventsData.startTranslate - U),
                                (m.touchEventsData.currentTranslate =
                                    m.touchEventsData.currentTranslate - U)));
                } else {
                    const Q = le ? W.length / S.grid.rows : W.length;
                    m.slideTo(m.activeIndex - Q, 0, !1, !0);
                }
        }
        if (
            ((m.allowSlidePrev = E),
                (m.allowSlideNext = v),
                m.controller && m.controller.control && !p)
        ) {
            const Q = {
                slideRealIndex: i,
                direction: s,
                setTranslate: r,
                activeSlideIndex: u,
                byController: !0,
            };
            Array.isArray(m.controller.control)
                ? m.controller.control.forEach(me => {
                    !me.destroyed &&
                        me.params.loop &&
                        me.loopFix({
                            ...Q,
                            slideTo:
                                me.params.slidesPerView === S.slidesPerView ? l : !1,
                        });
                })
                : m.controller.control instanceof m.constructor &&
                m.controller.control.params.loop &&
                m.controller.control.loopFix({
                    ...Q,
                    slideTo:
                        m.controller.control.params.slidesPerView === S.slidesPerView
                            ? l
                            : !1,
                });
        }
        m.emit('loopFix');
    }
    function ZT() {
        const i = this,
            { params: l, slidesEl: s } = i;
        if (!l.loop || !s || (i.virtual && i.params.virtual.enabled)) return;
        i.recalcSlides();
        const r = [];
        (i.slides.forEach(u => {
            const d =
                typeof u.swiperSlideIndex > 'u'
                    ? u.getAttribute('data-swiper-slide-index') * 1
                    : u.swiperSlideIndex;
            r[d] = u;
        }),
            i.slides.forEach(u => {
                u.removeAttribute('data-swiper-slide-index');
            }),
            r.forEach(u => {
                s.append(u);
            }),
            i.recalcSlides(),
            i.slideTo(i.realIndex, 0));
    }
    var WT = { loopCreate: YT, loopFix: PT, loopDestroy: ZT };
    function XT(i) {
        const l = this;
        if (
            !l.params.simulateTouch ||
            (l.params.watchOverflow && l.isLocked) ||
            l.params.cssMode
        )
            return;
        const s =
            l.params.touchEventsTarget === 'container' ? l.el : l.wrapperEl;
        (l.isElement && (l.__preventObserver__ = !0),
            (s.style.cursor = 'move'),
            (s.style.cursor = i ? 'grabbing' : 'grab'),
            l.isElement &&
            requestAnimationFrame(() => {
                l.__preventObserver__ = !1;
            }));
    }
    function QT() {
        const i = this;
        (i.params.watchOverflow && i.isLocked) ||
            i.params.cssMode ||
            (i.isElement && (i.__preventObserver__ = !0),
                (i[
                    i.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'
                ].style.cursor = ''),
                i.isElement &&
                requestAnimationFrame(() => {
                    i.__preventObserver__ = !1;
                }));
    }
    var JT = { setGrabCursor: XT, unsetGrabCursor: QT };
    function qT(i, l = this) {
        function s(r) {
            if (!r || r === bl() || r === Jt()) return null;
            r.assignedSlot && (r = r.assignedSlot);
            const u = r.closest(i);
            return !u && !r.getRootNode ? null : u || s(r.getRootNode().host);
        }
        return s(l);
    }
    function C0(i, l, s) {
        const r = Jt(),
            { params: u } = i,
            d = u.edgeSwipeDetection,
            p = u.edgeSwipeThreshold;
        return d && (s <= p || s >= r.innerWidth - p)
            ? d === 'prevent'
                ? (l.preventDefault(), !0)
                : !1
            : !0;
    }
    function $T(i) {
        const l = this,
            s = bl();
        let r = i;
        r.originalEvent && (r = r.originalEvent);
        const u = l.touchEventsData;
        if (r.type === 'pointerdown') {
            if (u.pointerId !== null && u.pointerId !== r.pointerId) return;
            u.pointerId = r.pointerId;
        } else
            r.type === 'touchstart' &&
                r.targetTouches.length === 1 &&
                (u.touchId = r.targetTouches[0].identifier);
        if (r.type === 'touchstart') {
            C0(l, r, r.targetTouches[0].pageX);
            return;
        }
        const { params: d, touches: p, enabled: h } = l;
        if (
            !h ||
            (!d.simulateTouch && r.pointerType === 'mouse') ||
            (l.animating && d.preventInteractionOnTransition)
        )
            return;
        !l.animating && d.cssMode && d.loop && l.loopFix();
        let m = r.target;
        if (
            (d.touchEventsTarget === 'wrapper' && !iT(m, l.wrapperEl)) ||
            ('which' in r && r.which === 3) ||
            ('button' in r && r.button > 0) ||
            (u.isTouched && u.isMoved)
        )
            return;
        const y = !!d.noSwipingClass && d.noSwipingClass !== '',
            E = r.composedPath ? r.composedPath() : r.path;
        y && r.target && r.target.shadowRoot && E && (m = E[0]);
        const v = d.noSwipingSelector
            ? d.noSwipingSelector
            : `.${d.noSwipingClass}`,
            N = !!(r.target && r.target.shadowRoot);
        if (d.noSwiping && (N ? qT(v, m) : m.closest(v))) {
            l.allowClick = !0;
            return;
        }
        if (d.swipeHandler && !m.closest(d.swipeHandler)) return;
        ((p.currentX = r.pageX), (p.currentY = r.pageY));
        const S = p.currentX,
            D = p.currentY;
        if (!C0(l, r, S)) return;
        (Object.assign(u, {
            isTouched: !0,
            isMoved: !1,
            allowTouchCallbacks: !0,
            isScrolling: void 0,
            startMoving: void 0,
        }),
            (p.startX = S),
            (p.startY = D),
            (u.touchStartTime = bu()),
            (l.allowClick = !0),
            l.updateSize(),
            (l.swipeDirection = void 0),
            d.threshold > 0 && (u.allowThresholdMove = !1));
        let O = !0;
        (m.matches(u.focusableElements) &&
            ((O = !1), m.nodeName === 'SELECT' && (u.isTouched = !1)),
            s.activeElement &&
            s.activeElement.matches(u.focusableElements) &&
            s.activeElement !== m &&
            (r.pointerType === 'mouse' ||
                (r.pointerType !== 'mouse' && !m.matches(u.focusableElements))) &&
            s.activeElement.blur());
        const k = O && l.allowTouchMove && d.touchStartPreventDefault;
        ((d.touchStartForcePreventDefault || k) &&
            !m.isContentEditable &&
            r.preventDefault(),
            d.freeMode &&
            d.freeMode.enabled &&
            l.freeMode &&
            l.animating &&
            !d.cssMode &&
            l.freeMode.onTouchStart(),
            l.emit('touchStart', r));
    }
    function FT(i) {
        const l = bl(),
            s = this,
            r = s.touchEventsData,
            { params: u, touches: d, rtlTranslate: p, enabled: h } = s;
        if (!h || (!u.simulateTouch && i.pointerType === 'mouse')) return;
        let m = i;
        if (
            (m.originalEvent && (m = m.originalEvent),
                m.type === 'pointermove' &&
                (r.touchId !== null || m.pointerId !== r.pointerId))
        )
            return;
        let y;
        if (m.type === 'touchmove') {
            if (
                ((y = [...m.changedTouches].find(P => P.identifier === r.touchId)),
                    !y || y.identifier !== r.touchId)
            )
                return;
        } else y = m;
        if (!r.isTouched) {
            r.startMoving && r.isScrolling && s.emit('touchMoveOpposite', m);
            return;
        }
        const E = y.pageX,
            v = y.pageY;
        if (m.preventedByNestedSwiper) {
            ((d.startX = E), (d.startY = v));
            return;
        }
        if (!s.allowTouchMove) {
            (m.target.matches(r.focusableElements) || (s.allowClick = !1),
                r.isTouched &&
                (Object.assign(d, {
                    startX: E,
                    startY: v,
                    currentX: E,
                    currentY: v,
                }),
                    (r.touchStartTime = bu())));
            return;
        }
        if (u.touchReleaseOnEdges && !u.loop)
            if (s.isVertical()) {
                if (
                    (v < d.startY && s.translate <= s.maxTranslate()) ||
                    (v > d.startY && s.translate >= s.minTranslate())
                ) {
                    ((r.isTouched = !1), (r.isMoved = !1));
                    return;
                }
            } else {
                if (
                    p &&
                    ((E > d.startX && -s.translate <= s.maxTranslate()) ||
                        (E < d.startX && -s.translate >= s.minTranslate()))
                )
                    return;
                if (
                    !p &&
                    ((E < d.startX && s.translate <= s.maxTranslate()) ||
                        (E > d.startX && s.translate >= s.minTranslate()))
                )
                    return;
            }
        if (
            (l.activeElement &&
                l.activeElement.matches(r.focusableElements) &&
                l.activeElement !== m.target &&
                m.pointerType !== 'mouse' &&
                l.activeElement.blur(),
                l.activeElement &&
                m.target === l.activeElement &&
                m.target.matches(r.focusableElements))
        ) {
            ((r.isMoved = !0), (s.allowClick = !1));
            return;
        }
        (r.allowTouchCallbacks && s.emit('touchMove', m),
            (d.previousX = d.currentX),
            (d.previousY = d.currentY),
            (d.currentX = E),
            (d.currentY = v));
        const N = d.currentX - d.startX,
            S = d.currentY - d.startY;
        if (
            s.params.threshold &&
            Math.sqrt(N ** 2 + S ** 2) < s.params.threshold
        )
            return;
        if (typeof r.isScrolling > 'u') {
            let P;
            (s.isHorizontal() && d.currentY === d.startY) ||
                (s.isVertical() && d.currentX === d.startX)
                ? (r.isScrolling = !1)
                : N * N + S * S >= 25 &&
                ((P = (Math.atan2(Math.abs(S), Math.abs(N)) * 180) / Math.PI),
                    (r.isScrolling = s.isHorizontal()
                        ? P > u.touchAngle
                        : 90 - P > u.touchAngle));
        }
        if (
            (r.isScrolling && s.emit('touchMoveOpposite', m),
                typeof r.startMoving > 'u' &&
                (d.currentX !== d.startX || d.currentY !== d.startY) &&
                (r.startMoving = !0),
                r.isScrolling ||
                (m.type === 'touchmove' && r.preventTouchMoveFromPointerMove))
        ) {
            r.isTouched = !1;
            return;
        }
        if (!r.startMoving) return;
        ((s.allowClick = !1),
            !u.cssMode && m.cancelable && m.preventDefault(),
            u.touchMoveStopPropagation && !u.nested && m.stopPropagation());
        let D = s.isHorizontal() ? N : S,
            O = s.isHorizontal()
                ? d.currentX - d.previousX
                : d.currentY - d.previousY;
        (u.oneWayMovement &&
            ((D = Math.abs(D) * (p ? 1 : -1)), (O = Math.abs(O) * (p ? 1 : -1))),
            (d.diff = D),
            (D *= u.touchRatio),
            p && ((D = -D), (O = -O)));
        const k = s.touchesDirection;
        ((s.swipeDirection = D > 0 ? 'prev' : 'next'),
            (s.touchesDirection = O > 0 ? 'prev' : 'next'));
        const _ = s.params.loop && !u.cssMode,
            I =
                (s.touchesDirection === 'next' && s.allowSlideNext) ||
                (s.touchesDirection === 'prev' && s.allowSlidePrev);
        if (!r.isMoved) {
            if (
                (_ && I && s.loopFix({ direction: s.swipeDirection }),
                    (r.startTranslate = s.getTranslate()),
                    s.setTransition(0),
                    s.animating)
            ) {
                const P = new window.CustomEvent('transitionend', {
                    bubbles: !0,
                    cancelable: !0,
                    detail: { bySwiperTouchMove: !0 },
                });
                s.wrapperEl.dispatchEvent(P);
            }
            ((r.allowMomentumBounce = !1),
                u.grabCursor &&
                (s.allowSlideNext === !0 || s.allowSlidePrev === !0) &&
                s.setGrabCursor(!0),
                s.emit('sliderFirstMove', m));
        }
        if (
            (new Date().getTime(),
                u._loopSwapReset !== !1 &&
                r.isMoved &&
                r.allowThresholdMove &&
                k !== s.touchesDirection &&
                _ &&
                I &&
                Math.abs(D) >= 1)
        ) {
            (Object.assign(d, {
                startX: E,
                startY: v,
                currentX: E,
                currentY: v,
                startTranslate: r.currentTranslate,
            }),
                (r.loopSwapReset = !0),
                (r.startTranslate = r.currentTranslate));
            return;
        }
        (s.emit('sliderMove', m),
            (r.isMoved = !0),
            (r.currentTranslate = D + r.startTranslate));
        let Y = !0,
            Z = u.resistanceRatio;
        if (
            (u.touchReleaseOnEdges && (Z = 0),
                D > 0
                    ? (_ &&
                        I &&
                        r.allowThresholdMove &&
                        r.currentTranslate >
                        (u.centeredSlides
                            ? s.minTranslate() -
                            s.slidesSizesGrid[s.activeIndex + 1] -
                            (u.slidesPerView !== 'auto' &&
                                s.slides.length - u.slidesPerView >= 2
                                ? s.slidesSizesGrid[s.activeIndex + 1] +
                                s.params.spaceBetween
                                : 0) -
                            s.params.spaceBetween
                            : s.minTranslate()) &&
                        s.loopFix({
                            direction: 'prev',
                            setTranslate: !0,
                            activeSlideIndex: 0,
                        }),
                        r.currentTranslate > s.minTranslate() &&
                        ((Y = !1),
                            u.resistance &&
                            (r.currentTranslate =
                                s.minTranslate() -
                                1 +
                                (-s.minTranslate() + r.startTranslate + D) ** Z)))
                    : D < 0 &&
                    (_ &&
                        I &&
                        r.allowThresholdMove &&
                        r.currentTranslate <
                        (u.centeredSlides
                            ? s.maxTranslate() +
                            s.slidesSizesGrid[s.slidesSizesGrid.length - 1] +
                            s.params.spaceBetween +
                            (u.slidesPerView !== 'auto' &&
                                s.slides.length - u.slidesPerView >= 2
                                ? s.slidesSizesGrid[s.slidesSizesGrid.length - 1] +
                                s.params.spaceBetween
                                : 0)
                            : s.maxTranslate()) &&
                        s.loopFix({
                            direction: 'next',
                            setTranslate: !0,
                            activeSlideIndex:
                                s.slides.length -
                                (u.slidesPerView === 'auto'
                                    ? s.slidesPerViewDynamic()
                                    : Math.ceil(parseFloat(u.slidesPerView, 10))),
                        }),
                        r.currentTranslate < s.maxTranslate() &&
                        ((Y = !1),
                            u.resistance &&
                            (r.currentTranslate =
                                s.maxTranslate() +
                                1 -
                                (s.maxTranslate() - r.startTranslate - D) ** Z))),
                Y && (m.preventedByNestedSwiper = !0),
                !s.allowSlideNext &&
                s.swipeDirection === 'next' &&
                r.currentTranslate < r.startTranslate &&
                (r.currentTranslate = r.startTranslate),
                !s.allowSlidePrev &&
                s.swipeDirection === 'prev' &&
                r.currentTranslate > r.startTranslate &&
                (r.currentTranslate = r.startTranslate),
                !s.allowSlidePrev &&
                !s.allowSlideNext &&
                (r.currentTranslate = r.startTranslate),
                u.threshold > 0)
        )
            if (Math.abs(D) > u.threshold || r.allowThresholdMove) {
                if (!r.allowThresholdMove) {
                    ((r.allowThresholdMove = !0),
                        (d.startX = d.currentX),
                        (d.startY = d.currentY),
                        (r.currentTranslate = r.startTranslate),
                        (d.diff = s.isHorizontal()
                            ? d.currentX - d.startX
                            : d.currentY - d.startY));
                    return;
                }
            } else {
                r.currentTranslate = r.startTranslate;
                return;
            }
        !u.followFinger ||
            u.cssMode ||
            (((u.freeMode && u.freeMode.enabled && s.freeMode) ||
                u.watchSlidesProgress) &&
                (s.updateActiveIndex(), s.updateSlidesClasses()),
                u.freeMode &&
                u.freeMode.enabled &&
                s.freeMode &&
                s.freeMode.onTouchMove(),
                s.updateProgress(r.currentTranslate),
                s.setTranslate(r.currentTranslate));
    }
    function KT(i) {
        const l = this,
            s = l.touchEventsData;
        let r = i;
        r.originalEvent && (r = r.originalEvent);
        let u;
        if (r.type === 'touchend' || r.type === 'touchcancel') {
            if (
                ((u = [...r.changedTouches].find(P => P.identifier === s.touchId)),
                    !u || u.identifier !== s.touchId)
            )
                return;
        } else {
            if (s.touchId !== null || r.pointerId !== s.pointerId) return;
            u = r;
        }
        if (
            [
                'pointercancel',
                'pointerout',
                'pointerleave',
                'contextmenu',
            ].includes(r.type) &&
            !(
                ['pointercancel', 'contextmenu'].includes(r.type) &&
                (l.browser.isSafari || l.browser.isWebView)
            )
        )
            return;
        ((s.pointerId = null), (s.touchId = null));
        const {
            params: p,
            touches: h,
            rtlTranslate: m,
            slidesGrid: y,
            enabled: E,
        } = l;
        if (!E || (!p.simulateTouch && r.pointerType === 'mouse')) return;
        if (
            (s.allowTouchCallbacks && l.emit('touchEnd', r),
                (s.allowTouchCallbacks = !1),
                !s.isTouched)
        ) {
            (s.isMoved && p.grabCursor && l.setGrabCursor(!1),
                (s.isMoved = !1),
                (s.startMoving = !1));
            return;
        }
        p.grabCursor &&
            s.isMoved &&
            s.isTouched &&
            (l.allowSlideNext === !0 || l.allowSlidePrev === !0) &&
            l.setGrabCursor(!1);
        const v = bu(),
            N = v - s.touchStartTime;
        if (l.allowClick) {
            const P = r.path || (r.composedPath && r.composedPath());
            (l.updateClickedSlide((P && P[0]) || r.target, P),
                l.emit('tap click', r),
                N < 300 &&
                v - s.lastClickTime < 300 &&
                l.emit('doubleTap doubleClick', r));
        }
        if (
            ((s.lastClickTime = bu()),
                Z0(() => {
                    l.destroyed || (l.allowClick = !0);
                }),
                !s.isTouched ||
                !s.isMoved ||
                !l.swipeDirection ||
                (h.diff === 0 && !s.loopSwapReset) ||
                (s.currentTranslate === s.startTranslate && !s.loopSwapReset))
        ) {
            ((s.isTouched = !1), (s.isMoved = !1), (s.startMoving = !1));
            return;
        }
        ((s.isTouched = !1), (s.isMoved = !1), (s.startMoving = !1));
        let S;
        if (
            (p.followFinger
                ? (S = m ? l.translate : -l.translate)
                : (S = -s.currentTranslate),
                p.cssMode)
        )
            return;
        if (p.freeMode && p.freeMode.enabled) {
            l.freeMode.onTouchEnd({ currentPos: S });
            return;
        }
        const D = S >= -l.maxTranslate() && !l.params.loop;
        let O = 0,
            k = l.slidesSizesGrid[0];
        for (
            let P = 0;
            P < y.length;
            P += P < p.slidesPerGroupSkip ? 1 : p.slidesPerGroup
        ) {
            const le = P < p.slidesPerGroupSkip - 1 ? 1 : p.slidesPerGroup;
            typeof y[P + le] < 'u'
                ? (D || (S >= y[P] && S < y[P + le])) &&
                ((O = P), (k = y[P + le] - y[P]))
                : (D || S >= y[P]) &&
                ((O = P), (k = y[y.length - 1] - y[y.length - 2]));
        }
        let _ = null,
            I = null;
        p.rewind &&
            (l.isBeginning
                ? (I =
                    p.virtual && p.virtual.enabled && l.virtual
                        ? l.virtual.slides.length - 1
                        : l.slides.length - 1)
                : l.isEnd && (_ = 0));
        const Y = (S - y[O]) / k,
            Z = O < p.slidesPerGroupSkip - 1 ? 1 : p.slidesPerGroup;
        if (N > p.longSwipesMs) {
            if (!p.longSwipes) {
                l.slideTo(l.activeIndex);
                return;
            }
            (l.swipeDirection === 'next' &&
                (Y >= p.longSwipesRatio
                    ? l.slideTo(p.rewind && l.isEnd ? _ : O + Z)
                    : l.slideTo(O)),
                l.swipeDirection === 'prev' &&
                (Y > 1 - p.longSwipesRatio
                    ? l.slideTo(O + Z)
                    : I !== null && Y < 0 && Math.abs(Y) > p.longSwipesRatio
                        ? l.slideTo(I)
                        : l.slideTo(O)));
        } else {
            if (!p.shortSwipes) {
                l.slideTo(l.activeIndex);
                return;
            }
            l.navigation &&
                (r.target === l.navigation.nextEl || r.target === l.navigation.prevEl)
                ? r.target === l.navigation.nextEl
                    ? l.slideTo(O + Z)
                    : l.slideTo(O)
                : (l.swipeDirection === 'next' && l.slideTo(_ !== null ? _ : O + Z),
                    l.swipeDirection === 'prev' && l.slideTo(I !== null ? I : O));
        }
    }
    function R0() {
        const i = this,
            { params: l, el: s } = i;
        if (s && s.offsetWidth === 0) return;
        l.breakpoints && i.setBreakpoint();
        const { allowSlideNext: r, allowSlidePrev: u, snapGrid: d } = i,
            p = i.virtual && i.params.virtual.enabled;
        ((i.allowSlideNext = !0),
            (i.allowSlidePrev = !0),
            i.updateSize(),
            i.updateSlides(),
            i.updateSlidesClasses());
        const h = p && l.loop;
        ((l.slidesPerView === 'auto' || l.slidesPerView > 1) &&
            i.isEnd &&
            !i.isBeginning &&
            !i.params.centeredSlides &&
            !h
            ? i.slideTo(i.slides.length - 1, 0, !1, !0)
            : i.params.loop && !p
                ? i.slideToLoop(i.realIndex, 0, !1, !0)
                : i.slideTo(i.activeIndex, 0, !1, !0),
            i.autoplay &&
            i.autoplay.running &&
            i.autoplay.paused &&
            (clearTimeout(i.autoplay.resizeTimeout),
                (i.autoplay.resizeTimeout = setTimeout(() => {
                    i.autoplay &&
                        i.autoplay.running &&
                        i.autoplay.paused &&
                        i.autoplay.resume();
                }, 500))),
            (i.allowSlidePrev = u),
            (i.allowSlideNext = r),
            i.params.watchOverflow && d !== i.snapGrid && i.checkOverflow());
    }
    function eC(i) {
        const l = this;
        l.enabled &&
            (l.allowClick ||
                (l.params.preventClicks && i.preventDefault(),
                    l.params.preventClicksPropagation &&
                    l.animating &&
                    (i.stopPropagation(), i.stopImmediatePropagation())));
    }
    function tC() {
        const i = this,
            { wrapperEl: l, rtlTranslate: s, enabled: r } = i;
        if (!r) return;
        ((i.previousTranslate = i.translate),
            i.isHorizontal()
                ? (i.translate = -l.scrollLeft)
                : (i.translate = -l.scrollTop),
            i.translate === 0 && (i.translate = 0),
            i.updateActiveIndex(),
            i.updateSlidesClasses());
        let u;
        const d = i.maxTranslate() - i.minTranslate();
        (d === 0 ? (u = 0) : (u = (i.translate - i.minTranslate()) / d),
            u !== i.progress && i.updateProgress(s ? -i.translate : i.translate),
            i.emit('setTranslate', i.translate, !1));
    }
    function nC(i) {
        const l = this;
        (mu(l, i.target),
            !(
                l.params.cssMode ||
                (l.params.slidesPerView !== 'auto' && !l.params.autoHeight)
            ) && l.update());
    }
    function aC() {
        const i = this;
        i.documentTouchHandlerProceeded ||
            ((i.documentTouchHandlerProceeded = !0),
                i.params.touchReleaseOnEdges && (i.el.style.touchAction = 'auto'));
    }
    const $0 = (i, l) => {
        const s = bl(),
            { params: r, el: u, wrapperEl: d, device: p } = i,
            h = !!r.nested,
            m = l === 'on' ? 'addEventListener' : 'removeEventListener',
            y = l;
        !u ||
            typeof u == 'string' ||
            (s[m]('touchstart', i.onDocumentTouchStart, {
                passive: !1,
                capture: h,
            }),
                u[m]('touchstart', i.onTouchStart, { passive: !1 }),
                u[m]('pointerdown', i.onTouchStart, { passive: !1 }),
                s[m]('touchmove', i.onTouchMove, { passive: !1, capture: h }),
                s[m]('pointermove', i.onTouchMove, { passive: !1, capture: h }),
                s[m]('touchend', i.onTouchEnd, { passive: !0 }),
                s[m]('pointerup', i.onTouchEnd, { passive: !0 }),
                s[m]('pointercancel', i.onTouchEnd, { passive: !0 }),
                s[m]('touchcancel', i.onTouchEnd, { passive: !0 }),
                s[m]('pointerout', i.onTouchEnd, { passive: !0 }),
                s[m]('pointerleave', i.onTouchEnd, { passive: !0 }),
                s[m]('contextmenu', i.onTouchEnd, { passive: !0 }),
                (r.preventClicks || r.preventClicksPropagation) &&
                u[m]('click', i.onClick, !0),
                r.cssMode && d[m]('scroll', i.onScroll),
                r.updateOnWindowResize
                    ? i[y](
                        p.ios || p.android
                            ? 'resize orientationchange observerUpdate'
                            : 'resize observerUpdate',
                        R0,
                        !0
                    )
                    : i[y]('observerUpdate', R0, !0),
                u[m]('load', i.onLoad, { capture: !0 }));
    };
    function iC() {
        const i = this,
            { params: l } = i;
        ((i.onTouchStart = $T.bind(i)),
            (i.onTouchMove = FT.bind(i)),
            (i.onTouchEnd = KT.bind(i)),
            (i.onDocumentTouchStart = aC.bind(i)),
            l.cssMode && (i.onScroll = tC.bind(i)),
            (i.onClick = eC.bind(i)),
            (i.onLoad = nC.bind(i)),
            $0(i, 'on'));
    }
    function lC() {
        $0(this, 'off');
    }
    var oC = { attachEvents: iC, detachEvents: lC };
    const M0 = (i, l) => i.grid && l.grid && l.grid.rows > 1;
    function sC() {
        const i = this,
            { realIndex: l, initialized: s, params: r, el: u } = i,
            d = r.breakpoints;
        if (!d || (d && Object.keys(d).length === 0)) return;
        const p = bl(),
            h =
                r.breakpointsBase === 'window' || !r.breakpointsBase
                    ? r.breakpointsBase
                    : 'container',
            m =
                ['window', 'container'].includes(r.breakpointsBase) ||
                    !r.breakpointsBase
                    ? i.el
                    : p.querySelector(r.breakpointsBase),
            y = i.getBreakpoint(d, h, m);
        if (!y || i.currentBreakpoint === y) return;
        const v = (y in d ? d[y] : void 0) || i.originalParams,
            N = M0(i, r),
            S = M0(i, v),
            D = i.params.grabCursor,
            O = v.grabCursor,
            k = r.enabled;
        (N && !S
            ? (u.classList.remove(
                `${r.containerModifierClass}grid`,
                `${r.containerModifierClass}grid-column`
            ),
                i.emitContainerClasses())
            : !N &&
            S &&
            (u.classList.add(`${r.containerModifierClass}grid`),
                ((v.grid.fill && v.grid.fill === 'column') ||
                    (!v.grid.fill && r.grid.fill === 'column')) &&
                u.classList.add(`${r.containerModifierClass}grid-column`),
                i.emitContainerClasses()),
            D && !O ? i.unsetGrabCursor() : !D && O && i.setGrabCursor(),
            ['navigation', 'pagination', 'scrollbar'].forEach(le => {
                if (typeof v[le] > 'u') return;
                const q = r[le] && r[le].enabled,
                    W = v[le] && v[le].enabled;
                (q && !W && i[le].disable(), !q && W && i[le].enable());
            }));
        const _ = v.direction && v.direction !== r.direction,
            I = r.loop && (v.slidesPerView !== r.slidesPerView || _),
            Y = r.loop;
        (_ && s && i.changeDirection(), gn(i.params, v));
        const Z = i.params.enabled,
            P = i.params.loop;
        (Object.assign(i, {
            allowTouchMove: i.params.allowTouchMove,
            allowSlideNext: i.params.allowSlideNext,
            allowSlidePrev: i.params.allowSlidePrev,
        }),
            k && !Z ? i.disable() : !k && Z && i.enable(),
            (i.currentBreakpoint = y),
            i.emit('_beforeBreakpoint', v),
            s &&
            (I
                ? (i.loopDestroy(), i.loopCreate(l), i.updateSlides())
                : !Y && P
                    ? (i.loopCreate(l), i.updateSlides())
                    : Y && !P && i.loopDestroy()),
            i.emit('breakpoint', v));
    }
    function rC(i, l = 'window', s) {
        if (!i || (l === 'container' && !s)) return;
        let r = !1;
        const u = Jt(),
            d = l === 'window' ? u.innerHeight : s.clientHeight,
            p = Object.keys(i).map(h => {
                if (typeof h == 'string' && h.indexOf('@') === 0) {
                    const m = parseFloat(h.substr(1));
                    return { value: d * m, point: h };
                }
                return { value: h, point: h };
            });
        p.sort((h, m) => parseInt(h.value, 10) - parseInt(m.value, 10));
        for (let h = 0; h < p.length; h += 1) {
            const { point: m, value: y } = p[h];
            l === 'window'
                ? u.matchMedia(`(min-width: ${y}px)`).matches && (r = m)
                : y <= s.clientWidth && (r = m);
        }
        return r || 'max';
    }
    var cC = { setBreakpoint: sC, getBreakpoint: rC };
    function uC(i, l) {
        const s = [];
        return (
            i.forEach(r => {
                typeof r == 'object'
                    ? Object.keys(r).forEach(u => {
                        r[u] && s.push(l + u);
                    })
                    : typeof r == 'string' && s.push(l + r);
            }),
            s
        );
    }
    function dC() {
        const i = this,
            { classNames: l, params: s, rtl: r, el: u, device: d } = i,
            p = uC(
                [
                    'initialized',
                    s.direction,
                    { 'free-mode': i.params.freeMode && s.freeMode.enabled },
                    { autoheight: s.autoHeight },
                    { rtl: r },
                    { grid: s.grid && s.grid.rows > 1 },
                    {
                        'grid-column':
                            s.grid && s.grid.rows > 1 && s.grid.fill === 'column',
                    },
                    { android: d.android },
                    { ios: d.ios },
                    { 'css-mode': s.cssMode },
                    { centered: s.cssMode && s.centeredSlides },
                    { 'watch-progress': s.watchSlidesProgress },
                ],
                s.containerModifierClass
            );
        (l.push(...p), u.classList.add(...l), i.emitContainerClasses());
    }
    function fC() {
        const i = this,
            { el: l, classNames: s } = i;
        !l ||
            typeof l == 'string' ||
            (l.classList.remove(...s), i.emitContainerClasses());
    }
    var mC = { addClasses: dC, removeClasses: fC };
    function pC() {
        const i = this,
            { isLocked: l, params: s } = i,
            { slidesOffsetBefore: r } = s;
        if (r) {
            const u = i.slides.length - 1,
                d = i.slidesGrid[u] + i.slidesSizesGrid[u] + r * 2;
            i.isLocked = i.size > d;
        } else i.isLocked = i.snapGrid.length === 1;
        (s.allowSlideNext === !0 && (i.allowSlideNext = !i.isLocked),
            s.allowSlidePrev === !0 && (i.allowSlidePrev = !i.isLocked),
            l && l !== i.isLocked && (i.isEnd = !1),
            l !== i.isLocked && i.emit(i.isLocked ? 'lock' : 'unlock'));
    }
    var hC = { checkOverflow: pC },
        jp = {
            init: !0,
            direction: 'horizontal',
            oneWayMovement: !1,
            swiperElementNodeName: 'SWIPER-CONTAINER',
            touchEventsTarget: 'wrapper',
            initialSlide: 0,
            speed: 300,
            cssMode: !1,
            updateOnWindowResize: !0,
            resizeObserver: !0,
            nested: !1,
            createElements: !1,
            eventsPrefix: 'swiper',
            enabled: !0,
            focusableElements:
                'input, select, option, textarea, button, video, label',
            width: null,
            height: null,
            preventInteractionOnTransition: !1,
            userAgent: null,
            url: null,
            edgeSwipeDetection: !1,
            edgeSwipeThreshold: 20,
            autoHeight: !1,
            setWrapperSize: !1,
            virtualTranslate: !1,
            effect: 'slide',
            breakpoints: void 0,
            breakpointsBase: 'window',
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerGroup: 1,
            slidesPerGroupSkip: 0,
            slidesPerGroupAuto: !1,
            centeredSlides: !1,
            centeredSlidesBounds: !1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            normalizeSlideIndex: !0,
            centerInsufficientSlides: !1,
            watchOverflow: !0,
            roundLengths: !1,
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: !0,
            shortSwipes: !0,
            longSwipes: !0,
            longSwipesRatio: 0.5,
            longSwipesMs: 300,
            followFinger: !0,
            allowTouchMove: !0,
            threshold: 5,
            touchMoveStopPropagation: !1,
            touchStartPreventDefault: !0,
            touchStartForcePreventDefault: !1,
            touchReleaseOnEdges: !1,
            uniqueNavElements: !0,
            resistance: !0,
            resistanceRatio: 0.85,
            watchSlidesProgress: !1,
            grabCursor: !1,
            preventClicks: !0,
            preventClicksPropagation: !0,
            slideToClickedSlide: !1,
            loop: !1,
            loopAddBlankSlides: !0,
            loopAdditionalSlides: 0,
            loopPreventsSliding: !0,
            rewind: !1,
            allowSlidePrev: !0,
            allowSlideNext: !0,
            swipeHandler: null,
            noSwiping: !0,
            noSwipingClass: 'swiper-no-swiping',
            noSwipingSelector: null,
            passiveListeners: !0,
            maxBackfaceHiddenSlides: 10,
            containerModifierClass: 'swiper-',
            slideClass: 'swiper-slide',
            slideBlankClass: 'swiper-slide-blank',
            slideActiveClass: 'swiper-slide-active',
            slideVisibleClass: 'swiper-slide-visible',
            slideFullyVisibleClass: 'swiper-slide-fully-visible',
            slideNextClass: 'swiper-slide-next',
            slidePrevClass: 'swiper-slide-prev',
            wrapperClass: 'swiper-wrapper',
            lazyPreloaderClass: 'swiper-lazy-preloader',
            lazyPreloadPrevNext: 0,
            runCallbacksOnInit: !0,
            _emitClasses: !1,
        };
    function gC(i, l) {
        return function (r = {}) {
            const u = Object.keys(r)[0],
                d = r[u];
            if (typeof d != 'object' || d === null) {
                gn(l, r);
                return;
            }
            if (
                (i[u] === !0 && (i[u] = { enabled: !0 }),
                    u === 'navigation' &&
                    i[u] &&
                    i[u].enabled &&
                    !i[u].prevEl &&
                    !i[u].nextEl &&
                    (i[u].auto = !0),
                    ['pagination', 'scrollbar'].indexOf(u) >= 0 &&
                    i[u] &&
                    i[u].enabled &&
                    !i[u].el &&
                    (i[u].auto = !0),
                    !(u in i && 'enabled' in d))
            ) {
                gn(l, r);
                return;
            }
            (typeof i[u] == 'object' &&
                !('enabled' in i[u]) &&
                (i[u].enabled = !0),
                i[u] || (i[u] = { enabled: !1 }),
                gn(l, r));
        };
    }
    const bp = {
        eventsEmitter: mT,
        update: ET,
        translate: MT,
        transition: VT,
        slide: _T,
        loop: WT,
        grabCursor: JT,
        events: oC,
        breakpoints: cC,
        checkOverflow: hC,
        classes: mC,
    },
        yp = {};
    let Bp = class Wa {
        constructor(...l) {
            let s, r;
            (l.length === 1 &&
                l[0].constructor &&
                Object.prototype.toString.call(l[0]).slice(8, -1) === 'Object'
                ? (r = l[0])
                : ([s, r] = l),
                r || (r = {}),
                (r = gn({}, r)),
                s && !r.el && (r.el = s));
            const u = bl();
            if (
                r.el &&
                typeof r.el == 'string' &&
                u.querySelectorAll(r.el).length > 1
            ) {
                const m = [];
                return (
                    u.querySelectorAll(r.el).forEach(y => {
                        const E = gn({}, r, { el: y });
                        m.push(new Wa(E));
                    }),
                    m
                );
            }
            const d = this;
            ((d.__swiper__ = !0),
                (d.support = X0()),
                (d.device = Q0({ userAgent: r.userAgent })),
                (d.browser = J0()),
                (d.eventsListeners = {}),
                (d.eventsAnyListeners = []),
                (d.modules = [...d.__modules__]),
                r.modules &&
                Array.isArray(r.modules) &&
                d.modules.push(...r.modules));
            const p = {};
            d.modules.forEach(m => {
                m({
                    params: r,
                    swiper: d,
                    extendParams: gC(r, p),
                    on: d.on.bind(d),
                    once: d.once.bind(d),
                    off: d.off.bind(d),
                    emit: d.emit.bind(d),
                });
            });
            const h = gn({}, jp, p);
            return (
                (d.params = gn({}, h, yp, r)),
                (d.originalParams = gn({}, d.params)),
                (d.passedParams = gn({}, r)),
                d.params &&
                d.params.on &&
                Object.keys(d.params.on).forEach(m => {
                    d.on(m, d.params.on[m]);
                }),
                d.params && d.params.onAny && d.onAny(d.params.onAny),
                Object.assign(d, {
                    enabled: d.params.enabled,
                    el: s,
                    classNames: [],
                    slides: [],
                    slidesGrid: [],
                    snapGrid: [],
                    slidesSizesGrid: [],
                    isHorizontal() {
                        return d.params.direction === 'horizontal';
                    },
                    isVertical() {
                        return d.params.direction === 'vertical';
                    },
                    activeIndex: 0,
                    realIndex: 0,
                    isBeginning: !0,
                    isEnd: !1,
                    translate: 0,
                    previousTranslate: 0,
                    progress: 0,
                    velocity: 0,
                    animating: !1,
                    cssOverflowAdjustment() {
                        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
                    },
                    allowSlideNext: d.params.allowSlideNext,
                    allowSlidePrev: d.params.allowSlidePrev,
                    touchEventsData: {
                        isTouched: void 0,
                        isMoved: void 0,
                        allowTouchCallbacks: void 0,
                        touchStartTime: void 0,
                        isScrolling: void 0,
                        currentTranslate: void 0,
                        startTranslate: void 0,
                        allowThresholdMove: void 0,
                        focusableElements: d.params.focusableElements,
                        lastClickTime: 0,
                        clickTimeout: void 0,
                        velocities: [],
                        allowMomentumBounce: void 0,
                        startMoving: void 0,
                        pointerId: null,
                        touchId: null,
                    },
                    allowClick: !0,
                    allowTouchMove: d.params.allowTouchMove,
                    touches: {
                        startX: 0,
                        startY: 0,
                        currentX: 0,
                        currentY: 0,
                        diff: 0,
                    },
                    imagesToLoad: [],
                    imagesLoaded: 0,
                }),
                d.emit('_swiper'),
                d.params.init && d.init(),
                d
            );
        }
        getDirectionLabel(l) {
            return this.isHorizontal()
                ? l
                : {
                    width: 'height',
                    'margin-top': 'margin-left',
                    'margin-bottom ': 'margin-right',
                    'margin-left': 'margin-top',
                    'margin-right': 'margin-bottom',
                    'padding-left': 'padding-top',
                    'padding-right': 'padding-bottom',
                    marginRight: 'marginBottom',
                }[l];
        }
        getSlideIndex(l) {
            const { slidesEl: s, params: r } = this,
                u = ya(s, `.${r.slideClass}, swiper-slide`),
                d = A0(u[0]);
            return A0(l) - d;
        }
        getSlideIndexByData(l) {
            return this.getSlideIndex(
                this.slides.find(
                    s => s.getAttribute('data-swiper-slide-index') * 1 === l
                )
            );
        }
        getSlideIndexWhenGrid(l) {
            return (
                this.grid &&
                this.params.grid &&
                this.params.grid.rows > 1 &&
                (this.params.grid.fill === 'column'
                    ? (l = Math.floor(l / this.params.grid.rows))
                    : this.params.grid.fill === 'row' &&
                    (l =
                        l % Math.ceil(this.slides.length / this.params.grid.rows))),
                l
            );
        }
        recalcSlides() {
            const l = this,
                { slidesEl: s, params: r } = l;
            l.slides = ya(s, `.${r.slideClass}, swiper-slide`);
        }
        enable() {
            const l = this;
            l.enabled ||
                ((l.enabled = !0),
                    l.params.grabCursor && l.setGrabCursor(),
                    l.emit('enable'));
        }
        disable() {
            const l = this;
            l.enabled &&
                ((l.enabled = !1),
                    l.params.grabCursor && l.unsetGrabCursor(),
                    l.emit('disable'));
        }
        setProgress(l, s) {
            const r = this;
            l = Math.min(Math.max(l, 0), 1);
            const u = r.minTranslate(),
                p = (r.maxTranslate() - u) * l + u;
            (r.translateTo(p, typeof s > 'u' ? 0 : s),
                r.updateActiveIndex(),
                r.updateSlidesClasses());
        }
        emitContainerClasses() {
            const l = this;
            if (!l.params._emitClasses || !l.el) return;
            const s = l.el.className
                .split(' ')
                .filter(
                    r =>
                        r.indexOf('swiper') === 0 ||
                        r.indexOf(l.params.containerModifierClass) === 0
                );
            l.emit('_containerClasses', s.join(' '));
        }
        getSlideClasses(l) {
            const s = this;
            return s.destroyed
                ? ''
                : l.className
                    .split(' ')
                    .filter(
                        r =>
                            r.indexOf('swiper-slide') === 0 ||
                            r.indexOf(s.params.slideClass) === 0
                    )
                    .join(' ');
        }
        emitSlidesClasses() {
            const l = this;
            if (!l.params._emitClasses || !l.el) return;
            const s = [];
            (l.slides.forEach(r => {
                const u = l.getSlideClasses(r);
                (s.push({ slideEl: r, classNames: u }),
                    l.emit('_slideClass', r, u));
            }),
                l.emit('_slideClasses', s));
        }
        slidesPerViewDynamic(l = 'current', s = !1) {
            const r = this,
                {
                    params: u,
                    slides: d,
                    slidesGrid: p,
                    slidesSizesGrid: h,
                    size: m,
                    activeIndex: y,
                } = r;
            let E = 1;
            if (typeof u.slidesPerView == 'number') return u.slidesPerView;
            if (u.centeredSlides) {
                let v = d[y] ? Math.ceil(d[y].swiperSlideSize) : 0,
                    N;
                for (let S = y + 1; S < d.length; S += 1)
                    d[S] &&
                        !N &&
                        ((v += Math.ceil(d[S].swiperSlideSize)),
                            (E += 1),
                            v > m && (N = !0));
                for (let S = y - 1; S >= 0; S -= 1)
                    d[S] &&
                        !N &&
                        ((v += d[S].swiperSlideSize), (E += 1), v > m && (N = !0));
            } else if (l === 'current')
                for (let v = y + 1; v < d.length; v += 1)
                    (s ? p[v] + h[v] - p[y] < m : p[v] - p[y] < m) && (E += 1);
            else for (let v = y - 1; v >= 0; v -= 1) p[y] - p[v] < m && (E += 1);
            return E;
        }
        update() {
            const l = this;
            if (!l || l.destroyed) return;
            const { snapGrid: s, params: r } = l;
            (r.breakpoints && l.setBreakpoint(),
                [...l.el.querySelectorAll('[loading="lazy"]')].forEach(p => {
                    p.complete && mu(l, p);
                }),
                l.updateSize(),
                l.updateSlides(),
                l.updateProgress(),
                l.updateSlidesClasses());
            function u() {
                const p = l.rtlTranslate ? l.translate * -1 : l.translate,
                    h = Math.min(Math.max(p, l.maxTranslate()), l.minTranslate());
                (l.setTranslate(h), l.updateActiveIndex(), l.updateSlidesClasses());
            }
            let d;
            if (r.freeMode && r.freeMode.enabled && !r.cssMode)
                (u(), r.autoHeight && l.updateAutoHeight());
            else {
                if (
                    (r.slidesPerView === 'auto' || r.slidesPerView > 1) &&
                    l.isEnd &&
                    !r.centeredSlides
                ) {
                    const p =
                        l.virtual && r.virtual.enabled ? l.virtual.slides : l.slides;
                    d = l.slideTo(p.length - 1, 0, !1, !0);
                } else d = l.slideTo(l.activeIndex, 0, !1, !0);
                d || u();
            }
            (r.watchOverflow && s !== l.snapGrid && l.checkOverflow(),
                l.emit('update'));
        }
        changeDirection(l, s = !0) {
            const r = this,
                u = r.params.direction;
            return (
                l || (l = u === 'horizontal' ? 'vertical' : 'horizontal'),
                l === u ||
                (l !== 'horizontal' && l !== 'vertical') ||
                (r.el.classList.remove(`${r.params.containerModifierClass}${u}`),
                    r.el.classList.add(`${r.params.containerModifierClass}${l}`),
                    r.emitContainerClasses(),
                    (r.params.direction = l),
                    r.slides.forEach(d => {
                        l === 'vertical' ? (d.style.width = '') : (d.style.height = '');
                    }),
                    r.emit('changeDirection'),
                    s && r.update()),
                r
            );
        }
        changeLanguageDirection(l) {
            const s = this;
            (s.rtl && l === 'rtl') ||
                (!s.rtl && l === 'ltr') ||
                ((s.rtl = l === 'rtl'),
                    (s.rtlTranslate = s.params.direction === 'horizontal' && s.rtl),
                    s.rtl
                        ? (s.el.classList.add(`${s.params.containerModifierClass}rtl`),
                            (s.el.dir = 'rtl'))
                        : (s.el.classList.remove(`${s.params.containerModifierClass}rtl`),
                            (s.el.dir = 'ltr')),
                    s.update());
        }
        mount(l) {
            const s = this;
            if (s.mounted) return !0;
            let r = l || s.params.el;
            if ((typeof r == 'string' && (r = document.querySelector(r)), !r))
                return !1;
            ((r.swiper = s),
                r.parentNode &&
                r.parentNode.host &&
                r.parentNode.host.nodeName ===
                s.params.swiperElementNodeName.toUpperCase() &&
                (s.isElement = !0));
            const u = () =>
                `.${(s.params.wrapperClass || '').trim().split(' ').join('.')}`;
            let p =
                r && r.shadowRoot && r.shadowRoot.querySelector
                    ? r.shadowRoot.querySelector(u())
                    : ya(r, u())[0];
            return (
                !p &&
                s.params.createElements &&
                ((p = vu('div', s.params.wrapperClass)),
                    r.append(p),
                    ya(r, `.${s.params.slideClass}`).forEach(h => {
                        p.append(h);
                    })),
                Object.assign(s, {
                    el: r,
                    wrapperEl: p,
                    slidesEl:
                        s.isElement && !r.parentNode.host.slideSlots
                            ? r.parentNode.host
                            : p,
                    hostEl: s.isElement ? r.parentNode.host : r,
                    mounted: !0,
                    rtl:
                        r.dir.toLowerCase() === 'rtl' || Ci(r, 'direction') === 'rtl',
                    rtlTranslate:
                        s.params.direction === 'horizontal' &&
                        (r.dir.toLowerCase() === 'rtl' || Ci(r, 'direction') === 'rtl'),
                    wrongRTL: Ci(p, 'display') === '-webkit-box',
                }),
                !0
            );
        }
        init(l) {
            const s = this;
            if (s.initialized || s.mount(l) === !1) return s;
            (s.emit('beforeInit'),
                s.params.breakpoints && s.setBreakpoint(),
                s.addClasses(),
                s.updateSize(),
                s.updateSlides(),
                s.params.watchOverflow && s.checkOverflow(),
                s.params.grabCursor && s.enabled && s.setGrabCursor(),
                s.params.loop && s.virtual && s.params.virtual.enabled
                    ? s.slideTo(
                        s.params.initialSlide + s.virtual.slidesBefore,
                        0,
                        s.params.runCallbacksOnInit,
                        !1,
                        !0
                    )
                    : s.slideTo(
                        s.params.initialSlide,
                        0,
                        s.params.runCallbacksOnInit,
                        !1,
                        !0
                    ),
                s.params.loop && s.loopCreate(void 0, !0),
                s.attachEvents());
            const u = [...s.el.querySelectorAll('[loading="lazy"]')];
            return (
                s.isElement &&
                u.push(...s.hostEl.querySelectorAll('[loading="lazy"]')),
                u.forEach(d => {
                    d.complete
                        ? mu(s, d)
                        : d.addEventListener('load', p => {
                            mu(s, p.target);
                        });
                }),
                kp(s),
                (s.initialized = !0),
                kp(s),
                s.emit('init'),
                s.emit('afterInit'),
                s
            );
        }
        destroy(l = !0, s = !0) {
            const r = this,
                { params: u, el: d, wrapperEl: p, slides: h } = r;
            return (
                typeof r.params > 'u' ||
                r.destroyed ||
                (r.emit('beforeDestroy'),
                    (r.initialized = !1),
                    r.detachEvents(),
                    u.loop && r.loopDestroy(),
                    s &&
                    (r.removeClasses(),
                        d && typeof d != 'string' && d.removeAttribute('style'),
                        p && p.removeAttribute('style'),
                        h &&
                        h.length &&
                        h.forEach(m => {
                            (m.classList.remove(
                                u.slideVisibleClass,
                                u.slideFullyVisibleClass,
                                u.slideActiveClass,
                                u.slideNextClass,
                                u.slidePrevClass
                            ),
                                m.removeAttribute('style'),
                                m.removeAttribute('data-swiper-slide-index'));
                        })),
                    r.emit('destroy'),
                    Object.keys(r.eventsListeners).forEach(m => {
                        r.off(m);
                    }),
                    l !== !1 &&
                    (r.el && typeof r.el != 'string' && (r.el.swiper = null),
                        KD(r)),
                    (r.destroyed = !0)),
                null
            );
        }
        static extendDefaults(l) {
            gn(yp, l);
        }
        static get extendedDefaults() {
            return yp;
        }
        static get defaults() {
            return jp;
        }
        static installModule(l) {
            Wa.prototype.__modules__ || (Wa.prototype.__modules__ = []);
            const s = Wa.prototype.__modules__;
            typeof l == 'function' && s.indexOf(l) < 0 && s.push(l);
        }
        static use(l) {
            return Array.isArray(l)
                ? (l.forEach(s => Wa.installModule(s)), Wa)
                : (Wa.installModule(l), Wa);
        }
    };
    Object.keys(bp).forEach(i => {
        Object.keys(bp[i]).forEach(l => {
            Bp.prototype[l] = bp[i][l];
        });
    });
    Bp.use([dT, fT]);
    const F0 = [
        'eventsPrefix',
        'injectStyles',
        'injectStylesUrls',
        'modules',
        'init',
        '_direction',
        'oneWayMovement',
        'swiperElementNodeName',
        'touchEventsTarget',
        'initialSlide',
        '_speed',
        'cssMode',
        'updateOnWindowResize',
        'resizeObserver',
        'nested',
        'focusableElements',
        '_enabled',
        '_width',
        '_height',
        'preventInteractionOnTransition',
        'userAgent',
        'url',
        '_edgeSwipeDetection',
        '_edgeSwipeThreshold',
        '_freeMode',
        '_autoHeight',
        'setWrapperSize',
        'virtualTranslate',
        '_effect',
        'breakpoints',
        'breakpointsBase',
        '_spaceBetween',
        '_slidesPerView',
        'maxBackfaceHiddenSlides',
        '_grid',
        '_slidesPerGroup',
        '_slidesPerGroupSkip',
        '_slidesPerGroupAuto',
        '_centeredSlides',
        '_centeredSlidesBounds',
        '_slidesOffsetBefore',
        '_slidesOffsetAfter',
        'normalizeSlideIndex',
        '_centerInsufficientSlides',
        '_watchOverflow',
        'roundLengths',
        'touchRatio',
        'touchAngle',
        'simulateTouch',
        '_shortSwipes',
        '_longSwipes',
        'longSwipesRatio',
        'longSwipesMs',
        '_followFinger',
        'allowTouchMove',
        '_threshold',
        'touchMoveStopPropagation',
        'touchStartPreventDefault',
        'touchStartForcePreventDefault',
        'touchReleaseOnEdges',
        'uniqueNavElements',
        '_resistance',
        '_resistanceRatio',
        '_watchSlidesProgress',
        '_grabCursor',
        'preventClicks',
        'preventClicksPropagation',
        '_slideToClickedSlide',
        '_loop',
        'loopAdditionalSlides',
        'loopAddBlankSlides',
        'loopPreventsSliding',
        '_rewind',
        '_allowSlidePrev',
        '_allowSlideNext',
        '_swipeHandler',
        '_noSwiping',
        'noSwipingClass',
        'noSwipingSelector',
        'passiveListeners',
        'containerModifierClass',
        'slideClass',
        'slideActiveClass',
        'slideVisibleClass',
        'slideFullyVisibleClass',
        'slideNextClass',
        'slidePrevClass',
        'slideBlankClass',
        'wrapperClass',
        'lazyPreloaderClass',
        'lazyPreloadPrevNext',
        'runCallbacksOnInit',
        'observer',
        'observeParents',
        'observeSlideChildren',
        'a11y',
        '_autoplay',
        '_controller',
        'coverflowEffect',
        'cubeEffect',
        'fadeEffect',
        'flipEffect',
        'creativeEffect',
        'cardsEffect',
        'hashNavigation',
        'history',
        'keyboard',
        'mousewheel',
        '_navigation',
        '_pagination',
        'parallax',
        '_scrollbar',
        '_thumbs',
        'virtual',
        'zoom',
        'control',
    ];
    function gl(i) {
        return (
            typeof i == 'object' &&
            i !== null &&
            i.constructor &&
            Object.prototype.toString.call(i).slice(8, -1) === 'Object' &&
            !i.__swiper__
        );
    }
    function Eo(i, l) {
        const s = ['__proto__', 'constructor', 'prototype'];
        Object.keys(l)
            .filter(r => s.indexOf(r) < 0)
            .forEach(r => {
                typeof i[r] > 'u'
                    ? (i[r] = l[r])
                    : gl(l[r]) && gl(i[r]) && Object.keys(l[r]).length > 0
                        ? l[r].__swiper__
                            ? (i[r] = l[r])
                            : Eo(i[r], l[r])
                        : (i[r] = l[r]);
            });
    }
    function K0(i = {}) {
        return (
            i.navigation &&
            typeof i.navigation.nextEl > 'u' &&
            typeof i.navigation.prevEl > 'u'
        );
    }
    function eS(i = {}) {
        return i.pagination && typeof i.pagination.el > 'u';
    }
    function tS(i = {}) {
        return i.scrollbar && typeof i.scrollbar.el > 'u';
    }
    function nS(i = '') {
        const l = i
            .split(' ')
            .map(r => r.trim())
            .filter(r => !!r),
            s = [];
        return (
            l.forEach(r => {
                s.indexOf(r) < 0 && s.push(r);
            }),
            s.join(' ')
        );
    }
    function bC(i = '') {
        return i
            ? i.includes('swiper-wrapper')
                ? i
                : `swiper-wrapper ${i}`
            : 'swiper-wrapper';
    }
    function yC({
        swiper: i,
        slides: l,
        passedParams: s,
        changedParams: r,
        nextEl: u,
        prevEl: d,
        scrollbarEl: p,
        paginationEl: h,
    }) {
        const m = r.filter(
            W => W !== 'children' && W !== 'direction' && W !== 'wrapperClass'
        ),
            {
                params: y,
                pagination: E,
                navigation: v,
                scrollbar: N,
                virtual: S,
                thumbs: D,
            } = i;
        let O, k, _, I, Y, Z, P, le;
        (r.includes('thumbs') &&
            s.thumbs &&
            s.thumbs.swiper &&
            !s.thumbs.swiper.destroyed &&
            y.thumbs &&
            (!y.thumbs.swiper || y.thumbs.swiper.destroyed) &&
            (O = !0),
            r.includes('controller') &&
            s.controller &&
            s.controller.control &&
            y.controller &&
            !y.controller.control &&
            (k = !0),
            r.includes('pagination') &&
            s.pagination &&
            (s.pagination.el || h) &&
            (y.pagination || y.pagination === !1) &&
            E &&
            !E.el &&
            (_ = !0),
            r.includes('scrollbar') &&
            s.scrollbar &&
            (s.scrollbar.el || p) &&
            (y.scrollbar || y.scrollbar === !1) &&
            N &&
            !N.el &&
            (I = !0),
            r.includes('navigation') &&
            s.navigation &&
            (s.navigation.prevEl || d) &&
            (s.navigation.nextEl || u) &&
            (y.navigation || y.navigation === !1) &&
            v &&
            !v.prevEl &&
            !v.nextEl &&
            (Y = !0));
        const q = W => {
            i[W] &&
                (i[W].destroy(),
                    W === 'navigation'
                        ? (i.isElement && (i[W].prevEl.remove(), i[W].nextEl.remove()),
                            (y[W].prevEl = void 0),
                            (y[W].nextEl = void 0),
                            (i[W].prevEl = void 0),
                            (i[W].nextEl = void 0))
                        : (i.isElement && i[W].el.remove(),
                            (y[W].el = void 0),
                            (i[W].el = void 0)));
        };
        (r.includes('loop') &&
            i.isElement &&
            (y.loop && !s.loop
                ? (Z = !0)
                : !y.loop && s.loop
                    ? (P = !0)
                    : (le = !0)),
            m.forEach(W => {
                if (gl(y[W]) && gl(s[W]))
                    (Object.assign(y[W], s[W]),
                        (W === 'navigation' ||
                            W === 'pagination' ||
                            W === 'scrollbar') &&
                        'enabled' in s[W] &&
                        !s[W].enabled &&
                        q(W));
                else {
                    const K = s[W];
                    (K === !0 || K === !1) &&
                        (W === 'navigation' || W === 'pagination' || W === 'scrollbar')
                        ? K === !1 && q(W)
                        : (y[W] = s[W]);
                }
            }),
            m.includes('controller') &&
            !k &&
            i.controller &&
            i.controller.control &&
            y.controller &&
            y.controller.control &&
            (i.controller.control = y.controller.control),
            r.includes('children') && l && S && y.virtual.enabled
                ? ((S.slides = l), S.update(!0))
                : r.includes('virtual') &&
                S &&
                y.virtual.enabled &&
                (l && (S.slides = l), S.update(!0)),
            r.includes('children') && l && y.loop && (le = !0),
            O && D.init() && D.update(!0),
            k && (i.controller.control = y.controller.control),
            _ &&
            (i.isElement &&
                (!h || typeof h == 'string') &&
                ((h = document.createElement('div')),
                    h.classList.add('swiper-pagination'),
                    h.part.add('pagination'),
                    i.el.appendChild(h)),
                h && (y.pagination.el = h),
                E.init(),
                E.render(),
                E.update()),
            I &&
            (i.isElement &&
                (!p || typeof p == 'string') &&
                ((p = document.createElement('div')),
                    p.classList.add('swiper-scrollbar'),
                    p.part.add('scrollbar'),
                    i.el.appendChild(p)),
                p && (y.scrollbar.el = p),
                N.init(),
                N.updateSize(),
                N.setTranslate()),
            Y &&
            (i.isElement &&
                ((!u || typeof u == 'string') &&
                    ((u = document.createElement('div')),
                        u.classList.add('swiper-button-next'),
                        Op(u, i.hostEl.constructor.nextButtonSvg),
                        u.part.add('button-next'),
                        i.el.appendChild(u)),
                    (!d || typeof d == 'string') &&
                    ((d = document.createElement('div')),
                        d.classList.add('swiper-button-prev'),
                        Op(d, i.hostEl.constructor.prevButtonSvg),
                        d.part.add('button-prev'),
                        i.el.appendChild(d))),
                u && (y.navigation.nextEl = u),
                d && (y.navigation.prevEl = d),
                v.init(),
                v.update()),
            r.includes('allowSlideNext') && (i.allowSlideNext = s.allowSlideNext),
            r.includes('allowSlidePrev') && (i.allowSlidePrev = s.allowSlidePrev),
            r.includes('direction') && i.changeDirection(s.direction, !1),
            (Z || le) && i.loopDestroy(),
            (P || le) && i.loopCreate(),
            i.update());
    }
    function vC(i = {}, l = !0) {
        const s = { on: {} },
            r = {},
            u = {};
        (Eo(s, jp), (s._emitClasses = !0), (s.init = !1));
        const d = {},
            p = F0.map(m => m.replace(/_/, '')),
            h = Object.assign({}, i);
        return (
            Object.keys(h).forEach(m => {
                typeof i[m] > 'u' ||
                    (p.indexOf(m) >= 0
                        ? gl(i[m])
                            ? ((s[m] = {}), (u[m] = {}), Eo(s[m], i[m]), Eo(u[m], i[m]))
                            : ((s[m] = i[m]), (u[m] = i[m]))
                        : m.search(/on[A-Z]/) === 0 && typeof i[m] == 'function'
                            ? l
                                ? (r[`${m[2].toLowerCase()}${m.substr(3)}`] = i[m])
                                : (s.on[`${m[2].toLowerCase()}${m.substr(3)}`] = i[m])
                            : (d[m] = i[m]));
            }),
            ['navigation', 'pagination', 'scrollbar'].forEach(m => {
                (s[m] === !0 && (s[m] = {}), s[m] === !1 && delete s[m]);
            }),
            { params: s, passedParams: u, rest: d, events: r }
        );
    }
    function SC(
        {
            el: i,
            nextEl: l,
            prevEl: s,
            paginationEl: r,
            scrollbarEl: u,
            swiper: d,
        },
        p
    ) {
        (K0(p) &&
            l &&
            s &&
            ((d.params.navigation.nextEl = l),
                (d.originalParams.navigation.nextEl = l),
                (d.params.navigation.prevEl = s),
                (d.originalParams.navigation.prevEl = s)),
            eS(p) &&
            r &&
            ((d.params.pagination.el = r),
                (d.originalParams.pagination.el = r)),
            tS(p) &&
            u &&
            ((d.params.scrollbar.el = u), (d.originalParams.scrollbar.el = u)),
            d.init(i));
    }
    function xC(i, l, s, r, u) {
        const d = [];
        if (!l) return d;
        const p = m => {
            d.indexOf(m) < 0 && d.push(m);
        };
        if (s && r) {
            const m = r.map(u),
                y = s.map(u);
            (m.join('') !== y.join('') && p('children'),
                r.length !== s.length && p('children'));
        }
        return (
            F0.filter(m => m[0] === '_')
                .map(m => m.replace(/_/, ''))
                .forEach(m => {
                    if (m in i && m in l)
                        if (gl(i[m]) && gl(l[m])) {
                            const y = Object.keys(i[m]),
                                E = Object.keys(l[m]);
                            y.length !== E.length
                                ? p(m)
                                : (y.forEach(v => {
                                    i[m][v] !== l[m][v] && p(m);
                                }),
                                    E.forEach(v => {
                                        i[m][v] !== l[m][v] && p(m);
                                    }));
                        } else i[m] !== l[m] && p(m);
                }),
            d
        );
    }
    const NC = i => {
        !i ||
            i.destroyed ||
            !i.params.virtual ||
            (i.params.virtual && !i.params.virtual.enabled) ||
            (i.updateSlides(),
                i.updateProgress(),
                i.updateSlidesClasses(),
                i.emit('_virtualUpdated'),
                i.parallax &&
                i.params.parallax &&
                i.params.parallax.enabled &&
                i.parallax.setTranslate());
    };
    function Su() {
        return (
            (Su = Object.assign
                ? Object.assign.bind()
                : function (i) {
                    for (var l = 1; l < arguments.length; l++) {
                        var s = arguments[l];
                        for (var r in s)
                            Object.prototype.hasOwnProperty.call(s, r) && (i[r] = s[r]);
                    }
                    return i;
                }),
            Su.apply(this, arguments)
        );
    }
    function aS(i) {
        return (
            i.type &&
            i.type.displayName &&
            i.type.displayName.includes('SwiperSlide')
        );
    }
    function iS(i) {
        const l = [];
        return (
            Nt.Children.toArray(i).forEach(s => {
                aS(s)
                    ? l.push(s)
                    : s.props &&
                    s.props.children &&
                    iS(s.props.children).forEach(r => l.push(r));
            }),
            l
        );
    }
    function wC(i) {
        const l = [],
            s = {
                'container-start': [],
                'container-end': [],
                'wrapper-start': [],
                'wrapper-end': [],
            };
        return (
            Nt.Children.toArray(i).forEach(r => {
                if (aS(r)) l.push(r);
                else if (r.props && r.props.slot && s[r.props.slot])
                    s[r.props.slot].push(r);
                else if (r.props && r.props.children) {
                    const u = iS(r.props.children);
                    u.length > 0
                        ? u.forEach(d => l.push(d))
                        : s['container-end'].push(r);
                } else s['container-end'].push(r);
            }),
            { slides: l, slots: s }
        );
    }
    function EC(i, l, s) {
        if (!s) return null;
        const r = E => {
            let v = E;
            return (
                E < 0 ? (v = l.length + E) : v >= l.length && (v = v - l.length),
                v
            );
        },
            u = i.isHorizontal()
                ? { [i.rtlTranslate ? 'right' : 'left']: `${s.offset}px` }
                : { top: `${s.offset}px` },
            { from: d, to: p } = s,
            h = i.params.loop ? -l.length : 0,
            m = i.params.loop ? l.length * 2 : l.length,
            y = [];
        for (let E = h; E < m; E += 1) E >= d && E <= p && y.push(l[r(E)]);
        return y.map((E, v) =>
            Nt.cloneElement(E, {
                swiper: i,
                style: u,
                key: E.props.virtualIndex || E.key || `slide-${v}`,
            })
        );
    }
    function lr(i, l) {
        return typeof window > 'u'
            ? $.useEffect(i, l)
            : $.useLayoutEffect(i, l);
    }
    const O0 = $.createContext(null),
        AC = $.createContext(null),
        rr = $.forwardRef(
            (
                {
                    className: i,
                    tag: l = 'div',
                    wrapperTag: s = 'div',
                    children: r,
                    onSwiper: u,
                    ...d
                } = {},
                p
            ) => {
                let h = !1;
                const [m, y] = $.useState('swiper'),
                    [E, v] = $.useState(null),
                    [N, S] = $.useState(!1),
                    D = $.useRef(!1),
                    O = $.useRef(null),
                    k = $.useRef(null),
                    _ = $.useRef(null),
                    I = $.useRef(null),
                    Y = $.useRef(null),
                    Z = $.useRef(null),
                    P = $.useRef(null),
                    le = $.useRef(null),
                    { params: q, passedParams: W, rest: K, events: te } = vC(d),
                    { slides: X, slots: oe } = wC(r),
                    ge = () => {
                        S(!N);
                    };
                Object.assign(q.on, {
                    _containerClasses(Q, me) {
                        y(me);
                    },
                });
                const Ee = () => {
                    (Object.assign(q.on, te), (h = !0));
                    const Q = { ...q };
                    if (
                        (delete Q.wrapperClass,
                            (k.current = new Bp(Q)),
                            k.current.virtual && k.current.params.virtual.enabled)
                    ) {
                        k.current.virtual.slides = X;
                        const me = {
                            cache: !1,
                            slides: X,
                            renderExternal: v,
                            renderExternalUpdate: !1,
                        };
                        (Eo(k.current.params.virtual, me),
                            Eo(k.current.originalParams.virtual, me));
                    }
                };
                (O.current || Ee(),
                    k.current && k.current.on('_beforeBreakpoint', ge));
                const _e = () => {
                    h ||
                        !te ||
                        !k.current ||
                        Object.keys(te).forEach(Q => {
                            k.current.on(Q, te[Q]);
                        });
                },
                    J = () => {
                        !te ||
                            !k.current ||
                            Object.keys(te).forEach(Q => {
                                k.current.off(Q, te[Q]);
                            });
                    };
                ($.useEffect(() => () => {
                    k.current && k.current.off('_beforeBreakpoint', ge);
                }),
                    $.useEffect(() => {
                        !D.current &&
                            k.current &&
                            (k.current.emitSlidesClasses(), (D.current = !0));
                    }),
                    lr(() => {
                        if ((p && (p.current = O.current), !!O.current))
                            return (
                                k.current.destroyed && Ee(),
                                SC(
                                    {
                                        el: O.current,
                                        nextEl: Y.current,
                                        prevEl: Z.current,
                                        paginationEl: P.current,
                                        scrollbarEl: le.current,
                                        swiper: k.current,
                                    },
                                    q
                                ),
                                u && !k.current.destroyed && u(k.current),
                                () => {
                                    k.current &&
                                        !k.current.destroyed &&
                                        k.current.destroy(!0, !1);
                                }
                            );
                    }, []),
                    lr(() => {
                        _e();
                        const Q = xC(W, _.current, X, I.current, me => me.key);
                        return (
                            (_.current = W),
                            (I.current = X),
                            Q.length &&
                            k.current &&
                            !k.current.destroyed &&
                            yC({
                                swiper: k.current,
                                slides: X,
                                passedParams: W,
                                changedParams: Q,
                                nextEl: Y.current,
                                prevEl: Z.current,
                                scrollbarEl: le.current,
                                paginationEl: P.current,
                            }),
                            () => {
                                J();
                            }
                        );
                    }),
                    lr(() => {
                        NC(k.current);
                    }, [E]));
                function ce() {
                    return q.virtual
                        ? EC(k.current, X, E)
                        : X.map((Q, me) =>
                            Nt.cloneElement(Q, {
                                swiper: k.current,
                                swiperSlideIndex: me,
                            })
                        );
                }
                return Nt.createElement(
                    l,
                    Su({ ref: O, className: nS(`${m}${i ? ` ${i}` : ''}`) }, K),
                    Nt.createElement(
                        AC.Provider,
                        { value: k.current },
                        oe['container-start'],
                        Nt.createElement(
                            s,
                            { className: bC(q.wrapperClass) },
                            oe['wrapper-start'],
                            ce(),
                            oe['wrapper-end']
                        ),
                        K0(q) &&
                        Nt.createElement(
                            Nt.Fragment,
                            null,
                            Nt.createElement('div', {
                                ref: Z,
                                className: 'swiper-button-prev',
                            }),
                            Nt.createElement('div', {
                                ref: Y,
                                className: 'swiper-button-next',
                            })
                        ),
                        tS(q) &&
                        Nt.createElement('div', {
                            ref: le,
                            className: 'swiper-scrollbar',
                        }),
                        eS(q) &&
                        Nt.createElement('div', {
                            ref: P,
                            className: 'swiper-pagination',
                        }),
                        oe['container-end']
                    )
                );
            }
        );
    rr.displayName = 'Swiper';
    const cr = $.forwardRef(
        (
            {
                tag: i = 'div',
                children: l,
                className: s = '',
                swiper: r,
                zoom: u,
                lazy: d,
                virtualIndex: p,
                swiperSlideIndex: h,
                ...m
            } = {},
            y
        ) => {
            const E = $.useRef(null),
                [v, N] = $.useState('swiper-slide'),
                [S, D] = $.useState(!1);
            function O(Y, Z, P) {
                Z === E.current && N(P);
            }
            (lr(() => {
                if (
                    (typeof h < 'u' && (E.current.swiperSlideIndex = h),
                        y && (y.current = E.current),
                        !(!E.current || !r))
                ) {
                    if (r.destroyed) {
                        v !== 'swiper-slide' && N('swiper-slide');
                        return;
                    }
                    return (
                        r.on('_slideClass', O),
                        () => {
                            r && r.off('_slideClass', O);
                        }
                    );
                }
            }),
                lr(() => {
                    r && E.current && !r.destroyed && N(r.getSlideClasses(E.current));
                }, [r]));
            const k = {
                isActive: v.indexOf('swiper-slide-active') >= 0,
                isVisible: v.indexOf('swiper-slide-visible') >= 0,
                isPrev: v.indexOf('swiper-slide-prev') >= 0,
                isNext: v.indexOf('swiper-slide-next') >= 0,
            },
                _ = () => (typeof l == 'function' ? l(k) : l),
                I = () => {
                    D(!0);
                };
            return Nt.createElement(
                i,
                Su(
                    {
                        ref: E,
                        className: nS(`${v}${s ? ` ${s}` : ''}`),
                        'data-swiper-slide-index': p,
                        onLoad: I,
                    },
                    m
                ),
                u &&
                Nt.createElement(
                    O0.Provider,
                    { value: k },
                    Nt.createElement(
                        'div',
                        {
                            className: 'swiper-zoom-container',
                            'data-swiper-zoom': typeof u == 'number' ? u : void 0,
                        },
                        _(),
                        d &&
                        !S &&
                        Nt.createElement('div', {
                            className: 'swiper-lazy-preloader',
                        })
                    )
                ),
                !u &&
                Nt.createElement(
                    O0.Provider,
                    { value: k },
                    _(),
                    d &&
                    !S &&
                    Nt.createElement('div', {
                        className: 'swiper-lazy-preloader',
                    })
                )
            );
        }
    );
    cr.displayName = 'SwiperSlide';
    function DC(i, l, s, r) {
        return (
            i.params.createElements &&
            Object.keys(r).forEach(u => {
                if (!s[u] && s.auto === !0) {
                    let d = ya(i.el, `.${r[u]}`)[0];
                    (d ||
                        ((d = vu('div', r[u])), (d.className = r[u]), i.el.append(d)),
                        (s[u] = d),
                        (l[u] = d));
                }
            }),
            s
        );
    }
    const TC =
        '<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>';
    function CC({ swiper: i, extendParams: l, on: s, emit: r }) {
        (l({
            navigation: {
                nextEl: null,
                prevEl: null,
                addIcons: !0,
                hideOnClick: !1,
                disabledClass: 'swiper-button-disabled',
                hiddenClass: 'swiper-button-hidden',
                lockClass: 'swiper-button-lock',
                navigationDisabledClass: 'swiper-navigation-disabled',
            },
        }),
            (i.navigation = { nextEl: null, prevEl: null }));
        function u(S) {
            let D;
            return S &&
                typeof S == 'string' &&
                i.isElement &&
                ((D = i.el.querySelector(S) || i.hostEl.querySelector(S)), D)
                ? D
                : (S &&
                    (typeof S == 'string' &&
                        (D = [...document.querySelectorAll(S)]),
                        i.params.uniqueNavElements &&
                            typeof S == 'string' &&
                            D &&
                            D.length > 1 &&
                            i.el.querySelectorAll(S).length === 1
                            ? (D = i.el.querySelector(S))
                            : D && D.length === 1 && (D = D[0])),
                    S && !D ? S : D);
        }
        function d(S, D) {
            const O = i.params.navigation;
            ((S = Za(S)),
                S.forEach(k => {
                    k &&
                        (k.classList[D ? 'add' : 'remove'](
                            ...O.disabledClass.split(' ')
                        ),
                            k.tagName === 'BUTTON' && (k.disabled = D),
                            i.params.watchOverflow &&
                            i.enabled &&
                            k.classList[i.isLocked ? 'add' : 'remove'](O.lockClass));
                }));
        }
        function p() {
            const { nextEl: S, prevEl: D } = i.navigation;
            if (i.params.loop) {
                (d(D, !1), d(S, !1));
                return;
            }
            (d(D, i.isBeginning && !i.params.rewind),
                d(S, i.isEnd && !i.params.rewind));
        }
        function h(S) {
            (S.preventDefault(),
                !(i.isBeginning && !i.params.loop && !i.params.rewind) &&
                (i.slidePrev(), r('navigationPrev')));
        }
        function m(S) {
            (S.preventDefault(),
                !(i.isEnd && !i.params.loop && !i.params.rewind) &&
                (i.slideNext(), r('navigationNext')));
        }
        function y() {
            const S = i.params.navigation;
            if (
                ((i.params.navigation = DC(
                    i,
                    i.originalParams.navigation,
                    i.params.navigation,
                    { nextEl: 'swiper-button-next', prevEl: 'swiper-button-prev' }
                )),
                    !(S.nextEl || S.prevEl))
            )
                return;
            let D = u(S.nextEl),
                O = u(S.prevEl);
            (Object.assign(i.navigation, { nextEl: D, prevEl: O }),
                (D = Za(D)),
                (O = Za(O)));
            const k = (_, I) => {
                if (_) {
                    if (
                        S.addIcons &&
                        _.matches('.swiper-button-next,.swiper-button-prev') &&
                        !_.querySelector('svg')
                    ) {
                        const Y = document.createElement('div');
                        (Op(Y, TC), _.appendChild(Y.querySelector('svg')), Y.remove());
                    }
                    _.addEventListener('click', I === 'next' ? m : h);
                }
                !i.enabled && _ && _.classList.add(...S.lockClass.split(' '));
            };
            (D.forEach(_ => k(_, 'next')), O.forEach(_ => k(_, 'prev')));
        }
        function E() {
            let { nextEl: S, prevEl: D } = i.navigation;
            ((S = Za(S)), (D = Za(D)));
            const O = (k, _) => {
                (k.removeEventListener('click', _ === 'next' ? m : h),
                    k.classList.remove(
                        ...i.params.navigation.disabledClass.split(' ')
                    ));
            };
            (S.forEach(k => O(k, 'next')), D.forEach(k => O(k, 'prev')));
        }
        (s('init', () => {
            i.params.navigation.enabled === !1 ? N() : (y(), p());
        }),
            s('toEdge fromEdge lock unlock', () => {
                p();
            }),
            s('destroy', () => {
                E();
            }),
            s('enable disable', () => {
                let { nextEl: S, prevEl: D } = i.navigation;
                if (((S = Za(S)), (D = Za(D)), i.enabled)) {
                    p();
                    return;
                }
                [...S, ...D]
                    .filter(O => !!O)
                    .forEach(O => O.classList.add(i.params.navigation.lockClass));
            }),
            s('click', (S, D) => {
                let { nextEl: O, prevEl: k } = i.navigation;
                ((O = Za(O)), (k = Za(k)));
                const _ = D.target;
                let I = k.includes(_) || O.includes(_);
                if (i.isElement && !I) {
                    const Y = D.path || (D.composedPath && D.composedPath());
                    Y && (I = Y.find(Z => O.includes(Z) || k.includes(Z)));
                }
                if (i.params.navigation.hideOnClick && !I) {
                    if (
                        i.pagination &&
                        i.params.pagination &&
                        i.params.pagination.clickable &&
                        (i.pagination.el === _ || i.pagination.el.contains(_))
                    )
                        return;
                    let Y;
                    (O.length
                        ? (Y = O[0].classList.contains(i.params.navigation.hiddenClass))
                        : k.length &&
                        (Y = k[0].classList.contains(
                            i.params.navigation.hiddenClass
                        )),
                        r(Y === !0 ? 'navigationShow' : 'navigationHide'),
                        [...O, ...k]
                            .filter(Z => !!Z)
                            .forEach(Z =>
                                Z.classList.toggle(i.params.navigation.hiddenClass)
                            ));
                }
            }));
        const v = () => {
            (i.el.classList.remove(
                ...i.params.navigation.navigationDisabledClass.split(' ')
            ),
                y(),
                p());
        },
            N = () => {
                (i.el.classList.add(
                    ...i.params.navigation.navigationDisabledClass.split(' ')
                ),
                    E());
            };
        Object.assign(i.navigation, {
            enable: v,
            disable: N,
            update: p,
            init: y,
            destroy: E,
        });
    }
    const Du = 2,
        xu = 300;
    function ha(i) {
        return !!(
            i &&
            i.el &&
            i.wrapperEl &&
            Array.isArray(i.slides) &&
            i.slides.length > 0 &&
            !i.destroyed
        );
    }
    function Tu(i) {
        const l = i.el;
        if (!l) return null;
        let s = l;
        for (; s;) {
            const { overflow: r, overflowX: u } = getComputedStyle(s);
            if (r === 'hidden' || u === 'hidden') return s;
            s = s.parentElement;
        }
        return l;
    }
    function RC(i) {
        const { params: l } = i,
            s = l.breakpoints ?? {},
            r = Object.keys(s)
                .map(Number)
                .filter(u => i.width >= u)
                .sort((u, d) => d - u);
        if (r.length > 0) {
            const u = s[r[0]];
            if (u?.slidesPerView !== void 0) return u.slidesPerView;
        }
        return l.slidesPerView;
    }
    function Lp(i) {
        const l = RC(i);
        return l === 1 || Number(l) === 1;
    }
    function lS(i) {
        const { params: l } = i,
            s = l.breakpoints ?? {},
            r = Object.keys(s)
                .map(Number)
                .filter(u => i.width >= u)
                .sort((u, d) => d - u);
        if (r.length > 0) {
            const u = s[r[0]];
            if (u && typeof u.spaceBetween == 'number') return u.spaceBetween;
        }
        return typeof l.spaceBetween == 'number' ? l.spaceBetween : 0;
    }
    function Cu(i) {
        const l = Tu(i),
            s = i.slides;
        if (!l || !s.length)
            return { viewportRect: null, firstRect: void 0, lastRect: void 0 };
        const r = l.getBoundingClientRect(),
            u = s[0]?.getBoundingClientRect(),
            d = s[s.length - 1]?.getBoundingClientRect();
        return { viewportRect: r, firstRect: u, lastRect: d };
    }
    function oS(i) {
        const l = Tu(i);
        if (!l) return i.getTranslate();
        (i.updateSize(), i.updateSlides());
        const s = l.clientWidth,
            r = i.slides.length - 1;
        if (r < 0) return i.getTranslate();
        const u = i.slidesGrid[r] ?? 0,
            d = i.slidesSizesGrid[r] ?? 0,
            p = u + d,
            h = lS(i);
        return p <= s
            ? i.minTranslate()
            : Math.min(i.minTranslate(), s - p - h);
    }
    function sS(i) {
        if (Lp(i)) return i.activeIndex <= 0;
        const { viewportRect: l, firstRect: s } = Cu(i);
        return !l || !s ? !0 : s.left >= l.left - Du;
    }
    function Ip(i) {
        if (Lp(i)) return i.activeIndex >= i.slides.length - 1;
        const { viewportRect: l, lastRect: s } = Cu(i);
        return !l || !s ? !0 : s.right <= l.right + Du;
    }
    function MC(i) {
        return { isBeginning: sS(i), isEnd: Ip(i) };
    }
    function OC(i, l) {
        i.translateTo(l, xu, !0, !1);
    }
    function rS(i) {
        if (!i.wrapperEl) return;
        const l = i.getTranslate();
        (i.wrapperEl.style.removeProperty('transition-duration'),
            i.wrapperEl.style.removeProperty('transition-delay'),
            i.wrapperEl.style.removeProperty('transform'),
            i.setTranslate(l),
            i.update());
    }
    function kC(i) {
        const { viewportRect: l, lastRect: s } = Cu(i);
        if (!l) return;
        const r = oS(i);
        let u = r;
        if (s) {
            const d = s.right - l.right;
            if (d > Du) {
                const p = i.getTranslate() - d;
                u = Math.min(p, r, i.minTranslate());
            }
        }
        OC(i, u);
    }
    function jC(i) {
        const { viewportRect: l, lastRect: s } = Cu(i);
        if (!l || !s) return !1;
        if (s.left < l.right) return !0;
        const r = oS(i),
            u = Math.abs(r - i.getTranslate()),
            d = i.activeIndex,
            p = (i.slidesSizesGrid[d + 1] ?? i.slidesSizesGrid[d] ?? 0) + lS(i);
        return u <= p * 1.5;
    }
    function VC(i) {
        if (!Ip(i)) {
            if (!Lp(i) && jC(i)) {
                kC(i);
                return;
            }
            (rS(i), i.slideNext());
        }
    }
    function zC(i) {
        const l = Tu(i);
        if (!l) return i.activeIndex;
        const s = l.getBoundingClientRect(),
            r = i.slides;
        for (let u = 0; u < r.length; u++)
            if (r[u].getBoundingClientRect().right > s.left + Du) return u;
        return Math.max(0, r.length - 1);
    }
    function BC(i) {
        let l = Math.max(0, zC(i) - 1);
        return (i.activeIndex === l && l > 0 && (l -= 1), l);
    }
    function LC(i) {
        if (sS(i)) return;
        const l = BC(i);
        (rS(i), i.updateSize(), i.updateSlides(), i.slideTo(l, xu));
    }
    function Ru() {
        const i = $.useRef(null),
            l = $.useRef(null),
            [s, r] = $.useState(!0),
            [u, d] = $.useState(!1),
            p = $.useCallback(S => {
                if (!ha(S)) return;
                const D = MC(S);
                (r(D.isBeginning), d(D.isEnd));
            }, []),
            h = $.useCallback(
                S => {
                    ha(S) &&
                        (p(S),
                            requestAnimationFrame(() => {
                                ha(S) && p(S);
                            }));
                },
                [p]
            ),
            m = $.useCallback(
                S => {
                    if ((l.current?.disconnect(), !ha(S))) return;
                    const D = Tu(S);
                    if (!D) return;
                    const O = new ResizeObserver(() => {
                        ha(i.current) && h(i.current);
                    });
                    (O.observe(D),
                        S.wrapperEl && O.observe(S.wrapperEl),
                        (l.current = O));
                },
                [h]
            ),
            y = $.useCallback(
                S => {
                    ha(S) && ((i.current = S), m(S), h(S));
                },
                [m, h]
            );
        $.useEffect(
            () => () => {
                (l.current?.disconnect(), (i.current = null));
            },
            []
        );
        const E = $.useCallback(() => {
            const S = i.current;
            !ha(S) ||
                Ip(S) ||
                (VC(S),
                    window.setTimeout(() => {
                        ha(i.current) && h(i.current);
                    }, xu + 50));
        }, [h]),
            v = $.useCallback(() => {
                const S = i.current;
                ha(S) &&
                    (LC(S),
                        window.setTimeout(() => {
                            ha(i.current) && h(i.current);
                        }, xu + 50));
            }, [h]);
        return {
            swiperRef: i,
            isBeginning: s,
            isEnd: u,
            goNext: E,
            goPrev: v,
            swiperNavHandlers: {
                onSwiper: y,
                onSlideChange: h,
                onTransitionEnd: p,
                onSetTranslate: p,
                onResize: h,
                onUpdate: h,
                onDestroy: () => {
                    (l.current?.disconnect(), (i.current = null));
                },
            },
            applyNavState: p,
        };
    }
    const IC = 'carousel_-Hs1s',
        HC = 'title_Lsegw',
        UC = 'subtitle_pUiF1',
        GC = 'tabs_I1kuo',
        _C = 'tab_XKtrX',
        YC = 'tabActive_2R-2m',
        PC = 'swiperArea_J9Sm-',
        ZC = 'swiper_AmXV-',
        WC = 'slideLayout_pH-Bn',
        XC = 'slideImage_gs6-M',
        QC = 'slideLeft_tXQK-',
        JC = 'slideRight_eEdcx',
        qC = 'slideMiddle_KYSQ9',
        $C = 'navBtn_fe6Aj',
        FC = 'navPrev_vo98m',
        KC = 'navNext_ftl89',
        eR = 'indicators_YxdES',
        tR = 'indicatorTrack_8A-an',
        nR = 'indicator_BAvdV',
        aR = 'indicatorActive_Tyruk',
        iR = 'indicatorLabel_X-AOO',
        lR = 'indicatorDot_4dmfX',
        oR = 'indicatorBar_-vNQl',
        nt = {
            carousel: IC,
            title: HC,
            subtitle: UC,
            tabs: GC,
            tab: _C,
            tabActive: YC,
            swiperArea: PC,
            swiper: ZC,
            slideLayout: WC,
            slideImage: XC,
            slideLeft: QC,
            slideRight: JC,
            slideMiddle: qC,
            navBtn: $C,
            navPrev: FC,
            navNext: KC,
            indicators: eR,
            indicatorTrack: tR,
            indicator: nR,
            indicatorActive: aR,
            indicatorLabel: iR,
            indicatorDot: lR,
            indicatorBar: oR,
        };
    function vp(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
    }
    function wo(i, l, s) {
        return i ? (s && vp(`${i}Mobile`, l)) || vp(i, l) : '';
    }
    function sR() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            s = $n(),
            [r, u] = $.useState('diode'),
            [d, p] = $.useState(0),
            [h, m] = $.useState({ left: 0, width: 0 }),
            {
                swiperRef: y,
                isBeginning: E,
                isEnd: v,
                goNext: N,
                goPrev: S,
                swiperNavHandlers: D,
            } = Ru(),
            O = $.useRef(null),
            k = $.useRef([]),
            I =
                i('section5.materialCarousel', { returnObjects: !0 })[r]?.slides ??
                [];
        $.useLayoutEffect(() => {
            const P = O.current,
                le = k.current[d];
            if (!P || !le) {
                m({ left: 0, width: 0 });
                return;
            }
            const q = () => {
                const W = P.getBoundingClientRect(),
                    K = le.getBoundingClientRect();
                m({ left: K.left - W.left, width: K.width });
            };
            return (
                q(),
                window.addEventListener('resize', q),
                () => window.removeEventListener('resize', q)
            );
        }, [d, r, I.length]);
        const Y = P => {
            P !== r && (u(P), p(0), y.current?.slideTo(0));
        },
            Z = P => {
                (p(P), y.current?.slideTo(P));
            };
        return b.jsxDEV(
            'div',
            {
                className: nt.carousel,
                children: [
                    b.jsxDEV(
                        'h2',
                        { className: nt.title, children: i('section5.materialsTitle') },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                            lineNumber: 102,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'p',
                        {
                            className: nt.subtitle,
                            children: i('section5.materialsSubtitle'),
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                            lineNumber: 103,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        b.Fragment,
                        {
                            children: [
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: nt.tabs,
                                        children: [
                                            b.jsxDEV(
                                                'button',
                                                {
                                                    type: 'button',
                                                    className: `${nt.tab} ${r === 'diode' ? nt.tabActive : ''}`,
                                                    onClick: () => Y('diode'),
                                                    children: i('section5.tabDiode'),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                    lineNumber: 107,
                                                    columnNumber: 9,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'button',
                                                {
                                                    type: 'button',
                                                    className: `${nt.tab} ${r === 'ir' ? nt.tabActive : ''}`,
                                                    onClick: () => Y('ir'),
                                                    children: i('section5.tabIR'),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                    lineNumber: 114,
                                                    columnNumber: 9,
                                                },
                                                this
                                            ),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                        lineNumber: 106,
                                        columnNumber: 7,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: nt.swiperArea,
                                        children: [
                                            b.jsxDEV(
                                                'button',
                                                {
                                                    type: 'button',
                                                    className: `${nt.navBtn} ${nt.navPrev}`,
                                                    onClick: S,
                                                    disabled: E,
                                                    'aria-label': 'Previous slide',
                                                    children: b.jsxDEV(
                                                        Qt,
                                                        { name: 'icon-left' },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                            lineNumber: 131,
                                                            columnNumber: 11,
                                                        },
                                                        this
                                                    ),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                    lineNumber: 124,
                                                    columnNumber: 9,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                rr,
                                                {
                                                    className: nt.swiper,
                                                    modules: [CC],
                                                    slidesPerView: 1,
                                                    spaceBetween: 0,
                                                    ...D,
                                                    onSlideChange: P => {
                                                        (D.onSlideChange(P), p(P.activeIndex));
                                                    },
                                                    children: I.map((P, le) =>
                                                        b.jsxDEV(
                                                            cr,
                                                            {
                                                                children: P.image
                                                                    ? b.jsxDEV(
                                                                        'div',
                                                                        {
                                                                            className: nt.slideImage,
                                                                            style: {
                                                                                backgroundImage: `url(${wo(P.image, l, s)})`,
                                                                            },
                                                                        },
                                                                        void 0,
                                                                        !1,
                                                                        {
                                                                            fileName:
                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                                            lineNumber: 149,
                                                                            columnNumber: 17,
                                                                        },
                                                                        this
                                                                    )
                                                                    : b.jsxDEV(
                                                                        'div',
                                                                        {
                                                                            className: nt.slideLayout,
                                                                            children: [
                                                                                b.jsxDEV(
                                                                                    'div',
                                                                                    {
                                                                                        className: nt.slideLeft,
                                                                                        style: {
                                                                                            backgroundImage: `url(${wo(P.left, l, s)})`,
                                                                                        },
                                                                                    },
                                                                                    void 0,
                                                                                    !1,
                                                                                    {
                                                                                        fileName:
                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                                                        lineNumber: 157,
                                                                                        columnNumber: 19,
                                                                                    },
                                                                                    this
                                                                                ),
                                                                                b.jsxDEV(
                                                                                    'div',
                                                                                    {
                                                                                        className: nt.slideMiddle,
                                                                                        children: [
                                                                                            b.jsxDEV(
                                                                                                Ut,
                                                                                                {
                                                                                                    src: wo(P.midTop, l, s),
                                                                                                    width: '100%',
                                                                                                    height: '100%',
                                                                                                    alt: '',
                                                                                                },
                                                                                                void 0,
                                                                                                !1,
                                                                                                {
                                                                                                    fileName:
                                                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                                                                    lineNumber: 164,
                                                                                                    columnNumber: 21,
                                                                                                },
                                                                                                this
                                                                                            ),
                                                                                            b.jsxDEV(
                                                                                                Ut,
                                                                                                {
                                                                                                    src: wo(
                                                                                                        P.midBottom,
                                                                                                        l,
                                                                                                        s
                                                                                                    ),
                                                                                                    width: '100%',
                                                                                                    height: '100%',
                                                                                                    alt: '',
                                                                                                },
                                                                                                void 0,
                                                                                                !1,
                                                                                                {
                                                                                                    fileName:
                                                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                                                                    lineNumber: 170,
                                                                                                    columnNumber: 21,
                                                                                                },
                                                                                                this
                                                                                            ),
                                                                                        ],
                                                                                    },
                                                                                    void 0,
                                                                                    !0,
                                                                                    {
                                                                                        fileName:
                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                                                        lineNumber: 163,
                                                                                        columnNumber: 19,
                                                                                    },
                                                                                    this
                                                                                ),
                                                                                b.jsxDEV(
                                                                                    'div',
                                                                                    {
                                                                                        className: nt.slideRight,
                                                                                        style: {
                                                                                            backgroundImage: `url(${wo(P.right, l, s)})`,
                                                                                        },
                                                                                    },
                                                                                    void 0,
                                                                                    !1,
                                                                                    {
                                                                                        fileName:
                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                                                        lineNumber: 177,
                                                                                        columnNumber: 19,
                                                                                    },
                                                                                    this
                                                                                ),
                                                                            ],
                                                                        },
                                                                        void 0,
                                                                        !0,
                                                                        {
                                                                            fileName:
                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                                            lineNumber: 156,
                                                                            columnNumber: 17,
                                                                        },
                                                                        this
                                                                    ),
                                                            },
                                                            `${r}-${P.label}-${le}`,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                                lineNumber: 147,
                                                                columnNumber: 13,
                                                            },
                                                            this
                                                        )
                                                    ),
                                                },
                                                r,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                    lineNumber: 134,
                                                    columnNumber: 9,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'button',
                                                {
                                                    type: 'button',
                                                    className: `${nt.navBtn} ${nt.navNext}`,
                                                    onClick: N,
                                                    disabled: v,
                                                    'aria-label': 'Next slide',
                                                    children: b.jsxDEV(
                                                        Qt,
                                                        { name: 'icon-More' },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                            lineNumber: 196,
                                                            columnNumber: 11,
                                                        },
                                                        this
                                                    ),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                    lineNumber: 189,
                                                    columnNumber: 9,
                                                },
                                                this
                                            ),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                        lineNumber: 123,
                                        columnNumber: 7,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: nt.indicators,
                                        children: b.jsxDEV(
                                            'div',
                                            {
                                                className: nt.indicatorTrack,
                                                ref: O,
                                                children: [
                                                    I.map((P, le) => {
                                                        const q = wo(P.indicatorImage, l, s);
                                                        return b.jsxDEV(
                                                            'button',
                                                            {
                                                                ref: W => {
                                                                    k.current[le] = W;
                                                                },
                                                                type: 'button',
                                                                className: `${nt.indicator} ${d === le ? nt.indicatorActive : ''}`,
                                                                onClick: () => Z(le),
                                                                children: [
                                                                    b.jsxDEV(
                                                                        'span',
                                                                        {
                                                                            className: nt.indicatorDot,
                                                                            style: q
                                                                                ? { backgroundImage: `url(${q})` }
                                                                                : void 0,
                                                                        },
                                                                        void 0,
                                                                        !1,
                                                                        {
                                                                            fileName:
                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                                            lineNumber: 215,
                                                                            columnNumber: 17,
                                                                        },
                                                                        this
                                                                    ),
                                                                    b.jsxDEV(
                                                                        'span',
                                                                        {
                                                                            className: nt.indicatorLabel,
                                                                            children: P.label,
                                                                        },
                                                                        void 0,
                                                                        !1,
                                                                        {
                                                                            fileName:
                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                                            lineNumber: 219,
                                                                            columnNumber: 17,
                                                                        },
                                                                        this
                                                                    ),
                                                                ],
                                                            },
                                                            `${r}-indicator-${P.label}`,
                                                            !0,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                                lineNumber: 206,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        );
                                                    }),
                                                    b.jsxDEV(
                                                        'span',
                                                        {
                                                            className: nt.indicatorBar,
                                                            style: { left: h.left, width: h.width },
                                                        },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                            lineNumber: 223,
                                                            columnNumber: 11,
                                                        },
                                                        this
                                                    ),
                                                ],
                                            },
                                            void 0,
                                            !0,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                                lineNumber: 201,
                                                columnNumber: 9,
                                            },
                                            this
                                        ),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                                        lineNumber: 200,
                                        columnNumber: 7,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                            lineNumber: 105,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section5/MaterialCarousel.tsx',
                lineNumber: 101,
                columnNumber: 5,
            },
            this
        );
    }
    const rR = 'gallery_2L9W5',
        cR = 'title_xml96',
        uR = 'swiperWrap_gtjgA',
        dR = 'swiper_esdCt',
        fR = 'slide_rxUk9',
        mR = 'card_YdLi6',
        pR = 'cardImage_Dhgnv',
        hR = 'cardLabel_4brNk',
        gR = 'footer_kWlIX',
        bR = 'navBtns_N7eJS',
        yR = 'navBtn_0-XuO',
        zn = {
            gallery: rR,
            title: cR,
            swiperWrap: uR,
            swiper: dR,
            slide: fR,
            card: mR,
            cardImage: pR,
            cardLabel: hR,
            footer: gR,
            navBtns: bR,
            navBtn: yR,
        };
    function vR(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
    }
    function SR() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            {
                isBeginning: s,
                isEnd: r,
                goNext: u,
                goPrev: d,
                swiperNavHandlers: p,
            } = Ru(),
            h = i('section5.gallerySlides', { returnObjects: !0 });
        return b.jsxDEV(
            'div',
            {
                className: zn.gallery,
                children: [
                    b.jsxDEV(
                        'h3',
                        { className: zn.title, children: i('section5.galleryTitle') },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                            lineNumber: 29,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: zn.swiperWrap,
                            children: b.jsxDEV(
                                rr,
                                {
                                    className: zn.swiper,
                                    slidesPerView: 'auto',
                                    spaceBetween: 12,
                                    watchOverflow: !0,
                                    observer: !0,
                                    observeParents: !0,
                                    breakpoints: { 769: { spaceBetween: 19 } },
                                    ...p,
                                    children: h.map((m, y) => {
                                        const E = vR(m.image, l);
                                        return b.jsxDEV(
                                            cr,
                                            {
                                                className: zn.slide,
                                                children: b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: zn.card,
                                                        children: [
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: zn.cardImage,
                                                                    style: E
                                                                        ? { backgroundImage: `url(${E})` }
                                                                        : void 0,
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                                                                    lineNumber: 50,
                                                                    columnNumber: 19,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: zn.cardLabel,
                                                                    children: m.label,
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                                                                    lineNumber: 54,
                                                                    columnNumber: 19,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                                                        lineNumber: 49,
                                                        columnNumber: 17,
                                                    },
                                                    this
                                                ),
                                            },
                                            `${m.label}-${y}`,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                                                lineNumber: 48,
                                                columnNumber: 15,
                                            },
                                            this
                                        );
                                    }),
                                },
                                void 0,
                                !1,
                                {
                                    fileName:
                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                                    lineNumber: 32,
                                    columnNumber: 9,
                                },
                                this
                            ),
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                            lineNumber: 31,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: zn.footer,
                            children: b.jsxDEV(
                                'div',
                                {
                                    className: zn.navBtns,
                                    children: [
                                        b.jsxDEV(
                                            'button',
                                            {
                                                type: 'button',
                                                className: zn.navBtn,
                                                onClick: d,
                                                disabled: s,
                                                'aria-label': 'Previous',
                                                children: b.jsxDEV(
                                                    Qt,
                                                    { name: 'icon-left' },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                                                        lineNumber: 71,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                                                lineNumber: 64,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                        b.jsxDEV(
                                            'button',
                                            {
                                                type: 'button',
                                                className: zn.navBtn,
                                                onClick: u,
                                                disabled: r,
                                                'aria-label': 'Next',
                                                children: b.jsxDEV(
                                                    Qt,
                                                    { name: 'icon-More' },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                                                        lineNumber: 80,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                                                lineNumber: 73,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                    ],
                                },
                                void 0,
                                !0,
                                {
                                    fileName:
                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                                    lineNumber: 63,
                                    columnNumber: 9,
                                },
                                this
                            ),
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                            lineNumber: 62,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section5/GalleryCarousel.tsx',
                lineNumber: 28,
                columnNumber: 5,
            },
            this
        );
    }
    const xR = 'section5_TCJms',
        NR = 'hero_iNIy1',
        wR = 'section5Body_dGQlk',
        ER = 'stabilityCards_puNq9',
        AR = 'stabilityCard_oAHgr',
        DR = 'stabilityCardImage_qJ8-5',
        TR = 'stabilityCardText_rzH6W',
        pl = {
            section5: xR,
            hero: NR,
            section5Body: wR,
            stabilityCards: ER,
            stabilityCard: AR,
            stabilityCardImage: DR,
            stabilityCardText: TR,
        },
        CR = ['stability1', 'stability2', 'stability3'];
    function RR() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            s = $n(),
            r = Au(l, 'stabilityHero', 'stabilityHeroMobile', s),
            u = i('section5.stabilityCards', { returnObjects: !0 }),
            d = CR.map((p, h) => ({
                imageKey: p,
                title: u[h]?.title ?? '',
                description: u[h]?.description ?? '',
            }));
        return b.jsxDEV(
            'section',
            {
                className: pl.section5,
                children: [
                    b.jsxDEV(
                        'div',
                        {
                            className: pl.hero,
                            style: { backgroundImage: `url(${r})` },
                            children: b.jsxDEV(
                                'h2',
                                {
                                    dangerouslySetInnerHTML: {
                                        __html: i('section5.heroTitle'),
                                    },
                                },
                                void 0,
                                !1,
                                {
                                    fileName:
                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/index.tsx',
                                    lineNumber: 31,
                                    columnNumber: 9,
                                },
                                this
                            ),
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/index.tsx',
                            lineNumber: 27,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: pl.section5Body,
                            children: [
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: pl.stabilityCards,
                                        children: d.map(p =>
                                            b.jsxDEV(
                                                'div',
                                                {
                                                    className: pl.stabilityCard,
                                                    children: [
                                                        b.jsxDEV(
                                                            'div',
                                                            {
                                                                className: pl.stabilityCardImage,
                                                                style: {
                                                                    backgroundImage: `url(${l(p.imageKey)})`,
                                                                },
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section5/index.tsx',
                                                                lineNumber: 38,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                        b.jsxDEV(
                                                            'div',
                                                            {
                                                                className: pl.stabilityCardText,
                                                                children: [
                                                                    b.jsxDEV(
                                                                        'h3',
                                                                        { children: p.title },
                                                                        void 0,
                                                                        !1,
                                                                        {
                                                                            fileName:
                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/index.tsx',
                                                                            lineNumber: 43,
                                                                            columnNumber: 17,
                                                                        },
                                                                        this
                                                                    ),
                                                                    b.jsxDEV(
                                                                        'p',
                                                                        {
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: p.description,
                                                                            },
                                                                        },
                                                                        void 0,
                                                                        !1,
                                                                        {
                                                                            fileName:
                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/index.tsx',
                                                                            lineNumber: 44,
                                                                            columnNumber: 17,
                                                                        },
                                                                        this
                                                                    ),
                                                                ],
                                                            },
                                                            void 0,
                                                            !0,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section5/index.tsx',
                                                                lineNumber: 42,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                    ],
                                                },
                                                p.imageKey,
                                                !0,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section5/index.tsx',
                                                    lineNumber: 37,
                                                    columnNumber: 13,
                                                },
                                                this
                                            )
                                        ),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section5/index.tsx',
                                        lineNumber: 35,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    sR,
                                    {},
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section5/index.tsx',
                                        lineNumber: 50,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    SR,
                                    {},
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section5/index.tsx',
                                        lineNumber: 52,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section5/index.tsx',
                            lineNumber: 34,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section5/index.tsx',
                lineNumber: 26,
                columnNumber: 5,
            },
            this
        );
    }
    const MR = 'section6_jJ2Mj',
        OR = 'content_xVmLM',
        kR = 'title_Zkquq',
        jR = 'subtitleRow_Hx0d4',
        VR = 'workspace_f3UqJ',
        zR = 'subtitle_XM3ml',
        BR = 'description_ZMZpq',
        LR = 'emDash_l27nX',
        IR = 'cards_5-yWF',
        HR = 'card_soI27',
        ga = {
            section6: MR,
            content: OR,
            title: kR,
            subtitleRow: jR,
            workspace: VR,
            subtitle: zR,
            description: BR,
            emDash: LR,
            cards: IR,
            card: HR,
        },
        UR = ['workspaceCard1', 'workspaceCard2', 'workspaceCard3'];
    function GR() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            s = $n(),
            r = l('workspaceBg'),
            u = l('workspaceBgMobile');
        return b.jsxDEV(
            'section',
            {
                className: ga.section6,
                style: s ? void 0 : { backgroundImage: `url(${r})` },
                children: [
                    b.jsxDEV(
                        'h2',
                        { className: ga.title, children: i('section6.title') },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section6/index.tsx',
                            lineNumber: 19,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: ga.content,
                            style: s ? { backgroundImage: `url(${u || r})` } : void 0,
                            children: [
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: ga.subtitleRow,
                                        children: [
                                            b.jsxDEV(
                                                'span',
                                                {
                                                    className: ga.workspace,
                                                    children: i('section6.workspace'),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section6/index.tsx',
                                                    lineNumber: 25,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'span',
                                                {
                                                    className: ga.subtitle,
                                                    children: i('section6.subtitle'),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section6/index.tsx',
                                                    lineNumber: 26,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section6/index.tsx',
                                        lineNumber: 24,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'p',
                                    {
                                        className: ga.description,
                                        children: [
                                            i('section6.description'),
                                            b.jsxDEV(
                                                'span',
                                                {
                                                    className: ga.emDash,
                                                    children: i('section6.emDash'),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section6/index.tsx',
                                                    lineNumber: 30,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                            i('section6.descriptionEnd'),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section6/index.tsx',
                                        lineNumber: 28,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: ga.cards,
                                        children: UR.map(d =>
                                            b.jsxDEV(
                                                'div',
                                                {
                                                    className: ga.card,
                                                    style: { backgroundImage: `url(${l(d)})` },
                                                },
                                                d,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section6/index.tsx',
                                                    lineNumber: 35,
                                                    columnNumber: 13,
                                                },
                                                this
                                            )
                                        ),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section6/index.tsx',
                                        lineNumber: 33,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section6/index.tsx',
                            lineNumber: 20,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section6/index.tsx',
                lineNumber: 15,
                columnNumber: 5,
            },
            this
        );
    }
    const _R = 'section7_aiRu-',
        YR = 'content_giFec',
        PR = 'title_MpHQX',
        ZR = 'subtitle_5N4RW',
        WR = 'mobileBg_K33Ze',
        ar = {
            section7: _R,
            content: YR,
            title: PR,
            subtitle: ZR,
            mobileBg: WR,
        };
    function XR() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            s = $n(),
            r = l('speedBg'),
            u = l('speedBgMobile');
        return b.jsxDEV(
            'section',
            {
                className: ar.section7,
                style: s ? void 0 : { backgroundImage: `url(${r})` },
                children: [
                    b.jsxDEV(
                        'div',
                        {
                            className: ar.content,
                            children: [
                                b.jsxDEV(
                                    'h2',
                                    { className: ar.title, children: i('section7.title') },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section7/index.tsx',
                                        lineNumber: 18,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'p',
                                    {
                                        className: ar.subtitle,
                                        children: i('section7.subtitle'),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section7/index.tsx',
                                        lineNumber: 19,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section7/index.tsx',
                            lineNumber: 17,
                            columnNumber: 7,
                        },
                        this
                    ),
                    s &&
                    b.jsxDEV(
                        'div',
                        {
                            className: ar.mobileBg,
                            style: { backgroundImage: `url(${u || r})` },
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section7/index.tsx',
                            lineNumber: 22,
                            columnNumber: 9,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section7/index.tsx',
                lineNumber: 13,
                columnNumber: 5,
            },
            this
        );
    }
    const QR = 'section8_Crot4',
        JR = 'header_uKqUd',
        qR = 'title_zdQGX',
        $R = 'class1_SAbq-',
        FR = 'subtitle_PUHHq',
        KR = 'highlight_YFLtR',
        eM = 'content_UW5Oe',
        tM = 'leftPanel_NSzas',
        nM = 'tabs_xW-hG',
        aM = 'tab_H38A8',
        iM = 'tabActive_HLgJJ',
        lM = 'tabTitle_Wz3qs',
        oM = 'tabDesc_PDkSh',
        sM = 'mediaPanel_C4lTH',
        rM = 'mediaPlaceholder_ZFLEk',
        cM = 'mediaImage_LAdGA',
        uM = 'mbHeader_5QVNO',
        dM = 'mbEnclosedImage_yZGp4',
        fM = 'mbCarousel_fn08R',
        mM = 'mbMedia_-6W-2',
        pM = 'mbMediaPlaceholder_REXPx',
        hM = 'mbMediaNavBtn_HBfHU',
        gM = 'mbMediaNavBtnPrev_A8w6y',
        bM = 'mbMediaNavBtnNext_LC-uG',
        yM = 'mbPanel_mp7p6',
        vM = 'mbSideBtn_KLOY5',
        SM = 'mbSideBtnLeft_xv-WA',
        xM = 'mbSidePill_2Y6Mc',
        NM = 'mbSidePlus_ktx0R',
        wM = 'mbSideBtnRight_vweuQ',
        EM = 'mbSideBtnDisabled_iDw8J',
        AM = 'mbCard_v-RG4',
        DM = 'mbCardTitle_jv2iz',
        TM = 'mbCardDesc_fiOev',
        we = {
            section8: QR,
            header: JR,
            title: qR,
            class1: $R,
            subtitle: FR,
            highlight: KR,
            content: eM,
            leftPanel: tM,
            tabs: nM,
            tab: aM,
            tabActive: iM,
            tabTitle: lM,
            tabDesc: oM,
            mediaPanel: sM,
            mediaPlaceholder: rM,
            mediaImage: cM,
            mbHeader: uM,
            mbEnclosedImage: dM,
            mbCarousel: fM,
            mbMedia: mM,
            mbMediaPlaceholder: pM,
            mbMediaNavBtn: hM,
            mbMediaNavBtnPrev: gM,
            mbMediaNavBtnNext: bM,
            mbPanel: yM,
            mbSideBtn: vM,
            mbSideBtnLeft: SM,
            mbSidePill: xM,
            mbSidePlus: NM,
            mbSideBtnRight: wM,
            mbSideBtnDisabled: EM,
            mbCard: AM,
            mbCardTitle: DM,
            mbCardDesc: TM,
        };
    function Vp(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
    }
    function CM(i, l) {
        if (!i) return '';
        const s = `${i}Mobile`;
        return Vp(s, l) || Vp(i, l);
    }
    function RM() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            s = $n(),
            [r, u] = $.useState(0),
            d = i('section8.safetyTabs', { returnObjects: !0 }),
            p = d[r],
            h = Vp(p?.image, l),
            m = CM(p?.image, l),
            y = Au(l, 'safetyHeaderBg', 'safetyHeaderMobile', s);
        if (s) {
            const E = r <= 0,
                v = r >= d.length - 1,
                N = () => {
                    E || u(D => Math.max(0, D - 1));
                },
                S = () => {
                    v || u(D => Math.min(d.length - 1, D + 1));
                };
            return b.jsxDEV(
                'section',
                {
                    className: we.section8,
                    children: [
                        b.jsxDEV(
                            'div',
                            {
                                className: we.mbHeader,
                                style: { backgroundImage: `url(${y})` },
                                children: [
                                    b.jsxDEV(
                                        'h2',
                                        {
                                            className: we.title,
                                            children: [
                                                b.jsxDEV(
                                                    'span',
                                                    {
                                                        className: we.class1,
                                                        children: i('section8.class1'),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                        lineNumber: 60,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                i('section8.eyeSafe'),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                            lineNumber: 59,
                                            columnNumber: 11,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'p',
                                        {
                                            className: we.subtitle,
                                            children: [
                                                b.jsxDEV(
                                                    'span',
                                                    {
                                                        className: we.highlight,
                                                        children: i('section8.noGoggles'),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                        lineNumber: 64,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                i('section8.noGogglesEnd'),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                            lineNumber: 63,
                                            columnNumber: 11,
                                        },
                                        this
                                    ),
                                ],
                            },
                            void 0,
                            !0,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                lineNumber: 58,
                                columnNumber: 9,
                            },
                            this
                        ),
                        b.jsxDEV(
                            'div',
                            {
                                className: we.mbCarousel,
                                children: [
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: we.mbMedia,
                                            children: [
                                                m
                                                    ? b.jsxDEV(
                                                        'div',
                                                        {
                                                            className: we.mbEnclosedImage,
                                                            style: { backgroundImage: `url(${m})` },
                                                        },
                                                        r,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                            lineNumber: 72,
                                                            columnNumber: 15,
                                                        },
                                                        this
                                                    )
                                                    : b.jsxDEV(
                                                        'div',
                                                        { className: we.mbMediaPlaceholder },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                            lineNumber: 78,
                                                            columnNumber: 15,
                                                        },
                                                        this
                                                    ),
                                                b.jsxDEV(
                                                    'button',
                                                    {
                                                        type: 'button',
                                                        className: `${we.mbMediaNavBtn} ${we.mbMediaNavBtnPrev}`,
                                                        onClick: N,
                                                        disabled: E,
                                                        'aria-label': 'Previous slide',
                                                        children: b.jsxDEV(
                                                            Qt,
                                                            { name: 'icon-left' },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                                lineNumber: 88,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                        lineNumber: 81,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'button',
                                                    {
                                                        type: 'button',
                                                        className: `${we.mbMediaNavBtn} ${we.mbMediaNavBtnNext}`,
                                                        onClick: S,
                                                        disabled: v,
                                                        'aria-label': 'Next slide',
                                                        children: b.jsxDEV(
                                                            Qt,
                                                            { name: 'icon-More' },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                                lineNumber: 97,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                        lineNumber: 90,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                            lineNumber: 70,
                                            columnNumber: 11,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: we.mbPanel,
                                            children: [
                                                b.jsxDEV(
                                                    'button',
                                                    {
                                                        type: 'button',
                                                        className: `${we.mbSideBtn} ${we.mbSideBtnLeft} ${E ? we.mbSideBtnDisabled : ''}`,
                                                        onClick: N,
                                                        disabled: E,
                                                        'aria-label': 'Previous feature',
                                                        children: [
                                                            b.jsxDEV(
                                                                'span',
                                                                { className: we.mbSidePill },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                                    lineNumber: 109,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: we.mbSidePlus,
                                                                    'aria-hidden': 'true',
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                                    lineNumber: 110,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                        lineNumber: 102,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: we.mbCard,
                                                        children: [
                                                            b.jsxDEV(
                                                                'h3',
                                                                {
                                                                    className: we.mbCardTitle,
                                                                    children: p?.title,
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                                    lineNumber: 114,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'p',
                                                                {
                                                                    className: we.mbCardDesc,
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: p?.description ?? '',
                                                                    },
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                                    lineNumber: 115,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                        lineNumber: 113,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'button',
                                                    {
                                                        type: 'button',
                                                        className: `${we.mbSideBtn} ${we.mbSideBtnRight} ${v ? we.mbSideBtnDisabled : ''}`,
                                                        onClick: S,
                                                        disabled: v,
                                                        'aria-label': 'Next feature',
                                                        children: [
                                                            b.jsxDEV(
                                                                'span',
                                                                { className: we.mbSidePill },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                                    lineNumber: 128,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: we.mbSidePlus,
                                                                    'aria-hidden': 'true',
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                                    lineNumber: 129,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                        lineNumber: 121,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                            lineNumber: 101,
                                            columnNumber: 11,
                                        },
                                        this
                                    ),
                                ],
                            },
                            void 0,
                            !0,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                lineNumber: 69,
                                columnNumber: 9,
                            },
                            this
                        ),
                    ],
                },
                void 0,
                !0,
                {
                    fileName:
                        'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                    lineNumber: 57,
                    columnNumber: 7,
                },
                this
            );
        }
        return b.jsxDEV(
            'section',
            {
                className: we.section8,
                children: [
                    b.jsxDEV(
                        'div',
                        {
                            className: we.header,
                            style: { backgroundImage: `url(${y})` },
                            children: [
                                b.jsxDEV(
                                    'h2',
                                    {
                                        className: we.title,
                                        children: [
                                            b.jsxDEV(
                                                'span',
                                                {
                                                    className: we.class1,
                                                    children: i('section8.class1'),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                    lineNumber: 141,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                            i('section8.eyeSafe'),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                        lineNumber: 140,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'p',
                                    {
                                        className: we.subtitle,
                                        children: [
                                            b.jsxDEV(
                                                'span',
                                                {
                                                    className: we.highlight,
                                                    children: i('section8.noGoggles'),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                    lineNumber: 145,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                            i('section8.noGogglesEnd'),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                        lineNumber: 144,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                            lineNumber: 139,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: we.content,
                            children: [
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: we.leftPanel,
                                        children: b.jsxDEV(
                                            'div',
                                            {
                                                className: we.tabs,
                                                children: d.map((E, v) =>
                                                    b.jsxDEV(
                                                        'button',
                                                        {
                                                            type: 'button',
                                                            className: `${we.tab} ${r === v ? we.tabActive : ''}`,
                                                            onClick: () => u(v),
                                                            children: [
                                                                b.jsxDEV(
                                                                    'h3',
                                                                    {
                                                                        className: we.tabTitle,
                                                                        children: E.title,
                                                                    },
                                                                    void 0,
                                                                    !1,
                                                                    {
                                                                        fileName:
                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                                        lineNumber: 160,
                                                                        columnNumber: 17,
                                                                    },
                                                                    this
                                                                ),
                                                                r === v &&
                                                                b.jsxDEV(
                                                                    'p',
                                                                    {
                                                                        className: we.tabDesc,
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: E.description,
                                                                        },
                                                                    },
                                                                    void 0,
                                                                    !1,
                                                                    {
                                                                        fileName:
                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                                        lineNumber: 162,
                                                                        columnNumber: 19,
                                                                    },
                                                                    this
                                                                ),
                                                            ],
                                                        },
                                                        E.title,
                                                        !0,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                            lineNumber: 154,
                                                            columnNumber: 15,
                                                        },
                                                        this
                                                    )
                                                ),
                                            },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                lineNumber: 152,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                        lineNumber: 151,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: we.mediaPanel,
                                        children: h
                                            ? b.jsxDEV(
                                                'div',
                                                {
                                                    className: we.mediaImage,
                                                    style: { backgroundImage: `url(${h})` },
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                    lineNumber: 174,
                                                    columnNumber: 13,
                                                },
                                                this
                                            )
                                            : b.jsxDEV(
                                                'div',
                                                { className: we.mediaPlaceholder },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                                    lineNumber: 176,
                                                    columnNumber: 13,
                                                },
                                                this
                                            ),
                                    },
                                    r,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                                        lineNumber: 172,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                            lineNumber: 150,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section8/index.tsx',
                lineNumber: 138,
                columnNumber: 5,
            },
            this
        );
    }
    const MM = 'section9_qBLUR',
        OM = 'header_91t1a',
        kM = 'title_nWlx1',
        jM = 'subtitle_wFI4-',
        VM = 'fdsTitle_ABVot',
        zM = 'fdsDesc_ZOvs0',
        BM = 'mainImage_gR4P0',
        LM = 'card_XY-f-',
        IM = 'cardColumn_-QaGq',
        HM = 'pcImage_49Jui',
        UM = 'appImage_rJqq1',
        GM = 'feature_Mu82H',
        Bn = {
            section9: MM,
            header: OM,
            title: kM,
            subtitle: jM,
            fdsTitle: VM,
            fdsDesc: zM,
            mainImage: BM,
            card: LM,
            cardColumn: IM,
            pcImage: HM,
            appImage: UM,
            feature: GM,
        };
    function Sp(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
    }
    function xp(i, l, s) {
        return i ? (s && Sp(`${i}Mobile`, l)) || Sp(i, l) : '';
    }
    function _M() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            s = $n(),
            r = xp('softwareMain', l, s),
            u = xp('softwarePC', l, s),
            d = xp('softwareDevices', l, s),
            p = i('section9.features', { returnObjects: !0 }),
            h = [
                { image: u, feature: p[0] },
                { image: d, feature: p[1] },
            ];
        return b.jsxDEV(
            'section',
            {
                className: Bn.section9,
                children: [
                    b.jsxDEV(
                        'div',
                        {
                            className: Bn.header,
                            children: [
                                b.jsxDEV(
                                    'h2',
                                    { className: Bn.title, children: i('section9.title') },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                                        lineNumber: 44,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'p',
                                    {
                                        className: Bn.subtitle,
                                        children: i('section9.subtitle'),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                                        lineNumber: 45,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                            lineNumber: 43,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'h3',
                        { className: Bn.fdsTitle, children: i('section9.fdsTitle') },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                            lineNumber: 47,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'p',
                        {
                            className: Bn.fdsDesc,
                            dangerouslySetInnerHTML: { __html: i('section9.fdsDesc') },
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                            lineNumber: 48,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        Ut,
                        {
                            className: Bn.mainImage,
                            src: r,
                            width: '100%',
                            height: 'auto',
                            alt: '',
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                            lineNumber: 49,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: Bn.card,
                            children: h.map((m, y) =>
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: Bn.cardColumn,
                                        children: [
                                            b.jsxDEV(
                                                Ut,
                                                {
                                                    className: y === 0 ? Bn.pcImage : Bn.appImage,
                                                    src: m.image,
                                                    alt: '',
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                                                    lineNumber: 53,
                                                    columnNumber: 13,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'div',
                                                {
                                                    className: Bn.feature,
                                                    children: [
                                                        b.jsxDEV(
                                                            'h4',
                                                            { children: m.feature?.title },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                                                                lineNumber: 59,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                        b.jsxDEV(
                                                            'p',
                                                            {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: m.feature?.description ?? '',
                                                                },
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                                                                lineNumber: 60,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                    ],
                                                },
                                                void 0,
                                                !0,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                                                    lineNumber: 58,
                                                    columnNumber: 13,
                                                },
                                                this
                                            ),
                                        ],
                                    },
                                    y,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                                        lineNumber: 52,
                                        columnNumber: 11,
                                    },
                                    this
                                )
                            ),
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                            lineNumber: 50,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section9/index.tsx',
                lineNumber: 42,
                columnNumber: 5,
            },
            this
        );
    }
    function Ao(i, l = 3e3) {
        return typeof window.requestIdleCallback == 'function'
            ? window.requestIdleCallback(i, { timeout: l })
            : window.setTimeout(i, 1500);
    }
    function cS(i) {
        if (typeof window.cancelIdleCallback == 'function') {
            window.cancelIdleCallback(i);
            return;
        }
        window.clearTimeout(i);
    }
    function YM(i) {
        const l = document.createElement('video');
        ((l.preload = 'auto'), (l.muted = !0), (l.src = i), l.load());
    }
    function uS(i) {
        const l = new Image();
        l.src = i;
    }
    function PM(i, l, s) {
        const r = $.useRef(new Set()),
            u = i.map(d => `${d.video ?? ''}|${d.image ?? ''}`).join(',');
        $.useEffect(() => {
            const d = i.flatMap(y => {
                const E = s(y.video),
                    v = s(y.image);
                return [
                    E && E !== l ? { url: E, type: 'video' } : null,
                    v && v !== l ? { url: v, type: 'image' } : null,
                ].filter(N => !!N);
            });
            let p = !1,
                h;
            const m = y => {
                if (p || y >= d.length) return;
                const E = d[y];
                if (!E || r.current.has(E.url)) {
                    h = Ao(() => m(y + 1));
                    return;
                }
                (r.current.add(E.url),
                    E.type === 'video' ? YM(E.url) : uS(E.url),
                    (h = Ao(() => m(y + 1))));
            };
            return (
                (h = Ao(() => m(0))),
                () => {
                    ((p = !0), h !== void 0 && cS(h));
                }
            );
        }, [u, l, s]);
    }
    function ZM(i) {
        const l = $.useRef(new Set()),
            s = i.filter(Boolean).join('|');
        $.useEffect(() => {
            const r = i.filter(h => h && !l.current.has(h));
            let u = !1,
                d;
            const p = h => {
                if (u || h >= r.length) return;
                const m = r[h];
                if (!m) {
                    d = Ao(() => p(h + 1));
                    return;
                }
                (l.current.add(m), uS(m), (d = Ao(() => p(h + 1))));
            };
            return (
                r.length > 0 && (d = Ao(() => p(0))),
                () => {
                    ((u = !0), d !== void 0 && cS(d));
                }
            );
        }, [s]);
    }
    function WM(i) {
        return $.useCallback(
            l => {
                if (!l) return '';
                if (l.startsWith('http://') || l.startsWith('https://')) return l;
                const s = i(l);
                return s && s !== l ? s : '';
            },
            [i]
        );
    }
    const XM = 'carousel_DR--m',
        QM = 'swiperWrap_2VC-u',
        JM = 'swiper_LQQOr',
        qM = 'card_099Ti',
        $M = 'thumb_Y7tLp',
        FM = 'cardTitle_FG9wg',
        KM = 'cardDesc_u-Zgu',
        eO = 'footer_EnEgk',
        tO = 'navBtns_DJ5qj',
        nO = 'navBtn_YtTjj',
        Jn = {
            carousel: XM,
            swiperWrap: QM,
            swiper: JM,
            card: qM,
            thumb: $M,
            cardTitle: FM,
            cardDesc: KM,
            footer: eO,
            navBtns: tO,
            navBtn: nO,
        };
    function aO(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
    }
    function iO() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            {
                isBeginning: s,
                isEnd: r,
                goNext: u,
                goPrev: d,
                swiperNavHandlers: p,
            } = Ru(),
            h = i('section10.featureSlides', { returnObjects: !0 });
        return b.jsxDEV(
            'div',
            {
                className: Jn.carousel,
                children: [
                    b.jsxDEV(
                        'div',
                        {
                            className: Jn.swiperWrap,
                            children: b.jsxDEV(
                                rr,
                                {
                                    className: Jn.swiper,
                                    slidesPerView: 'auto',
                                    spaceBetween: 10,
                                    watchOverflow: !0,
                                    observer: !0,
                                    observeParents: !0,
                                    breakpoints: { 769: { spaceBetween: 12 } },
                                    ...p,
                                    children: h.map((m, y) => {
                                        const E = aO(m.image, l);
                                        return b.jsxDEV(
                                            cr,
                                            {
                                                children: b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: Jn.card,
                                                        children: [
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: Jn.thumb,
                                                                    style: E
                                                                        ? { backgroundImage: `url(${E})` }
                                                                        : void 0,
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                                                                    lineNumber: 49,
                                                                    columnNumber: 19,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'h4',
                                                                {
                                                                    className: Jn.cardTitle,
                                                                    children: m.title,
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                                                                    lineNumber: 53,
                                                                    columnNumber: 19,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'p',
                                                                {
                                                                    className: Jn.cardDesc,
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: m.description,
                                                                    },
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                                                                    lineNumber: 54,
                                                                    columnNumber: 19,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                                                        lineNumber: 48,
                                                        columnNumber: 17,
                                                    },
                                                    this
                                                ),
                                            },
                                            `${m.title}-${y}`,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                                                lineNumber: 47,
                                                columnNumber: 15,
                                            },
                                            this
                                        );
                                    }),
                                },
                                void 0,
                                !1,
                                {
                                    fileName:
                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                                    lineNumber: 31,
                                    columnNumber: 9,
                                },
                                this
                            ),
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                            lineNumber: 30,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: Jn.footer,
                            children: b.jsxDEV(
                                'div',
                                {
                                    className: Jn.navBtns,
                                    children: [
                                        b.jsxDEV(
                                            'button',
                                            {
                                                type: 'button',
                                                className: Jn.navBtn,
                                                onClick: d,
                                                disabled: s,
                                                'aria-label': 'Previous',
                                                children: b.jsxDEV(
                                                    Qt,
                                                    { name: 'icon-left' },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                                                        lineNumber: 74,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                                                lineNumber: 67,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                        b.jsxDEV(
                                            'button',
                                            {
                                                type: 'button',
                                                className: Jn.navBtn,
                                                onClick: u,
                                                disabled: r,
                                                'aria-label': 'Next',
                                                children: b.jsxDEV(
                                                    Qt,
                                                    { name: 'icon-More' },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                                                        lineNumber: 83,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                                                lineNumber: 76,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                    ],
                                },
                                void 0,
                                !0,
                                {
                                    fileName:
                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                                    lineNumber: 66,
                                    columnNumber: 9,
                                },
                                this
                            ),
                        },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                            lineNumber: 65,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/FeatureCarousel.tsx',
                lineNumber: 29,
                columnNumber: 5,
            },
            this
        );
    }
    const lO = 'section10_7q8-0',
        oO = 'title_yjaWT',
        sO = 'topRow_TVeke',
        rO = 'topRowMobile_e-JKH',
        cO = 'mobileMedia_50-oz',
        uO = 'mobileMediaAsset_2gy1w',
        dO = 'mobileMediaPlaceholder_1JFsO',
        fO = 'mobileMediaNavBtn_-5VT6',
        mO = 'mobileMediaNavBtnPrev_MbM37',
        pO = 'mobileMediaNavBtnNext_wyQ5E',
        hO = 'mobilePanel_HHsfv',
        gO = 'mobileSideBtn_bzIwe',
        bO = 'mobileSideBtnLeft_hkj9L',
        yO = 'mobileSidePill_FsciA',
        vO = 'mobileSidePlus_24bZ4',
        SO = 'mobileSideBtnRight_EOaVo',
        xO = 'mobileSideBtnDisabled_cOtJu',
        NO = 'mobileCard_BZVj7',
        wO = 'mobileCardTitle_CmsLh',
        EO = 'mobileCardDesc_n2vIg',
        AO = 'aiPanel_RivXN',
        DO = 'tabItem_itwDi',
        TO = 'tabActive_CWKOb',
        CO = 'tabContent_RLwcG',
        RO = 'tabCollapsed_puL9o',
        MO = 'plus_nUNuZ',
        OO = 'tabTitle_nZh0M',
        kO = 'tabDescWrap_rSIz5',
        jO = 'tabDescOpen_xyL4-',
        VO = 'tabDesc_-VVJQ',
        zO = 'plusHidden_jYts-',
        BO = 'aiImage_-g901',
        LO = 'aiImageBg_8lnpx',
        IO = 'aiImagePlaceholder_RG14I',
        HO = 'video_AIhrQ',
        UO = 'playPauseBtn_CAn-c',
        GO = 'mobilePlayPauseBtn_EKTa5',
        _O = 'pauseIcon_AO2j4',
        YO = 'playBtnIcon_2r1DC',
        ye = {
            section10: lO,
            title: oO,
            topRow: sO,
            topRowMobile: rO,
            mobileMedia: cO,
            mobileMediaAsset: uO,
            mobileMediaPlaceholder: dO,
            mobileMediaNavBtn: fO,
            mobileMediaNavBtnPrev: mO,
            mobileMediaNavBtnNext: pO,
            mobilePanel: hO,
            mobileSideBtn: gO,
            mobileSideBtnLeft: bO,
            mobileSidePill: yO,
            mobileSidePlus: vO,
            mobileSideBtnRight: SO,
            mobileSideBtnDisabled: xO,
            mobileCard: NO,
            mobileCardTitle: wO,
            mobileCardDesc: EO,
            aiPanel: AO,
            tabItem: DO,
            tabActive: TO,
            tabContent: CO,
            tabCollapsed: RO,
            plus: MO,
            tabTitle: OO,
            tabDescWrap: kO,
            tabDescOpen: jO,
            tabDesc: VO,
            plusHidden: zO,
            aiImage: BO,
            aiImageBg: LO,
            aiImagePlaceholder: IO,
            video: HO,
            playPauseBtn: UO,
            mobilePlayPauseBtn: GO,
            pauseIcon: _O,
            playBtnIcon: YO,
        };
    function PO() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            s = $n(),
            [r, u] = $.useState(0),
            [d, p] = $.useState(!0),
            h = $.useRef(null),
            m = WM(l),
            y = i('section10.aiTabs', { returnObjects: !0 }),
            E = y[r],
            v = m(E?.video),
            N = m(E?.image),
            S = r <= 0,
            D = r >= y.length - 1;
        (PM(y, v || N, m),
            $.useEffect(() => {
                p(!0);
            }, [r, v]),
            $.useEffect(() => {
                const I = h.current;
                if (!I || !v) return;
                const Y = requestAnimationFrame(() => {
                    I.src !== v && ((I.src = v), I.load(), I.play().catch(() => { }));
                });
                return () => cancelAnimationFrame(Y);
            }, [v]));
        const O = () => {
            const I = h.current;
            if (I) {
                if (I.paused) {
                    (I.play(), p(!0));
                    return;
                }
                (I.pause(), p(!1));
            }
        },
            k = () => {
                S || u(I => Math.max(0, I - 1));
            },
            _ = () => {
                D || u(I => Math.min(y.length - 1, I + 1));
            };
        return b.jsxDEV(
            'section',
            {
                className: ye.section10,
                children: [
                    b.jsxDEV(
                        'h2',
                        { className: ye.title, children: i('section10.title') },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                            lineNumber: 79,
                            columnNumber: 7,
                        },
                        this
                    ),
                    s
                        ? b.jsxDEV(
                            'div',
                            {
                                className: ye.topRowMobile,
                                children: [
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ye.mobileMedia,
                                            children: [
                                                v
                                                    ? b.jsxDEV(
                                                        b.Fragment,
                                                        {
                                                            children: [
                                                                b.jsxDEV(
                                                                    'video',
                                                                    {
                                                                        ref: h,
                                                                        className: ye.mobileMediaAsset,
                                                                        src: v,
                                                                        autoPlay: !0,
                                                                        loop: !0,
                                                                        muted: !0,
                                                                        playsInline: !0,
                                                                    },
                                                                    void 0,
                                                                    !1,
                                                                    {
                                                                        fileName:
                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                        lineNumber: 86,
                                                                        columnNumber: 17,
                                                                    },
                                                                    this
                                                                ),
                                                                b.jsxDEV(
                                                                    'button',
                                                                    {
                                                                        type: 'button',
                                                                        className: ye.mobilePlayPauseBtn,
                                                                        onClick: O,
                                                                        'aria-label': d
                                                                            ? 'Pause video'
                                                                            : 'Play video',
                                                                        children: d
                                                                            ? b.jsxDEV(
                                                                                'span',
                                                                                {
                                                                                    className: ye.pauseIcon,
                                                                                    'aria-hidden': 'true',
                                                                                },
                                                                                void 0,
                                                                                !1,
                                                                                {
                                                                                    fileName:
                                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                                    lineNumber: 102,
                                                                                    columnNumber: 21,
                                                                                },
                                                                                this
                                                                            )
                                                                            : b.jsxDEV(
                                                                                'span',
                                                                                {
                                                                                    className: ye.playBtnIcon,
                                                                                    'aria-hidden': 'true',
                                                                                },
                                                                                void 0,
                                                                                !1,
                                                                                {
                                                                                    fileName:
                                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                                    lineNumber: 104,
                                                                                    columnNumber: 21,
                                                                                },
                                                                                this
                                                                            ),
                                                                    },
                                                                    void 0,
                                                                    !1,
                                                                    {
                                                                        fileName:
                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                        lineNumber: 95,
                                                                        columnNumber: 17,
                                                                    },
                                                                    this
                                                                ),
                                                            ],
                                                        },
                                                        void 0,
                                                        !0,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                            lineNumber: 85,
                                                            columnNumber: 15,
                                                        },
                                                        this
                                                    )
                                                    : N
                                                        ? b.jsxDEV(
                                                            'div',
                                                            {
                                                                className: ye.mobileMediaAsset,
                                                                style: { backgroundImage: `url(${N})` },
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                lineNumber: 109,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        )
                                                        : b.jsxDEV(
                                                            'div',
                                                            { className: ye.mobileMediaPlaceholder },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                lineNumber: 114,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                b.jsxDEV(
                                                    'button',
                                                    {
                                                        type: 'button',
                                                        className: `${ye.mobileMediaNavBtn} ${ye.mobileMediaNavBtnPrev}`,
                                                        onClick: k,
                                                        disabled: S,
                                                        'aria-label': 'Previous slide',
                                                        children: b.jsxDEV(
                                                            Qt,
                                                            { name: 'icon-left' },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                lineNumber: 124,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                        lineNumber: 117,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'button',
                                                    {
                                                        type: 'button',
                                                        className: `${ye.mobileMediaNavBtn} ${ye.mobileMediaNavBtnNext}`,
                                                        onClick: _,
                                                        disabled: D,
                                                        'aria-label': 'Next slide',
                                                        children: b.jsxDEV(
                                                            Qt,
                                                            { name: 'icon-More' },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                lineNumber: 133,
                                                                columnNumber: 15,
                                                            },
                                                            this
                                                        ),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                        lineNumber: 126,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                            lineNumber: 83,
                                            columnNumber: 11,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ye.mobilePanel,
                                            children: [
                                                b.jsxDEV(
                                                    'button',
                                                    {
                                                        type: 'button',
                                                        className: `${ye.mobileSideBtn} ${ye.mobileSideBtnLeft} ${S ? ye.mobileSideBtnDisabled : ''}`,
                                                        onClick: k,
                                                        disabled: S,
                                                        'aria-label': 'Previous feature',
                                                        children: [
                                                            b.jsxDEV(
                                                                'span',
                                                                { className: ye.mobileSidePill },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                    lineNumber: 145,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: ye.mobileSidePlus,
                                                                    'aria-hidden': 'true',
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                    lineNumber: 146,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                        lineNumber: 138,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ye.mobileCard,
                                                        children: [
                                                            b.jsxDEV(
                                                                'h3',
                                                                {
                                                                    className: ye.mobileCardTitle,
                                                                    children: E?.title,
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                    lineNumber: 150,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'p',
                                                                {
                                                                    className: ye.mobileCardDesc,
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: E?.description ?? '',
                                                                    },
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                    lineNumber: 151,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                        lineNumber: 149,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    'button',
                                                    {
                                                        type: 'button',
                                                        className: `${ye.mobileSideBtn} ${ye.mobileSideBtnRight} ${D ? ye.mobileSideBtnDisabled : ''}`,
                                                        onClick: _,
                                                        disabled: D,
                                                        'aria-label': 'Next feature',
                                                        children: [
                                                            b.jsxDEV(
                                                                'span',
                                                                { className: ye.mobileSidePill },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                    lineNumber: 164,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: ye.mobileSidePlus,
                                                                    'aria-hidden': 'true',
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                    lineNumber: 165,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                        lineNumber: 157,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        void 0,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                            lineNumber: 137,
                                            columnNumber: 11,
                                        },
                                        this
                                    ),
                                ],
                            },
                            void 0,
                            !0,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                lineNumber: 82,
                                columnNumber: 9,
                            },
                            this
                        )
                        : b.jsxDEV(
                            'div',
                            {
                                className: ye.topRow,
                                children: [
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ye.aiPanel,
                                            children: y.map((I, Y) => {
                                                const Z = r === Y;
                                                return b.jsxDEV(
                                                    'button',
                                                    {
                                                        type: 'button',
                                                        className: `${ye.tabItem} ${Z ? ye.tabActive : ye.tabCollapsed}`,
                                                        onClick: () => u(Y),
                                                        children: [
                                                            b.jsxDEV(
                                                                'span',
                                                                {
                                                                    className: `${ye.plus} ${Z ? ye.plusHidden : ''}`,
                                                                    'aria-hidden': 'true',
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                    lineNumber: 182,
                                                                    columnNumber: 19,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ye.tabContent,
                                                                    children: [
                                                                        b.jsxDEV(
                                                                            'h3',
                                                                            {
                                                                                className: ye.tabTitle,
                                                                                children: I.title,
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                                lineNumber: 187,
                                                                                columnNumber: 21,
                                                                            },
                                                                            this
                                                                        ),
                                                                        b.jsxDEV(
                                                                            'div',
                                                                            {
                                                                                className: `${ye.tabDescWrap} ${Z ? ye.tabDescOpen : ''}`,
                                                                                children: b.jsxDEV(
                                                                                    'p',
                                                                                    {
                                                                                        className: ye.tabDesc,
                                                                                        dangerouslySetInnerHTML: {
                                                                                            __html: I.description,
                                                                                        },
                                                                                    },
                                                                                    void 0,
                                                                                    !1,
                                                                                    {
                                                                                        fileName:
                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                                        lineNumber: 189,
                                                                                        columnNumber: 23,
                                                                                    },
                                                                                    this
                                                                                ),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                                lineNumber: 188,
                                                                                columnNumber: 21,
                                                                            },
                                                                            this
                                                                        ),
                                                                    ],
                                                                },
                                                                void 0,
                                                                !0,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                    lineNumber: 186,
                                                                    columnNumber: 19,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    I.title,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                        lineNumber: 176,
                                                        columnNumber: 17,
                                                    },
                                                    this
                                                );
                                            }),
                                        },
                                        void 0,
                                        !1,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                            lineNumber: 171,
                                            columnNumber: 11,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: ye.aiImage,
                                            children: v
                                                ? b.jsxDEV(
                                                    b.Fragment,
                                                    {
                                                        children: [
                                                            b.jsxDEV(
                                                                'video',
                                                                {
                                                                    ref: h,
                                                                    className: ye.video,
                                                                    src: v,
                                                                    autoPlay: !0,
                                                                    loop: !0,
                                                                    muted: !0,
                                                                    playsInline: !0,
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                    lineNumber: 203,
                                                                    columnNumber: 17,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'button',
                                                                {
                                                                    type: 'button',
                                                                    className: ye.playPauseBtn,
                                                                    onClick: O,
                                                                    'aria-label': d
                                                                        ? 'Pause video'
                                                                        : 'Play video',
                                                                    children: d
                                                                        ? b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ye.pauseIcon,
                                                                                'aria-hidden': 'true',
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                                lineNumber: 219,
                                                                                columnNumber: 21,
                                                                            },
                                                                            this
                                                                        )
                                                                        : b.jsxDEV(
                                                                            'span',
                                                                            {
                                                                                className: ye.playBtnIcon,
                                                                                'aria-hidden': 'true',
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                                lineNumber: 221,
                                                                                columnNumber: 21,
                                                                            },
                                                                            this
                                                                        ),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                                    lineNumber: 212,
                                                                    columnNumber: 17,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                        lineNumber: 202,
                                                        columnNumber: 15,
                                                    },
                                                    this
                                                )
                                                : N
                                                    ? b.jsxDEV(
                                                        'div',
                                                        {
                                                            className: ye.aiImageBg,
                                                            style: { backgroundImage: `url(${N})` },
                                                        },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                            lineNumber: 226,
                                                            columnNumber: 15,
                                                        },
                                                        this
                                                    )
                                                    : b.jsxDEV(
                                                        'div',
                                                        { className: ye.aiImagePlaceholder },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                                            lineNumber: 231,
                                                            columnNumber: 15,
                                                        },
                                                        this
                                                    ),
                                        },
                                        void 0,
                                        !1,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                            lineNumber: 200,
                                            columnNumber: 11,
                                        },
                                        this
                                    ),
                                ],
                            },
                            void 0,
                            !0,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                                lineNumber: 170,
                                columnNumber: 9,
                            },
                            this
                        ),
                    b.jsxDEV(
                        iO,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                            lineNumber: 237,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section10/index.tsx',
                lineNumber: 78,
                columnNumber: 5,
            },
            this
        );
    }
    const ZO = 'gallery_Bs7rE',
        WO = 'title_KivfL',
        XO = 'desc_4tpC5',
        QO = 'panels_57-Lm',
        JO = 'mobileSwiperWrap_rUzKQ',
        qO = 'mobileSwiper_BHIf3',
        $O = 'mobileSlide_z5TgO',
        FO = 'mobileCard_X42Hc',
        KO = 'mobileCardImage_S5ZPr',
        e4 = 'mobileFooter_aS5Hg',
        t4 = 'mobileNavBtns_OKAAS',
        n4 = 'mobileNavBtn_aZmJv',
        a4 = 'panel_E7XNV',
        i4 = 'panelExpanded_2tz6J',
        l4 = 'panelCollapsed_Ts1aT',
        o4 = 'panelBg_16-Eq',
        s4 = 'playBtn_z-MeA',
        r4 = 'playIcon_2b4Fq',
        ut = {
            gallery: ZO,
            title: WO,
            desc: XO,
            panels: QO,
            mobileSwiperWrap: JO,
            mobileSwiper: qO,
            mobileSlide: $O,
            mobileCard: FO,
            mobileCardImage: KO,
            mobileFooter: e4,
            mobileNavBtns: t4,
            mobileNavBtn: n4,
            panel: a4,
            panelExpanded: i4,
            panelCollapsed: l4,
            panelBg: o4,
            playBtn: s4,
            playIcon: r4,
        };
    function Np(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const s = l(i);
        return s && s !== i ? s : '';
    }
    function c4(i, l) {
        return i.playIcon ? i.playIcon : l === 2 ? 'portable2' : 'portable1';
    }
    function u4() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            s = $n(),
            [r, u] = $.useState(0),
            {
                isBeginning: d,
                isEnd: p,
                goNext: h,
                goPrev: m,
                swiperNavHandlers: y,
            } = Ru(),
            E = i('section11.portablePanels', { returnObjects: !0 });
        return s
            ? b.jsxDEV(
                'div',
                {
                    className: ut.gallery,
                    children: [
                        b.jsxDEV(
                            'h3',
                            {
                                className: ut.title,
                                children: i('section11.portableTitle'),
                            },
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                lineNumber: 40,
                                columnNumber: 9,
                            },
                            this
                        ),
                        b.jsxDEV(
                            'p',
                            {
                                className: ut.desc,
                                children: i('section11.portableDesc'),
                            },
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                lineNumber: 41,
                                columnNumber: 9,
                            },
                            this
                        ),
                        b.jsxDEV(
                            'div',
                            {
                                className: ut.mobileSwiperWrap,
                                children: b.jsxDEV(
                                    rr,
                                    {
                                        className: ut.mobileSwiper,
                                        slidesPerView: 'auto',
                                        spaceBetween: 12,
                                        watchOverflow: !0,
                                        observer: !0,
                                        observeParents: !0,
                                        ...y,
                                        onSlideChange: v => {
                                            (y.onSlideChange(v), u(v.activeIndex));
                                        },
                                        children: E.map((v, N) => {
                                            const S = Np(v.image, l);
                                            return b.jsxDEV(
                                                cr,
                                                {
                                                    className: ut.mobileSlide,
                                                    children: b.jsxDEV(
                                                        'div',
                                                        {
                                                            className: ut.mobileCard,
                                                            children: b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: ut.mobileCardImage,
                                                                    style: S
                                                                        ? { backgroundImage: `url(${S})` }
                                                                        : void 0,
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                                                    lineNumber: 63,
                                                                    columnNumber: 21,
                                                                },
                                                                this
                                                            ),
                                                        },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                                            lineNumber: 62,
                                                            columnNumber: 19,
                                                        },
                                                        this
                                                    ),
                                                },
                                                N,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                                    lineNumber: 61,
                                                    columnNumber: 17,
                                                },
                                                this
                                            );
                                        }),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                        lineNumber: 44,
                                        columnNumber: 11,
                                    },
                                    this
                                ),
                            },
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                lineNumber: 43,
                                columnNumber: 9,
                            },
                            this
                        ),
                        b.jsxDEV(
                            'div',
                            {
                                className: ut.mobileFooter,
                                children: b.jsxDEV(
                                    'div',
                                    {
                                        className: ut.mobileNavBtns,
                                        children: [
                                            b.jsxDEV(
                                                'button',
                                                {
                                                    type: 'button',
                                                    className: ut.mobileNavBtn,
                                                    onClick: m,
                                                    disabled: d,
                                                    'aria-label': 'Previous',
                                                    children: b.jsxDEV(
                                                        Qt,
                                                        { name: 'icon-left' },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                                            lineNumber: 83,
                                                            columnNumber: 15,
                                                        },
                                                        this
                                                    ),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                                    lineNumber: 76,
                                                    columnNumber: 13,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'button',
                                                {
                                                    type: 'button',
                                                    className: ut.mobileNavBtn,
                                                    onClick: h,
                                                    disabled: p,
                                                    'aria-label': 'Next',
                                                    children: b.jsxDEV(
                                                        Qt,
                                                        { name: 'icon-More' },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                                            lineNumber: 92,
                                                            columnNumber: 15,
                                                        },
                                                        this
                                                    ),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                                    lineNumber: 85,
                                                    columnNumber: 13,
                                                },
                                                this
                                            ),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                        lineNumber: 75,
                                        columnNumber: 11,
                                    },
                                    this
                                ),
                            },
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                lineNumber: 74,
                                columnNumber: 9,
                            },
                            this
                        ),
                    ],
                },
                void 0,
                !0,
                {
                    fileName:
                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                    lineNumber: 39,
                    columnNumber: 7,
                },
                this
            )
            : b.jsxDEV(
                'div',
                {
                    className: ut.gallery,
                    children: [
                        b.jsxDEV(
                            'h3',
                            {
                                className: ut.title,
                                children: i('section11.portableTitle'),
                            },
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                lineNumber: 102,
                                columnNumber: 7,
                            },
                            this
                        ),
                        b.jsxDEV(
                            'p',
                            {
                                className: ut.desc,
                                children: i('section11.portableDesc'),
                            },
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                lineNumber: 103,
                                columnNumber: 7,
                            },
                            this
                        ),
                        b.jsxDEV(
                            'div',
                            {
                                className: ut.panels,
                                children: E.map((v, N) => {
                                    const S = r === N,
                                        D = Np(v.image, l),
                                        O = Np(c4(v, N), l);
                                    return b.jsxDEV(
                                        'button',
                                        {
                                            type: 'button',
                                            className: `${ut.panel} ${S ? ut.panelExpanded : ut.panelCollapsed}`,
                                            onClick: () => u(N),
                                            'aria-label': S ? void 0 : `Expand panel ${N + 1}`,
                                            'aria-pressed': S,
                                            children: [
                                                D &&
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: ut.panelBg,
                                                        style: { backgroundImage: `url(${D})` },
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                                        lineNumber: 121,
                                                        columnNumber: 17,
                                                    },
                                                    this
                                                ),
                                                !S &&
                                                O &&
                                                b.jsxDEV(
                                                    'span',
                                                    {
                                                        className: ut.playBtn,
                                                        children: b.jsxDEV(
                                                            Ut,
                                                            {
                                                                src: O,
                                                                alt: '',
                                                                className: ut.playIcon,
                                                                style: { objectFit: 'contain' },
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                                fileName:
                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                                                lineNumber: 128,
                                                                columnNumber: 19,
                                                            },
                                                            this
                                                        ),
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                                        lineNumber: 127,
                                                        columnNumber: 17,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        N,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                            lineNumber: 112,
                                            columnNumber: 13,
                                        },
                                        this
                                    );
                                }),
                            },
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                                lineNumber: 105,
                                columnNumber: 7,
                            },
                            this
                        ),
                    ],
                },
                void 0,
                !0,
                {
                    fileName:
                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/PortableGallery.tsx',
                    lineNumber: 101,
                    columnNumber: 5,
                },
                this
            );
    }
    const d4 = 'section11_jQN2h',
        f4 = 'title_QdFkj',
        m4 = 'row_M-w-r',
        p4 = 'image_h2Bn1',
        h4 = 'text_QVhHZ',
        ln = { section11: d4, title: f4, row: m4, image: p4, text: h4 };
    function g4() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl');
        return b.jsxDEV(
            'section',
            {
                className: ln.section11,
                children: [
                    b.jsxDEV(
                        'h2',
                        { className: ln.title, children: i('section11.title') },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                            lineNumber: 12,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: ln.row,
                            'data-reverse': 'false',
                            children: [
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: ln.text,
                                        children: [
                                            b.jsxDEV(
                                                'h3',
                                                { children: i('section11.engraveCups') },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                                    lineNumber: 16,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'p',
                                                { children: i('section11.engraveCupsDesc') },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                                    lineNumber: 17,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                        lineNumber: 15,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: ln.image,
                                        children: b.jsxDEV(
                                            Ut,
                                            {
                                                src: l('section11EngraveCups'),
                                                width: '100%',
                                                height: '100%',
                                                alt: '',
                                            },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                                lineNumber: 20,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                        lineNumber: 19,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                            lineNumber: 14,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: ln.row,
                            'data-reverse': 'true',
                            children: [
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: ln.image,
                                        children: b.jsxDEV(
                                            Ut,
                                            {
                                                src: l('section11Maintenance'),
                                                width: '100%',
                                                height: '100%',
                                                alt: '',
                                            },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                                lineNumber: 26,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                        lineNumber: 25,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: ln.text,
                                        children: [
                                            b.jsxDEV(
                                                'h3',
                                                {
                                                    dangerouslySetInnerHTML: {
                                                        __html: i('section11.maintenanceTitle'),
                                                    },
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                                    lineNumber: 29,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'p',
                                                { children: i('section11.maintenanceDesc') },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                                    lineNumber: 30,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                        lineNumber: 28,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                            lineNumber: 24,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        u4,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                            lineNumber: 34,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: ln.row,
                            'data-reverse': 'false',
                            children: [
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: ln.text,
                                        children: [
                                            b.jsxDEV(
                                                'h3',
                                                {
                                                    dangerouslySetInnerHTML: {
                                                        __html: i('section11.airPurifierTitle'),
                                                    },
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                                    lineNumber: 38,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'p',
                                                { children: i('section11.airPurifierDesc') },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                                    lineNumber: 39,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                        lineNumber: 37,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: ln.image,
                                        children: b.jsxDEV(
                                            Ut,
                                            {
                                                src: l('section11AirPurifier'),
                                                width: '100%',
                                                height: '100%',
                                                alt: '',
                                            },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                                lineNumber: 42,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                        lineNumber: 41,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                            lineNumber: 36,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: ln.row,
                            'data-reverse': 'true',
                            children: [
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: ln.image,
                                        children: b.jsxDEV(
                                            Ut,
                                            {
                                                src: l('section11Fixture'),
                                                width: '100%',
                                                height: '100%',
                                                alt: '',
                                            },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                                lineNumber: 48,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                        lineNumber: 47,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: ln.text,
                                        children: [
                                            b.jsxDEV(
                                                'h3',
                                                { children: i('section11.fixtureTitle') },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                                    lineNumber: 51,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'p',
                                                { children: i('section11.fixtureDesc') },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                                    lineNumber: 52,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                                        lineNumber: 50,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                            lineNumber: 46,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section11/index.tsx',
                lineNumber: 11,
                columnNumber: 5,
            },
            this
        );
    }
    const b4 = [
        'inBoxVariantPg5w',
        'inBoxVariantWhite5w',
        'inBoxVariantPg10w',
        'inBoxVariantWhite10w',
        'inBoxItem1',
        'inBoxItem2',
        'inBoxItem3',
        'inBoxItem4',
        'inBoxItem5',
        'inBoxItem6',
        'inBoxItem7',
        'inBoxItem8',
        'inBoxItem9',
        'inBoxItem10',
        'inBoxItem11',
        'inBoxItem12',
        'inBoxItem13',
        'inBoxItem14',
        'inBoxItem15',
        'inBoxItem16',
        'inBoxItem17',
    ],
        y4 = {
            inBoxVariantPg5w:
                'https://cdn.creality.com/ow/a1c/177723b2-f75d-4158-8e78-ac6fbf80119e.png',
            inBoxVariantWhite5w:
                'https://cdn.creality.com/ow/a1c/4cae0768-105f-47dd-9179-3b026ce58c1b.png',
            inBoxVariantPg10w:
                'https://cdn.creality.com/ow/a1c/177723b2-f75d-4158-8e78-ac6fbf80119e.png',
            inBoxVariantWhite10w:
                'https://cdn.creality.com/ow/a1c/4cae0768-105f-47dd-9179-3b026ce58c1b.png',
            inBoxItem1:
                'https://cdn.creality.com/ow/a1c/94cd0f55-449c-4a66-87a8-7d696d1c2060.png',
            inBoxItem2:
                'https://cdn.creality.com/ow/a1c/d8b231c1-cb07-45ef-bfcb-c754262dc7c3.png',
            inBoxItem3:
                'https://cdn.creality.com/ow/a1c/8c705410-a233-4360-b4b7-81fc5d362632.png',
            inBoxItem4:
                'https://cdn.creality.com/ow/a1c/d9d7febd-a17a-4144-8bfc-d503540f2d79.png',
            inBoxItem5:
                'https://cdn.creality.com/ow/a1c/b38d74b3-c79b-44e0-9264-9dfea82a103a.png',
            inBoxItem6:
                'https://cdn.creality.com/ow/a1c/6a2249db-9137-4c8b-a4e0-984b878c4ced.png',
            inBoxItem7:
                'https://cdn.creality.com/ow/a1c/cb2a9ba7-b031-4412-9395-298b41895a03.png',
            inBoxItem8:
                'https://cdn.creality.com/ow/a1c/bb4f8747-c695-4ed0-bccc-115c16ee2860.png',
            inBoxItem9:
                'https://cdn.creality.com/ow/a1c/64d7de35-c9ea-4d0a-9b8c-26ed7776781b.png',
            inBoxItem10:
                'https://cdn.creality.com/ow/a1c/dcecef01-02dc-40a7-bf4b-897d9207d44e.png',
            inBoxItem11:
                'https://cdn.creality.com/ow/a1c/7bbcc6ca-9873-402c-9170-6e02e3ebaea5.png',
            inBoxItem12:
                'https://cdn.creality.com/ow/a1c/57f05fcf-2979-41b2-8c88-272af7a587fd.png',
            inBoxItem13:
                'https://cdn.creality.com/ow/a1c/37a6f0e7-7d9f-4e31-ad12-6764eae4c0b5.png',
            inBoxItem14:
                'https://cdn.creality.com/ow/a1c/cf9cf227-4cd6-4022-ac93-ad442131ebe9.png',
            inBoxItem15:
                'https://cdn.creality.com/ow/a1c/11b940e8-ce56-459e-82ba-21ac1b9ac253.png',
            inBoxItem16:
                'https://cdn.creality.com/ow/a1c/c795271b-9ee8-46c7-bf73-c6da69d9436e.png',
            inBoxItem17:
                'https://cdn.creality.com/ow/a1c/33fb660c-eee8-483f-b61c-8e34e5f03227.png',
        };
    var v4 = z0();
    function S4() {
        const [i, l] = $.useState('pc');
        return (
            $.useEffect(() => {
                const s = window.matchMedia('(max-width: 768px)'),
                    r = u => {
                        const d = u.matches ? 'mobile' : 'pc';
                        l(d);
                    };
                return (
                    r({ matches: s.matches }),
                    s.addEventListener('change', r),
                    () => s.removeEventListener('change', r)
                );
            }, []),
            i
        );
    }
    const x4 = 'overlay_zpPdo',
        N4 = 'panel_yXkRm',
        w4 = 'closeBtn_mxtAU',
        E4 = 'scrollArea_VxTVs',
        A4 = 'scaleShell_DNgVB',
        D4 = 'designRoot_LWnmy',
        T4 = 'title_yqfrB',
        C4 = 'compareSection_PaKDL',
        R4 = 'machineRow_Ah-41',
        M4 = 'tableRow_c6HnT',
        O4 = 'machineLabel_g-Mt7',
        k4 = 'itemName_tpD--',
        j4 = 'iconCol_0eXxs',
        V4 = 'variantList_VPOT4',
        z4 = 'valueList_4VTAM',
        B4 = 'variantItem_mNJHi',
        L4 = 'variantImageWrap_5K-te',
        I4 = 'variantImage_6QTxR',
        H4 = 'variantLabel_8b9Za',
        U4 = 'table_uavhh',
        G4 = 'itemIconWrap_qg9gd',
        _4 = 'itemIcon_cgQYm',
        Y4 = 'itemValue_9qY-6',
        P4 = 'itemValueHighlight_D31h3',
        Xe = {
            overlay: x4,
            panel: N4,
            closeBtn: w4,
            scrollArea: E4,
            scaleShell: A4,
            designRoot: D4,
            title: T4,
            compareSection: C4,
            machineRow: R4,
            tableRow: M4,
            machineLabel: O4,
            itemName: k4,
            iconCol: j4,
            variantList: V4,
            valueList: z4,
            variantItem: B4,
            variantImageWrap: L4,
            variantImage: I4,
            variantLabel: H4,
            table: U4,
            itemIconWrap: G4,
            itemIcon: _4,
            itemValue: Y4,
            itemValueHighlight: P4,
        },
        Z4 = 1200,
        W4 = 2826,
        k0 = [
            { w: 94, h: 86 },
            { w: 112, h: 83 },
            { w: 87, h: 77 },
            { w: 128, h: 68 },
            { w: 127, h: 68 },
            { w: 105, h: 81 },
            { w: 104, h: 81 },
            { w: 77, h: 70 },
            { w: 92, h: 80 },
            { w: 119, h: 67 },
            { w: 118, h: 68 },
            { w: 117, h: 75 },
            { w: 124, h: 74 },
            { w: 56, h: 52 },
            { w: 124, h: 87 },
            { w: 122, h: 78 },
            { w: 114, h: 72 },
        ],
        j0 = { w: 120, h: 111 };
    function X4({ open: i, onClose: l }) {
        const s = S4(),
            r = $.useRef(null),
            [u, d] = $.useState(1),
            { t: p } = ze(),
            { t: h } = ze('imageUrl'),
            m = p('section12.inBoxModal.variants', { returnObjects: !0 }),
            y = p('section12.inBoxModal.items', { returnObjects: !0 });
        if (
            ($.useEffect(() => {
                if (!i) return;
                const N = document.body.style.overflow;
                return (
                    (document.body.style.overflow = 'hidden'),
                    () => {
                        document.body.style.overflow = N;
                    }
                );
            }, [i]),
                $.useEffect(() => {
                    if (!i) return;
                    const N = S => {
                        S.key === 'Escape' && l();
                    };
                    return (
                        window.addEventListener('keydown', N),
                        () => window.removeEventListener('keydown', N)
                    );
                }, [i, l]),
                $.useEffect(() => {
                    if (!i || s === 'mobile') {
                        d(1);
                        return;
                    }
                    const N = r.current;
                    if (!N) return;
                    const S = () => {
                        d(N.clientWidth / Z4);
                    };
                    S();
                    const D = new ResizeObserver(S);
                    return (D.observe(N), () => D.disconnect());
                }, [i, s]),
                !i)
        )
            return null;
        const E = s !== 'mobile',
            v = E ? W4 * u : void 0;
        return v4.createPortal(
            b.jsxDEV(
                'div',
                {
                    className: Xe.overlay,
                    onClick: N => {
                        N.target === N.currentTarget && l();
                    },
                    role: 'presentation',
                    children: b.jsxDEV(
                        'div',
                        {
                            ref: r,
                            className: Xe.panel,
                            role: 'dialog',
                            'aria-modal': 'true',
                            'aria-labelledby': 'in-box-modal-title',
                            children: [
                                b.jsxDEV(
                                    'button',
                                    {
                                        type: 'button',
                                        className: Xe.closeBtn,
                                        onClick: l,
                                        'aria-label': 'Close',
                                        children: b.jsxDEV(
                                            'span',
                                            { 'aria-hidden': 'true' },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                lineNumber: 118,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                        lineNumber: 117,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: Xe.scrollArea,
                                        children: b.jsxDEV(
                                            'div',
                                            {
                                                className: Xe.scaleShell,
                                                style: E ? { height: v } : void 0,
                                                children: b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: Xe.designRoot,
                                                        style: E
                                                            ? { transform: `scale(${u})` }
                                                            : void 0,
                                                        children: [
                                                            b.jsxDEV(
                                                                'h2',
                                                                {
                                                                    id: 'in-box-modal-title',
                                                                    className: Xe.title,
                                                                    children: p('section12.inBoxModal.title'),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                    lineNumber: 133,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'div',
                                                                {
                                                                    className: Xe.compareSection,
                                                                    children: [
                                                                        b.jsxDEV(
                                                                            'div',
                                                                            {
                                                                                className: Xe.machineRow,
                                                                                children: [
                                                                                    b.jsxDEV(
                                                                                        'div',
                                                                                        {
                                                                                            className: Xe.iconCol,
                                                                                            'aria-hidden': 'true',
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                            lineNumber: 139,
                                                                                            columnNumber: 19,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                    b.jsxDEV(
                                                                                        'div',
                                                                                        {
                                                                                            className: Xe.iconNameGap,
                                                                                            'aria-hidden': 'true',
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                            lineNumber: 140,
                                                                                            columnNumber: 19,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                    b.jsxDEV(
                                                                                        'p',
                                                                                        {
                                                                                            className: Xe.machineLabel,
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: p(
                                                                                                    'section12.inBoxModal.machineLabel'
                                                                                                ),
                                                                                            },
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                            lineNumber: 141,
                                                                                            columnNumber: 19,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                    b.jsxDEV(
                                                                                        'div',
                                                                                        {
                                                                                            className: Xe.nameValueGap,
                                                                                            'aria-hidden': 'true',
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                            lineNumber: 145,
                                                                                            columnNumber: 19,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                    b.jsxDEV(
                                                                                        'div',
                                                                                        {
                                                                                            className: Xe.variantList,
                                                                                            children: m.map(N =>
                                                                                                b.jsxDEV(
                                                                                                    'div',
                                                                                                    {
                                                                                                        className:
                                                                                                            Xe.variantItem,
                                                                                                        children: [
                                                                                                            b.jsxDEV(
                                                                                                                'div',
                                                                                                                {
                                                                                                                    className:
                                                                                                                        Xe.variantImageWrap,
                                                                                                                    style: E
                                                                                                                        ? {
                                                                                                                            width: j0.w,
                                                                                                                            height:
                                                                                                                                j0.h,
                                                                                                                        }
                                                                                                                        : void 0,
                                                                                                                    children:
                                                                                                                        b.jsxDEV(
                                                                                                                            'img',
                                                                                                                            {
                                                                                                                                className:
                                                                                                                                    Xe.variantImage,
                                                                                                                                src: h(
                                                                                                                                    N.imageKey
                                                                                                                                ),
                                                                                                                                alt: '',
                                                                                                                                decoding:
                                                                                                                                    'async',
                                                                                                                            },
                                                                                                                            void 0,
                                                                                                                            !1,
                                                                                                                            {
                                                                                                                                fileName:
                                                                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                                                                lineNumber: 160,
                                                                                                                                columnNumber: 27,
                                                                                                                            },
                                                                                                                            this
                                                                                                                        ),
                                                                                                                },
                                                                                                                void 0,
                                                                                                                !1,
                                                                                                                {
                                                                                                                    fileName:
                                                                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                                                    lineNumber: 149,
                                                                                                                    columnNumber: 25,
                                                                                                                },
                                                                                                                this
                                                                                                            ),
                                                                                                            b.jsxDEV(
                                                                                                                'p',
                                                                                                                {
                                                                                                                    className:
                                                                                                                        Xe.variantLabel,
                                                                                                                    dangerouslySetInnerHTML:
                                                                                                                    {
                                                                                                                        __html:
                                                                                                                            N.label,
                                                                                                                    },
                                                                                                                },
                                                                                                                void 0,
                                                                                                                !1,
                                                                                                                {
                                                                                                                    fileName:
                                                                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                                                    lineNumber: 167,
                                                                                                                    columnNumber: 25,
                                                                                                                },
                                                                                                                this
                                                                                                            ),
                                                                                                        ],
                                                                                                    },
                                                                                                    N.imageKey,
                                                                                                    !0,
                                                                                                    {
                                                                                                        fileName:
                                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                                        lineNumber: 148,
                                                                                                        columnNumber: 23,
                                                                                                    },
                                                                                                    this
                                                                                                )
                                                                                            ),
                                                                                        },
                                                                                        void 0,
                                                                                        !1,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                            lineNumber: 146,
                                                                                            columnNumber: 19,
                                                                                        },
                                                                                        this
                                                                                    ),
                                                                                ],
                                                                            },
                                                                            void 0,
                                                                            !0,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                lineNumber: 138,
                                                                                columnNumber: 17,
                                                                            },
                                                                            this
                                                                        ),
                                                                        b.jsxDEV(
                                                                            'div',
                                                                            {
                                                                                className: Xe.table,
                                                                                children: y.map((N, S) => {
                                                                                    const D = k0[S] ?? k0[0];
                                                                                    return b.jsxDEV(
                                                                                        'div',
                                                                                        {
                                                                                            className: Xe.tableRow,
                                                                                            children: [
                                                                                                b.jsxDEV(
                                                                                                    'div',
                                                                                                    {
                                                                                                        className: Xe.iconCol,
                                                                                                        children: b.jsxDEV(
                                                                                                            'div',
                                                                                                            {
                                                                                                                className:
                                                                                                                    Xe.itemIconWrap,
                                                                                                                style: E
                                                                                                                    ? {
                                                                                                                        width: D.w,
                                                                                                                        height: D.h,
                                                                                                                    }
                                                                                                                    : void 0,
                                                                                                                children: b.jsxDEV(
                                                                                                                    'img',
                                                                                                                    {
                                                                                                                        className:
                                                                                                                            Xe.itemIcon,
                                                                                                                        src: h(
                                                                                                                            N.imageKey
                                                                                                                        ),
                                                                                                                        alt: '',
                                                                                                                        decoding:
                                                                                                                            'async',
                                                                                                                    },
                                                                                                                    void 0,
                                                                                                                    !1,
                                                                                                                    {
                                                                                                                        fileName:
                                                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                                                        lineNumber: 191,
                                                                                                                        columnNumber: 29,
                                                                                                                    },
                                                                                                                    this
                                                                                                                ),
                                                                                                            },
                                                                                                            void 0,
                                                                                                            !1,
                                                                                                            {
                                                                                                                fileName:
                                                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                                                lineNumber: 183,
                                                                                                                columnNumber: 27,
                                                                                                            },
                                                                                                            this
                                                                                                        ),
                                                                                                    },
                                                                                                    void 0,
                                                                                                    !1,
                                                                                                    {
                                                                                                        fileName:
                                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                                        lineNumber: 182,
                                                                                                        columnNumber: 25,
                                                                                                    },
                                                                                                    this
                                                                                                ),
                                                                                                b.jsxDEV(
                                                                                                    'div',
                                                                                                    {
                                                                                                        className:
                                                                                                            Xe.iconNameGap,
                                                                                                        'aria-hidden': 'true',
                                                                                                    },
                                                                                                    void 0,
                                                                                                    !1,
                                                                                                    {
                                                                                                        fileName:
                                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                                        lineNumber: 199,
                                                                                                        columnNumber: 25,
                                                                                                    },
                                                                                                    this
                                                                                                ),
                                                                                                b.jsxDEV(
                                                                                                    'p',
                                                                                                    {
                                                                                                        className: Xe.itemName,
                                                                                                        dangerouslySetInnerHTML:
                                                                                                            { __html: N.name },
                                                                                                    },
                                                                                                    void 0,
                                                                                                    !1,
                                                                                                    {
                                                                                                        fileName:
                                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                                        lineNumber: 200,
                                                                                                        columnNumber: 25,
                                                                                                    },
                                                                                                    this
                                                                                                ),
                                                                                                b.jsxDEV(
                                                                                                    'div',
                                                                                                    {
                                                                                                        className:
                                                                                                            Xe.nameValueGap,
                                                                                                        'aria-hidden': 'true',
                                                                                                    },
                                                                                                    void 0,
                                                                                                    !1,
                                                                                                    {
                                                                                                        fileName:
                                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                                        lineNumber: 204,
                                                                                                        columnNumber: 25,
                                                                                                    },
                                                                                                    this
                                                                                                ),
                                                                                                b.jsxDEV(
                                                                                                    'div',
                                                                                                    {
                                                                                                        className: Xe.valueList,
                                                                                                        children: N.values.map(
                                                                                                            (O, k) =>
                                                                                                                b.jsxDEV(
                                                                                                                    'span',
                                                                                                                    {
                                                                                                                        className:
                                                                                                                            N.highlightValues
                                                                                                                                ? Xe.itemValueHighlight
                                                                                                                                : Xe.itemValue,
                                                                                                                        children: O,
                                                                                                                    },
                                                                                                                    `${N.imageKey}-${k}`,
                                                                                                                    !1,
                                                                                                                    {
                                                                                                                        fileName:
                                                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                                                        lineNumber: 207,
                                                                                                                        columnNumber: 29,
                                                                                                                    },
                                                                                                                    this
                                                                                                                )
                                                                                                        ),
                                                                                                    },
                                                                                                    void 0,
                                                                                                    !1,
                                                                                                    {
                                                                                                        fileName:
                                                                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                                        lineNumber: 205,
                                                                                                        columnNumber: 25,
                                                                                                    },
                                                                                                    this
                                                                                                ),
                                                                                            ],
                                                                                        },
                                                                                        N.imageKey,
                                                                                        !0,
                                                                                        {
                                                                                            fileName:
                                                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                            lineNumber: 181,
                                                                                            columnNumber: 23,
                                                                                        },
                                                                                        this
                                                                                    );
                                                                                }),
                                                                            },
                                                                            void 0,
                                                                            !1,
                                                                            {
                                                                                fileName:
                                                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                                lineNumber: 176,
                                                                                columnNumber: 17,
                                                                            },
                                                                            this
                                                                        ),
                                                                    ],
                                                                },
                                                                void 0,
                                                                !0,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                                    lineNumber: 137,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                        lineNumber: 123,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            },
                                            void 0,
                                            !1,
                                            {
                                                fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                                lineNumber: 122,
                                                columnNumber: 11,
                                            },
                                            this
                                        ),
                                    },
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                                        lineNumber: 121,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                            lineNumber: 110,
                            columnNumber: 7,
                        },
                        this
                    ),
                },
                void 0,
                !1,
                {
                    fileName:
                        'D:/works/creality-offical-product/src/pages/A1C/components/Section12/InBoxModal.tsx',
                    lineNumber: 103,
                    columnNumber: 5,
                },
                this
            ),
            document.body
        );
    }
    const Q4 = 'section12_QFV-T',
        J4 = 'inBoxBtn_0jSKs',
        q4 = 'inBoxText_X9-R0',
        $4 = 'inBoxIcon_PAMjU',
        F4 = 'title_9Da4j',
        K4 = 'grid_MyYq3',
        ek = 'card_uPMmR',
        tk = 'cardContent_n40VX',
        nk = 'btnActive_U--dt',
        ak = 'btnInactive_n-gpH',
        ik = 'cardImage_eFyyP',
        qn = {
            section12: Q4,
            inBoxBtn: J4,
            inBoxText: q4,
            inBoxIcon: $4,
            title: F4,
            grid: K4,
            card: ek,
            cardContent: tk,
            btnActive: nk,
            btnInactive: ak,
            cardImage: ik,
        },
        lk = [
            'accessoryAirPurifier',
            'accessoryFixture',
            'accessoryFan',
            'accessoryRotary',
        ];
    function ok() {
        const [i, l] = $.useState(!1),
            { t: s } = ze(),
            { t: r } = ze('imageUrl'),
            u = lk,
            d = s('section12.accessories', { returnObjects: !0 }),
            p = $.useMemo(() => b4.map(h => r(h)).filter(Boolean), [r]);
        return (
            ZM(p),
            b.jsxDEV(
                'section',
                {
                    className: qn.section12,
                    children: [
                        b.jsxDEV(
                            'button',
                            {
                                type: 'button',
                                className: qn.inBoxBtn,
                                onClick: () => l(!0),
                                children: [
                                    b.jsxDEV(
                                        'span',
                                        { className: qn.inBoxIcon, 'aria-hidden': 'true' },
                                        void 0,
                                        !1,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                                            lineNumber: 46,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                    b.jsxDEV(
                                        'span',
                                        {
                                            className: qn.inBoxText,
                                            children: s('section12.inBox'),
                                        },
                                        void 0,
                                        !1,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                                            lineNumber: 47,
                                            columnNumber: 9,
                                        },
                                        this
                                    ),
                                ],
                            },
                            void 0,
                            !0,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                                lineNumber: 45,
                                columnNumber: 7,
                            },
                            this
                        ),
                        b.jsxDEV(
                            X4,
                            { open: i, onClose: () => l(!1) },
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                                lineNumber: 50,
                                columnNumber: 7,
                            },
                            this
                        ),
                        b.jsxDEV(
                            'h2',
                            {
                                className: qn.title,
                                children: s('section12.accessoriesTitle'),
                            },
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                                lineNumber: 52,
                                columnNumber: 7,
                            },
                            this
                        ),
                        b.jsxDEV(
                            'div',
                            {
                                className: qn.grid,
                                children: d.map((h, m) =>
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: qn.card,
                                            children: [
                                                b.jsxDEV(
                                                    'div',
                                                    {
                                                        className: qn.cardContent,
                                                        children: [
                                                            b.jsxDEV(
                                                                'h3',
                                                                { children: h.title },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                                                                    lineNumber: 58,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'p',
                                                                { children: h.description },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                                                                    lineNumber: 59,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                            b.jsxDEV(
                                                                'button',
                                                                {
                                                                    type: 'button',
                                                                    className: h.active
                                                                        ? qn.btnActive
                                                                        : qn.btnInactive,
                                                                    onClick: () => {
                                                                        h.href &&
                                                                            window.open(
                                                                                h.href,
                                                                                '_blank',
                                                                                'noopener,noreferrer'
                                                                            );
                                                                    },
                                                                    children: s('section12.learnMore'),
                                                                },
                                                                void 0,
                                                                !1,
                                                                {
                                                                    fileName:
                                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                                                                    lineNumber: 60,
                                                                    columnNumber: 15,
                                                                },
                                                                this
                                                            ),
                                                        ],
                                                    },
                                                    void 0,
                                                    !0,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                                                        lineNumber: 57,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                b.jsxDEV(
                                                    Ut,
                                                    {
                                                        className: qn.cardImage,
                                                        src: r(u[m]),
                                                        width: 'auto',
                                                        height: 'auto',
                                                        alt: h.title,
                                                    },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                                                        lineNumber: 71,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                            ],
                                        },
                                        h.title,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                                            lineNumber: 56,
                                            columnNumber: 11,
                                        },
                                        this
                                    )
                                ),
                            },
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                                lineNumber: 54,
                                columnNumber: 7,
                            },
                            this
                        ),
                    ],
                },
                void 0,
                !0,
                {
                    fileName:
                        'D:/works/creality-offical-product/src/pages/A1C/components/Section12/index.tsx',
                    lineNumber: 44,
                    columnNumber: 5,
                },
                this
            )
        );
    }
    const sk = 'section13_X06Vo',
        rk = 'title_WatHA',
        ck = 'specLayout_FHcNm',
        uk = 'specRow_UB90X',
        dk = 'rowTall_57A98',
        fk = 'imageRow_68gPo',
        mk = 'colLabel_3TlxQ',
        pk = 'colValue_SNfIf',
        Ln = {
            section13: sk,
            title: rk,
            specLayout: ck,
            specRow: uk,
            rowTall: dk,
            imageRow: fk,
            colLabel: mk,
            colValue: pk,
        };
    function hk() {
        const { t: i } = ze(),
            { t: l } = ze('imageUrl'),
            s = i('section13.labels', { returnObjects: !0 }),
            r = i('section13.variants', { returnObjects: !0 }),
            u = [
                { label: s[0], render: h => h.name },
                { label: s[1], render: h => h.color },
                { label: s[2], render: h => h.laserModules },
                { label: s[3], render: h => h.interchangeable },
                { label: s[4], render: h => h.engravingArea },
                { label: s[5], render: h => h.maxHeight },
                { label: s[6], render: h => h.laserSafety },
                { label: s[7], render: h => h.maxSpeed },
                { label: s[8], render: h => h.focusMode },
                { label: s[9], render: h => h.camera },
                { label: s[10], render: h => h.cameraAssist },
                { label: s[11], render: h => h.aiFill },
                { label: s[12], render: h => h.optionalPackages },
                { label: s[13], render: h => h.iotControl },
                { label: s[14], render: h => h.appControl },
                { label: s[15], render: h => h.machineDim },
                { label: s[16], render: h => h.packageDim },
                { label: s[17], render: h => h.netWeight },
                { label: s[18], render: h => h.grossWeight },
            ],
            d = h =>
                h === !0 || h === '✓'
                    ? '✓'
                    : h === !1 || h === '×'
                        ? '×'
                        : h || ' ',
            p = h => {
                if (
                    h.includes(`
`)
                ) {
                    const [m, y] = h.split(`
`);
                    return b.jsxDEV(
                        b.Fragment,
                        {
                            children: [
                                m,
                                b.jsxDEV(
                                    'br',
                                    {},
                                    void 0,
                                    !1,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                                        lineNumber: 76,
                                        columnNumber: 11,
                                    },
                                    this
                                ),
                                y,
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                            lineNumber: 74,
                            columnNumber: 9,
                        },
                        this
                    );
                }
                return h;
            };
        return b.jsxDEV(
            'section',
            {
                className: Ln.section13,
                children: [
                    b.jsxDEV(
                        'h2',
                        { className: Ln.title, children: i('section13.title') },
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                            lineNumber: 86,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        'div',
                        {
                            className: Ln.specLayout,
                            children: [
                                b.jsxDEV(
                                    'div',
                                    {
                                        className: `${Ln.specRow} ${Ln.imageRow}`,
                                        children: [
                                            b.jsxDEV(
                                                'div',
                                                { className: Ln.colLabel },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                                                    lineNumber: 90,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'div',
                                                {
                                                    className: Ln.colValue,
                                                    children: b.jsxDEV(
                                                        Ut,
                                                        {
                                                            src: l('specTable1'),
                                                            width: 'auto',
                                                            height: 'auto',
                                                            alt: '',
                                                        },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                                                            lineNumber: 92,
                                                            columnNumber: 13,
                                                        },
                                                        this
                                                    ),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                                                    lineNumber: 91,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                            b.jsxDEV(
                                                'div',
                                                {
                                                    className: Ln.colValue,
                                                    children: b.jsxDEV(
                                                        Ut,
                                                        {
                                                            src: l('specTable2'),
                                                            width: 'auto',
                                                            height: 'auto',
                                                            alt: '',
                                                        },
                                                        void 0,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                                                            lineNumber: 95,
                                                            columnNumber: 13,
                                                        },
                                                        this
                                                    ),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                    fileName:
                                                        'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                                                    lineNumber: 94,
                                                    columnNumber: 11,
                                                },
                                                this
                                            ),
                                        ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                        fileName:
                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                                        lineNumber: 89,
                                        columnNumber: 9,
                                    },
                                    this
                                ),
                                u.map((h, m) =>
                                    b.jsxDEV(
                                        'div',
                                        {
                                            className: `${Ln.specRow} ${m === 6 || m === 17 ? Ln.rowTall : ''}`,
                                            children: [
                                                b.jsxDEV(
                                                    'div',
                                                    { className: Ln.colLabel, children: p(h.label) },
                                                    void 0,
                                                    !1,
                                                    {
                                                        fileName:
                                                            'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                                                        lineNumber: 104,
                                                        columnNumber: 13,
                                                    },
                                                    this
                                                ),
                                                r.map(y =>
                                                    b.jsxDEV(
                                                        'div',
                                                        {
                                                            className: Ln.colValue,
                                                            children: d(h.render(y)),
                                                        },
                                                        y.color,
                                                        !1,
                                                        {
                                                            fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                                                            lineNumber: 106,
                                                            columnNumber: 15,
                                                        },
                                                        this
                                                    )
                                                ),
                                            ],
                                        },
                                        h.label,
                                        !0,
                                        {
                                            fileName:
                                                'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                                            lineNumber: 100,
                                            columnNumber: 11,
                                        },
                                        this
                                    )
                                ),
                            ],
                        },
                        void 0,
                        !0,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                            lineNumber: 88,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/components/Section13/index.tsx',
                lineNumber: 85,
                columnNumber: 5,
            },
            this
        );
    }
    function gk() {
        return b.jsxDEV(
            'div',
            {
                className: DE.page,
                style: { color: 'var(--a1c-text-dark)' },
                children: [
                    b.jsxDEV(
                        HE,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 19,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        XA,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 20,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        tD,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 21,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        qD,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 22,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        RR,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 23,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        GR,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 24,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        XR,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 25,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        RM,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 26,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        _M,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 27,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        PO,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 28,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        g4,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 29,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        ok,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 30,
                            columnNumber: 7,
                        },
                        this
                    ),
                    b.jsxDEV(
                        hk,
                        {},
                        void 0,
                        !1,
                        {
                            fileName:
                                'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                            lineNumber: 31,
                            columnNumber: 7,
                        },
                        this
                    ),
                ],
            },
            void 0,
            !0,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/index.tsx',
                lineNumber: 18,
                columnNumber: 5,
            },
            this
        );
    }
    const bk = {
        title: 'Creality Falcon A1C',
        section1: {
            badge: 'NEW',
            title: 'Creality Falcon A1C',
            subtitle: 'The Perfect First Laser Engraver<br/>for Your Home.',
            scrollTitle:
                'Lightweight & easy to use,<br/>unlock home creativity for<br/>all beginners.',
            scrollSubtitle: 'Your all-in-one household<br/>creativity engine.',
        },
        section2: {
            title: 'Highlights',
            autoFocus: 'True Auto Focus',
            liftingPlatform: 'Smart Lifting Platform',
            workingAreaLabel: 'Working Area:',
            workingAreaValue: '150 × 150 × <strong>148 mm</strong>',
            laserModulesTitle: '3 Interchangeable Laser Modules',
            laser5w: '5W',
            laser5wType: 'Diode',
            laser10w: '10W',
            laser10wType: 'Diode',
            laserIR: '1.2W',
            laserIRType: 'IR',
            materialsCount: '300+',
            materials: 'Materials',
            laserSafety: 'Laser<br/>Safety',
            class1: 'Class 1',
            smartIoT: 'Smart IoT Control',
            smartIoTDesc: `Seamless control
across devices`,
            aiCamera: 'AI Camera Assist',
            aiCameraDesc: 'Easier Positioning and Filling',
            highSpeed: 'High-Speed Engraving',
            upTo: 'up to',
            speedValue: '15,000',
            speedUnit: ' mm/min',
            aiPowered: 'AI-Powered<br/>',
            smartExperience: 'Smart Experience',
        },
        section3: {
            title: 'Experience Fun in Various Scenarios',
            subtitle: 'A1C fits perfectly into your lifestyle',
            scenarios: [
                {
                    title: 'Everyday DIY &<br class="br_pc"/>Creative Moments',
                    description:
                        'Create decorations, gifts, and keepsakes that<br class="br_mb"/>add a personal touch to daily life.',
                    imagePosition: 'right',
                    bgColor: '#ebedfa',
                },
                {
                    title:
                        'Holidays, Parties &<br class="br_pc"/>Special Occasions',
                    description:
                        'Make instant, personalized creations for birthdays,<br class="br_mb"/>holidays, and gatherings.',
                    imagePosition: 'left',
                    bgColor: '#faf5eb',
                },
                {
                    title:
                        'Turn Creativity<br class="br_pc"/>into Meaningful Gifts',
                    description:
                        'Engrave names, dates, or messages&#8209;make<br class="br_mb"/>every gift truly one of a kind.',
                    imagePosition: 'right',
                    bgColor: '#ebfaf2',
                },
                {
                    title:
                        'Retail & pop-up store<br class="br_pc"/>on-site engraving',
                    description:
                        'Instant personalization for customers&#8209;boost<br class="br_mb"/>engagement and sales.',
                    imagePosition: 'left',
                    bgColor: '#faf0eb',
                },
            ],
        },
        section4: {
            title: 'Simple and Easy to Use',
            subtitle: 'Start creating right away-no experience required.',
            easyUseTabs: [
                {
                    title: 'Interchangeable<br class="br_pc"/>Laser Modules',
                    description:
                        'Swap <span class="highlight">5W / 10W / 1.2W</span> lasers<br class="br_mb"/>in seconds without tools.',
                    video: 'easyUseVideo1',
                },
                {
                    title: 'True Autofocus,<br class="br_pc"/>No manual adjustment',
                    description:
                        'Just place the material and click. The machine automatically finds the perfect height.',
                    video: 'easyUseVideo2',
                },
                {
                    title: 'Clear PC/APP control',
                    description:
                        'Control the machine with intuitive software, even as a beginner.',
                    video: 'easyUseVideo3',
                },
                {
                    title: 'Portable and<br class="br_pc"/>Easy to Carry',
                    description:
                        'Easy to move between your living room, classroom, studio, or shop counter.',
                    image: 'easyUse4',
                },
            ],
        },
        section5: {
            heroTitle: 'Greater Stability,<br/>Sharper Details',
            stabilityCards: [
                {
                    title: 'High Motion Accuracy',
                    description:
                        'Precise and smooth<br/>movement delivers cleaner,<br/>more consistent lines.',
                },
                {
                    title: 'Rigid Structural Design',
                    description:
                        'Solid construction effectively<br/>reduces vibration for stable<br/>engraving performance.',
                },
                {
                    title: 'Fine Laser Spot',
                    description:
                        'A smaller laser spot<br/>produces sharper lines<br/>and more refined details.',
                },
            ],
            materialsTitle: 'Precise Engraving on Various Materials',
            materialsSubtitle: 'One machine, endless possibilities',
            tabDiode: '5W / 10W Diode',
            tabIR: '1.2W IR',
            materialCarousel: {
                diode: {
                    slides: [
                        {
                            label: 'Wood',
                            image: 'diodeSlide1',
                            indicatorImage: 'diodeIndicator1',
                        },
                        {
                            label: 'Bamboo',
                            image: 'diodeSlide2',
                            indicatorImage: 'diodeIndicator2',
                        },
                        {
                            label: 'Paper',
                            image: 'diodeSlide3',
                            indicatorImage: 'diodeIndicator3',
                        },
                        {
                            label: 'Cork/Cardboard',
                            image: 'diodeSlide4',
                            indicatorImage: 'diodeIndicator4',
                        },
                        {
                            label: 'Rock',
                            image: 'diodeSlide5',
                            indicatorImage: 'diodeIndicator5',
                        },
                        {
                            label: 'Leather',
                            image: 'diodeSlide6',
                            indicatorImage: 'diodeIndicator6',
                        },
                        {
                            label: 'Glass',
                            image: 'diodeSlide7',
                            indicatorImage: 'diodeIndicator7',
                        },
                        {
                            label: 'Fabric',
                            image: 'diodeSlide8',
                            indicatorImage: 'diodeIndicator8',
                        },
                    ],
                },
                ir: {
                    slides: [
                        {
                            label: 'Brass & Gold',
                            image: 'irSlide1',
                            indicatorImage: 'irIndicator1',
                        },
                        {
                            label: 'Silver & Platinum',
                            image: 'irSlide2',
                            indicatorImage: 'irIndicator2',
                        },
                        {
                            label: 'Acrylic & Plastic',
                            image: 'irSlide3',
                            indicatorImage: 'irIndicator3',
                        },
                        {
                            label: 'Aluminum & Stainless Steel',
                            image: 'irSlide4',
                            indicatorImage: 'irIndicator4',
                        },
                    ],
                },
            },
            galleryTitle: 'Start Creating Today with Falcon A1C',
            gallerySlides: [
                { label: 'Home', image: 'gallerySlide1' },
                { label: 'Gifts', image: 'gallerySlide2' },
                { label: 'Holiday', image: 'gallerySlide3' },
                { label: 'Events', image: 'gallerySlide4' },
                { label: 'Apparel', image: 'gallerySlide5' },
                { label: 'Pet', image: 'gallerySlide6' },
            ],
        },
        section6: {
            title: 'Auto Lifting',
            workspace: '150×150×148 mm',
            subtitle: 'Bigger Workspace in a Compact Body',
            description:
                'Despite its compact size, A1C delivers an impressively large 150 × 150 mm workspace',
            emDash: '—',
            descriptionEnd:
                'big enough for real, practical projects. Create coasters, leather goods, small ornaments, and personalized gifts with ease.',
        },
        section7: {
            title: '15,000 mm/min High-Speed Engraving',
            subtitle:
                'Leading speed in its class-less waiting, smoother creation.',
        },
        section8: {
            class1: 'Class 1',
            eyeSafe: ' Eye-Safe Design',
            noGoggles: 'No protective goggles',
            noGogglesEnd: ' required for everyday use.',
            safetyTabs: [
                {
                    title: 'Fully Enclosed Protective Design',
                    description:
                        'Effectively blocks harmful laser exposure while keeping a clear, visible workspace.',
                    image: 'safetyTab1',
                },
                {
                    title: 'Smart Flame Detection for Safer Engraving',
                    description:
                        'Automatically stops operation if flames are detected, with buzzer alerts and instant notifications sent to PC and App.',
                    image: 'safetyTab2',
                },
                {
                    title: 'Tilt Protection',
                    description:
                        'Automatically shuts down the machine if abnormal tilting is detected.',
                    image: 'safetyTab3',
                },
                {
                    title: 'USB Safety Lock',
                    description:
                        'Prevents accidental operation and keeps children safe.',
                    image: 'safetyTab4',
                },
            ],
        },
        section9: {
            title: 'Easy Free Software Studio',
            subtitle: 'Powerful tools that stay friendly for beginners',
            fdsTitle: 'Free FDS Studio',
            fdsDesc:
                'Clean interface, intuitive controls, and real-time<br/>preview for effortless creation.',
            features: [
                {
                    title: 'Full LightBurn compatibility',
                    description:
                        'Advanced tools for creators who want deeper control and professional results.',
                },
                {
                    title: 'Multi-Device Control',
                    description:
                        'Operate via PC or mobile App,<br/>with Wi-Fi, Bluetooth, and USB<br/>connectivity for flexible workflow.',
                },
            ],
        },
        section10: {
            title: 'Smart Tech That Elevates Everything',
            aiTabs: [
                {
                    title: 'AI Filter Lab',
                    description:
                        'Switch between a variety of professional styles and refresh your creative assets with one click.',
                    video: 'aiVideo1',
                },
                {
                    title: 'AI Contour Extraction',
                    description:
                        'Automatically detects colors and separates layers, converting images into color vector layers ideal for multi-color engraving—making color engraving faster and easier.',
                    video: 'aiVideo2',
                },
                {
                    title: 'AI Background Removal',
                    description:
                        'Automatically identifies object edges to create smooth, high-quality transparent images for faster workflows.',
                    video: 'aiVideo3',
                },
                {
                    title: 'AI Smart Fill & Layout',
                    description:
                        'Automatically detects identical materials and applies optimized patterns for 60% faster batch engraving.',
                    video: 'aiVideo4',
                },
            ],
            featureSlides: [
                {
                    title: 'Rich Project Library, Endless Inspiration',
                    description:
                        'The Caftseek library offers thousands of free, high-quality project designs. Download with one click and start creating—your creativity never runs out!',
                    image: 'featureSlide1',
                },
                {
                    title: 'APP AI One-Tap Engraving',
                    description:
                        'Upload a photo or take one with your phone. AI automatically converts it into engraving-ready styles like line art or illustration, optimizes the image, and matches the right material settings. Start with one tap-beginners can easily create high-quality engravings.',
                    image: 'featureSlide2',
                },
                {
                    title: 'AI Support Assistant',
                    description:
                        'When the device detects an alert, the AI assistant automatically provides the right solution.<br/>AI + human support ensures a worry-free experience from setup to production.',
                    image: 'featureSlide3',
                },
                {
                    title: 'Cloud Storage',
                    description:
                        'Supports cloud-based file storage with seamless access across devices.<br/>Your designs can be downloaded directly to the touchscreen anytime-start engraving whenever inspiration strikes.',
                    image: 'featureSlide4',
                },
                {
                    title: 'Material Test Array',
                    description:
                        'Automatically generates a grid with multiple power and speed combinations in a single job, helping you quickly identify the best settings for new materials while reducing trial and error.',
                    image: 'featureSlide5',
                },
                {
                    title: 'Intelligent Split & Fill',
                    description:
                        'Split oversized designs into joinable parts with precision joints, and use intelligent fill to optimize layouts for efficient material usage.',
                    image: 'featureSlide6',
                },
            ],
        },
        section11: {
            title: 'Portable, Flexible & Easy to Maintain',
            engraveCups: 'Engrave Cups & Spheres',
            engraveCupsDesc:
                'Easily engrave tumblers, mugs, spherical ornaments, and various curved or cylindrical items.',
            maintenanceTitle: 'Easy Maintenance,<br/>Easy Cleaning',
            maintenanceDesc:
                'Quick-release fan design makes daily cleaning simple and hassle-free.',
            portableTitle: 'Portable & Ready to Go',
            portableDesc:
                'Lightweight and easy to move-start creating anytime in your living room, garage, or studio.',
            portablePanels: [
                { image: 'portablePanel1', playIcon: 'portable1' },
                { image: 'portablePanel2', playIcon: 'portable1' },
                { image: 'portablePanel3', playIcon: 'portable2' },
            ],
            airPurifierTitle:
                'Optional Air Purifier for<br/>Worry-Free Creation',
            airPurifierDesc:
                'Effectively filters smoke and odors generated during engraving, making it ideal for home and indoor use.',
            fixtureTitle: 'Flexible Fixture Expansion',
            fixtureDesc:
                'Unlock more creative scenarios and explore new possibilities with flexible workholding options.',
        },
        section12: {
            inBox: 'What in box',
            inBoxModal: {
                title: 'What in box',
                machineLabel: 'Laser Cutter<br />and Engraver:',
                variants: [
                    { label: 'Purple Gray<br />5W', imageKey: 'inBoxVariantPg5w' },
                    { label: 'White<br />5W', imageKey: 'inBoxVariantWhite5w' },
                    {
                        label: 'Purple Gray<br />10W',
                        imageKey: 'inBoxVariantPg10w',
                    },
                    { label: 'White<br />10W', imageKey: 'inBoxVariantWhite10w' },
                ],
                items: [
                    {
                        name: 'Power Adapter:',
                        imageKey: 'inBoxItem1',
                        values: ['√', '√', '√', '√'],
                    },
                    {
                        name: 'Power Cord:',
                        imageKey: 'inBoxItem2',
                        values: ['√', '√', '√', '√'],
                    },
                    {
                        name: 'Exhaust Pipe:',
                        imageKey: 'inBoxItem3',
                        values: ['√', '√', '√', '√'],
                    },
                    {
                        name: 'Type-A to<br />Type-C Cable:',
                        imageKey: 'inBoxItem4',
                        values: ['√', '√', '√', '√'],
                    },
                    {
                        name: 'Lint-free Brush:',
                        imageKey: 'inBoxItem5',
                        values: ['√', '√', '√', '√'],
                    },
                    {
                        name: 'M2/M2.5<br />Hex Key:',
                        imageKey: 'inBoxItem6',
                        values: ['√', '√', '√', '√'],
                    },
                    {
                        name: 'Type-A to<br />Type-C Adapter:',
                        imageKey: 'inBoxItem7',
                        values: ['√', '√', '√', '√'],
                    },
                    {
                        name: 'Hose Clamp:',
                        imageKey: 'inBoxItem8',
                        values: ['√', '√', '√', '√'],
                    },
                    {
                        name: 'Dust-free Cloth:',
                        imageKey: 'inBoxItem9',
                        values: ['√', '√', '√', '√'],
                    },
                    {
                        name: 'Quick Start<br />Guide:',
                        imageKey: 'inBoxItem10',
                        values: ['√', '√', '√', '√'],
                    },
                    {
                        name: 'Safety<br />Instructions:',
                        imageKey: 'inBoxItem11',
                        values: ['√', '√', '√', '√'],
                    },
                    {
                        name: 'Camera<br />Calibration Card:',
                        imageKey: 'inBoxItem12',
                        values: ['√', '/', '√', '/'],
                        highlightValues: !0,
                    },
                    {
                        name: 'Cutting Plate:',
                        imageKey: 'inBoxItem13',
                        values: ['/', '/', '√', '√'],
                        highlightValues: !0,
                    },
                    {
                        name: 'Materials<br />retention screw:',
                        imageKey: 'inBoxItem14',
                        values: ['2', '2', '2', '2'],
                    },
                    {
                        name: 'Safety Key:',
                        imageKey: 'inBoxItem15',
                        values: ['2', '2', '2', '2'],
                    },
                    {
                        name: 'Basswood board:',
                        imageKey: 'inBoxItem16',
                        values: ['3', '3', '3', '3'],
                    },
                    {
                        name: 'Laser Engrave<br />Photo Paper:',
                        imageKey: 'inBoxItem17',
                        values: ['7', '3', '7', '3'],
                        highlightValues: !0,
                    },
                ],
            },
            accessoriesTitle: 'Adapt to Any Job. Master Every Objects',
            learnMore: 'Learn More',
            accessories: [
                {
                    title: 'Air Purifier',
                    description:
                        'Purifies smoke and odors generated during engraving, helps improve engraving quality, and maintains a cleaner indoor environment.',
                    active: !0,
                    href: 'https://au.crealityfalcon.com/products/creality-falcon-intelligent-air-purifier-ap1-mini',
                },
                {
                    title: 'Flexible Fixture',
                    description:
                        'Fast one-step clamping for irregular and specially shaped objects, with no repeated adjustments required for batch engraving.',
                    active: !0,
                    href: 'https://au.crealityfalcon.com/products/creality-falcon-flexible-fixture',
                },
                {
                    title: 'Exhaust Fan',
                    description:
                        'Powerfully removes fumes generated during engraving, helping improve engraving quality.',
                    active: !0,
                    href: 'https://au.crealityfalcon.com/products/creality-falcon-ef1-exhaust-fan',
                },
                {
                    title: 'Rotary kits',
                    description:
                        'Supports stable rotary engraving for cylindrical and round objects such as cups, rings, bracelets, and more.',
                    active: !1,
                },
            ],
        },
        section13: {
            title: 'Specifications',
            labels: [
                'Product Name:',
                'Product Color:',
                'Laser Modules Support:',
                'Interchangeable Laser Modules:',
                'Engraving Area:',
                'Max. Processing Height:',
                'Laser Safety:',
                'Max. Working Speed:',
                'Focus Mode:',
                'Camera:',
                `Camera-Assisted
Positioning:`,
                'AI Smart Fill & Layout:',
                'Optional Packages:',
                'IoT Control:',
                'APP Control:',
                'Machine Dimension:',
                'Package Dimension:',
                `Net Weight:
(Machine Only)`,
                'Gross Weight:',
            ],
            variants: [
                {
                    name: 'Falcon A1C',
                    color: 'Purple-Gray',
                    laserModules: '5W Diode | 10W Diode | 1.2W IR',
                    interchangeable: '✓',
                    engravingArea: '150 × 150 mm',
                    maxHeight: '148 mm',
                    laserSafety:
                        'Class 1 Laser Safety Flame Detection Tilt Detection USB Safety Lock',
                    maxSpeed: '15000mm/min',
                    focusMode: 'Auto Focus',
                    camera: '✓',
                    cameraAssist: '✓',
                    aiFill: '✓',
                    optionalPackages: 'Rotary Kit, Air Pufier',
                    iotControl: 'Wi-Fi + BLE, IoT Control',
                    appControl: 'Wireless APP Control',
                    machineDim: '336 mm * 377 mm * 341 mm',
                    packageDim: '470 mm * 395 mm * 410 mm',
                    netWeight: '9.8 kg',
                    grossWeight: '13 kg - 13.3 kg',
                },
                {
                    name: 'Falcon A1C',
                    color: 'White',
                    laserModules: '5W Diode | 10W Diode | 1.2W IR',
                    interchangeable: '✓',
                    engravingArea: '150 × 150 mm',
                    maxHeight: '148 mm',
                    laserSafety:
                        'Class 1 Laser Safety Flame Detection Tilt Detection USB Safety Lock',
                    maxSpeed: '15000mm/min',
                    focusMode: 'Auto Focus',
                    camera: '×',
                    cameraAssist: '×',
                    aiFill: '×',
                    optionalPackages: 'Rotary Kit, Air Pufier',
                    iotControl: 'Wi-Fi + BLE, IoT Control',
                    appControl: 'Wireless APP Control',
                    machineDim: '336 mm * 377 mm * 341 mm',
                    packageDim: '470 mm * 395 mm * 410 mm',
                    netWeight: '9.7 kg',
                    grossWeight: '12.9 kg - 13.2 kg',
                },
            ],
        },
    },
        yk =
            'data:image/png;base64,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',
        vk =
            'data:image/png;base64,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',
        Sk =
            'data:image/png;base64,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',
        xk = {
            heroBgMobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/0.kv.jpg?v=1781663811',
            easyUseMobile1: yk,
            easyUseMobile2: vk,
            easyUseSwapBg: Sk,
            stabilityHeroMobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_fbe045ad-c5e3-45f0-9a5e-8c572b797186.jpg?v=1781665046',
            diodeSlide1Mobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/wood_031259c5-6859-4d0e-976f-275fe0805cd2.png?v=1781603389',
            diodeSlide2Mobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/Bamboo.png?v=1781603389',
            diodeSlide3Mobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/paper.png?v=1781603389',
            diodeSlide4Mobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/Cork_Cardboard.png?v=1781603390',
            diodeSlide5Mobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/Rock.png?v=1781603389',
            diodeSlide6Mobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/Leather_8daa84d1-c0c0-4262-9813-7d99a83ee56f.png?v=1781603389',
            diodeSlide7Mobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/Glass_bcbc821a-a7e8-4577-a0b0-365ea17a4e15.png?v=1781603389',
            diodeSlide8Mobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/Fabric.png?v=1781603389',
            irSlide1Mobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/Brass_Gold.png?v=1781604609',
            irSlide2Mobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/Silver_Platinum.png?v=1781604610',
            irSlide3Mobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/Acrylic_Plastic.png?v=1781604609',
            irSlide4Mobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/Aluminum_Stainless_Steel.png?v=1781604610',
            workspaceBgMobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_a2fa3542-9dce-4c70-8151-2c525392cdc0.jpg?v=1781665379',
            speedBgMobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/8._9ca94a28-4743-48e8-8b13-087086659764.jpg?v=1781665451',
            safetyHeaderMobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_1e41a079-417f-47c4-8456-30d80e6bc812.jpg?v=1781665507',
            softwareMainMobile:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_cf6c3ea9-f3a8-4038-bcce-1e8d352b9b56.jpg?v=1781667372',
        },
        Nk =
            'data:image/png;base64,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',
        wk =
            'data:image/png;base64,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',
        Ek =
            'data:image/png;base64,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',
        Ak = {
            heroBg:
                'https://cdn.creality.com/ow/a1c/af31945a-c45d-455d-a5ce-f71b35810b5e.jpg',
            materialsIcon: Nk,
            scenario1:
                'https://cdn.creality.com/ow/a1c/b045960c-474a-40e0-96e2-31817b3110e3.jpg',
            scenario2:
                'https://cdn.creality.com/ow/a1c/46161c67-3521-4979-8be4-5dd58c3b2e51.jpg',
            scenario3:
                'https://cdn.creality.com/ow/a1c/356a4acf-2fde-429d-9117-e2e6337854c9.jpg',
            scenario4:
                'https://cdn.creality.com/ow/a1c/37ba10d6-54fa-4081-8fdb-f2cf03d9825c.jpg',
            easyUseVideo1:
                'https://cdn.creality.com/ow/a1c/45f605bd-e630-4638-a948-4a76eca6709b.mp4',
            easyUseVideo2:
                'https://cdn.creality.com/ow/a1c/9c6f5921-f735-4d76-a0c8-414c59f4572f.mp4',
            easyUseVideo3:
                'https://cdn.creality.com/ow/a1c/7ff05ba8-365b-489e-a1f2-eeafb951a69b.mp4',
            easyUse4:
                'https://cdn.creality.com/ow/a1c/e3d89bd6-e26d-4fe7-a7bb-2672be92dcdf.jpg',
            stability1:
                'https://cdn.creality.com/ow/a1c/353f2e70-64ad-4764-82ee-47f8fe115a38.jpg',
            stability2:
                'https://cdn.creality.com/ow/a1c/8e6737d4-964c-4713-b247-2e550a820fdf.jpg',
            stability3:
                'https://cdn.creality.com/ow/a1c/bd6920ac-1265-4f0b-bde6-a50475697617.jpg',
            speedBg:
                'https://cdn.creality.com/ow/a1c/2d38d0f0-5957-45eb-8ce6-1eea12a725e1.jpg',
            stabilityHero:
                'https://cdn.creality.com/ow/a1c/b4eff893-f97e-47f8-8854-e22f2f7bb9d7.jpg',
            workspaceBg:
                'https://cdn.creality.com/ow/a1c/6acb5b47-e6f8-42b9-b779-d7d16fa03b40.jpg',
            workspaceCard1:
                'https://cdn.creality.com/ow/a1c/5c428bfc-0734-4464-ae9b-89e7cecb67cb.jpg',
            workspaceCard2:
                'https://cdn.creality.com/ow/a1c/ddd2c3fd-c9b2-401e-a5d4-944a8674e51b.jpg',
            workspaceCard3:
                'https://cdn.creality.com/ow/a1c/0022432a-34f9-441c-a683-eb50476e46ae.jpg',
            safetyHeaderBg:
                'https://cdn.creality.com/ow/a1c/4f258b7a-4314-4010-8e36-5e505e34bdcf.jpg',
            safetyTab1:
                'https://cdn.creality.com/ow/a1c/627f4ea2-017a-4cce-b432-2221c5c707f0.jpg',
            safetyTab2:
                'https://cdn.creality.com/ow/a1c/47609cd1-9550-444d-ba03-0d90038776f1.jpg',
            safetyTab3:
                'https://cdn.creality.com/ow/a1c/b137ffca-2fea-4571-9369-7e79caa33d91.jpg',
            safetyTab4:
                'https://cdn.creality.com/ow/a1c/bfb5e6a1-26bf-4b71-ad4d-6af8d53b57b3.jpg',
            softwareMain:
                'https://cdn.creality.com/ow/a1c/a66ddf29-db1a-4d38-b642-cfa9150deb18.jpg',
            softwarePC:
                'https://cdn.creality.com/ow/a1c/ef1fca57-3bc1-43b1-a325-0dff49e2f267.png',
            softwareDevices:
                'https://cdn.creality.com/ow/a1c/b0c3cf8d-2abd-44f8-8462-4ee0a1221301.png',
            aiVideo1:
                'https://cdn.creality.com/ow/a1c/1af7859e-34ec-4099-8315-d6f90ec27826.mp4',
            aiVideo2:
                'https://cdn.creality.com/ow/a1c/8264942e-4dd0-47e5-984a-52a1377d0405.mp4',
            aiVideo3:
                'https://cdn.creality.com/ow/a1c/d6444c7d-e2eb-446a-9455-812fe484f929.mp4',
            aiVideo4:
                'https://cdn.creality.com/ow/a1c/074a2375-0796-44fa-909e-a39d3cf333f6.mp4',
            featureSlide1:
                'https://cdn.creality.com/ow/a1c/11e77808-8031-4361-9424-ce719703636a.jpg',
            featureSlide2:
                'https://cdn.creality.com/ow/a1c/cfbdf454-7a56-4be9-b1a1-c39c69d28aad.jpg',
            featureSlide3:
                'https://cdn.creality.com/ow/a1c/dba8a26d-1825-420a-9a21-c5cfec80a714.jpg',
            featureSlide4:
                'https://cdn.creality.com/ow/a1c/fe99df30-c435-40f7-8b26-8b03330a2e98.jpg',
            featureSlide5:
                'https://cdn.creality.com/ow/a1c/d90650fa-8860-4865-bc3c-d585add8cb3d.jpg',
            featureSlide6:
                'https://cdn.creality.com/ow/a1c/367fded3-8470-4b54-9c21-0229d59491c2.jpg',
            section11EngraveCups:
                'https://cdn.creality.com/ow/a1c/c5fc32ec-552a-44c3-aad4-31470d3bbd9e.jpg',
            section11Maintenance:
                'https://cdn.creality.com/ow/a1c/a3e0aac5-dae1-4e26-90fe-ba5773badc8f.jpg',
            section11AirPurifier:
                'https://cdn.creality.com/ow/a1c/7edf0680-7535-40e0-9f62-8e5da3349898.jpg',
            section11Fixture:
                'https://cdn.creality.com/ow/a1c/65a34776-7279-422c-8257-2221358d9df9.jpg',
            portablePanel1:
                'https://cdn.creality.com/ow/a1c/e467b7e2-d5b7-4b27-b1ea-a94df9544753.jpg',
            portablePanel2:
                'https://cdn.creality.com/ow/a1c/1b412de0-1262-4cd0-af3b-0f62b143310b.jpg',
            portablePanel3:
                'https://cdn.creality.com/ow/a1c/0c2fd857-56de-4a87-9fac-6d5d35f190ba.jpg',
            portable1: wk,
            portable2: Ek,
            accessoryAirPurifier:
                'https://cdn.creality.com/ow/a1c/f3a7416d-7f4c-443a-898d-049c47a93078.png',
            accessoryFixture:
                'https://cdn.creality.com/ow/a1c/0a8e013a-2634-4923-a03e-adadad3a86b2.png',
            accessoryFan:
                'https://cdn.creality.com/ow/a1c/36d185d2-2849-4ad3-b707-bfd91d1d12a8.png',
            accessoryRotary:
                'https://cdn.creality.com/ow/a1c/81729712-207b-45ff-b72d-a557b7abd9d7.png',
            specTable1:
                'https://cdn.creality.com/ow/a1c/f5c423b4-97d1-4aa7-a05c-ad14c73f4d79.png',
            specTable2:
                'https://cdn.creality.com/ow/a1c/4f6d443a-d609-400e-86f8-c6058ba18238.png',
            diodeSlide1:
                'https://cdn.creality.com/ow/a1c/eaa49912-6f71-40cd-82fe-7cb7c4424db3.png',
            diodeSlide2:
                'https://cdn.creality.com/ow/a1c/47384cd3-7cd2-45ad-9ebf-4b5c2f954e93.png',
            diodeSlide3:
                'https://cdn.creality.com/ow/a1c/5b034b3a-0521-4388-b32d-402dd590189b.png',
            diodeSlide4:
                'https://cdn.creality.com/ow/a1c/fcc16bab-a261-4ebc-b523-b43f390e4c6b.png',
            diodeSlide5:
                'https://cdn.creality.com/ow/a1c/c130087d-b2b6-42b9-a03a-1067128fd4d5.png',
            diodeSlide6:
                'https://cdn.creality.com/ow/a1c/d9a7e77a-9cf4-47f9-be52-1affbf3f4f4b.png',
            diodeSlide7:
                'https://cdn.creality.com/ow/a1c/eed043f9-a6b9-489e-9ca5-4314309bdfe5.png',
            diodeSlide8:
                'https://cdn.creality.com/ow/a1c/b97c887f-146a-4360-b633-e0487b053a1b.png',
            diodeIndicator1:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_7b50f996-272f-4468-afbf-56f6a9ad8749.png?v=1781605834',
            diodeIndicator2:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/2_656dd268-8c9c-4321-8845-69fa9fcf7a70.png?v=1781605853',
            diodeIndicator3:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/3_53168519-9002-4db5-9b19-11a7344d93ea.png?v=1781605853',
            diodeIndicator4:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/4_128ca3d5-a7b5-4233-9a3b-6af9d3a57565.png?v=1781605853',
            diodeIndicator5:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/5_057e206e-4ac4-4f49-9049-94c9decf12fa.png?v=1781605854',
            diodeIndicator6:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/6_2b050378-c5e4-484c-a634-e5e87cbaa26d.png?v=1781605854',
            diodeIndicator7:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/7_d67a25f0-0241-418e-aae8-db133afc61a3.png?v=1781605854',
            diodeIndicator8:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/8_27b8138f-133c-4f7a-b421-56eff4eaa1bd.png?v=1781605854',
            irSlide1:
                'https://cdn.creality.com/ow/a1c/d374f917-7d22-4e52-813d-9e4622e88ef1.png',
            irSlide2:
                'https://cdn.creality.com/ow/a1c/8daaa191-43b2-44d7-b8b7-25ed7084b785.png',
            irSlide3:
                'https://cdn.creality.com/ow/a1c/9f38f26e-0d3e-4498-82de-1abff4bc2d30.png',
            irSlide4:
                'https://cdn.creality.com/ow/a1c/a93fef1e-12d3-4e93-987f-540e8de58fd7.png',
            irIndicator1:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/156.png?v=1781662723',
            irIndicator2:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/155.png?v=1781662723',
            irIndicator3:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/154.png?v=1781662723',
            irIndicator4:
                'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/153.png?v=1781662723',
            gallerySlide1:
                'https://cdn.creality.com/ow/a1c/9c9b908b-fb5f-4981-8a53-a99a2ce8b2f5.jpg',
            gallerySlide2:
                'https://cdn.creality.com/ow/a1c/fb511449-6cf8-492c-a1db-b71a73723028.jpg',
            gallerySlide3:
                'https://cdn.creality.com/ow/a1c/9990bb06-415b-48c4-8b6a-2803ac98331f.jpg',
            gallerySlide4:
                'https://cdn.creality.com/ow/a1c/2d2b18aa-8cef-4379-8fee-76eb1dc5310c.jpg',
            gallerySlide5:
                'https://cdn.creality.com/ow/a1c/26cd50dd-6634-4308-9b57-93c80d482713.jpg',
            gallerySlide6:
                'https://cdn.creality.com/ow/a1c/25f7fbc7-70b8-41bf-9735-15b81a91be9a.jpg',
            highlight1:
                'https://cdn.creality.com/ow/a1c/85d0a10b-90b7-4191-94ba-6282643384e9.jpg',
            highlight2:
                'https://cdn.creality.com/ow/a1c/a16d4b59-7d97-40c1-bbb2-e7ad7914d56e.jpg',
            highlight3:
                'https://cdn.creality.com/ow/a1c/f8882d2a-1edc-4987-8729-d475ffafc7a4.jpg',
            highlight4:
                'https://cdn.creality.com/ow/a1c/df9ae666-e4f1-413a-8c95-6192b5f0d04f.jpg',
            highlight5:
                'https://cdn.creality.com/ow/a1c/d4ed4280-53de-4bec-8840-e784dff0e2af.jpg',
            highlight6:
                'https://cdn.creality.com/ow/a1c/2d7fbe02-273d-4458-aa87-850c35ba3508.jpg',
            highlight7:
                'https://cdn.creality.com/ow/a1c/e402112e-9ccb-4867-921b-80f948e358be.jpg',
            highlight8:
                'https://cdn.creality.com/ow/a1c/a0c5ae3b-20bc-40f6-8d17-3a8d9132e03f.jpg',
            ...xk,
            ...y4,
        },
        Dk = { en: { translation: bk, imageUrl: Ak } };
    Eu.use(SE).init({
        resources: Dk,
        lng: XE(),
        fallbackLng: 'en',
        interpolation: { escapeValue: !1 },
        initImmediate: !1,
    });
    function Tk(i) {
        {
            const l = {
                cn: 'zh-CN',
                en: 'en-US',
                br: 'pt-BR',
                de: 'de-DE',
                es: 'es-ES',
                fr: 'fr-FR',
                it: 'it-IT',
                jp: 'ja-JP',
                kr: 'ko-KR',
                ru: 'ru-RU',
            };
            document.documentElement.lang = l[i] || 'en-US';
        }
    }
    Tk(Eu.language);
    const wp = document.getElementById('product-detail-a1c'),
        V0 = b.jsxDEV(
            $.StrictMode,
            {
                children: b.jsxDEV(
                    EE,
                    {
                        i18n: Eu,
                        children: b.jsxDEV(
                            gk,
                            {},
                            void 0,
                            !1,
                            {
                                fileName:
                                    'D:/works/creality-offical-product/src/pages/A1C/main.tsx',
                                lineNumber: 18,
                                columnNumber: 7,
                            },
                            void 0
                        ),
                    },
                    void 0,
                    !1,
                    {
                        fileName:
                            'D:/works/creality-offical-product/src/pages/A1C/main.tsx',
                        lineNumber: 17,
                        columnNumber: 5,
                    },
                    void 0
                ),
            },
            void 0,
            !1,
            {
                fileName:
                    'D:/works/creality-offical-product/src/pages/A1C/main.tsx',
                lineNumber: 16,
                columnNumber: 3,
            },
            void 0
        );
    wp.hasChildNodes()
        ? l0.hydrateRoot(wp, V0)
        : l0.createRoot(wp).render(V0);
})();
